export const trackTitlesWithPreview = [
  "Stand by Me",
  "Space Oddity",
  "Dreams",
  "I Say a Little Prayer",
  "(Sittin' On) the Dock of the Bay",
  "Hotel California",
  "Stars",
  "Hungry Like the Wolf",
  "Against All Odds (Take a Look at Me Now)",
  "Heroes",
  "Yellow",
  "Thinking out Loud",
  "Fast Car",
  "Wicked Game",
  "Take on Me",
  "Crazy",
  "The Best",
  "I Want to Know What Love Is",
  "Fool (If You Think It's Over)",
  "Bad Day",
  "Edge of Seventeen",
  "Move on Up",
  "Last Request",
  "Respect",
  "You're so Vain",
  "Go Your Own Way",
  "How You Remind Me",
  "Take It Easy",
  "Ain't Nobody",
  "Feel It Still",
  "Don't Start Now",
  "A Little Respect",
  "Just the Way You Are",
  "Somewhere in My Heart",
  "Young Hearts Run Free",
  "Wings",
  "Golden Brown",
  "We Built This City",
  "Pure Shores",
  "Love Will Tear Us Apart",
  "This Charming Man",
  "You Can't Hurry Love",
  "Nothing's Gonna Stop Us Now",
  "Groove Is in the Heart",
  "Kiss from a Rose",
  "You're Beautiful",
  "Kiss",
  "True",
  "It Must Have Been Love",
  "Once in a Lifetime",
  "Can't Get You out of My Head",
  "West End Girls",
  "Pack Up",
  "Love Shack",
  "It's My Life ",
  "Running Up That Hill",
  "I'll Be There",
  "Just the Two of Us",
  "Drive",
  "Breathless",
  "Soul Man",
  "I'm Yours",
  "Cannonball",
  "Brass in Pocket",
  "When a Man Loves a Woman",
  "Baker Street",
  "Cry to Me",
  "Black Velvet",
  "Blue Monday '88",
  "Walking in Memphis",
  "Wish You Were Here",
  "Perfect",
  "Harvest Moon",
  "Constant Craving",
  "You've Got a Friend",
  "Knock on Wood",
  "She Drives Me Crazy",
  "Riptide",
  "Sleeping Satellite",
  "Sitting Down Here",
  "Rather Be",
  "Love Changes (Everything)",
  "I Got You Babe",
  "Sweet Love",
  "Into the Mystic",
  "Wasn't Expecting That",
  "Daydream Believer",
  "Smile",
  "I Love You Always Forever",
  "Owner of a Lonely Heart",
  "Viva La Vida",
  "Iris",
  "The Universal",
  "Under the Bridge",
  "A Thousand Years",
  "Rise Up",
  "Love Town",
  "You're the One for Me",
  "Forget Me Nots",
  "Imagination",
  "Native Son",
  "I Feel for You",
  "(Feels Like) Heaven",
  "Dancing In the Dark",
  "Hysteria",
  "Don't Stop Believin'",
  "One More Time",
  "Get Lucky",
  "I Don't Feel Like Dancin'",
  "Dreamer",
  "U Sure Do ",
  "Celebration",
  "Love Come Down",
  "Lets Groove",
  "Free",
  "Push The Feeling On",
  "Bitter Sweet Symphony",
  "And the Beat Goes On",
  "Ain't No Stoppin' Us Now",
  "Got to Be Real",
  "I Can't Wait",
  "Never Give up on a Good Thing",
  "I Can Make You Feel Good",
  "Give Me the Reason",
  "Lost in Music",
  "We Are Family",
  "Can You Feel It",
  "Not That Kind",
  "I'm Outta Love",
  "I'm So Excited",
  "Good Times",
  "I'm Gonna Be (500 Miles)",
  "Reach Out I'll Be There",
  "Boogie Wonderland",
  "Who Let The Dogs Out",
  "Hey, Little Girl",
  "What Is Love?",
  "Killer / Papa Was a Rollin' Stone",
  "Here Comes the Rain Again",
  "Thorn In My Side",
  "Love Is A Stranger",
  "What's Love Got to Do with It",
  "Sometimes",
  "We Don't Have To Take Our Clothes Off",
  "Nineteen",
  "Bad",
  "Just Can't Get Enough",
  "Pretty Green Eyes",
  "Dakota",
  "Don't Go",
  "All Around the World",
  "I Have Nothing",
  "Call Me",
  "The Sun Always Shines on T.V.",
  "Another Night",
  "Heaven",
  "9 PM - Till I come",
  "Silence (feat. Sarah McLachlan)",
  "L'Amour Toujours",
  "Love & Pride",
  "Encore Une Fois",
  "Ecuador",
  "Be My Lover",
  "For An Angel",
  "Party Rock Anthem",
  "Sexy And I Know It",
  "Sorry For Party Rocking",
  "Halo",
  "Flames",
  "Alive",
  "Smalltown Boy",
  "Crazy 'Bout My Baby",
  "Cry for You",
  "The Rhythm of the Night",
  "The Key, The Secret",
  "Bring Me To Life",
  "Jar of Hearts",
  "Only Girl (In The World)",
  "Shut Up And Drive",
  "Airplanes",
  "Jai Ho! (You Are My Destiny)",
  "Better in Time",
  "Stereo Love",
  "Infinity 2008",
  "Don't Stop Me Now",
  "Under Pressure",
  "Radio Ga Ga",
  "I Want To Break Free",
  "Eye of the Tiger",
  "Don't Know Much",
  "Unchained Melody",
  "My Name Is",
  "(Everything I Do) I Do It For You",
  "Summer Of '69",
  "My Heart Will Go On",
  "All You Need Is Love",
  "Digital Love",
  "Firestarter",
  "Purple Rain",
  "1999",
  "The Most Beautiful Girl In the World",
  "Gangnam Style",
  "Waiting for a Star to Fall",
  "Shake It Off",
  "There Must Be an Angel (Playing with My Heart)",
  "I'd Do Anything For Love (But I Won't Do That)",
  "What's Up?",
  "I Will Always Love You",
  "Barbie Girl",
  "Nothing Else Matters",
  "Always",
  "Losing My Religion",
  "...Baby One More Time",
  "They Don't Care About Us",
  "Desert Rose",
  "Believe",
  "More Than Words",
  "Linger",
  "Maria Maria",
  "Wonderwall",
  "When You Believe",
  "Enter Sandman",
  "Livin' la Vida Loca",
  "The Man Who Sold The World",
  "Wannabe",
  "No Scrubs",
  "I Don't Want To Miss A Thing",
  "All Star",
  "Coco Jamboo",
  "Scar Tissue",
  "Bed Of Roses",
  "Earth Song",
  "Come As You Are",
  "Thank You",
  "Don't Cry",
  "Smooth",
  "Black or White",
  "The Kids Aren't Alright",
  "I'll Be Missing You",
  "You Are Not Alone",
  "The Boy Is Mine",
  "Freestyler",
  "Cotton Eye Joe",
  "Scatman (ski-ba-bop-ba-dop-bop)",
  "All The Small Things",
  "Basket Case",
  "Torn",
  "Amazing",
  "Hero",
  "Without You",
  "Return of the Mack",
  "Ironic",
  "Heal the World",
  "All I Wanna Do Is Make Love To You",
  "One Headlight",
  "Send Me An Angel",
  "Truly Madly Deeply",
  "Save Tonight",
  "If You Had My Love",
  "Insane in the Brain",
  "Black Hole Sun",
  "Boom, Boom, Boom, Boom!!",
  "Men In Black",
  "Why Don't You Get A Job",
  "Sweat (A La La La La Long)",
  "When You Say Nothing At All",
  "More And More",
  "Everlong",
  "Candy Rain",
  "Remember the Time",
  "Bailamos",
  "Lithium",
  "Dragula",
  "Everybody Hurts",
  "Always Be My Baby",
  "Nobody",
  "Down In A Hole",
  "Mr. Jones",
  "Insomnia",
  "Song 2",
  "Pretty Fly (For A White Guy)",
  "California Love",
  "I Knew I Loved You",
  "Lovefool",
  "Nookie",
  "Fantasy",
  "Get A Way",
  "Freedom! '90",
  "This Is How We Do It",
  "Ordinary World",
  "Even Flow",
  "Return To Innocence",
  "Gonna Make You Sweat",
  "Runaway Train",
  "We like to Party! (The Vengabus)",
  "Stairway to Heaven",
  "Stayin' Alive",
  "Born to Be Alive",
  "Don't Stop 'Til You Get Enough",
  "Dance Hall Days",
  "Urgent",
  "Turn Me Loose",
  "The Logical Song",
  "Breakfast In America",
  "Rosanna",
  "Africa",
  "Tragedy",
  "Walking On Sunshine",
  "Sweet Dreams (Are Made of This)",
  "The Final Countdown",
  "YMCA",
  "Jump",
  "You Win Again",
  "Say Say Say",
  "Hope Of Deliverance",
  "One Night In Bangkok",
  "Say It Right",
  "Maneater",
  "Hung Up",
  "All The Things She Said",
  "Just Dance",
  "Valerie (feat. Amy Winehouse)",
  "Billie Jean",
  "Beat It",
  "Thriller",
  "Bohemian Rhapsody",
  "Smoke on the Water",
  "My Sharona",
  "Das Model",
  "Dancing Queen",
  "Highway to Hell",
  "Heart Of Glass",
  "I Feel Love",
  "You Shook Me All Night Long",
  "Livin' On A Prayer",
  "Pour Some Sugar On Me",
  "Girls Just Want to Have Fun",
  "The Way You Make Me Feel",
  "(I've Had) The Time Of My Life",
  "Crazy Little Thing Called Love",
  "Take Me Home Tonight",
  "Red Red Wine",
  "I Love Rock 'N Roll",
  "Another One Bites The Dust",
  "Smooth Criminal",
  "Rock with You",
  "The Safety Dance",
  "All Night Long",
  "Wanna Be Startin' Somethin'",
  "Wake Me Up Before You Go-Go",
  "It's Raining Men",
  "Back In Black",
  "Man in the Mirror",
  "Pump Up The Jam",
  "Uptown Girl",
  "Conga!",
  "Glory Days",
  "Walk Like an Egyptian",
  "You're the Inspiration",
  "Tainted Love",
  "Rhythm Is A Dancer",
  "Ice Ice Baby",
  "U Can't Touch This",
  "I Like To Move It",
  "Everybody Dance Now",
  "Dirty Diana",
  "Another Part of Me",
  "Mambo No. 5",
  "Love Is All Around",
  "The Lady In Red",
  "Everybody (Backstreet's Back)",
  "Blue (Da Ba Dee)",
  "The Sweet Escape",
  "Mr. Vain",
  "Easy Lover",
  "Don't Lose My Number",
  "Invisible Touch",
  "You're the Voice",
  "Juke Box Hero",
  "Karma Chameleon",
  "When the Rain Begins to Fall",
  "Upside Down",
  "What A Feeling",
  "Major Tom",
  "Der Kommissar",
  "The Loco-Motion",
  "I Gotta Feeling",
  "What Is Love",
  "Live Is Life",
  "Brother Louie",
  "You're My Heart, You're My Soul",
  "Cheri Cheri Lady",
  "Sing Hallelujah!",
  "The Ketchup Song",
  "Where Do You Go",
  "Daddy Cool",
  "Ma Baker",
  "Gimme! Gimme! Gimme! (A Man After Midnight)",
  "Video Killed The Radio Star",
  "La Isla Bonita",
  "Voyage voyage",
  "Big in Japan",
  "Hips Don't Lie",
  "Bailando",
  "Meet Me Halfway",
  "Haus am See",
  "Alles neu",
  "In the Year 2525",
  "Skandal im Sperrbezirk",
  "I've Been Thinking About You",
  "Go West",
  "Joyride",
  "Sleeping in My Car",
  "Waterloo",
  "Kung Fu Fighting",
  "Back To Black",
  "Rehab",
  "Family Affair",
  "Fallin'",
  "Umbrella",
  "Boat On The River",
  "Don't Let Me Be Misunderstood",
  "Walking on Broken Glass",
  "Have I Told You Lately",
  "Rhythm of My Heart",
  "Rhythm Divine",
  "Absolutely Everybody",
  "Butterfly",
  "Jesus He Knows Me",
  "Frozen",
  "MfG",
  "November Rain",
  "All You Zombies",
  "Shadow On The Wall",
  "Egoist",
  "Just Another Day",
  "I Was Born To Love You",
  "Enjoy the Silence",
  "Keep The Faith",
  "Everytime We Touch",
  "Out Of The Dark",
  "Maria",
  "Larger Than Life",
  "You'll Be In My Heart",
  "Breakfast At Tiffany's",
  "Baby, I Love Your Way",
  "Kiss Me",
  "Chiquitita",
  "Red Blooded Woman",
  "Ka-Ching!",
  "La Bamba",
  "Holding Out for a Hero",
  "All Good Things (Come To An End)",
  "I Should Be So Lucky",
  "She Works Hard For The Money",
  "We're Not Gonna Take It",
  "Midnight Blue",
  "Midnight Lady",
  "Whenever, Wherever",
  "Alejandro",
  "Can't Fight The Moonlight",
  "Californication",
  "Love Don't Cost a Thing",
  "Oops!...I Did It Again",
  "Bye Bye Bye",
  "Eternal Flame",
  "Poison",
  "Bed of Nails",
  "Here I Go Again",
  "Hey (Nah Neh Nah)",
  "You Keep Me Hangin On",
  "Tell It to My Heart",
  "It's a Sin",
  "Le Freak",
  "Superstar",
  "Down Under",
  "Tearin' up My Heart",
  "September",
  "Lay All Your Love On Me",
  "Sweat",
  "The River of Dreams",
  "How Will I Know",
  "Alive And Kicking",
  "Voulez-Vous",
  "Rebel Yell",
  "Rain In May",
  "Goldener Reiter",
  "Such a Shame",
  "Shut Up",
  "Push The Button",
  "Jenny from the Block",
  "The Riddle",
  "Johnny B.",
  "The One and Only",
  "Carrie",
  "Wind Of Change",
  "One Of Us",
  "Money, Money, Money",
  "Dance into the Light",
  "No Son Of Mine",
  "A Kind Of Magic",
  "Don't Dream It's Over",
  "Fernando",
  "That's the Way It Is",
  "That's The Way Love Goes",
  "One Night Love Affair",
  "Up Where We Belong",
  "True Colors",
  "She Wolf",
  "I Engineer",
  "Lemon Tree",
  "Gold",
  "Something Got Me Started",
  "Femme Like U",
  "If You Don't Know Me by Now",
  "Self Control",
  "New York Groove",
  "Axel F",
  "Summer In The City",
  "You Can Leave Your Hat On",
  "Easy",
  "Right Here",
  "I Love Your Smile",
  "Moving on Up",
  "I Feel Lonely",
  "Shiny Happy People",
  "The Shoop Shoop Song (It's In His Kiss)",
  "Come Along",
  "Supreme",
  "Whole Again",
  "Miss California",
  "Don't Pay The Ferryman",
  "Little Lies",
  "Summer Wine",
  "'74-'75",
  "Mmm Mmm Mmm Mmm",
  "Cats In The Cradle",
  "Moonlight Shadow",
  "Gimme All Your Lovin'",
  "Americanos",
  "Kopf verloren",
  "Lonely",
  "Played-A-Live (The Bongo Song)",
  "Heartlight",
  "Rivers of Babylon",
  "We Didn't Start the Fire",
  "Centerfold",
  "Born in the U.S.A.",
  "Hungry Heart",
  "The Boys Of Summer",
  "The Wild Boys",
  "Liberian Girl",
  "Leave Me Alone",
  "ABC",
  "Suspicious Minds",
  "Jailhouse Rock",
  "MMMBop",
  "Smells Like Teen Spirit",
  "Mamma Mia",
  "Isn't She Lovely",
  "Crazy In Love (feat. Jay-Z)",
  "Single Ladies (Put a Ring on It)",
  "Roar",
  "Firework",
  "Jolene",
  "9 to 5",
  "Take Your Mama",
  "Shape of You",
  "In the Air Tonight",
  "You're The First, The Last, My Everything",
  "Maggie May",
  "CAN'T STOP THE FEELING!",
  "Cry Me a River",
  "Feeling Good",
  "(Something Inside) So Strong",
  "I'm Still Standing",
  "Tiny Dancer",
  "Your Song",
  "My Girl",
  "Good Vibrations",
  "Barbara Ann",
  "Uptown Funk (feat. Bruno Mars)",
  "Creep",
  "Fireflies",
  "Where Is The Love?",
  "Cupid",
  "I Wanna Dance with Somebody (Who Loves Me)",
  "Vincent",
  "What A Wonderful World",
  "Stay With Me",
  "Titanium",
  "All About That Bass",
  "Call Me Maybe",
  "Empire State of Mind",
  "Wherever You Will Go",
  "If You're Not The One",
  "Gotta Get Thru This",
  "Son Of A Preacher Man",
  "Spooky",
  "American Pie",
  "Kiss The Rain",
  "Somebody That I Used To Know",
  "Waterfalls",
  "Unpretty",
  "Running on Empty",
  "I Try",
  "Hey Ya!",
  "Writing's On The Wall",
  "One Day Like This",
  "Marry You",
  "Don't Worry Be Happy",
  "Do Your Thing",
  "Wind Beneath My Wings",
  "Feel Good Inc.",
  "DARE",
  "We All Stand Together",
  "Moondance",
  "Beyond the Sea",
  "The Power Of Love",
  "Raspberry Beret",
  "Price Tag",
  "Last Friday Night (T.G.I.F.)",
  "If I Were a Boy",
  "Shackles (Praise You)",
  "Sweet Child O' Mine",
  "Higher And Higher",
  "Leave Right Now",
  "Since U Been Gone",
  "Breakaway",
  "Behind These Hazel Eyes",
  "Sweetest Girl (Dollar Bill) (feat. Akon, Lil' Wayne & Niia)",
  "Where I Wanna Be",
  "(You Drive Me) Crazy",
  "I'm a Slave 4 U",
  "If There's Any Justice",
  "Because of You",
  "Stupid Girls",
  "U + Ur Hand",
  "Your Love Alone Is Not Enough (feat. Nina Persson)",
  "Here (In Your Arms)",
  "Beautiful Liar",
  "Deja Vu (feat. Jay-Z)",
  "Shiver",
  "Daughters",
  "We Come 1",
  "Unwritten",
  "In the Morning",
  "Hips Don't Lie (feat. Wyclef Jean)",
  "Get Up (feat. Chamillionaire)",
  "Differences",
  "Oh (feat. Ludacris)",
  "1, 2 Step (feat. Missy Elliott)",
  "Let Me Love You",
  "Incomplete",
  "Let Me Hold You (feat. Omarion)",
  "Like You (feat. Ciara)",
  "Left Outside Alone",
  "Ordinary People",
  "Bills, Bills, Bills",
  "Jumpin', Jumpin'",
  "Say My Name",
  "Soldier (feat. T.I. & Lil' Wayne)",
  "Cater 2 U",
  "Girl",
  "My Prerogative",
  "Lucky",
  "Run It! (Featuring Juelz Santana)",
  "With You",
  "Thank God I Found You",
  "Naughty Girl",
  "My Boo",
  "I Don't Want to Be",
  "Perfect Gentleman (feat. Hope)",
  "As I Lay Me Down",
  "Hemorrhage (In My Hands)",
  "100 Years",
  "Play",
  "I'm Real (feat. Ja Rule) (Murder Remix)",
  "You Rock My World (with intro)",
  "Don't Think I'm Not",
  "She's so High",
  "Promise",
  "Absolutely (Story of a Girl)",
  "He Can't Love U",
  "Irresistible (Album Version)",
  "Let's Get Married",
  "So Anxious",
  "No More",
  "Miss You Love",
  "The Way You Move (feat. Sleepy Brown)",
  "Roses",
  "Fiesta (feat. Jay-Z, Boo & Gotti) (Remix)",
  "Karma",
  "If I Ain't Got You",
  "It's Gonna Be Me",
  "You're Making Me High",
  "Gone",
  "Sick and Tired",
  "Rockstar",
  "Slow Jamz (feat. Kanye West & Jamie Foxx)",
  "Lonely No More",
  "Lose Control (feat. Ciara & Fat Man Scoop)",
  "Grind With Me",
  "1973",
  "Diamonds and Pearls",
  "Cream",
  "One Minute Man (feat. Ludacris)",
  "Get Ur Freak On",
  "Saltwater",
  "In the End",
  "Welcome to the Black Parade",
  "Teenagers",
  "Shadow of the Day",
  "What I've Done",
  "Numb / Encore",
  "Numb",
  "Rain",
  "Sorry",
  "Snow (Hey Oh)",
  "Everything",
  "Turn Me On",
  "Cupid's Chokehold / Breakfast in America",
  "Runaway",
  "Another Day in Paradise (R&B-Version)",
  "Remember the Name (feat. Styles of Beyond)",
  "Vogue",
  "Justify My Love",
  "Around the World",
  "Otherside",
  "Road Trippin'",
  "American Idiot",
  "Wake Me up When September Ends",
  "Strong Enough",
  "Low (feat. T-Pain)",
  "Damaged",
  "4 Minutes (feat. Justin Timberlake and Timbaland)",
  "Are You Gonna Be My Girl",
  "Come to Me (feat. Nicole Scherzinger)",
  "Fit but You Know It",
  "Dry Your Eyes",
  "She Bangs (English Version)",
  "No More (Baby I'ma Do Right)",
  "Tha Crossroads",
  "I Need To Know",
  "Photograph",
  "Teenage Dirtbag",
  "Bounce With Me (feat. Xscape) (Edited Album Version)",
  "Love Song",
  "As Good As I Once Was",
  "Fergalicious",
  "Clumsy",
  "London Bridge",
  "Big Girls Don't Cry (Personal)",
  "Let It Go",
  "Last Night",
  "Love",
  "Ghetto Gospel",
  "Don't Phunk With My Heart",
  "Let Me Blow Ya Mind",
  "All About You",
  "Mustang Sally",
  "DONTTRUSTME",
  "Starz In Their Eyes",
  "About You Now",
  "Thnks fr th Mmrs",
  "Too Lost In You",
  "Makes Me Wonder",
  "Livin' On The Edge",
  "Cryin'",
  "No Diggity",
  "Stop And Stare",
  "Apologize (feat. One Republic)",
  "Dance, Dance",
  "Sugar, We're Goin Down",
  "It's Like That",
  "So Sick",
  "Hate That I Love You",
  "Disturbia",
  "Take A Bow",
  "Round Here",
  "Patience",
  "The Only One I Know",
  "Paper Planes",
  "It Wasn't Me",
  "Thong Song",
  "Mr. Brightside",
  "Rollin' (Air Raid Vehicle)",
  "Kryptonite",
  "Love Today",
  "Happy Ending",
  "Foundations",
  "Hit 'Em Up Style (Oops!)",
  "Angel of Mine",
  "Music (feat. Marvin Gaye)",
  "Here's to the Night",
  "It's Not Right But It's Okay",
  "Here With Me",
  "My Love Is Your Love",
  "Ms. Jackson",
  "My Own Worst Enemy",
  "Summer Girls",
  "U Remind Me",
  "Beep",
  "What You Waiting For?",
  "Rich Girl",
  "Cool",
  "My Love",
  "Let's Dance",
  "Survivor",
  "Dancing in the Moonlight",
  "Anything",
  "Another Sad Love Song",
  "Diggin' On You",
  "Breathe Again",
  "Said I Loved You...But I Lied",
  "Vision of Love",
  "Someday",
  "How Can We Be Lovers",
  "Step by Step",
  "Tonight",
  "Promise Me",
  "Bubbly",
  "I Tried",
  "My Band",
  "Pieces Of Me",
  "Only U (No Intro)",
  "Because Of You",
  "Just My Imagination",
  "Stan",
  "Shake That",
  "Like Toy Soldiers",
  "The Real Slim Shady",
  "Mockingbird",
  "When I'm Gone",
  "When You Were Young",
  "Rule The World",
  "America",
  "Fat Lip",
  "In Too Deep",
  "Chelsea Dagger",
  "Until The End Of Time",
  "Purple Pills",
  "Locked Up",
  "Better Than Me",
  "Lips Of An Angel",
  "Case Of The Ex (Whatcha Gonna Do)",
  "Get It On Tonite (Album Version)",
  "Sit Down",
  "Take A Look Around",
  "Laid",
  "Don't Cha",
  "Stickwitu",
  "Buttons",
  "Be Without You (Kendu Mix)",
  "She Will Be Loved",
  "Put It On Me",
  "Sacrifice",
  "Live And Let Die",
  "Don't Cry (Original)",
  "We Belong Together",
  "Too Little, Too Late (Album Version)",
  "Ridin'",
  "Lost Without U",
  "Get It Shawty",
  "Tease Me",
  "She Don't Let Nobody",
  "Twist And Shout",
  "I'm The Only One",
  "Come To My Window",
  "Beverly Hills",
  "Gold Digger",
  "Diamonds From Sierra Leone (Remix)",
  "Chasing Cars",
  "Shake It",
  "It Never Rains (In Southern California)",
  "Be With You",
  "Life Is A Rollercoaster",
  "Lovin' Each Day",
  "In The Morning",
  "No Tomorrow",
  "SOS (Album Version)",
  "Unfaithful (Album Version)",
  "The First Cut Is The Deepest",
  "Money Maker",
  "Runaway Love",
  "Wonderful World",
  "Glamorous",
  "The Only Thing That Looks Good On Me Is You",
  "Let's Make A Night To Remember",
  "Where My Girls At",
  "No More Drama",
  "Ms. Fat Booty",
  "Boombastic",
  "Angel",
  "Bag Lady",
  "Lollipop",
  "Heard It All Before",
  "Far Away",
  "Air Hostess",
  "Everytime",
  "Here Without You",
  "Back At One",
  "Baby, I'm Back",
  "Tears Dry On Their Own",
  "Southern Hospitality (Featuring Pharrell)",
  "Spotlight",
  "Outta Control",
  "I Like The Way",
  "God Gave Rock 'N' Roll To You II (Live/1992)",
  "You Needed Me",
  "When The Going Gets Tough",
  "Dangerous",
  "I Wanna Know",
  "Stutter (feat. Mystikal) (Double Take Remix)",
  "A Little Time",
  "AM To PM",
  "Rhythm Of Life",
  "Get Here",
  "What Would You Do?",
  "Disco Inferno",
  "Don't Forget About Us",
  'Slow Down (12" Version)',
  "Break It Down Again",
  "Contagious",
  "So What",
  "Everyday I Love You Less And Less",
  "I Predict A Riot",
  "Teardrops On My Guitar",
  "Our Song",
  "Kool Thing",
  "Learning To Fly",
  "Into The Great Wide Open",
  "Gotta Get Thru This (D'N'D Radio Edit)",
  "Gotta Tell You",
  "Vertigo",
  "Better Together",
  "Banana Pancakes",
  "Dizzy",
  "Just Lose It",
  "Salt Shaker",
  "Wait (The Whisper Song)",
  "Touch The Sky",
  "Switch",
  "Hollaback Girl",
  "Promiscuous",
  "Move Along",
  "It Ends Tonight",
  "Don't Lie",
  "My Humps",
  "Found Out About You",
  "Sexbomb",
  "Tell Me",
  "Give Me One Reason",
  "Bleeding Love",
  "A Moment Like This",
  "If I Had No Loot",
  "Southside",
  "Signs",
  "What's Love Got To Do With It",
  "Be Like That",
  "One (Album Version)",
  "I Just Wanna Love U (Give It 2 Me)",
  'Touch Me (All Night Long) (7" Mix)',
  "Lean Back",
  "Island In The Sun",
  "Love Machine",
  "Stay (Faraway, So Close!)",
  "Big Pimpin'",
  "1 Thing",
  "Starlight",
  "Snap Yo Fingers",
  "Move Ya Body",
  "Missing You",
  "When You Tell Me That You Love Me",
  "One Shining Moment",
  'Bailamos (From "Wild Wild West")',
  "Do You Know? (The Ping Pong Song)",
  "Hanging By A Moment",
  "Let It Rock",
  "White Flag",
  "Romeo",
  "Drops of Jupiter",
  "Me & U",
  "I Wish",
  "Hot Boyz",
  "You Found Me",
  "Takin' Back My Love",
  "Love Sex Magic (feat. Justin Timberlake)",
  "Sugar (feat. Wynter)",
  "Pon de Replay",
  "Party Up",
  "Get Up (Before The Night Is Over)",
  "Livin' It Up",
  "21 Guns",
  "Keep Coming Back",
  "What Took You So Long?",
  "She Wants To Move",
  "Have You Seen Her",
  "Hold On",
  "Release Me",
  "Impulsive",
  "You're In Love",
  "In Your Eyes",
  "She's The One",
  "Clint Eastwood",
  "Rock DJ",
  "Fix You",
  "Speed of Sound",
  "Are You Gonna Go My Way",
  "Right Here Right Now",
  "One Call Away",
  "Bossy",
  "She Moves In Her Own Way",
  "Face Down",
  "Put Your Records On",
  "Tripping",
  "Black Horse And The Cherry Tree (Radio Version)",
  "Suddenly I See",
  "Fall At Your Feet",
  "Close To You",
  "Candy",
  "Still Got The Blues",
  "Galvanize",
  "Santa Monica",
  "Naked and Sacred",
  "I Live For You",
  "Hey Boy Hey Girl",
  "Goodbye",
  "Lola's Theme",
  "Let There Be Love",
  "Always On The Run",
  "Stand By My Woman",
  "It Ain't Over 'Til It's Over",
  "Spinning Around",
  "Power of a Woman",
  "All Rise",
  "I Touch Myself",
  "Here I Am / Small Axe (Come And Take Me)",
  "Higher Ground",
  "(I Can't Help) Falling In Love With You",
  "This Is Why I'm Hot",
  "Trick Me",
  "Milkshake",
  "Millionaire",
  "Fly Away",
  "Naive",
  "Don't Worry",
  "Come Undone",
  "I Don't Wanna Fight",
  "All For You",
  "Doesn't Really Matter",
  "I Kissed A Girl",
  "Waking Up In Vegas",
  "Thinking Of You",
  "Hot N Cold",
  "This House",
  "Unskinny Bop",
  "Something To Believe In",
  "Wonderful",
  "I'll Be Your Baby Tonight (feat. UB40)",
  "Get A Life",
  "Oh Carolina",
  "I Like It",
  "Opposites Attract",
  "Rush Rush",
  "Sailing On The Seven Seas",
  "Pandora's Box",
  "That's Why You Go Away",
  "Fade Into You",
  "That Girl",
  "Fascinating Rhythm",
  "I Turn To You",
  "Never Be The Same Again",
  "Play That Funky Music",
  "Baby, Baby",
  "Every Heartbeat",
  "That's What Love Is For",
  "Spaceman",
  "Something To Talk About",
  "I Can't Make You Love Me",
  "Ms. New Booty",
  "Do It To It",
  "When Love Takes Over (feat. Kelly Rowland)",
  "Again",
  "Happening All Over Again",
  "Epic",
  "Supermassive Black Hole",
  "There You'll Be",
  "Closer to Free",
  "It's Been Awhile",
  "Twisted",
  "Nobody (feat. Athena Cage)",
  "New Shoes",
  "Shawty (feat. T Pain)",
  "Hotel Room Service",
  "She Talks To Angels",
  "Flat Beat",
  "Follow Me",
  "What's It Gonna Be?! (feat. Janet Jackson)",
  "Misery Business",
  "From a Distance",
  "Dance with Me",
  "Just the Girl",
  "Informer",
  "All I Want (Sunship Radio Edit)",
  "Laffy Taffy",
  "Sunshine (feat. Anthony Hamilton)",
  "I'm a Thug",
  "Desperately Wanting",
  "Pony (Single Version)",
  "Maria Maria (feat. The Product G&B)",
  "Battlefield",
  "No Air (feat. Chris Brown)",
  "Bulletproof",
  "Any Dream Will Do",
  "Bootylicious",
  "Like a Boy",
  "Heaven Is a Halfpipe (If I Die)",
  "Youth of the Nation",
  "All Summer Long",
  "I Wanna Sex You Up (Single Mix)",
  "All 4 Love",
  "So Fine",
  "Knock You Down",
  "Right Round",
  "We Be Burnin'",
  "Temperature",
  "Happily Ever After",
  "Beautiful Stranger",
  "I Know You Want Me (Calle Ocho)",
  "Day 'N' Nite (Crookers Remix)",
  "Party In The U.S.A.",
  "Obsessed",
  "Every Morning",
  "I'll Be There for You (Theme from 'Friends')",
  "The Climb",
  "Ego",
  "The Pretender",
  "Learn to Fly",
  "Do You Want To",
  "I Bet You Look Good On The Dancefloor",
  "When The Sun Goes Down",
  "Brianstorm",
  "Fluorescent Adolescent",
  "Crying Lightning",
  "Take Me Out",
  "22",
  "Hate It Or Love It",
  "How We Do",
  "Boom Boom Pow",
  "Love Story",
  "You Belong With Me",
  "Dip It Low",
  "Te Amo (Album Version)",
  "Bad Romance",
  "Paparazzi",
  "Wrap Me Up (Original Mix)",
  "BedRock",
  "I Write Sins Not Tragedies",
  "Whatcha Say",
  "Don't Walk Away",
  "Round and Round (Soul Mix Edit)",
  "I'm Too Sexy",
  "Independent Women, Pt. 1",
  "Pictures Of You",
  "Sometimes When We Touch",
  "Dear Maria, Count Me In",
  "Replay",
  "Got To Have Your Love",
  "Crying in the Rain",
  "Don't Give Up",
  "Escapade",
  "Black Cat",
  "Come Back To Me",
  "Never Let You Go",
  "Bleed It Out",
  "Boulevard of Broken Dreams",
  "Show Me Love",
  "Bust It Baby, Pt. 2 (feat. Ne-Yo)",
  "Better Days (And the Bottom Drops Out)",
  "Breathe",
  "Don't Stop Movin'",
  "Pure & Simple",
  "E.T.",
  "Rise",
  "Flowers (Sunship Edit)",
  "Right Now (Na Na Na)",
  "My Place",
  "Ride Wit Me",
  "Show Me The Way",
  "Pump It",
  "Everything You Want",
  "Silent Lucidity",
  "There You Go",
  "Who Knew",
  "Raise Your Glass",
  "Move Any Mountian",
  "Izzo (H.O.V.A.)",
  "I'm Like A Bird",
  "Over My Head (Cable Car)",
  "How to Save a Life",
  "Last Kiss",
  "I'm Every Woman",
  "The Time (Dirty Bit)",
  "Who's That Chick? (feat. Rihanna)",
  "Steal My Sunshine",
  "Stop Me (feat. Daniel Merriweather)",
  "Valerie (feat. Amy Winehouse) (Version Revisited)",
  "The Lazy Song",
  "Rolling in the Deep",
  "Rumour Has It",
  "Set Fire to the Rain",
  "Someone Like You",
  "Fastlove, Pt. 1",
  "I'm Your Baby Tonight",
  "Higher",
  "On The Floor",
  "I Need A Doctor",
  "Sweat (Remix)",
  "Just Can’t Get Enough",
  "Can't Stop",
  "Give Me Everything (feat. Ne-Yo, Afrojack & Nayer)",
  "Don't Let the Sun Go Down on Me",
  "Run the World (Girls)",
  "Black and Yellow",
  "Rapture (feat.Nadia Ali)",
  "Touch Me [feat. Cassandra]",
  "Feels Like Heaven",
  "Pocketful of Sunshine",
  "International Love (feat. Chris Brown)",
  "Too Close",
  'Moves Like Jagger (Studio Recording From "The Voice" Performance)',
  "The Horses",
  "Irreplaceable",
  "Goodbye Mr A",
  "What a Girl Wants",
  "Come on over Baby (All I Want Is You) (Radio Version)",
  "I'm Not Alone",
  "Children",
  "Check On It (feat. Slim Thug)",
  "Acceptable in the 80's",
  "Me, Myself and I",
  "Gimme That",
  "(God Must Have Spent) A Little More Time On You (Remix)",
  "I Want It That Way",
  "Summertime",
  "Before He Cheats",
  "Ice Box",
  "Goodies (feat. Petey Pablo)",
  "Your Body Is a Wonderland",
  "All or Nothing",
  "Cold as Ice",
  "Wifey",
  "Sweet Lady",
  "Pop, Lock & Drop It (Video Edit)",
  "Headlines",
  "Two Princes",
  "S&M",
  "Don't Wanna Go Home",
  "The A Team",
  "Drunk",
  "Lego House",
  "Keep Holding On",
  "Confessions Part II",
  "She's So Lovely",
  "Night People",
  "Stronger (What Doesn't Kill You)",
  "Paradise",
  "Every Teardrop Is a Waterfall",
  "Princess of China",
  "The Fly",
  "Mysterious Ways",
  "Got 2 Luv U (feat. Alexis Jordan)",
  "Where Have You Been (Album Version)",
  "Grenade",
  "Love Is",
  "Now That We Found Love",
  "Danza Kuduro",
  "The Creeps",
  "What's Left Of Me (Main Version)",
  "The Animal Song",
  "Dreamlover",
  "Guerrilla Radio",
  "Little L",
  "Wild Ones (feat. Sia)",
  "Hey Baby",
  "Sunshine (feat. Lea)",
  "Lose My Breath",
  "Freek-A-Leek",
  "Toxic",
  "Shape of My Heart",
  "La Tortura (feat. Alejandro Sanz) (Album)",
  "Video Games",
  "What is Love",
  "Life",
  "My Love (feat. T.I.)",
  "What Goes Around.../...Comes Around (Interlude)",
  "Love in This Club (feat. Young Jeezy)",
  "Use Somebody",
  "Ex-Factor",
  "Gimme More",
  "Piece of Me",
  "Give In to Me",
  "Will You Be There",
  "She's All I Ever Had",
  "Don't Tell Me",
  "One Night in Heaven",
  "Boom! Shake the Room",
  "Where the Streets Have No Name (I Can't Take My Eyes off You)",
  "Disarm",
  "Summertime Sadness",
  "Want U Back",
  "Praying for Time",
  "As",
  "Some Nights",
  "We Are Young (feat. Janelle Monáe)",
  "She Doesn't Mind",
  "Wide Awake",
  "Take Care",
  "The Motto",
  "Little Talks",
  "Everybody Talks",
  "I Won't Give Up",
  "Drive By",
  "I Do (Cherish You)",
  "Move Your Body (D.J.Gabry Ponte Original Radio Edit)",
  "All This Time",
  "So Good",
  "Whistle",
  "You",
  "Silhouettes",
  "Ruby",
  "Pound The Alarm",
  "Got to Get It",
  "This Love",
  "Oh Girl",
  "Boyfriend",
  "Beauty And A Beat",
  "Tender",
  "Coffee & TV",
  "Payphone",
  "True Love",
  "Kingston Town",
  "One More Night",
  "Spectrum",
  "Good Time",
  "I Love It (feat. Charli XCX)",
  "How We Do (Party)",
  "Hall of Fame (feat. will.i.am)",
  "Blow Me (One Last Kiss)",
  "Candy Shop",
  "Just A Lil Bit",
  "Gangnam Style (강남스타일)",
  "I Will Wait",
  "Something",
  "Don't You Worry Child",
  "Die Young",
  "Clarity",
  "Diamonds",
  "Feel So Close",
  "I Need Your Love",
  "Sweet Nothing",
  "Thinking About You",
  "Unfinished Sympathy",
  "U Got 2 Let The Music",
  "Can't Hold Us (feat. Ray Dalton)",
  "Thrift Shop (feat. Wanz)",
  "Same Love (feat. Mary Lambert)",
  "Girl on Fire",
  "Come With Me : Come With Me",
  "Let Me Love You (Until You Learn To Love Yourself)",
  "Let Her Go",
  "Everytime You Need Me (Radio Version)",
  "Stay (Album Version)",
  "Ain't No Other Man",
  "Something Kinda Ooooh",
  "Scream & Shout",
  "Star Girl",
  "Five Colours In Her Hair (U.S Version)",
  "Work Hard, Play Hard",
  "I'm Free",
  "Ayo Technology",
  "Locked out of Heaven",
  "Treasure",
  "When I Was Your Man",
  "Titanium (feat. Sia)",
  "She Wolf (Falling to Pieces) [feat. Sia]",
  "Without You (feat. Usher)",
  "Where Them Girls At (feat. Nicki Minaj & Flo Rida)",
  "Pompeii",
  "Radioactive",
  "It's Over Now",
  "Peaches & Cream",
  "Harlem Shake",
  "Heart Attack",
  "Most Girls",
  "Good Feeling",
  "Suit & Tie (feat. Jay-Z)",
  "Mirrors",
  "Hard To Handle",
  "Another Love",
  "Counting Stars",
  "We Fly High",
  "Cha Cha Slide",
  "Love On Top",
  "Best Thing I Never Had",
  "Porcelain",
  "Natural Blues",
  "Come & Get It",
  "My Songs Know What You Did In The Dark (Light Em Up)",
  "Waiting All Night (feat. Ella Eyre)",
  "Get Lucky (feat. Pharrell Williams & Nile Rodgers)",
  "Young And Beautiful",
  "Don't Call Me Baby",
  "La La La",
  "Lisztomania",
  "Really Don't Care",
  "Love Me Again",
  "Counting Blue Cars (Studio Version)",
  "Backseat Freestyle",
  "808",
  "Gonna Make You Sweat (Everybody Dance Now)",
  "Black Skinhead",
  "1979",
  "Beautiful People (feat. Benny Benassi)",
  "Not an Addict",
  "Everybody Everybody",
  "All of Me",
  "Lady (Hear Me Tonight)",
  "Things That Make You Go Hmmmm.... (feat. Freedom Williams)",
  "Wake Me Up",
  "Do I Wanna Know?",
  "Why'd You Only Call Me When You're High?",
  "Blurred Lines",
  "Royals",
  "Team",
  "Hey Porsche",
  "The Power of Love",
  "Ho Hey",
  "Automatic Lover (Call For Love)",
  "It's the Way You Make Me Feel",
  "I Wish (LP Version)",
  "Dark Horse",
  "Take You There",
  "Sober",
  "My Life Would Suck Without You",
  "Next To Me",
  "Say Something",
  "Lily Was Here (feat. Candy Dulfer)",
  "Timber (feat. Ke$ha)",
  "This Is What It Feels Like",
  "Best Song Ever",
  "Story of My Life",
  "Right in the Night (feat. Plavka) (Fall in Love with Music)",
  "Turn Down for What",
  "Drunk in Love (feat. Jay-Z)",
  "Rather Be (feat. Jess Glynne)",
  "In These Arms",
  "Stay High (Habits Remix)",
  "Latch",
  "Best Day Of My Life",
  "Magic",
  "Live Like You Were Dying",
  "Who Do U Love",
  "She Wolf (Album)",
  "Sweet Dreams",
  "I Will Never Let You Down",
  "The Other Side",
  "Crazy for You",
  "Fancy",
  "Black Widow",
  "Shower",
  "Cheerleader (Felix Jaehn Remix)",
  "Love Never Felt So Good",
  "I'm Not The Only One",
  "Colorblind",
  "Ugly Heart",
  "Chandelier",
  "Boom Clap",
  "Rude",
  "Don't",
  "Bloodstream",
  "Stay The Night (Featuring Hayley Williams Of Paramore)",
  "She Looks So Perfect",
  "Hideaway",
  "Call Me When You're Sober",
  "Paralyzer",
  "Fake It",
  "Bang Bang",
  "Womanizer",
  "Circus",
  "Smooth (feat. Rob Thomas)",
  "Cool Kids",
  "Amnesia",
  "Talking Body",
  "Take Me To Church",
  "Calling Elvis",
  "Heavy Fuel",
  "A Sky Full of Stars",
  "Am I Wrong",
  "Dangerous (feat. Sam Martin)",
  "I Promised Myself",
  "Tipsy (Club Mix)",
  "Summer",
  "Cry For You",
  "Blank Space",
  "Style",
  "Jealous",
  "Let It Go (From 'Frozen' / Single Version)",
  "Mama Do (Uh Oh, Uh Oh)",
  "Steal My Girl",
  "Shut Up and Dance",
  "Infinity",
  "I Still Haven't Found What I'm Looking For",
  "Nobody Knows",
  "Firestone",
  "Around The Way Girl",
  "Dani California",
  "Anaconda",
  "Trap Queen",
  "Wait for You",
  "Thunderstruck",
  "Moneytalks",
  "Uma Thurman",
  "Heartbeat Song",
  "Uncover",
  "Headsprung",
  "All That She Wants",
  "Worth It (feat. Kid Ink)",
  "Truffle Butter",
  "Marvin Gaye (feat. Meghan Trainor)",
  "Break Stuff",
  "Love Me Like You Do",
  "Ex's & Oh's",
  "See You Again (feat. Charlie Puth)",
  "Where Are Ü Now (with Justin Bieber)",
  "FourFiveSeconds",
  "Ain't Nobody (Loves Me Better)",
  'It Must Have Been Love (From the Film "Pretty Woman")',
  "Don't Worry (with Ray Dalton)",
  "Stitches",
  "Reach",
  "Have You Ever",
  "One Sweet Day",
  "Thinking About Your Love",
  "Roses (feat. ROZES)",
  "Stressed Out",
  "Sugar",
  "Want to Want Me",
  "Watch Me (Whip / Nae Nae)",
  "Jubel",
  "How Deep is Your Love (feat. Disciples)",
  "Hold My Hand",
  "Back Here",
  "The Hills",
  "Can't Feel My Face",
  "Waiting For Love",
  "Runnin' (Lose It All)",
  "Sugar (feat. Francesco Yates)",
  "Regret",
  'Writing\'s On The Wall (From "Spectre" Soundtrack)',
  "Hands To Myself",
  "Good For You",
  "Cool for the Summer",
  "Bang My Head (feat. Sia & Fetty Wap)",
  "What Do You Mean?",
  "Love Yourself",
  "Drag Me Down",
  "Lips Are Movin",
  "Hymn for the Weekend",
  "Adventure of a Lifetime",
  "I can't stand it",
  "Never Be Like You",
  "We Don't Talk Anymore (feat. Selena Gomez)",
  "Work",
  "Needed Me",
  "Love On The Brain",
  "Chocolate",
  "It's Not Over",
  "Feels Like Tonight",
  "Since I Don't Have You",
  "Panda",
  "King",
  "Here",
  "Scars To Your Beautiful",
  "Pop Ya Collar",
  "This Girl (Kungs Vs Cookin' On 3 Burners)",
  "PILLOWTALK",
  "7 Years",
  "Aloha",
  "Ain't Your Mama",
  "I Wish I Was a Punk Rocker (with Flowers in My Hair)",
  "Low Life (feat. The Weeknd)",
  "All My Friends (feat. Tinashe & Chance the Rapper)",
  "Hotter Than Hell",
  "This Is What You Came For",
  "Alarm",
  "CAN'T STOP THE FEELING! (from DreamWorks Animation's \"TROLLS\")",
  "One Dance",
  "Too Good",
  "Hotline Bling",
  "Final Song",
  "Side To Side",
  "Do You Remember?",
  "Something Happened on the Way to Heaven",
  "I Wish It Would Rain Down",
  "Work from Home (feat. Ty Dolla $ign)",
  "Heathens",
  "What's My Age Again?",
  "Adam's Song",
  "Drinking in L.A.",
  "Starving",
  "Life is a Highway",
  "In the Name of Love",
  "Middle",
  "I Don't Wanna Know (feat. Enya & P. Diddy)",
  "Black Beatles",
  "Love Lockdown (Album Version)",
  "LUV",
  'Still Falling For You (From "Bridget Jones\'s Baby")',
  "Nine Million Bicycles",
  "The Time Is Now",
  "Broccoli (feat. Lil Yachty)",
  "Get Ready",
  "My Way",
  "Hey There Delilah",
  "Good as Hell",
  "Perfect Illusion",
  "Rockabye (feat. Sean Paul & Anne-Marie)",
  "Cheap Thrills (feat. Sean Paul)",
  "The Greatest (feat. Kendrick Lamar)",
  "No Limit",
  "Say You Won't Let Go",
  "Cool Girl",
  "Policy of Truth",
  "24K Magic",
  "Cake By The Ocean",
  "Starboy",
  "I Feel It Coming",
  "Ready 2 Go",
  "Just Hold On",
  "Hello",
  "Send My Love (To Your New Lover)",
  "Because I Got High",
  "For Whom The Bell Tolls",
  "Issues",
  "Faded",
  "Scared to Be Lonely",
  "Human",
  "Skin",
  "Groovy Train",
  "Ciao Adios",
  "Life Is A Highway",
  "It Ain't Me",
  "Mask Off",
  "Something Just Like This",
  "Swalla (feat. Nicki Minaj & Ty Dolla $ign)",
  "Stay",
  "Fill Me In",
  "7 Days",
  "Don't Love You No More (I'm Sorry)",
  "Young Dumb & Broke",
  "Pretty Girl (Cheat Codes X CADE Remix)",
  "Never Forget You",
  "Symphony (feat. Zara Larsson)",
  "Do You Really Like It?",
  "Passionfruit",
  "No Promises (feat. Demi Lovato)",
  "Paris",
  "Secret Love",
  "(Can't Live Without Your) Love And Affection",
  "HUMBLE.",
  "The Cure",
  "There's Nothing Holdin' Me Back",
  "Cradle Of Love",
  "Mama",
  "1-800-273-8255",
  "NO",
  "I Like Me Better",
  "Sign of the Times",
  "Glycerine",
  "Bad Liar",
  "Strip That Down",
  "Chantaje (feat. Maluma)",
  "IDGAF",
  "New Rules",
  "Unbelievable",
  "2U (feat. Justin Bieber)",
  "Green Light",
  "Bad Blood",
  "Wild Thoughts (feat. Rihanna & Bryson Tiller)",
  "I'm the One",
  "Slide (feat. Frank Ocean & Migos)",
  "Feels (feat. Pharrell Williams, Katy Perry & Big Sean)",
  "Mi Gente",
  "Unforgettable (feat. Swae Lee)",
  "Bring Em Out",
  "Live Your Life",
  "Whatever You Like",
  "Dead And Gone",
  "The Middle",
  "Praying",
  "Silence (feat. Khalid)",
  "Glorious (feat. Skylar Grey)",
  "Dusk Till Dawn (feat. Sia)",
  "One Wish",
  "What About Us",
  "Mine",
  "Slow Hands",
  "Wolves",
  "Too Good At Goodbyes",
  "Deep",
  "Step On",
  "Exterminate (Endzeit 7) [feat. Niki Haris]",
  "The Power",
  "Ooops Up",
  "Delicate",
  "Look What You Made Me Do",
  "Sweet Harmony",
  "Love Will Lead You Back",
  "Never Be the Same",
  "Havana (feat. Young Thug)",
  "Two Steps Behind (String / Acoustic Version)",
  "Say Something (feat. Chris Stapleton)",
  "FRIENDS",
  "1, 2, 3 (feat. Jason Derulo & De La Ghetto)",
  "Love Lies",
  "American Boy",
  "Dancing On My Own",
  "Remind Me to Forget",
  "Alien",
  "Disappear",
  "Bodak Yellow",
  "One Kiss",
  "Youngblood",
  "lovely",
  "Psycho",
  "Better Now",
  "Make Me Feel",
  "Girls Like You (Cardi B Version)",
  "Attention",
  "Audio (feat. Sia, Diplo & Labrinth)",
  "Back To You",
  "Start Again",
  "Jackie Chan",
  "Forget to Forget",
  "In My Blood",
  "Let Me Down Slowly",
  "In My Mind",
  "Knockin' On Heaven's Door",
  "Girls Like You",
  "Don't Wanna Know",
  "Ocean (feat. Khalid)",
  "Turn Around",
  "I'm a Mess",
  "High Hopes",
  "Mad Love",
  "Happy Now",
  "Believer",
  "Thunder",
  "All Falls Down",
  "Jesus Walks",
  "I Knew You Were Trouble.",
  "We Are Never Ever Getting Back Together",
  "Body",
  "If I Ever Lose My Faith In You",
  "No Brainer (feat. Justin Bieber, Chance the Rapper & Quavo)",
  "God's Plan",
  "In My Feelings",
  "Whatta Man",
  "Shoop",
  "Sweet but Psycho",
  "Do Me Right",
  "Save Up All Your Tears",
  "Love And Understanding",
  "Give It To You",
  "Happier",
  "Promises",
  "God is a woman",
  "no tears left to cry",
  "My My My!",
  "My Blood",
  "Electricity (feat. Diplo & Mark Ronson)",
  "Don't Leave Me Alone (feat. Anne-Marie)",
  "Let You Love Me",
  "Without Me",
  "Shallow",
  "Son of Man",
  "Strangers Like Me",
  "3 Nights",
  "MIA (feat. Drake)",
  "Missing U",
  "thank u, next",
  "Woman Like Me (feat. Nicki Minaj)",
  "Someone You Loved",
  "It Feels So Good",
  "Solo (feat. Demi Lovato)",
  "Eastside",
  "New Soul",
  "Boom Boom Boom",
  "It's Alright (The Guvnor Mix)",
  "Grillz",
  "Get Right",
  "Dancing With A Stranger",
  "i'm so tired...",
  "Giant",
  "Don't Call Me Up",
  "Con Calma",
  "Separated",
  "The Hardest Thing",
  "Piece Of Your Heart",
  "Applause",
  "7 rings",
  "break up with your girlfriend, i'm bored",
  "We R Who We R",
  "Flashing Lights",
  "Best I Ever Had",
  "Can't Stop This Thing We Started",
  "Please Forgive Me",
  "All Day And Night",
  "bad guy",
  "when the party's over",
  "21 Seconds",
  "Old Town Road (feat. Billy Ray Cyrus) (Remix)",
  "Let Me Think About It",
  "Truth Hurts",
  "SOS",
  "Party For One",
  "Wish You Well",
  "Post Malone (feat. RANI)",
  "The London (feat. J. Cole & Travis Scott)",
  "Ritual",
  "Never Really Over",
  "Ransom",
  "Sucker",
  "On A Roll",
  "Nothing Breaks Like a Heart (feat. Miley Cyrus)",
  "Señorita",
  "Old Town Road",
  "Instagram",
  "Higher Love",
  "Lalala",
  "One Day / Reckoning Song (Wankelmut Remix)",
  "Ride It",
  "Beautiful People (feat. Khalid)",
  "I Don't Care",
  "Killer",
  "How Do You Sleep?",
  "China",
  "Where Does My Heart Beat Now",
  "Loco Contigo",
  "Innuendo",
  "The Show Must Go On",
  "Hot Girl Summer (feat. Nicki Minaj & Ty Dolla $ign)",
  "Dance Monkey",
  "Yo x Ti, Tu x Mi",
  "Poker Face",
  "Teeth",
  "Lover",
  "You Need To Calm Down",
  "Never Seen The Rain",
  "Circles",
  "Wanted",
  "Liar",
  "Goodbyes",
  "Heartbreak Hotel (feat. Faith Evans & Kelly Price)",
  "Graveyard",
  "Stack It Up",
  "Memories",
  "Trampoline",
  "Playing Games",
  "Outnumbered",
  "Do Me!",
  "HIGHEST IN THE ROOM",
  "Lose Control",
  "The Git Up",
  "RITMO (Bad Boys For Life)",
  "Lose You To Love Me",
  "What Hurts The Most",
  "Takeaway (feat. Lennon Stella)",
  "Tusa",
  "Say So",
  "It's You",
  "everything i wanted",
  "ROXANNE",
  "Before You Go",
  "Better Off Alone",
  "Baila Baila Baila",
  "Nothin' My Love Can't Fix",
  "The Box",
  "Alone, Pt. II",
  "Watermelon Sugar",
  "Adore You",
  "Breaking Me",
  "Another Chance",
  "Life Is Good (feat. Drake)",
  "Pray",
  "Relight My Fire (feat. Lulu)",
  "Babe",
  "Heartless",
  "Know Your Worth",
  "death bed (coffee for your head)",
  "Love to Hate You",
  "Intentions",
  "Yummy",
  "ily (i love you baby)",
  "Make It Rain",
  "Kings & Queens",
  "Blinding Lights",
  "How Do You Do!",
  "Almost Unreal",
  "Fading Like A Flower (Every Time You Leave)",
  "Spending My Time",
  "Toosie Slide",
  "Sensitivity",
  "My, My, My",
  "you broke me first",
  "ROCKSTAR",
  "Somebody Dance with Me",
  "Loverboy",
  "Some Say",
  "Stupid Love",
  "Rain On Me",
  "Go Let It Out",
  "Lyla",
  "Savage Love (Laxed - Siren Beat)",
  "MAMACITA",
  "Everybody's Free",
  "Salt",
  "Calma",
  "Holy",
  "Waves (Robin Schulz Radio Edit)",
  "Que Calor",
  'Show Me Heaven (From "Days Of Thunder")',
  "Physical",
  "Break My Heart",
  "Supalonely",
  "Super Bass",
  "What Time Is Love? (Live at Trancentral)",
  "3AM Eternal (Live at the S.S.L.)",
  "Last Train To Trancentral (Live From The Lost Continent)",
  "Justified & Ancient",
  "Gett Off",
  "Dub Be Good To Me",
  "See You Again",
  "Love Story (Taylor's Version)",
  "Cry for Help",
  "Mood (feat. iann dior)",
  "Sorry Not Sorry",
  "Nobody's Love",
  "Glad You Came",
  "Whoomp! There It Is",
  "Dynamite",
  "FAKE LOVE",
  "Hip Hop Hooray",
  "Come Baby Come",
  "(We Want) The Same Thing",
  "Mercy",
  "Hole Hearted",
  "Everybody Plays The Fool",
  "Nothing Compares 2 U",
  "The King of Wishful Thinking",
];

export interface Track {
  title: string;
  artist: string;
  id: number;
  release_date: string;
  genre: string;
  preview: string;
  cover: string;
}

export const tracks: Track[] = [
  {
    title: "Stand by Me",
    artist: "Ben E. King",
    id: 80728352,
    release_date: "1962-08-20",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/e/8/d/0/e8dfce8cc667df57951453f48a859148.mp3?hdnea=exp=1763730731~acl=/api/1/1/e/8/d/0/e8dfce8cc667df57951453f48a859148.mp3*~data=user_id=0,application_id=42~hmac=9e63cdaa1a0658b5567311ee3bebe358f154606fd5e4cbbb3b0d4e125f6041d5",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/dcea225fa1c17ad5bab1241bff4d0acf/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "Space Oddity",
    artist: "David Bowie",
    id: 107465566,
    release_date: "1969-09-25",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/7/d/3/0/7d342da36946904f066ef209124d086e.mp3?hdnea=exp=1763730731~acl=/api/1/1/7/d/3/0/7d342da36946904f066ef209124d086e.mp3*~data=user_id=0,application_id=42~hmac=d2ad294761fa90a8a12c6eac21be41960dda946ad74efd8f269bee4691111f68",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/8bd4a046f3d8c8895d9aff00a3b7c2df/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "(Sittin' On) the Dock of the Bay",
    artist: "Otis Redding",
    id: 90859071,
    release_date: "1968-01-08",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/4/4/e/0/44ec4df06736a24f474f5153b198ab2d.mp3?hdnea=exp=1763730731~acl=/api/1/1/4/4/e/0/44ec4df06736a24f474f5153b198ab2d.mp3*~data=user_id=0,application_id=42~hmac=461e33e5969d20fd1ecd9e8e373d1d431e45b9b263873c106d3d5067056387a1",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/e32d56c61a5914589c57cfd71c5f312e/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "I Say a Little Prayer",
    artist: "Aretha Franklin",
    id: 904747,
    release_date: "1967-10-14",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/b/e/a/0/beaeddb830b5411419374b1c49882549.mp3?hdnea=exp=1763730731~acl=/api/1/1/b/e/a/0/beaeddb830b5411419374b1c49882549.mp3*~data=user_id=0,application_id=42~hmac=b842ea5f5c28590393965a00b0afab5b53fabbd46f1bafa3cf28ffee6ce45234",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/825419030587ba289ee683382b652136/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Hotel California",
    artist: "Eagles",
    id: 68095470,
    release_date: "1977-02-22",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/d/e/0/0/de0b52925103149e94a7123d0c0cb6c4.mp3?hdnea=exp=1763730731~acl=/api/1/1/d/e/0/0/de0b52925103149e94a7123d0c0cb6c4.mp3*~data=user_id=0,application_id=42~hmac=4f37adc00b05af93a6a0ae2a528c0db1c18d1bb074bdc5e129b9c9651880ed5b",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/208c9a0b2fcc579be8fb7200c9cc0d4a/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Stars",
    artist: "Simply Red",
    id: 2551829,
    release_date: "1991-10-24",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/3/3/1/0/331c13146530e508d7728a61c3975485.mp3?hdnea=exp=1763730731~acl=/api/1/1/3/3/1/0/331c13146530e508d7728a61c3975485.mp3*~data=user_id=0,application_id=42~hmac=53ef90fe5a71b3641effd0e6dcc28376d15ebdda19e9a8fd6a499f8eac72b0a8",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/d2cb6d75e25263be723e1b31f9238978/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Hungry Like the Wolf",
    artist: "Duran Duran",
    id: 4127465,
    release_date: "1982-09-07",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/6/5/2/0/652c7be4ebcc5220a7f49863cfc6e75f.mp3?hdnea=exp=1763730731~acl=/api/1/1/6/5/2/0/652c7be4ebcc5220a7f49863cfc6e75f.mp3*~data=user_id=0,application_id=42~hmac=f807a55bf3a0028dfc16928865365f2f28a2b01c80637692c301a7b87cad3963",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/c3ef1ffaad88a51594e210a1075c2f1c/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Against All Odds (Take a Look at Me Now)",
    artist: "Phil Collins",
    id: 134036230,
    release_date: "1981-10-14",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/d/0/0/0/d0008ca45411e793699f331be08f489f.mp3?hdnea=exp=1763730731~acl=/api/1/1/d/0/0/0/d0008ca45411e793699f331be08f489f.mp3*~data=user_id=0,application_id=42~hmac=4f059aaba5a9fac5dbfb7e387e956ed8e86781b68697ae5e39587217de5efe97",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/73e6481676a8ab3e93f0f7b79a9cff68/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Heroes",
    artist: "David Bowie",
    id: 461043312,
    release_date: "1977-09-29",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/b/1/f/0/b1fda796e068d4582c854b3ce23af125.mp3?hdnea=exp=1763730731~acl=/api/1/1/b/1/f/0/b1fda796e068d4582c854b3ce23af125.mp3*~data=user_id=0,application_id=42~hmac=b39d2415e049a558a84b78c2534732d21b782b25aa6e91f23b4ee7ed3f582521",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/5fb91018679f65199308256be3c584ab/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Yellow",
    artist: "Coldplay",
    id: 3128096,
    release_date: "2000-07-10",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/6/4/f/0/64f36083ad5a11e6803ef7ddbcdaf898.mp3?hdnea=exp=1763730731~acl=/api/1/1/6/4/f/0/64f36083ad5a11e6803ef7ddbcdaf898.mp3*~data=user_id=0,application_id=42~hmac=344d91a15abfff783949609bd97dfa36892b968c41159f4962f8d9ac51bdab03",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/3a31bfbc6678856d2cfe10dbb22b8a24/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "Thinking out Loud",
    artist: "Ed Sheeran",
    id: 79875064,
    release_date: "2014-06-20",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/4/9/4/0/494ddfc070ac9ad7615d5a1655804710.mp3?hdnea=exp=1763730731~acl=/api/1/1/4/9/4/0/494ddfc070ac9ad7615d5a1655804710.mp3*~data=user_id=0,application_id=42~hmac=399b1bbce61c3a30a0c701d0c4f0e376972a0f3a0860e93f82b23fc2dfe33823",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/b1d763da698c38bde6a526c8220ca0ea/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Fast Car",
    artist: "Tracy Chapman",
    id: 2271563,
    release_date: "1988-01-01",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/0/0/0/0/0009cabc4816aa3e3f10fa9e26bceace.mp3?hdnea=exp=1763730731~acl=/api/1/1/0/0/0/0/0009cabc4816aa3e3f10fa9e26bceace.mp3*~data=user_id=0,application_id=42~hmac=9a91147a6aefc0201d74defabec1318eb69c829f847d23a08553ab5802f42b9f",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/b9990f3c2febfc83c1d7218da7474cb2/250x250-000000-80-0-0.jpg",
    genre: "Folk",
  },
  {
    title: "Wicked Game",
    artist: "Chris Isaak",
    id: 1391362322,
    release_date: "1981-06-04",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/d/b/7/0/db7dcc0dfeeeeebdd8428b4f20feeeb5.mp3?hdnea=exp=1763730731~acl=/api/1/1/d/b/7/0/db7dcc0dfeeeeebdd8428b4f20feeeb5.mp3*~data=user_id=0,application_id=42~hmac=ef7de6b634dd2c0e88f7b3a38da250304d230e12829731232ba362d35279135e",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/3eeae28ccbcbb62f5cd43565812429e8/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "Take on Me",
    artist: "a-ha",
    id: 664107,
    release_date: "1985-06-12",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/2/b/a/0/2baf2724d658f73af8ac7a1c81479f2e.mp3?hdnea=exp=1763730731~acl=/api/1/1/2/b/a/0/2baf2724d658f73af8ac7a1c81479f2e.mp3*~data=user_id=0,application_id=42~hmac=22aa92a557d910647bec9333b898ad8425cbd232b41c35b16c8b64e48a415278",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/e0ce8977ab98d73bcea00fc838ece034/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Crazy",
    artist: "Gnarls Barkley",
    id: 2794160,
    release_date: "2007-01-01",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/a/1/e/0/a1ec23ed2b57529bb2d3eb1198448044.mp3?hdnea=exp=1763731651~acl=/api/1/1/a/1/e/0/a1ec23ed2b57529bb2d3eb1198448044.mp3*~data=user_id=0,application_id=42~hmac=54bca8d89b55c0b7ff22307fb499ece9774be5df8cd93ec635bf7ae4b8b8d3f6",
    cover: "https://api.deezer.com/album/271531/image",
    genre: "Pop",
  },
  {
    title: "The Best",
    artist: "Tina Turner",
    id: 3167295,
    release_date: "1989-01-01",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/9/1/5/0/9151952d21aa50f3bcd24f5c3080103d.mp3?hdnea=exp=1763730731~acl=/api/1/1/9/1/5/0/9151952d21aa50f3bcd24f5c3080103d.mp3*~data=user_id=0,application_id=42~hmac=ea84fc91f13138d8ff50b9a55fd6a458df890e1851f741a730864ad995f3d0ab",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/42024f50dc501575ae920ccf506fa4dd/250x250-000000-80-0-0.jpg",
    genre: "R&B",
  },
  {
    title: "I Want to Know What Love Is",
    artist: "Foreigner",
    id: 675818,
    release_date: "1984-01-29",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/6/3/f/0/63f32f7f3247341d42d18f1b4cc6d92e.mp3?hdnea=exp=1763730731~acl=/api/1/1/6/3/f/0/63f32f7f3247341d42d18f1b4cc6d92e.mp3*~data=user_id=0,application_id=42~hmac=98b9e34c55657760b50a0b91671120582f9a874bf795e5bc3ba7ccf7c7c96a49",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/e9ff017e261498ee3b7fd3707763b211/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "Fool (If You Think It's Over)",
    artist: "Chris Rea",
    id: 424000782,
    release_date: "1988-10-17",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/d/f/d/0/dfd59085131ec68407a09bc59fe2231a.mp3?hdnea=exp=1763730731~acl=/api/1/1/d/f/d/0/dfd59085131ec68407a09bc59fe2231a.mp3*~data=user_id=0,application_id=42~hmac=1099b7accc6ae9fa676ff198dd821dd975a607b20c6aad21e5d1d7635855a891",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/1872b42859b17538573fd64b8c6b93a3/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Bad Day",
    artist: "Daniel Powter",
    id: 771897,
    release_date: "2005-02-22",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/7/0/c/0/70c4ec2b590040dfe7b763d4f59c107a.mp3?hdnea=exp=1763730731~acl=/api/1/1/7/0/c/0/70c4ec2b590040dfe7b763d4f59c107a.mp3*~data=user_id=0,application_id=42~hmac=14afa8d025ca8e529c09e231244526c86f694c94f7869f9bc9fb185a2cb9f873",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/0676a2ca21cc85832288b8b43f02482e/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Like a Prayer",
    artist: "Madonna",
    id: 4209640,
    release_date: "1989-03-03",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/7/2/b/0/72b88b7e520fa5cf75ed776def157d5d.mp3?hdnea=exp=1763730731~acl=/api/1/1/7/2/b/0/72b88b7e520fa5cf75ed776def157d5d.mp3*~data=user_id=0,application_id=42~hmac=c001919a34db9d996db8bf1fa894400a7a1cfde3307d596caf313548e26fd6ab",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/195d3d2c1196b20711cfb6ad76e1c2ba/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Edge of Seventeen",
    artist: "Stevie Nicks",
    id: 135376666,
    release_date: "1976-11-04",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/a/1/f/0/a1f1e546027242301d6f99004c06cc1f.mp3?hdnea=exp=1763730731~acl=/api/1/1/a/1/f/0/a1f1e546027242301d6f99004c06cc1f.mp3*~data=user_id=0,application_id=42~hmac=fa9600908a16796ef921db8290b1d8763e47a863f085c3fbfa2faacfbcb82497",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/6ff23019f5d481542c19706995c7980c/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "Move on Up",
    artist: "Curtis Mayfield",
    id: 115195420,
    release_date: "1970-12-18",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/c/a/c/0/cac605a14df61ba6ddf6e23b9ce1cc46.mp3?hdnea=exp=1763730731~acl=/api/1/1/c/a/c/0/cac605a14df61ba6ddf6e23b9ce1cc46.mp3*~data=user_id=0,application_id=42~hmac=94505370b21df482f8308eef6e8a234c634eddcc9c00dd57c0841a3f19885d11",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/93637763db9f47b7a8f8c1e31ff11c0e/250x250-000000-80-0-0.jpg",
    genre: "R&B",
  },
  {
    title: "Last Request",
    artist: "Paolo Nutini",
    id: 3657960,
    release_date: "2007-01-30",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/4/7/1/0/4719ccb129690c041562644845ff40f6.mp3?hdnea=exp=1763730731~acl=/api/1/1/4/7/1/0/4719ccb129690c041562644845ff40f6.mp3*~data=user_id=0,application_id=42~hmac=17d024358af804f66623ef260659be2c45839278ee0cc90edf8498f98a0cd4a7",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/f43d26dc4fa2d28279dd3665af1dad83/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Respect",
    artist: "Aretha Franklin",
    id: 904732,
    release_date: "1967-04-29",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/c/3/3/0/c33e79affa5092d8e74aeed3388023bd.mp3?hdnea=exp=1763730731~acl=/api/1/1/c/3/3/0/c33e79affa5092d8e74aeed3388023bd.mp3*~data=user_id=0,application_id=42~hmac=df0ed5dc08fad360556adeafd04caf8b376abda58fb08ab4c8f74492a2bacfec",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/9e9ba9115d0fb62879d1bb672ee67c07/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "You're so Vain",
    artist: "Carly Simon",
    id: 688346,
    release_date: "1972-01-21",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/9/b/a/0/9bae8ac36d8608bfb182dfa84afeab90.mp3?hdnea=exp=1763730731~acl=/api/1/1/9/b/a/0/9bae8ac36d8608bfb182dfa84afeab90.mp3*~data=user_id=0,application_id=42~hmac=f2f9cec2dd8caf9902c0968fa505db71090bce1f4761e4ef065b2b113595a77c",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/ee8f9b6f3ba4d17c17cf3f6b43b24c85/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Go Your Own Way",
    artist: "Fleetwood Mac",
    id: 67549191,
    release_date: "1977-12-04",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/d/0/3/0/d035cf11959f12094864ea2bf33a95c9.mp3?hdnea=exp=1763730731~acl=/api/1/1/d/0/3/0/d035cf11959f12094864ea2bf33a95c9.mp3*~data=user_id=0,application_id=42~hmac=63060c8cffbc797208e8d4eb13e418f91ba50cba9da5dcc672ae33ca098b42de",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/df696ab6f33650f6d8e32dda8adf5264/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "How You Remind Me",
    artist: "Nickelback",
    id: 810179,
    release_date: "2001-09-10",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/2/c/1/0/2c166c4c36422f08376c52774eb9427d.mp3?hdnea=exp=1763730731~acl=/api/1/1/2/c/1/0/2c166c4c36422f08376c52774eb9427d.mp3*~data=user_id=0,application_id=42~hmac=cbb1b030d2a5105836af39aec02b68561a1888c607310c4bf58f69bc1d8cd3e4",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/61395db55522768a7a42e085c487d045/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "Take It Easy",
    artist: "Eagles",
    id: 68094695,
    release_date: "1972-04-26",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/e/b/5/0/eb5a581c382c0b4f5872ea36f73e8e89.mp3?hdnea=exp=1763730731~acl=/api/1/1/e/b/5/0/eb5a581c382c0b4f5872ea36f73e8e89.mp3*~data=user_id=0,application_id=42~hmac=159620caf414ca2119059fcb79d2f64aab34abe68b349815d614aa82f4f26b97",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/b7a45d37330235f99a01a2e1e8106d1f/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Ain't Nobody",
    artist: "Chaka Khan",
    id: 776220,
    release_date: "1983-01-01",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/1/6/d/0/16d4d568e35fb4f24d057a876f6cb32d.mp3?hdnea=exp=1763730731~acl=/api/1/1/1/6/d/0/16d4d568e35fb4f24d057a876f6cb32d.mp3*~data=user_id=0,application_id=42~hmac=1728eda54b6bf015b976d94e8b61e9a235525ec9a1a047e545b96dcfe7005906",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/84ecee5f0d598c5d0b5da405f6a3fa90/250x250-000000-80-0-0.jpg",
    genre: "R&B",
  },
  {
    title: "Feel It Still",
    artist: "Portugal. The Man",
    id: 143171642,
    release_date: "2017-03-03",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/c/4/0/0/c40625c5884ce97ba5725b43d3cafb3b.mp3?hdnea=exp=1763730731~acl=/api/1/1/c/4/0/0/c40625c5884ce97ba5725b43d3cafb3b.mp3*~data=user_id=0,application_id=42~hmac=f712951002e66f139d068d5f28e29540118aa6e6e69217031cd3ae41d97e242c",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/6f204aa755d4354a8d548334f193fd86/250x250-000000-80-0-0.jpg",
    genre: "Alternative",
  },
  {
    title: "Don't Start Now",
    artist: "Dua Lipa",
    id: 793163542,
    release_date: "2019-10-31",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/7/e/6/0/7e61976ea51d9b253a6c887d644c87a7.mp3?hdnea=exp=1763730731~acl=/api/1/1/7/e/6/0/7e61976ea51d9b253a6c887d644c87a7.mp3*~data=user_id=0,application_id=42~hmac=01a6c6aeabb2519d96eda7144b07f93e3e22dbe0a427071525dc2c31926adc22",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/2330b746089b5f6f4507cb84cc35d4d3/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "A Little Respect",
    artist: "Erasure",
    id: 61774152,
    release_date: "1985-06-21",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/7/d/1/0/7d134d8270d261e95d8bea3d4376b1bb.mp3?hdnea=exp=1763731651~acl=/api/1/1/7/d/1/0/7d134d8270d261e95d8bea3d4376b1bb.mp3*~data=user_id=0,application_id=42~hmac=578ba247d67a2880ea433108a88b8c73a0adf307ce706fe529de9697784bdaf0",
    cover: "https://api.deezer.com/album/6056339/image",
    genre: "Pop",
  },
  {
    title: "Just the Way You Are",
    artist: "Bruno Mars",
    id: 7084642,
    release_date: "2010-07-20",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/b/6/9/0/b698a4e6c85776865d8d2517923988ce.mp3?hdnea=exp=1763730731~acl=/api/1/1/b/6/9/0/b698a4e6c85776865d8d2517923988ce.mp3*~data=user_id=0,application_id=42~hmac=2c1b7639d3c8b5f6bb0f92e2ae238a005e93deb7191e7122104866fc8de49f43",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/fca132eaf0b297e95aca78a2739a0f33/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Somewhere in My Heart",
    artist: "Aztec Camera",
    id: 782929,
    release_date: "1987-01-18",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/7/4/8/0/7485985e1f41df33ceeacc8f745379bc.mp3?hdnea=exp=1763731651~acl=/api/1/1/7/4/8/0/7485985e1f41df33ceeacc8f745379bc.mp3*~data=user_id=0,application_id=42~hmac=d95bb5967ad23367a14ab50ed0032de9758d384d0039e4afca48fdc95f81ea84",
    cover: "https://api.deezer.com/album/91700/image",
    genre: "Pop",
  },
  {
    title: "Young Hearts Run Free",
    artist: "Candi Staton",
    id: 720737,
    release_date: "1976-02-08",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/2/4/c/0/24c56600217e43659fce9d4201a2b711.mp3?hdnea=exp=1763730731~acl=/api/1/1/2/4/c/0/24c56600217e43659fce9d4201a2b711.mp3*~data=user_id=0,application_id=42~hmac=cc8f95b1750d10d862be01000c16deaa8eab9c7e577e1fbec54cad0c1a1138fc",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/8a3cad753bd8e46f528d5d339f9f0e57/250x250-000000-80-0-0.jpg",
    genre: "R&B",
  },
  {
    title: "Wings",
    artist: "Birdy",
    id: 69466071,
    release_date: "2013-07-29",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/6/b/1/0/6b1e9a7d236f3c79e250b4fe5f19fc1f.mp3?hdnea=exp=1763730731~acl=/api/1/1/6/b/1/0/6b1e9a7d236f3c79e250b4fe5f19fc1f.mp3*~data=user_id=0,application_id=42~hmac=97b7824120547836d27388ecac51403ee044120ab982be3e77dbd2f5d600374f",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/3d24aeaaa8ddb94c9e71b36ab1ac690c/250x250-000000-80-0-0.jpg",
    genre: "Alternative",
  },
  {
    title: "Golden Brown",
    artist: "The Stranglers",
    id: 3152622,
    release_date: "1981-10-25",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/c/4/e/0/c4ef696c84c5f29055785d1aa43ca9d4.mp3?hdnea=exp=1763730731~acl=/api/1/1/c/4/e/0/c4ef696c84c5f29055785d1aa43ca9d4.mp3*~data=user_id=0,application_id=42~hmac=75da9af210294c715f1b5cf21d3bff6689a4f4aa1f3bec0c8be67fd44b78c015",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/510f299a5e25a267f0dde2dcfd41d0f1/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "We Built This City",
    artist: "Starship",
    id: 602137972,
    release_date: "1985-09-10",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/a/0/5/0/a05dbd2a2bd6f42181f4d6841fa67756.mp3?hdnea=exp=1763730731~acl=/api/1/1/a/0/5/0/a05dbd2a2bd6f42181f4d6841fa67756.mp3*~data=user_id=0,application_id=42~hmac=34af91ff549514676abeb3fcb82b890b51e18c81dd9bf72ee1be7cd6ac881b8c",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/15cf311226db704fd9925c4362628ac8/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "Love Will Tear Us Apart",
    artist: "Joy Division",
    id: 797434,
    release_date: "1981-02-12",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/6/7/9/0/6793d131ed8ce7fc5fba9ef1167a3dcf.mp3?hdnea=exp=1763731651~acl=/api/1/1/6/7/9/0/6793d131ed8ce7fc5fba9ef1167a3dcf.mp3*~data=user_id=0,application_id=42~hmac=c16278e2cd04c0f956ed2b29ce2d8bc9a0929e54850712c3af1996bd8b8a9c49",
    cover: "https://api.deezer.com/album/93066/image",
    genre: "Pop",
  },
  {
    title: "This Charming Man",
    artist: "The Smiths",
    id: 13776514,
    release_date: "1981-06-26",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/1/b/2/0/1b2cf3fafb40140f3b16cc753340ed61.mp3?hdnea=exp=1763730731~acl=/api/1/1/1/b/2/0/1b2cf3fafb40140f3b16cc753340ed61.mp3*~data=user_id=0,application_id=42~hmac=17f26a4e9fb389daddb77f79b4199fc7d3ad87c3b9494f2c771ef9970fd35581",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/57d3a0dd210f59a53b889d2afb20c402/250x250-000000-80-0-0.jpg",
    genre: "Alternative",
  },
  {
    title: "You Can't Hurry Love",
    artist: "Phil Collins",
    id: 119121832,
    release_date: "1982-11-05",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/7/a/6/0/7a62756aec14ab09ce04abcf4b10a9bd.mp3?hdnea=exp=1763730732~acl=/api/1/1/7/a/6/0/7a62756aec14ab09ce04abcf4b10a9bd.mp3*~data=user_id=0,application_id=42~hmac=4f62bdc3a8e80ea0160e447df062fdf2d6d6ce5e5050c44107a6e8bb3565b574",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/ac7ba5cf3b11fabf4e6779e40cfce16d/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Nothing's Gonna Stop Us Now",
    artist: "Starship",
    id: 602137932,
    release_date: "1991-05-14",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/e/6/d/0/e6d700770d11f43802c2e9c30c704263.mp3?hdnea=exp=1763730732~acl=/api/1/1/e/6/d/0/e6d700770d11f43802c2e9c30c704263.mp3*~data=user_id=0,application_id=42~hmac=fd7222821414d68b645ca28963b86b32ceaef30788624e22251b098c7fa4eaa0",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/b23cca2bd9985e39cb1909c3cc90cc9d/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "Groove Is in the Heart",
    artist: "Deee-Lite",
    id: 75070408,
    release_date: "1990-04-19",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/f/f/6/0/ff68ac1700619546f7caf21c5b1fdf45.mp3?hdnea=exp=1763731651~acl=/api/1/1/f/f/6/0/ff68ac1700619546f7caf21c5b1fdf45.mp3*~data=user_id=0,application_id=42~hmac=1f9480204aeb7560219ef7843ecdd4dde1704f646b92941a58291f5933717a86",
    cover: "https://api.deezer.com/album/7423261/image",
    genre: "Pop",
  },
  {
    title: "Kiss from a Rose",
    artist: "Seal",
    id: 730428,
    release_date: "1987-11-08",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/8/5/6/0/85655f312ddb53e2583cdbd766a3f84b.mp3?hdnea=exp=1763730732~acl=/api/1/1/8/5/6/0/85655f312ddb53e2583cdbd766a3f84b.mp3*~data=user_id=0,application_id=42~hmac=8baa9b69425bde7ccb3acb75bcc22150a995d181769f1239c6ca73d39b0e66f2",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/4c895d110af6fb22aa99c2d2bf995a0d/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Kiss",
    artist: "Prince",
    id: 664178,
    release_date: "1986-03-25",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/8/c/3/0/8c392a4f7618e60d22cac844b0315e36.mp3?hdnea=exp=1763730732~acl=/api/1/1/8/c/3/0/8c392a4f7618e60d22cac844b0315e36.mp3*~data=user_id=0,application_id=42~hmac=4a98ccca985e2da8177fa4282abf3e9734dbb22fe52d32253eff3e7c41328b9a",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/07d3890b48303d09025f92ba7b9d67ac/250x250-000000-80-0-0.jpg",
    genre: "Alternative",
  },
  {
    title: "True",
    artist: "Spandau Ballet",
    id: 3130319,
    release_date: "1984-12-18",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/6/8/5/0/6853c80a9c7f361030d1af303369f935.mp3?hdnea=exp=1763730732~acl=/api/1/1/6/8/5/0/6853c80a9c7f361030d1af303369f935.mp3*~data=user_id=0,application_id=42~hmac=2e6dae18be4a4a6bc4347530e702be801b52df4cbf5dc790a873cfd96e07b756",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/b88d3c3ad23435fb5b8d52038551c1f6/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "It Must Have Been Love",
    artist: "Roxette",
    id: 3098301,
    release_date: "1981-07-26",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/0/6/6/0/066aae449406b6ea3addfb6ad51a6ded.mp3?hdnea=exp=1763730732~acl=/api/1/1/0/6/6/0/066aae449406b6ea3addfb6ad51a6ded.mp3*~data=user_id=0,application_id=42~hmac=eaa23c4579ea2253b04f67b758de64cbb0cd98ad91cb2087877ce7141e757435",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/04a8fc1d885619f9418aab478cccf881/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Once in a Lifetime",
    artist: "Talking Heads",
    id: 5093672,
    release_date: "1980-10-08",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/7/a/4/0/7a4551aaa34d530efd8505395bfb2be1.mp3?hdnea=exp=1763730732~acl=/api/1/1/7/a/4/0/7a4551aaa34d530efd8505395bfb2be1.mp3*~data=user_id=0,application_id=42~hmac=60c4c6810046c3d26b4b6f1886a6361917569b12fd0df49fca862151cdf419b4",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/1f829d18efbdb8a54fbca7701d5098a9/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "West End Girls",
    artist: "Pet Shop Boys",
    id: 3310512,
    release_date: "1986-06-06",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/e/c/1/0/ec1b1f90924e6f83373d3add7aa7ca61.mp3?hdnea=exp=1763730732~acl=/api/1/1/e/c/1/0/ec1b1f90924e6f83373d3add7aa7ca61.mp3*~data=user_id=0,application_id=42~hmac=d63c49ca189222338c3cca0161464eb22d336eaf4800d5ef2cc9abbbba71c091",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/393d2ce1ba348485b895213e226bd9da/250x250-000000-80-0-0.jpg",
    genre: "Dance",
  },
  {
    title: "Pack Up",
    artist: "Eliza Doolittle",
    id: 6719344,
    release_date: "2010-07-23",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/8/1/f/0/81fa5724fbbcdd40be3daeb380d46fdc.mp3?hdnea=exp=1763730463~acl=/api/1/1/8/1/f/0/81fa5724fbbcdd40be3daeb380d46fdc.mp3*~data=user_id=0,application_id=42~hmac=13023a7c333c8dfc36f92a76dcd2cc058f943517b665bf39853d5fa5664615c0",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/db89f647fd33aad7fb446423ecc759d7/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Love Shack",
    artist: "The B-52's",
    id: 701763002,
    release_date: "1989-08-19",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/c/b/5/0/cb5d6e0cfe15be4a0b839d8550c3ee3b.mp3?hdnea=exp=1763730732~acl=/api/1/1/c/b/5/0/cb5d6e0cfe15be4a0b839d8550c3ee3b.mp3*~data=user_id=0,application_id=42~hmac=8429fb287c54122881e023ef379b2cf76417c34f75a588f7348b27303e3d92ba",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/6818c7381d798e48f789709b882a77b4/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "It's My Life ",
    artist: "Talk Talk",
    id: 3257507,
    release_date: "1984-01-15",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/1/a/9/0/1a9bd11cb47c2a161433c21d1cbffd9c.mp3?hdnea=exp=1763726030~acl=/api/1/1/1/a/9/0/1a9bd11cb47c2a161433c21d1cbffd9c.mp3*~data=user_id=0,application_id=42~hmac=7bdac44c489081723840f4c80c2b6ee87b613db327ba4aad8202924486aa78ec",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/5d0f763786b6be3fe0450985f5e0c524/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "Running Up That Hill",
    artist: "Kate Bush",
    id: 11616579,
    release_date: "1985-05-16",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/9f2d90023183010d657b01cba6bd5f19/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "I'll Be There",
    artist: "Jess Glynne",
    id: 491898322,
    release_date: "2018-05-04",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/1/7/c/0/17c6546dece9e6af1e21b9acb2885381.mp3?hdnea=exp=1763731225~acl=/api/1/1/1/7/c/0/17c6546dece9e6af1e21b9acb2885381.mp3*~data=user_id=0,application_id=42~hmac=b14ca5813f64b428dbbebb82e6e23c4af7d8af50760e119632675aafc5fb8cbc",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/6b50f62715805aecb686fa1a90d1705b/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Just the Two of Us",
    artist: "Grover Washington, Jr.",
    id: 3085246,
    release_date: "1980-04-14",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/d/9/b/0/d9b2454163bb4315f871e763ffc81ed7.mp3?hdnea=exp=1763731225~acl=/api/1/1/d/9/b/0/d9b2454163bb4315f871e763ffc81ed7.mp3*~data=user_id=0,application_id=42~hmac=a89eb2fa1ee987029e30705eb0ac1f878cf503dfb05e670e3aba249eae109a70",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/c6d04772ee490586a8771df7c2705c43/250x250-000000-80-0-0.jpg",
    genre: "Soul",
  },
  {
    title: "Drive",
    artist: "The Cars",
    id: 474178182,
    release_date: "1984-03-13",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/0/6/6/0/066349ab5981ceb3386309996da3b3bd.mp3?hdnea=exp=1763731225~acl=/api/1/1/0/6/6/0/066349ab5981ceb3386309996da3b3bd.mp3*~data=user_id=0,application_id=42~hmac=9e67aa9bd08e3bd46a2827a84b1e32228b202a257675c916eaa2728099e5af44",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/d3c653ace62ec6833849e55970598199/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Breathless",
    artist: "The Corrs",
    id: 661620,
    release_date: "2000-01-01",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/4/a/7/0/4a7a42808cf6f801473de3a89a64db4b.mp3?hdnea=exp=1763731225~acl=/api/1/1/4/a/7/0/4a7a42808cf6f801473de3a89a64db4b.mp3*~data=user_id=0,application_id=42~hmac=41bb532797eb4530e834db711bb3783852d88d2f9eea7aa3db05cf1854ea0170",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/53399d8b50372230690a46d783a83709/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Soul Man",
    artist: "Sam & Dave",
    id: 685250,
    release_date: "1967-06-20",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/3/5/8/0/3586f985de3836a3d86a7be2cf8ef284.mp3?hdnea=exp=1763731225~acl=/api/1/1/3/5/8/0/3586f985de3836a3d86a7be2cf8ef284.mp3*~data=user_id=0,application_id=42~hmac=ef2485afed7f9e0728b3af133e3d4b77b385e4da9ece56e85a6719b2abcd320d",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/127d728275f3bacb36c19705ecf9ceb1/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "I'm Yours",
    artist: "Jason Mraz",
    id: 845909,
    release_date: "2008-05-12",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/2/7/d/0/27de9a005e318f52c1630426e33d04a6.mp3?hdnea=exp=1763731225~acl=/api/1/1/2/7/d/0/27de9a005e318f52c1630426e33d04a6.mp3*~data=user_id=0,application_id=42~hmac=d6b0e18f0ac4a628d80f1d04d3d55929c2fd6fd946b5f1a43125f45621386a47",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/14afa8e767482283a4bd57ceae31eb80/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Cannonball",
    artist: "Damien Rice",
    id: 904289,
    release_date: "2003-06-03",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/a/1/a/0/a1a9b6f8f6c69c3e359e4a62daa0279b.mp3?hdnea=exp=1763731225~acl=/api/1/1/a/1/a/0/a1a9b6f8f6c69c3e359e4a62daa0279b.mp3*~data=user_id=0,application_id=42~hmac=e94bffb7943f9299d4981c243289e191925b2ff03d18658cf09242d7f08c8fc9",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/7fb2dfbd954d1bf84405bdafa9a76491/250x250-000000-80-0-0.jpg",
    genre: "Alternative",
  },
  {
    title: "Brass in Pocket",
    artist: "The Pretenders",
    id: 14636389,
    release_date: "1992-05-25",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/7/8/2/0/7828c418fe265f3b3af979b7a383c24e.mp3?hdnea=exp=1763731225~acl=/api/1/1/7/8/2/0/7828c418fe265f3b3af979b7a383c24e.mp3*~data=user_id=0,application_id=42~hmac=3de38bf334560218070a2c34575c6d35c866c261b85c55575a9717b3dba16b6e",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/9eb2fd178dc4c9d53204ee6467cb52cb/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "When a Man Loves a Woman",
    artist: "Percy Sledge",
    id: 727540,
    release_date: "1966-04-15",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/9/6/5/0/965f54a683740499a5a79af00507da10.mp3?hdnea=exp=1763731225~acl=/api/1/1/9/6/5/0/965f54a683740499a5a79af00507da10.mp3*~data=user_id=0,application_id=42~hmac=9dcd26c0b949407cf8be361d8223c33ab4cd2b5b2084aa4740c86b0d81d84c65",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/cb9cd3ff4da779845c681baf2241570e/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "Baker Street",
    artist: "Gerry Rafferty",
    id: 3169189,
    release_date: "1978-06-03",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/0/5/2/0/0528aadbdfd7a7e005ec09464105cd19.mp3?hdnea=exp=1763731225~acl=/api/1/1/0/5/2/0/0528aadbdfd7a7e005ec09464105cd19.mp3*~data=user_id=0,application_id=42~hmac=b1bd657a3122a6ab7fa222c4e6c1528909b89764fecad282f58c11391da0e772",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/a4a40656ade105b7010c58687a14bd06/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "Cry to Me",
    artist: "Solomon Burke",
    id: 67404732,
    release_date: "1962-05-14",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/8/5/7/0/85796dee5865c8765aafe7e4a54bb9e6.mp3?hdnea=exp=1763731651~acl=/api/1/1/8/5/7/0/85796dee5865c8765aafe7e4a54bb9e6.mp3*~data=user_id=0,application_id=42~hmac=ced5c1cc64e4d74f662e834e895ac378913d7c92bb04d7deca935272bb0da5be",
    cover: "https://api.deezer.com/album/6592547/image",
    genre: "Rock",
  },
  {
    title: "Black Velvet",
    artist: "Alannah Myles",
    id: 674958,
    release_date: "1989-03-14",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/3/e/a/0/3eaa53bc90f8e5a39cc2b75f2690bda1.mp3?hdnea=exp=1763731225~acl=/api/1/1/3/e/a/0/3eaa53bc90f8e5a39cc2b75f2690bda1.mp3*~data=user_id=0,application_id=42~hmac=9cc51151a96a48589fe32127789d8f88046eea7965457af5757bff3cab00d643",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/38793735d9b791ceb15e0679161a9248/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "Blue Monday '88",
    artist: "New Order",
    id: 706051,
    release_date: "1988-12-06",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/7/a/e/0/7aea8a4ca1d9900292e76da306cf1692.mp3?hdnea=exp=1763731651~acl=/api/1/1/7/a/e/0/7aea8a4ca1d9900292e76da306cf1692.mp3*~data=user_id=0,application_id=42~hmac=eb999fc36586cdc9bd5a5e5a62933b845568e58ad49cee1c5599e34d223117aa",
    cover: "https://api.deezer.com/album/84572/image",
    genre: "Pop",
  },
  {
    title: "Walking in Memphis",
    artist: "Marc Cohn",
    id: 675175,
    release_date: "1991-01-22",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/a/0/0/0/a0090db809fc9de8ad2c84cc49ac36de.mp3?hdnea=exp=1763731226~acl=/api/1/1/a/0/0/0/a0090db809fc9de8ad2c84cc49ac36de.mp3*~data=user_id=0,application_id=42~hmac=e878411499192ff0977f18c55cc571f6a33bbbbfcda1386cd65dc6875a44c1b3",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/e93c673f9acf0afa27432ae67dfad76b/250x250-000000-80-0-0.jpg",
    genre: "Country",
  },
  {
    title: "Wish You Were Here",
    artist: "Pink Floyd",
    id: 116914042,
    release_date: "1975-09-15",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/0/1/b/0/01bb9546e0555d21953c927ae4d1950a.mp3?hdnea=exp=1763731226~acl=/api/1/1/0/1/b/0/01bb9546e0555d21953c927ae4d1950a.mp3*~data=user_id=0,application_id=42~hmac=03f206d84207d7da279469d8e687328aaac935a950499e6c29c3e518d0740ec8",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/4720f991d5806bd8dcf46f9460737cad/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "Perfect",
    artist: "Ed Sheeran",
    id: 142986206,
    release_date: "2017-03-03",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/f/1/3/0/f1325f089fd1f0f72b291014f20dcc4a.mp3?hdnea=exp=1763731226~acl=/api/1/1/f/1/3/0/f1325f089fd1f0f72b291014f20dcc4a.mp3*~data=user_id=0,application_id=42~hmac=2f3f5ef79674e9e52ae15d3c7aaa315395f93b14ab5ea4bc303591023af268a8",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/000a9228cecfcc7c2093d9cd7bb66447/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Harvest Moon",
    artist: "Neil Young",
    id: 677484,
    release_date: "1992-10-23",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/d/6/5/0/d65bfcfde6ead263806c4f2c579eb0e3.mp3?hdnea=exp=1763731226~acl=/api/1/1/d/6/5/0/d65bfcfde6ead263806c4f2c579eb0e3.mp3*~data=user_id=0,application_id=42~hmac=04e87c3a8d77c012e33127e117fa9f13551594066d5f6ab823b4a1822834ed55",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/51e508e0f63b2d4f610d84503fc10467/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Constant Craving",
    artist: "K.D. Lang",
    id: 5414332,
    release_date: "1992-02-05",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/3/f/f/0/3ffbd70fd3a2726fa4998b7ae0353dd0.mp3?hdnea=exp=1763731226~acl=/api/1/1/3/f/f/0/3ffbd70fd3a2726fa4998b7ae0353dd0.mp3*~data=user_id=0,application_id=42~hmac=eaf2af97320aaea0e2bbdd142336227a23c58daafb651c558b3d159ba2df5080",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/9d3f9b6f6f1836c8362d8f42ef5f37d4/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "You've Got a Friend",
    artist: "James Taylor",
    id: 2794416,
    release_date: "1970-01-01",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/6/7/9/0/679776978673db954075675e65a12a93.mp3?hdnea=exp=1763731226~acl=/api/1/1/6/7/9/0/679776978673db954075675e65a12a93.mp3*~data=user_id=0,application_id=42~hmac=eb6c02e994b1da9644b818f71d7670f0b1f294d6e9ffd5e63a46bb8a9bb8cd51",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/feb6b5dcb16e2f5e0441c1d3623f8c20/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "Knock on Wood",
    artist: "Eddie Floyd",
    id: 690462,
    release_date: "1979-03-26",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/f/e/7/0/fe7fc5e04fa41c0d8085f381d0a9feef.mp3?hdnea=exp=1763731226~acl=/api/1/1/f/e/7/0/fe7fc5e04fa41c0d8085f381d0a9feef.mp3*~data=user_id=0,application_id=42~hmac=e9f93d2e6ac6831218992d61cab8c99adf2d256f9382bfe9ae0c9151827654ee",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/0932240b16bf7293d82c58e05f5116ca/250x250-000000-80-0-0.jpg",
    genre: "R&B",
  },
  {
    title: "She Drives Me Crazy",
    artist: "Fine Young Cannibals",
    id: 700715042,
    release_date: "1989-02-20",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/d8f5b3da8a883596aba17a55067e426f/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Sleeping Satellite",
    artist: "Tasmin Archer",
    id: 3115574,
    release_date: "1992-10-19",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/2/9/0/0/290c191b8db4eac0ad97353a821ee772.mp3?hdnea=exp=1763731226~acl=/api/1/1/2/9/0/0/290c191b8db4eac0ad97353a821ee772.mp3*~data=user_id=0,application_id=42~hmac=da09918f42a38b647dcfaa562b9b9e5677edbff579be63a23a29b2b4b74ced6a",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/b85663f5c0008c8fd0b7892506c4f822/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "Sitting Down Here",
    artist: "Lene Marlin",
    id: 3134928,
    release_date: "1999-05-31",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/2/0/4/0/2043a98d12e71a844f83d9eeee3f74e6.mp3?hdnea=exp=1763731226~acl=/api/1/1/2/0/4/0/2043a98d12e71a844f83d9eeee3f74e6.mp3*~data=user_id=0,application_id=42~hmac=5bebc3da7e0e68c1a9dd84f07b81812ad9855793b81b259ea9cd252a96561812",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/4a039abef730d570941f61c50d8b53e0/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Rather Be",
    artist: "Clean Bandit",
    id: 73982869,
    release_date: "2014-06-23",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/d/b/b/0/dbb449df39281075077e294ef092c2ce.mp3?hdnea=exp=1763731226~acl=/api/1/1/d/b/b/0/dbb449df39281075077e294ef092c2ce.mp3*~data=user_id=0,application_id=42~hmac=82ccf5ec9c49367b9308d86d4a27771be19c89b215c3114d278a3e23d9dc11c8",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/3193132d50c74a62d1cd419fa170139a/250x250-000000-80-0-0.jpg",
    genre: "Dance",
  },
  {
    title: "Love Changes (Everything)",
    artist: "Climie Fisher",
    id: 3147082,
    release_date: "1988-03-14",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/8/d/5/0/8d5f503beed96dec857371a0e73846c5.mp3?hdnea=exp=1763731226~acl=/api/1/1/8/d/5/0/8d5f503beed96dec857371a0e73846c5.mp3*~data=user_id=0,application_id=42~hmac=e291a4f15e16a851f7b25bb3cde337a0003fcd820a9098957a4ae0b2faf68947",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/6ad9e952f6e2d02d54b4b68a2e5c440d/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "I Got You Babe",
    artist: "Sonny & Cher",
    id: 735788,
    release_date: "1965-04-26",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/c/4/e/0/c4e1f8fcb6fd909a823368d46507601e.mp3?hdnea=exp=1763731226~acl=/api/1/1/c/4/e/0/c4e1f8fcb6fd909a823368d46507601e.mp3*~data=user_id=0,application_id=42~hmac=dc2da57103006c930a9b5923d77ae46603660ed0f599fbc0cbb0be64c4963d3e",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/1ebbc4b4ee98befdb3c342aef82af73e/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Sweet Love",
    artist: "Anita Baker",
    id: 717534,
    release_date: "1986-01-01",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/1/9/5/0/195c0074afa468afe5e21ab65ae26bd6.mp3?hdnea=exp=1763731226~acl=/api/1/1/1/9/5/0/195c0074afa468afe5e21ab65ae26bd6.mp3*~data=user_id=0,application_id=42~hmac=e4be96c153c8f268bfd95fecb18134a44469c8c6a8bc910f245cb9eb951f7b99",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/4dfc174b1bb5ce17188129fb2994fb78/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Into the Mystic",
    artist: "Van Morrison",
    id: 71433041,
    release_date: "1970-10-18",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/0/e/6/0/0e6e92bacba01af65d6270abf8622db4.mp3?hdnea=exp=1763731226~acl=/api/1/1/0/e/6/0/0e6e92bacba01af65d6270abf8622db4.mp3*~data=user_id=0,application_id=42~hmac=8f9b49536a4c1d349a3c336677a40e27dbe64e68bcb2d678bfeaa43f9b4cab5e",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/f648440c11c75ac519bd74b75f486cb8/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "Wasn't Expecting That",
    artist: "Jamie Lawson",
    id: 103907218,
    release_date: "2015-07-17",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/f/3/0/0/f30b4688d57e3454415151e321e23a90.mp3?hdnea=exp=1763731226~acl=/api/1/1/f/3/0/0/f30b4688d57e3454415151e321e23a90.mp3*~data=user_id=0,application_id=42~hmac=e413f7e1545d12db1d42c8e539d6c776e0ddd7bbd2a0df077ba67a9f040031ec",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/0529672ee69ae96207d2967e785e23e3/250x250-000000-80-0-0.jpg",
    genre: "Alternative",
  },
  {
    title: "Daydream Believer",
    artist: "The Monkees",
    id: 5093933,
    release_date: "1968-12-18",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/9/9/1/0/9915f14292722a850bb7b832e69ee5ac.mp3?hdnea=exp=1763731652~acl=/api/1/1/9/9/1/0/9915f14292722a850bb7b832e69ee5ac.mp3*~data=user_id=0,application_id=42~hmac=00cd138674dda2c4497c462c880caa7d6f946dc2844969a205c86f5bdaceae0b",
    cover: "https://api.deezer.com/album/467286/image",
    genre: "Pop",
  },
  {
    title: "Smile",
    artist: "Lily Allen",
    id: 3153912,
    release_date: "2006-07-17",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/d/9/3/0/d933fe76109128ae9b79816491fdab74.mp3?hdnea=exp=1763731226~acl=/api/1/1/d/9/3/0/d933fe76109128ae9b79816491fdab74.mp3*~data=user_id=0,application_id=42~hmac=b0013b469cf5dca3bf7585cb539aff7db15ef8ec0ffe73802802fa5f4dc9049d",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/d6fe228b80ced09fde7666b3d9371567/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "I Love You Always Forever",
    artist: "Donna Lewis",
    id: 846048,
    release_date: "1996-06-27",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/a/f/e/0/afe6869f87836ffdcb0f887533ce1ee2.mp3?hdnea=exp=1763731226~acl=/api/1/1/a/f/e/0/afe6869f87836ffdcb0f887533ce1ee2.mp3*~data=user_id=0,application_id=42~hmac=675e57ddce2aff67ef927d64546e2f6900556c7574459489d073c889903cff8e",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/27795c295df90807631e2bffa1da0a73/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Owner of a Lonely Heart",
    artist: "Yes",
    id: 3613215,
    release_date: "1983-06-01",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/3/2/a/0/32a72db166b5035d2ab5d993099e82c1.mp3?hdnea=exp=1763731226~acl=/api/1/1/3/2/a/0/32a72db166b5035d2ab5d993099e82c1.mp3*~data=user_id=0,application_id=42~hmac=68c43d2720ba5e9bad59ab3997b2b4c9f7b4bde45183dd8a2414832459301e88",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/1bdcb776e4d04064cba66bdd494a94ef/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "Viva La Vida",
    artist: "Coldplay",
    id: 3157972,
    release_date: "2008-05-26",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/e/2/5/0/e25fade11767fd539ad651da72103237.mp3?hdnea=exp=1763731226~acl=/api/1/1/e/2/5/0/e25fade11767fd539ad651da72103237.mp3*~data=user_id=0,application_id=42~hmac=4e818b0fb28c5d23efb2c8e092bf6bfeec59edc39b33867fd3e0d41f011fe673",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/eede3cd0dc3a5a87c7a5b1085b022e2d/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "Iris",
    artist: "The Goo Goo Dolls",
    id: 4209117,
    release_date: "1998-03-31",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/9/5/7/0/9574f855fbbe0897c4d79412d8275b92.mp3?hdnea=exp=1763731226~acl=/api/1/1/9/5/7/0/9574f855fbbe0897c4d79412d8275b92.mp3*~data=user_id=0,application_id=42~hmac=e0305b223ff8cd30394791f4cdba0d9edd36aa52a4fcaeea9dfbd4054f947186",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/82b3dfb072236e94f9d6c8204b0fd82c/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "The Universal",
    artist: "Blur",
    id: 38441521,
    release_date: "1995-09-11",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/1/6/e/0/16e518e8fe42b70e1ded1d4b59803cc4.mp3?hdnea=exp=1763731226~acl=/api/1/1/1/6/e/0/16e518e8fe42b70e1ded1d4b59803cc4.mp3*~data=user_id=0,application_id=42~hmac=53f9fc016fd793497761cbcef183a15e5c743fcd70bb2f116a43a92d9fc9a895",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/f501ee1cff6f7ecdf0d8f2f67cceb4c4/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "Under the Bridge",
    artist: "Red Hot Chili Peppers",
    id: 724838,
    release_date: "1991-09-24",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/3/4/b/0/34bc5e060833b39587eec58e9dc84fea.mp3?hdnea=exp=1763731226~acl=/api/1/1/3/4/b/0/34bc5e060833b39587eec58e9dc84fea.mp3*~data=user_id=0,application_id=42~hmac=b962cdd79eb7f314423cad5b8ba3d1343e643638d7cf59895427c5b2ff86899b",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/5d7af03204d679ef877b9033d279d8bd/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "A Thousand Years",
    artist: "Christina Perri",
    id: 14495443,
    release_date: "2011-10-18",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/0/8/2/0/0825619c0e40ccbe0db06bd0c599b7b7.mp3?hdnea=exp=1763731226~acl=/api/1/1/0/8/2/0/0825619c0e40ccbe0db06bd0c599b7b7.mp3*~data=user_id=0,application_id=42~hmac=34ce659fd6e046aea0e2066ee4b79193cb1020f1c6562d380c8044f28e9e79eb",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/9f361f0228d08731b70cb0c996520606/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Rise Up",
    artist: "Andra Day",
    id: 105804300,
    release_date: "2015-08-28",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/f/6/8/0/f68df14cbaaa78d86fa2fe8a46b49c54.mp3?hdnea=exp=1763731226~acl=/api/1/1/f/6/8/0/f68df14cbaaa78d86fa2fe8a46b49c54.mp3*~data=user_id=0,application_id=42~hmac=2e40b0757848adf2dce1077780fc0388c3ffaec741763ea4aca9083be41c11f0",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/428505622a2bf7bbed8b1d05cdb67b8a/250x250-000000-80-0-0.jpg",
    genre: "R&B",
  },
  {
    title: "Love Town",
    artist: "Booker Newberry III",
    id: 74785361,
    release_date: "1983-06-06",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/d/e/2/0/de2c66da2966812cfcfc3b8882b2265e.mp3?hdnea=exp=1763731226~acl=/api/1/1/d/e/2/0/de2c66da2966812cfcfc3b8882b2265e.mp3*~data=user_id=0,application_id=42~hmac=216f268f22bc57573383e194bc8f6e824c263ffec044fbec4fd31662e2d69090",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/6acb8032280e22494773cc3b08229c29/250x250-000000-80-0-0.jpg",
    genre: "Soul & Funk",
  },
  {
    title: "You're the One for Me",
    artist: "D Train",
    id: 73236419,
    release_date: "1981-11-27",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/b/6/3/0/b639ab593280cbeca4c2a1875c038bd4.mp3?hdnea=exp=1763731226~acl=/api/1/1/b/6/3/0/b639ab593280cbeca4c2a1875c038bd4.mp3*~data=user_id=0,application_id=42~hmac=8d3b51f9ad309c9709daad0567b6d8fbf998d175b1ee6b86f2f7ae2f562b6368",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/180435dc808834a234c4e8bca7e4a48e/250x250-000000-80-0-0.jpg",
    genre: "Soul",
  },
  {
    title: "Forget Me Nots",
    artist: "Patrice Rushen",
    id: 434614222,
    release_date: "1982-01-01",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/2/0/a/0/20ab7570b71579db3ab9eaa6f4b4ac8f.mp3?hdnea=exp=1763731226~acl=/api/1/1/2/0/a/0/20ab7570b71579db3ab9eaa6f4b4ac8f.mp3*~data=user_id=0,application_id=42~hmac=4771732b39c86b78275eb8b83177335ff8e3b2de1b75c1e35f4e0f033088e71b",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/c8189301e853ab1debddc16e2bce59ff/250x250-000000-80-0-0.jpg",
    genre: "R&B",
  },
  {
    title: "Imagination",
    artist: "Belouis Some",
    id: 3873128,
    release_date: "1985-06-26",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/e/e/c/0/eec4f3f68fd2afb5bfe8d92dfb180ef3.mp3?hdnea=exp=1763731226~acl=/api/1/1/e/e/c/0/eec4f3f68fd2afb5bfe8d92dfb180ef3.mp3*~data=user_id=0,application_id=42~hmac=025766651f950b3fc7a12545c229da057c1fe22447a0659bb9860eac4ba6dca6",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/3f0e862ec9a60ba799292fb0e0ab5798/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Native Son",
    artist: "Bryan Adams",
    id: 1564430,
    release_date: "1988-11-01",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/8/d/5/0/8d5ce28050d4bb3a76c1beeb112fa72a.mp3?hdnea=exp=1763731226~acl=/api/1/1/8/d/5/0/8d5ce28050d4bb3a76c1beeb112fa72a.mp3*~data=user_id=0,application_id=42~hmac=b5176ed6edd4ea1571e96f9d3e0d4fbeeff1b40777e873359e4d48110c3a4858",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/665789e3447d33ef1f3af71ff4d44ad1/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "I Feel for You",
    artist: "Chaka Khan",
    id: 685227,
    release_date: "1984-04-18",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/8/9/8/0/898d0c2f6cb3242a6291d62b037ff3ed.mp3?hdnea=exp=1763731226~acl=/api/1/1/8/9/8/0/898d0c2f6cb3242a6291d62b037ff3ed.mp3*~data=user_id=0,application_id=42~hmac=53af3a3f276f7c750e69ea6675506e0b53b83bb3211d586c3aab0a433bf03a5e",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/1b35699645d63299c0979e679d7f4ee2/250x250-000000-80-0-0.jpg",
    genre: "Dance",
  },
  {
    title: "(Feels Like) Heaven",
    artist: "Fiction Factory",
    id: 5404615,
    release_date: "1984-02-26",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/3/4/a/0/34a0cfc08aad9d640cc59543cd547714.mp3?hdnea=exp=1763731651~acl=/api/1/1/3/4/a/0/34a0cfc08aad9d640cc59543cd547714.mp3*~data=user_id=0,application_id=42~hmac=757999f6039c22038938fcaa49fb13133818cc728c7de10517e136652b314356",
    cover: "https://api.deezer.com/album/494852/image",
    genre: "Pop",
  },
  {
    title: "Dancing In the Dark",
    artist: "Bruce Springsteen",
    id: 15586246,
    release_date: "1984-06-04",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/8/9/f/0/89fa971ce8594abd29d87e7891cb03b8.mp3?hdnea=exp=1763731651~acl=/api/1/1/8/9/f/0/89fa971ce8594abd29d87e7891cb03b8.mp3*~data=user_id=0,application_id=42~hmac=176be6250150a96e8a2346595f5a6c875bf2b764204b49b2abd2822815b0740d",
    cover: "https://api.deezer.com/album/1440805/image",
    genre: "Rock",
  },
  {
    title: "Hysteria",
    artist: "Def Leppard",
    id: 447552872,
    release_date: "1987-01-19",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/c/e/a/0/cea11fa1d3ec874aa25b1ea8bda2f75d.mp3?hdnea=exp=1763731651~acl=/api/1/1/c/e/a/0/cea11fa1d3ec874aa25b1ea8bda2f75d.mp3*~data=user_id=0,application_id=42~hmac=dff83fda41aa902dfab83e7d8f6c174410d60735f0942faa46308829f60e925b",
    cover: "https://api.deezer.com/album/54592642/image",
    genre: "Rock",
  },
  {
    title: "Don't Stop Believin'",
    artist: "Journey",
    id: 534462,
    release_date: "1988-11-15",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/a/c/9/0/ac913a6056291b8b7eace8215717df37.mp3?hdnea=exp=1763731651~acl=/api/1/1/a/c/9/0/ac913a6056291b8b7eace8215717df37.mp3*~data=user_id=0,application_id=42~hmac=75d69abfc9d73fd662e768338399bdf478c3b92f0f0931372ed78838f09a7d33",
    cover: "https://api.deezer.com/album/71148/image",
    genre: "Pop",
  },
  {
    title: "One More Time",
    artist: "Daft Punk",
    id: 3135553,
    release_date: "2005-01-24",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/f/8/c/0/f8c5dc3837912dba37c9a1ab3170cc3f.mp3?hdnea=exp=1763731652~acl=/api/1/1/f/8/c/0/f8c5dc3837912dba37c9a1ab3170cc3f.mp3*~data=user_id=0,application_id=42~hmac=3ef17b5fb051d5e734a2e0c8a6b93d1cb2339ff5330db8da080ea8b43cadb527",
    cover: "https://api.deezer.com/album/302127/image",
    genre: "Dance",
  },
  {
    title: "Get Lucky",
    artist: "Daft Punk",
    id: 67238735,
    release_date: "2013-05-17",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/c/8/a/0/c8a61130657a2cf58e3ac751e7950617.mp3?hdnea=exp=1763731652~acl=/api/1/1/c/8/a/0/c8a61130657a2cf58e3ac751e7950617.mp3*~data=user_id=0,application_id=42~hmac=b7204e4e47c583fe9e593515a08a4677281dad03a6a0bc4dc003b851fb7bc797",
    cover: "https://api.deezer.com/album/6575789/image",
    genre: "Pop",
  },
  {
    title: "I Don't Feel Like Dancin'",
    artist: "Scissor Sisters",
    id: 2504050,
    release_date: "2006-07-28",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/3/c/2/0/3c2922f155a7c3a3aa147bbbbec77fa3.mp3?hdnea=exp=1763731652~acl=/api/1/1/3/c/2/0/3c2922f155a7c3a3aa147bbbbec77fa3.mp3*~data=user_id=0,application_id=42~hmac=ec41a358b8d68bfd5de9ce3958335a1c36ba76206beee48408cf60440c2a32aa",
    cover: "https://api.deezer.com/album/246128/image",
    genre: "Pop",
  },
  {
    title: "Dreamer",
    artist: "Livin' Joy",
    id: 117106930,
    release_date: "1994-01-08",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/7/2/6/0/726da7db4408f656b668bbb285813b5c.mp3?hdnea=exp=1763731652~acl=/api/1/1/7/2/6/0/726da7db4408f656b668bbb285813b5c.mp3*~data=user_id=0,application_id=42~hmac=34d8ddcad54fbbaa6fe8cc54f6be170aa876e8d1678977a7661968ac21c9fef2",
    cover: "https://api.deezer.com/album/12151610/image",
    genre: "Dance",
  },
  {
    title: "U Sure Do ",
    artist: "Strike",
    id: 129736034,
    release_date: "1994-08-19",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/a/d/f/0/adf37fecc1127b13ac40b312f6dbeb2e.mp3?hdnea=exp=1763731652~acl=/api/1/1/a/d/f/0/adf37fecc1127b13ac40b312f6dbeb2e.mp3*~data=user_id=0,application_id=42~hmac=8630eddc9de44fd352a6e2c85462fe5a8fcdae990cd5019fd46a31189b77e953",
    cover: "https://api.deezer.com/album/13738780/image",
    genre: "Dance",
  },
  {
    title: "Love Come Down",
    artist: "Evelyn Champagne King",
    id: 5404581,
    release_date: "1982-02-26",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/c/1/e/0/c1e8cc2c6f2acac3b39090574e4b9f8c.mp3?hdnea=exp=1763731652~acl=/api/1/1/c/1/e/0/c1e8cc2c6f2acac3b39090574e4b9f8c.mp3*~data=user_id=0,application_id=42~hmac=09002a9289d7f89a3a3d95439352fe9202d0b4b2e782b9c24d24a99c92bd1b96",
    cover: "https://api.deezer.com/album/494852/image",
    genre: "Pop",
  },
  {
    title: "Lets Groove",
    artist: "Earth, Wind & Fire",
    id: 430578532,
    release_date: "1977-11-08",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/d/8/2/0/d82a84d940e1d53a42fb8df1d06b35bc.mp3?hdnea=exp=1763731652~acl=/api/1/1/d/8/2/0/d82a84d940e1d53a42fb8df1d06b35bc.mp3*~data=user_id=0,application_id=42~hmac=d7d551187c7222d2decbf2bdd1dc21055bd265061b54ca56a5e678f27eff617c",
    cover: "https://api.deezer.com/album/51929112/image",
    genre: "Rap/Hip Hop",
  },
  {
    title: "Free",
    artist: "Ultra Nate",
    id: 86921769,
    release_date: "1997-04-14",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/1/c/3/0/1c399fa3f4661bf7bc5601286afcf6c2.mp3?hdnea=exp=1763731652~acl=/api/1/1/1/c/3/0/1c399fa3f4661bf7bc5601286afcf6c2.mp3*~data=user_id=0,application_id=42~hmac=953404f6e17ad6c519ac85f6d4532a2c9fb7b44d16b9ed94ed787f6018cdbb03",
    cover: "https://api.deezer.com/album/8769807/image",
    genre: "Dance",
  },
  {
    title: "Push The Feeling On",
    artist: "Nightcrawlers",
    id: 105353318,
    release_date: "1992-08-21",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/2/3/8/0/238532b63ecf49ecbab61c3e1bc2dd40.mp3?hdnea=exp=1763731652~acl=/api/1/1/2/3/8/0/238532b63ecf49ecbab61c3e1bc2dd40.mp3*~data=user_id=0,application_id=42~hmac=db1da023f7aa17084ab971b330308e9d3ab47899210a53079d40b908887b96a8",
    cover: "https://api.deezer.com/album/10974000/image",
    genre: "Dance",
  },
  {
    title: "And the Beat Goes On",
    artist: "The Whispers",
    id: 131212454,
    release_date: "1980-01-01",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/2/6/d/0/26d1f4e7fde446be4ddf4834f0233983.mp3?hdnea=exp=1763731652~acl=/api/1/1/2/6/d/0/26d1f4e7fde446be4ddf4834f0233983.mp3*~data=user_id=0,application_id=42~hmac=6f8c94812414696399ad25b922c4922fe93f577e81d367b27ea72575339e5267",
    cover: "https://api.deezer.com/album/13935074/image",
    genre: "R&B",
  },
  {
    title: "Ain't No Stoppin' Us Now",
    artist: "McFadden & Whitehead",
    id: 4760904,
    release_date: "1979-12-04",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/a/a/3/0/aa3dd87b3ad9f94503ea292273d72586.mp3?hdnea=exp=1763731652~acl=/api/1/1/a/a/3/0/aa3dd87b3ad9f94503ea292273d72586.mp3*~data=user_id=0,application_id=42~hmac=02d828247a7c981a15838b20ab66bb538d63a4b304d41c7bad3bda7276506352",
    cover: "https://api.deezer.com/album/438244/image",
    genre: "Pop",
  },
  {
    title: "Got to Be Real",
    artist: "Cheryl Lynn",
    id: 68075550,
    release_date: "1978-06-21",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/2/4/a/0/24acd1621bf03584447aabb86b5fd0f9.mp3?hdnea=exp=1763731652~acl=/api/1/1/2/4/a/0/24acd1621bf03584447aabb86b5fd0f9.mp3*~data=user_id=0,application_id=42~hmac=d30c47b6b4fe1fca6a67fee3c45d4c6436801175042040bde6e697edad70687b",
    cover: "https://api.deezer.com/album/6668596/image",
    genre: "Pop",
  },
  {
    title: "I Can't Wait",
    artist: "Nu Shooz",
    id: 71807622,
    release_date: "1986-05-05",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/3/a/4/0/3a4204457d8f1e8578c9e5f7d9c4b1ed.mp3?hdnea=exp=1763731652~acl=/api/1/1/3/a/4/0/3a4204457d8f1e8578c9e5f7d9c4b1ed.mp3*~data=user_id=0,application_id=42~hmac=9ef5b0bc05a9e1e88eff3e01a4803795bcce7862f4475dfd3a3f9c23f42ad55c",
    cover: "https://api.deezer.com/album/7055205/image",
    genre: "Dance",
  },
  {
    title: "Never Give up on a Good Thing",
    artist: "George Benson",
    id: 95964494,
    release_date: "1981-02-27",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/3/a/8/0/3a83e075366ed5498c19b4d8c1359143.mp3?hdnea=exp=1763731652~acl=/api/1/1/3/a/8/0/3a83e075366ed5498c19b4d8c1359143.mp3*~data=user_id=0,application_id=42~hmac=9cb43ae1d086acce3a100e52b2a93a47b1f3e493f170cdeaf190a7b60bbe6a89",
    cover: "https://api.deezer.com/album/9760330/image",
    genre: "Pop",
  },
  {
    title: "I Can Make You Feel Good",
    artist: "Shalamar",
    id: 5448334,
    release_date: "1982-01-04",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/0/f/9/0/0f956cff0d9b851b99b4f2cc4bbe86bf.mp3?hdnea=exp=1763731652~acl=/api/1/1/0/f/9/0/0f956cff0d9b851b99b4f2cc4bbe86bf.mp3*~data=user_id=0,application_id=42~hmac=1e32a03b0a38161c29f0137b84ab4a62b2fcb88c58d88188f9ed966237cf6f88",
    cover: "https://api.deezer.com/album/498728/image",
    genre: "Rap/Hip Hop",
  },
  {
    title: "Give Me the Reason",
    artist: "Luther Vandross",
    id: 15176244,
    release_date: "1986-09-19",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/5/a/8/0/5a8bdbfdcea11eb28a8d6122fd758493.mp3?hdnea=exp=1763731652~acl=/api/1/1/5/a/8/0/5a8bdbfdcea11eb28a8d6122fd758493.mp3*~data=user_id=0,application_id=42~hmac=1502c6ca5b86dc4d92ac530fe64854f361ceb6f0efd1d5d0d68abb1360329049",
    cover: "https://api.deezer.com/album/1398549/image",
    genre: "R&B",
  },
  {
    title: "Lost in Music",
    artist: "Sister Sledge",
    id: 846328,
    release_date: "1972-08-11",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/6/e/d/0/6ed3ab5df65763a3ed624aa9a7c1e9bf.mp3?hdnea=exp=1763731652~acl=/api/1/1/6/e/d/0/6ed3ab5df65763a3ed624aa9a7c1e9bf.mp3*~data=user_id=0,application_id=42~hmac=94f521d913154d0dd4a86cc5e92bf1b1b741d791c321e81909f48d058c36dd18",
    cover: "https://api.deezer.com/album/97336/image",
    genre: "Dance",
  },
  {
    title: "We Are Family",
    artist: "Sister Sledge",
    id: 846327,
    release_date: "1972-08-11",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/c/4/9/0/c49d90ea610129caa520f6d7262ceb0e.mp3?hdnea=exp=1763731652~acl=/api/1/1/c/4/9/0/c49d90ea610129caa520f6d7262ceb0e.mp3*~data=user_id=0,application_id=42~hmac=2a4fe523249ba5dd06c5948a7a478e265c8d5f6444c746d3073693bf7b450106",
    cover: "https://api.deezer.com/album/97336/image",
    genre: "Dance",
  },
  {
    title: "Can You Feel It",
    artist: "The Jacksons",
    id: 5404550,
    release_date: "1980-02-26",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/9/5/6/0/956065570ad16b4f7f35ecd856fb8dea.mp3?hdnea=exp=1763731652~acl=/api/1/1/9/5/6/0/956065570ad16b4f7f35ecd856fb8dea.mp3*~data=user_id=0,application_id=42~hmac=3c3b26f9b3252dddb33ec0f9a08e5c08e748290899ea515cc651917ba5ceb04e",
    cover: "https://api.deezer.com/album/494852/image",
    genre: "Pop",
  },
  {
    title: "Not That Kind",
    artist: "Anastacia",
    id: 833621,
    release_date: "2000-05-01",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/9/3/e/0/93e2c735b7bbab2cb970466d1b93fa25.mp3?hdnea=exp=1763731652~acl=/api/1/1/9/3/e/0/93e2c735b7bbab2cb970466d1b93fa25.mp3*~data=user_id=0,application_id=42~hmac=cfe3b53d3807eaccb4d64cd9490ff4cf4818930772b5c4136498513f1ae4cdaa",
    cover: "https://api.deezer.com/album/96292/image",
    genre: "Pop",
  },
  {
    title: "I'm Outta Love",
    artist: "Anastacia",
    id: 833622,
    release_date: "2000-05-01",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/f/7/a/0/f7ad749c12716c05f3559b197da0049d.mp3?hdnea=exp=1763731652~acl=/api/1/1/f/7/a/0/f7ad749c12716c05f3559b197da0049d.mp3*~data=user_id=0,application_id=42~hmac=2152a4d724a1c8d964b0a202de3f7e47fe2bd2bb34c423f30fa5811781a13683",
    cover: "https://api.deezer.com/album/96292/image",
    genre: "Pop",
  },
  {
    title: "I'm So Excited",
    artist: "The Pointer Sisters",
    id: 546757,
    release_date: "1982-01-01",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/1/4/c/0/14c59fc709c194da0f55f2b7369984b3.mp3?hdnea=exp=1763731652~acl=/api/1/1/1/4/c/0/14c59fc709c194da0f55f2b7369984b3.mp3*~data=user_id=0,application_id=42~hmac=c2f22d4c3fe2fb15e289b802b6ba5284634c2b8398627214d76b834d57fe2f36",
    cover: "https://api.deezer.com/album/72061/image",
    genre: "Pop",
  },
  {
    title: "Good Times",
    artist: "Chic",
    id: 6614292,
    release_date: "1979-10-05",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/c/7/0/0/c7061afb6eca2fa62335365ff52d8d13.mp3?hdnea=exp=1763731652~acl=/api/1/1/c/7/0/0/c7061afb6eca2fa62335365ff52d8d13.mp3*~data=user_id=0,application_id=42~hmac=0fad7ba83b7ac627098f1a57e333331ab3eb6e510f951453d596e119bfe9e695",
    cover: "https://api.deezer.com/album/611530/image",
    genre: "Pop",
  },
  {
    title: "I'm Gonna Be (500 Miles)",
    artist: "The Proclaimers",
    id: 3109247,
    release_date: "1987-08-11",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/e/d/1/0/ed178dc1475c336eda755d3c17461ed2.mp3?hdnea=exp=1763731652~acl=/api/1/1/e/d/1/0/ed178dc1475c336eda755d3c17461ed2.mp3*~data=user_id=0,application_id=42~hmac=e80073270a67451d8449cbab546bbc43e4487522788e24d1eaa4320fcecf2616",
    cover: "https://api.deezer.com/album/300494/image",
    genre: "Pop",
  },
  {
    title: "Reach Out I'll Be There",
    artist: "Four Tops",
    id: 909611,
    release_date: "1966-06-05",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/f/7/5/0/f752b5c4c6f8377867356bd2a83af8dd.mp3?hdnea=exp=1763731652~acl=/api/1/1/f/7/5/0/f752b5c4c6f8377867356bd2a83af8dd.mp3*~data=user_id=0,application_id=42~hmac=bb22d4a1416c2b6a3d595aae8c650b4257ad9989786cdc8658a4df09fd2ad389",
    cover: "https://api.deezer.com/album/102586/image",
    genre: "Pop",
  },
  {
    title: "Boogie Wonderland",
    artist: "Earth, Wind & Fire",
    id: 1277771,
    release_date: "1978-07-25",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/7fe1f8e4c7ea6bf2b1f99543d3a8c35e/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Who Let The Dogs Out",
    artist: "Baha Men",
    id: 3389258,
    release_date: "2000-07-25",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/3c811e7975cf933fdb0b17a6426dcc01/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Hey, Little Girl",
    artist: "Icehouse",
    id: 13213908,
    release_date: "1982-08-26",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/c0ec5d3e566373109767afce9f9879eb/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "What Is Love?",
    artist: "Howard Jones",
    id: 367292071,
    release_date: "1983-06-01",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/4bace238d73b2329d4f6596a71ee6aca/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Killer / Papa Was a Rollin' Stone",
    artist: "George Michael",
    id: 16433503,
    release_date: "1998-01-30",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/549a1f50cd5903e2f42e3253814f8b33/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Here Comes the Rain Again",
    artist: "Eurythmics",
    id: 1022289,
    release_date: "1984-01-06",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/81061a21fd646f5bec5dcfe32684385b/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Thorn In My Side",
    artist: "Eurythmics",
    id: 1022300,
    release_date: "1991-03-01",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/81061a21fd646f5bec5dcfe32684385b/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Love Is A Stranger",
    artist: "Eurythmics",
    id: 576086,
    release_date: "1991-11-04",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/160c2f2740b5043d609af68003d01eb0/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "What's Love Got to Do with It",
    artist: "Tina Turner",
    id: 3120266,
    release_date: "1984-02-05",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/7b5022390f35e035d14edd5e0d6cfb92/250x250-000000-80-0-0.jpg",
    genre: "R&B",
  },
  {
    title: "Sometimes",
    artist: "Erasure",
    id: 143041970,
    release_date: "1987-10-20",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/cc1c2bd258e623943d223ab873674d82/250x250-000000-80-0-0.jpg",
    genre: "Dance",
  },
  {
    title: "We Don't Have To Take Our Clothes Off",
    artist: "Jermaine Stewart",
    id: 9968997,
    release_date: "1986-02-25",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/7bfc7009e751d43d96f7e8b1aabf7e8f/250x250-000000-80-0-0.jpg",
    genre: "R&B",
  },
  {
    title: "Nineteen",
    artist: "Paul Hardcastle",
    id: 132042578,
    release_date: "1985-09-12",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/6aeffa2d5c980f71a2e3efc5303ec6df/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Bad",
    artist: "Michael Jackson",
    id: 59509531,
    release_date: "1982-09-14",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/fb0a49a91ab8137ec9d028c4dbb04021/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Just Can't Get Enough",
    artist: "Depeche Mode",
    id: 68511564,
    release_date: "1981-10-05",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/9ec9c75ccce73408e769d18f382669fd/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "Pretty Green Eyes",
    artist: "Ultrabeat",
    id: 379139391,
    release_date: "2007-07-07",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/bbf94dc2b6784a263c3c8ef611f0afcf/250x250-000000-80-0-0.jpg",
    genre: "Dance",
  },
  {
    title: "Dakota",
    artist: "Stereophonics",
    id: 2420458,
    release_date: "2005-02-28",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/0d210da789d5468aa7f4322e4c4941b8/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "Don't Go",
    artist: "Yazoo",
    id: 143039072,
    release_date: "1982-01-18",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/de6b4c328de177e3331e8e2826305c0f/250x250-000000-80-0-0.jpg",
    genre: "Dance",
  },
  {
    title: "All Around the World",
    artist: "Lisa Stansfield",
    id: 1019524,
    release_date: "1999-12-31",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/b93da8c24fe0a6942d10caec26725afd/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "I Have Nothing",
    artist: "Whitney Houston",
    id: 5363365,
    release_date: "1992-02-09",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/e9f963b239113b1f92c39d10a051d95e/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Call Me",
    artist: "Blondie",
    id: 3104486,
    release_date: "1980-03-03",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/cdc9d8ba7d6f9d8c40c5389bb4577409/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "The Sun Always Shines on T.V.",
    artist: "a-ha",
    id: 664115,
    release_date: "1985-06-12",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/e0ce8977ab98d73bcea00fc838ece034/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Another Night",
    artist: "Real McCoy",
    id: 1042543,
    release_date: "1995-04-10",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/8cdc05b609232d463417238a6dc09e89/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Heaven",
    artist: "DJ Sammy",
    id: 69420264,
    release_date: "2002-02-17",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/62a81585292c53acc048eb02b3fd7b62/250x250-000000-80-0-0.jpg",
    genre: "Dance",
  },
  {
    title: "9 PM - Till I come",
    artist: "ATB",
    id: 61639668,
    release_date: "1999-08-09",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/dbb747abd287e0dead5c68ef6c3e2bd8/250x250-000000-80-0-0.jpg",
    genre: "Dance",
  },
  {
    title: "Silence (feat. Sarah McLachlan)",
    artist: "Delerium",
    id: 85276490,
    release_date: "1997-09-28",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/b37a343d30a8a723b22e0d45896e05f9/250x250-000000-80-0-0.jpg",
    genre: "Dance",
  },
  {
    title: "Forever",
    artist: "Super3",
    id: 414650452,
    release_date: "2009-09-28",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/79a92923ada47f26ac6b8e1c3d4ff0f4/250x250-000000-80-0-0.jpg",
    genre: "Kids",
  },
  {
    title: "L'Amour Toujours",
    artist: "Gigi D'Agostino",
    id: 35782811,
    release_date: "1999-01-23",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/e19251a60eeae5b1943861dffc23ea5e/250x250-000000-80-0-0.jpg",
    genre: "Dance",
  },
  {
    title: "Love & Pride",
    artist: "King",
    id: 2311058,
    release_date: "1998-02-28",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/be74b8af8f2677d8ff8f923a38b0dfb7/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Encore Une Fois",
    artist: "Sash!",
    id: 133949042,
    release_date: "1996-03-15",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/28b63337235b5d9d1633e260e501c04c/250x250-000000-80-0-0.jpg",
    genre: "Dance",
  },
  {
    title: "Ecuador",
    artist: "Sash!",
    id: 133134750,
    release_date: "1997-03-22",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/6dc2524744ef735f7fe0471c0c95f5b2/250x250-000000-80-0-0.jpg",
    genre: "Dance",
  },
  {
    title: "Be My Lover",
    artist: "La Bouche",
    id: 4096754,
    release_date: "1995-08-27",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/02f880e927fe2d0ea5c5c234ef0bd050/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "For An Angel",
    artist: "Paul van Dyk",
    id: 60827150,
    release_date: "1998-10-28",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/8f16bad5d5de8b2e243f8e7470b0ef91/250x250-000000-80-0-0.jpg",
    genre: "Dance",
  },
  {
    title: "Party Rock Anthem",
    artist: "LMFAO",
    id: 12452085,
    release_date: "2011-07-18",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/1f66f698240e7bd03385f89773bd3148/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Sexy And I Know It",
    artist: "LMFAO",
    id: 12452086,
    release_date: "2011-07-18",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/1f66f698240e7bd03385f89773bd3148/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Sorry For Party Rocking",
    artist: "LMFAO",
    id: 12452084,
    release_date: "2011-07-18",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/1f66f698240e7bd03385f89773bd3148/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Halo",
    artist: "Beyoncé",
    id: 2485108,
    release_date: "2008-11-14",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/1f0450a010b5a825194d7ca00b3067ab/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Flames",
    artist: "David Guetta",
    id: 473784012,
    release_date: "2018-03-22",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/00ba194ad2417b1cc6d79a34113995cb/250x250-000000-80-0-0.jpg",
    genre: "Dance",
  },
  {
    title: "Alive",
    artist: "Sia",
    id: 107980710,
    release_date: "2015-09-24",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/36ef26001118282b59659568f267bc36/250x250-000000-80-0-0.jpg",
    genre: "Alternative",
  },
  {
    title: "Smalltown Boy",
    artist: "Bronski Beat",
    id: 428735732,
    release_date: "1982-01-01",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/ffbbe6dfa1ff0d6ff551379a496b8f85/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Crazy 'Bout My Baby",
    artist: "Randy Newman",
    id: 123820402,
    release_date: "1963-10-11",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/d7ac975bb038b063abb2cc61b23791a3/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Cry for You",
    artist: "September",
    id: 15543742,
    release_date: "2007-03-08",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/bacb7ec2fe6b57f1af8f9a9efc083b68/250x250-000000-80-0-0.jpg",
    genre: "Dance",
  },
  {
    title: "The Rhythm of the Night",
    artist: "Corona",
    id: 61723285,
    release_date: "1995-01-01",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/cb7dc8ffabfb85536cbae5ca1801f39b/250x250-000000-80-0-0.jpg",
    genre: "Dance",
  },
  {
    title: "The Key, The Secret",
    artist: "Urban Cookie Collective",
    id: 12159134,
    release_date: "1996-07-21",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/57ffff16dc7fff50b677277367f3fb6f/250x250-000000-80-0-0.jpg",
    genre: "Dance",
  },
  {
    title: "Bring Me To Life",
    artist: "Evanescence",
    id: 80274512,
    release_date: "2003-06-24",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/56c02d3764f5a078ceecd27b64b7d789/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "Jar of Hearts",
    artist: "Christina Perri",
    id: 12343340,
    release_date: "2010-07-27",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/2cf468fd0556a7e87d10640ebb270587/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Only Girl (In The World)",
    artist: "Rihanna",
    id: 13529563,
    release_date: "2011-08-18",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/3a12c64bb52a167944783878ffe41f02/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Shut Up And Drive",
    artist: "Rihanna",
    id: 925110,
    release_date: "2008-06-17",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/91276466fbc876d96be9e6926060af60/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Airplanes",
    artist: "B.o.B",
    id: 6461684,
    release_date: "2010-04-27",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/1922ce037df0dd576c008bb626320303/250x250-000000-80-0-0.jpg",
    genre: "Rap/Hip Hop",
  },
  {
    title: "Jai Ho! (You Are My Destiny)",
    artist: "A. R. Rahman",
    id: 2947119,
    release_date: "2009-02-23",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/e6bfa2ee147854dc35fdc5dd4950a084/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Stereo Love",
    artist: "Edward Maya",
    id: 6310384,
    release_date: "2010-05-09",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/2ad30b3a0b496dd1e7b126b5b213e2cb/250x250-000000-80-0-0.jpg",
    genre: "Dance",
  },
  {
    title: "Infinity 2008",
    artist: "Guru Josh Project",
    id: 61686264,
    release_date: "2008-06-06",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/19ebbbef82394515787864d7fc480170/250x250-000000-80-0-0.jpg",
    genre: "Dance",
  },
  {
    title: "Don't Stop Me Now",
    artist: "Queen",
    id: 12209331,
    release_date: "1979-06-27",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/fb22a75aa1aafc992230abd0bd79faef/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "Under Pressure",
    artist: "Queen",
    id: 3155488,
    release_date: "1981-12-18",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/0a1daf96211c7d0d662eab97b5e6e337/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "Radio Ga Ga",
    artist: "Queen",
    id: 7868649,
    release_date: "1984-01-01",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/fa63381faefb51fba501498bc836765a/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "I Want To Break Free",
    artist: "Queen",
    id: 7868651,
    release_date: "1984-01-01",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/fa63381faefb51fba501498bc836765a/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "Eye of the Tiger",
    artist: "Survivor",
    id: 576431,
    release_date: "1982-03-29",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/e66b5d3a40f69690c1633afb73cc590c/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "Don't Know Much",
    artist: "Linda Ronstadt",
    id: 7125589,
    release_date: "1986-12-19",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/095eaaa2dec76bd2b120d10edc708b37/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Unchained Melody",
    artist: "The Righteous Brothers",
    id: 885544,
    release_date: "1965-06-15",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/4d10d999f93483e2ea1a4e3496d8d72e/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "My Name Is",
    artist: "Eminem",
    id: 1109729,
    release_date: "2005-11-21",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/e2b36a9fda865cb2e9ed1476b6291a7d/250x250-000000-80-0-0.jpg",
    genre: "Rap/Hip Hop",
  },
  {
    title: "Summer Of '69",
    artist: "Bryan Adams",
    id: 88902741,
    release_date: "1984-11-24",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/e7be525c05b1942e1844d0073f7b9ab5/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "All You Need Is Love",
    artist: "The Beatles",
    id: 116348734,
    release_date: "1967-07-07",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/c105ffd0f6855c565cd3a0be47a1ee31/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "Digital Love",
    artist: "Daft Punk",
    id: 3135555,
    release_date: "2001-06-11",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/2e018122cb56986277102d2041a592c8/250x250-000000-80-0-0.jpg",
    genre: "Dance",
  },
  {
    title: "Firestarter",
    artist: "The Prodigy",
    id: 62126191,
    release_date: "1997-12-03",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/566d28d32080a6d82a2d4d145ea5ea7e/250x250-000000-80-0-0.jpg",
    genre: "Dance",
  },
  {
    title: "Purple Rain",
    artist: "Prince",
    id: 2794654,
    release_date: "1984-06-19",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/88b5b2593429607587f5ea0f931af960/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "1999",
    artist: "Prince",
    id: 690101,
    release_date: "1982-12-18",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/e4e1feb81f8ac2be66599b362d5451aa/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "The Most Beautiful Girl In the World",
    artist: "Prince",
    id: 536618412,
    release_date: "1985-09-26",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/b94aca81917de9254d54cb45ba820677/250x250-000000-80-0-0.jpg",
    genre: "R&B",
  },
  {
    title: "Gangnam Style",
    artist: "Psy",
    id: 60726278,
    release_date: "2012-09-06",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/45e4493fcc15997085491debddcf049e/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Waiting for a Star to Fall",
    artist: "Boy Meets Girl",
    id: 471297912,
    release_date: "1988-02-26",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/4/2/2/0/42215dd831911a62a044af2b5f87e26b.mp3?hdnea=exp=1763731656~acl=/api/1/1/4/2/2/0/42215dd831911a62a044af2b5f87e26b.mp3*~data=user_id=0,application_id=42~hmac=da345d91fe0458c261d0723163dc024ce4c0da4cead8bf99f02d44f538af56c9",
    cover: "https://api.deezer.com/album/58684672/image",
    genre: "Pop",
  },
  {
    title: "Shake It Off",
    artist: "Taylor Swift",
    id: 89077555,
    release_date: "2014-10-27",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/68b4e986958b17f05b062ffa8d7ae114/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "There Must Be an Angel (Playing with My Heart)",
    artist: "Eurythmics",
    id: 561785,
    release_date: "1985-11-07",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/d/5/d/0/d5d76363e9bcddc71a8b7627234e13db.mp3?hdnea=exp=1763731656~acl=/api/1/1/d/5/d/0/d5d76363e9bcddc71a8b7627234e13db.mp3*~data=user_id=0,application_id=42~hmac=004924fe6f2111cba785e5bff173042093dd589487d9b2974a3392a6ca60b87f",
    cover: "https://api.deezer.com/album/73276/image",
    genre: "Pop",
  },
  {
    title: "I'd Do Anything For Love (But I Won't Do That)",
    artist: "Meat Loaf",
    id: 3166759,
    release_date: "1986-11-27",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/8/3/d/0/83deed7ca1b83e5340a865615931b575.mp3?hdnea=exp=1763731656~acl=/api/1/1/8/3/d/0/83deed7ca1b83e5340a865615931b575.mp3*~data=user_id=0,application_id=42~hmac=18d62e7a7c00a1ec9b286782f8057a89df3aadbc1206f7a20a999c30eedcf132",
    cover: "https://api.deezer.com/album/304142/image",
    genre: "Rock",
  },
  {
    title: "What's Up?",
    artist: "4 Non Blondes",
    id: 2184743,
    release_date: "1996-07-24",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/b/6/0/0/b6094cd4a5bf36cd534651cdb6ad29e8.mp3?hdnea=exp=1763731656~acl=/api/1/1/b/6/0/0/b6094cd4a5bf36cd534651cdb6ad29e8.mp3*~data=user_id=0,application_id=42~hmac=cd00ea0f9295965db9c6e5fe46a637de8bbe2a4f525ea1a424e2c93504c402cb",
    cover: "https://api.deezer.com/album/218365/image",
    genre: "Pop",
  },
  {
    title: "I Will Always Love You",
    artist: "Whitney Houston",
    id: 2244121,
    release_date: "1992-11-17",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/b/4/2/0/b4236e6f42779a308e35087db4ed2b60.mp3?hdnea=exp=1763731656~acl=/api/1/1/b/4/2/0/b4236e6f42779a308e35087db4ed2b60.mp3*~data=user_id=0,application_id=42~hmac=5cdca5a056de0f0e5f0ee4edc4642ab9c4070e29eb528390ac85324cef7eb41a",
    cover: "https://api.deezer.com/album/77489/image",
    genre: "Pop",
  },
  {
    title: "Barbie Girl",
    artist: "Aqua",
    id: 1115044,
    release_date: "1997-10-20",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/4/3/7/0/4371d1b1cfd9c181f987a3befea3585b.mp3?hdnea=exp=1763730736~acl=/api/1/1/4/3/7/0/4371d1b1cfd9c181f987a3befea3585b.mp3*~data=user_id=0,application_id=42~hmac=e9cb89e7d577710dac8ec36660c8d22cd160e1f38857e6cdbe2934c85e349356",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/89c2dae2b498dc9ca9151324d02eca2d/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Always",
    artist: "Bon Jovi",
    id: 538586982,
    release_date: "1994-08-10",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/2/e/0/0/2e04fe72f1b7c2e883d6d99e5ac2b45c.mp3?hdnea=exp=1763731656~acl=/api/1/1/2/e/0/0/2e04fe72f1b7c2e883d6d99e5ac2b45c.mp3*~data=user_id=0,application_id=42~hmac=c2db31ee7aacceb74096b7c338393a7ea64c4bfeabd08fe9722a44d6b2dd823d",
    cover: "https://api.deezer.com/album/70189822/image",
    genre: "Pop",
  },
  {
    title: "Bitter Sweet Symphony",
    artist: "The Verve",
    id: 398570642,
    release_date: "1997-12-01",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/3/4/1/0/341bbcf7cf85b72d242ecee1c7134483.mp3?hdnea=exp=1763730736~acl=/api/1/1/3/4/1/0/341bbcf7cf85b72d242ecee1c7134483.mp3*~data=user_id=0,application_id=42~hmac=6d7d6e70642b247a1fab267775eaec4aa2b2ffaf682cb8da3dbec569df767955",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/ecc7727e897198892b98e7c019fba45f/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "Losing My Religion",
    artist: "R.E.M.",
    id: 136334560,
    release_date: "1991-02-19",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/4/e/f/0/4ef0a38d9159a0f45d5f16399db90862.mp3?hdnea=exp=1763730736~acl=/api/1/1/4/e/f/0/4ef0a38d9159a0f45d5f16399db90862.mp3*~data=user_id=0,application_id=42~hmac=c38a40fbf41987f176942785b97afb460a2a7f7a5b4fd5f8234f4ff61e347c07",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/a968ed3814acb2ef8f3929b1bebcb42d/250x250-000000-80-0-0.jpg",
    genre: "Alternative",
  },
  {
    title: "...Baby One More Time",
    artist: "Britney Spears",
    id: 540175,
    release_date: "1999-01-12",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/1/0/f/0/10fd8e9cf7fc9f6f47e7ef391877ead3.mp3?hdnea=exp=1763730736~acl=/api/1/1/1/0/f/0/10fd8e9cf7fc9f6f47e7ef391877ead3.mp3*~data=user_id=0,application_id=42~hmac=1951fd34e1c1cb4a9d99e9e30dc8193360f52807370e505f29d6c8a42ecd0011",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/bd904e47db5549124f099c1fef304dc9/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "They Don't Care About Us",
    artist: "Michael Jackson",
    id: 8164642,
    release_date: "1997-11-13",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/7/a/a/0/7aa2b4079e33bedd3cb6ca0b4372d5c4.mp3?hdnea=exp=1763730736~acl=/api/1/1/7/a/a/0/7aa2b4079e33bedd3cb6ca0b4372d5c4.mp3*~data=user_id=0,application_id=42~hmac=908b384de0430128f0926746e5b6ab2f2850176542ac9984bdb3c056cc8cacad",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/fbed9a8cfcdd8a5e48cebbea8d8078ea/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Desert Rose",
    artist: "Sting",
    id: 2525873,
    release_date: "1992-02-10",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/a/4/2/0/a423ff8abe72863f551dde095927597a.mp3?hdnea=exp=1763730736~acl=/api/1/1/a/4/2/0/a423ff8abe72863f551dde095927597a.mp3*~data=user_id=0,application_id=42~hmac=d0500f86901a2e620aebd5aef3ad6f738cfc8a8caf898c538b4410e1e979ab46",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/316afdaed93c4a18cf730389648d03d6/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Believe",
    artist: "Cher",
    id: 786717,
    release_date: "1998-10-19",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/c/f/e/0/cfe5600eb3b0f8b50ff351ae46129e07.mp3?hdnea=exp=1763730736~acl=/api/1/1/c/f/e/0/cfe5600eb3b0f8b50ff351ae46129e07.mp3*~data=user_id=0,application_id=42~hmac=12d0fb29167fa85acd7c62237464ce125553927ec932bc29a1f255e79db7f94e",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/af263778ad6ef2f3f5be381292ed02a8/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "More Than Words",
    artist: "Extreme",
    id: 906621,
    release_date: "1991-08-20",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/9/f/7/0/9f7ecd5a2a0bd7cbec9262cea7f903ab.mp3?hdnea=exp=1763731656~acl=/api/1/1/9/f/7/0/9f7ecd5a2a0bd7cbec9262cea7f903ab.mp3*~data=user_id=0,application_id=42~hmac=18bbcb464e333eb70ff38437df3802affa3b56ad692767298d62c0ff1eab0037",
    cover: "https://api.deezer.com/album/102391/image",
    genre: "Pop",
  },
  {
    title: "Linger",
    artist: "The Cranberries",
    id: 1137657,
    release_date: "2002-06-13",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/0/a/8/0/0a8dcf25f52c4a057abb3d5218dd3ed9.mp3?hdnea=exp=1763730736~acl=/api/1/1/0/a/8/0/0a8dcf25f52c4a057abb3d5218dd3ed9.mp3*~data=user_id=0,application_id=42~hmac=055d904f32912d29626bec0628541dd32f38eb44e780fb73301dca58790280e0",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/1dadf15bb8ea7e829bd69b2f3966c701/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "Maria Maria",
    artist: "Santana",
    id: 82241406,
    release_date: "1999-02-18",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/8/9/e/0/89e9d7435933b8005a37c90ad0c78388.mp3?hdnea=exp=1763730736~acl=/api/1/1/8/9/e/0/89e9d7435933b8005a37c90ad0c78388.mp3*~data=user_id=0,application_id=42~hmac=9040b784fef6ed77d00f56caa36ba4c2aa2a81ec55eeade80772b02717e98d69",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/929132f50492c7acfab23b32722f4537/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Wonderwall",
    artist: "Oasis",
    id: 84572613,
    release_date: "1995-09-26",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/b/8/1/0/b81fd9640e88766ff59cc7fb7abe9539.mp3?hdnea=exp=1763730736~acl=/api/1/1/b/8/1/0/b81fd9640e88766ff59cc7fb7abe9539.mp3*~data=user_id=0,application_id=42~hmac=84f96b701d8304c75a54e7436bb1bd257dd725bfaba8e52053b34db3b6a1eb92",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/d63b6ce2589b96cee3e6aa85d996023a/250x250-000000-80-0-0.jpg",
    genre: "Alternative",
  },
  {
    title: "When You Believe",
    artist: "Mariah Carey",
    id: 596057,
    release_date: "1998-11-02",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/9/c/4/0/9c4436bc58d2ee8c12104587c8c6b1dd.mp3?hdnea=exp=1763730736~acl=/api/1/1/9/c/4/0/9c4436bc58d2ee8c12104587c8c6b1dd.mp3*~data=user_id=0,application_id=42~hmac=5e0970125a2dad39a735ecd6fe7161302cbf2781f95318ed5fafd7f51b9f43ee",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/6a1aeef41619907cc283d4eb1eac2fe6/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Enter Sandman",
    artist: "Metallica",
    id: 20481851,
    release_date: "1991-07-29",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/37c5bd270ca19bcf6bd5e9354f9f3df0/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Livin' la Vida Loca",
    artist: "Ricky Martin",
    id: 13111370,
    release_date: "1999-06-11",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/7/e/7/0/7e79e4ff7d20ddd9b680506d3fa7c926.mp3?hdnea=exp=1763730736~acl=/api/1/1/7/e/7/0/7e79e4ff7d20ddd9b680506d3fa7c926.mp3*~data=user_id=0,application_id=42~hmac=8c6b2f692b174325526c95095a090a100c383e1b684f24bb8c5473b382123e52",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/554607caa28b1531ea6f447aec02ecdd/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "The Man Who Sold The World",
    artist: "Nirvana",
    id: 1105736,
    release_date: "1994-10-27",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/e/9/8/0/e98c26c637dd7da3ce3b75cc8c9e9958.mp3?hdnea=exp=1763730736~acl=/api/1/1/e/9/8/0/e98c26c637dd7da3ce3b75cc8c9e9958.mp3*~data=user_id=0,application_id=42~hmac=d50ec836aef5b7b306cb9a3c73835e51c4060220c3183978f44d5c548062541b",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/fe1082c5ef54876802146897e76b592e/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "Wannabe",
    artist: "Spice Girls",
    id: 3164155,
    release_date: "1997-11-12",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/b/2/c/0/b2c127c2fce427ea7e90cbae6cda1a55.mp3?hdnea=exp=1763730736~acl=/api/1/1/b/2/c/0/b2c127c2fce427ea7e90cbae6cda1a55.mp3*~data=user_id=0,application_id=42~hmac=d5846bb117215840e18ac60b3702f4e468c4704e55e2b09481bc147570582140",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/ba4d6b08d01a59c34e14a8cd5727c6fb/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "No Scrubs",
    artist: "TLC",
    id: 1075781,
    release_date: "1999-02-22",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/1/0/8/0/1089b05806068e19ab4d8ebc48c06c8d.mp3?hdnea=exp=1763730736~acl=/api/1/1/1/0/8/0/1089b05806068e19ab4d8ebc48c06c8d.mp3*~data=user_id=0,application_id=42~hmac=46e682128f08e67cd6d4829e99d61af49351d4f643cc3bb0cbeb3ed3c489be93",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/6dd5f40e7688ba155a5ef557977e95d3/250x250-000000-80-0-0.jpg",
    genre: "R&B",
  },
  {
    title: "I Don't Want To Miss A Thing",
    artist: "Aerosmith",
    id: 624823,
    release_date: "1998-06-23",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/8/a/0/0/8a037808681ad1ec39fa969694663514.mp3?hdnea=exp=1763730736~acl=/api/1/1/8/a/0/0/8a037808681ad1ec39fa969694663514.mp3*~data=user_id=0,application_id=42~hmac=f138984969e3d595251ae410d3d56759f8daf6fa4501ae2f180e2b8f1442baf3",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/82bb160fe7b46cca64dc989a4f5843d0/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "All Star",
    artist: "Smash Mouth",
    id: 917717,
    release_date: "1999-08-02",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/c/3/9/0/c39b11ed88563f5017876b45b68dd6db.mp3?hdnea=exp=1763730736~acl=/api/1/1/c/3/9/0/c39b11ed88563f5017876b45b68dd6db.mp3*~data=user_id=0,application_id=42~hmac=5fc0bd74ac1f9f17d2fc246483c4165d934a88a4e2c017c887271d163dd8a1d3",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/34a4542cb4e8a54639674ed6aab1bd65/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "Coco Jamboo",
    artist: "Mr. President",
    id: 2194974,
    release_date: "2008-09-16",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/0/8/b/0/08b5d3d32f372ab628d8699c29090bd1.mp3?hdnea=exp=1763730736~acl=/api/1/1/0/8/b/0/08b5d3d32f372ab628d8699c29090bd1.mp3*~data=user_id=0,application_id=42~hmac=e8f4395b178d27372cf78da6cc712efde30f2fe1d5f2a9c383265161f00ac43a",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/c3152ba548375ae7fba3399a0e6b38fe/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Scar Tissue",
    artist: "Red Hot Chili Peppers",
    id: 725254,
    release_date: "1999-06-07",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/5/8/2/0/5827c9257a749eb955a7dd3ef3c2eb3c.mp3?hdnea=exp=1763730736~acl=/api/1/1/5/8/2/0/5827c9257a749eb955a7dd3ef3c2eb3c.mp3*~data=user_id=0,application_id=42~hmac=f5ed0a90b64eeb4c17e9f0f1eb8b10a28c324ef92b9672c9a0550d7b6756949a",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/5e61e8290a4d1d64ca58920656c9602d/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "Bed Of Roses",
    artist: "Bon Jovi",
    id: 74628110,
    release_date: "1992-04-05",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/e/4/2/0/e42e56b65e5a041afc0a99dc1f97070b.mp3?hdnea=exp=1763730736~acl=/api/1/1/e/4/2/0/e42e56b65e5a041afc0a99dc1f97070b.mp3*~data=user_id=0,application_id=42~hmac=903a20ac6b218d844a3af88449f98ede976a1d9fa90cc88807e46acf61d858d1",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/4a2821c5cfa61955ddd982c15cc21882/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "Earth Song",
    artist: "Michael Jackson",
    id: 8164645,
    release_date: "1983-11-13",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/9/c/0/0/9c0d6e7bddcfbb2fa21c6d75c206a6c2.mp3?hdnea=exp=1763730736~acl=/api/1/1/9/c/0/0/9c0d6e7bddcfbb2fa21c6d75c206a6c2.mp3*~data=user_id=0,application_id=42~hmac=471d34c9ffa96ec9250bc63673a102f6c8d9149fb5c7ea3000abb774fb6313bb",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/fbed9a8cfcdd8a5e48cebbea8d8078ea/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Thank You",
    artist: "Dido",
    id: 962173,
    release_date: "1999-06-01",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/2/f/c/0/2fc0f322e34f97f4a4e95c507656e9fa.mp3?hdnea=exp=1763730736~acl=/api/1/1/2/f/c/0/2fc0f322e34f97f4a4e95c507656e9fa.mp3*~data=user_id=0,application_id=42~hmac=c79cda6a39e6db6245c99e7a0560c217ef54162c123ae41c98dbef643681ec01",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/3eaae15d23993db3cd9c69ae113c4333/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Don't Cry",
    artist: "Guns N' Roses",
    id: 1169677,
    release_date: "1991-09-18",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/9/2/9/0/929232c70eca30ce34e5233d2702e224.mp3?hdnea=exp=1763730736~acl=/api/1/1/9/2/9/0/929232c70eca30ce34e5233d2702e224.mp3*~data=user_id=0,application_id=42~hmac=c0777145118c9d4c582ab37600b97e73c6b5595128c3f64df7aa095381aaf4ee",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/546fe1eca5d3bf48c6a48fb3c0ddac63/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "Smooth",
    artist: "Santana",
    id: 82241402,
    release_date: "1999-06-29",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/0/6/6/0/066818622bab6266aa80190fa52124cc.mp3?hdnea=exp=1763730736~acl=/api/1/1/0/6/6/0/066818622bab6266aa80190fa52124cc.mp3*~data=user_id=0,application_id=42~hmac=4784cd313de17a630c5ff9d5e86451c37b99ff4e581b813e40eb5a2659688688",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/929132f50492c7acfab23b32722f4537/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Black or White",
    artist: "Michael Jackson",
    id: 15593566,
    release_date: "1981-10-16",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/2/5/2/0/2523fceaa336fa3aedcd33a8a4e2bda9.mp3?hdnea=exp=1763730736~acl=/api/1/1/2/5/2/0/2523fceaa336fa3aedcd33a8a4e2bda9.mp3*~data=user_id=0,application_id=42~hmac=0fd48699e7342d83d64f98c749e07892d5783f9361e098043fd5023ecd5c62d3",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/93a5354699d552666448e1c87c976605/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "The Kids Aren't Alright",
    artist: "The Offspring",
    id: 137233986,
    release_date: "1998-06-16",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/b/0/3/0/b0384634d586e98fcf6f8613fc22eeb7.mp3?hdnea=exp=1763730736~acl=/api/1/1/b/0/3/0/b0384634d586e98fcf6f8613fc22eeb7.mp3*~data=user_id=0,application_id=42~hmac=24f35a644c3239d03640a7a4dfaa85367f59ebb12830b6716880e56125e97584",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/f7d8a61b8c4b118e642acfb3db0a45a1/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "I'll Be Missing You",
    artist: "Diddy",
    id: 2794603,
    release_date: "2004-03-09",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/9/b/a/0/9ba1df9628707d82c366da3fe59966d9.mp3?hdnea=exp=1763730736~acl=/api/1/1/9/b/a/0/9ba1df9628707d82c366da3fe59966d9.mp3*~data=user_id=0,application_id=42~hmac=fc629604f5e0ec5723faa39651384ce66440b6535bca56440a603b7fb59c4470",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/755dc7da07ba60a8c879963858150f84/250x250-000000-80-0-0.jpg",
    genre: "R&B",
  },
  {
    title: "You Are Not Alone",
    artist: "Michael Jackson",
    id: 8164649,
    release_date: "1997-11-13",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/e/6/4/0/e642797b099ecb7e6bf5b8e6c4db7b46.mp3?hdnea=exp=1763730736~acl=/api/1/1/e/6/4/0/e642797b099ecb7e6bf5b8e6c4db7b46.mp3*~data=user_id=0,application_id=42~hmac=cbe1a922d5c10764f288b730ec2e6df927a6c4918fc077418d88df79a0ea94b2",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/fbed9a8cfcdd8a5e48cebbea8d8078ea/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "The Boy Is Mine",
    artist: "Brandy",
    id: 662355,
    release_date: "1997-01-01",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/8/a/c/0/8ac00280fa9bb959bc8e5d6e8b14cca0.mp3?hdnea=exp=1763730736~acl=/api/1/1/8/a/c/0/8ac00280fa9bb959bc8e5d6e8b14cca0.mp3*~data=user_id=0,application_id=42~hmac=ef5a5121b1f07ec5be7ab4c571f105e5b8bb2643ce107c0a78a43ce15c088172",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/4112854d5ad8f7b5dffa421c9df06515/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Cotton Eye Joe",
    artist: "Rednex",
    id: 88328649,
    release_date: "1994-10-30",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/3/d/1/0/3d14aa40718243097006121a30733c08.mp3?hdnea=exp=1763730736~acl=/api/1/1/3/d/1/0/3d14aa40718243097006121a30733c08.mp3*~data=user_id=0,application_id=42~hmac=7065d4a4123dac75e5974678642a04c7c785e9754fa3ac3d4c938c6ef271a052",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/6c9c7419d8c50f843b5e42e8300ebdcb/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Basket Case",
    artist: "Green Day",
    id: 678044,
    release_date: "1994-01-28",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/e/9/2/0/e92e69639b644d52ef79e3ae235c8a91.mp3?hdnea=exp=1763730736~acl=/api/1/1/e/9/2/0/e92e69639b644d52ef79e3ae235c8a91.mp3*~data=user_id=0,application_id=42~hmac=91453408bec1c4bc5ad7b93b654e924fe13753ea7718338413f51bd54250f7fb",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/1e17054b7bfa6576f64ea867b71ef479/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "Torn",
    artist: "Natalie Imbruglia",
    id: 554446,
    release_date: "1997-09-05",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/6/5/a/0/65a825288d2f235a798c3dc2b9f35ee9.mp3?hdnea=exp=1763730736~acl=/api/1/1/6/5/a/0/65a825288d2f235a798c3dc2b9f35ee9.mp3*~data=user_id=0,application_id=42~hmac=5f80628cd4a02934c18cc14dc06fb0a24406ca993c8b3bf6d0cea8035caab92b",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/ce07121876070fc4ac134e9111871e5f/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Hero",
    artist: "Mariah Carey",
    id: 596015,
    release_date: "1997-11-08",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/f/6/b/0/f6bfb3fc7b37fcaf5d0dc603c2253502.mp3?hdnea=exp=1763730736~acl=/api/1/1/f/6/b/0/f6bfb3fc7b37fcaf5d0dc603c2253502.mp3*~data=user_id=0,application_id=42~hmac=1aa830cc39d1e2f6d78d75a9284b0e84f8090cbad9e2e7e1bb7ac4bedaae5382",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/6a1aeef41619907cc283d4eb1eac2fe6/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Without You",
    artist: "Mariah Carey",
    id: 595920,
    release_date: "1993-04-27",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/e/6/0/0/e6002789b09fd2740a65eac6cfefdc06.mp3?hdnea=exp=1763731656~acl=/api/1/1/e/6/0/0/e6002789b09fd2740a65eac6cfefdc06.mp3*~data=user_id=0,application_id=42~hmac=d3fb362fc0beac2b678f53b4d62abc5ecc5faf8648abe2202747a19dde352142",
    cover: "https://api.deezer.com/album/76133/image",
    genre: "Pop",
  },
  {
    title: "Return of the Mack",
    artist: "Mark Morrison",
    id: 703748,
    release_date: "1996-04-22",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/e/7/0/0/e70f2f54fcdc64c5ed369d1d859ec62e.mp3?hdnea=exp=1763730736~acl=/api/1/1/e/7/0/0/e70f2f54fcdc64c5ed369d1d859ec62e.mp3*~data=user_id=0,application_id=42~hmac=9909ce376330a5c2b0b23295cd9175e4c61da1316f86073fe17c7bf6b0564dee",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/655e659d77faed4a3dca4f9c5a0fcd9e/250x250-000000-80-0-0.jpg",
    genre: "R&B",
  },
  {
    title: "Heal the World",
    artist: "Michael Jackson",
    id: 15593565,
    release_date: "2001-10-16",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/d/b/9/0/db962c00b49fc4ed70586c427a35a808.mp3?hdnea=exp=1763730736~acl=/api/1/1/d/b/9/0/db962c00b49fc4ed70586c427a35a808.mp3*~data=user_id=0,application_id=42~hmac=fd37839cc929241538ac4ede14abda5c520d2fd42b851c64598ff865df7c43ad",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/93a5354699d552666448e1c87c976605/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "All I Wanna Do Is Make Love To You",
    artist: "Heart",
    id: 3482138,
    release_date: "1990-03-26",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/c/c/c/0/ccc04f1d36dc4de166606a641133f5be.mp3?hdnea=exp=1763730736~acl=/api/1/1/c/c/c/0/ccc04f1d36dc4de166606a641133f5be.mp3*~data=user_id=0,application_id=42~hmac=984ced13f5ff2963e021397e2470281c2c999f3a2e4857d30253ffede35a16a2",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/9e45eca89fbb8d759a7e4a5d66349a93/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "One Headlight",
    artist: "The Wallflowers",
    id: 2193499,
    release_date: "1997-02-21",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/c/c/a/0/cca4a1a93af87370ed9b84e76b6333d9.mp3?hdnea=exp=1763730736~acl=/api/1/1/c/c/a/0/cca4a1a93af87370ed9b84e76b6333d9.mp3*~data=user_id=0,application_id=42~hmac=9c9b7af4e82b063222e3bcd2f820871077044d478f81e620dfffe8dfcff211b9",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/d3fcc02ae974d3eb6ff036ba325fb1e8/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "Send Me An Angel",
    artist: "Scorpions",
    id: 927907,
    release_date: "1991-01-07",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/f/a/4/0/fa4534a5fc4408c130224796f429ed64.mp3?hdnea=exp=1763730737~acl=/api/1/1/f/a/4/0/fa4534a5fc4408c130224796f429ed64.mp3*~data=user_id=0,application_id=42~hmac=28cdf4a59875b81e24f7acbcd6f97bb40b9d879ec9606e6795c6ba86f1560b92",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/5d1724dd3ac61f2e1df593c543ce2b22/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "Truly Madly Deeply",
    artist: "Savage Garden",
    id: 117262952,
    release_date: "1996-03-23",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/7/2/6/0/7263b3ac60d7e1bfb0f8bb7d9818413c.mp3?hdnea=exp=1763730737~acl=/api/1/1/7/2/6/0/7263b3ac60d7e1bfb0f8bb7d9818413c.mp3*~data=user_id=0,application_id=42~hmac=b2c507871406f70954a526604bcd015eeffac020cea2952c6ed4737988e18895",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/d393bffce44a4cf6ac86fab7adc51c62/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Save Tonight",
    artist: "Eagle-Eye Cherry",
    id: 2252935,
    release_date: "1998-05-04",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/5/2/1/0/521d03e6780cce7fdf787adfebfbb7cf.mp3?hdnea=exp=1763730737~acl=/api/1/1/5/2/1/0/521d03e6780cce7fdf787adfebfbb7cf.mp3*~data=user_id=0,application_id=42~hmac=6c5e457b985aebca556b88111a3d6af1024efef9b588138695b54c605c7669c2",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/e266242f0f87f9f394f12b1ad3b549f0/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "If You Had My Love",
    artist: "Jennifer Lopez",
    id: 15475926,
    release_date: "1999-06-01",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/7/8/e/0/78e9fbca5041b0e73eacaa190190616f.mp3?hdnea=exp=1763730737~acl=/api/1/1/7/8/e/0/78e9fbca5041b0e73eacaa190190616f.mp3*~data=user_id=0,application_id=42~hmac=efc0685213eaf34da48c4e0a422caa593262133efaf4eff1f71eed3c5085b0bc",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/e9e59d8b00661ff2971cf7e62e1d780c/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Insane in the Brain",
    artist: "Cypress Hill",
    id: 1015862,
    release_date: "1993-07-20",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/e/5/f/0/e5f89a883780dd9239f0e62ff9a8bab6.mp3?hdnea=exp=1763730737~acl=/api/1/1/e/5/f/0/e5f89a883780dd9239f0e62ff9a8bab6.mp3*~data=user_id=0,application_id=42~hmac=d8bb553653c76931ad0ff93e93927d8ce97f36a75d41994a04e6351ec2b24953",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/ff3a4fbb250a131f8cf3f413814eb29a/250x250-000000-80-0-0.jpg",
    genre: "Rap/Hip Hop",
  },
  {
    title: "Black Hole Sun",
    artist: "Soundgarden",
    id: 78631539,
    release_date: "1994-06-03",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/d/d/f/0/ddfb8e736d8dc5690ad7498ed26e8251.mp3?hdnea=exp=1763730737~acl=/api/1/1/d/d/f/0/ddfb8e736d8dc5690ad7498ed26e8251.mp3*~data=user_id=0,application_id=42~hmac=816e26cdc66bcef4da7b87ea8222216e60aa53faf50f07dbf62c3d7277421060",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/94248b664be0890be31cabf62a068293/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "Boom, Boom, Boom, Boom!!",
    artist: "Vengaboys",
    id: 1802253167,
    release_date: "1999-12-10",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/7/3/a/0/73a8c8fbb27dd79a2ce4e887b98d0425.mp3?hdnea=exp=1763731656~acl=/api/1/1/7/3/a/0/73a8c8fbb27dd79a2ce4e887b98d0425.mp3*~data=user_id=0,application_id=42~hmac=9aea701e805cffbb7473bbc84b1f5c3990ac91aea382b04bf55da9b274425aee",
    cover: "https://api.deezer.com/album/330138737/image",
    genre: "Dance",
  },
  {
    title: "Men In Black",
    artist: "Will Smith",
    id: 626417,
    release_date: "1997-11-25",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/6/2/9/0/629d2b639cf2763d8f18a5dc94c90430.mp3?hdnea=exp=1763730737~acl=/api/1/1/6/2/9/0/629d2b639cf2763d8f18a5dc94c90430.mp3*~data=user_id=0,application_id=42~hmac=f131c918dd1954de12bdbbfe2b0b278534ff0f6c8ab50b082ae1ac9583912ea4",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/e06e37cd6c0b10dde07ff71b4a95fc2a/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Why Don't You Get A Job",
    artist: "The Offspring",
    id: 137234014,
    release_date: "1996-12-02",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/b/5/5/0/b551397cbd6ffb255faf9d5fb20b6eb7.mp3?hdnea=exp=1763730737~acl=/api/1/1/b/5/5/0/b551397cbd6ffb255faf9d5fb20b6eb7.mp3*~data=user_id=0,application_id=42~hmac=1d662a617003414b5c7976cef767989bb7b6a99757b34feab4592e911e60d292",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/f7d8a61b8c4b118e642acfb3db0a45a1/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "Sweat (A La La La La Long)",
    artist: "Inner Circle",
    id: 2557399742,
    release_date: "1992-12-14",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/3/c/5/0/3c5b102858d663d7d14bbb18e19779a1.mp3?hdnea=exp=1763731656~acl=/api/1/1/3/c/5/0/3c5b102858d663d7d14bbb18e19779a1.mp3*~data=user_id=0,application_id=42~hmac=1d2a16e155b0c4c71363f06e4d4af890348cf9897945de56520830d777f5f18f",
    cover: "https://api.deezer.com/album/516350632/image",
    genre: "Reggae",
  },
  {
    title: "When You Say Nothing At All",
    artist: "Ronan Keating",
    id: 3978398,
    release_date: "1997-11-22",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/5/3/2/0/532139066f4855add961fe1737322dec.mp3?hdnea=exp=1763731656~acl=/api/1/1/5/3/2/0/532139066f4855add961fe1737322dec.mp3*~data=user_id=0,application_id=42~hmac=0270f6508a20793d7d860dd5068165876008f212bb4a88a5962cc96370e01945",
    cover: "https://api.deezer.com/album/371909/image",
    genre: "Pop",
  },
  {
    title: "More And More",
    artist: "Captain Hollywood Project",
    id: 143154464,
    release_date: "1992-07-10",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/6/a/d/0/6ad74cf901f2b3a099b503e0e981e30c.mp3?hdnea=exp=1763731656~acl=/api/1/1/6/a/d/0/6ad74cf901f2b3a099b503e0e981e30c.mp3*~data=user_id=0,application_id=42~hmac=15976738a4a6863c7947d48f3176a423069104352681492921f5b693d76fd516",
    cover: "https://api.deezer.com/album/15496446/image",
    genre: "Dance",
  },
  {
    title: "Everlong",
    artist: "Foo Fighters",
    id: 4762041,
    release_date: "1999-10-30",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/9/1/b/0/91b781968e297de2467fe9890893e586.mp3?hdnea=exp=1763731656~acl=/api/1/1/9/1/b/0/91b781968e297de2467fe9890893e586.mp3*~data=user_id=0,application_id=42~hmac=3cd41b2894837f071f0e10df8e5012c3b365f24076df99c0fe6b3be62eee7af7",
    cover: "https://api.deezer.com/album/401032/image",
    genre: "Rock",
  },
  {
    title: "Candy Rain",
    artist: "Soul For Real",
    id: 1110898,
    release_date: "1997-09-10",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/8/e/c/0/8ecb14932a92c14e5d8bd69e2fdfd824.mp3?hdnea=exp=1763731656~acl=/api/1/1/8/e/c/0/8ecb14932a92c14e5d8bd69e2fdfd824.mp3*~data=user_id=0,application_id=42~hmac=6c53c7516ddb75c120d31cd75e5e7d1ef71e84d2bfc06cbb67ffab215fd4abfd",
    cover: "https://api.deezer.com/album/119682/image",
    genre: "R&B",
  },
  {
    title: "Remember the Time",
    artist: "Michael Jackson",
    id: 15593563,
    release_date: "1981-10-16",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/3/a/a/0/3aa8e58e024bd295afd0ba22a1a0c15a.mp3?hdnea=exp=1763731656~acl=/api/1/1/3/a/a/0/3aa8e58e024bd295afd0ba22a1a0c15a.mp3*~data=user_id=0,application_id=42~hmac=1c1dbe9e2aa3e1bf40481ccdc66eba6af8f634f3a2218016ccef563f1f20065b",
    cover: "https://api.deezer.com/album/1441212/image",
    genre: "Pop",
  },
  {
    title: "Bailamos",
    artist: "Enrique Iglesias",
    id: 2604907,
    release_date: "1998-11-27",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/c/8/9/0/c8996c4b061545d378450eb22f54dfcc.mp3?hdnea=exp=1763731656~acl=/api/1/1/c/8/9/0/c8996c4b061545d378450eb22f54dfcc.mp3*~data=user_id=0,application_id=42~hmac=0496a0a1f3fe4b6a36a2019a4d155add91c781f810e8dd8146cefa729ca26470",
    cover: "https://api.deezer.com/album/254041/image",
    genre: "Pop",
  },
  {
    title: "Lithium",
    artist: "Nirvana",
    id: 13791934,
    release_date: "1991-09-26",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/1/1/7/0/1174a6c09fbc3fe39c1d01e49de8c85b.mp3?hdnea=exp=1763731656~acl=/api/1/1/1/1/7/0/1174a6c09fbc3fe39c1d01e49de8c85b.mp3*~data=user_id=0,application_id=42~hmac=91d8e78e51b421551dc50364771106be92d639a6ae42746d337c095ae05d657b",
    cover: "https://api.deezer.com/album/1262014/image",
    genre: "Rock",
  },
  {
    title: "Dragula",
    artist: "Rob Zombie",
    id: 2307303,
    release_date: "1998-08-24",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/3/5/0/0/3500e48eab8e63cb630c787397e8eb6a.mp3?hdnea=exp=1763731656~acl=/api/1/1/3/5/0/0/3500e48eab8e63cb630c787397e8eb6a.mp3*~data=user_id=0,application_id=42~hmac=b7bb7b425cc890084febfc5501835e2efb137fd7bcbca4b20a86b8ae1376b44d",
    cover: "https://api.deezer.com/album/229916/image",
    genre: "Pop",
  },
  {
    title: "Everybody Hurts",
    artist: "R.E.M.",
    id: 121921372,
    release_date: "1992-04-01",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/7/b/7/0/7b77038e4e3beaab562a9defd217e59c.mp3?hdnea=exp=1763731656~acl=/api/1/1/7/b/7/0/7b77038e4e3beaab562a9defd217e59c.mp3*~data=user_id=0,application_id=42~hmac=665073b88fea7483a4af1dbc9ee8436576d8b5d7173757a07e160aa3f1aced1f",
    cover: "https://api.deezer.com/album/12752508/image",
    genre: "Alternative",
  },
  {
    title: "Always Be My Baby",
    artist: "Mariah Carey",
    id: 596030,
    release_date: "1997-11-08",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/5/7/b/0/57bb7d6fce6c8c83bec102c4d820fda4.mp3?hdnea=exp=1763731656~acl=/api/1/1/5/7/b/0/57bb7d6fce6c8c83bec102c4d820fda4.mp3*~data=user_id=0,application_id=42~hmac=35eefdadce2619a75147b757b566d503c224e15b7dfd9f7f5ddf21a892be1c95",
    cover: "https://api.deezer.com/album/76133/image",
    genre: "Pop",
  },
  {
    title: "Nobody",
    artist: "Keith Sweat",
    id: 3616541,
    release_date: "1994-10-26",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/c/6/c/0/c6cef2b8bc14f4bdad3ca62e74b25802.mp3?hdnea=exp=1763731656~acl=/api/1/1/c/6/c/0/c6cef2b8bc14f4bdad3ca62e74b25802.mp3*~data=user_id=0,application_id=42~hmac=632b0bc569bb3544cf41d67736f93d295c39e4bcb4191ffe13e8118b91aeeeb7",
    cover: "https://api.deezer.com/album/341051/image",
    genre: "Dance",
  },
  {
    title: "Down In A Hole",
    artist: "Alice In Chains",
    id: 7675186,
    release_date: "1996-07-29",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/6/6/6/0/666df228c9ea54df4d54e9c107abfd22.mp3?hdnea=exp=1763731656~acl=/api/1/1/6/6/6/0/666df228c9ea54df4d54e9c107abfd22.mp3*~data=user_id=0,application_id=42~hmac=573ddfab6eb8421b38cb9ba73a66497a9aeea12b35a3d7b914e47d237e9687ae",
    cover: "https://api.deezer.com/album/708678/image",
    genre: "Alternative",
  },
  {
    title: "Insomnia",
    artist: "Faithless",
    id: 7035328,
    release_date: "1995-09-10",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/1/d/3/0/1d30450bd5b1d310f00bb1ef2c14f4b1.mp3?hdnea=exp=1763731656~acl=/api/1/1/1/d/3/0/1d30450bd5b1d310f00bb1ef2c14f4b1.mp3*~data=user_id=0,application_id=42~hmac=8bb3cd9f6f8d1effaba4b826006e7085658856a62ad36f88c17a5d995970097e",
    cover: "https://api.deezer.com/album/647850/image",
    genre: "Pop",
  },
  {
    title: "Song 2",
    artist: "Blur",
    id: 44133771,
    release_date: "1997-02-10",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/b/1/9/0/b1913fbb2efa47444b31bd4f611d59da.mp3?hdnea=exp=1763731656~acl=/api/1/1/b/1/9/0/b1913fbb2efa47444b31bd4f611d59da.mp3*~data=user_id=0,application_id=42~hmac=af52076c31a15b301d19d2350e31f264f1b9c9fdcf19dc69e3d69d6b6ac1c375",
    cover: "https://api.deezer.com/album/4351431/image",
    genre: "Rock",
  },
  {
    title: "Pretty Fly (For A White Guy)",
    artist: "The Offspring",
    id: 137233982,
    release_date: "1996-12-02",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/2/8/8/0/288206f008130dfe972fce5af914e585.mp3?hdnea=exp=1763731656~acl=/api/1/1/2/8/8/0/288206f008130dfe972fce5af914e585.mp3*~data=user_id=0,application_id=42~hmac=45c252fc721b6c90b027120f96cc44c0277aaad1c6b2286b7daba1ded457f97d",
    cover: "https://api.deezer.com/album/14717564/image",
    genre: "Rock",
  },
  {
    title: "California Love",
    artist: "2Pac",
    id: 910683,
    release_date: "1999-12-15",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/c/9/2/0/c925be214514bbd15e60fc961dc95304.mp3?hdnea=exp=1763731656~acl=/api/1/1/c/9/2/0/c925be214514bbd15e60fc961dc95304.mp3*~data=user_id=0,application_id=42~hmac=541ee188e84b47bb18fbde9ae8307e21d0eb5e4198409711d6fb62bb8c31dc2d",
    cover: "https://api.deezer.com/album/102653/image",
    genre: "Rap/Hip Hop",
  },
  {
    title: "I Knew I Loved You",
    artist: "Savage Garden",
    id: 532605,
    release_date: "1997-02-02",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/5/1/5/0/515de4ba5d45a934ba07fa9fbc2fa70d.mp3?hdnea=exp=1763731657~acl=/api/1/1/5/1/5/0/515de4ba5d45a934ba07fa9fbc2fa70d.mp3*~data=user_id=0,application_id=42~hmac=623cfd12307cec1e31324d79272a498ee88f20f1d4626443888db7e9f94d2944",
    cover: "https://api.deezer.com/album/71015/image",
    genre: "Pop",
  },
  {
    title: "Lovefool",
    artist: "The Cardigans",
    id: 910474,
    release_date: "1998-01-28",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/7/0/9/0/7090cce1503a9db184b8ee56f33c7d47.mp3?hdnea=exp=1763731657~acl=/api/1/1/7/0/9/0/7090cce1503a9db184b8ee56f33c7d47.mp3*~data=user_id=0,application_id=42~hmac=1a0b96b5a9a76f50a1ca9e2e37153c92308b9f82faf3acdddad9a55fd6934d5a",
    cover: "https://api.deezer.com/album/102639/image",
    genre: "Pop",
  },
  {
    title: "Nookie",
    artist: "Limp Bizkit",
    id: 94613610,
    release_date: "1998-07-29",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/2/4/4/0/24439dd892a757b858b6de824e451d6c.mp3?hdnea=exp=1763731657~acl=/api/1/1/2/4/4/0/24439dd892a757b858b6de824e451d6c.mp3*~data=user_id=0,application_id=42~hmac=617d91a8435def9f1355f9752a91fa48f3ac0bf5dfa54ee09e54e6736f645b49",
    cover: "https://api.deezer.com/album/9623860/image",
    genre: "Rock",
  },
  {
    title: "Fantasy",
    artist: "Mariah Carey",
    id: 1013792,
    release_date: "1995-10-03",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/8/0/7/0/8075ab03acadc3f8587fccbbb1b2e7aa.mp3?hdnea=exp=1763731657~acl=/api/1/1/8/0/7/0/8075ab03acadc3f8587fccbbb1b2e7aa.mp3*~data=user_id=0,application_id=42~hmac=c3d6c577a7c681a9663f6b3c0b8e8eb74fd86aa774fe41501351ccc0134ae510",
    cover: "https://api.deezer.com/album/111706/image",
    genre: "Pop",
  },
  {
    title: "Get A Way",
    artist: "Maxx",
    id: 16204632,
    release_date: "1993-03-23",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/1/8/d/0/18d72004ddcba1becd59563d15598361.mp3?hdnea=exp=1763731657~acl=/api/1/1/1/8/d/0/18d72004ddcba1becd59563d15598361.mp3*~data=user_id=0,application_id=42~hmac=ca6a88a5ff23508e0b8d98d110cb1bc139f4e93081352fe04ee9406b8186036b",
    cover: "https://api.deezer.com/album/1510636/image",
    genre: "Dance",
  },
  {
    title: "This Is How We Do It",
    artist: "Montell Jordan",
    id: 107351278,
    release_date: "1995-09-25",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/2/3/2/0/2320701cc8f1518eb66c8b5ce944d692.mp3?hdnea=exp=1763731657~acl=/api/1/1/2/3/2/0/2320701cc8f1518eb66c8b5ce944d692.mp3*~data=user_id=0,application_id=42~hmac=3f3cff1b882d9ea06ccac57ea3a7bec8307daf24968caacad73ffb0c1f9b41e6",
    cover: "https://api.deezer.com/album/11192672/image",
    genre: "R&B",
  },
  {
    title: "Ordinary World",
    artist: "Duran Duran",
    id: 3130430,
    release_date: "1988-11-09",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/1/e/7/0/1e7d4718515b14c09d63322cbea7c3a3.mp3?hdnea=exp=1763731657~acl=/api/1/1/1/e/7/0/1e7d4718515b14c09d63322cbea7c3a3.mp3*~data=user_id=0,application_id=42~hmac=0b771ea62d856de03c9eb57f4e605e294dc8c9f7c71b68f6474e5906305c41f8",
    cover: "https://api.deezer.com/album/301791/image",
    genre: "Rock",
  },
  {
    title: "Even Flow",
    artist: "Pearl Jam",
    id: 7675129,
    release_date: "1992-01-14",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/3/3/7/0/33745c12797ff41b67c78952050765a0.mp3?hdnea=exp=1763731657~acl=/api/1/1/3/3/7/0/33745c12797ff41b67c78952050765a0.mp3*~data=user_id=0,application_id=42~hmac=3018ac0522defd09f890c0e79174c2227776379f6cf36c19e0f1f80cb104a9b9",
    cover: "https://api.deezer.com/album/708674/image",
    genre: "Rock",
  },
  {
    title: "Return To Innocence",
    artist: "Enigma",
    id: 3132752,
    release_date: "1994-01-25",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/c/5/c/0/c5ce5e0f7d2ea14845375cda2ae22f35.mp3?hdnea=exp=1763731657~acl=/api/1/1/c/5/c/0/c5ce5e0f7d2ea14845375cda2ae22f35.mp3*~data=user_id=0,application_id=42~hmac=4090ed2ba0f30175a8109cff449c5531b85aa4b6ed077045c277f9d43529e1b4",
    cover: "https://api.deezer.com/album/301927/image",
    genre: "Pop",
  },
  {
    title: "Gonna Make You Sweat",
    artist: "C+C Music Factory",
    id: 829895,
    release_date: "1999-10-08",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/4/e/0/0/4e05d4d003396c02f9090ad66d2950f2.mp3?hdnea=exp=1763731657~acl=/api/1/1/4/e/0/0/4e05d4d003396c02f9090ad66d2950f2.mp3*~data=user_id=0,application_id=42~hmac=b5f3c275a33bcbd171bd490227281c24a21af075e7de5504ed42606cf432121b",
    cover: "https://api.deezer.com/album/96061/image",
    genre: "R&B",
  },
  {
    title: "Runaway Train",
    artist: "Soul Asylum",
    id: 1057312,
    release_date: "1992-01-01",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/4/d/d/0/4dd6b71800c5454af9ad0611af50b5e2.mp3?hdnea=exp=1763731657~acl=/api/1/1/4/d/d/0/4dd6b71800c5454af9ad0611af50b5e2.mp3*~data=user_id=0,application_id=42~hmac=de4f3699b124d52b6c098ed2449d51783fe8258051d29e9ad8aea6d449051f39",
    cover: "https://api.deezer.com/album/114769/image",
    genre: "Rock",
  },
  {
    title: "We like to Party! (The Vengabus)",
    artist: "Vengaboys",
    id: 397344502,
    release_date: "1999-12-11",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/ce258c669c4eeed127859e9386f7b76a/250x250-000000-80-0-0.jpg",
    genre: "Dance",
  },
  {
    title: "Stairway to Heaven",
    artist: "Led Zeppelin",
    id: 88003859,
    release_date: "1969-01-12",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/2/6/6/0/26692783366247f9e456227bc4eb9550.mp3?hdnea=exp=1763731657~acl=/api/1/1/2/6/6/0/26692783366247f9e456227bc4eb9550.mp3*~data=user_id=0,application_id=42~hmac=bee9b5420c6377e0b5347002c505e03f1912faa759860b9eccaf74df594a3eee",
    cover: "https://api.deezer.com/album/8887733/image",
    genre: "Rock",
  },
  {
    title: "Stayin' Alive",
    artist: "Bee Gees",
    id: 406815322,
    release_date: "1977-12-13",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/3/1/9/0/319c89b68405e15329ed21a4139fff38.mp3?hdnea=exp=1763731657~acl=/api/1/1/3/1/9/0/319c89b68405e15329ed21a4139fff38.mp3*~data=user_id=0,application_id=42~hmac=03e7a02ea6486b07237af5be8fa4a104cd8c6aed2f0eb14999957223d79216be",
    cover: "https://api.deezer.com/album/48140842/image",
    genre: "Disco",
  },
  {
    title: "Born to Be Alive",
    artist: "Patrick Hernandez",
    id: 4077573,
    release_date: "1979-03-20",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/7/e/7/0/7e792b5e2b606282d58f403c34ad0a22.mp3?hdnea=exp=1763730467~acl=/api/1/1/7/e/7/0/7e792b5e2b606282d58f403c34ad0a22.mp3*~data=user_id=0,application_id=42~hmac=dd37b21ff39b0eea27fa15f8470594231c555bc73f95cdb80919cccfcc14b671",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/cd1f9c428f3d6d84c4771f7422186afe/250x250-000000-80-0-0.jpg",
    genre: "Dance",
  },
  {
    title: "Don't Stop 'Til You Get Enough",
    artist: "Michael Jackson",
    id: 15586296,
    release_date: "1983-07-04",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/1/3/8/0/13822e707198e6a10be1af77031aef3e.mp3?hdnea=exp=1763731657~acl=/api/1/1/1/3/8/0/13822e707198e6a10be1af77031aef3e.mp3*~data=user_id=0,application_id=42~hmac=22eb0e799207f44e31622445adffbaf9aa81a51f83c7881cc17f04527ae298de",
    cover: "https://api.deezer.com/album/1440807/image",
    genre: "Pop",
  },
  {
    title: "Dance Hall Days",
    artist: "Wang Chung",
    id: 907794,
    release_date: "1983-11-19",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/9/a/d/0/9ad4ba327daa8095e151f3c2fd8ffac5.mp3?hdnea=exp=1763731657~acl=/api/1/1/9/a/d/0/9ad4ba327daa8095e151f3c2fd8ffac5.mp3*~data=user_id=0,application_id=42~hmac=10a6f10ab19e4eb26cbf8050816a6bb1e6bfa95b107e6d7496f8f5ba04dd90fa",
    cover: "https://api.deezer.com/album/102475/image",
    genre: "Pop",
  },
  {
    title: "Urgent",
    artist: "Foreigner",
    id: 2814888,
    release_date: "1987-01-29",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/c/5/6/0/c563b26ab8897671a4d6cfc31bfd9f19.mp3?hdnea=exp=1763730467~acl=/api/1/1/c/5/6/0/c563b26ab8897671a4d6cfc31bfd9f19.mp3*~data=user_id=0,application_id=42~hmac=1ab929dc581abc0387125b0f9172d2c4c07b6473a3f9a244b1bebaf1a02ce4b6",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/a7545dbac40fbecabeafc4847bcba549/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "Turn Me Loose",
    artist: "Loverboy",
    id: 1025465,
    release_date: "2003-03-25",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/6883eab08b168388d73c2783aae41469/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "The Logical Song",
    artist: "Supertramp",
    id: 7087537,
    release_date: "1979-10-04",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/2/5/7/0/2573107f791c6ffdd430fcdaa9d8827d.mp3?hdnea=exp=1763730467~acl=/api/1/1/2/5/7/0/2573107f791c6ffdd430fcdaa9d8827d.mp3*~data=user_id=0,application_id=42~hmac=6380caca6d15eaee28552a8af3270153eca8d6b4b331f346c50ea349f4a18ac5",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/fee526711039ce10381a3091204faca4/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "Breakfast In America",
    artist: "Supertramp",
    id: 7087529,
    release_date: "1979-10-04",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/7/e/3/0/7e3ccc542170379ccbb97a16418bb04f.mp3?hdnea=exp=1763730467~acl=/api/1/1/7/e/3/0/7e3ccc542170379ccbb97a16418bb04f.mp3*~data=user_id=0,application_id=42~hmac=2a0475bfb1deb5a01a965af6f90fc385f43e012ee29ee5218c13ce15ec5aa9a5",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/9c82f1673a2526a69bda92271d24c087/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "Rosanna",
    artist: "Toto",
    id: 1079628,
    release_date: "1982-04-08",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/5/4/7/0/5479434824d3313fc41a95f3a54524a3.mp3?hdnea=exp=1763730467~acl=/api/1/1/5/4/7/0/5479434824d3313fc41a95f3a54524a3.mp3*~data=user_id=0,application_id=42~hmac=63b0225ab9600b83cee5555a18c6a450bcb1a14714943d26327232e309c7fbf8",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/153332e88a14255a8c3d5959a5a21882/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Africa",
    artist: "Toto",
    id: 1079668,
    release_date: "1982-04-08",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/d/4/6/0/d46762f2025f13175f2fd2c062b46182.mp3?hdnea=exp=1763730467~acl=/api/1/1/d/4/6/0/d46762f2025f13175f2fd2c062b46182.mp3*~data=user_id=0,application_id=42~hmac=f0ea9bfb169c25a254526fed9711fc5caa6eab060ece35181738c489eddae22d",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/153332e88a14255a8c3d5959a5a21882/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Tragedy",
    artist: "Bee Gees",
    id: 350027801,
    release_date: "1976-05-16",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/f/5/6/0/f568a6c77c232484c7830404d57d55c8.mp3?hdnea=exp=1763730467~acl=/api/1/1/f/5/6/0/f568a6c77c232484c7830404d57d55c8.mp3*~data=user_id=0,application_id=42~hmac=62a6f5b44e2cde89fb76f0ab0b6ad11a19e44197026552c29a06ac357cc2189e",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/ff58c365559fb6061db49dbdcfdf2287/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Walking On Sunshine",
    artist: "Katrina & The Waves",
    id: 3166724,
    release_date: "1983-04-20",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/7/3/3/0/73334a7574876bdf8e20a302a08fa960.mp3?hdnea=exp=1763730467~acl=/api/1/1/7/3/3/0/73334a7574876bdf8e20a302a08fa960.mp3*~data=user_id=0,application_id=42~hmac=ec345ba66e44c314e0f2f27bd9c5bf34c79e0f7db989fd5ac37e6ce13cc14c29",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/1a81bcd5543be9705c0c66e57593a258/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Sweet Dreams (Are Made of This)",
    artist: "Eurythmics",
    id: 561836,
    release_date: "1983-10-21",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/c/7/6/0/c762b853f6084e40164035a67f8c2e67.mp3?hdnea=exp=1763730467~acl=/api/1/1/c/7/6/0/c762b853f6084e40164035a67f8c2e67.mp3*~data=user_id=0,application_id=42~hmac=6f3b52ffa82a696381353c9ac75f6aedfeda6f6b86ee0e50ddfcf0049ce727ed",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/364f0d4ea4b5452b59e6664b9e5480f0/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "The Final Countdown",
    artist: "Europe",
    id: 619310,
    release_date: "1984-03-01",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/7/6/2/0/7626fba38c65e5dfc73242566f962705.mp3?hdnea=exp=1763730467~acl=/api/1/1/7/6/2/0/7626fba38c65e5dfc73242566f962705.mp3*~data=user_id=0,application_id=42~hmac=2d8753cdf14f941e3e3e5d2fface59d10a473249ea2b54d2b3139a1c3f8633a8",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/da44873bbb18e25f946863209fcbbbe0/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "YMCA",
    artist: "Village People",
    id: 78595927,
    release_date: "1978-05-09",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/2/e/4/0/2e41df21f0480dfeb9355275611b4cdd.mp3?hdnea=exp=1763730467~acl=/api/1/1/2/e/4/0/2e41df21f0480dfeb9355275611b4cdd.mp3*~data=user_id=0,application_id=42~hmac=7c2e222f7beb48de2584303957f8f514f24179e29e60e7c47b319b9cb72b9403",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/c446db15539f4e82846c606b072fe8b7/250x250-000000-80-0-0.jpg",
    genre: "Dance",
  },
  {
    title: "It's My Life - Radio Edit",
    artist: "Bon Jovi",
    id: 89870993,
    release_date: "2000-01-15",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/3/7/e/0/37e796a27156222852cf585904d2c98d.mp3?hdnea=exp=1763730467~acl=/api/1/1/3/7/e/0/37e796a27156222852cf585904d2c98d.mp3*~data=user_id=0,application_id=42~hmac=17405217eab7f198454767266051023d018e914fd1a9ddceca1e4ad565b3ee56",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/08a906bd35e5707ef08ceed3e36db1c7/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "Jump",
    artist: "Van Halen",
    id: 97098410,
    release_date: "1984-09-24",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/4/5/6/0/4564585fd721c9bf1df04fbf95f2ba9a.mp3?hdnea=exp=1763730467~acl=/api/1/1/4/5/6/0/4564585fd721c9bf1df04fbf95f2ba9a.mp3*~data=user_id=0,application_id=42~hmac=3af1b5265a388e785ae4831ed14f9fb16f66b68ad5bea0fc27827f9467cd7190",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/0649448bcdeeeb48c25edc0e83653711/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "You Win Again",
    artist: "Bee Gees",
    id: 348129241,
    release_date: "1987-09-01",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/8/8/d/0/88d6ad135ce0c0184dc5bbe9b5433f89.mp3?hdnea=exp=1763730467~acl=/api/1/1/8/8/d/0/88d6ad135ce0c0184dc5bbe9b5433f89.mp3*~data=user_id=0,application_id=42~hmac=ac3919329d35f7c065f30e791f38f990ec843fc0053c8d25688506bd810e17a8",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/0e9ae81018b27c2eb06a0fb9b10427b7/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Say Say Say",
    artist: "Paul McCartney",
    id: 107768560,
    release_date: "1983-10-02",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/a/2/9/0/a294e4a2f6d12d63468233f36a8f7c03.mp3?hdnea=exp=1763730467~acl=/api/1/1/a/2/9/0/a294e4a2f6d12d63468233f36a8f7c03.mp3*~data=user_id=0,application_id=42~hmac=c25eb0aa7e91410a49a13d9c34ff17509dbec45014f8d48118fe62a5f57d2c43",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/28f8b1fe717413c1b709da5f7234b723/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "Hope Of Deliverance",
    artist: "Paul McCartney",
    id: 10176186,
    release_date: "1993-03-08",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/0/8/e/0/08ecb5a2b23d84863cd4c00c662a3b57.mp3?hdnea=exp=1763730467~acl=/api/1/1/0/8/e/0/08ecb5a2b23d84863cd4c00c662a3b57.mp3*~data=user_id=0,application_id=42~hmac=9f3e2eb32179939ce047918aca842f7759f2f4006463d6460468ba32b6e212d1",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/87c3d6b2e71fa02fbd26ffff59f84035/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "One Night In Bangkok",
    artist: "Murray Head",
    id: 89977351,
    release_date: "1984-11-24",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/b/e/b/0/beb44dcbe783ab690149b7f2db5196be.mp3?hdnea=exp=1763730467~acl=/api/1/1/b/e/b/0/beb44dcbe783ab690149b7f2db5196be.mp3*~data=user_id=0,application_id=42~hmac=48f59b27a93c5387fa78636ed7e1f9b799acd878aa555cb0947f24d167a9068c",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/84d654a1c8cd9281bfa2f1f118e361c4/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Say It Right",
    artist: "Nelly Furtado",
    id: 7562986,
    release_date: "2006-12-31",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/9/f/4/0/9f4873b6a9b2fd2abe6f12d1dfebb924.mp3?hdnea=exp=1763730467~acl=/api/1/1/9/f/4/0/9f4873b6a9b2fd2abe6f12d1dfebb924.mp3*~data=user_id=0,application_id=42~hmac=ef44e2ff6722aa74aac71cdb70d693433a90faf6e1cf6d09fbc42fc12ec8a624",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/fbd6d06c71d72755bba27af0b1e3c88e/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Maneater",
    artist: "Nelly Furtado",
    id: 1151141,
    release_date: "2007-03-08",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/7/f/c/0/7fc8f2f95cb15d6ba6f73af8dafa6eb3.mp3?hdnea=exp=1763730467~acl=/api/1/1/7/f/c/0/7fc8f2f95cb15d6ba6f73af8dafa6eb3.mp3*~data=user_id=0,application_id=42~hmac=57db882d5a39b7eaaab6eae2cacedecbed9a862241b7dec5fa34f68418cf1d6d",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/1d3625d9f19527440769e7f8cc09db85/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Hung Up",
    artist: "Madonna",
    id: 679217,
    release_date: "2005-11-14",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/0/9/6/0/096286ef9836241cf1f34c03713f0222.mp3?hdnea=exp=1763730467~acl=/api/1/1/0/9/6/0/096286ef9836241cf1f34c03713f0222.mp3*~data=user_id=0,application_id=42~hmac=ab77e7cb49cfc2f4d4adaa58916807c43b3202484237ed0835427c2b9034cbfc",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/8e499d7b0e9be5b77eb6c2697e179fe3/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "All The Things She Said",
    artist: "t.A.T.u.",
    id: 62070435,
    release_date: "2012-11-19",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/c/6/2/0/c62366f476a71684b76c266bbe1b86ee.mp3?hdnea=exp=1763730467~acl=/api/1/1/c/6/2/0/c62366f476a71684b76c266bbe1b86ee.mp3*~data=user_id=0,application_id=42~hmac=4d13439c700bd59226248e48b2048e00e77db5fac0b07a50f6568108ca079bcc",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/ca53a09389eda98a6894cf603a98a9c6/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Just Dance",
    artist: "Lady Gaga",
    id: 2603555,
    release_date: "2008-11-24",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/8/2/0/0/82006e670fe9f4fa417c7fcc22dcf456.mp3?hdnea=exp=1763730467~acl=/api/1/1/8/2/0/0/82006e670fe9f4fa417c7fcc22dcf456.mp3*~data=user_id=0,application_id=42~hmac=5c53c38e47a05a6abab18bf86221fa9dd0ad37265577def05b2e7775a125011b",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/cc24d60a998e1a296f0c22efa8ddffd2/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Valerie (feat. Amy Winehouse)",
    artist: "Mark Ronson",
    id: 7923756,
    release_date: "2007-04-16",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/1/d/2/0/1d2abe863e60afb472b52986795bd3f8.mp3?hdnea=exp=1763730467~acl=/api/1/1/1/d/2/0/1d2abe863e60afb472b52986795bd3f8.mp3*~data=user_id=0,application_id=42~hmac=d638b7f39dead26d6b60a3798e77726ab3a270a90704d6093413d1e2c2a34705",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/aa17bc2f15022dd727fd21922e90c9c9/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Billie Jean",
    artist: "Michael Jackson",
    id: 4603408,
    release_date: "1989-10-26",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/e/6/e/0/e6e0f8717b1e6353e2abf797c6849889.mp3?hdnea=exp=1763730467~acl=/api/1/1/e/6/e/0/e6e0f8717b1e6353e2abf797c6849889.mp3*~data=user_id=0,application_id=42~hmac=4f0dc04045ac310ce4298594caccc2a50c1bd3669e75f4b9189bd11639579536",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/a0ad67d1beb761f2cb9f8b60e5bcf07a/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Beat It",
    artist: "Michael Jackson",
    id: 555640,
    release_date: "1983-11-30",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/a/7/b/0/a7b72478be04fb6d75ed6fd296efd096.mp3?hdnea=exp=1763730467~acl=/api/1/1/a/7/b/0/a7b72478be04fb6d75ed6fd296efd096.mp3*~data=user_id=0,application_id=42~hmac=c4ebf85f21676ed016a411b4dfdcb6b37ffb2b287b8e6c69ee6cd35f53317cb2",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/92a024220a9532489c75c9d994835697/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Thriller",
    artist: "Michael Jackson",
    id: 14874867,
    release_date: "1985-07-18",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/2/f/7/0/2f7aa112bb86302cd0bc2227d1e365f4.mp3?hdnea=exp=1763730467~acl=/api/1/1/2/f/7/0/2f7aa112bb86302cd0bc2227d1e365f4.mp3*~data=user_id=0,application_id=42~hmac=c801edc7022273d6c58f1f4039eff4abd7ddd15709a12f14b9cfb5bb28cb91f6",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/041e3b8fc5ed298264b6e374b825b24f/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Bohemian Rhapsody",
    artist: "Queen",
    id: 7857234,
    release_date: "1975-01-01",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/3/6/7/0/367ff8f9e20e026b31155d82bff77bdf.mp3?hdnea=exp=1763730467~acl=/api/1/1/3/6/7/0/367ff8f9e20e026b31155d82bff77bdf.mp3*~data=user_id=0,application_id=42~hmac=4ee32f4806a9365489f6cf340f8c3a5677f598e6e314c00760ed47a85c932d58",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/9d5f6e56b755d104525cf3a0810356bc/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "Smoke on the Water",
    artist: "Deep Purple",
    id: 3152610,
    release_date: "1972-07-23",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/c4cbc4f2ad6cbd36d1d7549178e301d7/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "My Sharona",
    artist: "The Knack",
    id: 6812046,
    release_date: "1979-08-20",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/9/f/4/0/9f495649119a0841a7361bb18d2d369b.mp3?hdnea=exp=1763730467~acl=/api/1/1/9/f/4/0/9f495649119a0841a7361bb18d2d369b.mp3*~data=user_id=0,application_id=42~hmac=d601a4be5b1b35307591c234f4865ed023ebc4d8d185fa5446b346d4d890f4fc",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/87655ffd4c1910baa30c5459cbfaadb9/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "Das Model",
    artist: "Kraftwerk",
    id: 1006803652,
    release_date: "1987-05-26",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/5/8/9/0/58904217e81cec700585554d9d614ff4.mp3?hdnea=exp=1763730467~acl=/api/1/1/5/8/9/0/58904217e81cec700585554d9d614ff4.mp3*~data=user_id=0,application_id=42~hmac=281ba19f0494e75184b7cdd955a262240bddb745549b5b90b57b4bf44ca20d61",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/4270c9ccd41bd480c76610ead7128d66/250x250-000000-80-0-0.jpg",
    genre: "Dance",
  },
  {
    title: "Dancing Queen",
    artist: "ABBA",
    id: 884025,
    release_date: "1978-06-02",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/9/1/6/0/916f7137187790e999bc66e6460c07b2.mp3?hdnea=exp=1763730467~acl=/api/1/1/9/1/6/0/916f7137187790e999bc66e6460c07b2.mp3*~data=user_id=0,application_id=42~hmac=bcb40418ebfd0d6448e2fdd86da307fd01b1dc920f13111d7c30b5903cde198a",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/b8b70d474b7a8f27799e0d665e9b737e/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Highway to Hell",
    artist: "AC/DC",
    id: 92719900,
    release_date: "1979-07-27",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/d/7/1/0/d7183d3dd28d85289690100ef5d7c78e.mp3?hdnea=exp=1763730467~acl=/api/1/1/d/7/1/0/d7183d3dd28d85289690100ef5d7c78e.mp3*~data=user_id=0,application_id=42~hmac=fa2f40fb98ec72608dfdb744aa157de2fa7d263e17d1af16beed4f4a1e79f243",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/de48d988a82fc401f4b9bafc2639f7d0/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "Heart Of Glass",
    artist: "Blondie",
    id: 3151379,
    release_date: "1978-05-25",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/e/2/b/0/e2b1d291c2f83d0388d4a84dd8304f83.mp3?hdnea=exp=1763730467~acl=/api/1/1/e/2/b/0/e2b1d291c2f83d0388d4a84dd8304f83.mp3*~data=user_id=0,application_id=42~hmac=8c6ed9c10712f7dcdf5d7ee8af8f1b0d12b02ada63165fa3ca089f867ce6e79a",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/93eb8b69b5b5d03af224af1c9d28bc53/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "I Feel Love",
    artist: "Donna Summer",
    id: 487042352,
    release_date: "1978-04-20",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/a/4/5/0/a456e5397fcf0689248ed9faf8a64d44.mp3?hdnea=exp=1763730467~acl=/api/1/1/a/4/5/0/a456e5397fcf0689248ed9faf8a64d44.mp3*~data=user_id=0,application_id=42~hmac=19fce67c027ade3319438f96fb7f691082a8c63fe76883f0c0bdaecff115b7be",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/31ae32eedb76d458f95b26a9ba35ac49/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "You Shook Me All Night Long",
    artist: "AC/DC",
    id: 92720048,
    release_date: "1980-07-25",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/2/1/a/0/21af9bde7aacee934f02c9df8c931bdf.mp3?hdnea=exp=1763730467~acl=/api/1/1/2/1/a/0/21af9bde7aacee934f02c9df8c931bdf.mp3*~data=user_id=0,application_id=42~hmac=600ad57b328b7a905a72c0f9d34e7b71f0bf2490441f418274f87c0b56cebe61",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/41041b14873956eff0459c8ea2c296a8/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "Livin' On A Prayer",
    artist: "Bon Jovi",
    id: 538660022,
    release_date: "1986-10-31",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/7/c/1/0/7c1d95d2fe6ad479f66d912db049df50.mp3?hdnea=exp=1763730467~acl=/api/1/1/7/c/1/0/7c1d95d2fe6ad479f66d912db049df50.mp3*~data=user_id=0,application_id=42~hmac=4903fd0fb1e8a357eeabb9d478209e071d22b72b9f829df749698f90faed302a",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/1f0365311a9d03c267f175e0ef79f40c/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "Pour Some Sugar On Me",
    artist: "Def Leppard",
    id: 447552822,
    release_date: "1987-01-19",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/5/b/8/0/5b87fbdb6487f201b23d37e7e2adea41.mp3?hdnea=exp=1763730467~acl=/api/1/1/5/b/8/0/5b87fbdb6487f201b23d37e7e2adea41.mp3*~data=user_id=0,application_id=42~hmac=9e0ae0a0151f7890a572450eacc790521a8c0706d72a507e0e26929985b461a8",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/86d5af2077f5b6ef18fd0ca158a91134/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "Celebration",
    artist: "Kool & The Gang",
    id: 906568,
    release_date: "1977-09-10",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/7/b/5/0/7b52cf6cc92897e31f6ac250f032cc17.mp3?hdnea=exp=1763730467~acl=/api/1/1/7/b/5/0/7b52cf6cc92897e31f6ac250f032cc17.mp3*~data=user_id=0,application_id=42~hmac=5a8ec87130fef373a214cddbb4fe84c2642493e95a884e34d96a68315b73ad3e",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/e993fe7d2c6e0a4fe259485d940aa7a5/250x250-000000-80-0-0.jpg",
    genre: "Dance",
  },
  {
    title: "Girls Just Want to Have Fun",
    artist: "Cyndi Lauper",
    id: 76057844,
    release_date: "1984-03-28",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/8/0/2/0/8029ee36f2638c65b196f42a2b884dc1.mp3?hdnea=exp=1763730467~acl=/api/1/1/8/0/2/0/8029ee36f2638c65b196f42a2b884dc1.mp3*~data=user_id=0,application_id=42~hmac=21e18a8dbdfc08e915f879f293b4b0e36249f59a31f89cb0535df019807b75c3",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/a00e104be064ecd2ba490ded73bd6698/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "The Way You Make Me Feel",
    artist: "Michael Jackson",
    id: 59509541,
    release_date: "1982-09-14",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/c/3/b/0/c3b441196f56db508ba8f0d5551ae3f3.mp3?hdnea=exp=1763730467~acl=/api/1/1/c/3/b/0/c3b441196f56db508ba8f0d5551ae3f3.mp3*~data=user_id=0,application_id=42~hmac=bdf1c2561043f17cb32a05d11f29c617127e48499e94cb8bab1d5cac97baa3ca",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/fb0a49a91ab8137ec9d028c4dbb04021/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "(I've Had) The Time Of My Life",
    artist: "Bill Medley",
    id: 13128250,
    release_date: "1987-12-18",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/7/f/3/0/7f397fb764da99ef77dfcf22d9eac6db.mp3?hdnea=exp=1763730467~acl=/api/1/1/7/f/3/0/7f397fb764da99ef77dfcf22d9eac6db.mp3*~data=user_id=0,application_id=42~hmac=420713df1121f7bc0ae85bdbed6917f0b4b01dc0adda0e6ccd5401cce90a8e19",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/f24ac40f8c7a0dbe438399788763a042/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Crazy Little Thing Called Love",
    artist: "Queen",
    id: 568121002,
    release_date: "1988-10-19",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/e/8/4/0/e84ca26dc530e3f1170d17a5bdd5afef.mp3?hdnea=exp=1763730467~acl=/api/1/1/e/8/4/0/e84ca26dc530e3f1170d17a5bdd5afef.mp3*~data=user_id=0,application_id=42~hmac=8372d07d3e19c4a5836344baa6477c9a840bcd8e0b04e4a0d79b65184daef4ae",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/8b8fc5d117f9357b79f0a0a410a170e8/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "Take Me Home Tonight",
    artist: "Eddie Money",
    id: 1081064,
    release_date: "1986-10-15",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/6/6/e/0/66e18e2c78cd660d6987ded9b67c01bc.mp3?hdnea=exp=1763730467~acl=/api/1/1/6/6/e/0/66e18e2c78cd660d6987ded9b67c01bc.mp3*~data=user_id=0,application_id=42~hmac=98ce459261546539b55a08ab8a03606bef045948ec29d0e3c1bd07e986870836",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/bdfbfeffad8d5c31d1084075b5487cc2/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "Red Red Wine",
    artist: "UB40",
    id: 3129568,
    release_date: "1983-03-01",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/3/c/6/0/3c6baf8bc8a93e9fac3fd2be9d972d9e.mp3?hdnea=exp=1763730467~acl=/api/1/1/3/c/6/0/3c6baf8bc8a93e9fac3fd2be9d972d9e.mp3*~data=user_id=0,application_id=42~hmac=67acb3867a14e30f7f5dd4969f4bf4f5cf3a1fdd64af02c5966a00fb6dcc1e59",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/ba1ee8b4130e3c0e2606dfe365312dab/250x250-000000-80-0-0.jpg",
    genre: "Reggae",
  },
  {
    title: "I Love Rock 'N Roll",
    artist: "Joan Jett and the Blackhearts",
    id: 545992732,
    release_date: "1981-11-18",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/b/4/4/0/b440cb2b130f22caf9a8d99e958288fd.mp3?hdnea=exp=1763730467~acl=/api/1/1/b/4/4/0/b440cb2b130f22caf9a8d99e958288fd.mp3*~data=user_id=0,application_id=42~hmac=d8075efce8cc0ff381f0729222fff680b399518991a35a1b5cad13c2d95c012f",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/8c4fb793cfedbb94d6e8926f3647eb8b/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "Another One Bites The Dust",
    artist: "Queen",
    id: 67503793,
    release_date: "1981-01-01",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/b/f/d/0/bfd666256f73f856e9b8cd4ecdc90559.mp3?hdnea=exp=1763730467~acl=/api/1/1/b/f/d/0/bfd666256f73f856e9b8cd4ecdc90559.mp3*~data=user_id=0,application_id=42~hmac=fe75f0ceffaa85c965a5a9a00b67e240ec62dcc3308fa6aefc131b66b6edd55b",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/1e1883d47e9e07a3b6dbf5c9249452d8/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "Smooth Criminal",
    artist: "Michael Jackson",
    id: 59509621,
    release_date: "1982-09-14",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/4/5/b/0/45b7fe5ee8a6dd29d28146400a020ebd.mp3?hdnea=exp=1763730467~acl=/api/1/1/4/5/b/0/45b7fe5ee8a6dd29d28146400a020ebd.mp3*~data=user_id=0,application_id=42~hmac=97e59340abac2bef7349d58c8f3ebe7cefdbaef445f37550869f9b9d40923fe3",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/fb0a49a91ab8137ec9d028c4dbb04021/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Rock with You",
    artist: "Michael Jackson",
    id: 15586286,
    release_date: "1983-07-04",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/f/e/7/0/fe73bc32de433688b3ad3ae17929b028.mp3?hdnea=exp=1763730467~acl=/api/1/1/f/e/7/0/fe73bc32de433688b3ad3ae17929b028.mp3*~data=user_id=0,application_id=42~hmac=8a325a0712dfdd3f16237fbb50889ef7ba535866b920e8aebaa7068f31e1e110",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/baf09a24b48b82e3af270efba101d07b/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "The Safety Dance",
    artist: "Men Without Hats",
    id: 63440828,
    release_date: "1982-02-11",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/f/e/a/0/fea4a43bc9c4fcd6ff72ef18d6f84cbb.mp3?hdnea=exp=1763730150~acl=/api/1/1/f/e/a/0/fea4a43bc9c4fcd6ff72ef18d6f84cbb.mp3*~data=user_id=0,application_id=42~hmac=74ee11df7804fae851760f501cb1a88a10be33e060136f64673e8de1d9bf387b",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/4ff46d3112e44464f09f67d161012f23/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "All Night Long",
    artist: "Lionel Richie",
    id: 920062,
    release_date: "1983-06-22",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/f/1/8/0/f18be05d355637d2f0ae646201740027.mp3?hdnea=exp=1763730150~acl=/api/1/1/f/1/8/0/f18be05d355637d2f0ae646201740027.mp3*~data=user_id=0,application_id=42~hmac=cd78e22288e03f5f6705fce0f9f4cef3c9f8b0b2903a2fa9e492c54a91e2b967",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/7050e918a1ead7bdbd7cadd9dfa2b858/250x250-000000-80-0-0.jpg",
    genre: "R&B",
  },
  {
    title: "Wanna Be Startin' Somethin'",
    artist: "Michael Jackson",
    id: 831216,
    release_date: "1983-07-29",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/0/8/3/0/083d0d153a1005e529732c857e87c2b5.mp3?hdnea=exp=1763730467~acl=/api/1/1/0/8/3/0/083d0d153a1005e529732c857e87c2b5.mp3*~data=user_id=0,application_id=42~hmac=71ad12e6474d32f77fd81357fca4dc5f9e17d74aaab8edb3b07ba41735d4ab0b",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/544862aa5be45bc82ad4ab1a14daf63a/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Wake Me Up Before You Go-Go",
    artist: "Wham!",
    id: 15194531,
    release_date: "1985-01-22",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/b/6/b/0/b6b916879db11a5fcf980c6261c46b54.mp3?hdnea=exp=1763730150~acl=/api/1/1/b/6/b/0/b6b916879db11a5fcf980c6261c46b54.mp3*~data=user_id=0,application_id=42~hmac=0dc73ff0ff66aef3031f9d768933f23bd51b798fb0db91405ee03438774957a8",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/3c1858a4aa5d732a60c8cfcf424f24ef/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "It's Raining Men",
    artist: "The Weather Girls",
    id: 555755,
    release_date: "1982-11-25",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/7/c/8/0/7c8cecb1957ab39f24bca09fd70df7ab.mp3?hdnea=exp=1763730150~acl=/api/1/1/7/c/8/0/7c8cecb1957ab39f24bca09fd70df7ab.mp3*~data=user_id=0,application_id=42~hmac=951c22554a465c4101261393f294a0f838f4f5d0d8458e103f85ff485cc8f5ff",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/9fe1f7455be7fa598bf2777ad15f08d8/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Back In Black",
    artist: "AC/DC",
    id: 92720046,
    release_date: "1980-07-25",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/8/2/b/0/82be918b42c3d26093b20d01e97e4a03.mp3?hdnea=exp=1763730150~acl=/api/1/1/8/2/b/0/82be918b42c3d26093b20d01e97e4a03.mp3*~data=user_id=0,application_id=42~hmac=3c8653cb726bd1b94c3ad2355d93d13cbdf5853237298379f288e6b85ff3f5f6",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/41041b14873956eff0459c8ea2c296a8/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "Man in the Mirror",
    artist: "Michael Jackson",
    id: 59509591,
    release_date: "1988-09-14",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/2/9/4/0/294e31b478ff799345803f2334231851.mp3?hdnea=exp=1763730150~acl=/api/1/1/2/9/4/0/294e31b478ff799345803f2334231851.mp3*~data=user_id=0,application_id=42~hmac=dfa85b2f7d171e3303560c9ec7f0b57c39960894de1b7c013b36a67908319f01",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/fb0a49a91ab8137ec9d028c4dbb04021/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Pump Up The Jam",
    artist: "Technotronic",
    id: 2961498,
    release_date: "1999-03-23",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/2/a/e/0/2aecc8b287853fe365e22a80310d90dc.mp3?hdnea=exp=1763730150~acl=/api/1/1/2/a/e/0/2aecc8b287853fe365e22a80310d90dc.mp3*~data=user_id=0,application_id=42~hmac=200bb95e3f5290586ceccae67bb155e56b17bf395521a35bdf2a5a8c35de19de",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/8ddb94a0ba17254188a54d18b6173f7f/250x250-000000-80-0-0.jpg",
    genre: "Dance",
  },
  {
    title: "Uptown Girl",
    artist: "Billy Joel",
    id: 1025659,
    release_date: "1983-08-08",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/7/f/a/0/7fa78b96031968e12d31af61bcc5d361.mp3?hdnea=exp=1763730150~acl=/api/1/1/7/f/a/0/7fa78b96031968e12d31af61bcc5d361.mp3*~data=user_id=0,application_id=42~hmac=0f0b26500428bc7125a254af598545f216aae3e15814b78f5216b8c01f23c44d",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/fa5a6fc95f4adfb8784dcd719422c26e/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Conga!",
    artist: "Miami Sound Machine",
    id: 565055,
    release_date: "1996-10-03",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/b/c/e/0/bceb0e7eaa15257db70014a33323b2d8.mp3?hdnea=exp=1763730150~acl=/api/1/1/b/c/e/0/bceb0e7eaa15257db70014a33323b2d8.mp3*~data=user_id=0,application_id=42~hmac=ec6b10e8db5cce05975f6ce5d3d1fb396858ae3942826d6feb9488bc0646718c",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/1b0411abe7d773fd5e5d56c47da318c6/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Glory Days",
    artist: "Bruce Springsteen",
    id: 15586215,
    release_date: "1984-06-04",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/b/5/b/0/b5b8d78a3208983eea7eaf1681aed7d5.mp3?hdnea=exp=1763730150~acl=/api/1/1/b/5/b/0/b5b8d78a3208983eea7eaf1681aed7d5.mp3*~data=user_id=0,application_id=42~hmac=2a50ad432fe073968621d09d9c6a6d03f7df858b62396f56eddc04489db553fb",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/106f651bf559796879b90e83c50b3e96/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "Walk Like an Egyptian",
    artist: "The Bangles",
    id: 610231,
    release_date: "1983-04-23",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/1/f/4/0/1f4a1e12663babaced37feb3a08cda90.mp3?hdnea=exp=1763730150~acl=/api/1/1/1/f/4/0/1f4a1e12663babaced37feb3a08cda90.mp3*~data=user_id=0,application_id=42~hmac=22682a8d5170c1d818f28ab8eeb1cc32083b6b04ee023a8d11189c041641b24a",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/938d17e5a07d6178bcabbe2349a79ba0/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "You're the Inspiration",
    artist: "Chicago",
    id: 3616316,
    release_date: "1984-11-14",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/c/c/c/0/cccfcb88b65b1d605b638ac4bbea62de.mp3?hdnea=exp=1763730150~acl=/api/1/1/c/c/c/0/cccfcb88b65b1d605b638ac4bbea62de.mp3*~data=user_id=0,application_id=42~hmac=0f14dbf5c45e9b4ee81eaa6841eb64fe9c32779a5e0b38abd84c55ecdd1bf064",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/9fb83435f0d9bfee9397100320c59cfc/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Tainted Love",
    artist: "Soft Cell",
    id: 1173622,
    release_date: "1982-06-15",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/6/4/c/0/64c7f0ad48610384343c8a57e0209491.mp3?hdnea=exp=1763730150~acl=/api/1/1/6/4/c/0/64c7f0ad48610384343c8a57e0209491.mp3*~data=user_id=0,application_id=42~hmac=71f5f5b18c585305f6a7f08875a9518666ca0d17549e3aa1ba1fbce2921119e2",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/a809e8767a0cc557be1c894c5ed1c71e/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Rhythm Is A Dancer",
    artist: "Snap!",
    id: 434215172,
    release_date: "1992-01-01",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/e/9/c/0/e9ca6bef77ca7c3a43b0bede17894cfc.mp3?hdnea=exp=1763730150~acl=/api/1/1/e/9/c/0/e9ca6bef77ca7c3a43b0bede17894cfc.mp3*~data=user_id=0,application_id=42~hmac=6330dc9dbca7d5ab8219fa8db68bf7b26b7fecbfcdc2f5e5cdc5376ab0b08fda",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/e9836fcf60102662b686f93d01bcda69/250x250-000000-80-0-0.jpg",
    genre: "Dance",
  },
  {
    title: "Ice Ice Baby",
    artist: "Vanilla Ice",
    id: 2397026,
    release_date: "1992-11-04",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/7/f/c/0/7fc6770245cef5670004343eaccb2452.mp3?hdnea=exp=1763730150~acl=/api/1/1/7/f/c/0/7fc6770245cef5670004343eaccb2452.mp3*~data=user_id=0,application_id=42~hmac=1290b8d05b6de9a053802d1a57c49dea1b491704d17614ec828d555cdf25b636",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/177bec5553a37b3ecf7d548ca8f6d370/250x250-000000-80-0-0.jpg",
    genre: "Rap/Hip Hop",
  },
  {
    title: "U Can't Touch This",
    artist: "MC Hammer",
    id: 3090793,
    release_date: "1990-02-12",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/7/9/6/0/79663c2462dba4b6f5a4da1dd4921e0e.mp3?hdnea=exp=1763730150~acl=/api/1/1/7/9/6/0/79663c2462dba4b6f5a4da1dd4921e0e.mp3*~data=user_id=0,application_id=42~hmac=76254a8389b86a4165010812c5366218d5dcedde31098b9d8f4083eae98f46fd",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/3558d89040fc95f8978c67b09aa2d16b/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "I Like To Move It",
    artist: "Reel 2 Real",
    id: 524374752,
    release_date: "1994-10-10",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/9/c/a/0/9ca829d1aabc0489dd694ae3489c2659.mp3?hdnea=exp=1763730150~acl=/api/1/1/9/c/a/0/9ca829d1aabc0489dd694ae3489c2659.mp3*~data=user_id=0,application_id=42~hmac=7504a1cee927efe95259feadab06833402bd825376785e3749602c6d75b44991",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/58ba0c77278cb7f63bb9fbd094e2fabd/250x250-000000-80-0-0.jpg",
    genre: "Dance",
  },
  {
    title: "Everybody Dance Now",
    artist: "DJ Twilight",
    id: 8151890,
    release_date: "2011-01-10",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/1c2e1e1f519c64b2059d352b9fc8f432/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Dirty Diana",
    artist: "Michael Jackson",
    id: 14874854,
    release_date: "1985-07-18",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/f/1/2/0/f121f3ff681871ba3636f9d9f9bd308b.mp3?hdnea=exp=1763730150~acl=/api/1/1/f/1/2/0/f121f3ff681871ba3636f9d9f9bd308b.mp3*~data=user_id=0,application_id=42~hmac=5b7c5d4373901fbb28eb408fd8fffda30d748295807cd84f80b18302f3c829d0",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/041e3b8fc5ed298264b6e374b825b24f/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Another Part of Me",
    artist: "Michael Jackson",
    id: 59509471,
    release_date: "1988-09-14",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/b/0/a/0/b0af950a4995c190abd327312e9be686.mp3?hdnea=exp=1763730150~acl=/api/1/1/b/0/a/0/b0af950a4995c190abd327312e9be686.mp3*~data=user_id=0,application_id=42~hmac=bd3c3bb49a8d4396a7d331a994cd36a1844d7e12da405c1f4c336e7aa01ed64c",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/995b33eaad9a62409c822ce9c670e542/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Mambo No. 5",
    artist: "Lou Bega",
    id: 994493,
    release_date: "1998-05-24",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/c/4/2/0/c429f9ce07f0ea14d99f892d678d632e.mp3?hdnea=exp=1763726034~acl=/api/1/1/c/4/2/0/c429f9ce07f0ea14d99f892d678d632e.mp3*~data=user_id=0,application_id=42~hmac=51967f6d7c3c553c8344c4df7b9f3ae9f6f07b28fa283434acac8b7a0ecec7f9",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/6a827921da4e6afde64294d7483cbf0e/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Love Is All Around",
    artist: "Wet Wet Wet",
    id: 910912,
    release_date: "1994-05-09",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/3/6/3/0/36324239bff109b7c85ae3984e87fbde.mp3?hdnea=exp=1763726034~acl=/api/1/1/3/6/3/0/36324239bff109b7c85ae3984e87fbde.mp3*~data=user_id=0,application_id=42~hmac=3007eccabfa277097cddb943df9d7432b399897a9baceaef0039eaeb4646672b",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/447dbf905a9bc8113add6d914babe853/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "The Lady In Red",
    artist: "Chris De Burgh",
    id: 522699602,
    release_date: "1986-06-15",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/c5653d56284b179befadab5070bfc6cf/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "My Heart Will Go On",
    artist: "Céline Dion",
    id: 14552280,
    release_date: "1998-01-20",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/f/b/d/0/fbd59f9121892eed1ed1671730f012bd.mp3?hdnea=exp=1763726034~acl=/api/1/1/f/b/d/0/fbd59f9121892eed1ed1671730f012bd.mp3*~data=user_id=0,application_id=42~hmac=8ffe7599e86c2fada212efb909f03d6fe1c12fe4fc9d39cc866495bb10d865ce",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/177346106112348e15ec4f9add0c1ef4/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Everybody (Backstreet's Back)",
    artist: "Backstreet Boys",
    id: 15608663,
    release_date: "1997-10-09",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/f/c/d/0/fcd1f2df6ae0cea3b151c5f290ed7fc7.mp3?hdnea=exp=1763726034~acl=/api/1/1/f/c/d/0/fcd1f2df6ae0cea3b151c5f290ed7fc7.mp3*~data=user_id=0,application_id=42~hmac=9eb13ed5131184ac809e10361fb30a26626b94bb068b7e2fd606f4682bbecec1",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/4f5bf0b5232ddc0f8453c3014c83a592/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Blue (Da Ba Dee)",
    artist: "Eiffel 65",
    id: 88825391,
    release_date: "1998-01-29",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/1/8/b/0/18bd7ab3d61c33b90e9c8a6e7f5ddcce.mp3?hdnea=exp=1763726034~acl=/api/1/1/1/8/b/0/18bd7ab3d61c33b90e9c8a6e7f5ddcce.mp3*~data=user_id=0,application_id=42~hmac=080252574029fd76822af287eb001c62ec355d97c5cae3ee71bc5a44c7f99f20",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/457d79704890c7d827bdf92dbc037087/250x250-000000-80-0-0.jpg",
    genre: "Dance",
  },
  {
    title: "Scatman (ski-ba-bop-ba-dop-bop)",
    artist: "Scatman John",
    id: 99360002,
    release_date: "1995-06-01",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/a/b/2/0/ab2d1f4f90ecd3a78913b8c055fa960e.mp3?hdnea=exp=1763726034~acl=/api/1/1/a/b/2/0/ab2d1f4f90ecd3a78913b8c055fa960e.mp3*~data=user_id=0,application_id=42~hmac=8c30f6eecbadf3ef91102a27f230d8094fd108b2f8d292e0b54bbe391564ee42",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/42f2703765ad6be59c106e0d8db10570/250x250-000000-80-0-0.jpg",
    genre: "Dance",
  },
  {
    title: "The Sweet Escape",
    artist: "Gwen Stefani",
    id: 886428,
    release_date: "1998-05-12",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/e/2/2/0/e2255216c2c2645346127bbc89cad15d.mp3?hdnea=exp=1763726034~acl=/api/1/1/e/2/2/0/e2255216c2c2645346127bbc89cad15d.mp3*~data=user_id=0,application_id=42~hmac=2320c416f7fbf661d93ac21cd218b99bff3c3c5e608fd0cdadad22ab727acb1d",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/c10f36c2ce7bf1006ced08147d02de32/250x250-000000-80-0-0.jpg",
    genre: "Rap/Hip Hop",
  },
  {
    title: "Mr. Vain",
    artist: "Culture Beat",
    id: 29794781,
    release_date: "1993-05-11",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/8/d/9/0/8d9db81a051394cc02a2c8be44a2dce8.mp3?hdnea=exp=1763726034~acl=/api/1/1/8/d/9/0/8d9db81a051394cc02a2c8be44a2dce8.mp3*~data=user_id=0,application_id=42~hmac=1fc70ea1bfb14ce035efce484f3460a815950ecd7369c0cf814929eb83a6a4e5",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/a652433c79217dc6e885cfa28428f174/250x250-000000-80-0-0.jpg",
    genre: "Dance",
  },
  {
    title: "Easy Lover",
    artist: "Philip Bailey",
    id: 82199946,
    release_date: "1987-11-06",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/9/b/0/0/9b09c726a0da215410e32e94c3e3cd86.mp3?hdnea=exp=1763726034~acl=/api/1/1/9/b/0/0/9b09c726a0da215410e32e94c3e3cd86.mp3*~data=user_id=0,application_id=42~hmac=5b100d3450784f1e56507c15758ff19cd7318ba736fe701b428ee4adc15bc369",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/e8afa0ca97a60b87740bb36ad17c8591/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Don't Lose My Number",
    artist: "Phil Collins",
    id: 134036238,
    release_date: "1985-10-14",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/5/9/6/0/596da9e15791faa7521e975f9b213a8e.mp3?hdnea=exp=1763726034~acl=/api/1/1/5/9/6/0/596da9e15791faa7521e975f9b213a8e.mp3*~data=user_id=0,application_id=42~hmac=acca801542114731e72c162b182218ee312be395a2cd1e84e0e0e6181d99b1ea",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/73e6481676a8ab3e93f0f7b79a9cff68/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Invisible Touch",
    artist: "Genesis",
    id: 3145739,
    release_date: "1987-10-01",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/0fa14b7e1c7c350f389fc7fb1e53cd28/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "You're the Voice",
    artist: "John Farnham",
    id: 2221501,
    release_date: "1988-09-19",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/b/8/3/0/b837ee52967891e25e21fae57d76f68f.mp3?hdnea=exp=1763726034~acl=/api/1/1/b/8/3/0/b837ee52967891e25e21fae57d76f68f.mp3*~data=user_id=0,application_id=42~hmac=9a29b16faa47edc5e37863dd9081c3d62114614714f81b1c39e5b8e4999d4a4f",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/28ebbfbe9136e36c92560ef9243b16c9/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Juke Box Hero",
    artist: "Foreigner",
    id: 2814884,
    release_date: "1987-02-05",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/b/a/4/0/ba41cba5765b4690ff1bd7ac62842934.mp3?hdnea=exp=1763726034~acl=/api/1/1/b/a/4/0/ba41cba5765b4690ff1bd7ac62842934.mp3*~data=user_id=0,application_id=42~hmac=25374c0d301e1ed2dc8397289057b372f3c856c0c4afcaec225d08fd794cb621",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/a7545dbac40fbecabeafc4847bcba549/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "Karma Chameleon",
    artist: "Culture Club",
    id: 3090499,
    release_date: "1983-03-01",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/4/2/8/0/42837917bfea49d8671bb27cac41cf57.mp3?hdnea=exp=1763726034~acl=/api/1/1/4/2/8/0/42837917bfea49d8671bb27cac41cf57.mp3*~data=user_id=0,application_id=42~hmac=aadf552196275a366577e7908dd0dab6033e28bb0308d24d1d0bacf34a3b8790",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/3012d9bd9d57d1764e2549b2301777d7/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "When the Rain Begins to Fall",
    artist: "Jermaine Jackson",
    id: 4311056,
    release_date: "1989-10-28",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/2/b/d/0/2bd33e51001a7fb975af8b484c6fde85.mp3?hdnea=exp=1763726034~acl=/api/1/1/2/b/d/0/2bd33e51001a7fb975af8b484c6fde85.mp3*~data=user_id=0,application_id=42~hmac=f8b52bd5058bc8fd116f6291faac17fb4fbf6705f7ece0d9a26e1c8b97266163",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/b9bdf4f76c2b48ed528956a271f44818/250x250-000000-80-0-0.jpg",
    genre: "R&B",
  },
  {
    title: "Upside Down",
    artist: "Diana Ross",
    id: 906582,
    release_date: "1987-09-10",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/e/d/a/0/edac8da550e89eadf15ba179631d2ccf.mp3?hdnea=exp=1763726034~acl=/api/1/1/e/d/a/0/edac8da550e89eadf15ba179631d2ccf.mp3*~data=user_id=0,application_id=42~hmac=d5637ca175e030bc413d0f5325d2bb1fa42abf088d2f4473444c806df46a8329",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/dae9c863ba27686af441666135693de2/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "What A Feeling",
    artist: "Irene Cara",
    id: 1434081,
    release_date: "1983-02-21",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/2/1/2/0/2128364f3c452b0a72646c60d9c7e642.mp3?hdnea=exp=1763726034~acl=/api/1/1/2/1/2/0/2128364f3c452b0a72646c60d9c7e642.mp3*~data=user_id=0,application_id=42~hmac=dd837638dda16e6b505e2cd103a642b6b31426ac3b6c96be36eed29614a3760c",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/204672f30d473f7969e36f687ff6ee02/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Major Tom",
    artist: "Peter Schilling",
    id: 3605281,
    release_date: "1983-06-27",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/7/5/2/0/7527695e926b4c5bce65fc3be17141b4.mp3?hdnea=exp=1763726034~acl=/api/1/1/7/5/2/0/7527695e926b4c5bce65fc3be17141b4.mp3*~data=user_id=0,application_id=42~hmac=fa18bd370d599f9ab4e174116e3c0ba8f5a7bb6efda3b3c20e9d3951c1a9fb09",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/2d9e877767b4c31be9a7ac73979e8e2a/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Der Kommissar",
    artist: "Falco",
    id: 142334565,
    release_date: "1982-02-17",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/b/c/9/0/bc9c25d56f8260efc05a6803abc78259.mp3?hdnea=exp=1763726034~acl=/api/1/1/b/c/9/0/bc9c25d56f8260efc05a6803abc78259.mp3*~data=user_id=0,application_id=42~hmac=c4c81237e271448f012473252571fd9417324fd60fcdbf671e0d3dd3f9c7fd96",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/e8bfb068c2769c3e87bb90c0fa5a37d1/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "The Loco-Motion",
    artist: "Kylie Minogue",
    id: 137232280,
    release_date: "1985-01-21",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/f/7/b/0/f7bfe141f91583cd84eb1d7722c4a1d5.mp3?hdnea=exp=1763726034~acl=/api/1/1/f/7/b/0/f7bfe141f91583cd84eb1d7722c4a1d5.mp3*~data=user_id=0,application_id=42~hmac=84b6bca29c48f47937e801f19178ee011a5a067033811235ca675714a00f7845",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/0b2676ab5b25fab30c4e9a6d4294c839/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "I Gotta Feeling",
    artist: "The Black Eyed Peas",
    id: 4619466,
    release_date: "2009-06-23",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/ea30377840f4ef9ac62406c5e16e9c4b/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "What Is Love",
    artist: "Haddaway",
    id: 61590162,
    release_date: "1997-08-02",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/9f52e7fe0c253a6586800dc85fd93458/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Live Is Life",
    artist: "Opus",
    id: 6973073,
    release_date: "1985-01-21",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/decd1e28e78e8346bf6340504ad7e7e6/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Brother Louie",
    artist: "Modern Talking",
    id: 548510,
    release_date: "1986-12-18",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/f5ab7814eda8bdbab33e9bb6941655f3/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "You're My Heart, You're My Soul",
    artist: "Modern Talking",
    id: 985538,
    release_date: "1984-04-28",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/826af42c59b6a9f6ced4777bbdaf89fe/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Cheri Cheri Lady",
    artist: "Modern Talking",
    id: 74249000,
    release_date: "1985-09-02",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/e087110af2549642da54098a5c14b7ab/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Sing Hallelujah!",
    artist: "Dr. Alban",
    id: 1059093,
    release_date: "1997-06-15",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/741671be29de2ec19538224869e51eb5/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "The Ketchup Song",
    artist: "Las Ketchup",
    id: 476739472,
    release_date: "2003-04-13",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/be45674dc35c8f974a934dc3779c7b59/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Where Do You Go",
    artist: "No Mercy",
    id: 4096755,
    release_date: "1996-08-27",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/02f880e927fe2d0ea5c5c234ef0bd050/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Daddy Cool",
    artist: "Boney M.",
    id: 532070,
    release_date: "1976-09-27",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/675e0e5a4ae84e6457d513e205fc5a4a/250x250-000000-80-0-0.jpg",
    genre: "R&B",
  },
  {
    title: "Ma Baker",
    artist: "Boney M.",
    id: 1049893,
    release_date: "1977-03-14",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/5b95e4fc13571a55f02478665f3e2ec9/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Gimme! Gimme! Gimme! (A Man After Midnight)",
    artist: "ABBA",
    id: 884041,
    release_date: "1978-06-02",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/b8b70d474b7a8f27799e0d665e9b737e/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Video Killed The Radio Star",
    artist: "The Buggles",
    id: 4255660,
    release_date: "1989-09-21",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/3f436d427e93542fc52cd077215ae95a/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "La Isla Bonita",
    artist: "Madonna",
    id: 678372,
    release_date: "1986-06-11",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/43a8e2b1b035391f58b0927cf1040bc4/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Voyage voyage",
    artist: "Desireless",
    id: 4298172,
    release_date: "1987-12-13",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/3fcbfc72be5ad78fa6277eb5dc5df8d3/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Big in Japan",
    artist: "Alphaville",
    id: 756850192,
    release_date: "1984-01-12",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/4045858b4e63ddeb52d89f3705354673/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Hips Don't Lie",
    artist: "Shakira",
    id: 75859436,
    release_date: "2007-11-13",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/edae3ceaf89afa1159c999fbafc6c836/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Bailando",
    artist: "Loona",
    id: 1102129952,
    release_date: "2014-10-11",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/a882f510354221bce39fde00397f0c29/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Haus am See",
    artist: "Peter Fox",
    id: 2200206,
    release_date: "2008-09-26",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/67fe414d2cf5cceab6429147fa37f6bd/250x250-000000-80-0-0.jpg",
    genre: "Rap/Hip Hop",
  },
  {
    title: "Alles neu",
    artist: "Peter Fox",
    id: 2200204,
    release_date: "2008-09-26",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/67fe414d2cf5cceab6429147fa37f6bd/250x250-000000-80-0-0.jpg",
    genre: "Rap/Hip Hop",
  },
  {
    title: "In the Year 2525",
    artist: "Zager & Evans",
    id: 392461892,
    release_date: "1969-07-01",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/0f094284f1086d3202a49537c3e7caa1/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "Skandal im Sperrbezirk",
    artist: "Spider Murphy Gang",
    id: 3123329,
    release_date: "1981-12-23",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/ba80f264e3b7c2426e409399d3c22f84/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "I've Been Thinking About You",
    artist: "Londonbeat",
    id: 1056486,
    release_date: "1995-11-20",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/619122ac7d43050d8e2e65b4d8fd7e03/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Go West",
    artist: "Pet Shop Boys",
    id: 3147740,
    release_date: "1996-09-18",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/dfc1edc4b84659467b3b2bd556de7fc7/250x250-000000-80-0-0.jpg",
    genre: "Dance",
  },
  {
    title: "Joyride",
    artist: "Roxette",
    id: 15710900,
    release_date: "1991-03-24",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/e8c62bc59111088c3464be95fd286399/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Sleeping in My Car",
    artist: "Roxette",
    id: 3092174,
    release_date: "1993-03-24",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/795b45e8a76e80ef4c342b00f9d37845/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Waterloo",
    artist: "ABBA",
    id: 884046,
    release_date: "1974-03-04",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/b8b70d474b7a8f27799e0d665e9b737e/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Kung Fu Fighting",
    artist: "Carl Douglas",
    id: 131285694,
    release_date: "1978-04-29",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/419a1541716064e3952cc9b38f47a54b/250x250-000000-80-0-0.jpg",
    genre: "R&B",
  },
  {
    title: "Back To Black",
    artist: "Amy Winehouse",
    id: 2176856,
    release_date: "2006-10-30",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/8/c/5/0/8c51a0c8941f72ee783a7b2798cff8c8.mp3?hdnea=exp=1763730741~acl=/api/1/1/8/c/5/0/8c51a0c8941f72ee783a7b2798cff8c8.mp3*~data=user_id=0,application_id=42~hmac=f60a3d3052f2ff27f80a7830d0b01a96807ec8877023da816f37c1f83447ac13",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/3ce985e6653c350c6e6fed077ab7d0d4/250x250-000000-80-0-0.jpg",
    genre: "R&B",
  },
  {
    title: "Rehab",
    artist: "Amy Winehouse",
    id: 2176852,
    release_date: "2006-10-30",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/2/1/d/0/21dd455c62dd8ecfbb94a879455fce82.mp3?hdnea=exp=1763730741~acl=/api/1/1/2/1/d/0/21dd455c62dd8ecfbb94a879455fce82.mp3*~data=user_id=0,application_id=42~hmac=3e7e50bef40f6b0a041126090c130e8ce3dea28801cd0dce4ad9e4b43e1c96cb",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/3ce985e6653c350c6e6fed077ab7d0d4/250x250-000000-80-0-0.jpg",
    genre: "R&B",
  },
  {
    title: "Family Affair",
    artist: "Mary J. Blige",
    id: 1161679,
    release_date: "2006-12-14",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/e/a/7/0/ea74dbeba11d7b55877202a62502aa3e.mp3?hdnea=exp=1763730741~acl=/api/1/1/e/a/7/0/ea74dbeba11d7b55877202a62502aa3e.mp3*~data=user_id=0,application_id=42~hmac=11e21ef572de16f0b05d9b49489f9ab1912b644115e7bbad9db78e6bd0e7787b",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/a3939a5b62df412e83d898dfd85035c9/250x250-000000-80-0-0.jpg",
    genre: "R&B",
  },
  {
    title: "Fallin'",
    artist: "Alicia Keys",
    id: 959183,
    release_date: "2001-06-05",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/e/4/0/0/e40810e3b71429a89bdf2633a6255620.mp3?hdnea=exp=1763730741~acl=/api/1/1/e/4/0/0/e40810e3b71429a89bdf2633a6255620.mp3*~data=user_id=0,application_id=42~hmac=d03fefcf8492abe5d74991b596a402833db300049e1c1a426fd772ca9760edd3",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/d83318951e3899a096ed96c6fd422032/250x250-000000-80-0-0.jpg",
    genre: "R&B",
  },
  {
    title: "Umbrella",
    artist: "Rihanna",
    id: 925106,
    release_date: "2007-06-17",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/c/6/2/0/c62231a4abced1c3e3ba03b5effb9aa9.mp3?hdnea=exp=1763730741~acl=/api/1/1/c/6/2/0/c62231a4abced1c3e3ba03b5effb9aa9.mp3*~data=user_id=0,application_id=42~hmac=1d460bda88dafffc198a33ed33e4d62e439ec506faef97b5611ed0c10d37b169",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/91276466fbc876d96be9e6926060af60/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Boat On The River",
    artist: "Styx",
    id: 61286644,
    release_date: "1979-04-08",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/3/e/3/0/3e3f75877793a94405f3980c4ecee9b9.mp3?hdnea=exp=1763730741~acl=/api/1/1/3/e/3/0/3e3f75877793a94405f3980c4ecee9b9.mp3*~data=user_id=0,application_id=42~hmac=88ba0418a4cc2f05fb87c6f728b6a1d48192554c15eeee028ee4b3aa87515f4b",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/87bef520784bf1c12a498ef45570f2b4/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "Don't Let Me Be Misunderstood",
    artist: "Santa Esmeralda",
    id: 3083376,
    release_date: "2003-09-23",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/6165b7abb2f52d4f758dd4542dcc4dcb/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Walking on Broken Glass",
    artist: "Annie Lennox",
    id: 1048702,
    release_date: "1992-04-02",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/b/b/5/0/bb5f783931fd77d86c0f939ae9e9ac6b.mp3?hdnea=exp=1763730741~acl=/api/1/1/b/b/5/0/bb5f783931fd77d86c0f939ae9e9ac6b.mp3*~data=user_id=0,application_id=42~hmac=70be85a086687418e032d408e1e394bd0b35a97fb0880e6e8cdb7429bf2f123e",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/137bb5655a30cd9cff6e3cb56001ed7a/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Have I Told You Lately",
    artist: "Rod Stewart",
    id: 2550674,
    release_date: "1988-11-17",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/5/1/4/0/514fee70f75785c39b200d8bd0dce037.mp3?hdnea=exp=1763730741~acl=/api/1/1/5/1/4/0/514fee70f75785c39b200d8bd0dce037.mp3*~data=user_id=0,application_id=42~hmac=74e62bb0e838e6e9f877605c840807163a6396af4731a85530b4733c2d6f454f",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/bc17008ae06cccd392a2312c8f30bc9c/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Rhythm of My Heart",
    artist: "Rod Stewart",
    id: 3605543,
    release_date: "1988-11-17",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/e/c/5/0/ec5ba1c9bb91d346d85c92e5689cddca.mp3?hdnea=exp=1763730741~acl=/api/1/1/e/c/5/0/ec5ba1c9bb91d346d85c92e5689cddca.mp3*~data=user_id=0,application_id=42~hmac=904e87c819f43d7881e7c0b6b653bbb0d10aab5fb628d4becc6380820d19dadb",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/bc17008ae06cccd392a2312c8f30bc9c/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Rhythm Divine",
    artist: "Enrique Iglesias",
    id: 2604912,
    release_date: "1999-11-09",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/3/8/e/0/38e4e47b8eb5959ebc8ed18f6cee417b.mp3?hdnea=exp=1763730741~acl=/api/1/1/3/8/e/0/38e4e47b8eb5959ebc8ed18f6cee417b.mp3*~data=user_id=0,application_id=42~hmac=a11c02d059e45d46c1cdbe87aaa186e674034371625cb32cab64f76913f3a31f",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/d5909ac32e17d6f7c12cc1443aa88428/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Absolutely Everybody",
    artist: "Vanessa Amorosi",
    id: 111314264,
    release_date: "2000-10-20",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/f/6/6/0/f66c2d6e03ed20c8093b17d0093187b7.mp3?hdnea=exp=1763730741~acl=/api/1/1/f/6/6/0/f66c2d6e03ed20c8093b17d0093187b7.mp3*~data=user_id=0,application_id=42~hmac=201296f48488a313c945d178912909073223e0c8111b4874cd5bfd24a4366181",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/ca6de5b0bed98fc49eac7b6760bb2fdb/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Jesus He Knows Me",
    artist: "Genesis",
    id: 3129672,
    release_date: "1984-04-01",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/bfb419853af09096dadd54d7c84d955d/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "Frozen",
    artist: "Madonna",
    id: 4209669,
    release_date: "2009-09-18",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/f/e/f/0/fef9dacbc03f358e4b6801cfc461bf58.mp3?hdnea=exp=1763730741~acl=/api/1/1/f/e/f/0/fef9dacbc03f358e4b6801cfc461bf58.mp3*~data=user_id=0,application_id=42~hmac=19df8d4a8470426ac7899583ed0b875c08da54c6d75ea6f7e2d68ba901f7af49",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/195d3d2c1196b20711cfb6ad76e1c2ba/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "MfG",
    artist: "Die Fantastischen Vier",
    id: 111844700,
    release_date: "1999-11-06",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/9/b/f/0/9bf723ba9039d7df4c1597cd050625f6.mp3?hdnea=exp=1763730741~acl=/api/1/1/9/b/f/0/9bf723ba9039d7df4c1597cd050625f6.mp3*~data=user_id=0,application_id=42~hmac=4d01d0aa2dbf5b5d1d7b8a9a7d6ea1433cd4d28e11c10f8912e845e36cf52d6c",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/1f2be3ef09864973a64c60693c0f9f14/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "November Rain",
    artist: "Guns N' Roses",
    id: 1169683,
    release_date: "1991-09-18",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/9/1/6/0/916752bf818dfdb5374c5ae5614ccda7.mp3?hdnea=exp=1763730741~acl=/api/1/1/9/1/6/0/916752bf818dfdb5374c5ae5614ccda7.mp3*~data=user_id=0,application_id=42~hmac=ebd225af18568768c007c8fe978aac300d674afa9273be63446b184d42c53656",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/546fe1eca5d3bf48c6a48fb3c0ddac63/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "All You Zombies",
    artist: "The Hooters",
    id: 5817104,
    release_date: "1985-06-01",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/2/c/2/0/2c2248802ac1b186c2bf3e1c742b0123.mp3?hdnea=exp=1763730741~acl=/api/1/1/2/c/2/0/2c2248802ac1b186c2bf3e1c742b0123.mp3*~data=user_id=0,application_id=42~hmac=7b248c5d90ced63cea3f4a9e6065f34b7584c78ee237015cb9c1cb2d1438a824",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/35fe2c643d2f00ecf78cf16def7eae99/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "Shadow On The Wall",
    artist: "Mike Oldfield",
    id: 3978858,
    release_date: "1989-06-08",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/8/0/c/0/80c28d15452b7b050e857d2ef40c8d52.mp3?hdnea=exp=1763730741~acl=/api/1/1/8/0/c/0/80c28d15452b7b050e857d2ef40c8d52.mp3*~data=user_id=0,application_id=42~hmac=69986d52a87ae124662d95c5950d00e667ab0ff297b8f9a2356437b4c6ef591a",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/2b3e7d77cf4454c3de4aad41fa9abdb4/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "Egoist",
    artist: "Falco",
    id: 3458985,
    release_date: "2003-03-03",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/c/6/0/0/c60b80094a3cb19c519658c8e5cedce4.mp3?hdnea=exp=1763730741~acl=/api/1/1/c/6/0/0/c60b80094a3cb19c519658c8e5cedce4.mp3*~data=user_id=0,application_id=42~hmac=42bb3cef4ba38e208c6a52b6ccb0fc9110836a1cb3a9d3c7d4ef5393a665d837",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/2aa6b348a02b22ba0c981712af14f485/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Just Another Day",
    artist: "Jon Secada",
    id: 3359659,
    release_date: "1992-03-24",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/5/d/3/0/5d346ac388651ce88a6f7f3c43bd0a5a.mp3?hdnea=exp=1763730741~acl=/api/1/1/5/d/3/0/5d346ac388651ce88a6f7f3c43bd0a5a.mp3*~data=user_id=0,application_id=42~hmac=0703275874a4c79a372dc42294f52f6e624f0c5aa2c9cea07c47177864fccf6d",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/a6f22e152a4a4f2c659b57b4b3789ce5/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "I Was Born To Love You",
    artist: "Queen",
    id: 13499093,
    release_date: "1995-09-05",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/1/4/c/0/14c3e5023974c028473fcb96601a5380.mp3?hdnea=exp=1763730741~acl=/api/1/1/1/4/c/0/14c3e5023974c028473fcb96601a5380.mp3*~data=user_id=0,application_id=42~hmac=3ec0a0b98c5090a6dcfd084aa240eee45783fc773a7afa9943285e98f562b822",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/20adfb09ef5afd27ddcdd830780efcf1/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "Enjoy the Silence",
    artist: "Depeche Mode",
    id: 68515055,
    release_date: "1990-09-28",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/6/b/c/0/6bc8eee9f93fb96544848258798033ea.mp3?hdnea=exp=1763730741~acl=/api/1/1/6/b/c/0/6bc8eee9f93fb96544848258798033ea.mp3*~data=user_id=0,application_id=42~hmac=ffdb2e1a50c9efac1b744fbb81bf1d7e559cbfbb48b5ff9ed30df357dd1d161b",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/e73716d037ee24f1331a8c0332526590/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Keep The Faith",
    artist: "Bon Jovi",
    id: 74628107,
    release_date: "1997-04-05",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/b/d/f/0/bdfd1c987e9416344bf81fee30fcb530.mp3?hdnea=exp=1763730741~acl=/api/1/1/b/d/f/0/bdfd1c987e9416344bf81fee30fcb530.mp3*~data=user_id=0,application_id=42~hmac=d4a9173019d1f52ec8bf7ff5da0edfb8ece5bbfefb23b0ee4e4f6a6d3c1c2e27",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/4a2821c5cfa61955ddd982c15cc21882/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "Everytime We Touch",
    artist: "Maggie Reilly",
    id: 665239482,
    release_date: "1992-05-10",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/7/5/e/0/75e7b8cc88b36cb0c8ba8b136e2b8595.mp3?hdnea=exp=1763730741~acl=/api/1/1/7/5/e/0/75e7b8cc88b36cb0c8ba8b136e2b8595.mp3*~data=user_id=0,application_id=42~hmac=e1e571755d015e57c53049b895f78eb9fec1447a1ebf936ede08a1ee4addc606",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/b088365895312b9e384ca187f10ae6f9/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Out Of The Dark",
    artist: "Falco",
    id: 13569299,
    release_date: "1998-09-09",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/2/6/5/0/26560af4c8fffc619d048c63a05bd633.mp3?hdnea=exp=1763730741~acl=/api/1/1/2/6/5/0/26560af4c8fffc619d048c63a05bd633.mp3*~data=user_id=0,application_id=42~hmac=0c332dec0a9c639918aa8d255993845904f824e6967ea4c67e4fcf97afbe31b9",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/0ce857515b6285c7d08d4d264a52fc5e/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "Maria",
    artist: "Blondie",
    id: 3151637,
    release_date: "2002-09-19",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/e/d/e/0/ede7822388d1db31c3a08dd214f35997.mp3?hdnea=exp=1763730741~acl=/api/1/1/e/d/e/0/ede7822388d1db31c3a08dd214f35997.mp3*~data=user_id=0,application_id=42~hmac=df1d258089fb38655b5b73324e04399e8ceb60ceb82fe0be1fa1caf2698eeff9",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/dc16bfe0516e13b247098f9fcea35acf/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "Larger Than Life",
    artist: "Backstreet Boys",
    id: 13141169,
    release_date: "1999-05-18",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/8/f/1/0/8f1b41780b0d23226b536ca3cc5bea25.mp3?hdnea=exp=1763730741~acl=/api/1/1/8/f/1/0/8f1b41780b0d23226b536ca3cc5bea25.mp3*~data=user_id=0,application_id=42~hmac=5216529a9e8af83be48cad85a11f53a45a7e83c18047ce219e8f56f88972b5a5",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/d61eaad8f321ea876a5f5c7219aae892/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "You'll Be In My Heart",
    artist: "Phil Collins",
    id: 561875132,
    release_date: "1988-10-05",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/2/1/3/0/2139586678b734d02d63ef1694720648.mp3?hdnea=exp=1763730741~acl=/api/1/1/2/1/3/0/2139586678b734d02d63ef1694720648.mp3*~data=user_id=0,application_id=42~hmac=56faedcbb6ea64e68e4032f70587638a829dff67cebdaa58dfff6357a8e2c3dd",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/6f48385948df5ed9a8e00c647a87e3a9/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Breakfast At Tiffany's",
    artist: "Deep Blue Something",
    id: 2315711,
    release_date: "1993-07-19",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/4/a/1/0/4a1f67bcfa251655d3c1d1d466db4715.mp3?hdnea=exp=1763730741~acl=/api/1/1/4/a/1/0/4a1f67bcfa251655d3c1d1d466db4715.mp3*~data=user_id=0,application_id=42~hmac=0cb48bd251f3ce804aa77f495abcc0e5608df5252a370b00fc86aeee6fbcdc71",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/f27d35f211f3e2975176f41bd8ac079b/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Baby, I Love Your Way",
    artist: "Big Mountain",
    id: 846215,
    release_date: "1994-07-19",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/5/d/9/0/5d983fdcf24bf19a5786903df2701907.mp3?hdnea=exp=1763730741~acl=/api/1/1/5/d/9/0/5d983fdcf24bf19a5786903df2701907.mp3*~data=user_id=0,application_id=42~hmac=a626b81c1b6cc33fee0e7ac0615b08e3884168ff228d554b6a26c3fb1398d196",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/bd1a6798645fb5cc63fd866668e8faa1/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Kiss Me",
    artist: "Sixpence None The Richer",
    id: 134116940,
    release_date: "1998-01-20",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/e/3/4/0/e34e7cc5b8cbd7d9e60aa18292d53e80.mp3?hdnea=exp=1763730741~acl=/api/1/1/e/3/4/0/e34e7cc5b8cbd7d9e60aa18292d53e80.mp3*~data=user_id=0,application_id=42~hmac=047327668a2258c086f77d671ef105ff41e7cab1f0b3ec7eeb5b1fbc806bd794",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/c37356b5ada5f3a79689653f7a6f5067/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Chiquitita",
    artist: "ABBA",
    id: 884038,
    release_date: "1978-06-02",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/0/1/a/0/01a4d08eef3d410a80f8f9c2842db05e.mp3?hdnea=exp=1763730741~acl=/api/1/1/0/1/a/0/01a4d08eef3d410a80f8f9c2842db05e.mp3*~data=user_id=0,application_id=42~hmac=e35d6769565c231e44b3c1127434f34a02b5300b5da61e2165331ad06d9cec30",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/b8b70d474b7a8f27799e0d665e9b737e/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Red Blooded Woman",
    artist: "Kylie Minogue",
    id: 6588267,
    release_date: "2003-10-27",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/8/8/d/0/88d8ae75c5921b0900e06f6a875f987c.mp3?hdnea=exp=1763730741~acl=/api/1/1/8/8/d/0/88d8ae75c5921b0900e06f6a875f987c.mp3*~data=user_id=0,application_id=42~hmac=14d01d2d00c7bc71ae4fb3e15a594d9ac8d01821e5fe6a1c9fa121a5467e09fe",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/49f20e9e74c0b91060792c889f8d219c/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "Ka-Ching!",
    artist: "Shania Twain",
    id: 2543341,
    release_date: "2002-11-19",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/9/8/e/0/98ed5ecd401801c85f1bab702c05120f.mp3?hdnea=exp=1763730742~acl=/api/1/1/9/8/e/0/98ed5ecd401801c85f1bab702c05120f.mp3*~data=user_id=0,application_id=42~hmac=15094c61744b5b215689acd76d4dde4d4f3c72b147c02d9758b99a95b5fdc618",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/86db043638625fc894a2b0d2e09c21f9/250x250-000000-80-0-0.jpg",
    genre: "Country",
  },
  {
    title: "La Bamba",
    artist: "Los Lobos",
    id: 3819736,
    release_date: "1986-07-10",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/f/9/9/0/f99fe7582d1c44dd2c3be0794fa81eaf.mp3?hdnea=exp=1763730742~acl=/api/1/1/f/9/9/0/f99fe7582d1c44dd2c3be0794fa81eaf.mp3*~data=user_id=0,application_id=42~hmac=28add8e096f74cfa485b5a11059dcc729bc4d4e8c9ea13e8161afc41401d0f62",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/d0e784e5cfd9717676fc9837b88921cc/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "Holding Out for a Hero",
    artist: "Bonnie Tyler",
    id: 82299358,
    release_date: "1988-08-26",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/7/a/c/0/7ac51221d6317b79f9279621e19ef66c.mp3?hdnea=exp=1763730742~acl=/api/1/1/7/a/c/0/7ac51221d6317b79f9279621e19ef66c.mp3*~data=user_id=0,application_id=42~hmac=b433e80fe486cc1b34bebf3273bb484c85e070a872fd6147ba26e2ac7ac9c558",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/0768a04e291fee32f7b474e18796ac37/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "All Good Things (Come To An End)",
    artist: "Nelly Furtado",
    id: 1151152,
    release_date: "2007-03-08",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/c/5/6/0/c569e67365186236d0341b8a7dcb2afa.mp3?hdnea=exp=1763730742~acl=/api/1/1/c/5/6/0/c569e67365186236d0341b8a7dcb2afa.mp3*~data=user_id=0,application_id=42~hmac=96cf5adb35840d6d005e9f81e6168cc8ec69d981eb5e32cb3988505522668715",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/1d3625d9f19527440769e7f8cc09db85/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "I Should Be So Lucky",
    artist: "Kylie Minogue",
    id: 137232330,
    release_date: "1987-08-24",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/0/9/3/0/09364da5fb33293acb1d390c8bced116.mp3?hdnea=exp=1763730742~acl=/api/1/1/0/9/3/0/09364da5fb33293acb1d390c8bced116.mp3*~data=user_id=0,application_id=42~hmac=12047d822ad548677b0700678402c83b21536c229d6d02f574a29a31b54041bd",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/a4329d5d528ceda7b2e9c73080b69557/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "She Works Hard For The Money",
    artist: "Donna Summer",
    id: 34180931,
    release_date: "1983-05-14",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/4/8/5/0/485f5bb09204c04bca4248e72a0691f4.mp3?hdnea=exp=1763730742~acl=/api/1/1/4/8/5/0/485f5bb09204c04bca4248e72a0691f4.mp3*~data=user_id=0,application_id=42~hmac=7ddc2ae3a7a9f0704f7680e3eb36574180986c157728547e49002d02bbeee3bc",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/85494b32954ac1611bbdc51e991f6356/250x250-000000-80-0-0.jpg",
    genre: "R&B",
  },
  {
    title: "We're Not Gonna Take It",
    artist: "Twisted Sister",
    id: 3906972,
    release_date: "1984-08-27",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/3d821765fe1cc4078cddcc23c46c8f72/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "Midnight Blue",
    artist: "Lou Gramm",
    id: 5611979,
    release_date: "1987-03-03",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/b/9/6/0/b9668a0e63fdd16e5e1f27cbfd46bebd.mp3?hdnea=exp=1763730742~acl=/api/1/1/b/9/6/0/b9668a0e63fdd16e5e1f27cbfd46bebd.mp3*~data=user_id=0,application_id=42~hmac=d3f9a5e78563e709e1650eed95f8bfe6069c2166c8498948a799054876da4b08",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/eaafbf81ad6f979b765ae2721bd48486/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "Midnight Lady",
    artist: "Chris Norman",
    id: 61509261,
    release_date: "1986-05-17",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/1/5/6/0/156c9c52f63313e5e0bd3ef403c7c9b8.mp3?hdnea=exp=1763730742~acl=/api/1/1/1/5/6/0/156c9c52f63313e5e0bd3ef403c7c9b8.mp3*~data=user_id=0,application_id=42~hmac=63368e770be101052cd23145c9726956e1982f57f1c9cdb1f4bcf4f12d100e95",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/0ec87c06a02598f11b3884417cfdceb6/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Whenever, Wherever",
    artist: "Shakira",
    id: 15211178,
    release_date: "2001-08-27",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/8/9/a/0/89aafd76a99c7f4ae707c999968ae8d5.mp3?hdnea=exp=1763730742~acl=/api/1/1/8/9/a/0/89aafd76a99c7f4ae707c999968ae8d5.mp3*~data=user_id=0,application_id=42~hmac=95d3fb75fff1d3e0ed2bd7f13fe71c38f3253dc5df9e38dad067fb5bd3defd60",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/3c50690401eed099df05e72f5080af1b/250x250-000000-80-0-0.jpg",
    genre: "Latin Music",
  },
  {
    title: "Alejandro",
    artist: "Lady Gaga",
    id: 4709938,
    release_date: "2009-11-23",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/9/7/2/0/9723bd43efc4629ba5183c33eefbbdc2.mp3?hdnea=exp=1763730742~acl=/api/1/1/9/7/2/0/9723bd43efc4629ba5183c33eefbbdc2.mp3*~data=user_id=0,application_id=42~hmac=34d7dee6b4285e8030b30385541cc01e19cc2001ec826f1031a0be0c4c99687a",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/62f368993ddb68c5364cd03221d07ac6/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Can't Fight The Moonlight",
    artist: "LeAnn Rimes",
    id: 75779409,
    release_date: "2001-01-30",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/4/b/4/0/4b44950cbfd23bdbef369b194881af4b.mp3?hdnea=exp=1763730742~acl=/api/1/1/4/b/4/0/4b44950cbfd23bdbef369b194881af4b.mp3*~data=user_id=0,application_id=42~hmac=6848a0e867590d8d67d0be5a5e065c6a0c111cb5004afce6b9d66c928246e208",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/7b6725e19d0c57ba87d2e9a00ee7be5b/250x250-000000-80-0-0.jpg",
    genre: "Country",
  },
  {
    title: "Californication",
    artist: "Red Hot Chili Peppers",
    id: 725274,
    release_date: "1999-06-07",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/2/c/7/0/2c7c12953e487de2983fc0d361992604.mp3?hdnea=exp=1763730742~acl=/api/1/1/2/c/7/0/2c7c12953e487de2983fc0d361992604.mp3*~data=user_id=0,application_id=42~hmac=e9384caa1b1b1560d58599b1a3d49d93aca4dd0b51be1cc63b53d2f0dcd5ab72",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/5e61e8290a4d1d64ca58920656c9602d/250x250-000000-80-0-0.jpg",
    genre: "Alternative",
  },
  {
    title: "Love Don't Cost a Thing",
    artist: "Jennifer Lopez",
    id: 618317,
    release_date: "2003-09-15",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/7/4/a/0/74af6572794fcee7781ec3028b959642.mp3?hdnea=exp=1763730742~acl=/api/1/1/7/4/a/0/74af6572794fcee7781ec3028b959642.mp3*~data=user_id=0,application_id=42~hmac=4e5103ec5841053927e8ca754b8e9558aa5868a8795b7ff26c725f966885b555",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/c6385c391e17a1c16beccb7ef7da976f/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Oops!...I Did It Again",
    artist: "Britney Spears",
    id: 582254,
    release_date: "2000-03-27",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/6/8/9/0/689e2a07e2e65855e34efabc39847563.mp3?hdnea=exp=1763730742~acl=/api/1/1/6/8/9/0/689e2a07e2e65855e34efabc39847563.mp3*~data=user_id=0,application_id=42~hmac=d6a957c5bace86fd1b2cd8b3f70ba987a82e69cfdc8149142101ed353d3f0b16",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/34265ac018fe0d973eac131fe04038a2/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Bye Bye Bye",
    artist: "*NSYNC",
    id: 632447,
    release_date: "2000-03-21",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/c/b/6/0/cb6e0cf5675a2b309947c4e8a16352c6.mp3?hdnea=exp=1763730742~acl=/api/1/1/c/b/6/0/cb6e0cf5675a2b309947c4e8a16352c6.mp3*~data=user_id=0,application_id=42~hmac=3d824823c850e738a54fab0c097416de0837b100b47a6f53faff418e1845a904",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/01fdca2ecf54d678ff005162b5b6cc92/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Eternal Flame",
    artist: "The Bangles",
    id: 3037340,
    release_date: "1989-04-30",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/a/3/b/0/a3bb36690e6b4b2a85010ea632ba73ec.mp3?hdnea=exp=1763730742~acl=/api/1/1/a/3/b/0/a3bb36690e6b4b2a85010ea632ba73ec.mp3*~data=user_id=0,application_id=42~hmac=630f53a2a77d181b6e2d79e5bfabebadfea7806058e7e7f1d73dba1c747b945d",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/160a720272bfeac612989f32ae101c0d/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Poison",
    artist: "Alice Cooper",
    id: 626178,
    release_date: "2006-03-07",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/0/6/0/0/060465cc9c32f30c1e3ff4cff7086c2e.mp3?hdnea=exp=1763730742~acl=/api/1/1/0/6/0/0/060465cc9c32f30c1e3ff4cff7086c2e.mp3*~data=user_id=0,application_id=42~hmac=20760d3a481bb007462f10bb96734e790ba7b7b80274b4d5537c0fd4bd506792",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/3640fee637a166da4ccc65246467b560/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "Bed of Nails",
    artist: "Alice Cooper",
    id: 468471872,
    release_date: "1989-03-16",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/2d4638ee8af1ba13ff7ad9c456ca076c/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "Here I Go Again",
    artist: "Whitesnake",
    id: 576902402,
    release_date: "1982-10-06",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/84a375b90c2751bb7b4e6effb4d7e2d1/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "Hey (Nah Neh Nah)",
    artist: "Vaya Con Dios",
    id: 58667011,
    release_date: "1990-09-27",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/ea6c274ad45ba5835111eb2e5d8b148e/250x250-000000-80-0-0.jpg",
    genre: "Dance",
  },
  {
    title: "You Keep Me Hangin On",
    artist: "Kim Wilde",
    id: 74640929,
    release_date: "1986-09-23",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/34145a9345aa92437fae5db912e7218f/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Tell It to My Heart",
    artist: "Taylor Dayne",
    id: 444738122,
    release_date: "1988-01-19",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/130089f12fa9ceaba703a12043b44860/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "It's a Sin",
    artist: "Pet Shop Boys",
    id: 3122973,
    release_date: "1987-11-04",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/5453ca81ae47f016b0aa7b55729da928/250x250-000000-80-0-0.jpg",
    genre: "Dance",
  },
  {
    title: "Le Freak",
    artist: "Chic",
    id: 67359668,
    release_date: "1973-05-20",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/8a5b56f3b2533c5748cf985447def437/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Superstar",
    artist: "Jamelia",
    id: 463394462,
    release_date: "2003-06-30",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/aaa7a43bfa31f931f46895a6650b0c50/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Down Under",
    artist: "Men At Work",
    id: 1030221,
    release_date: "1981-02-01",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/968a09e7739dfeee3448a1a79555504a/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "Tearin' up My Heart",
    artist: "*NSYNC",
    id: 15477160,
    release_date: "1997-05-26",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/6a4958616c62ba71889a075ce84db82a/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "September",
    artist: "Earth, Wind & Fire",
    id: 487484142,
    release_date: "2007-03-08",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/18f41ecd3781fb96bffa2b0b49955db5/250x250-000000-80-0-0.jpg",
    genre: "R&B",
  },
  {
    title: "Lay All Your Love On Me",
    artist: "ABBA",
    id: 76376863,
    release_date: "1974-04-07",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/0e28b2ad6ec55276c66dae8297c686c6/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Sweat",
    artist: "Snoop Dogg",
    id: 10162588,
    release_date: "2011-03-04",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/f81151ad27acdf3d3139e9c3dbf875ff/250x250-000000-80-0-0.jpg",
    genre: "Rap/Hip Hop",
  },
  {
    title: "The River of Dreams",
    artist: "Billy Joel",
    id: 548676,
    release_date: "1993-04-03",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/4586382c3e3c536105b138f5a9ff7443/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "How Will I Know",
    artist: "Whitney Houston",
    id: 1131192,
    release_date: "1985-02-14",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/e5712b346f0ca0f167da8ffd7588db3f/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Alive And Kicking",
    artist: "Simple Minds",
    id: 58831541,
    release_date: "1985-09-24",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/b2f8d7c1463685f5c3c7c4d78c4c5e2d/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Voulez-Vous",
    artist: "ABBA",
    id: 884040,
    release_date: "1978-04-23",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/b8b70d474b7a8f27799e0d665e9b737e/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Rebel Yell",
    artist: "Billy Idol",
    id: 3140135,
    release_date: "1988-06-23",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/cdff56843117adeb102f5c9f490295ec/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "Rain In May",
    artist: "Max Werner",
    id: 96538266,
    release_date: "1981-03-30",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/61b69b3b041385b3da54881e5a5c4e03/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Goldener Reiter",
    artist: "Joachim Witt",
    id: 700835,
    release_date: "1998-10-26",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/5631571f81b8fbd5d318bf22051fdf87/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Such a Shame",
    artist: "Talk Talk",
    id: 3257061,
    release_date: "1982-06-26",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/18298b61298f0355c69a8038829287a9/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "Shut Up",
    artist: "The Black Eyed Peas",
    id: 953676,
    release_date: "2003-07-31",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/6efe94615f21a80c1ad670741e86e482/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Jenny from the Block",
    artist: "Jennifer Lopez",
    id: 628099,
    release_date: "2002-11-11",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/f60d5198e5a3deb22b3312bafb6d314c/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "The Riddle",
    artist: "Nik Kershaw",
    id: 1174772,
    release_date: "1984-11-24",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/ce29a69eecc2c08d2b772bf0c5cca02f/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Johnny B.",
    artist: "The Hooters",
    id: 1081050,
    release_date: "1987-07-19",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/ed86407d9712c21e5177390822daf4b3/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "The One and Only",
    artist: "Chesney Hawkes",
    id: 130195442,
    release_date: "1991-04-13",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/233b1e9651543a6fceaa9fc2f10087a1/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Carrie",
    artist: "Europe",
    id: 858447,
    release_date: "1988-09-16",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/2971537322dde7f40381a8586c08cd8e/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "Wind Of Change",
    artist: "Scorpions",
    id: 927900,
    release_date: "1991-01-07",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/5d1724dd3ac61f2e1df593c543ce2b22/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "Money, Money, Money",
    artist: "ABBA",
    id: 884036,
    release_date: "1978-06-02",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/b8b70d474b7a8f27799e0d665e9b737e/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Born This Way",
    artist: "Lady Gaga",
    id: 11747931,
    release_date: "2014-12-18",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/0f256c4bebac58a7c4122e0e639303a8/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Dance into the Light",
    artist: "Phil Collins",
    id: 134036268,
    release_date: "1986-10-14",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/73e6481676a8ab3e93f0f7b79a9cff68/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "No Son Of Mine",
    artist: "Genesis",
    id: 3145758,
    release_date: "1987-10-01",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/ab6bae79d41a6d8b765fe0f006302bca/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "A Kind Of Magic",
    artist: "Queen",
    id: 13499039,
    release_date: "1986-09-05",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/518738a2c485a7ea27ef52ded999902f/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "Don't Dream It's Over",
    artist: "Crowded House",
    id: 133577580,
    release_date: "1986-10-07",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/797cfed6ecc569b95afd34ba55784fba/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Fernando",
    artist: "ABBA",
    id: 884039,
    release_date: "1978-06-02",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/b8b70d474b7a8f27799e0d665e9b737e/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "That's the Way It Is",
    artist: "Céline Dion",
    id: 14552286,
    release_date: "1999-11-07",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/177346106112348e15ec4f9add0c1ef4/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "That's The Way Love Goes",
    artist: "Janet Jackson",
    id: 3501645,
    release_date: "1993-04-20",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/4104f417dff07ee2b6c49b798f8b23ad/250x250-000000-80-0-0.jpg",
    genre: "R&B",
  },
  {
    title: "One Night Love Affair",
    artist: "Bryan Adams",
    id: 88902731,
    release_date: "1994-11-24",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/e7be525c05b1942e1844d0073f7b9ab5/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Up Where We Belong",
    artist: "Joe Cocker",
    id: 3156388,
    release_date: "1982-02-18",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/c/9/b/0/c9b03123ef5ca008a52176f12b67d89c.mp3?hdnea=exp=1763731661~acl=/api/1/1/c/9/b/0/c9b03123ef5ca008a52176f12b67d89c.mp3*~data=user_id=0,application_id=42~hmac=2cca7098fd3161751f74e2615487285cfc38c630718d61669d3c7dc63a69de41",
    cover: "https://api.deezer.com/album/303481/image",
    genre: "Pop",
  },
  {
    title: "True Colors",
    artist: "Cyndi Lauper",
    id: 6067352,
    release_date: "1983-04-23",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/0/9/8/0/098d77abb144f443cfcbd0d5c606ddcb.mp3?hdnea=exp=1763731661~acl=/api/1/1/0/9/8/0/098d77abb144f443cfcbd0d5c606ddcb.mp3*~data=user_id=0,application_id=42~hmac=94ce35b538a6db9471a0c2629785c18923eb0276e0a53e255b4dda9ce05169df",
    cover: "https://api.deezer.com/album/373794/image",
    genre: "Pop",
  },
  {
    title: "She Wolf",
    artist: "Shakira",
    id: 3018798101,
    release_date: "2009-10-09",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/3/7/e/0/37e3bf04299db83f70c45dc9cabf4e9b.mp3?hdnea=exp=1763731661~acl=/api/1/1/3/7/e/0/37e3bf04299db83f70c45dc9cabf4e9b.mp3*~data=user_id=0,application_id=42~hmac=0b9df81fa55fd7703279612c6c0cdf31d58af1e5caac015af313682bcf7f8321",
    cover: "https://api.deezer.com/album/648801441/image",
    genre: "Pop",
  },
  {
    title: "I Engineer",
    artist: "Animotion",
    id: 1758952397,
    release_date: "1996-04-16",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/f/6/5/0/f6558b93477983a80de9122102055796.mp3?hdnea=exp=1763731661~acl=/api/1/1/f/6/5/0/f6558b93477983a80de9122102055796.mp3*~data=user_id=0,application_id=42~hmac=74a2f7d6ed2f328b9b9b57707bed6ea7ed71211cc4e98ae86332bf0166781a7d",
    cover: "https://api.deezer.com/album/320460847/image",
    genre: "Pop",
  },
  {
    title: "Lemon Tree",
    artist: "Fools Garden",
    id: 1915408647,
    release_date: "1995-11-15",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/e/a/6/0/ea67a670f86b201c671b3d8d84a69617.mp3?hdnea=exp=1763731661~acl=/api/1/1/e/a/6/0/ea67a670f86b201c671b3d8d84a69617.mp3*~data=user_id=0,application_id=42~hmac=1151536e1b69fe9c67c273e956616201afb5093949d3e9382b417826596c956f",
    cover: "https://api.deezer.com/album/356994287/image",
    genre: "Pop",
  },
  {
    title: "Gold",
    artist: "Spandau Ballet",
    id: 3130318,
    release_date: "1980-05-15",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/c/8/f/0/c8f6ba0bf79baec74057da235757595b.mp3?hdnea=exp=1763731230~acl=/api/1/1/c/8/f/0/c8f6ba0bf79baec74057da235757595b.mp3*~data=user_id=0,application_id=42~hmac=53e07f92ce411f24e06f486cb0ee5d17babbb6ad098719a81238052105aa8e74",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/b88d3c3ad23435fb5b8d52038551c1f6/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "Something Got Me Started",
    artist: "Simply Red",
    id: 75814726,
    release_date: "1992-10-01",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/5/1/2/0/512a7e7571e920299417613e34e35f5b.mp3?hdnea=exp=1763731230~acl=/api/1/1/5/1/2/0/512a7e7571e920299417613e34e35f5b.mp3*~data=user_id=0,application_id=42~hmac=c2a6547fa9d4918bed9cc17b804d661a63062e4d623bb6894d1714d627a3602b",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/6082ea7f45ec9a7093225b85bd6ebadd/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Femme Like U",
    artist: "K-Maro",
    id: 2173055847,
    release_date: "2004-12-10",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/7/5/7/0/75740eaddde9610572e016f8b796dddd.mp3?hdnea=exp=1763731661~acl=/api/1/1/7/5/7/0/75740eaddde9610572e016f8b796dddd.mp3*~data=user_id=0,application_id=42~hmac=474fc19becc1a264810d6d7d2e3ca149436c93ba3f0b6a30b3a5bc20f12ce965",
    cover: "https://api.deezer.com/album/413251397/image",
    genre: "R&B",
  },
  {
    title: "If You Don't Know Me by Now",
    artist: "Simply Red",
    id: 75814729,
    release_date: "1992-10-01",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/1/e/a/0/1ea628075d071785b7270899165d27db.mp3?hdnea=exp=1763731230~acl=/api/1/1/1/e/a/0/1ea628075d071785b7270899165d27db.mp3*~data=user_id=0,application_id=42~hmac=bc81339da0e2a9b619b6612f1d9e0a715d60421286813c318c038e39d00ff8df",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/6082ea7f45ec9a7093225b85bd6ebadd/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Self Control",
    artist: "Laura Branigan",
    id: 4288159,
    release_date: "1984-04-01",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/e/2/5/0/e25daf61bbf49a1275cd5d7c547ded7a.mp3?hdnea=exp=1763731230~acl=/api/1/1/e/2/5/0/e25daf61bbf49a1275cd5d7c547ded7a.mp3*~data=user_id=0,application_id=42~hmac=faf4c2e87e097cae25b395aa2fc6f95ca878fe2675b0e9943e5fafe3b81b6b05",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/e8d7d2bb9f156110a5be3734c246c99a/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "New York Groove",
    artist: "Hello",
    id: 1271164422,
    release_date: "1976-02-25",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/5/a/1/0/5a12fa24f5aeab1ba5424eb51ce0ce1e.mp3?hdnea=exp=1763731661~acl=/api/1/1/5/a/1/0/5a12fa24f5aeab1ba5424eb51ce0ce1e.mp3*~data=user_id=0,application_id=42~hmac=8e605c3ac0d779561984002a3c540318987886591ddfcfcf4b68a18d6bad639e",
    cover: "https://api.deezer.com/album/213771852/image",
    genre: "Rock",
  },
  {
    title: "Axel F",
    artist: "Harold Faltermeyer",
    id: 17933254,
    release_date: "1984-06-01",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/2d1630ee29a1c9ea22822a086c5a4a8e/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Summer In The City",
    artist: "Joe Cocker",
    id: 69795749,
    release_date: "1994-03-08",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/7ccf682bde3b72731fb21347123ed52c/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "You Can Leave Your Hat On",
    artist: "Joe Cocker",
    id: 3104719,
    release_date: "1994-05-25",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/2/5/f/0/25f3dfa869e19030f7fda37b429c8fcc.mp3?hdnea=exp=1763731230~acl=/api/1/1/2/5/f/0/25f3dfa869e19030f7fda37b429c8fcc.mp3*~data=user_id=0,application_id=42~hmac=663613953e928e5b23e82d11735ea5d345bd3061c5bdad8e9f811f197ef63afb",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/57e4c3c461961e77fab66662fecee013/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "Easy",
    artist: "Faith No More",
    id: 813837,
    release_date: "1990-01-15",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/8/3/e/0/83ef1d31d21aa673036301f8e28e93cf.mp3?hdnea=exp=1763731230~acl=/api/1/1/8/3/e/0/83ef1d31d21aa673036301f8e28e93cf.mp3*~data=user_id=0,application_id=42~hmac=891d2b25e344b6b402c124e53d8c8a4b4abd36f54bf98ce3aa224c9f048b74d7",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/b9634f0c731e31dc5f3e3c43f0771376/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Right Here",
    artist: "SWV",
    id: 555805,
    release_date: "1992-08-27",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/6/a/5/0/6a516d424408c4870c4dccfaedda36c6.mp3?hdnea=exp=1763731230~acl=/api/1/1/6/a/5/0/6a516d424408c4870c4dccfaedda36c6.mp3*~data=user_id=0,application_id=42~hmac=b5f319de959786c42b0bbb7f22eb1d5747e5b7cbdb52552b8ecde3cfebbfcf62",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/8852e80ba157a469f6e8702170e585b9/250x250-000000-80-0-0.jpg",
    genre: "R&B",
  },
  {
    title: "I Love Your Smile",
    artist: "Shanice",
    id: 910925,
    release_date: "1991-03-07",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/b/8/b/0/b8bee78c2540e74ee12f4ea6f085c4ad.mp3?hdnea=exp=1763731230~acl=/api/1/1/b/8/b/0/b8bee78c2540e74ee12f4ea6f085c4ad.mp3*~data=user_id=0,application_id=42~hmac=e5bdaa39a89140e3afb44b1ba5da8408f178fa75bb646ef9ead7de0ca837644c",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/447dbf905a9bc8113add6d914babe853/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Moving on Up",
    artist: "M People",
    id: 600153,
    release_date: "1993-02-21",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/b/f/0/0/bf0967efd8d1f5cbfcad4a0b403620c9.mp3?hdnea=exp=1763731230~acl=/api/1/1/b/f/0/0/bf0967efd8d1f5cbfcad4a0b403620c9.mp3*~data=user_id=0,application_id=42~hmac=9029d5b95e14ff664727ef0ca197765932efdf14594c85288aae6d355e0388a0",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/03ae0d6ea06504c955ff6661049af62b/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "I Feel Lonely",
    artist: "Sasha",
    id: 686342,
    release_date: "1998-10-26",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/f/f/8/0/ff8f0f7f11c4fcc84340d01931ece476.mp3?hdnea=exp=1763731230~acl=/api/1/1/f/f/8/0/ff8f0f7f11c4fcc84340d01931ece476.mp3*~data=user_id=0,application_id=42~hmac=9faefa24a482ceed6aac9c0287b6cee0ff8b7c104a73c6a22244d0047a8a11a4",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/637642a15b8d354e6c3f5f08e74a81af/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Shiny Happy People",
    artist: "R.E.M.",
    id: 136339500,
    release_date: "1991-11-18",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/6/b/5/0/6b5def4a7cd82c81c7cbf749ba2d8206.mp3?hdnea=exp=1763731230~acl=/api/1/1/6/b/5/0/6b5def4a7cd82c81c7cbf749ba2d8206.mp3*~data=user_id=0,application_id=42~hmac=b701f1a8064c614b097bf0b24a64168bbd792031b2390e7e6b2e605d796b48f4",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/a968ed3814acb2ef8f3929b1bebcb42d/250x250-000000-80-0-0.jpg",
    genre: "Alternative",
  },
  {
    title: "The Shoop Shoop Song (It's In His Kiss)",
    artist: "Cher",
    id: 540169472,
    release_date: "1990-08-10",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/6/2/d/0/62da6f9f8ca5a4a6bfebf89c88834848.mp3?hdnea=exp=1763731230~acl=/api/1/1/6/2/d/0/62da6f9f8ca5a4a6bfebf89c88834848.mp3*~data=user_id=0,application_id=42~hmac=ebbf419bf6626f562c760db72d1c61737c9b1b22250858cdbd616cb02e1231d0",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/06cd15444c800fc985d53489b8ca4a13/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Come Along",
    artist: "Titiyo",
    id: 19271551,
    release_date: "2007-10-11",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/1/1/1/0/11169f7261408687a5fcbbc20f78aebf.mp3?hdnea=exp=1763731230~acl=/api/1/1/1/1/1/0/11169f7261408687a5fcbbc20f78aebf.mp3*~data=user_id=0,application_id=42~hmac=0f6939b5141dcdff9bf9be44c1c3ca66c86d0f8e8dd450f497aa84a2da85eecd",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/6fcc0f75aaa955309c6377b1b6387ad9/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Supreme",
    artist: "Robbie Williams",
    id: 3102420,
    release_date: "2003-03-01",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/6/a/2/0/6a202cc053cabd2de995fb35e7aa2da8.mp3?hdnea=exp=1763731230~acl=/api/1/1/6/a/2/0/6a202cc053cabd2de995fb35e7aa2da8.mp3*~data=user_id=0,application_id=42~hmac=a99dcf1003b87c405ab483ae802e0fc23f08ce9f29c1278bbb428b8db9682227",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/d260fa442f925e1eb1c95bb29941f636/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "Miss California",
    artist: "Dante Thomas",
    id: 368705481,
    release_date: "1996-07-17",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/3/d/2/0/3d2425dcf5853610db5a2f549267e26e.mp3?hdnea=exp=1763731230~acl=/api/1/1/3/d/2/0/3d2425dcf5853610db5a2f549267e26e.mp3*~data=user_id=0,application_id=42~hmac=132a557f606d1d1d98a98cb91373457fd5a41ca277dce43388bc09c421d1dffd",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/e7001559164b20d486115986f508ad49/250x250-000000-80-0-0.jpg",
    genre: "R&B",
  },
  {
    title: "Don't Pay The Ferryman",
    artist: "Chris De Burgh",
    id: 1158199,
    release_date: "1981-04-02",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/9/7/0/0/970d281d4d501e7db4124dec18ed53a6.mp3?hdnea=exp=1763731230~acl=/api/1/1/9/7/0/0/970d281d4d501e7db4124dec18ed53a6.mp3*~data=user_id=0,application_id=42~hmac=e8dda64ac07333c5b9f6f4499da3d4b639acb7dc6d7894d64fc99408870b36a4",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/4507359752a023d0d4e91370c779acd2/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Little Lies",
    artist: "Fleetwood Mac",
    id: 664456,
    release_date: "1987-01-01",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/7/3/5/0/7358e66a7f87dfb70f1be0ab4be30101.mp3?hdnea=exp=1763731230~acl=/api/1/1/7/3/5/0/7358e66a7f87dfb70f1be0ab4be30101.mp3*~data=user_id=0,application_id=42~hmac=28ebd7632c27250575e377666063c80781dc2648f0f784e1a449c6453b567881",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/fae8305ef18ac327a4c19436672d5d5b/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Summer Wine",
    artist: "Nancy Sinatra",
    id: 1701069977,
    release_date: "1968-01-01",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/a/3/1/0/a31aa4f096a86292e89d720958862c2b.mp3?hdnea=exp=1763731661~acl=/api/1/1/a/3/1/0/a31aa4f096a86292e89d720958862c2b.mp3*~data=user_id=0,application_id=42~hmac=76ca715aa97207b2c4ea87a72022f93476ba0ba9f879141a31033865463a4270",
    cover: "https://api.deezer.com/album/306544897/image",
    genre: "Pop",
  },
  {
    title: "'74-'75",
    artist: "The Connells",
    id: 84382469,
    release_date: "1993-07-29",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/9/1/3/0/91324d38c670c7f3fb97a5d7d426c3b9.mp3?hdnea=exp=1763731230~acl=/api/1/1/9/1/3/0/91324d38c670c7f3fb97a5d7d426c3b9.mp3*~data=user_id=0,application_id=42~hmac=20b3bb42c04b34e528901a72c01881ff30186564f695fcb75f5dde1020ec6ecc",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/c6c7515591bb1d506e22853ee4b6817f/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "Mmm Mmm Mmm Mmm",
    artist: "Crash Test Dummies",
    id: 90630611,
    release_date: "1993-04-05",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/2/e/e/0/2ee1a4207dfd4728d4ab6f307180dbd1.mp3?hdnea=exp=1763731661~acl=/api/1/1/2/e/e/0/2ee1a4207dfd4728d4ab6f307180dbd1.mp3*~data=user_id=0,application_id=42~hmac=68b35ac5dde02eb35c4070f1c76e420ba48bc4da9c03a135830490e8689f5ef6",
    cover: "https://api.deezer.com/album/9188115/image",
    genre: "Pop",
  },
  {
    title: "Cats In The Cradle",
    artist: "Ugly Kid Joe",
    id: 1115742,
    release_date: "1993-08-19",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/0/c/1/0/0c132b07c93c05e0a32b04f9640f215d.mp3?hdnea=exp=1763731230~acl=/api/1/1/0/c/1/0/0c132b07c93c05e0a32b04f9640f215d.mp3*~data=user_id=0,application_id=42~hmac=8cc9ab457d28700926d116b30a5f391aa9374ba0062b72379a8fa2da2bf874b3",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/04fd7d9a9a9a00cb7f69d9e3a5509dd1/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "Moonlight Shadow",
    artist: "Mike Oldfield",
    id: 3978859,
    release_date: "1989-06-08",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/1/9/7/0/197be6968ab0e62ac9d0f6bb4b54836b.mp3?hdnea=exp=1763731230~acl=/api/1/1/1/9/7/0/197be6968ab0e62ac9d0f6bb4b54836b.mp3*~data=user_id=0,application_id=42~hmac=a225430f87969d8ab342bb47daad35141587c3d3d71eff52d811f0270eecfafd",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/2b3e7d77cf4454c3de4aad41fa9abdb4/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "Gimme All Your Lovin'",
    artist: "ZZ Top",
    id: 2133998,
    release_date: "1983-07-08",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/4/0/0/0/400270d6adc640bccd834fe25fd4c666.mp3?hdnea=exp=1763731230~acl=/api/1/1/4/0/0/0/400270d6adc640bccd834fe25fd4c666.mp3*~data=user_id=0,application_id=42~hmac=e01bb140a3eb99b68889f7b081d253b432707fb12b017a5ce3ad339c1e063584",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/706d994a9b906b857db6869183c30274/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Americanos",
    artist: "Holly Johnson",
    id: 4275259,
    release_date: "2009-09-28",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/0/3/b/0/03b73ff6485896cc3bdd9dd21433285a.mp3?hdnea=exp=1763731230~acl=/api/1/1/0/3/b/0/03b73ff6485896cc3bdd9dd21433285a.mp3*~data=user_id=0,application_id=42~hmac=9812bceeb9ee690a322a6a3d132cbe4e870425263c5d1930168ddc74363ee789",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/6827672c0ca3c851f602191c281f1b10/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Kopf verloren",
    artist: "Peter Fox",
    id: 2200207,
    release_date: "2008-09-26",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/0/e/6/0/0e6d426161d69ceaf753fd736664762a.mp3?hdnea=exp=1763731230~acl=/api/1/1/0/e/6/0/0e6d426161d69ceaf753fd736664762a.mp3*~data=user_id=0,application_id=42~hmac=c0f348090bdacb3511c5a74da69a5f5b08e74713aedd681761d49c856904aa49",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/67fe414d2cf5cceab6429147fa37f6bd/250x250-000000-80-0-0.jpg",
    genre: "Rap/Hip Hop",
  },
  {
    title: "Played-A-Live (The Bongo Song)",
    artist: "Safri Duo",
    id: 2276002,
    release_date: "2007-08-09",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/9/3/6/0/9364f014b582c3e97d94aa4182c08666.mp3?hdnea=exp=1763731230~acl=/api/1/1/9/3/6/0/9364f014b582c3e97d94aa4182c08666.mp3*~data=user_id=0,application_id=42~hmac=ea4bae2f3c4bb643ddb0a947a6971255d5e989c2ec7f86a10261ffd2e067bcb9",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/411921710089486f9c2f1d00247bd9f2/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "Heartlight",
    artist: "Kenny Loggins",
    id: 15526148,
    release_date: "1983-09-06",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/0/6/2/0/0627f446bce16caf15ac860c0fed80d4.mp3?hdnea=exp=1763731230~acl=/api/1/1/0/6/2/0/0627f446bce16caf15ac860c0fed80d4.mp3*~data=user_id=0,application_id=42~hmac=1c7a2c03107dd58620b3369d2534e848a654c4f72ec00cc510d79d3476e4fdab",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/2f45d298a7d06d5b4809d91445976adb/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Rivers of Babylon",
    artist: "Boney M.",
    id: 968798,
    release_date: "1988-05-12",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/0/4/c/0/04c94528eba04fe9c32fe07f64416050.mp3?hdnea=exp=1763731230~acl=/api/1/1/0/4/c/0/04c94528eba04fe9c32fe07f64416050.mp3*~data=user_id=0,application_id=42~hmac=0ff6a04a7497fed9111fe5780f531d71c195c5d355ac1b84f0160c039f2e810d",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/24290d29032e06a3669ab17c5e1b7a2a/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "We Didn't Start the Fire",
    artist: "Billy Joel",
    id: 626123,
    release_date: "1989-10-17",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/3/c/2/0/3c217db98586cfe1f9e923b0bde7db96.mp3?hdnea=exp=1763731230~acl=/api/1/1/3/c/2/0/3c217db98586cfe1f9e923b0bde7db96.mp3*~data=user_id=0,application_id=42~hmac=0dc06e7134cfaae2956da472e5797b5c7fc87e262e288aebb28d7f179f25917f",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/8a44cff0ab7a842716dc62235a211a30/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Centerfold",
    artist: "The J. Geils Band",
    id: 3168236,
    release_date: "1989-09-20",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/1/2/8/0/12817fff642493603e7bda4ff8fd3748.mp3?hdnea=exp=1763731230~acl=/api/1/1/1/2/8/0/12817fff642493603e7bda4ff8fd3748.mp3*~data=user_id=0,application_id=42~hmac=15533d37d3313471d3241a44b8adee3742d1386326dc0f3f9976169a2a3056f6",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/cc1722705a41d9221bff919895c236bf/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "Born in the U.S.A.",
    artist: "Bruce Springsteen",
    id: 15586213,
    release_date: "1984-06-04",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/e/4/8/0/e48e42023cd3829c4ef8a6a18031fcd1.mp3?hdnea=exp=1763731230~acl=/api/1/1/e/4/8/0/e48e42023cd3829c4ef8a6a18031fcd1.mp3*~data=user_id=0,application_id=42~hmac=38999b03edbb2326b0b232fff4315a06845adaeb45989ec0e7add3bb0b1c2421",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/106f651bf559796879b90e83c50b3e96/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "Hungry Heart",
    artist: "Bruce Springsteen",
    id: 15177141,
    release_date: "1980-10-17",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/d/8/0/0/d8072b0d5ea737c983762c57f8991fae.mp3?hdnea=exp=1763731230~acl=/api/1/1/d/8/0/0/d8072b0d5ea737c983762c57f8991fae.mp3*~data=user_id=0,application_id=42~hmac=b59fb5b86f864752b1d576f8c993b7d8e78938abaf2dbbbfa717a14fe7cfb5e9",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/a971f0ed2fda6d017adeb5e3af3c1619/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "The Boys Of Summer",
    artist: "Don Henley",
    id: 3977905,
    release_date: "1984-06-16",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/1/d/9/0/1d996a7a67991def36c8b625dbbbcdb8.mp3?hdnea=exp=1763731230~acl=/api/1/1/1/d/9/0/1d996a7a67991def36c8b625dbbbcdb8.mp3*~data=user_id=0,application_id=42~hmac=21919a053ef0b12dc8bb9cd52f35b0c7fd32e2092eff1180c48eb78dfce332cb",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/e374e05d5e2991dda20e1b2636e69cc9/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "The Wild Boys",
    artist: "Duran Duran",
    id: 3130438,
    release_date: "1984-11-09",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/5/1/d/0/51d010610ca410dcd46f857e291dba57.mp3?hdnea=exp=1763731230~acl=/api/1/1/5/1/d/0/51d010610ca410dcd46f857e291dba57.mp3*~data=user_id=0,application_id=42~hmac=e639ed752441dfb4414a7a8de942ad8390bd90185004a331687f621fa34e5fda",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/3ed10ab812e802c87e423db20800f678/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "Liberian Girl",
    artist: "Michael Jackson",
    id: 59509561,
    release_date: "1989-09-14",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/0/7/f/0/07f05479901de5939e067657c6883e75.mp3?hdnea=exp=1763731230~acl=/api/1/1/0/7/f/0/07f05479901de5939e067657c6883e75.mp3*~data=user_id=0,application_id=42~hmac=9ef2fc8128624166c0139693528bd1c5a7e68afe4aa9a401d69077543b77305c",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/fb0a49a91ab8137ec9d028c4dbb04021/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Leave Me Alone",
    artist: "Michael Jackson",
    id: 59509521,
    release_date: "1989-09-14",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/2/b/2/0/2b26be079b1adf56ed5df41d935331ad.mp3?hdnea=exp=1763731230~acl=/api/1/1/2/b/2/0/2b26be079b1adf56ed5df41d935331ad.mp3*~data=user_id=0,application_id=42~hmac=2b159ad21690269ec9ba722b0c051adb71d61b4ff3f33691d269d0927863c423",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/995b33eaad9a62409c822ce9c670e542/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "ABC",
    artist: "Jackson 5",
    id: 920082,
    release_date: "1970-11-07",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/b/0/5/0/b055c74f50bd8dc4a9c9bce29db15328.mp3?hdnea=exp=1763731230~acl=/api/1/1/b/0/5/0/b055c74f50bd8dc4a9c9bce29db15328.mp3*~data=user_id=0,application_id=42~hmac=83891126752d81383097ccf8326c815af8ab5b16dec885ae2208daee89763ed5",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/441713fba5bca16b3731767218c27234/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Suspicious Minds",
    artist: "Elvis Presley",
    id: 1055776,
    release_date: "1969-09-28",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/d/1/a/0/d1a492b30715f528ed6de3c6faaf713e.mp3?hdnea=exp=1763731230~acl=/api/1/1/d/1/a/0/d1a492b30715f528ed6de3c6faaf713e.mp3*~data=user_id=0,application_id=42~hmac=c1e7f2a2e63f9d4a27cf1e512b3a5387ec287054526bf3109d7e467d60bc2506",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/3598c1cdd425022000eba13ade236e8d/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Jailhouse Rock",
    artist: "Elvis Presley",
    id: 6596867,
    release_date: "1957-08-30",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/b/2/6/0/b26a1f4f3217e3cab3e40f9163653d18.mp3?hdnea=exp=1763731230~acl=/api/1/1/b/2/6/0/b26a1f4f3217e3cab3e40f9163653d18.mp3*~data=user_id=0,application_id=42~hmac=269ab2f48f8dc2397dd6c304f818c7f279a3be028276f5b905aaf9173cdb47dd",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/ddd830fa6768774fdc110e4388b88992/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "MMMBop",
    artist: "Hanson",
    id: 88685889,
    release_date: "1997-05-26",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/f/b/b/0/fbb4abe90538b013c3f854a67ec0d75c.mp3?hdnea=exp=1763731230~acl=/api/1/1/f/b/b/0/fbb4abe90538b013c3f854a67ec0d75c.mp3*~data=user_id=0,application_id=42~hmac=21e36ec3cc4bd5837ea28ef68299a6724b6a4ae9bff50e1cf5fbecbdf9fdd99b",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/394c44c400a9786a9582a7fed308622e/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Smells Like Teen Spirit",
    artist: "Nirvana",
    id: 13791930,
    release_date: "1991-09-26",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/3/4/b/0/34bad352aa1aa0f8eecbbc9c27a40eaf.mp3?hdnea=exp=1763731230~acl=/api/1/1/3/4/b/0/34bad352aa1aa0f8eecbbc9c27a40eaf.mp3*~data=user_id=0,application_id=42~hmac=870c22e95d39476518b573f8250f5a78a64564ae8f14050880e683e1abbaa4a3",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/f0282817b697279e56df13909962a54a/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "Mamma Mia",
    artist: "ABBA",
    id: 884030,
    release_date: "1978-06-02",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/2/f/4/0/2f43ec31dca14cb85d055161622fbe2c.mp3?hdnea=exp=1763731230~acl=/api/1/1/2/f/4/0/2f43ec31dca14cb85d055161622fbe2c.mp3*~data=user_id=0,application_id=42~hmac=bae3f47f5d359c260ac2fa9613fa7383dd279c0b85230fb732fc7c0c4f24201c",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/b8b70d474b7a8f27799e0d665e9b737e/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Isn't She Lovely",
    artist: "Stevie Wonder",
    id: 2802054,
    release_date: "1976-02-10",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/5/3/1/0/531b60e2842b092be27c7bbf8a34330e.mp3?hdnea=exp=1763731230~acl=/api/1/1/5/3/1/0/531b60e2842b092be27c7bbf8a34330e.mp3*~data=user_id=0,application_id=42~hmac=42a6a0c7abb532286472147d4959b973e7141245726b3f554194c78cbff80bc9",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/cca2a5854f722f615dddf22ca9d93804/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Crazy In Love (feat. Jay-Z)",
    artist: "Beyoncé",
    id: 609244,
    release_date: "2003-06-24",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/9/d/a/0/9da6dc6e093d7afe9aba7868644fda2a.mp3?hdnea=exp=1763731230~acl=/api/1/1/9/d/a/0/9da6dc6e093d7afe9aba7868644fda2a.mp3*~data=user_id=0,application_id=42~hmac=702576289ad8d725ebd96a6656a227f68de8f7f892c42377155826ea1ca6ce0b",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/1ea1a631aa5235bbd0063643beb96fa8/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Single Ladies (Put a Ring on It)",
    artist: "Beyoncé",
    id: 2485118,
    release_date: "2008-11-14",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/0/c/9/0/0c9cc0beae938bd297f288ff142133f4.mp3?hdnea=exp=1763731230~acl=/api/1/1/0/c/9/0/0c9cc0beae938bd297f288ff142133f4.mp3*~data=user_id=0,application_id=42~hmac=ee2c9db27f3e92fe4d4b67f26d280a7207a2cc5f51a036f9369ce76412dbfbcb",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/1f0450a010b5a825194d7ca00b3067ab/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Roar",
    artist: "Katy Perry",
    id: 71645431,
    release_date: "2013-01-01",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/9/0/4/0/90438e4ff23b991843b4bdfd73a52584.mp3?hdnea=exp=1763731230~acl=/api/1/1/9/0/4/0/90438e4ff23b991843b4bdfd73a52584.mp3*~data=user_id=0,application_id=42~hmac=33f515c3abb2f93633d93b16802c0a7349a5f9477ed34816de1a9da1950c58a7",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/fe781ecd9879a82beed80f6d3e80745b/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Firework",
    artist: "Katy Perry",
    id: 17135111,
    release_date: "2012-03-23",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/2/f/6/0/2f693142ea48d53192d369fc21f233dc.mp3?hdnea=exp=1763731230~acl=/api/1/1/2/f/6/0/2f693142ea48d53192d369fc21f233dc.mp3*~data=user_id=0,application_id=42~hmac=4dbab2b01c8f843016085b2265e6265c82b62525aa318757e5a7f8b855ca1d62",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/99578b0bb8c838383c414a5b62b5e15d/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Jolene",
    artist: "Dolly Parton",
    id: 114422238,
    release_date: "1974-02-04",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/3/9/1/0/39196bba724775ae89ae4fdd5a528e84.mp3?hdnea=exp=1763731230~acl=/api/1/1/3/9/1/0/39196bba724775ae89ae4fdd5a528e84.mp3*~data=user_id=0,application_id=42~hmac=4ceee6745ca0b281a78698eff45dbe508aa5111392b9d2a84f26b14db82f407d",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/d47fc7a27a0d40cc2a8c119ed2bc53b7/250x250-000000-80-0-0.jpg",
    genre: "Country",
  },
  {
    title: "9 to 5",
    artist: "Dolly Parton",
    id: 992937,
    release_date: "1980-11-17",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/f/6/4/0/f6429ee343fe41fab2a95ab9d0d85e5b.mp3?hdnea=exp=1763731661~acl=/api/1/1/f/6/4/0/f6429ee343fe41fab2a95ab9d0d85e5b.mp3*~data=user_id=0,application_id=42~hmac=09e19837cec7a183e5c8834620ad0be3cd228f1c2cb29677157313e3b6acbd36",
    cover: "https://api.deezer.com/album/110191/image",
    genre: "Country",
  },
  {
    title: "Shape of You",
    artist: "Ed Sheeran",
    id: 142986204,
    release_date: "2017-01-06",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/f/1/b/0/f1becf66c6264a6a0306fc47d47690b0.mp3?hdnea=exp=1763731230~acl=/api/1/1/f/1/b/0/f1becf66c6264a6a0306fc47d47690b0.mp3*~data=user_id=0,application_id=42~hmac=c1088bcb17a87777898a0f52737c11409bd850b6ad5be6f1c2a76fbf08f3addc",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/000a9228cecfcc7c2093d9cd7bb66447/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "In the Air Tonight",
    artist: "Phil Collins",
    id: 134036212,
    release_date: "1981-10-14",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/7/a/e/0/7ae98a206f52ed24eb6166804b9fb797.mp3?hdnea=exp=1763731661~acl=/api/1/1/7/a/e/0/7ae98a206f52ed24eb6166804b9fb797.mp3*~data=user_id=0,application_id=42~hmac=0611886cd97a482f019bc70b107d6d1b631f3a6167803f04430c9720781067dd",
    cover: "https://api.deezer.com/album/14285090/image",
    genre: "Pop",
  },
  {
    title: "You're The First, The Last, My Everything",
    artist: "Barry White",
    id: 537988582,
    release_date: "1974-08-10",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/c/c/f/0/ccfb388e904c7b3186a1b4772de17aca.mp3?hdnea=exp=1763731661~acl=/api/1/1/c/c/f/0/ccfb388e904c7b3186a1b4772de17aca.mp3*~data=user_id=0,application_id=42~hmac=4037fb15bd1fcc7a0604a10d2d0899dcccf67c0437bbd2448ac9f0136fa59785",
    cover: "https://api.deezer.com/album/70113142/image",
    genre: "Pop",
  },
  {
    title: "Maggie May",
    artist: "Rod Stewart",
    id: 538641872,
    release_date: "1971-08-10",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/6/4/9/0/6494504b9763c2215e3a2fea9ad67348.mp3?hdnea=exp=1763731661~acl=/api/1/1/6/4/9/0/6494504b9763c2215e3a2fea9ad67348.mp3*~data=user_id=0,application_id=42~hmac=24ff1dcdf0303a10476e4742ec86702d5fb08bb6d4b8578a7f6cd686f5277c4d",
    cover: "https://api.deezer.com/album/70197852/image",
    genre: "Pop",
  },
  {
    title: "CAN'T STOP THE FEELING!",
    artist: "Justin Timberlake",
    id: 124237488,
    release_date: "2016-05-06",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/9/4/b/0/94b08535e1d86650c891c720af3aa77a.mp3?hdnea=exp=1763731661~acl=/api/1/1/9/4/b/0/94b08535e1d86650c891c720af3aa77a.mp3*~data=user_id=0,application_id=42~hmac=49b6cfc7b837000ad5f5514ce16e25445b28087dd01999564f26e27c1f10b81c",
    cover: "https://api.deezer.com/album/13035460/image",
    genre: "Pop",
  },
  {
    title: "Cry Me a River",
    artist: "Justin Timberlake",
    id: 969494,
    release_date: "2002-11-05",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/3/4/8/0/348bce8baa3328eb09a9f10565a59d62.mp3?hdnea=exp=1763731661~acl=/api/1/1/3/4/8/0/348bce8baa3328eb09a9f10565a59d62.mp3*~data=user_id=0,application_id=42~hmac=e934a03f7a32a7c60a72ae485fb8136607b9bcb3cf4b979fbafc54903069f9fa",
    cover: "https://api.deezer.com/album/108359/image",
    genre: "Pop",
  },
  {
    title: "Feeling Good",
    artist: "Nina Simone",
    id: 709830092,
    release_date: "1965-06-21",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/7/9/9/0/799d0ea320d9762806e71efa6c68693d.mp3?hdnea=exp=1763731661~acl=/api/1/1/7/9/9/0/799d0ea320d9762806e71efa6c68693d.mp3*~data=user_id=0,application_id=42~hmac=946e82eb30c6a34b201af423de72541ebffb966f72839d6e0d18c1fcf357af39",
    cover: "https://api.deezer.com/album/103047822/image",
    genre: "Jazz",
  },
  {
    title: "(Something Inside) So Strong",
    artist: "Labi Siffre",
    id: 6469108,
    release_date: "1987-07-07",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/2/d/8/0/2d86d177efbd03427600d5ed763827dd.mp3?hdnea=exp=1763731661~acl=/api/1/1/2/d/8/0/2d86d177efbd03427600d5ed763827dd.mp3*~data=user_id=0,application_id=42~hmac=e7b0d4dbbfee5d1d0c814b6c6c0daf89be9cb96c0724220883b5592cda1ff2b3",
    cover: "https://api.deezer.com/album/596180/image",
    genre: "Pop",
  },
  {
    title: "I'm Still Standing",
    artist: "Elton John",
    id: 1171163,
    release_date: "1983-04-30",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/4/c/7/0/4c73011f100bfabc80faf753149058b4.mp3?hdnea=exp=1763731661~acl=/api/1/1/4/c/7/0/4c73011f100bfabc80faf753149058b4.mp3*~data=user_id=0,application_id=42~hmac=09b443d405a1c2357d9c71c84f84e4732aa8ba35462872dba890fb5cbb889e32",
    cover: "https://api.deezer.com/album/125333/image",
    genre: "Pop",
  },
  {
    title: "Tiny Dancer",
    artist: "Elton John",
    id: 1151503,
    release_date: "1971-11-10",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/8/d/0/0/8d0137c82dbe2205cde23b5e8779a2f5.mp3?hdnea=exp=1763731662~acl=/api/1/1/8/d/0/0/8d0137c82dbe2205cde23b5e8779a2f5.mp3*~data=user_id=0,application_id=42~hmac=5a675f67b62c5474f815da43a08b706babc42ee3f30df9848aac38c4f5c07078",
    cover: "https://api.deezer.com/album/123371/image",
    genre: "Pop",
  },
  {
    title: "Your Song",
    artist: "Elton John",
    id: 880181,
    release_date: "1970-10-26",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/7/f/5/0/7f542ea6651ba0e1355009583f3cc1d7.mp3?hdnea=exp=1763731661~acl=/api/1/1/7/f/5/0/7f542ea6651ba0e1355009583f3cc1d7.mp3*~data=user_id=0,application_id=42~hmac=a448e395cbdc898c519da546ab5a3459e939a14278e2005a77983472b4b359c7",
    cover: "https://api.deezer.com/album/99998/image",
    genre: "Pop",
  },
  {
    title: "My Girl",
    artist: "The Temptations",
    id: 1156952,
    release_date: "1965-03-19",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/6/0/5/0/6056a0582174e4d83205ac875ee18764.mp3?hdnea=exp=1763731661~acl=/api/1/1/6/0/5/0/6056a0582174e4d83205ac875ee18764.mp3*~data=user_id=0,application_id=42~hmac=3c365a615084c6e45db373d791bec1a5cd9056f0bef3c7fbaf7b0ea6dc2da6f4",
    cover: "https://api.deezer.com/album/123894/image",
    genre: "Pop",
  },
  {
    title: "Good Vibrations",
    artist: "The Beach Boys",
    id: 3091992,
    release_date: "1991-07-16",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/3/b/8/0/3b8ae26a77c0a4f808019edfb9e3a672.mp3?hdnea=exp=1763731661~acl=/api/1/1/3/b/8/0/3b8ae26a77c0a4f808019edfb9e3a672.mp3*~data=user_id=0,application_id=42~hmac=e511ba5b3f8d5c735340a56574631268523cb0b3efb49e6910fa32f63d6054e4",
    cover: "https://api.deezer.com/album/299377/image",
    genre: "Rock",
  },
  {
    title: "Barbara Ann",
    artist: "The Beach Boys",
    id: 3091983,
    release_date: "1963-05-29",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/5/4/b/0/54bbfd9f5ade3bc4b78c069d797c6849.mp3?hdnea=exp=1763731661~acl=/api/1/1/5/4/b/0/54bbfd9f5ade3bc4b78c069d797c6849.mp3*~data=user_id=0,application_id=42~hmac=3c8b5670058e6389f33363242d698e51bcbdc21697642c96d4cb794d48917022",
    cover: "https://api.deezer.com/album/299377/image",
    genre: "Rock",
  },
  {
    title: "Uptown Funk (feat. Bruno Mars)",
    artist: "Mark Ronson",
    id: 92734438,
    release_date: "2015-01-12",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/b/0/a/0/b0a30d99fddf73c172e0d3f308899dd5.mp3?hdnea=exp=1763731662~acl=/api/1/1/b/0/a/0/b0a30d99fddf73c172e0d3f308899dd5.mp3*~data=user_id=0,application_id=42~hmac=95712251aadecfe4a868ec1943e4608dbe97df8faf833a268ec5ddff3070d5f6",
    cover: "https://api.deezer.com/album/9411436/image",
    genre: "Pop",
  },
  {
    title: "Creep - Radio Edit",
    artist: "Radiohead",
    id: 138547415,
    release_date: "1993-02-22",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/b/9/c/0/b9c4cde36fbe176cc3e84dc08fc0611b.mp3?hdnea=exp=1763731662~acl=/api/1/1/b/9/c/0/b9c4cde36fbe176cc3e84dc08fc0611b.mp3*~data=user_id=0,application_id=42~hmac=d27584de38e1073d0e5e1eb42c90982e13352c155d5eb8bf632419caf7ecd5ba",
    cover: "https://api.deezer.com/album/14880711/image",
    genre: "Alternative",
  },
  {
    title: "Fireflies",
    artist: "Owl City",
    id: 4188437,
    release_date: "2009-07-28",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/0/6/0/0/060f3e78063b5ccc9f5197bb1ab8c4e2.mp3?hdnea=exp=1763731662~acl=/api/1/1/0/6/0/0/060f3e78063b5ccc9f5197bb1ab8c4e2.mp3*~data=user_id=0,application_id=42~hmac=268d2d2816774de8c7e28d06a19b4e4bb7b54cb70ef3215a171adb3fb0c9232f",
    cover: "https://api.deezer.com/album/390346/image",
    genre: "Electro",
  },
  {
    title: "Where Is The Love?",
    artist: "The Black Eyed Peas",
    id: 1697351967,
    release_date: "2002-04-01",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/9/2/3/0/9231a220d417d2c7f7e9489fc280b3dd.mp3?hdnea=exp=1763731662~acl=/api/1/1/9/2/3/0/9231a220d417d2c7f7e9489fc280b3dd.mp3*~data=user_id=0,application_id=42~hmac=93296b0c758ab6b1a8d1358ca88f316a8f5bead813688a5784fd2869d86224b9",
    cover: "https://api.deezer.com/album/305742477/image",
    genre: "R&B",
  },
  {
    title: "Cupid",
    artist: "Sam Cooke",
    id: 71190918,
    release_date: "0000-00-00",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/9/2/8/0/9286d1ee827f063b22fd3ff4b322dda9.mp3?hdnea=exp=1763731662~acl=/api/1/1/9/2/8/0/9286d1ee827f063b22fd3ff4b322dda9.mp3*~data=user_id=0,application_id=42~hmac=5ec0152f49665c4dec8157aa42aaec4b1488909af8424d30b99f46a72a41d8e6",
    cover: "https://api.deezer.com/album/6989185/image",
    genre: "R&B",
  },
  {
    title: "I Wanna Dance with Somebody (Who Loves Me)",
    artist: "Whitney Houston",
    id: 75981528,
    release_date: "1987-01-01",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/f/f/b/0/ffbaa0dbc8eb4b09e015a5b92d497425.mp3?hdnea=exp=1763731662~acl=/api/1/1/f/f/b/0/ffbaa0dbc8eb4b09e015a5b92d497425.mp3*~data=user_id=0,application_id=42~hmac=23e6eea15ce8950d7449643d1983eef24c843ce7dd2f5b7a6017860aac2a6056",
    cover: "https://api.deezer.com/album/7530488/image",
    genre: "R&B",
  },
  {
    title: "Vincent",
    artist: "Don McLean",
    id: 3166507,
    release_date: "1987-04-24",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/3/a/0/0/3a0405f78b6f4fcc69fa96be1865aff1.mp3?hdnea=exp=1763731662~acl=/api/1/1/3/a/0/0/3a0405f78b6f4fcc69fa96be1865aff1.mp3*~data=user_id=0,application_id=42~hmac=3c7f6342c5b9693d6f034f7024ac93e3a54b6a3cf284d2e91e87b709e10b10ce",
    cover: "https://api.deezer.com/album/304126/image",
    genre: "Pop",
  },
  {
    title: "What A Wonderful World",
    artist: "Louis Armstrong",
    id: 906625,
    release_date: "1967-05-27",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/4/9/d/0/49d90c639ea6fc1699105e9adacfdf56.mp3?hdnea=exp=1763731662~acl=/api/1/1/4/9/d/0/49d90c639ea6fc1699105e9adacfdf56.mp3*~data=user_id=0,application_id=42~hmac=a03fe6fc42d393bcdf1938a1467f1ba267ea9367a2278ef29101d2069597b742",
    cover: "https://api.deezer.com/album/102392/image",
    genre: "Jazz",
  },
  {
    title: "Titanium",
    artist: "David Guetta",
    id: 62624905,
    release_date: "2011-08-24",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/6/7/0/0/6704168518eedd6eff222b5fb55f86c0.mp3?hdnea=exp=1763731662~acl=/api/1/1/6/7/0/0/6704168518eedd6eff222b5fb55f86c0.mp3*~data=user_id=0,application_id=42~hmac=85dd1b3a024a63dee3cafb57b0df61f651f8a370dbf6127c69a1f7ccad803be4",
    cover: "https://api.deezer.com/album/6148941/image",
    genre: "Dance",
  },
  {
    title: "All About That Bass",
    artist: "Meghan Trainor",
    id: 113420702,
    release_date: "2014-06-30",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/8/7/d/0/87d67deb77c9b2019825eef23df4b08d.mp3?hdnea=exp=1763731662~acl=/api/1/1/8/7/d/0/87d67deb77c9b2019825eef23df4b08d.mp3*~data=user_id=0,application_id=42~hmac=6a7744d066ae0da0b4552489a68e52521610dbffa303acb0227eadd956ebab2c",
    cover: "https://api.deezer.com/album/11748268/image",
    genre: "Pop",
  },
  {
    title: "Call Me Maybe",
    artist: "Carly Rae Jepsen",
    id: 17826508,
    release_date: "2012-05-14",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/7/2/9/0/7299f5c7f9eaa0570e1f46eac83a9512.mp3?hdnea=exp=1763731662~acl=/api/1/1/7/2/9/0/7299f5c7f9eaa0570e1f46eac83a9512.mp3*~data=user_id=0,application_id=42~hmac=04ede7fc04026947f1bdb29f5054acd8d5f7f475ed94ab8a941413380414c359",
    cover: "https://api.deezer.com/album/1673192/image",
    genre: "Pop",
  },
  {
    title: "Empire State of Mind",
    artist: "Alicia Keys",
    id: 4761593,
    release_date: "2009-12-15",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/f/1/9/0/f1949e2ac936a392d1e6911e11d8f904.mp3?hdnea=exp=1763731662~acl=/api/1/1/f/1/9/0/f1949e2ac936a392d1e6911e11d8f904.mp3*~data=user_id=0,application_id=42~hmac=87c2456316de4aff993470b45663fc55256c7eba4e87909fe0ef8d1cd5062543",
    cover: "https://api.deezer.com/album/438306/image",
    genre: "R&B",
  },
  {
    title: "Wherever You Will Go",
    artist: "The Calling",
    id: 994228,
    release_date: "2001-02-11",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/a/b/d/0/abd0868a31eb93df22bb4b64090f1e0a.mp3?hdnea=exp=1763731662~acl=/api/1/1/a/b/d/0/abd0868a31eb93df22bb4b64090f1e0a.mp3*~data=user_id=0,application_id=42~hmac=9c5bd9cb75aa5838c11a8c5114cc3aa9a735b5370e2ac86e15f2770730ed61f5",
    cover: "https://api.deezer.com/album/110059/image",
    genre: "Pop",
  },
  {
    title: "If You're Not The One",
    artist: "Daniel Bedingfield",
    id: 2319140,
    release_date: "2002-02-07",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/7/4/5/0/7451b62822a604503060b5a22a6f8d94.mp3?hdnea=exp=1763731662~acl=/api/1/1/7/4/5/0/7451b62822a604503060b5a22a6f8d94.mp3*~data=user_id=0,application_id=42~hmac=80fe6cdaa98f9a0d978c9b570ab72c0d049b82d08b6fa0d53f47c09c2b6e4108",
    cover: "https://api.deezer.com/album/230958/image",
    genre: "Pop",
  },
  {
    title: "Gotta Get Thru This",
    artist: "Daniel Bedingfield",
    id: 2298587,
    release_date: "2001-04-14",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/9/9/d/0/99de2ea2cfbba948b203d7775a04458d.mp3?hdnea=exp=1763731662~acl=/api/1/1/9/9/d/0/99de2ea2cfbba948b203d7775a04458d.mp3*~data=user_id=0,application_id=42~hmac=9e43bf885d188946ae5c2ff059c97edabe2baa11b61755d1e23202c9a69134ff",
    cover: "https://api.deezer.com/album/229146/image",
    genre: "Pop",
  },
  {
    title: "Son Of A Preacher Man",
    artist: "Dusty Springfield",
    id: 1104547,
    release_date: "1969-09-30",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/2/4/c/0/24c6fc59f23f0b23dfcc996f8f820833.mp3?hdnea=exp=1763731662~acl=/api/1/1/2/4/c/0/24c6fc59f23f0b23dfcc996f8f820833.mp3*~data=user_id=0,application_id=42~hmac=02930075b420d2eeb9632b4a62718cdb0bbb005328f1ecccf6289c9845c5886d",
    cover: "https://api.deezer.com/album/119137/image",
    genre: "Pop",
  },
  {
    title: "Spooky",
    artist: "Dusty Springfield",
    id: 2267150,
    release_date: "1969-10-01",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/4/8/7/0/487cd5957be2727370fe5d952ae5493d.mp3?hdnea=exp=1763731662~acl=/api/1/1/4/8/7/0/487cd5957be2727370fe5d952ae5493d.mp3*~data=user_id=0,application_id=42~hmac=512c119e83533747aca6b6a66b56b8bfcdec57e8fbfcf28587a151e45c1baedb",
    cover: "https://api.deezer.com/album/226388/image",
    genre: "Pop",
  },
  {
    title: "American Pie",
    artist: "Don McLean",
    id: 3156285,
    release_date: "1971-06-12",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/5a0cfdacfaaa0ba9b514f86f9d69f988/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Kiss The Rain",
    artist: "Billie Myers",
    id: 2298539,
    release_date: "1997-04-05",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/521c96c424f76ba822f09273a7918896/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Somebody That I Used To Know",
    artist: "Gotye",
    id: 14993990,
    release_date: "2011-12-12",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/875e28fbbb3a7b381ffd5839b5905445/250x250-000000-80-0-0.jpg",
    genre: "Alternative",
  },
  {
    title: "Waterfalls",
    artist: "TLC",
    id: 1043894,
    release_date: "1994-11-14",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/3134fd3fba883b4e6c8df8dc1487dbef/250x250-000000-80-0-0.jpg",
    genre: "R&B",
  },
  {
    title: "Unpretty",
    artist: "TLC",
    id: 1076856,
    release_date: "1999-02-22",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/6dd5f40e7688ba155a5ef557977e95d3/250x250-000000-80-0-0.jpg",
    genre: "R&B",
  },
  {
    title: "Creep",
    artist: "TLC",
    id: 1043879,
    release_date: "1993-02-22",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/3134fd3fba883b4e6c8df8dc1487dbef/250x250-000000-80-0-0.jpg",
    genre: "R&B",
  },
  {
    title: "Running on Empty",
    artist: "Jackson Browne",
    id: 3613971,
    release_date: "1977-12-06",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/a5e537dadbff5e3528af1c7ce9495325/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "I Try",
    artist: "Macy Gray",
    id: 15175385,
    release_date: "1999-07-03",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/c68c524bca29e48dff44d2eacb719e43/250x250-000000-80-0-0.jpg",
    genre: "R&B",
  },
  {
    title: "Hey Ya!",
    artist: "OutKast",
    id: 628266,
    release_date: "2003-07-08",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/f81783b6cc6030733cd475f820855562/250x250-000000-80-0-0.jpg",
    genre: "Rap/Hip Hop",
  },
  {
    title: "Writing's On The Wall",
    artist: "Sam Smith",
    id: 107900036,
    release_date: "2015-09-25",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/75e56110a5cef30a4518a075d10ad05e/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "One Day Like This",
    artist: "Elbow",
    id: 1088130,
    release_date: "2008-03-17",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/3b4d06789fb518d736d62244a9363301/250x250-000000-80-0-0.jpg",
    genre: "Alternative",
  },
  {
    title: "Marry You",
    artist: "Bruno Mars",
    id: 8011854,
    release_date: "2010-10-05",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/5b59dc18e109515420f8237719bd2186/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Don't Worry Be Happy",
    artist: "Bobby McFerrin",
    id: 3127387,
    release_date: "1988-09-03",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/121ed33882c127248831b9aacfe5220b/250x250-000000-80-0-0.jpg",
    genre: "",
  },
  {
    title: "Do Your Thing",
    artist: "Basement Jaxx",
    id: 2661885,
    release_date: "2001-06-25",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/c5c187cbbd0265d34859f9116a4cc46d/250x250-000000-80-0-0.jpg",
    genre: "Electro",
  },
  {
    title: "Wind Beneath My Wings",
    artist: "Bette Midler",
    id: 3616256,
    release_date: "1988-03-06",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/30fa0ef71608a98273700307fc40ad59/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Feel Good Inc.",
    artist: "Gorillaz",
    id: 3129407,
    release_date: "2005-05-23",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/8dd837db7a1c6acf7acb20e26c0452c3/250x250-000000-80-0-0.jpg",
    genre: "Rap/Hip Hop",
  },
  {
    title: "DARE",
    artist: "Gorillaz",
    id: 3129413,
    release_date: "2005-05-23",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/8dd837db7a1c6acf7acb20e26c0452c3/250x250-000000-80-0-0.jpg",
    genre: "Rap/Hip Hop",
  },
  {
    title: "We All Stand Together",
    artist: "Paul McCartney",
    id: 1125787962,
    release_date: "1984-11-06",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/b834628a1a37bf798dc6326f68edf50a/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Moondance",
    artist: "Michael Bublé",
    id: 782888,
    release_date: "2003-02-11",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/a5dd92ae1b53ad19f39e3036dd510541/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Beyond the Sea",
    artist: "Bobby Darin",
    id: 3613860,
    release_date: "1958-10-30",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/9193897d1d59fff550bc9cc971a7eb5b/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "The Power Of Love",
    artist: "Huey Lewis & The News",
    id: 3116046,
    release_date: "1985-05-23",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/947835de11de3edaf23440d0078b0a92/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "Raspberry Beret",
    artist: "Prince",
    id: 775712,
    release_date: "1985-04-16",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/52efb13d0fe33002a4079d321f7f9d69/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Price Tag",
    artist: "Jessie J",
    id: 14405185,
    release_date: "2011-11-14",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/2e830d5ee10ad8654e0d8ab70a18e54a/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "If I Were a Boy",
    artist: "Beyoncé",
    id: 2455091,
    release_date: "2008-10-17",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/2a5cc391d209d80a3e3146772c41665c/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Shackles (Praise You)",
    artist: "Mary Mary",
    id: 626167,
    release_date: "2000-04-25",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/00ce09d9b4267630242eb0063a10f3ee/250x250-000000-80-0-0.jpg",
    genre: "Soul",
  },
  {
    title: "Sweet Child O' Mine",
    artist: "Guns N' Roses",
    id: 2171464,
    release_date: "1987-03-18",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/88286a305ec9940bb7099fb5dac0211d/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Higher And Higher",
    artist: "Jackie Wilson",
    id: 558161542,
    release_date: "1967-01-01",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/artist/af0d35bde1677b99e056ec6dfa50b413/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Better in Time",
    artist: "Leona Lewis",
    id: 365070,
    release_date: "2008-03-07",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/884deb9902213e00195d3d696965b080/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "No One",
    artist: "Alicia Keys",
    id: 2466262,
    release_date: "2008-12-29",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/8/c/7/0/8c7ddd4ab2d621d3811f37ea17ae3d65.mp3?hdnea=exp=1763731576~acl=/api/1/1/8/c/7/0/8c7ddd4ab2d621d3811f37ea17ae3d65.mp3*~data=user_id=0,application_id=42~hmac=bc2f5defeabe5673381d9b416977295bcf35e3e62c45ea467eb8aba28cf922d5",
    cover: "https://api.deezer.com/album/242347/image",
    genre: "Pop",
  },
  {
    title: "Leave Right Now",
    artist: "Will Young",
    id: 533992,
    release_date: "2003-12-01",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/2/a/7/0/2a78ef605ccdc4c607332152ff592f16.mp3?hdnea=exp=1763730746~acl=/api/1/1/2/a/7/0/2a78ef605ccdc4c607332152ff592f16.mp3*~data=user_id=0,application_id=42~hmac=44c66bb74b9126e623131bf2261ee9bf87e7cc5ab151acc38d7e4fff98f9675d",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/7eca7c22988937feba5c5ca021f3bb8b/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Since U Been Gone",
    artist: "Kelly Clarkson",
    id: 534076,
    release_date: "2004-11-16",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/0/3/e/0/03e39bcec0db1324fbdab270fdc2390e.mp3?hdnea=exp=1763730746~acl=/api/1/1/0/3/e/0/03e39bcec0db1324fbdab270fdc2390e.mp3*~data=user_id=0,application_id=42~hmac=5d665a49642b87b0048e902ef6b4771276da6273bdca62e55f282376fa0d2a5f",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/ce2a4077de90c1b5c9ce0f46321611a8/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Breakaway",
    artist: "Kelly Clarkson",
    id: 534077,
    release_date: "2009-03-02",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/8/7/2/0/8724114e149891454cd636f84198b9c3.mp3?hdnea=exp=1763730746~acl=/api/1/1/8/7/2/0/8724114e149891454cd636f84198b9c3.mp3*~data=user_id=0,application_id=42~hmac=6b4d851eec72af74ac07d3f1e0d4edfc974b75c436988364ce01c187e741fdde",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/ce2a4077de90c1b5c9ce0f46321611a8/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Behind These Hazel Eyes",
    artist: "Kelly Clarkson",
    id: 534078,
    release_date: "2009-03-02",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/8/0/3/0/8037c7e5163cda32a727cb9e7182865d.mp3?hdnea=exp=1763730746~acl=/api/1/1/8/0/3/0/8037c7e5163cda32a727cb9e7182865d.mp3*~data=user_id=0,application_id=42~hmac=e1eb9a4fd1790d7eb3b5e158e08c880fa6c5da1afb0a0d6cbf870616dcb79a3f",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/ce2a4077de90c1b5c9ce0f46321611a8/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "SexyBack",
    artist: "Justin Timberlake",
    id: 534726,
    release_date: "2006-09-11",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/d83c16b5f7dce9e5db13a350a1a76dd4/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "LoveStoned / I Think She Knows (Interlude)",
    artist: "Justin Timberlake",
    id: 534729,
    release_date: "2006-09-11",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/d83c16b5f7dce9e5db13a350a1a76dd4/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Freestyler",
    artist: "Bomfunk MC's",
    id: 534964,
    release_date: "2000-05-22",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/4/b/d/0/4bd194f51663405a2f4faa896b5ea1fc.mp3?hdnea=exp=1763730746~acl=/api/1/1/4/b/d/0/4bd194f51663405a2f4faa896b5ea1fc.mp3*~data=user_id=0,application_id=42~hmac=fa94e02e8fb6398797869fa37d978023585c4a4928df2c0b7f0a084e8788866f",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/cafda36f44d15143abdb48cd18f604af/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Sweetest Girl (Dollar Bill) (feat. Akon, Lil' Wayne & Niia)",
    artist: "Wyclef Jean",
    id: 536408,
    release_date: "2007-08-14",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/5/8/e/0/58ea38ff0fb696f4c4eab9bc8824ff91.mp3?hdnea=exp=1763730746~acl=/api/1/1/5/8/e/0/58ea38ff0fb696f4c4eab9bc8824ff91.mp3*~data=user_id=0,application_id=42~hmac=c2f02604107ba98e73c6cc6ebfb178dc84920af29b2657221cb84095148498a3",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/2a0fe3540c7fbb9f779c9e6cd12742c3/250x250-000000-80-0-0.jpg",
    genre: "R&B",
  },
  {
    title: "Where I Wanna Be",
    artist: "Donell Jones",
    id: 536926,
    release_date: "2007-09-25",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/6/0/f/0/60f352d937204f1e2961090d4db5af17.mp3?hdnea=exp=1763730746~acl=/api/1/1/6/0/f/0/60f352d937204f1e2961090d4db5af17.mp3*~data=user_id=0,application_id=42~hmac=34027ea06277c6447b292827e676cb5d87551afffe391bb72d4ff3e9d232e177",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/5b5096ef469133260e0f3d3671961ac0/250x250-000000-80-0-0.jpg",
    genre: "R&B",
  },
  {
    title: "(You Drive Me) Crazy",
    artist: "Britney Spears",
    id: 540176,
    release_date: "1999-01-12",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/c/d/4/0/cd46e17449eaf8bc8564dbf5687ef115.mp3?hdnea=exp=1763730746~acl=/api/1/1/c/d/4/0/cd46e17449eaf8bc8564dbf5687ef115.mp3*~data=user_id=0,application_id=42~hmac=ea27864ede1d47fb65ecb93ffb024b6c83eaba45db0b82f91e43cfd07267afc1",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/bd904e47db5549124f099c1fef304dc9/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "I'm a Slave 4 U",
    artist: "Britney Spears",
    id: 540191,
    release_date: "2001-10-31",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/f/c/8/0/fc841e123edee208d47934be557caf65.mp3?hdnea=exp=1763730746~acl=/api/1/1/f/c/8/0/fc841e123edee208d47934be557caf65.mp3*~data=user_id=0,application_id=42~hmac=769c188abf7b72ecaea983648d85d31ccbae06b6dd7f378f48365e2c56e9e549",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/2d38e9d1e1a07e69e0bad3302eeb8722/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "If There's Any Justice",
    artist: "Lemar",
    id: 545245,
    release_date: "2004-11-26",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/4/9/2/0/4925935d4725ec7497f3f387a62fdabc.mp3?hdnea=exp=1763730746~acl=/api/1/1/4/9/2/0/4925935d4725ec7497f3f387a62fdabc.mp3*~data=user_id=0,application_id=42~hmac=5e30cee3a8175d1c7b05fe82b0aac0925f11f8650874adacdf534d1e094c1ef5",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/750053aaba00e32ee83a54cdae111c91/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Because of You",
    artist: "Kelly Clarkson",
    id: 546130,
    release_date: "2009-03-02",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/5/1/9/0/51903d4fda619918a6a3cf59f6c9ff58.mp3?hdnea=exp=1763730746~acl=/api/1/1/5/1/9/0/51903d4fda619918a6a3cf59f6c9ff58.mp3*~data=user_id=0,application_id=42~hmac=fe1976f24ba30fb779e9c982a4756cc565b69ae59880b2e91148b4e92f8c4b79",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/ce2a4077de90c1b5c9ce0f46321611a8/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Stupid Girls",
    artist: "P!nk",
    id: 547530,
    release_date: "2006-04-04",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/e/c/d/0/ecdc229b455c77240dab5136e1526329.mp3?hdnea=exp=1763730746~acl=/api/1/1/e/c/d/0/ecdc229b455c77240dab5136e1526329.mp3*~data=user_id=0,application_id=42~hmac=50c0976c202f793139fc7fb027bd84ca270a4586d34af1c1462f5547da68c466",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/bf22d6537087e34651291f6710879b5b/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "U + Ur Hand",
    artist: "P!nk",
    id: 547538,
    release_date: "2006-04-04",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/1/3/9/0/13973b68814730147b7e4b96a90b3616.mp3?hdnea=exp=1763730746~acl=/api/1/1/1/3/9/0/13973b68814730147b7e4b96a90b3616.mp3*~data=user_id=0,application_id=42~hmac=d10477615c4c59364c026cdf79bb406012bbd1930d6039ba3a8bb86cd1436423",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/bf22d6537087e34651291f6710879b5b/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "That's My Goal",
    artist: "Shayne Ward",
    id: 548274,
    release_date: "2006-04-15",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/28d13129d2b07cce7c1d5cb065924890/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "No Promises",
    artist: "Shayne Ward",
    id: 548275,
    release_date: "2006-04-15",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/28d13129d2b07cce7c1d5cb065924890/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "I'm Sprung",
    artist: "T-Pain",
    id: 548342,
    release_date: "2006-05-06",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/2b95b7733027084f14de832478580fca/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Your Love Alone Is Not Enough (feat. Nina Persson)",
    artist: "Manic Street Preachers",
    id: 550585,
    release_date: "2007-04-20",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/7/1/6/0/71609bb0c2c8b52e4d23787348a88534.mp3?hdnea=exp=1763730746~acl=/api/1/1/7/1/6/0/71609bb0c2c8b52e4d23787348a88534.mp3*~data=user_id=0,application_id=42~hmac=656e5685c33992bb69ee2e811a972ec6ee5712b43672dfcba411914b4a5bf4d7",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/e6435d857d8e6e6c00038f6697e362d5/250x250-000000-80-0-0.jpg",
    genre: "Alternative",
  },
  {
    title: "Here (In Your Arms)",
    artist: "hellogoodbye",
    id: 550951,
    release_date: "2007-05-18",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/f/7/2/0/f728ed37cf0d94886293f63703ad5883.mp3?hdnea=exp=1763730746~acl=/api/1/1/f/7/2/0/f728ed37cf0d94886293f63703ad5883.mp3*~data=user_id=0,application_id=42~hmac=649171f20fe4ae6bb3168f69b7c957554ef987d849fd3a6460e44d65e7b168bf",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/e7748a1b0e617469b151d0b11ae92a41/250x250-000000-80-0-0.jpg",
    genre: "Alternative",
  },
  {
    title: "Beautiful Liar",
    artist: "Beyoncé",
    id: 551207,
    release_date: "2007-04-03",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/e/1/4/0/e146d94ce5dd67daa0e7fee1c49069e2.mp3?hdnea=exp=1763730746~acl=/api/1/1/e/1/4/0/e146d94ce5dd67daa0e7fee1c49069e2.mp3*~data=user_id=0,application_id=42~hmac=e668b80ad069e7edfbec37edb108b84bc7823b4306f139051b64d1f02ee5df2c",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/24aa4e9bed041437c703bd8c9c0b0381/250x250-000000-80-0-0.jpg",
    genre: "R&B",
  },
  {
    title: "Deja Vu (feat. Jay-Z)",
    artist: "Beyoncé",
    id: 551226,
    release_date: "2007-04-03",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/6/8/3/0/6837e9419c9934c4170fad84a6afda2b.mp3?hdnea=exp=1763730746~acl=/api/1/1/6/8/3/0/6837e9419c9934c4170fad84a6afda2b.mp3*~data=user_id=0,application_id=42~hmac=cc4ce1d164d5c9fcb5057b9c6bafdd14701b4d63b0f97fa839c08c4242bfd8dd",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/24aa4e9bed041437c703bd8c9c0b0381/250x250-000000-80-0-0.jpg",
    genre: "R&B",
  },
  {
    title: "Shiver",
    artist: "Natalie Imbruglia",
    id: 554449,
    release_date: "2007-09-05",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/4/b/b/0/4bbb89d827ea5fe4ac2de72992adcfde.mp3?hdnea=exp=1763730746~acl=/api/1/1/4/b/b/0/4bbb89d827ea5fe4ac2de72992adcfde.mp3*~data=user_id=0,application_id=42~hmac=5d48943eb8d8b7c336414c1b9bb0587b80bec3e22f0dd8c06920751f8e8e1394",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/ce07121876070fc4ac134e9111871e5f/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Daughters",
    artist: "John Mayer",
    id: 556646,
    release_date: "2005-06-07",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/9/d/f/0/9df676c06f8de51b0b32f57a3a62c334.mp3?hdnea=exp=1763730746~acl=/api/1/1/9/d/f/0/9df676c06f8de51b0b32f57a3a62c334.mp3*~data=user_id=0,application_id=42~hmac=ed9bc063c6e4083ecc25d9d74b696032d9786adcd96fec78f13a793e2e0ca8a1",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/11414fe73b4ae0a0161254a7f0768e45/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "Caught Up",
    artist: "Usher",
    id: 559923,
    release_date: "2005-04-15",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/e117bee15be4274bf0947339aee7baaf/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Almost Here",
    artist: "Brian McFadden",
    id: 559928,
    release_date: "2005-04-15",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/e117bee15be4274bf0947339aee7baaf/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "We Come 1",
    artist: "Faithless",
    id: 560272,
    release_date: "2005-08-30",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/f/e/0/0/fe00b6326e362838abad54f5d377ada8.mp3?hdnea=exp=1763730746~acl=/api/1/1/f/e/0/0/fe00b6326e362838abad54f5d377ada8.mp3*~data=user_id=0,application_id=42~hmac=e01e9b6928bfef6d1f405f72949a40567fe256e760357c02744007f802b16e83",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/09150c41390667202b0e0d9e7ca10105/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Unwritten",
    artist: "Natasha Bedingfield",
    id: 560504,
    release_date: "2005-05-24",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/0/2/4/0/024cc23064a27d7c3472258cecd8289f.mp3?hdnea=exp=1763730746~acl=/api/1/1/0/2/4/0/024cc23064a27d7c3472258cecd8289f.mp3*~data=user_id=0,application_id=42~hmac=ee02d2597f842a9bcd4e8fe8363b865feda3fc6cf8a8bc291d24b9b5c7f30ccf",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/caa7a44a1dd426f4ceb66f34e82c5b23/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "In the Morning",
    artist: "The Coral",
    id: 560769,
    release_date: "2005-05-23",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/7/e/b/0/7eb72cd4126667ac2ccfb4d2ffa60d02.mp3?hdnea=exp=1763730746~acl=/api/1/1/7/e/b/0/7eb72cd4126667ac2ccfb4d2ffa60d02.mp3*~data=user_id=0,application_id=42~hmac=c951e1dbad537ce0ad2e5bd25db1150ad3d3a5a34aa27865687078201368f6b2",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/5f37b2618e2e5e3e2e8ad26d0b7065cc/250x250-000000-80-0-0.jpg",
    genre: "Alternative",
  },
  {
    title: "Hips Don't Lie (feat. Wyclef Jean)",
    artist: "Shakira",
    id: 562487,
    release_date: "2005-11-28",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/01c2d6152eb73558d91dd955eeba9b5a/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Get Up (feat. Chamillionaire)",
    artist: "Ciara",
    id: 563922,
    release_date: "2006-08-08",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/8/f/8/0/8f8666c49e198325d7c49a5079c3797f.mp3?hdnea=exp=1763730746~acl=/api/1/1/8/f/8/0/8f8666c49e198325d7c49a5079c3797f.mp3*~data=user_id=0,application_id=42~hmac=5a4a2f884557be53f6a93e15d0e3b8e8a46db8875c942c6beb80e5947ab92320",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/ac8bc4c8bfa91949e49c672a012716fa/250x250-000000-80-0-0.jpg",
    genre: "Films/Games",
  },
  {
    title: "The Rose",
    artist: "Westlife",
    id: 566286,
    release_date: "2006-11-13",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/fdeff774266214c2b01c16457a5d5e84/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "He Wasn't Man Enough",
    artist: "Toni Braxton",
    id: 567649,
    release_date: "2000-03-07",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/d2b19f701bbba7a6de9c89f737b7cead/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Un-Break My Heart",
    artist: "Toni Braxton",
    id: 567656,
    release_date: "1993-10-27",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/d2b19f701bbba7a6de9c89f737b7cead/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Differences",
    artist: "Ginuwine",
    id: 567968,
    release_date: "2001-02-10",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/d/9/9/0/d992b8ae4f8eedaebf000d0b06c39af2.mp3?hdnea=exp=1763730747~acl=/api/1/1/d/9/9/0/d992b8ae4f8eedaebf000d0b06c39af2.mp3*~data=user_id=0,application_id=42~hmac=ff5247765d666005d08eebeeed238b9b4f23d969ca55263d319ef1a47bc3409a",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/ee5ef668765cdc1f7900498fb7308c9f/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Oh (feat. Ludacris)",
    artist: "Ciara",
    id: 569201,
    release_date: "2005-01-22",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/e/e/a/0/eea142e52c443d30bd76fe6e9847b8e1.mp3?hdnea=exp=1763730747~acl=/api/1/1/e/e/a/0/eea142e52c443d30bd76fe6e9847b8e1.mp3*~data=user_id=0,application_id=42~hmac=719731137cb2a5eed9dc5d83ae62407a45bf3f993a17a055c4b96d4270fd073d",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/6617b0742476083a5d507097b1f15534/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "1, 2 Step (feat. Missy Elliott)",
    artist: "Ciara",
    id: 569213,
    release_date: "2005-01-22",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/5/3/1/0/5313efff42b5bf1b357636db7709cb87.mp3?hdnea=exp=1763730747~acl=/api/1/1/5/3/1/0/5313efff42b5bf1b357636db7709cb87.mp3*~data=user_id=0,application_id=42~hmac=e005289b40d24085e5e577992dfb5a377a27ee9654f5e1fa3998091c885bc8f8",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/6617b0742476083a5d507097b1f15534/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Let Me Love You",
    artist: "Mario",
    id: 569899,
    release_date: "2016-08-05",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/1/5/4/0/154937fc72ded47ae6277da5bfc7e803.mp3?hdnea=exp=1763730747~acl=/api/1/1/1/5/4/0/154937fc72ded47ae6277da5bfc7e803.mp3*~data=user_id=0,application_id=42~hmac=8ddaea41dfc60c9ed30ddedcb8d45f8bdd54254a03a48f9af7efeb0ba69d017b",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/de4e9b0f4d2ecf01f035369cca257f2c/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Incomplete",
    artist: "Backstreet Boys",
    id: 569913,
    release_date: "2005-08-22",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/5/1/4/0/5148e5a02bad704c0c93bf168c0723cb.mp3?hdnea=exp=1763730747~acl=/api/1/1/5/1/4/0/5148e5a02bad704c0c93bf168c0723cb.mp3*~data=user_id=0,application_id=42~hmac=709ebf69166a2eb4611625ea9914a34538db650f4ac134934a20ff8947b25bec",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/ba145cded08eb7a11b0238e67bce1b0f/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Let Me Hold You (feat. Omarion)",
    artist: "Bow Wow",
    id: 571165,
    release_date: "2005-07-11",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/9/2/2/0/922d011c67e2b5a56107eb834ef70ce6.mp3?hdnea=exp=1763730747~acl=/api/1/1/9/2/2/0/922d011c67e2b5a56107eb834ef70ce6.mp3*~data=user_id=0,application_id=42~hmac=46b137283a62f08ee04b5d904ee31dd6bfdd502482f7410ff5838bf7b2b142f9",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/cc60ec982e6ed18e19a3ac1e373ee591/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Like You (feat. Ciara)",
    artist: "Bow Wow",
    id: 571541,
    release_date: "2005-07-11",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/a/a/e/0/aae8b5bd3973846ea641dbf25fb411de.mp3?hdnea=exp=1763730747~acl=/api/1/1/a/a/e/0/aae8b5bd3973846ea641dbf25fb411de.mp3*~data=user_id=0,application_id=42~hmac=e072b44338788c71b16c66ff0523d4d2e07f9c0d240bac7ae75b34f3ade598a0",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/cc60ec982e6ed18e19a3ac1e373ee591/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "You Raise Me Up",
    artist: "Westlife",
    id: 574866,
    release_date: "2005-10-24",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/3ba1d4127c23a779d95fa2986eb9d1ef/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Left Outside Alone",
    artist: "Anastacia",
    id: 575228,
    release_date: "2005-10-25",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/a/d/b/0/adb8db06d6bcc47288f779500eb5c070.mp3?hdnea=exp=1763730747~acl=/api/1/1/a/d/b/0/adb8db06d6bcc47288f779500eb5c070.mp3*~data=user_id=0,application_id=42~hmac=379dc3b4859a9729efb50516682e6f962767f64b5ee2c0313f9069b3769c0a52",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/adcc3162f6abf31d2ddcffe5f0887694/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Ordinary People",
    artist: "John Legend",
    id: 576284,
    release_date: "2005-11-07",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/d/2/3/0/d2372054b10e5f408a1e210aa5f0ba38.mp3?hdnea=exp=1763730747~acl=/api/1/1/d/2/3/0/d2372054b10e5f408a1e210aa5f0ba38.mp3*~data=user_id=0,application_id=42~hmac=207407796ab749817f05f6b2054bbac2dd347da76e691e4618939e998315cef1",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/ed44612066b98bfed7ff97669e6f6103/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Girlfriend",
    artist: "Avril Lavigne",
    id: 580029,
    release_date: "2007-02-23",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/00a46b9642435935f18df29c937eb0e2/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Bills, Bills, Bills",
    artist: "Destiny's Child",
    id: 580889,
    release_date: "1999-07-27",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/f/8/d/0/f8d14ec39bee9157d401e065ef488e00.mp3?hdnea=exp=1763730747~acl=/api/1/1/f/8/d/0/f8d14ec39bee9157d401e065ef488e00.mp3*~data=user_id=0,application_id=42~hmac=76aa1a91175749dc17437ebd26b03f1406bba0c1439f0c410cfd837c34be541c",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/73da200f9335f752d2f7cb5ed8933cef/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Jumpin', Jumpin'",
    artist: "Destiny's Child",
    id: 580931,
    release_date: "1999-07-27",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/8/b/e/0/8bea816f389c181898e362b362efd235.mp3?hdnea=exp=1763730747~acl=/api/1/1/8/b/e/0/8bea816f389c181898e362b362efd235.mp3*~data=user_id=0,application_id=42~hmac=f7488db8ee8772f27511c5a228101e88b8206351b781ab735efc1cc90de39132",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/73da200f9335f752d2f7cb5ed8933cef/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Say My Name",
    artist: "Destiny's Child",
    id: 580936,
    release_date: "1999-07-27",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/b/c/0/0/bc0df105bf6fd096d9c77d22f76b7ced.mp3?hdnea=exp=1763730747~acl=/api/1/1/b/c/0/0/bc0df105bf6fd096d9c77d22f76b7ced.mp3*~data=user_id=0,application_id=42~hmac=ab46255899f7b27d1742cb1b46d9edf0683a1e6233d4bad4d6b28b9db62fee02",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/73da200f9335f752d2f7cb5ed8933cef/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Soldier (feat. T.I. & Lil' Wayne)",
    artist: "Destiny's Child",
    id: 581082,
    release_date: "2004-11-16",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/0/2/f/0/02f79b07e0133702561065ec8e2dca06.mp3?hdnea=exp=1763730747~acl=/api/1/1/0/2/f/0/02f79b07e0133702561065ec8e2dca06.mp3*~data=user_id=0,application_id=42~hmac=5ed85d4f998fde83389d59f1a795bd8152347b2a96e860f7cd49b72dd0f44b7a",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/a834c91eee2bb719f89287aa6d93ff51/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Cater 2 U",
    artist: "Destiny's Child",
    id: 581085,
    release_date: "2004-11-16",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/6/c/2/0/6c27f176c4705d37d0e7074cd5b16d79.mp3?hdnea=exp=1763730747~acl=/api/1/1/6/c/2/0/6c27f176c4705d37d0e7074cd5b16d79.mp3*~data=user_id=0,application_id=42~hmac=3bc8130e6eaadc7f1bcb9612a1154207da3f370a5c366c1f89076dbff3955b90",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/a834c91eee2bb719f89287aa6d93ff51/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Girl",
    artist: "Destiny's Child",
    id: 581095,
    release_date: "2004-11-16",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/0/8/6/0/086d15e7d65f7a85bf31c09603d61e8d.mp3?hdnea=exp=1763730747~acl=/api/1/1/0/8/6/0/086d15e7d65f7a85bf31c09603d61e8d.mp3*~data=user_id=0,application_id=42~hmac=d687a01a3adb4e2072b405dd28d3f8e32da684111d16ad663b2283dbbb4500cf",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/a834c91eee2bb719f89287aa6d93ff51/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "My Prerogative",
    artist: "Britney Spears",
    id: 582250,
    release_date: "2004-11-08",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/0/4/3/0/04312b3ddae13866f6f838ff0b42734b.mp3?hdnea=exp=1763730747~acl=/api/1/1/0/4/3/0/04312b3ddae13866f6f838ff0b42734b.mp3*~data=user_id=0,application_id=42~hmac=cc612aa621e2f4c5d617cde5bbdeab3f1b6fe6257a0eb07ddc1982e407d6bd79",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/34265ac018fe0d973eac131fe04038a2/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Lucky",
    artist: "Britney Spears",
    id: 582261,
    release_date: "2004-11-08",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/34265ac018fe0d973eac131fe04038a2/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Run It! (Featuring Juelz Santana)",
    artist: "Chris Brown",
    id: 583392,
    release_date: "2006-01-30",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/08715753a44fedb76cb597ed4b1b9c2f/250x250-000000-80-0-0.jpg",
    genre: "Rap/Hip Hop",
  },
  {
    title: "With You",
    artist: "Jessica Simpson",
    id: 587102,
    release_date: "2004-04-16",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/ed8ed0f4e9dcc54379b5cf18dec1f2bf/250x250-000000-80-0-0.jpg",
    genre: "Dance",
  },
  {
    title: "Thank God I Found You",
    artist: "Mariah Carey",
    id: 596072,
    release_date: "2007-11-08",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/0/7/1/0/07136d14934539f1344d33d64856d569.mp3?hdnea=exp=1763730155~acl=/api/1/1/0/7/1/0/07136d14934539f1344d33d64856d569.mp3*~data=user_id=0,application_id=42~hmac=efa60b268f6dd569f0210946ac86f8a059b7f02f2ca6274913e17cd577576955",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/6a1aeef41619907cc283d4eb1eac2fe6/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Naughty Girl",
    artist: "Beyoncé",
    id: 597856,
    release_date: "2004-05-03",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/c/f/0/0/cf01c6f32db9f8f519e36e2d18f22322.mp3?hdnea=exp=1763730155~acl=/api/1/1/c/f/0/0/cf01c6f32db9f8f519e36e2d18f22322.mp3*~data=user_id=0,application_id=42~hmac=b8865fff2248a7d267dd6098731013da6cbdacfedc01588c947eab80f9c029b0",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/d0d05e7449b21e78bc278e69d82bb15e/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Yeah!",
    artist: "Usher",
    id: 598098,
    release_date: "1998-12-30",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/1e7239aacd1d85071238906aef97e5d7/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Burn (Confession Special Edition Version)",
    artist: "Usher",
    id: 598697,
    release_date: "1998-12-30",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/1e7239aacd1d85071238906aef97e5d7/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "My Boo",
    artist: "Usher",
    id: 601626,
    release_date: "2004-08-31",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/5/3/d/0/53dc462a7b8f1d4a80d13ad2c328464e.mp3?hdnea=exp=1763730155~acl=/api/1/1/5/3/d/0/53dc462a7b8f1d4a80d13ad2c328464e.mp3*~data=user_id=0,application_id=42~hmac=14677e2982958f5468b2cb61873a08eeffdab277d55b7a307fdc776b0bde1d0e",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/4c81883cd6884abb66cee03c49d8bbba/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "I Don't Want to Be",
    artist: "Gavin DeGraw",
    id: 604745,
    release_date: "2010-02-10",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/c/6/9/0/c691b39b4c2c4f3c72a23fae4717e73c.mp3?hdnea=exp=1763730155~acl=/api/1/1/c/6/9/0/c691b39b4c2c4f3c72a23fae4717e73c.mp3*~data=user_id=0,application_id=42~hmac=4084044d75a87ef47240bc7d914adba6922785ad349b7c15f6c25ee0e5962ac2",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/d2e9db3150f9445ca440f9fb6236a9e8/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Perfect Gentleman (feat. Hope)",
    artist: "Wyclef Jean",
    id: 605281,
    release_date: "2001-01-01",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/6/d/1/0/6d17ec4b291ad6654be902faea0e58bb.mp3?hdnea=exp=1763730155~acl=/api/1/1/6/d/1/0/6d17ec4b291ad6654be902faea0e58bb.mp3*~data=user_id=0,application_id=42~hmac=4e44d987a35df9069b46269c0f47b5eea5e8f47c6ed419b5dd293abd53d224b4",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/ecc59f47a8994ef8064e8cc5f3143f34/250x250-000000-80-0-0.jpg",
    genre: "Country",
  },
  {
    title: "As I Lay Me Down",
    artist: "Sophie B. Hawkins",
    id: 609209,
    release_date: "1995-04-10",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/0/c/7/0/0c74c1864bab78a54cc4fa910b8d1fb5.mp3?hdnea=exp=1763730155~acl=/api/1/1/0/c/7/0/0c74c1864bab78a54cc4fa910b8d1fb5.mp3*~data=user_id=0,application_id=42~hmac=e0d3899e6a4b91c572e1e13913dd4c387a73136ce6a80d7cf97a6b05f2b9cbb1",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/0ce55751a923cce517d8909616b19ea0/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Hemorrhage (In My Hands)",
    artist: "Fuel",
    id: 610171,
    release_date: "2005-12-13",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/6/7/5/0/67567dbac484782247a967084d2ffa29.mp3?hdnea=exp=1763730155~acl=/api/1/1/6/7/5/0/67567dbac484782247a967084d2ffa29.mp3*~data=user_id=0,application_id=42~hmac=b07f10be9e1123ebc350ea604e0a4cee4529ee98223667fc388a99c7f4aac7d5",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/413c48599e2bea7e876e0398a10e25d2/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "100 Years",
    artist: "Five For Fighting",
    id: 610989,
    release_date: "2004-02-03",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/1/e/6/0/1e678cdcb3dc427e3dc9ea558ae615ba.mp3?hdnea=exp=1763730155~acl=/api/1/1/1/e/6/0/1e678cdcb3dc427e3dc9ea558ae615ba.mp3*~data=user_id=0,application_id=42~hmac=1b1ce19f0cb1145426de5adbfe703a789cfc013b3d0a19f8b902f603757b2af8",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/9d2527c0b451d0ef5753a9fa136631a0/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "Amazing",
    artist: "George Michael",
    id: 615851,
    release_date: "1987-03-29",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/e/4/5/0/e45b0e4fa2e8a8e8b40d237bef8b2671.mp3?hdnea=exp=1763730155~acl=/api/1/1/e/4/5/0/e45b0e4fa2e8a8e8b40d237bef8b2671.mp3*~data=user_id=0,application_id=42~hmac=6fb4117920dcbadd5aa7147143f0de993148976c8c8bc543a38292d3253d8c2b",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/29a3a921a0ae284b7530cdb563e182ae/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Play",
    artist: "Jennifer Lopez",
    id: 618321,
    release_date: "2003-09-15",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/0/9/f/0/09f5b545f762d361cb14a831590a84c1.mp3?hdnea=exp=1763730155~acl=/api/1/1/0/9/f/0/09f5b545f762d361cb14a831590a84c1.mp3*~data=user_id=0,application_id=42~hmac=259ac8a86eeb9b76861cceddac912b5c418629dbfe37cec75a6f3187e898bd6a",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/c6385c391e17a1c16beccb7ef7da976f/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "I'm Real (feat. Ja Rule) (Murder Remix)",
    artist: "Jennifer Lopez",
    id: 618363,
    release_date: "2003-09-15",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/b/3/a/0/b3a0a654fa5c6366ca240a46ea692951.mp3?hdnea=exp=1763730155~acl=/api/1/1/b/3/a/0/b3a0a654fa5c6366ca240a46ea692951.mp3*~data=user_id=0,application_id=42~hmac=25a06ffcbeddf1c8e56064ea4798c999d4a01414a0c39736cf86c2625afdd88d",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/c6385c391e17a1c16beccb7ef7da976f/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "You Rock My World (with intro)",
    artist: "Michael Jackson",
    id: 619622,
    release_date: "2001-08-22",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/6/b/f/0/6bfde036cf159215613740704c21ab55.mp3?hdnea=exp=1763730155~acl=/api/1/1/6/b/f/0/6bfde036cf159215613740704c21ab55.mp3*~data=user_id=0,application_id=42~hmac=20353fa29509db31ae217a9ce7cd4daaa7bf90bfa5d6319a3ebe282f97a5ced2",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/0381446a7083728f88374afece0fec3b/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Don't Think I'm Not",
    artist: "Kandi",
    id: 623397,
    release_date: "2000-09-12",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/7/b/7/0/7b71a2af9089c0d9058e7af1de272293.mp3?hdnea=exp=1763730155~acl=/api/1/1/7/b/7/0/7b71a2af9089c0d9058e7af1de272293.mp3*~data=user_id=0,application_id=42~hmac=bc909af7681865af7ae7b5309da90bc5a8b44b027a47bca6e667b816e5000cbe",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/8dd57119003dca89a0af02200e22579d/250x250-000000-80-0-0.jpg",
    genre: "R&B",
  },
  {
    title: "She's so High",
    artist: "Tal Bachman",
    id: 623469,
    release_date: "1999-02-23",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/f/4/e/0/f4e9fe4e647733c08dcf23bcb58c8843.mp3?hdnea=exp=1763730155~acl=/api/1/1/f/4/e/0/f4e9fe4e647733c08dcf23bcb58c8843.mp3*~data=user_id=0,application_id=42~hmac=3bb2bb9c39819a26dce3932457e2c4bf55374343d7be473ead630c7a13c1c7dc",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/8750a18d11333dd0aa37c7876b17edb3/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "Promise",
    artist: "Jagged Edge",
    id: 623717,
    release_date: "2012-10-19",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/e/6/9/0/e690867d75283da028ce85e893d7f820.mp3?hdnea=exp=1763730155~acl=/api/1/1/e/6/9/0/e690867d75283da028ce85e893d7f820.mp3*~data=user_id=0,application_id=42~hmac=436a0acfcc6977cdae84969088016f20604d81f608071ddfd8c817453b400cb1",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/5a7bedce12f57e199780c05afd7a6e0b/250x250-000000-80-0-0.jpg",
    genre: "R&B",
  },
  {
    title: "Absolutely (Story of a Girl)",
    artist: "Nine Days",
    id: 624080,
    release_date: "2000-05-16",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/d/1/6/0/d16b12d7df31c656769cd6a1443d4615.mp3?hdnea=exp=1763730155~acl=/api/1/1/d/1/6/0/d16b12d7df31c656769cd6a1443d4615.mp3*~data=user_id=0,application_id=42~hmac=c1af6548c41b52e48241bb9961f5863f4078c367e8c5b7fa7f16548a39650b11",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/37dd9d0fff31cfa168d855e1d21ebda5/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "He Can't Love U",
    artist: "Jagged Edge",
    id: 624575,
    release_date: "1999-11-01",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/7/8/f/0/78f8da95c60d03de0709868eafccea4a.mp3?hdnea=exp=1763730155~acl=/api/1/1/7/8/f/0/78f8da95c60d03de0709868eafccea4a.mp3*~data=user_id=0,application_id=42~hmac=53adaa56360715eb81c91c6b2dace9e96de8e5c657ccd959eec81fedc70624b1",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/5a7bedce12f57e199780c05afd7a6e0b/250x250-000000-80-0-0.jpg",
    genre: "R&B",
  },
  {
    title: "Irresistible (Album Version)",
    artist: "Jessica Simpson",
    id: 624711,
    release_date: "2001-06-05",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/3/2/b/0/32b246ac3cd6dac17364e182a5d0b820.mp3?hdnea=exp=1763730155~acl=/api/1/1/3/2/b/0/32b246ac3cd6dac17364e182a5d0b820.mp3*~data=user_id=0,application_id=42~hmac=24315e4e6c2710b11582bd266e4d1071201e690c7936be2c10b23e520a16b42c",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/cea5fda2b6250f0db5e17a3950873101/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Let's Get Married",
    artist: "Jagged Edge",
    id: 625038,
    release_date: "1999-11-01",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/e/0/0/0/e00fa04d1a4e99d7eff66bef1dc6cbfc.mp3?hdnea=exp=1763730155~acl=/api/1/1/e/0/0/0/e00fa04d1a4e99d7eff66bef1dc6cbfc.mp3*~data=user_id=0,application_id=42~hmac=67d7c9758ee55b6c8eb7240230ae145e103a66b99d4aa196fc55056ef078e079",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/5a7bedce12f57e199780c05afd7a6e0b/250x250-000000-80-0-0.jpg",
    genre: "R&B",
  },
  {
    title: "So Anxious",
    artist: "Ginuwine",
    id: 625436,
    release_date: "1999-03-15",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/5/4/0/0/5400eabc93404c1a222a8ac22944f45b.mp3?hdnea=exp=1763730155~acl=/api/1/1/5/4/0/0/5400eabc93404c1a222a8ac22944f45b.mp3*~data=user_id=0,application_id=42~hmac=d51ce2b5c876913c2715d35ae4a639f35bebb19889768942fc85fefdba865492",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/d50f36228bc318f8d7b3f2c42b250df7/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "No More",
    artist: "Ruff Endz",
    id: 625939,
    release_date: "2000-08-22",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/2/b/f/0/2bfb01592286dd04de4194f6c0c34bd7.mp3?hdnea=exp=1763730155~acl=/api/1/1/2/b/f/0/2bfb01592286dd04de4194f6c0c34bd7.mp3*~data=user_id=0,application_id=42~hmac=80beef601f86fbe3eb07c536fd1e1109140f7fe23c67505ecdcfe78fe4b975a8",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/96a8d09d250f0d8833b0eebe122bcef7/250x250-000000-80-0-0.jpg",
    genre: "R&B",
  },
  {
    title: "Miss You Love",
    artist: "Silverchair",
    id: 627797,
    release_date: "1999-03-22",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/0/1/8/0/018c266d8cad8904794a8c41b2cf7997.mp3?hdnea=exp=1763730155~acl=/api/1/1/0/1/8/0/018c266d8cad8904794a8c41b2cf7997.mp3*~data=user_id=0,application_id=42~hmac=0194e0a9a8debabff75a94946a69711f773d5f516f79d1a32750a6516acafd45",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/e337fd1e6628e800e9302e8f14364291/250x250-000000-80-0-0.jpg",
    genre: "Alternative",
  },
  {
    title: "The Way You Move (feat. Sleepy Brown)",
    artist: "OutKast",
    id: 628247,
    release_date: "2003-09-23",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/8/e/7/0/8e7c4962ab5503f50f3ab20e86631924.mp3?hdnea=exp=1763730155~acl=/api/1/1/8/e/7/0/8e7c4962ab5503f50f3ab20e86631924.mp3*~data=user_id=0,application_id=42~hmac=09c8f759932a6e8afc7160e32a468099a19edb918b42b9c305e49fb379e02777",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/f81783b6cc6030733cd475f820855562/250x250-000000-80-0-0.jpg",
    genre: "Rap/Hip Hop",
  },
  {
    title: "Roses",
    artist: "OutKast",
    id: 628267,
    release_date: "2003-09-23",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/8/b/b/0/8bbef80f9195d1a74af27d546fab9794.mp3?hdnea=exp=1763730155~acl=/api/1/1/8/b/b/0/8bbef80f9195d1a74af27d546fab9794.mp3*~data=user_id=0,application_id=42~hmac=86a19abe9dd7955fb018b586647e724eb0273c768b46abda793165f803c7b7a3",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/f81783b6cc6030733cd475f820855562/250x250-000000-80-0-0.jpg",
    genre: "Rap/Hip Hop",
  },
  {
    title: "Fiesta (feat. Jay-Z, Boo & Gotti) (Remix)",
    artist: "R. Kelly",
    id: 629328,
    release_date: "2003-09-23",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/5/3/0/0/530f109473e8ddf6a78fb6c6a9a94a58.mp3?hdnea=exp=1763730155~acl=/api/1/1/5/3/0/0/530f109473e8ddf6a78fb6c6a9a94a58.mp3*~data=user_id=0,application_id=42~hmac=8ae9c441b7b2658b5c94c4c1d5e37accd7b81d09352a0980b828c318a8b68dc8",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/dc7637895e982429854e76d654fbf0fc/250x250-000000-80-0-0.jpg",
    genre: "R&B",
  },
  {
    title: "Karma",
    artist: "Alicia Keys",
    id: 629460,
    release_date: "2003-12-02",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/9/0/4/0/90401f5055c132466593028f0faadf39.mp3?hdnea=exp=1763730155~acl=/api/1/1/9/0/4/0/90401f5055c132466593028f0faadf39.mp3*~data=user_id=0,application_id=42~hmac=8894957f83c754760429086ac3118c5ba0129b2671485198dae03665b5f14e4c",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/cef30c1c2a5a63c773d26d56049c81e5/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "If I Ain't Got You",
    artist: "Alicia Keys",
    id: 629466,
    release_date: "2003-12-02",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/7/1/0/0/710b6e1d578419376acaa766454d5686.mp3?hdnea=exp=1763730155~acl=/api/1/1/7/1/0/0/710b6e1d578419376acaa766454d5686.mp3*~data=user_id=0,application_id=42~hmac=55fb617be5ff8a80bff4db8cba2cd73bab8546eae72a0746739913c00081fda0",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/cef30c1c2a5a63c773d26d56049c81e5/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "It's Gonna Be Me",
    artist: "*NSYNC",
    id: 632488,
    release_date: "2000-03-21",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/6/1/2/0/612e2acf027a8812fe7c33dd759b97b7.mp3?hdnea=exp=1763730155~acl=/api/1/1/6/1/2/0/612e2acf027a8812fe7c33dd759b97b7.mp3*~data=user_id=0,application_id=42~hmac=22c1b2f66306cce153a4d11591b6a988e2e44849257426911dd6afd50f53b8f8",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/01fdca2ecf54d678ff005162b5b6cc92/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "You're Making Me High",
    artist: "Toni Braxton",
    id: 632934,
    release_date: "1996-05-27",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/2/c/6/0/2c6530a61c347a7ecfa1aa66b2f1edef.mp3?hdnea=exp=1763730155~acl=/api/1/1/2/c/6/0/2c6530a61c347a7ecfa1aa66b2f1edef.mp3*~data=user_id=0,application_id=42~hmac=371f6fbc6f66302a0fdf1003210358c2dc9b4db48fd2213c0af917825906b97b",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/879e6b0a21327acd4160cf89322aec52/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Gone",
    artist: "*NSYNC",
    id: 633123,
    release_date: "2001-07-24",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/e/4/e/0/e4eb044d06e5afa96003658f85c2438a.mp3?hdnea=exp=1763730155~acl=/api/1/1/e/4/e/0/e4eb044d06e5afa96003658f85c2438a.mp3*~data=user_id=0,application_id=42~hmac=6df34318aa383ad64bde8759e1f899b424164e0c5eab5e3f42a6d262793bbe3d",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/9c86390863bc26a71e43318402a8d293/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Sick and Tired",
    artist: "Anastacia",
    id: 638409,
    release_date: "2001-01-01",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/f/0/4/0/f04a3c433024b6b154ea59cebf835b27.mp3?hdnea=exp=1763730155~acl=/api/1/1/f/0/4/0/f04a3c433024b6b154ea59cebf835b27.mp3*~data=user_id=0,application_id=42~hmac=9611463f0eb88c3fa316349f56760c19954757020c665e159a3f163f2233e5c1",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/e550f19538f883c6663e1f1da24b7359/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Rockstar",
    artist: "Nickelback",
    id: 660849,
    release_date: "2005-09-26",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/6/6/f/0/66f019c1322f35072feb6dc56943376f.mp3?hdnea=exp=1763730155~acl=/api/1/1/6/6/f/0/66f019c1322f35072feb6dc56943376f.mp3*~data=user_id=0,application_id=42~hmac=7d5100cb73259c2e99bd20e53b9f33ebe2a0f1043f2f6e4b564f7f35058502fc",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/a0174acbb7bc72ba56b3ff7212829f18/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "Slow Jamz (feat. Kanye West & Jamie Foxx)",
    artist: "Twista",
    id: 661912,
    release_date: "2004-01-27",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/2/1/f/0/21f59c1cc4c70a5f3bd76ffbaa319e2f.mp3?hdnea=exp=1763730155~acl=/api/1/1/2/1/f/0/21f59c1cc4c70a5f3bd76ffbaa319e2f.mp3*~data=user_id=0,application_id=42~hmac=195303dca73b2cdf4c462b1fee1e66eb2b55a1fc1d0974dbc416f69c335ef70d",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/9636c9851c45fbd87352a4563b35d19e/250x250-000000-80-0-0.jpg",
    genre: "Rap/Hip Hop",
  },
  {
    title: "Lonely No More",
    artist: "Rob Thomas",
    id: 662287,
    release_date: "2005-04-05",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/e/7/2/0/e7218f9cd09c2cc96f63824d50fc16b1.mp3?hdnea=exp=1763730155~acl=/api/1/1/e/7/2/0/e7218f9cd09c2cc96f63824d50fc16b1.mp3*~data=user_id=0,application_id=42~hmac=8f2591d0147d68dc25d72e0f28b08ae7726c47dbdb9c203cdc1bcc7e225d936d",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/4131b7189ac8cd75bd2568f7f4230107/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Lose Control (feat. Ciara & Fat Man Scoop)",
    artist: "Missy Elliott",
    id: 662589,
    release_date: "2005-07-04",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/9/d/d/0/9dd0d22539b99165e1f573bddfe09345.mp3?hdnea=exp=1763730155~acl=/api/1/1/9/d/d/0/9dd0d22539b99165e1f573bddfe09345.mp3*~data=user_id=0,application_id=42~hmac=024ad6931749aac9f2965ab963757ad2bcdcd4e0be2c07ebf46965247458a78b",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/1674494e6fb1c319cc333de15a57f82c/250x250-000000-80-0-0.jpg",
    genre: "Rap/Hip Hop",
  },
  {
    title: "Grind With Me",
    artist: "Pretty Ricky",
    id: 662685,
    release_date: "2005-05-17",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/4/4/0/0/44061b133bc4afe5aad820826f11886b.mp3?hdnea=exp=1763730155~acl=/api/1/1/4/4/0/0/44061b133bc4afe5aad820826f11886b.mp3*~data=user_id=0,application_id=42~hmac=9bb1a2e6ce0d63f3accdbb73122c17129a418c286fd6b2c29924181cc3a001aa",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/c137a3eed7a76f3fedb08bc7f07450eb/250x250-000000-80-0-0.jpg",
    genre: "Rap/Hip Hop",
  },
  {
    title: "1973",
    artist: "James Blunt",
    id: 663476,
    release_date: "2007-07-24",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/5/8/b/0/58b44200aff72144b9d9625aa5216c37.mp3?hdnea=exp=1763730155~acl=/api/1/1/5/8/b/0/58b44200aff72144b9d9625aa5216c37.mp3*~data=user_id=0,application_id=42~hmac=cfdc118dc0c41d4f6cafb50b481c9f8489bd5d0c139f47905c7fb42553affca2",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/d338414b056a7afd5ba7313c40df77da/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Diamonds and Pearls",
    artist: "Prince",
    id: 664140,
    release_date: "2009-01-24",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/b/e/3/0/be37dba539fb4cfda915d7a6ee5625e4.mp3?hdnea=exp=1763730155~acl=/api/1/1/b/e/3/0/be37dba539fb4cfda915d7a6ee5625e4.mp3*~data=user_id=0,application_id=42~hmac=a9b7c0bc8ffe926a67101ccef1d0a7425596d8b786f1cef31ba69e1143872387",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/69e3f69ae975e0e25b241d5a066c0ba2/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Cream",
    artist: "Prince",
    id: 664142,
    release_date: "2009-01-24",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/e/6/0/0/e6007e887589498e0247f9f8e484748a.mp3?hdnea=exp=1763730155~acl=/api/1/1/e/6/0/0/e6007e887589498e0247f9f8e484748a.mp3*~data=user_id=0,application_id=42~hmac=abeb7fa3d90b7e63fb8f0b8b44b98ab80762ca26a3f753be3f5c62e5cb11a7ae",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/69e3f69ae975e0e25b241d5a066c0ba2/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "One Minute Man (feat. Ludacris)",
    artist: "Missy Elliott",
    id: 671138,
    release_date: "2001-05-14",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/9/a/1/0/9a1e9253ea673d6fd55e451ef0774f28.mp3?hdnea=exp=1763730155~acl=/api/1/1/9/a/1/0/9a1e9253ea673d6fd55e451ef0774f28.mp3*~data=user_id=0,application_id=42~hmac=bbd06984c0ab7ad0160282f1d3ad4392028a07656db9a6bc079ef2570b134e1b",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/d506a6d8b28483240daee6f379fd866c/250x250-000000-80-0-0.jpg",
    genre: "R&B",
  },
  {
    title: "Get Ur Freak On",
    artist: "Missy Elliott",
    id: 671140,
    release_date: "2001-05-14",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/5/f/d/0/5fd79ff7d704b7f5d191d9e0fcfecb78.mp3?hdnea=exp=1763730155~acl=/api/1/1/5/f/d/0/5fd79ff7d704b7f5d191d9e0fcfecb78.mp3*~data=user_id=0,application_id=42~hmac=5ef7baed08462f566e4e79dfae6866700db779ef2bb2b89837bbf8b263c4fffd",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/d506a6d8b28483240daee6f379fd866c/250x250-000000-80-0-0.jpg",
    genre: "R&B",
  },
  {
    title: "Saltwater",
    artist: "Julian Lennon",
    id: 675227,
    release_date: "1991-08-06",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/b/c/6/0/bc6b9cb891e3ba66e88ec2af78c4859d.mp3?hdnea=exp=1763730155~acl=/api/1/1/b/c/6/0/bc6b9cb891e3ba66e88ec2af78c4859d.mp3*~data=user_id=0,application_id=42~hmac=7f079a0ca68b799160f0061d49f5174f84ce32ab771bbd1024a1e06b380f6e3a",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/7fdc7c762fe31b72609e8b3ce8936fb1/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "In the End",
    artist: "Linkin Park",
    id: 676183,
    release_date: "2000-10-24",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/9/b/3/0/9b3b33fa47f00eb43729de30e8027afa.mp3?hdnea=exp=1763730155~acl=/api/1/1/9/b/3/0/9b3b33fa47f00eb43729de30e8027afa.mp3*~data=user_id=0,application_id=42~hmac=58af70097af61d9b2ea1063eead0ac7c039fbd21b3778fe112a64086c08da7e8",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/033a271b5ec10842c287827c39244fb5/250x250-000000-80-0-0.jpg",
    genre: "Alternative",
  },
  {
    title: "Welcome to the Black Parade",
    artist: "My Chemical Romance",
    id: 676573,
    release_date: "2006-10-23",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/6/3/4/0/6345c2ae4a80adf6c11e50ee66bd62bb.mp3?hdnea=exp=1763730155~acl=/api/1/1/6/3/4/0/6345c2ae4a80adf6c11e50ee66bd62bb.mp3*~data=user_id=0,application_id=42~hmac=79861c143594cf108c542f402f0f4794549c30ab12ec248116fc1e353da6b6b0",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/ae78cd7f32230593392c8b76519e9044/250x250-000000-80-0-0.jpg",
    genre: "Alternative",
  },
  {
    title: "Teenagers",
    artist: "My Chemical Romance",
    id: 676590,
    release_date: "2006-10-23",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/c/d/9/0/cd98f219dc34fb93658afaaec8d380e7.mp3?hdnea=exp=1763730155~acl=/api/1/1/c/d/9/0/cd98f219dc34fb93658afaaec8d380e7.mp3*~data=user_id=0,application_id=42~hmac=d3ebaffe9ebd8edeef4c01e15ce18ec532a943665f8dbf6f04d567b1fd673169",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/ae78cd7f32230593392c8b76519e9044/250x250-000000-80-0-0.jpg",
    genre: "Alternative",
  },
  {
    title: "Shadow of the Day",
    artist: "Linkin Park",
    id: 676844,
    release_date: "2007-05-14",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/8/8/f/0/88feadeb7cb12fa7c26ba0b8d83ebd17.mp3?hdnea=exp=1763730155~acl=/api/1/1/8/8/f/0/88feadeb7cb12fa7c26ba0b8d83ebd17.mp3*~data=user_id=0,application_id=42~hmac=5898e3e12131547a336d447c3ab3360312df84c2c5cdec72b2ef41184f24996c",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/2dd699adcd68089f49f3ab558a2bd296/250x250-000000-80-0-0.jpg",
    genre: "Alternative",
  },
  {
    title: "What I've Done",
    artist: "Linkin Park",
    id: 676847,
    release_date: "2007-05-14",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/4/d/8/0/4d87a610f292bf82a5571f52950f302a.mp3?hdnea=exp=1763730155~acl=/api/1/1/4/d/8/0/4d87a610f292bf82a5571f52950f302a.mp3*~data=user_id=0,application_id=42~hmac=55d099c8fd0c2a352b8854f6d0d8677d3aee2fc9b4e415c24f2a71883b88dad4",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/2dd699adcd68089f49f3ab558a2bd296/250x250-000000-80-0-0.jpg",
    genre: "Alternative",
  },
  {
    title: "Numb / Encore",
    artist: "JAY-Z",
    id: 676954,
    release_date: "2004-11-30",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/6/e/8/0/6e8d0e1d66889d80c8259388855f3884.mp3?hdnea=exp=1763730155~acl=/api/1/1/6/e/8/0/6e8d0e1d66889d80c8259388855f3884.mp3*~data=user_id=0,application_id=42~hmac=ff9e34da4b912a0945b946004a4bfc3fe026152b521cc652e60c83552a35b312",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/7245b8fe756d39f20a53020163168dbe/250x250-000000-80-0-0.jpg",
    genre: "Rap/Hip Hop",
  },
  {
    title: "Numb",
    artist: "Linkin Park",
    id: 677232,
    release_date: "2003-03-24",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/4/2/b/0/42b05e42e6f684b6a2de860831cfa91a.mp3?hdnea=exp=1763730155~acl=/api/1/1/4/2/b/0/42b05e42e6f684b6a2de860831cfa91a.mp3*~data=user_id=0,application_id=42~hmac=a9ebfcdc1ba0b6d3486b032902731728648a528085456b39c7f91bef9d88b242",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/44df4f6fb2534768f4924365c103d0f7/250x250-000000-80-0-0.jpg",
    genre: "Alternative",
  },
  {
    title: "Rain",
    artist: "Madonna",
    id: 677400,
    release_date: "1992-10-16",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/5/c/7/0/5c7c7f13d0c70a5f60ce08d000835f70.mp3?hdnea=exp=1763730155~acl=/api/1/1/5/c/7/0/5c7c7f13d0c70a5f60ce08d000835f70.mp3*~data=user_id=0,application_id=42~hmac=597ce717090698eedefbf319027bbe2e7aec87edd4992deac3538c20c6bd4afc",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/00eba6517f89cd953072782206b3bad9/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Snow (Hey Oh)",
    artist: "Red Hot Chili Peppers",
    id: 680518,
    release_date: "2006-05-05",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/8/1/9/0/8199a2b66b31069b367d7fb0e2b31e61.mp3?hdnea=exp=1763729080~acl=/api/1/1/8/1/9/0/8199a2b66b31069b367d7fb0e2b31e61.mp3*~data=user_id=0,application_id=42~hmac=5fcb558dc074a93ec215e582b3f15f97a02c059461e06c941d0b03859890a150",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/a3a4028b1192c50d82a579439cbfc4af/250x250-000000-80-0-0.jpg",
    genre: "Alternative",
  },
  {
    title: "Everything",
    artist: "Michael Bublé",
    id: 680660,
    release_date: "2007-04-30",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/f/c/d/0/fcd3b2028bdced82f50815d41b87908c.mp3?hdnea=exp=1763729080~acl=/api/1/1/f/c/d/0/fcd3b2028bdced82f50815d41b87908c.mp3*~data=user_id=0,application_id=42~hmac=7cd2914b2c7d446d1aa64668ba17cb22daaf85147328aae37260ccdc4b6b9b80",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/1bb7630219206f20050fb7e7f46b23c1/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Pure Shores",
    artist: "All Saints",
    id: 690526,
    release_date: "2001-03-17",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/a/d/7/0/ad71fe7cf0d6d328d45db0a66f1ab0af.mp3?hdnea=exp=1763729080~acl=/api/1/1/a/d/7/0/ad71fe7cf0d6d328d45db0a66f1ab0af.mp3*~data=user_id=0,application_id=42~hmac=dae584261a08a2e5b332c4ba8745d383a0d48539eb6a04d5d86db224da3381a4",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/f73db4644fd8f418c194dbbfad75a2c2/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Turn Me On",
    artist: "Kevin Lyttle",
    id: 705531,
    release_date: "2004-03-30",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/b/7/b/0/b7bc45ef67b537295e559e36bf188688.mp3?hdnea=exp=1763729080~acl=/api/1/1/b/7/b/0/b7bc45ef67b537295e559e36bf188688.mp3*~data=user_id=0,application_id=42~hmac=5db189125502d854e6fb2c91655ee982d10c09ba9ae5cbc8c55132ee833a4710",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/0261ed55e0f9a9029cbd397b786c4847/250x250-000000-80-0-0.jpg",
    genre: "Reggae",
  },
  {
    title: "Cupid's Chokehold / Breakfast in America",
    artist: "Gym Class Heroes",
    id: 708037,
    release_date: "2006-07-25",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/e/6/1/0/e614b2dc8a1182df92f460b9b299d22f.mp3?hdnea=exp=1763726039~acl=/api/1/1/e/6/1/0/e614b2dc8a1182df92f460b9b299d22f.mp3*~data=user_id=0,application_id=42~hmac=237a4001b9ad3f9b5ec40e440a3b72773ceebd28fffb7f27168b98cf0fe249e1",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/3c1336089785f66ce4a98ae1e7a67173/250x250-000000-80-0-0.jpg",
    genre: "Alternative",
  },
  {
    title: "Runaway",
    artist: "The Corrs",
    id: 714692,
    release_date: "2001-01-01",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/5/3/2/0/532de52acdb92a74a2b4301627fe62d3.mp3?hdnea=exp=1763726039~acl=/api/1/1/5/3/2/0/532de52acdb92a74a2b4301627fe62d3.mp3*~data=user_id=0,application_id=42~hmac=6b9d4713b57b7d871c59245afdbccb58701893feb4d79e69e8bdb54f61451b05",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/ec392dc2f4032357cffbab34bdfc93e8/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Another Day in Paradise (R&B-Version)",
    artist: "Brandy",
    id: 714954,
    release_date: "2002-02-25",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/8/e/4/0/8e4160ce04b1dd741dba9404c2733b7a.mp3?hdnea=exp=1763726039~acl=/api/1/1/8/e/4/0/8e4160ce04b1dd741dba9404c2733b7a.mp3*~data=user_id=0,application_id=42~hmac=10001b3d1a8fa449ecab00b03d04fc23b24f059cb8fbc98aecd1f66bcdbbe32b",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/f8fc36d4630624087603352ee8528e01/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Remember the Name (feat. Styles of Beyond)",
    artist: "Fort Minor",
    id: 715929,
    release_date: "2005-10-04",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/7/6/e/0/76e85dbed81463aedcd2496e8b14402e.mp3?hdnea=exp=1763726039~acl=/api/1/1/7/6/e/0/76e85dbed81463aedcd2496e8b14402e.mp3*~data=user_id=0,application_id=42~hmac=3725601cf1f6fd34e0bf25d2355dbb85a2414578784378d1fb3496dc7a92aae7",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/d4059c5525f643e2843b2f1e18e2d39f/250x250-000000-80-0-0.jpg",
    genre: "Rap/Hip Hop",
  },
  {
    title: "Vogue",
    artist: "Madonna",
    id: 723903,
    release_date: "1990-11-09",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/c/1/f/0/c1fb5f5ef77403b79869be7f24d917c7.mp3?hdnea=exp=1763726039~acl=/api/1/1/c/1/f/0/c1fb5f5ef77403b79869be7f24d917c7.mp3*~data=user_id=0,application_id=42~hmac=f5cdd9b4dd20c240ebd5b93ae3f5483ebbaf31c824024c30d8268601531822b2",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/329c772be6103678d4c53c43d293cd51/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Justify My Love",
    artist: "Madonna",
    id: 723909,
    release_date: "1990-11-09",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/4/c/c/0/4ccc55543d37170f240350f465985abc.mp3?hdnea=exp=1763726039~acl=/api/1/1/4/c/c/0/4ccc55543d37170f240350f465985abc.mp3*~data=user_id=0,application_id=42~hmac=0229cfd59691a41f5104013f80a3560a6861df54a7d94b598e103e4c4e77f223",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/329c772be6103678d4c53c43d293cd51/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Around the World",
    artist: "Red Hot Chili Peppers",
    id: 725241,
    release_date: "1999-06-07",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/9/2/5/0/925e3aa4bd498c678073f6841cda8d72.mp3?hdnea=exp=1763726039~acl=/api/1/1/9/2/5/0/925e3aa4bd498c678073f6841cda8d72.mp3*~data=user_id=0,application_id=42~hmac=363846b3b7603050ab824b2895baf93e04f9aff73e31183ef8e4940005846e05",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/5e61e8290a4d1d64ca58920656c9602d/250x250-000000-80-0-0.jpg",
    genre: "Alternative",
  },
  {
    title: "Otherside",
    artist: "Red Hot Chili Peppers",
    id: 725261,
    release_date: "1999-06-07",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/7/5/1/0/751e3451f12359b6d125b8ad04133afa.mp3?hdnea=exp=1763726039~acl=/api/1/1/7/5/1/0/751e3451f12359b6d125b8ad04133afa.mp3*~data=user_id=0,application_id=42~hmac=f0c80d3b29cd3a18a664217e9c3e4386748e45a2cef0320cd58bca6f049ee15b",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/5e61e8290a4d1d64ca58920656c9602d/250x250-000000-80-0-0.jpg",
    genre: "Alternative",
  },
  {
    title: "Road Trippin'",
    artist: "Red Hot Chili Peppers",
    id: 725320,
    release_date: "1999-06-07",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/3/6/b/0/36bcca3e896505920a8ab1415ffabeaf.mp3?hdnea=exp=1763726039~acl=/api/1/1/3/6/b/0/36bcca3e896505920a8ab1415ffabeaf.mp3*~data=user_id=0,application_id=42~hmac=c4581277541f7ddc1923969add9a3afdcaf0e10573bd9631fa8e2409af8b5e08",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/5e61e8290a4d1d64ca58920656c9602d/250x250-000000-80-0-0.jpg",
    genre: "Alternative",
  },
  {
    title: "When It's Over (David Kahne Main)",
    artist: "Sugar Ray",
    id: 756272,
    release_date: "2005-12-20",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/cfefc2be340cf32f6454a923ab5222ba/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "American Idiot",
    artist: "Green Day",
    id: 773367,
    release_date: "2004-09-21",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/6/b/2/0/6b20f0ea0464d874e0dc5bc77b581c21.mp3?hdnea=exp=1763726039~acl=/api/1/1/6/b/2/0/6b20f0ea0464d874e0dc5bc77b581c21.mp3*~data=user_id=0,application_id=42~hmac=82fce062c0e71a0a89e8d40d5a58ffac3bcc68773bf75514e44695f70e6c13a9",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/9e17c202b5ab081171f31c81eb32dc5d/250x250-000000-80-0-0.jpg",
    genre: "Alternative",
  },
  {
    title: "Wake Me up When September Ends",
    artist: "Green Day",
    id: 773430,
    release_date: "2004-09-21",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/9/8/3/0/9837dd113ea0fa2c6b022319fa291ecf.mp3?hdnea=exp=1763726039~acl=/api/1/1/9/8/3/0/9837dd113ea0fa2c6b022319fa291ecf.mp3*~data=user_id=0,application_id=42~hmac=ee83279c889e21ee08b9eaa7b119ff7d45e06fa386d45989847bc365090e3ab0",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/9e17c202b5ab081171f31c81eb32dc5d/250x250-000000-80-0-0.jpg",
    genre: "Alternative",
  },
  {
    title: "Ironic",
    artist: "Alanis Morissette",
    id: 776541,
    release_date: "1997-01-01",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/5/d/8/0/5d80d16645f0452e7a5b3111b13fdee9.mp3?hdnea=exp=1763726039~acl=/api/1/1/5/d/8/0/5d80d16645f0452e7a5b3111b13fdee9.mp3*~data=user_id=0,application_id=42~hmac=d5cc0565f3ad7db2fbe7fc53df761dad3dbdeda8aea6ebe705c84b3a94778130",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/ba42860e4b1209e7daa11cf7f36d05b1/250x250-000000-80-0-0.jpg",
    genre: "Alternative",
  },
  {
    title: "You're Beautiful",
    artist: "James Blunt",
    id: 784321,
    release_date: "2005-08-08",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/6/7/0/0/670ea0fd169d1daae01a0e71200be597.mp3?hdnea=exp=1763726039~acl=/api/1/1/6/7/0/0/670ea0fd169d1daae01a0e71200be597.mp3*~data=user_id=0,application_id=42~hmac=fd1116da323c1c16639cd36c94b4fc91aca1512f617bb9533d20d981bf7d9eec",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/8b701ce9a0c1cdddf43a42638d0610b3/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Strong Enough",
    artist: "Cher",
    id: 786748,
    release_date: "1998-10-26",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/5/d/8/0/5d82c42689818ba8bac1959b47989b98.mp3?hdnea=exp=1763726039~acl=/api/1/1/5/d/8/0/5d82c42689818ba8bac1959b47989b98.mp3*~data=user_id=0,application_id=42~hmac=58dc766ac3fd61b8e3df2da9ed8b031a4a6c842ac50003681145a5d4d210074d",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/af263778ad6ef2f3f5be381292ed02a8/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Low (feat. T-Pain)",
    artist: "Flo Rida",
    id: 786826,
    release_date: "2008-03-17",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/9/2/f/0/92fd4d977c3f46f172facd1d7c6a548d.mp3?hdnea=exp=1763726039~acl=/api/1/1/9/2/f/0/92fd4d977c3f46f172facd1d7c6a548d.mp3*~data=user_id=0,application_id=42~hmac=07bfa3c63e9df7b9f384ea5698cfd1a0bfc5510650a120c15bfd9eb1cf42f9aa",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/f57db1d78cde50906285c31160dc20cd/250x250-000000-80-0-0.jpg",
    genre: "Rap/Hip Hop",
  },
  {
    title: "Damaged",
    artist: "Danity Kane",
    id: 790402,
    release_date: "2008-03-17",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/8/b/e/0/8bedfef369b8f452084d71d56fc1cdf2.mp3?hdnea=exp=1763726039~acl=/api/1/1/8/b/e/0/8bedfef369b8f452084d71d56fc1cdf2.mp3*~data=user_id=0,application_id=42~hmac=2901509a0c1ee9bc07291e6f44e318fb9cf99026a0369d451336a2368af53b4f",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/24539ec683c6b2506ad40ba97e4be176/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "4 Minutes (feat. Justin Timberlake and Timbaland)",
    artist: "Madonna",
    id: 794020,
    release_date: "2008-04-28",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/e6f20f5a022403e93a94e5b9e7c1b81d/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Are You Gonna Be My Girl",
    artist: "Jet",
    id: 811880,
    release_date: "2003-09-15",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/be2bce57ff0de814db635834d55b2e40/250x250-000000-80-0-0.jpg",
    genre: "Alternative",
  },
  {
    title: "Come to Me (feat. Nicole Scherzinger)",
    artist: "Diddy",
    id: 815263,
    release_date: "2006-10-16",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/a09b17ed270f28cf3935699e45e112ed/250x250-000000-80-0-0.jpg",
    genre: "Rap/Hip Hop",
  },
  {
    title: "Fit but You Know It",
    artist: "The Streets",
    id: 823132,
    release_date: "2002-03-18",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/1ca1b9bd6cf02ff2b32b90a7e8cbef07/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Dry Your Eyes",
    artist: "The Streets",
    id: 823135,
    release_date: "2002-03-18",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/1ca1b9bd6cf02ff2b32b90a7e8cbef07/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "She Bangs (English Version)",
    artist: "Ricky Martin",
    id: 830084,
    release_date: "2014-06-13",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/8ce3c2e14c8872e7a74367a0a12f90b6/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "No More (Baby I'ma Do Right)",
    artist: "3LW",
    id: 831253,
    release_date: "2000-11-06",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/39c93a940020b7910673dc3da7a52f90/250x250-000000-80-0-0.jpg",
    genre: "R&B",
  },
  {
    title: "Tha Crossroads",
    artist: "Bone Thugs-N-Harmony",
    id: 831546,
    release_date: "1999-10-08",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/0443774b0fee838507fc9221e9c8b6b9/250x250-000000-80-0-0.jpg",
    genre: "R&B",
  },
  {
    title: "I Need To Know",
    artist: "Marc Anthony",
    id: 833823,
    release_date: "1999-11-01",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/12bb759dc412400a3e7e304933cb5f02/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Photograph (Radio Edit)",
    artist: "Nickelback",
    id: 847072,
    release_date: "2005-06-14",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/35e6f1860ed9f8a7e486c56deb8c3832/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "Teenage Dirtbag",
    artist: "Wheatus",
    id: 849698,
    release_date: "2000-09-29",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/b3f9660d7b98cc4fc6b4c9207bb1164b/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "Bounce With Me (feat. Xscape) (Edited Album Version)",
    artist: "Bow Wow",
    id: 863423,
    release_date: "2000-11-21",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/c096d9d7d254f700dd179d0bee4cbe04/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Love Song",
    artist: "Sara Bareilles",
    id: 872915,
    release_date: "2008-06-23",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/2b598688c3783e05053da9744f71b788/250x250-000000-80-0-0.jpg",
    genre: "Alternative",
  },
  {
    title: "As Good As I Once Was",
    artist: "Toby Keith",
    id: 881404,
    release_date: "2005-11-07",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/2a1b96a8f0a255fd2be123e800c1a2de/250x250-000000-80-0-0.jpg",
    genre: "Country",
  },
  {
    title: "Fergalicious",
    artist: "Fergie",
    id: 882287,
    release_date: "2006-09-25",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/0285dad64dcaaf6ff3652fbc8e3f58d6/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Clumsy",
    artist: "Fergie",
    id: 882288,
    release_date: "2006-09-25",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/0285dad64dcaaf6ff3652fbc8e3f58d6/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "London Bridge",
    artist: "Fergie",
    id: 882290,
    release_date: "2006-07-18",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/0285dad64dcaaf6ff3652fbc8e3f58d6/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Big Girls Don't Cry (Personal)",
    artist: "Fergie",
    id: 882296,
    release_date: "2015-01-06",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/0285dad64dcaaf6ff3652fbc8e3f58d6/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Let It Go",
    artist: "Keyshia Cole",
    id: 885965,
    release_date: "2007-04-28",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/33e298f0e1832595a5ff712c74da6c6f/250x250-000000-80-0-0.jpg",
    genre: "R&B",
  },
  {
    title: "Last Night",
    artist: "Keyshia Cole",
    id: 885967,
    release_date: "2008-04-28",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/33e298f0e1832595a5ff712c74da6c6f/250x250-000000-80-0-0.jpg",
    genre: "R&B",
  },
  {
    title: "Ghetto Gospel",
    artist: "2Pac",
    id: 886446,
    release_date: "2004-01-21",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/c10f36c2ce7bf1006ced08147d02de32/250x250-000000-80-0-0.jpg",
    genre: "Rap/Hip Hop",
  },
  {
    title: "Don't Phunk With My Heart",
    artist: "The Black Eyed Peas",
    id: 886447,
    release_date: "2008-05-12",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/c10f36c2ce7bf1006ced08147d02de32/250x250-000000-80-0-0.jpg",
    genre: "Rap/Hip Hop",
  },
  {
    title: "Let Me Blow Ya Mind",
    artist: "Eve",
    id: 886460,
    release_date: "2008-05-12",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/c10f36c2ce7bf1006ced08147d02de32/250x250-000000-80-0-0.jpg",
    genre: "Rap/Hip Hop",
  },
  {
    title: "All About You",
    artist: "McFly",
    id: 62471658,
    release_date: "2008-02-25",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/5/6/3/0/563bbbcb97471fda19f8394ec4d532ec.mp3?hdnea=exp=1763731666~acl=/api/1/1/5/6/3/0/563bbbcb97471fda19f8394ec4d532ec.mp3*~data=user_id=0,application_id=42~hmac=733f88dd073376766df3207cc6531bcae993bb27d2942920b729919fe46cc9d2",
    cover: "https://api.deezer.com/album/6130614/image",
    genre: "Pop",
  },
  {
    title: "Mustang Sally",
    artist: "The Commitments",
    id: 890307,
    release_date: "1991-08-20",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/e/f/d/0/efdf0ce25210a9749839987b907b4c46.mp3?hdnea=exp=1763731666~acl=/api/1/1/e/f/d/0/efdf0ce25210a9749839987b907b4c46.mp3*~data=user_id=0,application_id=42~hmac=a3b209489659d90b1e75462ed4446a8b15ed71633a2832dcf3abcdc0f5f87898",
    cover: "https://api.deezer.com/album/100905/image",
    genre: "Pop",
  },
  {
    title: "DONTTRUSTME",
    artist: "3OH!3",
    id: 903258,
    release_date: "2008-07-07",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/38456a9f23783447b51903475d3da8cc/250x250-000000-80-0-0.jpg",
    genre: "Alternative",
  },
  {
    title: "Starz In Their Eyes",
    artist: "Just Jack",
    id: 907576,
    release_date: "2007-10-22",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/3/e/c/0/3ecb1fc74fc661c1b9c0f2c4dbda9695.mp3?hdnea=exp=1763731666~acl=/api/1/1/3/e/c/0/3ecb1fc74fc661c1b9c0f2c4dbda9695.mp3*~data=user_id=0,application_id=42~hmac=bd744c8cb0fe5e270863c8a51a65d4641616ef4b485595dfe39b6c193be2af4a",
    cover: "https://api.deezer.com/album/102460/image",
    genre: "Pop",
  },
  {
    title: "Don't Stop The Music",
    artist: "Rihanna",
    id: 925108,
    release_date: "2008-06-17",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/b/6/8/0/b68999f43dd5f6bc0f6396da4fc0c6c2.mp3?hdnea=exp=1763731666~acl=/api/1/1/b/6/8/0/b68999f43dd5f6bc0f6396da4fc0c6c2.mp3*~data=user_id=0,application_id=42~hmac=7bf5422c8e00a00bff0249130f596dba02a17797fc26d79532f0631a86bac7c2",
    cover: "https://api.deezer.com/album/104188/image",
    genre: "Pop",
  },
  {
    title: "About You Now",
    artist: "Sugababes",
    id: 911356,
    release_date: "2007-10-01",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/5/f/7/0/5f73327bf00d6ca277981974de173c18.mp3?hdnea=exp=1763731666~acl=/api/1/1/5/f/7/0/5f73327bf00d6ca277981974de173c18.mp3*~data=user_id=0,application_id=42~hmac=c614603076dd954095596ac95c4c57101356a8fa59530acfeace92fd9b449016",
    cover: "https://api.deezer.com/album/102719/image",
    genre: "Pop",
  },
  {
    title: "Thnks fr th Mmrs",
    artist: "Fall Out Boy",
    id: 911496,
    release_date: "2007-11-20",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/2/b/5/0/2b55e4f4ee7e4251acd369d4bd1206f2.mp3?hdnea=exp=1763731666~acl=/api/1/1/2/b/5/0/2b55e4f4ee7e4251acd369d4bd1206f2.mp3*~data=user_id=0,application_id=42~hmac=abf874a6fcacfe7bd40cfa0fa150e06254e8438c74e699513258a5e81e5e5c81",
    cover: "https://api.deezer.com/album/102729/image",
    genre: "Alternative",
  },
  {
    title: "Too Lost In You",
    artist: "Sugababes",
    id: 913832,
    release_date: "2008-02-25",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/4/c/1/0/4c115daa0626ea8cd065925ee36b3861.mp3?hdnea=exp=1763731666~acl=/api/1/1/4/c/1/0/4c115daa0626ea8cd065925ee36b3861.mp3*~data=user_id=0,application_id=42~hmac=fbda2cfe0be288ccfe790d7c1809cb8de1ee362b2db4c9bc9927cb7ec05050b6",
    cover: "https://api.deezer.com/album/102951/image",
    genre: "Pop",
  },
  {
    title: "Makes Me Wonder",
    artist: "Maroon 5",
    id: 914780,
    release_date: "2008-06-30",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/0/f/6/0/0f67342563fee9eb4d5245989abc4f31.mp3?hdnea=exp=1763731666~acl=/api/1/1/0/f/6/0/0f67342563fee9eb4d5245989abc4f31.mp3*~data=user_id=0,application_id=42~hmac=4464966f015069f1f9ee2be7e552d887ec51cb5373b19b36fd32d1c85a18190c",
    cover: "https://api.deezer.com/album/103069/image",
    genre: "Rock",
  },
  {
    title: "Livin' On The Edge",
    artist: "Aerosmith",
    id: 1105731,
    release_date: "1993-03-30",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/1/c/9/0/1c9ba8dd87c182bd52de9be15b132ddc.mp3?hdnea=exp=1763731666~acl=/api/1/1/1/c/9/0/1c9ba8dd87c182bd52de9be15b132ddc.mp3*~data=user_id=0,application_id=42~hmac=3ca60dd099447c74633c6fa0b44dc862527bf94d1536a1005d4834f185d0d39e",
    cover: "https://api.deezer.com/album/119281/image",
    genre: "Rock",
  },
  {
    title: "Cryin'",
    artist: "Aerosmith",
    id: 2246520677,
    release_date: "1993-06-20",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/9/5/a/0/95a911e2a88c88bb54aa4c1613cfe7b5.mp3?hdnea=exp=1763731666~acl=/api/1/1/9/5/a/0/95a911e2a88c88bb54aa4c1613cfe7b5.mp3*~data=user_id=0,application_id=42~hmac=217ebcb68ef8a18d0011e592efdb7e5330dd2aff763e8eb19944047bb60f9b17",
    cover: "https://api.deezer.com/album/431988817/image",
    genre: "Rock",
  },
  {
    title: "No Diggity",
    artist: "Blackstreet",
    id: 916496,
    release_date: "2003-06-24",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/8/8/f/0/88fcefe3f4bb29ae3fcbd4cb8abb0f54.mp3?hdnea=exp=1763731666~acl=/api/1/1/8/8/f/0/88fcefe3f4bb29ae3fcbd4cb8abb0f54.mp3*~data=user_id=0,application_id=42~hmac=626a93f54dced6cbe5d64a623b6c3008fd9eac6294408140a1769d2cf9e3d5bb",
    cover: "https://api.deezer.com/album/103254/image",
    genre: "R&B",
  },
  {
    title: "Stop And Stare",
    artist: "OneRepublic",
    id: 916827,
    release_date: "2008-02-07",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/1/c/d/0/1cddb1888372b7a532089e5c7bbadd6d.mp3?hdnea=exp=1763731666~acl=/api/1/1/1/c/d/0/1cddb1888372b7a532089e5c7bbadd6d.mp3*~data=user_id=0,application_id=42~hmac=71b22df805a5f68e396fd8a53398b0affc16c37ca1e6286fe61fdb3b618ef60d",
    cover: "https://api.deezer.com/album/103293/image",
    genre: "Pop",
  },
  {
    title: "Apologize (feat. One Republic)",
    artist: "Timbaland",
    id: 916841,
    release_date: "2008-02-07",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/7/0/e/0/70e47edf867631baf6ff20ffe4a1a81e.mp3?hdnea=exp=1763731666~acl=/api/1/1/7/0/e/0/70e47edf867631baf6ff20ffe4a1a81e.mp3*~data=user_id=0,application_id=42~hmac=8a2757d6d735dd52e1520996de37174af463a8fb09d94358c7cb1029dcef5a55",
    cover: "https://api.deezer.com/album/103293/image",
    genre: "Pop",
  },
  {
    title: "Dance, Dance",
    artist: "Fall Out Boy",
    id: 1138246,
    release_date: "2006-03-14",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/f/d/0/0/fd0bc72c69346a5bc2810af9bbf2948d.mp3?hdnea=exp=1763731666~acl=/api/1/1/f/d/0/0/fd0bc72c69346a5bc2810af9bbf2948d.mp3*~data=user_id=0,application_id=42~hmac=1f8b86bee9dd1699e5556fb7d02a7662147982b429e176f23f976df1a707d2be",
    cover: "https://api.deezer.com/album/122005/image",
    genre: "Rock",
  },
  {
    title: "Sugar, We're Goin Down",
    artist: "Fall Out Boy",
    id: 1138247,
    release_date: "2006-03-14",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/9/3/8/0/938605b5b099a3e2a05b3eb6d8c822cb.mp3?hdnea=exp=1763731666~acl=/api/1/1/9/3/8/0/938605b5b099a3e2a05b3eb6d8c822cb.mp3*~data=user_id=0,application_id=42~hmac=b8a4ffd2a5c55eb4f1c6567c3aca94e89bbc0a78366b24c3dbfdfe30214d5e48",
    cover: "https://api.deezer.com/album/122005/image",
    genre: "Rock",
  },
  {
    title: "It's Like That",
    artist: "Mariah Carey",
    id: 917359,
    release_date: "2005-03-28",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/0/1/1/0/01192b1559248318a2097324102c8ea2.mp3?hdnea=exp=1763731666~acl=/api/1/1/0/1/1/0/01192b1559248318a2097324102c8ea2.mp3*~data=user_id=0,application_id=42~hmac=28141f1e0b9254877a586b3bb2979af2f1d80f8d9a90a2529925a09f9d7decd9",
    cover: "https://api.deezer.com/album/103350/image",
    genre: "Pop",
  },
  {
    title: "Fields Of Gold",
    artist: "Sting",
    id: 2525867,
    release_date: "1998-09-21",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/6/e/f/0/6efa6ac3f8f2417df759e4069f189e1e.mp3?hdnea=exp=1763731666~acl=/api/1/1/6/e/f/0/6efa6ac3f8f2417df759e4069f189e1e.mp3*~data=user_id=0,application_id=42~hmac=202633e78cc665e277fc61f9d322214feaaaac80678f5422bc230328da963d01",
    cover: "https://api.deezer.com/album/247629/image",
    genre: "Pop",
  },
  {
    title: "Shape Of My Heart",
    artist: "Sting",
    id: 530979521,
    release_date: "1998-09-21",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/7/c/1/0/7c1b2e38abe8869436c0689055a56552.mp3?hdnea=exp=1763731666~acl=/api/1/1/7/c/1/0/7c1b2e38abe8869436c0689055a56552.mp3*~data=user_id=0,application_id=42~hmac=48b02a80c8241bdec26484d3e70ef5c6781951907b2bb81cee6fedc9420f7d37",
    cover: "https://api.deezer.com/album/68804761/image",
    genre: "Pop",
  },
  {
    title: "So Sick",
    artist: "Ne-Yo",
    id: 924800,
    release_date: "2007-07-03",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/5/0/0/0/5009df943302ae492d762cf61fac63c2.mp3?hdnea=exp=1763731666~acl=/api/1/1/5/0/0/0/5009df943302ae492d762cf61fac63c2.mp3*~data=user_id=0,application_id=42~hmac=555aae4a95ddbc947dd3bbc1ff8ebef74a65b8b7f1a78cb4a3c8f1f86c34442b",
    cover: "https://api.deezer.com/album/104157/image",
    genre: "R&B",
  },
  {
    title: "Hate That I Love You",
    artist: "Rihanna",
    id: 925111,
    release_date: "2008-06-17",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/f/7/6/0/f76cd283cb3ccc57a2113d2ea02bf259.mp3?hdnea=exp=1763731666~acl=/api/1/1/f/7/6/0/f76cd283cb3ccc57a2113d2ea02bf259.mp3*~data=user_id=0,application_id=42~hmac=566f6b5566f3d8eaa399ed2726d86e474664334fb6273d21d1c48a24020e125b",
    cover: "https://api.deezer.com/album/104188/image",
    genre: "Pop",
  },
  {
    title: "Disturbia",
    artist: "Rihanna",
    id: 925118,
    release_date: "2008-06-17",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/9/4/4/0/944b1db8e9e33a98bc09a56abab875b4.mp3?hdnea=exp=1763731666~acl=/api/1/1/9/4/4/0/944b1db8e9e33a98bc09a56abab875b4.mp3*~data=user_id=0,application_id=42~hmac=556fe8d25391c6998bd0b4fb601dad5de4924099c189dfd1ef7d81adc78ff433",
    cover: "https://api.deezer.com/album/104188/image",
    genre: "Pop",
  },
  {
    title: "Take A Bow",
    artist: "Rihanna",
    id: 925119,
    release_date: "2008-06-17",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/2/8/8/0/2880c7aaee679cb6fa98283891e1564e.mp3?hdnea=exp=1763731666~acl=/api/1/1/2/8/8/0/2880c7aaee679cb6fa98283891e1564e.mp3*~data=user_id=0,application_id=42~hmac=1f25f1cad3583ec950dd8e6d49f78ee498b046c596961a1088e2aac1818b2129",
    cover: "https://api.deezer.com/album/104188/image",
    genre: "Pop",
  },
  {
    title: "Round Here",
    artist: "Counting Crows",
    id: 925651,
    release_date: "2007-09-18",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/b/c/f/0/bcf8b2e346a9c7f446b2a2f0ea6f2f1b.mp3?hdnea=exp=1763731666~acl=/api/1/1/b/c/f/0/bcf8b2e346a9c7f446b2a2f0ea6f2f1b.mp3*~data=user_id=0,application_id=42~hmac=1fb310e85efa6f4644bb629df3712a032b1974f26851664c95dd6979fd298545",
    cover: "https://api.deezer.com/album/104247/image",
    genre: "Pop",
  },
  {
    title: "Mr. Jones",
    artist: "Counting Crows",
    id: 925653,
    release_date: "2003-11-24",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/d/1/f/0/d1fbae17338397a159115e60ce67c967.mp3?hdnea=exp=1763731666~acl=/api/1/1/d/1/f/0/d1fbae17338397a159115e60ce67c967.mp3*~data=user_id=0,application_id=42~hmac=ec4a9f01be601e34fa72b477b77cd0c4dab514fb756bfd84dcea4442d8240218",
    cover: "https://api.deezer.com/album/104247/image",
    genre: "Pop",
  },
  {
    title: "Give It To Me",
    artist: "Timbaland",
    id: 4685512,
    release_date: "2007-08-24",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/2/5/a/0/25a717b873d70b756fa38eb322054099.mp3?hdnea=exp=1763731667~acl=/api/1/1/2/5/a/0/25a717b873d70b756fa38eb322054099.mp3*~data=user_id=0,application_id=42~hmac=cc9893b94dcdbcd9a870e7e6a9efd9b31fda633258789217b3ad9b5daf09e69a",
    cover: "https://api.deezer.com/album/431272/image",
    genre: "Pop",
  },
  {
    title: "Patience",
    artist: "Take That",
    id: 929558,
    release_date: "2006-11-20",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/c/a/a/0/caaa63e88c79bfbd09fcda146b210375.mp3?hdnea=exp=1763730751~acl=/api/1/1/c/a/a/0/caaa63e88c79bfbd09fcda146b210375.mp3*~data=user_id=0,application_id=42~hmac=4fc1e7076a55d325caedd4fbaac3a7f9d4f62283f50b7189e113efaab6720a8f",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/688dbebac904ce0f2c9eec2875978346/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Take Your Mama",
    artist: "Scissor Sisters",
    id: 930051,
    release_date: "2004-05-03",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/e/2/6/0/e26049fabc17a0744a907efaad04f483.mp3?hdnea=exp=1763730751~acl=/api/1/1/e/2/6/0/e26049fabc17a0744a907efaad04f483.mp3*~data=user_id=0,application_id=42~hmac=836f6e86582f411421a35181c7354310b51f968da1b3ca4e8b9755a8b884d6a2",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/715911bf1f58a8a43e309c851655a6d2/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Good Luck (feat. Lisa Kekaula)",
    artist: "Basement Jaxx",
    id: 935732,
    release_date: "2005-03-21",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/a17c28cb5b79252e71f371df0e9ab867/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "The Only One I Know",
    artist: "The Charlatans",
    id: 938769,
    release_date: "1990-09-25",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/e/0/8/0/e082fee821faeb9e9669ecb9940a45a0.mp3?hdnea=exp=1763730751~acl=/api/1/1/e/0/8/0/e082fee821faeb9e9669ecb9940a45a0.mp3*~data=user_id=0,application_id=42~hmac=af3a789abe13364f7176c38a9a3cc08beaaa50def4deeb862c7eb9d33de790aa",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/fc68158202b483cef1ea55244d09d7c5/250x250-000000-80-0-0.jpg",
    genre: "Alternative",
  },
  {
    title: "Paper Planes",
    artist: "M.I.A.",
    id: 943376,
    release_date: "2007-08-20",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/5/f/9/0/5f974a4755080001e769dfa67afce73c.mp3?hdnea=exp=1763730751~acl=/api/1/1/5/f/9/0/5f974a4755080001e769dfa67afce73c.mp3*~data=user_id=0,application_id=42~hmac=63a8b52b5092c3a58b0842521a03a538e4b7678a023912b3ea1e94bcc2c68791",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/8dfb8aa426b4d5e2f8c292a6e2df93d6/250x250-000000-80-0-0.jpg",
    genre: "Electro",
  },
  {
    title: "It Wasn't Me",
    artist: "Shaggy",
    id: 952870,
    release_date: "2000-08-08",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/0/c/a/0/0cabc721f7c2a3eb4995edcf254e44b4.mp3?hdnea=exp=1763730751~acl=/api/1/1/0/c/a/0/0cabc721f7c2a3eb4995edcf254e44b4.mp3*~data=user_id=0,application_id=42~hmac=eecbbdbe3e16083a1fcb8c548895be1c5d03a01e6757d74bb8de8f43ade9a997",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/eb3f1be6046ad03fe70abb09a2f289ec/250x250-000000-80-0-0.jpg",
    genre: "R&B",
  },
  {
    title: "Thong Song",
    artist: "Sisqo",
    id: 952875,
    release_date: "2007-09-17",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/d/0/c/0/d0c38f510de0ae06bc9d4fbceb024197.mp3?hdnea=exp=1763730751~acl=/api/1/1/d/0/c/0/d0c38f510de0ae06bc9d4fbceb024197.mp3*~data=user_id=0,application_id=42~hmac=0828973ea8827e2369099a641134765dcaab3eb7fb8e39169b02d035bb39e1fe",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/eb3f1be6046ad03fe70abb09a2f289ec/250x250-000000-80-0-0.jpg",
    genre: "R&B",
  },
  {
    title: "Mr. Brightside",
    artist: "The Killers",
    id: 953097,
    release_date: "2015-02-24",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/0/f/2/0/0f2afffd5ba40fc616ee562cde64b94f.mp3?hdnea=exp=1763730751~acl=/api/1/1/0/f/2/0/0f2afffd5ba40fc616ee562cde64b94f.mp3*~data=user_id=0,application_id=42~hmac=41088d56a7384b0d9fabc9214a75a6605ad653f255be3c38d655caac929a27e1",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/ecff532dd84c6538099b58baefccb8fb/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "Rollin' (Air Raid Vehicle)",
    artist: "Limp Bizkit",
    id: 953098,
    release_date: "2007-09-17",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/7/8/a/0/78a0c22d9eb0306490804195f16165d2.mp3?hdnea=exp=1763730751~acl=/api/1/1/7/8/a/0/78a0c22d9eb0306490804195f16165d2.mp3*~data=user_id=0,application_id=42~hmac=a6fe8044ef86909cda9bd4840695022d076d558bffeac565acebedbf8377fdc4",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/ecff532dd84c6538099b58baefccb8fb/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "Kryptonite",
    artist: "3 Doors Down",
    id: 953104,
    release_date: "2007-09-17",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/6/b/c/0/6bc6e7b3c59bce3e3c44a6d86fcc9b46.mp3?hdnea=exp=1763730751~acl=/api/1/1/6/b/c/0/6bc6e7b3c59bce3e3c44a6d86fcc9b46.mp3*~data=user_id=0,application_id=42~hmac=51fca0e28d1dff2e2548527a0f6c0521d4f6d16ce331233be299ed2c929862f8",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/ecff532dd84c6538099b58baefccb8fb/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "The Bad Touch",
    artist: "Bloodhound Gang",
    id: 953105,
    release_date: "1999-09-17",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/b/f/b/0/bfb41a3cb7870407da19cdd8c1dafd9e.mp3?hdnea=exp=1763730751~acl=/api/1/1/b/f/b/0/bfb41a3cb7870407da19cdd8c1dafd9e.mp3*~data=user_id=0,application_id=42~hmac=1478458ddf540a670948a7aeb3e0e92fd536e51d57d695721984e03638cf1204",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/ecff532dd84c6538099b58baefccb8fb/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "Love Today",
    artist: "MIKA",
    id: 953605,
    release_date: "2007-02-27",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/2/8/4/0/284e80ff2257f2c2c0843d7caf2ebdd9.mp3?hdnea=exp=1763730751~acl=/api/1/1/2/8/4/0/284e80ff2257f2c2c0843d7caf2ebdd9.mp3*~data=user_id=0,application_id=42~hmac=1c2da26687ebf263e862a0daed793a8e751b201737911661e50d7ba724766c40",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/d9a13bb07b812fa04f34258f7068c038/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Happy Ending",
    artist: "MIKA",
    id: 953611,
    release_date: "2007-02-27",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/9/e/4/0/9e441e1fa2673c17c2708220e8be8435.mp3?hdnea=exp=1763730751~acl=/api/1/1/9/e/4/0/9e441e1fa2673c17c2708220e8be8435.mp3*~data=user_id=0,application_id=42~hmac=d3017f7d0c26819d7626059ebe1666bdcd6b3d5a04d5b8764d13331ddf9e48bc",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/d9a13bb07b812fa04f34258f7068c038/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Foundations",
    artist: "Kate Nash",
    id: 954806,
    release_date: "2007-09-10",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/1/c/5/0/1c517f102e90f2d2e04348deb9663ad4.mp3?hdnea=exp=1763730751~acl=/api/1/1/1/c/5/0/1c517f102e90f2d2e04348deb9663ad4.mp3*~data=user_id=0,application_id=42~hmac=554d2f94ae566018b545e43e8a5620c1dbbd131160eee0dde114260bd3e3c00e",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/13eb5e5580a1a1f06d5aa41872ce7f52/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Hit 'Em Up Style (Oops!)",
    artist: "Blu Cantrell",
    id: 958747,
    release_date: "2001-01-18",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/1/7/9/0/179d470c2e0418839e0e1e45c9fbd1a4.mp3?hdnea=exp=1763730751~acl=/api/1/1/1/7/9/0/179d470c2e0418839e0e1e45c9fbd1a4.mp3*~data=user_id=0,application_id=42~hmac=e6342e4b168c88cac393cfca8e33c23f6b6375bbc7aad027b07ef047997391dc",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/24c3043f8d72ea148c2ad1819df212ce/250x250-000000-80-0-0.jpg",
    genre: "R&B",
  },
  {
    title: "Angel of Mine",
    artist: "Monica",
    id: 958976,
    release_date: "1998-07-13",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/b/4/c/0/b4c52e5210ed1efbb7d8f1abcf135e67.mp3?hdnea=exp=1763730751~acl=/api/1/1/b/4/c/0/b4c52e5210ed1efbb7d8f1abcf135e67.mp3*~data=user_id=0,application_id=42~hmac=cf4c090f8f878c92ad937c4f5437cb0ac5073e95c56fc42fad509637044b0706",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/6024cb25122f304a2bec9969b00e2ecc/250x250-000000-80-0-0.jpg",
    genre: "R&B",
  },
  {
    title: "Music (feat. Marvin Gaye)",
    artist: "Erick Sermon",
    id: 959253,
    release_date: "2001-08-27",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/f/3/5/0/f359e3c975e7d3667f60d0d624800923.mp3?hdnea=exp=1763730751~acl=/api/1/1/f/3/5/0/f359e3c975e7d3667f60d0d624800923.mp3*~data=user_id=0,application_id=42~hmac=f1156721bc249e3745b954ea493e55fb28b0dfa10affd18a32ea336982dc12b2",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/814396f98dd72c6aeaf6098125841574/250x250-000000-80-0-0.jpg",
    genre: "Rap/Hip Hop",
  },
  {
    title: "If I Let You Go",
    artist: "Westlife",
    id: 959916,
    release_date: "1999-04-25",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/0be55022a97b3cc41491e1e4c678648c/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Here's to the Night",
    artist: "Eve 6",
    id: 960166,
    release_date: "1999-11-01",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/d/1/c/0/d1cb4a43c0bb5c127e179bcb47f52648.mp3?hdnea=exp=1763730751~acl=/api/1/1/d/1/c/0/d1cb4a43c0bb5c127e179bcb47f52648.mp3*~data=user_id=0,application_id=42~hmac=0f423f2aeede0141c65628205af4a204de1b782c24d201a6b0af1a0ad72622aa",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/53c389e343bce6c799d412e5580362af/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Flying Without Wings",
    artist: "Westlife",
    id: 1170251862,
    release_date: "1999-04-25",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/d/8/e/0/d8e45d029bc0ef648adc9746d402440b.mp3?hdnea=exp=1763731667~acl=/api/1/1/d/8/e/0/d8e45d029bc0ef648adc9746d402440b.mp3*~data=user_id=0,application_id=42~hmac=05fda29a70ce2a9a2abdae448f4100b3e514e971cb120d433f329687a3c44ed9",
    cover: "https://api.deezer.com/album/191864652/image",
    genre: "Pop",
  },
  {
    title: "It's Not Right But It's Okay",
    artist: "Whitney Houston",
    id: 962142,
    release_date: "1998-11-17",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/1/d/4/0/1d41a3a4207281367c9c69fd2cee8e26.mp3?hdnea=exp=1763730751~acl=/api/1/1/1/d/4/0/1d41a3a4207281367c9c69fd2cee8e26.mp3*~data=user_id=0,application_id=42~hmac=00bc2af4562b9ed2f9609a77a010363317abadbf92c795f251cb7dd35979a6e7",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/5116544ed84bc468877d02fcfe4bf8f6/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Here With Me",
    artist: "Dido",
    id: 962165,
    release_date: "1999-06-01",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/4/5/c/0/45c19546c2a19d492703208ac1ebc12a.mp3?hdnea=exp=1763730751~acl=/api/1/1/4/5/c/0/45c19546c2a19d492703208ac1ebc12a.mp3*~data=user_id=0,application_id=42~hmac=3f9590a0e63c5d80412824b75f9ee5c4c36619b767c6a15303846081d4748303",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/3eaae15d23993db3cd9c69ae113c4333/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: 'U Know What\'s Up (feat. Lisa "Left Eye" Lopes)',
    artist: "Donell Jones",
    id: 962216,
    release_date: "1999-10-11",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/d/6/4/0/d649e314c521ef512099f79aea27ec52.mp3?hdnea=exp=1763730751~acl=/api/1/1/d/6/4/0/d649e314c521ef512099f79aea27ec52.mp3*~data=user_id=0,application_id=42~hmac=6b4809b673cc81844241932218bc34892a710417eeb6621d1e09348017346edf",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/959aab86461bbe0c92ee8ea5393bff4b/250x250-000000-80-0-0.jpg",
    genre: "R&B",
  },
  {
    title: "My Love Is Your Love",
    artist: "Whitney Houston",
    id: 962260,
    release_date: "1998-11-17",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/f/6/e/0/f6e4942c0523aba80856f61b3d5d08d0.mp3?hdnea=exp=1763730751~acl=/api/1/1/f/6/e/0/f6e4942c0523aba80856f61b3d5d08d0.mp3*~data=user_id=0,application_id=42~hmac=db19d58f50039a3c9909acf49fea1e2ee35c6a412b73ffea228a1d3d3e6d4383",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/5116544ed84bc468877d02fcfe4bf8f6/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Ms. Jackson",
    artist: "OutKast",
    id: 963042,
    release_date: "2000-10-31",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/e/8/1/0/e81cf633d05ce15ce038684f06edf032.mp3?hdnea=exp=1763730751~acl=/api/1/1/e/8/1/0/e81cf633d05ce15ce038684f06edf032.mp3*~data=user_id=0,application_id=42~hmac=3e253018e8f9ea8c6592b7c1ffa3dff9f5f0bc1cdea11c4b39a2bcd8e80103c2",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/646d6414a24faaccf67c1d7e01f7d095/250x250-000000-80-0-0.jpg",
    genre: "Rap/Hip Hop",
  },
  {
    title: "Genie in a Bottle",
    artist: "Christina Aguilera",
    id: 15627386,
    release_date: "1999-07-15",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/8/e/2/0/8e22266bd0ab3e16cf5df4208f1ff06d.mp3?hdnea=exp=1763731667~acl=/api/1/1/8/e/2/0/8e22266bd0ab3e16cf5df4208f1ff06d.mp3*~data=user_id=0,application_id=42~hmac=2ac026e2214f7562a283bb77454941dfb2a4e54610e501773a3b1802c68bac97",
    cover: "https://api.deezer.com/album/1443463/image",
    genre: "Pop",
  },
  {
    title: "My Own Worst Enemy",
    artist: "Lit",
    id: 967040,
    release_date: "1999-02-22",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/e/e/8/0/ee885281e2cc83cb83200c850e50166e.mp3?hdnea=exp=1763730751~acl=/api/1/1/e/e/8/0/ee885281e2cc83cb83200c850e50166e.mp3*~data=user_id=0,application_id=42~hmac=c35c60efb8fb3e7ffc5c7fe6d8315f651ec6d4c17ebd632419d72dd56a791ce1",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/a91f52c785f596ecc7f73e086dd8afbe/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Summer Girls",
    artist: "LFO",
    id: 969161,
    release_date: "1999-08-10",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/c/b/2/0/cb28af85c78343dd667555b3c79bafd9.mp3?hdnea=exp=1763730751~acl=/api/1/1/c/b/2/0/cb28af85c78343dd667555b3c79bafd9.mp3*~data=user_id=0,application_id=42~hmac=53e5a615f03b3399c181990c8ad75f578f6a489d3487aae6338b742a801b8f80",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/24f96efcfedd8331e359c7730b26400c/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "U Remind Me",
    artist: "Usher",
    id: 969347,
    release_date: "2001-08-07",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/8/6/6/0/86601a1c3aa024eff73e07c472782584.mp3?hdnea=exp=1763730751~acl=/api/1/1/8/6/6/0/86601a1c3aa024eff73e07c472782584.mp3*~data=user_id=0,application_id=42~hmac=8596bd09aa5adc35a84617c4d68981f54be42fa69fa356e87cc3cf504a01f366",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/b1243a7f89bec5d034b82fec489f7221/250x250-000000-80-0-0.jpg",
    genre: "Rap/Hip Hop",
  },
  {
    title: "Beep",
    artist: "The Pussycat Dolls",
    id: 978913,
    release_date: "2005-08-25",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/6/d/2/0/6d233650933341c87e9979fe4b670547.mp3?hdnea=exp=1763730751~acl=/api/1/1/6/d/2/0/6d233650933341c87e9979fe4b670547.mp3*~data=user_id=0,application_id=42~hmac=e0cb2a69e7056920cf80566fcf4b70aa099d262de7807aed5eb18054d3ff24c2",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/02822548b58fa72419b3044871d08a92/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Sexy Love",
    artist: "Ne-Yo",
    id: 1576044,
    release_date: "2007-04-16",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/7/8/a/0/78a3aded7f98e1b3135c5a24af953665.mp3?hdnea=exp=1763731667~acl=/api/1/1/7/8/a/0/78a3aded7f98e1b3135c5a24af953665.mp3*~data=user_id=0,application_id=42~hmac=33b930fe32ca938e4fa199afc779b0f3bac14d6befbf9049439f636dbc8a34fc",
    cover: "https://api.deezer.com/album/161601/image",
    genre: "Pop",
  },
  {
    title: "Touch My Body",
    artist: "Mariah Carey",
    id: 1225539462,
    release_date: "2008-04-24",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/e/4/3/0/e43132ca4c9d4846bb97cbdd25ced98c.mp3?hdnea=exp=1763731667~acl=/api/1/1/e/4/3/0/e43132ca4c9d4846bb97cbdd25ced98c.mp3*~data=user_id=0,application_id=42~hmac=29f745ef0731a850edf188b936ca81639f75f11e53f97ce6dde11279056609df",
    cover: "https://api.deezer.com/album/203592792/image",
    genre: "Pop",
  },
  {
    title: "What You Waiting For?",
    artist: "Gwen Stefani",
    id: 983448,
    release_date: "2004-11-22",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/0/0/b/0/00b0873e66b2eeb09f78bb0691ff5a21.mp3?hdnea=exp=1763730751~acl=/api/1/1/0/0/b/0/00b0873e66b2eeb09f78bb0691ff5a21.mp3*~data=user_id=0,application_id=42~hmac=f230fdc52f5941bdd2f83457ed96eadc21e37cbe0bb0dc81dd64ccde82af3961",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/0dbe967d19dcf74cf7e2ad7e5c350bc4/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Rich Girl",
    artist: "Gwen Stefani",
    id: 983449,
    release_date: "2004-11-22",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/a/0/d/0/a0d7b5a3d435993575d6ba64116e9b7c.mp3?hdnea=exp=1763730751~acl=/api/1/1/a/0/d/0/a0d7b5a3d435993575d6ba64116e9b7c.mp3*~data=user_id=0,application_id=42~hmac=0c957c0017a3382d4e86f23a586855f0a6be9b4e7b9c75046b6514aef73e2ac1",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/0dbe967d19dcf74cf7e2ad7e5c350bc4/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Cool",
    artist: "Gwen Stefani",
    id: 983455,
    release_date: "2004-11-22",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/7/6/0/0/7607e1733000f4904c2714086dd48a92.mp3?hdnea=exp=1763730751~acl=/api/1/1/7/6/0/0/7607e1733000f4904c2714086dd48a92.mp3*~data=user_id=0,application_id=42~hmac=ce5b21a4afdecbcd7a13336a13cdaa96684b090c81fcefecc1a0dea741db1ca4",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/0dbe967d19dcf74cf7e2ad7e5c350bc4/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Waiting On the World to Change",
    artist: "John Mayer",
    id: 14875475,
    release_date: "2008-05-19",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/0/e/9/0/0e9f7e0db38a8f155d1195402f5fb9a0.mp3?hdnea=exp=1763731667~acl=/api/1/1/0/e/9/0/0e9f7e0db38a8f155d1195402f5fb9a0.mp3*~data=user_id=0,application_id=42~hmac=05e112d26137c35bb739cfef0de0a0892d64ed8b6e3c65b76f5a3988f291775e",
    cover: "https://api.deezer.com/album/1372014/image",
    genre: "Pop",
  },
  {
    title: "My Love",
    artist: "Westlife",
    id: 993615,
    release_date: "2000-11-06",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/d/b/b/0/dbbb98aa772f79c763b8f9e4ae75b32f.mp3?hdnea=exp=1763730751~acl=/api/1/1/d/b/b/0/dbbb98aa772f79c763b8f9e4ae75b32f.mp3*~data=user_id=0,application_id=42~hmac=416ea9287bbe5985536928854e86f5ce5d46fdd255e0fd5da907ce6223530466",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/031a6c4a0067a19d68a215387f1fe2e2/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Let's Dance",
    artist: "Five",
    id: 994520,
    release_date: "2001-01-16",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/9/5/2/0/952e62c2ef339e8fb45064ce59726729.mp3?hdnea=exp=1763730752~acl=/api/1/1/9/5/2/0/952e62c2ef339e8fb45064ce59726729.mp3*~data=user_id=0,application_id=42~hmac=19b6635fc3cb54071cd96b63ab69a456f81c3cef029269962af01744953d4159",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/22f3192b17972a268f8cbe46fa6bb105/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Survivor",
    artist: "Destiny's Child",
    id: 1008337,
    release_date: "1982-03-29",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/a/a/e/0/aaeb9c3d10c6fefcffb8c9f92e64e968.mp3?hdnea=exp=1763730752~acl=/api/1/1/a/a/e/0/aaeb9c3d10c6fefcffb8c9f92e64e968.mp3*~data=user_id=0,application_id=42~hmac=ee449ce55062c00f55e00c484f3f50d51b82f20cf0217aadecba124367ae4c34",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/86f72dd2051d0a225f5799451d20fc5e/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Dancing in the Moonlight",
    artist: "Toploader",
    id: 1011028,
    release_date: "2000-12-29",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/0/d/1/0/0d152ad59c6368d0d22b6543f8600873.mp3?hdnea=exp=1763730752~acl=/api/1/1/0/d/1/0/0d152ad59c6368d0d22b6543f8600873.mp3*~data=user_id=0,application_id=42~hmac=505dfc822c528ecc8231d685e37f62dce494de047e27145f5384bb4275e7d191",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/26e81c50320c98da5ae6f346ff5a092e/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Anything",
    artist: "3T",
    id: 1012851,
    release_date: "1995-10-01",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/c/4/6/0/c46dc94c784274625889246afc982ed4.mp3?hdnea=exp=1763730752~acl=/api/1/1/c/4/6/0/c46dc94c784274625889246afc982ed4.mp3*~data=user_id=0,application_id=42~hmac=56414c0ed0516822a2f97fe70375fc3ff73a5a3a472caa286fda1b1391b73ddd",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/df847b35407475fc497d3046eae11186/250x250-000000-80-0-0.jpg",
    genre: "R&B",
  },
  {
    title: "Killing Me Softly With His Song",
    artist: "Fugees",
    id: 1024973,
    release_date: "2010-02-10",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/04a5526b7b94c6e2d617ade762ddf5dc/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Another Sad Love Song",
    artist: "Toni Braxton",
    id: 1043825,
    release_date: "1993-07-13",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/1/2/4/0/124c1ca1bb6de278071b90261e272bb2.mp3?hdnea=exp=1763730752~acl=/api/1/1/1/2/4/0/124c1ca1bb6de278071b90261e272bb2.mp3*~data=user_id=0,application_id=42~hmac=a0d5fbf647637430c8b8fcb634516bf583c59a4b8e7f16466ca8a8eafe7cce52",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/b906011f5618872a8cfca1695fdd1059/250x250-000000-80-0-0.jpg",
    genre: "R&B",
  },
  {
    title: "Diggin' On You",
    artist: "TLC",
    id: 1043882,
    release_date: "1994-11-14",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/c/8/a/0/c8ab60fb7b149ff07e5e26d8f0683811.mp3?hdnea=exp=1763730752~acl=/api/1/1/c/8/a/0/c8ab60fb7b149ff07e5e26d8f0683811.mp3*~data=user_id=0,application_id=42~hmac=e9226c65c2c77698bc5cd04acb813bc94ac7b9995d6f1377e71436d802aea3b2",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/3134fd3fba883b4e6c8df8dc1487dbef/250x250-000000-80-0-0.jpg",
    genre: "R&B",
  },
  {
    title: "Breathe Again",
    artist: "Toni Braxton",
    id: 1047761,
    release_date: "1993-07-13",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/f/9/d/0/f9d8f08ea58895aaa4fbb26f6ac46a6a.mp3?hdnea=exp=1763730752~acl=/api/1/1/f/9/d/0/f9d8f08ea58895aaa4fbb26f6ac46a6a.mp3*~data=user_id=0,application_id=42~hmac=c89db9d16e1179bc803bd991e39ab1f8086c07d45eb927056539382c9642c1a8",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/b906011f5618872a8cfca1695fdd1059/250x250-000000-80-0-0.jpg",
    genre: "R&B",
  },
  {
    title: "Said I Loved You...But I Lied",
    artist: "Michael Bolton",
    id: 1054944,
    release_date: "1993-11-15",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/4/3/c/0/43c90ee863b678abfee38696f7cadcf1.mp3?hdnea=exp=1763730752~acl=/api/1/1/4/3/c/0/43c90ee863b678abfee38696f7cadcf1.mp3*~data=user_id=0,application_id=42~hmac=87eccbfdcb792ec7336b61491a2b7b6ca039cf7c62c5fb2c13fc992e13607290",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/3f38b48f4124e9b349d512e9d03ec64b/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Vision of Love",
    artist: "Mariah Carey",
    id: 1055713,
    release_date: "1990-06-12",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/4/7/7/0/4770c64d956be929f4eededed298fe4f.mp3?hdnea=exp=1763730752~acl=/api/1/1/4/7/7/0/4770c64d956be929f4eededed298fe4f.mp3*~data=user_id=0,application_id=42~hmac=c840a58e2dbf8671ed2a8a52b925d9568bda51a4de50778f3ea0deb827b7e47f",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/a6842e0e44e02fae9cc5bfa666ffe435/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "Someday",
    artist: "Mariah Carey",
    id: 1056637,
    release_date: "1990-06-12",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/e/9/c/0/e9c60abfdba07ac00f7ae7d511d0f9b0.mp3?hdnea=exp=1763730752~acl=/api/1/1/e/9/c/0/e9c60abfdba07ac00f7ae7d511d0f9b0.mp3*~data=user_id=0,application_id=42~hmac=94722ae44267f2fee971dccadf06a9ff9034f634b554111197a9a9c4db23fb1e",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/a6842e0e44e02fae9cc5bfa666ffe435/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "How Can We Be Lovers",
    artist: "Michael Bolton",
    id: 1056774,
    release_date: "1989-06-27",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/4/6/8/0/468066ab7fb8dfa94722f1a55cbeebd1.mp3?hdnea=exp=1763730752~acl=/api/1/1/4/6/8/0/468066ab7fb8dfa94722f1a55cbeebd1.mp3*~data=user_id=0,application_id=42~hmac=b365a6605e8ad32da5d88a2d54eaf5a9494c959fae72fabe7d6362a0fc34eb49",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/e241034e68be88ff024bd050df76f043/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Step by Step",
    artist: "New Kids On The Block",
    id: 1065849,
    release_date: "1990-06-04",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/f/b/4/0/fb4b52c5006dea10464b8b3ac8f5c939.mp3?hdnea=exp=1763730752~acl=/api/1/1/f/b/4/0/fb4b52c5006dea10464b8b3ac8f5c939.mp3*~data=user_id=0,application_id=42~hmac=a27383899e54adcda114dd06d4d9213eb4d68889c0afd7153e4393e4f165e577",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/5dfb57052ac6302651554dae116230e5/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Tonight",
    artist: "New Kids On The Block",
    id: 1065851,
    release_date: "1990-06-04",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/1/d/0/0/1d04902a7c6d05b3714266dd95789619.mp3?hdnea=exp=1763731667~acl=/api/1/1/1/d/0/0/1d04902a7c6d05b3714266dd95789619.mp3*~data=user_id=0,application_id=42~hmac=2586cfd6ed7272c6f4911799362de1441d349a70273c90c511197feb02df16f6",
    cover: "https://api.deezer.com/album/115829/image",
    genre: "Pop",
  },
  {
    title: "Promise Me",
    artist: "Beverley Craven",
    id: 1073621,
    release_date: "1990-07-09",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/0a3c59a06e27516153f63ad76f9eb0a9/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Bubbly",
    artist: "Colbie Caillat",
    id: 1087017,
    release_date: "2007-09-17",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/363668345f2ad1bd0d72bd53ff339277/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Drop It Like It's Hot",
    artist: "Snoop Dogg",
    id: 1098069,
    release_date: "2004-11-29",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/3d6b2f5daaa104448b5c219732a66673/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "I Tried",
    artist: "Bone Thugs-N-Harmony",
    id: 1099490,
    release_date: "2007-05-08",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/6e31edd175fbf3de647d5bcf6b6a7cc3/250x250-000000-80-0-0.jpg",
    genre: "Rap/Hip Hop",
  },
  {
    title: "My Band",
    artist: "D12",
    id: 1102401,
    release_date: "2004-04-26",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/bdc8d2198ca13f1acc6a44bdaa16a31f/250x250-000000-80-0-0.jpg",
    genre: "Rap/Hip Hop",
  },
  {
    title: "Pieces Of Me",
    artist: "Ashlee Simpson",
    id: 1102486,
    release_date: "2004-07-30",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/19dc49068be0ea8527824943e0f3b102/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Only U (No Intro)",
    artist: "Ashanti",
    id: 1102518,
    release_date: "2004-12-03",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/1f8d7a15ab143414d10f6369b5ec5936/250x250-000000-80-0-0.jpg",
    genre: "R&B",
  },
  {
    title: "Because Of You",
    artist: "Ne-Yo",
    id: 1102966,
    release_date: "2007-05-01",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/a43959834621942aa43a1aded17d3fbe/250x250-000000-80-0-0.jpg",
    genre: "R&B",
  },
  {
    title: "Blaze Of Glory (From 'Young Guns II' Soundtrack)",
    artist: "Jon Bon Jovi",
    id: 1104054,
    release_date: "1990-09-11",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/f4a2d8eb0ed56a5c8512cbbde378cdf9/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "Just My Imagination",
    artist: "The Cranberries",
    id: 1104510,
    release_date: "2002-06-13",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/e12974f5b2c6e5e9fb1e8c32463e62de/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "Through The Wire",
    artist: "Kanye West",
    id: 1104683,
    release_date: "2004-02-10",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/0d079eec6f8995ef64ace8d5fd39dd6e/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Stan",
    artist: "Eminem",
    id: 1109730,
    release_date: "2000-12-09",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/e2b36a9fda865cb2e9ed1476b6291a7d/250x250-000000-80-0-0.jpg",
    genre: "Rap/Hip Hop",
  },
  {
    title: "Shake That",
    artist: "Eminem",
    id: 1109733,
    release_date: "2005-11-21",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/e2b36a9fda865cb2e9ed1476b6291a7d/250x250-000000-80-0-0.jpg",
    genre: "Rap/Hip Hop",
  },
  {
    title: "Like Toy Soldiers",
    artist: "Eminem",
    id: 1109736,
    release_date: "2005-11-21",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/e2b36a9fda865cb2e9ed1476b6291a7d/250x250-000000-80-0-0.jpg",
    genre: "Rap/Hip Hop",
  },
  {
    title: "The Real Slim Shady",
    artist: "Eminem",
    id: 1109737,
    release_date: "2005-11-21",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/e2b36a9fda865cb2e9ed1476b6291a7d/250x250-000000-80-0-0.jpg",
    genre: "Rap/Hip Hop",
  },
  {
    title: "Mockingbird",
    artist: "Eminem",
    id: 1109739,
    release_date: "2005-11-21",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/e2b36a9fda865cb2e9ed1476b6291a7d/250x250-000000-80-0-0.jpg",
    genre: "Rap/Hip Hop",
  },
  {
    title: "When I'm Gone",
    artist: "Eminem",
    id: 1109744,
    release_date: "2005-11-21",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/e2b36a9fda865cb2e9ed1476b6291a7d/250x250-000000-80-0-0.jpg",
    genre: "Rap/Hip Hop",
  },
  {
    title: "When You Were Young",
    artist: "The Killers",
    id: 1109953,
    release_date: "2006-10-12",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/daaf443d20af3ec952c2504a02032e49/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Rule The World",
    artist: "Take That",
    id: 1112125,
    release_date: "2007-10-15",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/4f967bef41ae37144b38d5a54ee79be8/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Wanna Get To Know You",
    artist: "G-Unit",
    id: 1121645,
    release_date: "2014-12-27",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/efdd8f314f78b5dd7db4fbafdbdc8b94/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "America",
    artist: "Razorlight",
    id: 1121936,
    release_date: "1976-11-20",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/1fc2315d13dd6362ee6762936d1d5feb/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "Can't Tell Me Nothing",
    artist: "Kanye West",
    id: 1124863,
    release_date: "2007-06-11",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/96bc031a10b72be6beb897795169b738/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Fat Lip",
    artist: "Sum 41",
    id: 1125079,
    release_date: "2001-08-09",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/4980c272257aa0c38dc2d22972b72dfe/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "Chelsea Dagger",
    artist: "The Fratellis",
    id: 1125334,
    release_date: "2007-10-02",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/56a5af71d7e2c4fbab839135d09f041e/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Until The End Of Time",
    artist: "2Pac",
    id: 1126556,
    release_date: "2001-04-19",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/992a1dbca08c51e41d1cffeb0b0ff6d7/250x250-000000-80-0-0.jpg",
    genre: "Rap/Hip Hop",
  },
  {
    title: "Purple Pills",
    artist: "D12",
    id: 1126602,
    release_date: "2001-06-14",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/df8e1ba1054c1eb75e3f22b6fe51291f/250x250-000000-80-0-0.jpg",
    genre: "Rap/Hip Hop",
  },
  {
    title: "Locked Up",
    artist: "Akon",
    id: 1137869,
    release_date: "2007-06-22",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/1500be1f54f01e99d52a5014860bf3b6/250x250-000000-80-0-0.jpg",
    genre: "Rap/Hip Hop",
  },
  {
    title: "Better Than Me",
    artist: "Hinder",
    id: 1138326,
    release_date: "2007-01-11",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/1af921cd540fb3523ab883472a3c2ba0/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "Lips Of An Angel",
    artist: "Hinder",
    id: 1138329,
    release_date: "2007-01-11",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/1af921cd540fb3523ab883472a3c2ba0/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "Make Me Better",
    artist: "Fabolous",
    id: 1138690,
    release_date: "2007-06-12",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/ef0f9fa8203752883da48bddc7ebf2d6/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Everytime We Touch (Remix)",
    artist: "Cascada",
    id: 1139054,
    release_date: "2007-01-15",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/f1cf9edd40e52a426f85c912af34f76d/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Case Of The Ex (Whatcha Gonna Do)",
    artist: "Mya",
    id: 1140336,
    release_date: "2001-05-28",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/e5981b4586472571c8a5acbea587531a/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Get It On Tonite (Album Version)",
    artist: "Montell Jordan",
    id: 1141514,
    release_date: "2011-12-16",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/91c638c497c3602dc0128dffa3fa6f12/250x250-000000-80-0-0.jpg",
    genre: "R&B",
  },
  {
    title: "Grace Kelly",
    artist: "MIKA",
    id: 1142725,
    release_date: "2007-02-26",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/91f5f0d415958e009641ed060fe09e64/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Sit Down",
    artist: "James",
    id: 1142813,
    release_date: "2007-05-07",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/196adb20fa0b1535a177b1244fdd9f28/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Take A Look Around",
    artist: "Limp Bizkit",
    id: 1143493,
    release_date: "2007-11-01",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/f17a6d764d4eea95dab085c917e1ce7f/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "Laid",
    artist: "James",
    id: 1150506,
    release_date: "2009-01-30",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/489b166c2de5db7223037ec3d6e0882f/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Insensitive",
    artist: "Jann Arden",
    id: 1153062,
    release_date: "1995-02-28",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/7da3bfc0252f4aca06ae5e287078b14a/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Push The Button",
    artist: "Sugababes",
    id: 1159190,
    release_date: "2009-09-28",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/c65ac45fff047f4827f6bca0ef00066d/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Don't Cha",
    artist: "The Pussycat Dolls",
    id: 1161005,
    release_date: "2005-10-13",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/b8d29ee7cf1683a32358f9bab783df15/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Stickwitu",
    artist: "The Pussycat Dolls",
    id: 1161008,
    release_date: "2005-10-13",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/b8d29ee7cf1683a32358f9bab783df15/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Buttons",
    artist: "The Pussycat Dolls",
    id: 1161009,
    release_date: "2005-10-13",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/b8d29ee7cf1683a32358f9bab783df15/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Be Without You (Kendu Mix)",
    artist: "Mary J. Blige",
    id: 1161682,
    release_date: "2006-12-14",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/a3939a5b62df412e83d898dfd85035c9/250x250-000000-80-0-0.jpg",
    genre: "R&B",
  },
  {
    title: "She Will Be Loved",
    artist: "Maroon 5",
    id: 1165303,
    release_date: "2007-06-21",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/39fe38574c7af3181d1e56ad7c03fce3/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Put It On Me",
    artist: "Ja Rule",
    id: 1165992,
    release_date: "2001-04-03",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/93cd81ab9e24303e07abbc2bc76a5191/250x250-000000-80-0-0.jpg",
    genre: "R&B",
  },
  {
    title: "Sacrifice",
    artist: "Elton John",
    id: 1166025,
    release_date: "1989-10-20",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/1cb1ba8c9d2357c6cda590b48ac2d642/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Live And Let Die",
    artist: "Guns N' Roses",
    id: 1169676,
    release_date: "1991-09-18",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/546fe1eca5d3bf48c6a48fb3c0ddac63/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "Don't Cry (Original)",
    artist: "Guns N' Roses",
    id: 1169677,
    release_date: "1991-09-18",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/546fe1eca5d3bf48c6a48fb3c0ddac63/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "This Ain't A Scene, It's An Arms Race",
    artist: "Fall Out Boy",
    id: 1169830,
    release_date: "2007-01-29",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/bf36522124e0f5cfc86cd5bc2b7f3959/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "We Belong Together",
    artist: "Mariah Carey",
    id: 1170586,
    release_date: "2007-09-03",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/64512aad7ba4d5278b84c647b131124e/250x250-000000-80-0-0.jpg",
    genre: "R&B",
  },
  {
    title: "Too Little, Too Late (Album Version)",
    artist: "JoJo",
    id: 1170615,
    release_date: "2007-09-03",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/64512aad7ba4d5278b84c647b131124e/250x250-000000-80-0-0.jpg",
    genre: "R&B",
  },
  {
    title: "Ridin'",
    artist: "Chamillionaire",
    id: 1172093,
    release_date: "2008-06-19",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/61731168bac0366142b80b66a4e31d74/250x250-000000-80-0-0.jpg",
    genre: "Rap/Hip Hop",
  },
  {
    title: "When You're Gone",
    artist: "Bryan Adams",
    id: 1172332,
    release_date: "1999-11-10",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/e0b9ed40e62936f3ab8ea80122115730/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "The Reason",
    artist: "Hoobastank",
    id: 1172920,
    release_date: "2003-12-09",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/d8be54e2c3140b823274a7e99652d89b/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Lost Without U",
    artist: "Robin Thicke",
    id: 1173720,
    release_date: "2006-10-03",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/79f3c86a009fdeb34ef9053a4cead92d/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Get It Shawty",
    artist: "Lloyd",
    id: 1176072,
    release_date: "2007-03-13",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/04e14d3286307ce645d0ded5d68d02f9/250x250-000000-80-0-0.jpg",
    genre: "R&B",
  },
  {
    title: "Just A Girl",
    artist: "No Doubt",
    id: 1176775,
    release_date: "2003-11-24",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/b30056da894f7f8acb84899210f38089/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Tease Me",
    artist: "Chaka Demus & Pliers",
    id: 1178331,
    release_date: "1994-02-07",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/a9cfcaaaa113ee5d5a39bf138ef721da/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "She Don't Let Nobody",
    artist: "Chaka Demus & Pliers",
    id: 1178332,
    release_date: "1994-02-07",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/a9cfcaaaa113ee5d5a39bf138ef721da/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Twist And Shout",
    artist: "Chaka Demus & Pliers",
    id: 1178343,
    release_date: "1994-02-07",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/a9cfcaaaa113ee5d5a39bf138ef721da/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "I'm The Only One",
    artist: "Melissa Etheridge",
    id: 1181048,
    release_date: "1993-11-17",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/b73e0d4e32b14a307e53ee6c3aae45dd/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Come To My Window",
    artist: "Melissa Etheridge",
    id: 1181050,
    release_date: "1993-11-17",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/b73e0d4e32b14a307e53ee6c3aae45dd/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "(Everything I Do) I Do It For You",
    artist: "Bryan Adams",
    id: 1182159,
    release_date: "1996-03-15",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/d7d28861a72ecb30a7676ec38db05907/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Beverly Hills",
    artist: "Weezer",
    id: 1183538,
    release_date: "2005-05-02",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/239515c0d77e9fc21c2c37b28a1fcac7/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "Gold Digger",
    artist: "Kanye West",
    id: 1184309,
    release_date: "2005-08-12",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/7cbfc94084895e59b5a313a98ab1bd9a/250x250-000000-80-0-0.jpg",
    genre: "Rap/Hip Hop",
  },
  {
    title: "Diamonds From Sierra Leone (Remix)",
    artist: "Kanye West",
    id: 1184318,
    release_date: "2005-08-12",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/7cbfc94084895e59b5a313a98ab1bd9a/250x250-000000-80-0-0.jpg",
    genre: "Rap/Hip Hop",
  },
  {
    title: "Chasing Cars",
    artist: "Snow Patrol",
    id: 1184425,
    release_date: "2006-08-04",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/fce2bbf1625b343693fd80627c4cfbb4/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "Shake It",
    artist: "Metro Station",
    id: 1277448,
    release_date: "2007-09-18",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/8da54959f5118fcd83541790b9a2368a/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "It Never Rains (In Southern California)",
    artist: "Tony! Toni! Toné!",
    id: 1561286,
    release_date: "2001-08-28",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/e2a9db8bff21181276833b06b7fa8041/250x250-000000-80-0-0.jpg",
    genre: "R&B",
  },
  {
    title: "Be With You",
    artist: "Enrique Iglesias",
    id: 1567451,
    release_date: "2003-11-16",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/1f7545f0e94660f0a9dd9d4b91731d34/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Life Is A Rollercoaster",
    artist: "Ronan Keating",
    id: 1570220,
    release_date: "2004-10-11",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/4/4/b/0/44b87e37766a45fb46910439d5b7c9ab.mp3?hdnea=exp=1763731671~acl=/api/1/1/4/4/b/0/44b87e37766a45fb46910439d5b7c9ab.mp3*~data=user_id=0,application_id=42~hmac=b4ce398e50afd3493f2f04b4aba4255cbdfe06b19dbe1b40ae4526d8f1b39fb4",
    cover: "https://api.deezer.com/album/161037/image",
    genre: "Pop",
  },
  {
    title: "Lovin' Each Day",
    artist: "Ronan Keating",
    id: 1570226,
    release_date: "2004-10-11",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/4/9/3/0/49363d99a1667602194b8ee1f14ecc18.mp3?hdnea=exp=1763731671~acl=/api/1/1/4/9/3/0/49363d99a1667602194b8ee1f14ecc18.mp3*~data=user_id=0,application_id=42~hmac=a70a56e3373a6aea2aa77046b9b68a05d8c4c78f8f2e7fbc462f88edc389801c",
    cover: "https://api.deezer.com/album/161037/image",
    genre: "Pop",
  },
  {
    title: "In The Morning",
    artist: "Razorlight",
    id: 1571865,
    release_date: "2006-10-02",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/3/7/8/0/378b67424b93103aa51a3b3034b92d19.mp3?hdnea=exp=1763731671~acl=/api/1/1/3/7/8/0/378b67424b93103aa51a3b3034b92d19.mp3*~data=user_id=0,application_id=42~hmac=c840f8f4d4d0c8827c76140c0e761cffec30c31b4bce184d34dbabb18b5a7a48",
    cover: "https://api.deezer.com/album/161148/image",
    genre: "Pop",
  },
  {
    title: "No Tomorrow",
    artist: "Orson",
    id: 1574192,
    release_date: "2006-05-29",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/a/a/1/0/aa1288b4e469937f76a8026508e790d1.mp3?hdnea=exp=1763731671~acl=/api/1/1/a/a/1/0/aa1288b4e469937f76a8026508e790d1.mp3*~data=user_id=0,application_id=42~hmac=40e4b7f76f12cd7baf5a111dfdf8f8490ca2886eb5509e2bffa72e63f26b173d",
    cover: "https://api.deezer.com/album/161394/image",
    genre: "Pop",
  },
  {
    title: "SOS (Album Version)",
    artist: "Rihanna",
    id: 1574660,
    release_date: "2006-05-02",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/f/3/6/0/f36b7748475a95c323d41bb954979acb.mp3?hdnea=exp=1763731671~acl=/api/1/1/f/3/6/0/f36b7748475a95c323d41bb954979acb.mp3*~data=user_id=0,application_id=42~hmac=32ec25daab877ae1c15efc4bc7b79392fd2cc04e8a6b751e3aa0f7aa55579d1e",
    cover: "https://api.deezer.com/album/161439/image",
    genre: "Pop",
  },
  {
    title: "Unfaithful (Album Version)",
    artist: "Rihanna",
    id: 1574666,
    release_date: "2006-06-29",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/9/d/2/0/9d2c53f20bedcec9d181872ebb5e3341.mp3?hdnea=exp=1763731671~acl=/api/1/1/9/d/2/0/9d2c53f20bedcec9d181872ebb5e3341.mp3*~data=user_id=0,application_id=42~hmac=edc2c6905a2e2061a806fcd0fd7fda0d336525ea40df4e9a034c2c87f013b9c9",
    cover: "https://api.deezer.com/album/161439/image",
    genre: "Pop",
  },
  {
    title: "The First Cut Is The Deepest",
    artist: "Sheryl Crow",
    id: 1574833,
    release_date: "2003-10-05",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/7/a/1/0/7a1494af9bd7f0175f32bedabbd94759.mp3?hdnea=exp=1763731671~acl=/api/1/1/7/a/1/0/7a1494af9bd7f0175f32bedabbd94759.mp3*~data=user_id=0,application_id=42~hmac=8e60283add434df532676afd0eae39289dfd2325bda1ce3b6d472cdaebb05d2b",
    cover: "https://api.deezer.com/album/161459/image",
    genre: "Pop",
  },
  {
    title: "Shine",
    artist: "Take That",
    id: 60725345,
    release_date: "2006-11-24",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/d/2/6/0/d26b7f75a0dc3e62871a000ce561ed3d.mp3?hdnea=exp=1763731671~acl=/api/1/1/d/2/6/0/d26b7f75a0dc3e62871a000ce561ed3d.mp3*~data=user_id=0,application_id=42~hmac=fffa3f30089bdff0c839642a2715975018c37117eab7dc2e78017a878afa1410",
    cover: "https://api.deezer.com/album/5942135/image",
    genre: "Pop",
  },
  {
    title: "Money Maker",
    artist: "Ludacris",
    id: 1575902,
    release_date: "2006-10-12",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/a/4/8/0/a48a14b03c564bc8ad4e7c2e2c888453.mp3?hdnea=exp=1763731671~acl=/api/1/1/a/4/8/0/a48a14b03c564bc8ad4e7c2e2c888453.mp3*~data=user_id=0,application_id=42~hmac=b8cf68c74b517a10951758c489db529518682a0836f76c45d0282b807b6e8e9e",
    cover: "https://api.deezer.com/album/161578/image",
    genre: "Rap/Hip Hop",
  },
  {
    title: "Runaway Love",
    artist: "Ludacris",
    id: 1575918,
    release_date: "2006-10-12",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/6/6/c/0/66c260f71719ff09846d719cff34627e.mp3?hdnea=exp=1763731671~acl=/api/1/1/6/6/c/0/66c260f71719ff09846d719cff34627e.mp3*~data=user_id=0,application_id=42~hmac=4500a69126aa4dc225bf9dd658f0bdadb0d176ec853caa4f854a7aa5ed58a8dc",
    cover: "https://api.deezer.com/album/161578/image",
    genre: "Rap/Hip Hop",
  },
  {
    title: "Wonderful World",
    artist: "James Morrison",
    id: 1575967,
    release_date: "2006-09-11",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/c/6/c/0/c6c45aa7c6636c6f6bf54b307096a18c.mp3?hdnea=exp=1763731671~acl=/api/1/1/c/6/c/0/c6c45aa7c6636c6f6bf54b307096a18c.mp3*~data=user_id=0,application_id=42~hmac=8e9e191fb80c96d0391d3f3ed527e166de470f7c039d2477ccce8a7033cf1a48",
    cover: "https://api.deezer.com/album/161583/image",
    genre: "Country",
  },
  {
    title: "You Give Me Something",
    artist: "James Morrison",
    id: 929557,
    release_date: "2006-09-04",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/4/4/d/0/44d17012f59e71f9d959f6cd9130d570.mp3?hdnea=exp=1763731671~acl=/api/1/1/4/4/d/0/44d17012f59e71f9d959f6cd9130d570.mp3*~data=user_id=0,application_id=42~hmac=b9498f60fb535e3ee42182c285ca6efc0881c51bcc421f53aa0c581416a01939",
    cover: "https://api.deezer.com/album/102951/image",
    genre: "Pop",
  },
  {
    title: "Glamorous",
    artist: "Fergie",
    id: 1577408,
    release_date: "2006-09-18",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/7/8/4/0/784142817b25d33d1e7b3649145bac1b.mp3?hdnea=exp=1763731671~acl=/api/1/1/7/8/4/0/784142817b25d33d1e7b3649145bac1b.mp3*~data=user_id=0,application_id=42~hmac=9a140a78f43587a086db7f54df9abac7e6db206796fdd5d171ec53a66ac9fda4",
    cover: "https://api.deezer.com/album/161755/image",
    genre: "Pop",
  },
  {
    title: "What's The Difference",
    artist: "Dr. Dre",
    id: 128743587,
    release_date: "1999-12-21",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/b/d/1/0/bd150be90115cadfdaf00db712ac9dad.mp3?hdnea=exp=1763731671~acl=/api/1/1/b/d/1/0/bd150be90115cadfdaf00db712ac9dad.mp3*~data=user_id=0,application_id=42~hmac=33774789e937fd1eede7615491a58f82c505abf881d46b610a51696c7bd68d53",
    cover: "https://api.deezer.com/album/13606387/image",
    genre: "Pop",
  },
  {
    title: "Forgot About Dre",
    artist: "Dr. Dre",
    id: 128743593,
    release_date: "1999-12-21",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/3/8/6/0/386934fb234fcbad988e0d49da77c597.mp3?hdnea=exp=1763731671~acl=/api/1/1/3/8/6/0/386934fb234fcbad988e0d49da77c597.mp3*~data=user_id=0,application_id=42~hmac=8bdf2dd9aab5434595d5f8de984fa0a1102ad5a23f7fa254028c2a7e4f548049",
    cover: "https://api.deezer.com/album/13606387/image",
    genre: "Pop",
  },
  {
    title: "The Next Episode",
    artist: "Dr. Dre",
    id: 128743595,
    release_date: "1999-12-21",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/b/7/c/0/b7cd9c360222d7d4b8bcb384f9353bec.mp3?hdnea=exp=1763731671~acl=/api/1/1/b/7/c/0/b7cd9c360222d7d4b8bcb384f9353bec.mp3*~data=user_id=0,application_id=42~hmac=b12b130fd009a9ca17167faf713d3d69c3086d008b5555d9440bf252f43765c8",
    cover: "https://api.deezer.com/album/13606387/image",
    genre: "Pop",
  },
  {
    title: "The Only Thing That Looks Good On Me Is You",
    artist: "Bryan Adams",
    id: 1582142,
    release_date: "1996-05-07",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/a/1/e/0/a1e0f96fe6c703e72bf4f4c6df10e2ca.mp3?hdnea=exp=1763731671~acl=/api/1/1/a/1/e/0/a1e0f96fe6c703e72bf4f4c6df10e2ca.mp3*~data=user_id=0,application_id=42~hmac=1ab1c99d91fce2104c1b51707a830942b47903819a4c17162cfb8366554c47c6",
    cover: "https://api.deezer.com/album/162157/image",
    genre: "Pop",
  },
  {
    title: "Let's Make A Night To Remember",
    artist: "Bryan Adams",
    id: 1582144,
    release_date: "1996-05-07",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/2/2/4/0/224e96181f0374fb1b081879f098c7c8.mp3?hdnea=exp=1763731671~acl=/api/1/1/2/2/4/0/224e96181f0374fb1b081879f098c7c8.mp3*~data=user_id=0,application_id=42~hmac=02335aab70bbfcadea8fe14614dbfba0fe06b6690c85bb7b153bbf0f70e61316",
    cover: "https://api.deezer.com/album/162157/image",
    genre: "Pop",
  },
  {
    title: "Where My Girls At",
    artist: "702",
    id: 1583246,
    release_date: "2008-05-15",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/8/9/9/0/899e8cba71a408c7a313bc74ffa6fe81.mp3?hdnea=exp=1763731671~acl=/api/1/1/8/9/9/0/899e8cba71a408c7a313bc74ffa6fe81.mp3*~data=user_id=0,application_id=42~hmac=9ccb4b7c0af71f1c552c4b00bad0ce224fca537fe884bd92a06f5a66007e4b44",
    cover: "https://api.deezer.com/album/162230/image",
    genre: "R&B",
  },
  {
    title: "No More Drama",
    artist: "Mary J. Blige",
    id: 2112335,
    release_date: "2002-02-21",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/1/2/8/0/1283438c640fde59ad3a86ec96f51f27.mp3?hdnea=exp=1763731671~acl=/api/1/1/1/2/8/0/1283438c640fde59ad3a86ec96f51f27.mp3*~data=user_id=0,application_id=42~hmac=c6b8735679ef0f8254a12ca95d69c7b0bb4272d57ec6d949f3fbf6d506e9b0f7",
    cover: "https://api.deezer.com/album/212183/image",
    genre: "Pop",
  },
  {
    title: "Ms. Fat Booty",
    artist: "Mos Def",
    id: 2112351,
    release_date: "2002-07-30",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/4/2/c/0/42ca2da3a64fd857f74f926105cc117a.mp3?hdnea=exp=1763731671~acl=/api/1/1/4/2/c/0/42ca2da3a64fd857f74f926105cc117a.mp3*~data=user_id=0,application_id=42~hmac=7a0d00a90d55cb897b11932bcb3254eb3af3549bfd171f852d491433830efb9d",
    cover: "https://api.deezer.com/album/212184/image",
    genre: "Pop",
  },
  {
    title: "Nothing Else Matters",
    artist: "Metallica",
    id: 2114406,
    release_date: "1991-10-04",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/f1c31620f0e108b707ce1a1af0954158/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Boombastic",
    artist: "Shaggy",
    id: 2122526,
    release_date: "1995-06-05",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/8/5/8/0/8588095299f2aed737681d3c30246b66.mp3?hdnea=exp=1763731671~acl=/api/1/1/8/5/8/0/8588095299f2aed737681d3c30246b66.mp3*~data=user_id=0,application_id=42~hmac=5a1dbb0a52c93671b2e115e8f6f9d78882db0ee70e32d260d4e855546e2ff4e0",
    cover: "https://api.deezer.com/album/213082/image",
    genre: "Pop",
  },
  {
    title: "Angel",
    artist: "Shaggy",
    id: 2122528,
    release_date: "2008-08-25",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/e/c/d/0/ecd57aff7760c2d8af12a66dfb2306b3.mp3?hdnea=exp=1763731671~acl=/api/1/1/e/c/d/0/ecd57aff7760c2d8af12a66dfb2306b3.mp3*~data=user_id=0,application_id=42~hmac=437d161defddbac598ee8c4d2a55d04044a911b5d7847a9ff77bf5500ec646d8",
    cover: "https://api.deezer.com/album/213082/image",
    genre: "Pop",
  },
  {
    title: "Bag Lady",
    artist: "Erykah Badu",
    id: 2122750,
    release_date: "2000-11-17",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/f/e/0/0/fe0116857456df41c150fb658239e231.mp3?hdnea=exp=1763731671~acl=/api/1/1/f/e/0/0/fe0116857456df41c150fb658239e231.mp3*~data=user_id=0,application_id=42~hmac=6a79856eb7da56c1e90893eb02868ed36baf03ae54e9f652b038628471c8c737",
    cover: "https://api.deezer.com/album/213094/image",
    genre: "R&B",
  },
  {
    title: "Lollipop",
    artist: "Lil Wayne",
    id: 2124764,
    release_date: "2008-08-11",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/5/a/2/0/5a20696d07ddab275b748f650e2bd882.mp3?hdnea=exp=1763731671~acl=/api/1/1/5/a/2/0/5a20696d07ddab275b748f650e2bd882.mp3*~data=user_id=0,application_id=42~hmac=ec4ba6b237977698ff5e5c9867afad72c82b79478f46cbc884a6dac1603695b2",
    cover: "https://api.deezer.com/album/213327/image",
    genre: "Rap/Hip Hop",
  },
  {
    title: "Heard It All Before",
    artist: "Sunshine Anderson",
    id: 2129585,
    release_date: "2008-08-29",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/0/3/f/0/03fb03a7c23c34032d2ee3ecbbf12c2b.mp3?hdnea=exp=1763731671~acl=/api/1/1/0/3/f/0/03fb03a7c23c34032d2ee3ecbbf12c2b.mp3*~data=user_id=0,application_id=42~hmac=fbc5753d2981ee35b6f896a70bc3a02c922e97a625cfaf0715580bac439fd8f5",
    cover: "https://api.deezer.com/album/213709/image",
    genre: "R&B",
  },
  {
    title: "Missing (Todd Terry Remix)",
    artist: "Everything But The Girl",
    id: 2138669,
    release_date: "1994-06-13",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/106ae38357f72d17430b7954ff2a3fab/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Far Away",
    artist: "Nickelback",
    id: 2139735,
    release_date: "2008-09-12",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/8/0/2/0/802a67b2745ab32e01d2f4377e394ed9.mp3?hdnea=exp=1763731671~acl=/api/1/1/8/0/2/0/802a67b2745ab32e01d2f4377e394ed9.mp3*~data=user_id=0,application_id=42~hmac=a6456973ca8b9be9d65c1006d6456e53ea3f8eee0d9c2a2a927eeab067231ea5",
    cover: "https://api.deezer.com/album/214572/image",
    genre: "Rock",
  },
  {
    title: "Air Hostess",
    artist: "Busted",
    id: 2157931,
    release_date: "2004-06-21",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/2/6/7/0/2672458e9747d7e324753be3219908e7.mp3?hdnea=exp=1763731671~acl=/api/1/1/2/6/7/0/2672458e9747d7e324753be3219908e7.mp3*~data=user_id=0,application_id=42~hmac=2f44fa33f7c614d874b7b6f42f8059c1f0056bd2b1ba6babb5a5eb99cf02dcc8",
    cover: "https://api.deezer.com/album/215977/image",
    genre: "Pop",
  },
  {
    title: "When I Grow Up",
    artist: "The Pussycat Dolls",
    id: 619976902,
    release_date: "2008-09-22",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/5/8/f/0/58fda5c8cbcffebef14e0596290945ed.mp3?hdnea=exp=1763731672~acl=/api/1/1/5/8/f/0/58fda5c8cbcffebef14e0596290945ed.mp3*~data=user_id=0,application_id=42~hmac=39931b933426a6225a999d6dc80f34b5b866fe584473232b5c1a6bfd210de4ff",
    cover: "https://api.deezer.com/album/84882522/image",
    genre: "Pop",
  },
  {
    title: "Love",
    artist: "Musiq Soulchild",
    id: 2162815,
    release_date: "2008-04-28",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/6/c/7/0/6c73955a4c9eb8393048c2cee25348b9.mp3?hdnea=exp=1763731672~acl=/api/1/1/6/c/7/0/6c73955a4c9eb8393048c2cee25348b9.mp3*~data=user_id=0,application_id=42~hmac=17f79e695911a63dad3fab2a40ff58e905a4212f2886cc564474af106e5b459b",
    cover: "https://api.deezer.com/album/216492/image",
    genre: "Pop",
  },
  {
    title: "Live Your Life (feat. Rihanna)",
    artist: "T.I.",
    id: 2164882,
    release_date: "2008-09-08",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/16f821683f216c4bf834c9348b9a8f62/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Everytime",
    artist: "Britney Spears",
    id: 2168030,
    release_date: "2004-11-08",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/d/7/f/0/d7f79555630c98c015bbdb7b06822f57.mp3?hdnea=exp=1763731672~acl=/api/1/1/d/7/f/0/d7f79555630c98c015bbdb7b06822f57.mp3*~data=user_id=0,application_id=42~hmac=0f8e1710bd9bb5da673e9578947f0fb754f870cff71fab95d0482c953e08385a",
    cover: "https://api.deezer.com/album/74926/image",
    genre: "Pop",
  },
  {
    title: "Here Without You",
    artist: "3 Doors Down",
    id: 2172900,
    release_date: "2002-11-13",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/c/f/3/0/cf3d23630f678d7d5703590aea546a0b.mp3?hdnea=exp=1763731672~acl=/api/1/1/c/f/3/0/cf3d23630f678d7d5703590aea546a0b.mp3*~data=user_id=0,application_id=42~hmac=bd3627938fdf142b0818f39bc593bed0d2b41453a4a4fc09768cc1163635463e",
    cover: "https://api.deezer.com/album/217393/image",
    genre: "Rock",
  },
  {
    title: "Back At One",
    artist: "Brian McKnight",
    id: 2173612,
    release_date: "2000-02-09",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/2/2/8/0/22866f4dd49e04729d6ec21b8cdbe5dd.mp3?hdnea=exp=1763731672~acl=/api/1/1/2/2/8/0/22866f4dd49e04729d6ec21b8cdbe5dd.mp3*~data=user_id=0,application_id=42~hmac=fd7fb4fb09d8eb244e8c84fdc08827b3b8d6dd6d18e300fc664b60fe271179ea",
    cover: "https://api.deezer.com/album/217444/image",
    genre: "R&B",
  },
  {
    title: "Baby, I'm Back",
    artist: "Baby Bash",
    id: 2176492,
    release_date: "2005-03-14",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/4/f/4/0/4f43b9d98aa7c7bb4c8d19f503c293b4.mp3?hdnea=exp=1763731672~acl=/api/1/1/4/f/4/0/4f43b9d98aa7c7bb4c8d19f503c293b4.mp3*~data=user_id=0,application_id=42~hmac=c761a0c322282121f1df866c8daa23f5c32c2e41f3f704b5f9f8ca88ae038917",
    cover: "https://api.deezer.com/album/217747/image",
    genre: "Rap/Hip Hop",
  },
  {
    title: "Tears Dry On Their Own",
    artist: "Amy Winehouse",
    id: 2176858,
    release_date: "2006-10-30",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/2/8/9/0/289b5e55edbbc89bf5a3a8501a7f4bc1.mp3?hdnea=exp=1763731672~acl=/api/1/1/2/8/9/0/289b5e55edbbc89bf5a3a8501a7f4bc1.mp3*~data=user_id=0,application_id=42~hmac=be683c693cec5db929f0dbf82f0423f1807b93f31d0b854a6ff6dc52274db86e",
    cover: "https://api.deezer.com/album/217795/image",
    genre: "R&B",
  },
  {
    title: "Southern Hospitality (Featuring Pharrell)",
    artist: "Ludacris",
    id: 2179333,
    release_date: "2008-06-26",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/e/d/b/0/edb48f6cee449373a3cc08557a44868b.mp3?hdnea=exp=1763731672~acl=/api/1/1/e/d/b/0/edb48f6cee449373a3cc08557a44868b.mp3*~data=user_id=0,application_id=42~hmac=6430b2bb7fc9372abe7147a3ad27ac9c2167008abe31ce7e2cc35243caaef55f",
    cover: "https://api.deezer.com/album/217946/image",
    genre: "R&B",
  },
  {
    title: "Spotlight",
    artist: "Jennifer Hudson",
    id: 2181154,
    release_date: "2008-09-29",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/6/8/6/0/68658901e251cfcae73f6d420af9cb7c.mp3?hdnea=exp=1763731672~acl=/api/1/1/6/8/6/0/68658901e251cfcae73f6d420af9cb7c.mp3*~data=user_id=0,application_id=42~hmac=e37ab27fc858b9adc03fed08d59b218bb4c3c323d9b3a6d4cca9a03fa8918cf7",
    cover: "https://api.deezer.com/album/218087/image",
    genre: "R&B",
  },
  {
    title: "Outta Control",
    artist: "50 Cent",
    id: 2183835,
    release_date: "2005-06-21",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/8/e/9/0/8e9fc0f429d74968cc2958ffa61d6ecc.mp3?hdnea=exp=1763731672~acl=/api/1/1/8/e/9/0/8e9fc0f429d74968cc2958ffa61d6ecc.mp3*~data=user_id=0,application_id=42~hmac=fdfec228d0b2a0180b256441178d455e3f336ab37ac7928e47acd1f1c040ac36",
    cover: "https://api.deezer.com/album/218276/image",
    genre: "Rap/Hip Hop",
  },
  {
    title: "I Like The Way",
    artist: "Bodyrockers",
    id: 2184465,
    release_date: "2005-05-09",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/e5e0b056b5968d94647d5235850c9cd0/250x250-000000-80-0-0.jpg",
    genre: "Dance",
  },
  {
    title: "God Gave Rock 'N' Roll To You II (Live/1992)",
    artist: "Kiss",
    id: 2184735,
    release_date: "1991-07-05",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/a2a6ae101ad36ca524cef3a5f606a52f/250x250-000000-80-0-0.jpg",
    genre: "Films/Games",
  },
  {
    title: "You Needed Me",
    artist: "Boyzone",
    id: 2203336,
    release_date: "2008-10-12",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/2b9108c553da504d4b2ff3fe1f82c892/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "When The Going Gets Tough",
    artist: "Boyzone",
    id: 2203342,
    release_date: "2008-10-12",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/2b9108c553da504d4b2ff3fe1f82c892/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Dangerous",
    artist: "Kardinal Offishall",
    id: 2203354,
    release_date: "2008-10-13",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/1/f/c/0/1fc708f8ca0ad236be0e89cc8edece5a.mp3?hdnea=exp=1763730477~acl=/api/1/1/1/f/c/0/1fc708f8ca0ad236be0e89cc8edece5a.mp3*~data=user_id=0,application_id=42~hmac=52e3b11755a91d0ab5dc8f74c76656b6e8399d48e58729c098b67a25c263b17e",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/c37e16d3e0ba7d8274ec6ad90ae642d4/250x250-000000-80-0-0.jpg",
    genre: "Rap/Hip Hop",
  },
  {
    title: "I Wanna Know",
    artist: "Joe",
    id: 2221574,
    release_date: "2008-10-13",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/f/7/e/0/f7e5db42f9e234648f8dab73c03762f4.mp3?hdnea=exp=1763730477~acl=/api/1/1/f/7/e/0/f7e5db42f9e234648f8dab73c03762f4.mp3*~data=user_id=0,application_id=42~hmac=da7e6b479beba18bcc36b422e98a0cf70c3af7bdf8e9ef41b2fd1df19d001b76",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/d316a5dceea79d5e0c7475976661a8ae/250x250-000000-80-0-0.jpg",
    genre: "R&B",
  },
  {
    title: "Stutter (feat. Mystikal) (Double Take Remix)",
    artist: "Joe",
    id: 2221577,
    release_date: "2008-10-13",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/a/a/7/0/aa7a36b79628581b6b00495fef215384.mp3?hdnea=exp=1763730477~acl=/api/1/1/a/a/7/0/aa7a36b79628581b6b00495fef215384.mp3*~data=user_id=0,application_id=42~hmac=5017961523761a078307a79a6adf3daccc7965834e14aed292d6f1f57db726ff",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/d316a5dceea79d5e0c7475976661a8ae/250x250-000000-80-0-0.jpg",
    genre: "R&B",
  },
  {
    title: "A Little Time",
    artist: "The Beautiful South",
    id: 2230580,
    release_date: "1990-10-29",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/5/f/c/0/5fc581c4d43f23a5307088de4d307c9d.mp3?hdnea=exp=1763730477~acl=/api/1/1/5/f/c/0/5fc581c4d43f23a5307088de4d307c9d.mp3*~data=user_id=0,application_id=42~hmac=974cb3bf29dce0063308b356bc3f6bad94e02e58b7079aa661beaeec7f12f48e",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/73a960872a2c457707d2ab6edbd8749b/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "AM To PM",
    artist: "Christina Milian",
    id: 2232897,
    release_date: "2002-01-21",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/b/0/e/0/b0ee7e79685e3841d332a067f8d03697.mp3?hdnea=exp=1763730477~acl=/api/1/1/b/0/e/0/b0ee7e79685e3841d332a067f8d03697.mp3*~data=user_id=0,application_id=42~hmac=ff74787637738b98cdad9ecd1d0f8535000189cfb7e7defe57e955db469273f1",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/e66e6d29a957371dd58a971892f3b7e1/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Rhythm Of Life",
    artist: "Oleta Adams",
    id: 2233716,
    release_date: "1991-07-01",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/d/9/d/0/d9df2a4736f5a0306dc5b2329eb9df5f.mp3?hdnea=exp=1763730477~acl=/api/1/1/d/9/d/0/d9df2a4736f5a0306dc5b2329eb9df5f.mp3*~data=user_id=0,application_id=42~hmac=f2229e9b51fa38949cff57b07cea73aab55211f8d0f5a0c18b8886859158cf1a",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/05704f56ff522fb4ffa81693078ef29e/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Get Here",
    artist: "Oleta Adams",
    id: 2233717,
    release_date: "1991-07-01",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/0/0/4/0/004df262f913b0128a4ab51a75f9d4c6.mp3?hdnea=exp=1763730477~acl=/api/1/1/0/0/4/0/004df262f913b0128a4ab51a75f9d4c6.mp3*~data=user_id=0,application_id=42~hmac=3a7b960a61861ef54a0f4fcc6c454c2e3a4da07e8e46c1ac5d180a5a4afea7cf",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/05704f56ff522fb4ffa81693078ef29e/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "What Would You Do?",
    artist: "City High",
    id: 2233967,
    release_date: "2001-10-23",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/1/c/0/0/1c0cce4aa58053fc55daf236c25bd0b2.mp3?hdnea=exp=1763730477~acl=/api/1/1/1/c/0/0/1c0cce4aa58053fc55daf236c25bd0b2.mp3*~data=user_id=0,application_id=42~hmac=d30851d596c1d983ae82a4b957231c5d0730c9612b8136c43e89d9be1d9c7fcb",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/95b0b861afc06a87e7d0c2f42ffb3f35/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Disco Inferno",
    artist: "50 Cent",
    id: 2256565,
    release_date: "2004-12-21",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/3/6/7/0/36712fdac07d70ae9912712cc944685f.mp3?hdnea=exp=1763730477~acl=/api/1/1/3/6/7/0/36712fdac07d70ae9912712cc944685f.mp3*~data=user_id=0,application_id=42~hmac=51edd4ae5d1887c53efe91a59e2b8f21b0ddbd45288b4574f6e9f75ad96a1cde",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/333b3620de536ae80acdf70331c9503b/250x250-000000-80-0-0.jpg",
    genre: "Rap/Hip Hop",
  },
  {
    title: "Don't Forget About Us",
    artist: "Mariah Carey",
    id: 2261617,
    release_date: "2006-02-06",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/d/c/d/0/dcd2cb5febab75f49cc49e254081ee8a.mp3?hdnea=exp=1763730477~acl=/api/1/1/d/c/d/0/dcd2cb5febab75f49cc49e254081ee8a.mp3*~data=user_id=0,application_id=42~hmac=c557cd3236e6bba5c4993f80514d288bb648eb2b0d296c9bbddae53dc0053a09",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/eee47533e27fc9aed74f3212ebe5fb8f/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: 'Slow Down (12" Version)',
    artist: "Bobby V.",
    id: 2261899,
    release_date: "2005-05-16",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/9/f/9/0/9f9d0622a126564721bd687506a8756d.mp3?hdnea=exp=1763730477~acl=/api/1/1/9/f/9/0/9f9d0622a126564721bd687506a8756d.mp3*~data=user_id=0,application_id=42~hmac=73dc2bbda9aedfc50baf611469c4adb7a176145a558b426833620535292f91b7",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/0d3cb2ca458fc783c73768f8d0d5f9f2/250x250-000000-80-0-0.jpg",
    genre: "R&B",
  },
  {
    title: "Dirty Little Secret",
    artist: "The All-American Rejects",
    id: 2263378,
    release_date: "2005-10-02",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/01f706ab51fd10a153367064839e3dc5/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Hey Mama",
    artist: "The Black Eyed Peas",
    id: 2264729,
    release_date: "2004-01-20",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/6efe94615f21a80c1ad670741e86e482/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Break It Down Again",
    artist: "Tears For Fears",
    id: 2266864,
    release_date: "1993-06-07",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/5/c/7/0/5c7417219d394431e10043864b74249b.mp3?hdnea=exp=1763730477~acl=/api/1/1/5/c/7/0/5c7417219d394431e10043864b74249b.mp3*~data=user_id=0,application_id=42~hmac=787a9977f2c0326d3757c4f16b2d2224a5cb3116f4052a4ef8168c57e4501362",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/798541a8024eed902da5cea050ef94ed/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Contagious",
    artist: "The Isley Brothers",
    id: 2276508,
    release_date: "2001-08-14",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/0/8/7/0/0872150efb5e252cd6cdf8319961a452.mp3?hdnea=exp=1763730477~acl=/api/1/1/0/8/7/0/0872150efb5e252cd6cdf8319961a452.mp3*~data=user_id=0,application_id=42~hmac=4e5c9b50b59ce3edb13b261c92c7028702307e02be51d4ccc0b6736149df970c",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/6192e617fe3a6e8163cbb89dff0208c4/250x250-000000-80-0-0.jpg",
    genre: "R&B",
  },
  {
    title: "You're All I Have",
    artist: "Snow Patrol",
    id: 2279320,
    release_date: "2006-10-30",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/83d4c843fc3e6deee6ad13790eb2e530/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "So What",
    artist: "P!nk",
    id: 2281133,
    release_date: "2008-10-27",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/f/3/4/0/f341837295d50312513f2c19c844692c.mp3?hdnea=exp=1763730477~acl=/api/1/1/f/3/4/0/f341837295d50312513f2c19c844692c.mp3*~data=user_id=0,application_id=42~hmac=9fd2635ce91f611ae5f33611ef91ab0e4afec64a2756e6b7045f07de39413146",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/d89c0c403b9dd94ce1ceb021d13cf662/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Everyday I Love You Less And Less",
    artist: "Kaiser Chiefs",
    id: 2281570,
    release_date: "2005-03-07",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/c/8/f/0/c8fcc991e269580c0e1b839124169ae9.mp3?hdnea=exp=1763730477~acl=/api/1/1/c/8/f/0/c8fcc991e269580c0e1b839124169ae9.mp3*~data=user_id=0,application_id=42~hmac=978a3e558ec16acd5230c444ac8bbaf82b1267f452649b19c7eee1626f42528c",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/4e858cde7d2f5ed7381186addd816a19/250x250-000000-80-0-0.jpg",
    genre: "Alternative",
  },
  {
    title: "I Predict A Riot",
    artist: "Kaiser Chiefs",
    id: 2281571,
    release_date: "2005-03-07",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/8/5/8/0/858390f8684b5e24404dc050eef62123.mp3?hdnea=exp=1763730477~acl=/api/1/1/8/5/8/0/858390f8684b5e24404dc050eef62123.mp3*~data=user_id=0,application_id=42~hmac=4ba8b18eecf551ac296338ca4bcea09eaf2134a06610a71a2e8f66f7540d6b2f",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/4e858cde7d2f5ed7381186addd816a19/250x250-000000-80-0-0.jpg",
    genre: "Alternative",
  },
  {
    title: "Teardrops On My Guitar",
    artist: "Taylor Swift",
    id: 2282486,
    release_date: "2008-10-04",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/3/6/5/0/36537850aef687326b2599a2fe4dcec7.mp3?hdnea=exp=1763730477~acl=/api/1/1/3/6/5/0/36537850aef687326b2599a2fe4dcec7.mp3*~data=user_id=0,application_id=42~hmac=ef732367bbc1616710f6e3a48f563892080059fa6e2e8d88638dbad9b5ea26d1",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/9c0e80bb3c16e1c987cf235929eb7757/250x250-000000-80-0-0.jpg",
    genre: "Country",
  },
  {
    title: "Our Song",
    artist: "Taylor Swift",
    id: 2282494,
    release_date: "2008-10-04",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/8/a/5/0/8a5b6efa3d6383c0d7da6d0be7b5bee6.mp3?hdnea=exp=1763730477~acl=/api/1/1/8/a/5/0/8a5b6efa3d6383c0d7da6d0be7b5bee6.mp3*~data=user_id=0,application_id=42~hmac=96c1b9160bb4e887455dc08ab11b3cba702ebbbbc79afa140798ae1c0dd76860",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/9c0e80bb3c16e1c987cf235929eb7757/250x250-000000-80-0-0.jpg",
    genre: "Country",
  },
  {
    title: "Kool Thing",
    artist: "Sonic Youth",
    id: 2288587,
    release_date: "2007-06-21",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/c/5/5/0/c551e0b1d76f973230b709d1b8492a4e.mp3?hdnea=exp=1763730477~acl=/api/1/1/c/5/5/0/c551e0b1d76f973230b709d1b8492a4e.mp3*~data=user_id=0,application_id=42~hmac=a94adfd4182c76751495949ed9c87dc6aa59a0bc1d4616253261ce2b00711062",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/7e9e4f3f059bab95e602b805cfcb43df/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "Learning To Fly",
    artist: "Tom Petty And The Heartbreakers",
    id: 2293281,
    release_date: "2007-07-05",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/e/9/9/0/e99f43b79651ca262997ac5fc3907e75.mp3?hdnea=exp=1763730477~acl=/api/1/1/e/9/9/0/e99f43b79651ca262997ac5fc3907e75.mp3*~data=user_id=0,application_id=42~hmac=ee7fe50b174118e6f5c29cfcb89ff21d87912608536726dbe49684529be59a94",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/9e60cb17ff666bd8a299fb71043c1cf2/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "Into The Great Wide Open",
    artist: "Tom Petty And The Heartbreakers",
    id: 2293285,
    release_date: "1991-07-02",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/1/d/6/0/1d6e6fb20887681d90c970175d0f931c.mp3?hdnea=exp=1763730477~acl=/api/1/1/1/d/6/0/1d6e6fb20887681d90c970175d0f931c.mp3*~data=user_id=0,application_id=42~hmac=1bf209cc0e363a2ed2b8f4ed8a6d00283c9af02ad03facea8fbc697eb0e2857b",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/9e60cb17ff666bd8a299fb71043c1cf2/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "Gotta Get Thru This (D'N'D Radio Edit)",
    artist: "Daniel Bedingfield",
    id: 2298587,
    release_date: "2003-04-14",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/9/9/d/0/99de2ea2cfbba948b203d7775a04458d.mp3?hdnea=exp=1763730477~acl=/api/1/1/9/9/d/0/99de2ea2cfbba948b203d7775a04458d.mp3*~data=user_id=0,application_id=42~hmac=8fe5e64d2dbe8ce48f447c056f37c0ee44b59433681952ab7b78f7eda1eb2dd6",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/10e111eb47dd8b80c8b2166fa4ac0872/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Gotta Tell You",
    artist: "Samantha Mumba",
    id: 2303104,
    release_date: "2001-09-06",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/4/0/b/0/40be5aafab583bbee0bdab833f2ffbeb.mp3?hdnea=exp=1763730477~acl=/api/1/1/4/0/b/0/40be5aafab583bbee0bdab833f2ffbeb.mp3*~data=user_id=0,application_id=42~hmac=432368a8951829713ece678a91baa8f02319af01e721c03691c2f7139008db9f",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/8f20fcec7a01e5f3e13f200d6b19cffa/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Vertigo",
    artist: "U2",
    id: 2315240,
    release_date: "2004-11-22",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/e/2/0/0/e207ea98f5b33e0614785875f9405fbd.mp3?hdnea=exp=1763730477~acl=/api/1/1/e/2/0/0/e207ea98f5b33e0614785875f9405fbd.mp3*~data=user_id=0,application_id=42~hmac=58798ac76c2c005e53d9a270c259d3017a36775ab2dc88ea0564e9b61c612251",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/74985254012fb1794c487fe3f5aa3840/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "Better Together",
    artist: "Jack Johnson",
    id: 2320086,
    release_date: "2005-03-01",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/2/c/5/0/2c5d2ca4d1a3341a589d0b95f0e329a2.mp3?hdnea=exp=1763730477~acl=/api/1/1/2/c/5/0/2c5d2ca4d1a3341a589d0b95f0e329a2.mp3*~data=user_id=0,application_id=42~hmac=5803681640ffd624705e7dc48d8f9879eb19e79d32e096c310198e5c55a2899a",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/6fc75cf6170ae0ed9c6a40810c67ba87/250x250-000000-80-0-0.jpg",
    genre: "Alternative",
  },
  {
    title: "Banana Pancakes",
    artist: "Jack Johnson",
    id: 2320088,
    release_date: "2005-03-01",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/b/9/5/0/b95ba63b09e16ba5ccc5b1cbe17f7f58.mp3?hdnea=exp=1763730477~acl=/api/1/1/b/9/5/0/b95ba63b09e16ba5ccc5b1cbe17f7f58.mp3*~data=user_id=0,application_id=42~hmac=a0657927162f85742e8af90a11317a05a4f8bc44f9302d9f56559d15b15c4a88",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/6fc75cf6170ae0ed9c6a40810c67ba87/250x250-000000-80-0-0.jpg",
    genre: "Alternative",
  },
  {
    title: "Dizzy",
    artist: "Vic Reeves",
    id: 2320340,
    release_date: "1994-09-26",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/6/5/d/0/65de64644c518b326e25adf6d0ddbdf1.mp3?hdnea=exp=1763730477~acl=/api/1/1/6/5/d/0/65de64644c518b326e25adf6d0ddbdf1.mp3*~data=user_id=0,application_id=42~hmac=4ab7f4a31fd8d710750c757272620ae5cff69bbf2d18bc0b7b629bd2f81fabf5",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/5a9493dd55b9e6cce90cac8bb4388e2d/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "Just Lose It",
    artist: "Eminem",
    id: 2330805,
    release_date: "2004-11-01",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/4/7/f/0/47f75219ea7ea5f608e832925b343fc8.mp3?hdnea=exp=1763730477~acl=/api/1/1/4/7/f/0/47f75219ea7ea5f608e832925b343fc8.mp3*~data=user_id=0,application_id=42~hmac=1b41f7fce1f438c37e42b9f5acd28e5edbaf4bb1988db27de51767c1cabf132c",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/ef99b64b2d0f806e667c132893274bc5/250x250-000000-80-0-0.jpg",
    genre: "Rap/Hip Hop",
  },
  {
    title: "Salt Shaker",
    artist: "Ying Yang Twins",
    id: 2374799,
    release_date: "2003-09-16",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/6/8/8/0/68869018ad7cfd229f6027da697b1f68.mp3?hdnea=exp=1763730477~acl=/api/1/1/6/8/8/0/68869018ad7cfd229f6027da697b1f68.mp3*~data=user_id=0,application_id=42~hmac=b2a56b94895dfe3ba25df5fe61a357f26821d15d8fe05de3819d233b8d958e09",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/1a5ece56c54045323442ef553dee930f/250x250-000000-80-0-0.jpg",
    genre: "Rap/Hip Hop",
  },
  {
    title: "Wait (The Whisper Song)",
    artist: "Ying Yang Twins",
    id: 2375108,
    release_date: "2005-06-28",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/5/f/9/0/5f9a0940a392e9f8590db8a007d0968d.mp3?hdnea=exp=1763730477~acl=/api/1/1/5/f/9/0/5f9a0940a392e9f8590db8a007d0968d.mp3*~data=user_id=0,application_id=42~hmac=bbce3abfa3e8c7ed40b702e769c566b050c712188394b4ebb8b02c4277c4cd46",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/5e30fadde8272534627e2ee6b3e60f89/250x250-000000-80-0-0.jpg",
    genre: "Rap/Hip Hop",
  },
  {
    title: "Touch The Sky",
    artist: "Kanye West",
    id: 2423416,
    release_date: "2005-08-29",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/6/1/0/0/610739ad15151deeb451fde2e0c6382e.mp3?hdnea=exp=1763730477~acl=/api/1/1/6/1/0/0/610739ad15151deeb451fde2e0c6382e.mp3*~data=user_id=0,application_id=42~hmac=0e143ec73f209eff0d7feadbf1bb682cde99c0389bf27c61dd3cac7fe5cfad1c",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/6a7aaa21c3b7802745448c33c4affbd1/250x250-000000-80-0-0.jpg",
    genre: "Rap/Hip Hop",
  },
  {
    title: "Switch",
    artist: "Will Smith",
    id: 2426647,
    release_date: "2005-03-28",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/b/5/8/0/b58e525a455801ca718a2ad424b8ffef.mp3?hdnea=exp=1763730477~acl=/api/1/1/b/5/8/0/b58e525a455801ca718a2ad424b8ffef.mp3*~data=user_id=0,application_id=42~hmac=375554e65645235bf121a2adfc68e805b058a4789623ac79a6170959d5e062ed",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/c8079db8d19ac62becbdea6a19e913c2/250x250-000000-80-0-0.jpg",
    genre: "R&B",
  },
  {
    title: "Lonely",
    artist: "Akon",
    id: 2426732,
    release_date: "2005-04-25",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/1/6/c/0/16c5dbd26b8d395eb56a53913790af9d.mp3?hdnea=exp=1763730477~acl=/api/1/1/1/6/c/0/16c5dbd26b8d395eb56a53913790af9d.mp3*~data=user_id=0,application_id=42~hmac=b8458c847893cc9c0f8b2d8155fcb553b98d6418f826a91141877e3b73672194",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/1f0c3940d55267dd837cfae7d95e4b3b/250x250-000000-80-0-0.jpg",
    genre: "R&B",
  },
  {
    title: "Hollaback Girl",
    artist: "Gwen Stefani",
    id: 2426753,
    release_date: "2005-10-24",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/1/1/8/0/11822f8e7067f0ddbdac05d3c50c0a02.mp3?hdnea=exp=1763730477~acl=/api/1/1/1/1/8/0/11822f8e7067f0ddbdac05d3c50c0a02.mp3*~data=user_id=0,application_id=42~hmac=ee12cd4c7d20591e5e29998ef250e5ed241c1b308c11bbb37c10e7fc411c6c01",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/c133e6ca154037e1de95fb82475d206b/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Love Generation",
    artist: "Bob Sinclar",
    id: 2430021,
    release_date: "2005-09-19",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/a86fe3205a3c926491d202ac8a02bc6c/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Promiscuous",
    artist: "Nelly Furtado",
    id: 2430338,
    release_date: "2006-06-12",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/b/1/f/0/b1fb4e9f4253bf143e2f277a59af9365.mp3?hdnea=exp=1763730477~acl=/api/1/1/b/1/f/0/b1fb4e9f4253bf143e2f277a59af9365.mp3*~data=user_id=0,application_id=42~hmac=7f9949bab0d6733795f01e5be778851430127eac05cf15b9c09b3b54579b9974",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/55a124e01e46d0aa494fc59afe53c639/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Let's Get It Started (Spike Mix)",
    artist: "The Black Eyed Peas",
    id: 2431781,
    release_date: "2010-04-13",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/8d7a615bf38ac9a97d55717bd0218bdc/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Move Along",
    artist: "The All-American Rejects",
    id: 2438123,
    release_date: "2005-09-19",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/6/3/4/0/634d34942c4b42ca4168f1f4979880fe.mp3?hdnea=exp=1763730756~acl=/api/1/1/6/3/4/0/634d34942c4b42ca4168f1f4979880fe.mp3*~data=user_id=0,application_id=42~hmac=5d9348f1e6d2223078d9b0cfe5e168334e774c09001eb060e61366e63acbc1a2",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/378b6a65c7b2bd76d826aa2d2fc6e751/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "It Ends Tonight",
    artist: "The All-American Rejects",
    id: 2438124,
    release_date: "2005-09-19",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/6/d/8/0/6d82f80f952267768323e809e147b6dd.mp3?hdnea=exp=1763730756~acl=/api/1/1/6/d/8/0/6d82f80f952267768323e809e147b6dd.mp3*~data=user_id=0,application_id=42~hmac=c636a30dd16a2af8c5c5644697b372059cd26c4b3978edb924f34868b51b8667",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/378b6a65c7b2bd76d826aa2d2fc6e751/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Don't Lie",
    artist: "The Black Eyed Peas",
    id: 2440661,
    release_date: "2006-06-29",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/35c6f881d5660898e5a3d135cf42e7af/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "My Humps",
    artist: "The Black Eyed Peas",
    id: 2440662,
    release_date: "2006-06-29",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/35c6f881d5660898e5a3d135cf42e7af/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Not In Love",
    artist: "Enrique Iglesias",
    id: 2447998,
    release_date: "2004-03-08",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/aa8db819d78059a1bad23258a7dd6e2d/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Found Out About You",
    artist: "Gin Blossoms",
    id: 2448350,
    release_date: "1992-08-31",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/a/1/0/0/a10d558d44480f8e2b12f177665240f6.mp3?hdnea=exp=1763730756~acl=/api/1/1/a/1/0/0/a10d558d44480f8e2b12f177665240f6.mp3*~data=user_id=0,application_id=42~hmac=4a84e06c8c3967e5e67c0f94352721f873168f86a9a87a37e98ab63361923883",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/21cbfcda72e8202b0e9ddb0e5fed8c3a/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "Sexbomb",
    artist: "Tom Jones",
    id: 2459527,
    release_date: "2003-02-09",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/0/8/5/0/0857a15a13547a06acb76c02d36666d5.mp3?hdnea=exp=1763730756~acl=/api/1/1/0/8/5/0/0857a15a13547a06acb76c02d36666d5.mp3*~data=user_id=0,application_id=42~hmac=f223a628a0d8bdf61fd657f03c08b1a6859a0e87c7b2a2fd27d073b2e0bc3358",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/be7a8eaf564cca20a4e76a72cb39aa74/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "One Of Us",
    artist: "Joan Osborne",
    id: 2463249,
    release_date: "1974-04-07",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/f/c/1/0/fc178a2a5322f25f199b9c3740b1a68a.mp3?hdnea=exp=1763730756~acl=/api/1/1/f/c/1/0/fc178a2a5322f25f199b9c3740b1a68a.mp3*~data=user_id=0,application_id=42~hmac=d679a431c84b71bae27266f12ba7ddb67b9d29057656c8eeff43b0fba7ad5e5d",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/6fcf1bc7b0971b8718c51a73b33ca5e1/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Tell Me",
    artist: "Groove Theory",
    id: 2464635,
    release_date: "1995-07-25",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/f/0/8/0/f080faa0626437fb574608904bdcc226.mp3?hdnea=exp=1763730756~acl=/api/1/1/f/0/8/0/f080faa0626437fb574608904bdcc226.mp3*~data=user_id=0,application_id=42~hmac=fbc2fd7319eefdcf0e2304dfa21eec9429acd2560bbb56c09dea8aa4798ceee2",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/2dc25a4d8c44e724a5226c5e6e37bdd6/250x250-000000-80-0-0.jpg",
    genre: "R&B",
  },
  {
    title: "Give Me One Reason",
    artist: "Tracy Chapman",
    id: 2477838,
    release_date: "1995-10-31",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/d/7/0/0/d70a6c1352c13d7eec4f6315f3ad3d00.mp3?hdnea=exp=1763730756~acl=/api/1/1/d/7/0/0/d70a6c1352c13d7eec4f6315f3ad3d00.mp3*~data=user_id=0,application_id=42~hmac=f761528c6935ff6e668ff9843b5684a6e774738fb26093b8822f09df9fcf0bda",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/f34b4d8e8b5795adde5ce91e78a830e7/250x250-000000-80-0-0.jpg",
    genre: "Folk",
  },
  {
    title: "Bleeding Love",
    artist: "Leona Lewis",
    id: 2484995,
    release_date: "2008-11-17",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/1/8/a/0/18a887763db6ea97622cf4ffa8a1c238.mp3?hdnea=exp=1763730756~acl=/api/1/1/1/8/a/0/18a887763db6ea97622cf4ffa8a1c238.mp3*~data=user_id=0,application_id=42~hmac=6a7de0d49d1333567be2d95bb4c198847f36882612bb98980818d53d592a1592",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/02d0ed56b2485b5f58fa63e6a3bbb73c/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "A Moment Like This",
    artist: "Leona Lewis",
    id: 2485008,
    release_date: "2008-11-17",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/6/b/0/0/6b0fe949bd3489c50e170433e5139a38.mp3?hdnea=exp=1763730756~acl=/api/1/1/6/b/0/0/6b0fe949bd3489c50e170433e5139a38.mp3*~data=user_id=0,application_id=42~hmac=64543714cc48a7b092b6c947ccb7c1f5c6ca54ecc173cce3ac2e0d4e7f903e87",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/02d0ed56b2485b5f58fa63e6a3bbb73c/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "If I Had No Loot",
    artist: "Tony! Toni! Toné!",
    id: 2487402,
    release_date: "1993-06-22",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/e/e/f/0/eef27646d4998a128fc3ab4048532f4d.mp3?hdnea=exp=1763730756~acl=/api/1/1/e/e/f/0/eef27646d4998a128fc3ab4048532f4d.mp3*~data=user_id=0,application_id=42~hmac=a4b5813358b73ccaea79f4c09ee26bb239f024b63fe420c192c2783fd676b791",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/e7091130dc59c2cd4fd1736115b54e21/250x250-000000-80-0-0.jpg",
    genre: "R&B",
  },
  {
    title: "Southside",
    artist: "Lloyd",
    id: 2496270,
    release_date: "2007-12-13",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/5/0/f/0/50f4a802b1e95ec9f9be9315c4eea9b9.mp3?hdnea=exp=1763730756~acl=/api/1/1/5/0/f/0/50f4a802b1e95ec9f9be9315c4eea9b9.mp3*~data=user_id=0,application_id=42~hmac=b181901933efdb3542ce0ba09c787d2f9c65bd99bcb4f730af38c0cf1d693ed5",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/11b7981cec8d0689d19888bf88813586/250x250-000000-80-0-0.jpg",
    genre: "R&B",
  },
  {
    title: "Signs",
    artist: "Snoop Dogg",
    id: 2498752,
    release_date: "2005-04-18",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/5/8/b/0/58b2c312793519bf215a5771fb60aa02.mp3?hdnea=exp=1763730756~acl=/api/1/1/5/8/b/0/58b2c312793519bf215a5771fb60aa02.mp3*~data=user_id=0,application_id=42~hmac=80718f4096bd4b6eb9f0d12a498851412d78cccff4062ce4c25bad6c9be668aa",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/67a836ad43bad1593baab1300e3f0cf4/250x250-000000-80-0-0.jpg",
    genre: "Rap/Hip Hop",
  },
  {
    title: "Suga Suga",
    artist: "Baby Bash",
    id: 2501296,
    release_date: "2004-03-15",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/15bb85fb5e546a2190dd41eb7eca3a00/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "What's Love Got To Do With It",
    artist: "Warren G",
    id: 2509581,
    release_date: "1997-02-24",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/d/6/c/0/d6c4649d087e4cdeead21a695b0c05dd.mp3?hdnea=exp=1763730756~acl=/api/1/1/d/6/c/0/d6c4649d087e4cdeead21a695b0c05dd.mp3*~data=user_id=0,application_id=42~hmac=853592b44ddce2004c2ae1bb6353cb06d18ddeeca220de60387f612b6bdd36f4",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/18d2887e3abf29f8d288efa4866a6259/250x250-000000-80-0-0.jpg",
    genre: "Rap/Hip Hop",
  },
  {
    title: "Be Like That",
    artist: "3 Doors Down",
    id: 2511228,
    release_date: "2000-05-26",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/6/4/2/0/642e501516bcf81dddc5b937393ca6c3.mp3?hdnea=exp=1763730756~acl=/api/1/1/6/4/2/0/642e501516bcf81dddc5b937393ca6c3.mp3*~data=user_id=0,application_id=42~hmac=a3e788304ca1da0435fc81f51a38aee1745fa330114160ecb485aff50afda44b",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/e075197e5985cd4269f829f1ea217cad/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "One (Album Version)",
    artist: "Mary J. Blige",
    id: 2514842,
    release_date: "2006-10-31",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/f/d/7/0/fd77f18bcf2bbc2bca9b291972376332.mp3?hdnea=exp=1763730756~acl=/api/1/1/f/d/7/0/fd77f18bcf2bbc2bca9b291972376332.mp3*~data=user_id=0,application_id=42~hmac=e209e2c8eab59d92652df0a8b0398fcdebd007234c0a0aee8ee5ac7ee5a715df",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/54f4de6cadc6e5687cdcfbeefa918a98/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "I Just Wanna Love U (Give It 2 Me)",
    artist: "JAY-Z",
    id: 2515569,
    release_date: "2000-10-30",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/9/2/0/0/9201b4f9e4a00c93c6613b8ef8d0ff1f.mp3?hdnea=exp=1763730756~acl=/api/1/1/9/2/0/0/9201b4f9e4a00c93c6613b8ef8d0ff1f.mp3*~data=user_id=0,application_id=42~hmac=b04cdea8ef34448382e7def5e351c68d73779f6ad478bf167cb248c69f6e4a91",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/4f410c346c29edb4e625a8a067fa6520/250x250-000000-80-0-0.jpg",
    genre: "Rap/Hip Hop",
  },
  {
    title: 'Touch Me (All Night Long) (7" Mix)',
    artist: "Cathy Dennis",
    id: 2520739,
    release_date: "2000-07-09",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/4/7/e/0/47e18045eff395bf28a53232d591025f.mp3?hdnea=exp=1763730756~acl=/api/1/1/4/7/e/0/47e18045eff395bf28a53232d591025f.mp3*~data=user_id=0,application_id=42~hmac=e3c7a6e223a7154aabf749a715871330423d3d440d9672e09def7c4323b5b4e5",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/f49a05e9c75f071e65a9704d8c077931/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Thunder In My Heart Again",
    artist: "Meck",
    id: 2522622,
    release_date: "2006-02-06",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/98d83fc99ab4539ed2cc80934545387b/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Control Myself",
    artist: "LL COOL J",
    id: 2527718,
    release_date: "2006-05-01",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/7f64f493fe5b921f9d80b77cd12837f4/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Fill My Little World",
    artist: "The Feeling",
    id: 2530287,
    release_date: "2006-06-05",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/6ac5203eb8ee0befdc1da0ed61f81786/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Lean Back",
    artist: "Terror Squad",
    id: 2530363,
    release_date: "2007-12-13",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/c/a/1/0/ca1837e1ac9adaed28bf756af923e581.mp3?hdnea=exp=1763730756~acl=/api/1/1/c/a/1/0/ca1837e1ac9adaed28bf756af923e581.mp3*~data=user_id=0,application_id=42~hmac=59ba16a1b2999fb41da8d0507d398042c05b09984d1570b48a80f7152db3d385",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/8ecc5d16327a2d0ca13312e3d0da043d/250x250-000000-80-0-0.jpg",
    genre: "Rap/Hip Hop",
  },
  {
    title: "Rock This Party (Everybody Dance Now)",
    artist: "Bob Sinclar",
    id: 2544065,
    release_date: "2006-05-29",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/0604fced8451b2cbc155e30d84f69cce/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Island In The Sun",
    artist: "Weezer",
    id: 2544628,
    release_date: "2001-04-24",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/4/c/0/0/4c04b1949ee94c585ecbf98aca43bcd4.mp3?hdnea=exp=1763730756~acl=/api/1/1/4/c/0/0/4c04b1949ee94c585ecbf98aca43bcd4.mp3*~data=user_id=0,application_id=42~hmac=7a0844ed9928b4918562c13d911e69487ddc8349ecf4531bfb79f93b59b1bace",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/a67a3dc5916907b9d5679c068d874451/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "Love Machine",
    artist: "Girls Aloud",
    id: 2547682,
    release_date: "2004-11-29",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/c/0/f/0/c0fb89461ce86d0a2f3180111fb107e5.mp3?hdnea=exp=1763730756~acl=/api/1/1/c/0/f/0/c0fb89461ce86d0a2f3180111fb107e5.mp3*~data=user_id=0,application_id=42~hmac=41369416f5de38391e9a171d4828e4fa020c724aecd8f0242b7b5abe68c46dd6",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/c0dc95d36b9064cb45007528f830596f/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Stay (Faraway, So Close!)",
    artist: "U2",
    id: 2547848,
    release_date: "1993-07-05",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/6/8/0/0/6803ee7dffc8e97ed4f5cfcfc481ed2d.mp3?hdnea=exp=1763730756~acl=/api/1/1/6/8/0/0/6803ee7dffc8e97ed4f5cfcfc481ed2d.mp3*~data=user_id=0,application_id=42~hmac=65ae6f50c012d1dbd39473eeea7c75521f6123bad2a3038a400f7588aa4bf0f8",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/69c4ded5f55e250d4ff22ca4e7d3ed2c/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "Big Pimpin'",
    artist: "JAY-Z",
    id: 2548838,
    release_date: "2007-11-22",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/2/3/1/0/2318d56c1cd1f5f35ae86ffbba235c2e.mp3?hdnea=exp=1763730756~acl=/api/1/1/2/3/1/0/2318d56c1cd1f5f35ae86ffbba235c2e.mp3*~data=user_id=0,application_id=42~hmac=aee856739393bac2ce2c8b910d51c85d76045229025bcacb8d317b23c3fa8099",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/0a349e3a00eb843fa5bda7970bb40a61/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "1 Thing",
    artist: "Amerie",
    id: 2553109,
    release_date: "2008-11-10",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/1/0/6/0/1061dff6448f59ef7a07abd8f70a3db2.mp3?hdnea=exp=1763730756~acl=/api/1/1/1/0/6/0/1061dff6448f59ef7a07abd8f70a3db2.mp3*~data=user_id=0,application_id=42~hmac=09c1ab6387b776c26413c9bf6e4894f21c947e8c86eaeb5bac4c30ac0e258623",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/7ce44c4450d9e2153706f0840d843e1c/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Starlight",
    artist: "The Supermen Lovers",
    id: 2575685,
    release_date: "2001-01-01",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/924c87a478de374538b1b5b554b20949/250x250-000000-80-0-0.jpg",
    genre: "Electro",
  },
  {
    title: "Snap Yo Fingers",
    artist: "Lil Jon",
    id: 2594366,
    release_date: "2006-05-02",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/3/c/c/0/3cc69ed4ccd23d31080fd71071ca1bb8.mp3?hdnea=exp=1763730756~acl=/api/1/1/3/c/c/0/3cc69ed4ccd23d31080fd71071ca1bb8.mp3*~data=user_id=0,application_id=42~hmac=14f202036698fb833caefa760ba6118ed4f7d79c3df5126010ca4c18c1c09054",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/a4bac5fc5fa841c2bb014223f8f8be4b/250x250-000000-80-0-0.jpg",
    genre: "Rap/Hip Hop",
  },
  {
    title: "Move Ya Body",
    artist: "Nina Sky",
    id: 2598368,
    release_date: "2004-06-29",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/5/8/7/0/587e87dfa5f776634bbc8cadc8299ec4.mp3?hdnea=exp=1763730756~acl=/api/1/1/5/8/7/0/587e87dfa5f776634bbc8cadc8299ec4.mp3*~data=user_id=0,application_id=42~hmac=001a1e2f06a8674118ddbd500dfd7bcfd61b36c9e865e2df3d2b3a32b4cd2e4d",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/7ec0475e6606608914f924204859a942/250x250-000000-80-0-0.jpg",
    genre: "R&B",
  },
  {
    title: "Missing You",
    artist: "Case",
    id: 2600215,
    release_date: "2008-05-01",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/a/5/9/0/a59cec67806c25531ee49f932d9ca0a8.mp3?hdnea=exp=1763730756~acl=/api/1/1/a/5/9/0/a59cec67806c25531ee49f932d9ca0a8.mp3*~data=user_id=0,application_id=42~hmac=8c7b7a500fd14ecfea329ba0933368a98406f0fc4b72febdf6bab2c08faa0429",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/cb9b5428a36553e00a959e1c1a557b3a/250x250-000000-80-0-0.jpg",
    genre: "R&B",
  },
  {
    title: "When You Tell Me That You Love Me",
    artist: "Diana Ross",
    id: 2602276,
    release_date: "2005-04-12",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/c/a/2/0/ca2f8459739ff34ed7e4b26bd6dfb1e8.mp3?hdnea=exp=1763730756~acl=/api/1/1/c/a/2/0/ca2f8459739ff34ed7e4b26bd6dfb1e8.mp3*~data=user_id=0,application_id=42~hmac=4351ef5d40ce1da51d11a0f33ee48d9139f118cd44d1230c2420254239b8099e",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/7db5a08be2abcf4c5a5d34960dd18a72/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "One Shining Moment",
    artist: "Diana Ross",
    id: 2602283,
    release_date: "2005-04-12",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/7/1/6/0/716434710455871c64f2e8ef4ce410e3.mp3?hdnea=exp=1763730756~acl=/api/1/1/7/1/6/0/716434710455871c64f2e8ef4ce410e3.mp3*~data=user_id=0,application_id=42~hmac=57f7701ece0e8ba4f5b13c55211ce63fd77ed76ea4e565b80efafb55f246ed63",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/7db5a08be2abcf4c5a5d34960dd18a72/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: 'Bailamos (From "Wild Wild West")',
    artist: "Enrique Iglesias",
    id: 2604907,
    release_date: "2008-11-27",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/c/8/9/0/c8996c4b061545d378450eb22f54dfcc.mp3?hdnea=exp=1763730756~acl=/api/1/1/c/8/9/0/c8996c4b061545d378450eb22f54dfcc.mp3*~data=user_id=0,application_id=42~hmac=b232b8f750787ead15f338d3c6da50dc6d57a6fd77637ad983d5456a9056eeaf",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/d5909ac32e17d6f7c12cc1443aa88428/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Do You Know? (The Ping Pong Song)",
    artist: "Enrique Iglesias",
    id: 2604913,
    release_date: "2008-11-27",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/0/a/b/0/0abea6370e675c4fe2df734e9a08db00.mp3?hdnea=exp=1763730756~acl=/api/1/1/0/a/b/0/0abea6370e675c4fe2df734e9a08db00.mp3*~data=user_id=0,application_id=42~hmac=2ac3bf9afe0bc2a4e29fcbf787d9c9007c56ff76c81ac9f11122a8c728d924f9",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/d5909ac32e17d6f7c12cc1443aa88428/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Hanging By A Moment",
    artist: "Lifehouse",
    id: 2628562,
    release_date: "2001-07-22",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/0/8/b/0/08b7df2529cfcb1ef983d0e760e7893c.mp3?hdnea=exp=1763730756~acl=/api/1/1/0/8/b/0/08b7df2529cfcb1ef983d0e760e7893c.mp3*~data=user_id=0,application_id=42~hmac=01fe6da108683aa71d28d7dce3733553555dfe4a6b977c85ff79660fa8c5e3b0",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/c36d47d43d558336e176e4f3f0cdb2f2/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Let It Rock",
    artist: "Kevin Rudolf",
    id: 2630775,
    release_date: "2008-11-24",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/c/f/5/0/cf5878bec0ca934904d9926d80a5cb8a.mp3?hdnea=exp=1763730756~acl=/api/1/1/c/f/5/0/cf5878bec0ca934904d9926d80a5cb8a.mp3*~data=user_id=0,application_id=42~hmac=a551c7b391c2806893d119350cb585269e6da29be49b8c914e43633b2176deee",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/8ceb2d932ee7f01e4d4cf7ce35889c09/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Heartless (Album Version)",
    artist: "Kanye West",
    id: 2651093,
    release_date: "2008-11-24",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/7db344db3c0d329b0967adb86b24662b/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "White Flag",
    artist: "Dido",
    id: 2654326,
    release_date: "2008-12-01",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/3/f/a/0/3fa8f0056bea8c1f9cc883db7c47df65.mp3?hdnea=exp=1763730757~acl=/api/1/1/3/f/a/0/3fa8f0056bea8c1f9cc883db7c47df65.mp3*~data=user_id=0,application_id=42~hmac=61f9e873e8247edfe455d930917131b76975fa0024823097f7b07196ed8f47bf",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/c3ffee70a615564ac1238c493774bd9c/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Romeo",
    artist: "Basement Jaxx",
    id: 2661874,
    release_date: "2001-06-25",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/5/f/c/0/5fcc1a92e17591522f48ebada28cb68b.mp3?hdnea=exp=1763730757~acl=/api/1/1/5/f/c/0/5fcc1a92e17591522f48ebada28cb68b.mp3*~data=user_id=0,application_id=42~hmac=58a1952c96bcd9061df2a09bc8f3ba8cdf9bada513b1675e11d1c286acb1deb2",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/c5c187cbbd0265d34859f9116a4cc46d/250x250-000000-80-0-0.jpg",
    genre: "Electro",
  },
  {
    title: "Drops of Jupiter",
    artist: "Train",
    id: 2672855,
    release_date: "2008-11-28",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/c/e/3/0/ce34f66e892e1363d637c6e3ae23e492.mp3?hdnea=exp=1763730757~acl=/api/1/1/c/e/3/0/ce34f66e892e1363d637c6e3ae23e492.mp3*~data=user_id=0,application_id=42~hmac=8fd520f780024762e00d04cd9b2caa4e515fd3271053613d1823a982e8b811a1",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/9a2400f7114621869e993e8adbc24cbe/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Gives You Hell",
    artist: "The All-American Rejects",
    id: 2676238,
    release_date: "2008-11-15",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/d952648bdde60f12eedbdbf8ad28a6d6/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Closer",
    artist: "Ne-Yo",
    id: 2718242,
    release_date: "2008-12-16",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/f41914cb2aedb8c3c5c40966e8b44196/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Miss Independent",
    artist: "Ne-Yo",
    id: 2718246,
    release_date: "2008-12-16",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/f41914cb2aedb8c3c5c40966e8b44196/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "JCB Song",
    artist: "Nizlopi",
    id: 2734152,
    release_date: "2006-05-19",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/37716b88883e667aef51e8cd3edcaba4/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Call On Me",
    artist: "Eric Prydz",
    id: 2739742,
    release_date: "2004-09-13",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/d14d82d9402c738c88660f893ee22af9/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Me & U",
    artist: "Cassie",
    id: 2793680,
    release_date: "2006-08-07",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/6/7/9/0/67924036afc7a12dfe7fff6f666e3aa2.mp3?hdnea=exp=1763730160~acl=/api/1/1/6/7/9/0/67924036afc7a12dfe7fff6f666e3aa2.mp3*~data=user_id=0,application_id=42~hmac=9de4f350544321646cba767c95ae3fba5ec8f7cb15d5da5a7cdf5132dd6f433d",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/191d3e7ca739887e4befabde40cf10cd/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "I Wish",
    artist: "Carl Thomas",
    id: 2794602,
    release_date: "2004-03-09",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/0/e/c/0/0ec11b09740b0d6e38d2f91178641abb.mp3?hdnea=exp=1763730160~acl=/api/1/1/0/e/c/0/0ec11b09740b0d6e38d2f91178641abb.mp3*~data=user_id=0,application_id=42~hmac=c5120d891ef46014d3927df841248ae49883da666706f4ee6ef71f03d4cfad86",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/755dc7da07ba60a8c879963858150f84/250x250-000000-80-0-0.jpg",
    genre: "R&B",
  },
  {
    title: "Hot Boyz",
    artist: "Missy Elliott",
    id: 2803679,
    release_date: "1998-03-31",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/2/1/8/0/2184ee5545214356f23589be34311995.mp3?hdnea=exp=1763730160~acl=/api/1/1/2/1/8/0/2184ee5545214356f23589be34311995.mp3*~data=user_id=0,application_id=42~hmac=99210ea370af2014fda754dc536f393577d7dcb61e19c07da4c5a3d4943e9c9d",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/0624cda602ebdb6f705b4364014ee223/250x250-000000-80-0-0.jpg",
    genre: "Rap/Hip Hop",
  },
  {
    title: "You Found Me",
    artist: "The Fray",
    id: 2889763,
    release_date: "2009-02-02",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/6/c/1/0/6c1e9ddf666624a838f984960478ec67.mp3?hdnea=exp=1763730160~acl=/api/1/1/6/c/1/0/6c1e9ddf666624a838f984960478ec67.mp3*~data=user_id=0,application_id=42~hmac=4d3db169b685a5c65c86f2f615dc0789ba1c9aae0d06eb4e71c45fab1b70b044",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/357c6766a490652760028cd66c53442b/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "Takin' Back My Love",
    artist: "Enrique Iglesias",
    id: 2917317,
    release_date: "2009-03-09",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/6/5/f/0/65f59ff946980eaf63233c5ebe308f9c.mp3?hdnea=exp=1763730160~acl=/api/1/1/6/5/f/0/65f59ff946980eaf63233c5ebe308f9c.mp3*~data=user_id=0,application_id=42~hmac=39866f0ce44947d454aa836e1de818d113c20815982fdb8af404da4fad58710e",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/802864e885dbac600025b87e23398c83/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Love Sex Magic (feat. Justin Timberlake)",
    artist: "Ciara",
    id: 2924891,
    release_date: "2009-03-12",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/1/6/6/0/1662437ac86fcb4543e90c55be1b5799.mp3?hdnea=exp=1763730160~acl=/api/1/1/1/6/6/0/1662437ac86fcb4543e90c55be1b5799.mp3*~data=user_id=0,application_id=42~hmac=770e5f4b0b2373fe1d8583ea2efae57c12ed90f9c97a21512d2af39bca242158",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/14920dc26ced9a181a51b05b7ab26958/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Faded Pictures",
    artist: "Case",
    id: 2925070,
    release_date: "2009-03-10",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/1/9/6/0/19682580fb424b6655992c8940e3d1f9.mp3?hdnea=exp=1763730160~acl=/api/1/1/1/9/6/0/19682580fb424b6655992c8940e3d1f9.mp3*~data=user_id=0,application_id=42~hmac=de884cd03a4537852e00a4a2e22b149ab904c703a120c47f5f9aab975df187ab",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/4a4d90c6fb4cee22357ea9a4cb5939f2/250x250-000000-80-0-0.jpg",
    genre: "Rap/Hip Hop",
  },
  {
    title: "Sugar (feat. Wynter)",
    artist: "Flo Rida",
    id: 2943201,
    release_date: "2009-03-17",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/e/6/3/0/e633c7cc3f8e0f8ab42e413cee70e266.mp3?hdnea=exp=1763730160~acl=/api/1/1/e/6/3/0/e633c7cc3f8e0f8ab42e413cee70e266.mp3*~data=user_id=0,application_id=42~hmac=409737e46f406def883ad31bdc54cecd31ddd9fce72c233698bd486e00f64192",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/71ba8675d023e7f3d1c2d042c81ec133/250x250-000000-80-0-0.jpg",
    genre: "Rap/Hip Hop",
  },
  {
    title: "Kiss Me Thru The Phone",
    artist: "Soulja Boy Tell'em",
    id: 2949679,
    release_date: "2009-03-16",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/7ad0ff036688602bd4d32e5a798139ab/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Pon de Replay",
    artist: "Rihanna",
    id: 2953166,
    release_date: "2005-08-12",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/9/f/6/0/9f6c81a7a0222d11fc33ad92205141a1.mp3?hdnea=exp=1763730160~acl=/api/1/1/9/f/6/0/9f6c81a7a0222d11fc33ad92205141a1.mp3*~data=user_id=0,application_id=42~hmac=db89f991bf018c559ca4f94f43f43b69ef093de633d744c050e4a3ced2830305",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/7324007a556009d008075eeb32157c16/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Party Up",
    artist: "DMX",
    id: 2954802,
    release_date: "2009-03-24",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/b/0/d/0/b0d4b796beade1ff79e86e092a7396f8.mp3?hdnea=exp=1763730160~acl=/api/1/1/b/0/d/0/b0d4b796beade1ff79e86e092a7396f8.mp3*~data=user_id=0,application_id=42~hmac=c78f7f8d62275dc898b87a009ef9db44d74e0474db21034f1f8754625a89fc4a",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/5fc26eac306c4f5d499c33a28a4bbbae/250x250-000000-80-0-0.jpg",
    genre: "Rap/Hip Hop",
  },
  {
    title: "Get Up (Before The Night Is Over)",
    artist: "Technotronic",
    id: 2961499,
    release_date: "1989-11-26",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/0/a/0/0/0a0923d238c746ac03ec46fdb531d9a2.mp3?hdnea=exp=1763730160~acl=/api/1/1/0/a/0/0/0a0923d238c746ac03ec46fdb531d9a2.mp3*~data=user_id=0,application_id=42~hmac=49e63768d8aa7078ee49da3dfff7da6dd896889f4b2992b24eff87555ea11480",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/8ddb94a0ba17254188a54d18b6173f7f/250x250-000000-80-0-0.jpg",
    genre: "Dance",
  },
  {
    title: "Livin' It Up",
    artist: "Ja Rule",
    id: 2962733,
    release_date: "2001-10-03",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/bf24cf88a9e67e7e48b9da49965a5134/250x250-000000-80-0-0.jpg",
    genre: "R&B",
  },
  {
    title: "21 Guns",
    artist: "Green Day",
    id: 3087241,
    release_date: "2009-05-15",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/f/7/7/0/f77ca4f6073ee619d0b21d59af5a876a.mp3?hdnea=exp=1763730160~acl=/api/1/1/f/7/7/0/f77ca4f6073ee619d0b21d59af5a876a.mp3*~data=user_id=0,application_id=42~hmac=09e741883b36e1d6d65ed198603d92ceac0dd02fc6b9ac378bb65144961f3c48",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/ebd6fc49c3c87cbd5441424f151c04f2/250x250-000000-80-0-0.jpg",
    genre: "Alternative",
  },
  {
    title: "Keep Coming Back",
    artist: "Richard Marx",
    id: 3087496,
    release_date: "1997-11-04",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/1/6/9/0/1697c1951c7d729718fbfefc2d8c0d3d.mp3?hdnea=exp=1763730160~acl=/api/1/1/1/6/9/0/1697c1951c7d729718fbfefc2d8c0d3d.mp3*~data=user_id=0,application_id=42~hmac=86105f7868c28c3c0c4e406c7b7772137e6d007bd6a110a9eff5c59ae68b4214",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/b2f1669d644dcab1cf79800aaea72c65/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "What Took You So Long?",
    artist: "Emma Bunton",
    id: 3088626,
    release_date: "2003-03-01",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/8/9/7/0/897d65b51406dc4f114f029b2829d3b7.mp3?hdnea=exp=1763730160~acl=/api/1/1/8/9/7/0/897d65b51406dc4f114f029b2829d3b7.mp3*~data=user_id=0,application_id=42~hmac=99223f85aea45c68eaf22173b176c83ff57a2118897fe19687ed495944ef9d10",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/1e441a14683530ea4af81339d9062edb/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "She Wants To Move",
    artist: "N.E.R.D.",
    id: 3090719,
    release_date: "2004-03-23",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/1/6/2/0/162e57e29e69fd848ef1d819078565b3.mp3?hdnea=exp=1763730160~acl=/api/1/1/1/6/2/0/162e57e29e69fd848ef1d819078565b3.mp3*~data=user_id=0,application_id=42~hmac=c302d0ad6cdec0260a1ffca572e9e5597c4e90ed04078122becc85dd633437d1",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/c759f1f1a6aa8dbccdcb7ce05bb7d1a7/250x250-000000-80-0-0.jpg",
    genre: "Rap/Hip Hop",
  },
  {
    title: "Have You Seen Her",
    artist: "MC Hammer",
    id: 3090794,
    release_date: "1990-02-12",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/5/1/e/0/51e35a3b38e80c137780579d45d6b6b4.mp3?hdnea=exp=1763730160~acl=/api/1/1/5/1/e/0/51e35a3b38e80c137780579d45d6b6b4.mp3*~data=user_id=0,application_id=42~hmac=cf9debfaf218aaed80153dffa7f6428330291722d154e0d2df2ad0f38ab9f16f",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/3558d89040fc95f8978c67b09aa2d16b/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Hold On",
    artist: "Wilson Phillips",
    id: 3090950,
    release_date: "1992-03-24",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/7/2/c/0/72c3c8886048205e28616cac7bcda445.mp3?hdnea=exp=1763730160~acl=/api/1/1/7/2/c/0/72c3c8886048205e28616cac7bcda445.mp3*~data=user_id=0,application_id=42~hmac=9b8041e4ff4b2378b5e0ea3c2c6dcc8c75f400997b44b4f565935a803c294786",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/1ec253e4915193b4b11185cea4afd4ca/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Release Me",
    artist: "Wilson Phillips",
    id: 3090951,
    release_date: "1990-03-24",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/f/5/e/0/f5e9d237094546c2c8521e17f132c375.mp3?hdnea=exp=1763730160~acl=/api/1/1/f/5/e/0/f5e9d237094546c2c8521e17f132c375.mp3*~data=user_id=0,application_id=42~hmac=fba3f33b2b86a1f3218e57b8bd1aef6dde926c4cb0f3621e87273d12993ac401",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/1ec253e4915193b4b11185cea4afd4ca/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Impulsive",
    artist: "Wilson Phillips",
    id: 3090952,
    release_date: "1990-03-24",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/c/c/5/0/cc5faddea9662aa8001f8885c0d7567a.mp3?hdnea=exp=1763730160~acl=/api/1/1/c/c/5/0/cc5faddea9662aa8001f8885c0d7567a.mp3*~data=user_id=0,application_id=42~hmac=bd8e5cfacf319897fc2b17d0f8beac69d9243be02b305a673025ff8fd18b8c79",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/1ec253e4915193b4b11185cea4afd4ca/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "You're In Love",
    artist: "Wilson Phillips",
    id: 3090954,
    release_date: "1990-03-24",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/2/f/6/0/2f625dee9cc3b6e13d3cea6a15f195c0.mp3?hdnea=exp=1763730160~acl=/api/1/1/2/f/6/0/2f625dee9cc3b6e13d3cea6a15f195c0.mp3*~data=user_id=0,application_id=42~hmac=2e81a4c1e98b23c4858e490795187e356cfadaac42c3a120a5d4e533c4300509",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/1ec253e4915193b4b11185cea4afd4ca/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Can't Get You out of My Head",
    artist: "Kylie Minogue",
    id: 3098100,
    release_date: "2001-10-01",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/a/9/4/0/a945ad6f37567a8b1500c4bf7355fc9b.mp3?hdnea=exp=1763730160~acl=/api/1/1/a/9/4/0/a945ad6f37567a8b1500c4bf7355fc9b.mp3*~data=user_id=0,application_id=42~hmac=dcea94fbb60de5e7bd681d85cf0093c1daaa0453b7f42a67d893fa071dabf866",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/834a7fd1964efa083b6e5bf82b49f406/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "In Your Eyes",
    artist: "Kylie Minogue",
    id: 3098105,
    release_date: "2001-02-19",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/5/7/7/0/5778f221b2810b05cb719aea9b4befb8.mp3?hdnea=exp=1763730160~acl=/api/1/1/5/7/7/0/5778f221b2810b05cb719aea9b4befb8.mp3*~data=user_id=0,application_id=42~hmac=592074aa96a9b0fd94d6e47b3cb6b2ba39db5d5861db7ca54018b7c828caed21",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/834a7fd1964efa083b6e5bf82b49f406/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "She's The One",
    artist: "Robbie Williams",
    id: 3099009,
    release_date: "2004-04-01",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/d/e/b/0/deb3a26eea73fa1d25dccfe5b6d6676a.mp3?hdnea=exp=1763730160~acl=/api/1/1/d/e/b/0/deb3a26eea73fa1d25dccfe5b6d6676a.mp3*~data=user_id=0,application_id=42~hmac=966f9b7a6badb231e2c7ff923ee180181c7d53dd0cbf821e6399723bd606441b",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/5d97332e17a89414a877cce274d86d95/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "Clint Eastwood",
    artist: "Gorillaz",
    id: 3100444,
    release_date: "2001-03-26",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/d/2/e/0/d2eac3654c6d1e9fed14cb6f22c352ac.mp3?hdnea=exp=1763730160~acl=/api/1/1/d/2/e/0/d2eac3654c6d1e9fed14cb6f22c352ac.mp3*~data=user_id=0,application_id=42~hmac=f993d71d2308cd23c1d5a01f80fce83d322dade284fac08e4705db5c0f62d5c5",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/f4d581f4b86c869547704d7db9aa2c43/250x250-000000-80-0-0.jpg",
    genre: "Rap/Hip Hop",
  },
  {
    title: "Rock DJ",
    artist: "Robbie Williams",
    id: 3102419,
    release_date: "2003-03-01",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/c/9/a/0/c9a822e24ebde082cf91a7fe7ca966a2.mp3?hdnea=exp=1763730160~acl=/api/1/1/c/9/a/0/c9a822e24ebde082cf91a7fe7ca966a2.mp3*~data=user_id=0,application_id=42~hmac=ce92e15d1a2a1ad95a9fac1aec6a7626a77e30ae4f005da4214b58bcd3a4732a",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/d260fa442f925e1eb1c95bb29941f636/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "Fix You",
    artist: "Coldplay",
    id: 3106505,
    release_date: "2005-06-07",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/a/8/1/0/a81b6f3b4d941ab1e0beae57cba05960.mp3?hdnea=exp=1763730160~acl=/api/1/1/a/8/1/0/a81b6f3b4d941ab1e0beae57cba05960.mp3*~data=user_id=0,application_id=42~hmac=eb8c3e02e37b897208395cb468f154ccb9f37b056aab812209d77432f26b25d7",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/8a1a3e7c5e46b5f763328d95431ac19a/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "Speed of Sound",
    artist: "Coldplay",
    id: 3106508,
    release_date: "2005-06-07",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/c/2/7/0/c27210d2625fc4a46b39b9e3b679ef53.mp3?hdnea=exp=1763730160~acl=/api/1/1/c/2/7/0/c27210d2625fc4a46b39b9e3b679ef53.mp3*~data=user_id=0,application_id=42~hmac=da319681797744d50983df110a337be07c47212951b0177763a7b731fa3a3220",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/8a1a3e7c5e46b5f763328d95431ac19a/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "Are You Gonna Go My Way",
    artist: "Lenny Kravitz",
    id: 3107395,
    release_date: "1993-03-09",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/4/2/5/0/425773b389d492d75d1bf57641b23f4d.mp3?hdnea=exp=1763730160~acl=/api/1/1/4/2/5/0/425773b389d492d75d1bf57641b23f4d.mp3*~data=user_id=0,application_id=42~hmac=4f488a9bf612621dd7005f2baa0e58759c3bf98f4aa62cb016f26ea2cba5a6a5",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/92fc3b56541e6af90105452f8e3cf510/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "Right Here Right Now",
    artist: "Jesus Jones",
    id: 3109370,
    release_date: "1991-01-28",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/7/d/4/0/7d4972ed7ef6b60f681798f76366b82e.mp3?hdnea=exp=1763730160~acl=/api/1/1/7/d/4/0/7d4972ed7ef6b60f681798f76366b82e.mp3*~data=user_id=0,application_id=42~hmac=9f56c29aded5812680091f61bccefede02cc52c400837d9425ccf432460a8220",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/2e14053e309d4fae675df0daca915998/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "One Call Away",
    artist: "Chingy",
    id: 3112419,
    release_date: "2006-09-26",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/0/e/6/0/0e68763ec2b9eda8212b36996c698408.mp3?hdnea=exp=1763730160~acl=/api/1/1/0/e/6/0/0e68763ec2b9eda8212b36996c698408.mp3*~data=user_id=0,application_id=42~hmac=a6c1e8bc00827a54ccc6aa7a6a0cdb68690d9ba24c3b8e8e98ba8d80965ca45b",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/535071fc15641e578a69dce6fc3d1670/250x250-000000-80-0-0.jpg",
    genre: "Rap/Hip Hop",
  },
  {
    title: "Bossy",
    artist: "Kelis",
    id: 3115987,
    release_date: "2006-09-11",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/9d2b2b606cace23ec0aef9c66a8bcc2c/250x250-000000-80-0-0.jpg",
    genre: "Rap/Hip Hop",
  },
  {
    title: "She Moves In Her Own Way",
    artist: "The Kooks",
    id: 3119029,
    release_date: "2006-01-23",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/8/b/d/0/8bd570da7fedefa835a62b945664e34c.mp3?hdnea=exp=1763730160~acl=/api/1/1/8/b/d/0/8bd570da7fedefa835a62b945664e34c.mp3*~data=user_id=0,application_id=42~hmac=dbd777bfa59d1643cdcc41c7de05f8f18edb1c2e1f5fb5583c5537d0a1bf34e5",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/ff7f8634c319827bd8350f6d4305a80d/250x250-000000-80-0-0.jpg",
    genre: "Alternative",
  },
  {
    title: "Face Down",
    artist: "The Red Jumpsuit Apparatus",
    id: 3119156,
    release_date: "2006-07-18",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/a/4/8/0/a48e51f57a6a3eff062d350a7167556d.mp3?hdnea=exp=1763730160~acl=/api/1/1/a/4/8/0/a48e51f57a6a3eff062d350a7167556d.mp3*~data=user_id=0,application_id=42~hmac=dc9bf964729631febfb4cdcf002e2d7cc774fb564edf26e264b76f4d1cbde196",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/d468592f2a5f4f920c337fc41bf1b04e/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "Beautiful Soul",
    artist: "Jesse McCartney",
    id: 3119252,
    release_date: "2006-02-06",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/0b91e17deb08c4f54098ec8f791b98c8/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Put Your Records On",
    artist: "Corinne Bailey Rae",
    id: 3119484,
    release_date: "2006-02-27",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/9/8/b/0/98b6d3ab6286e690087c19c5d6354c22.mp3?hdnea=exp=1763730160~acl=/api/1/1/9/8/b/0/98b6d3ab6286e690087c19c5d6354c22.mp3*~data=user_id=0,application_id=42~hmac=a02d6f6ea231879b2543dc5a51695c173b58808610cb8a169c7c061607967401",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/395904b0070e13c1edd27a4bd45b7f4f/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Tripping",
    artist: "Robbie Williams",
    id: 3119900,
    release_date: "2002-01-01",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/d/c/2/0/dc2e16f579709131ced6d784689df858.mp3?hdnea=exp=1763730160~acl=/api/1/1/d/c/2/0/dc2e16f579709131ced6d784689df858.mp3*~data=user_id=0,application_id=42~hmac=7667031cfda16f6f0dd0110c49375bf3d648bad22a8a4355c310236eb5a2bb89",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/e6849e357cb889d6ce800040570ebafc/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Black Horse And The Cherry Tree (Radio Version)",
    artist: "KT Tunstall",
    id: 3120612,
    release_date: "2006-02-07",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/1/7/4/0/174e82d80a4145d7641c0ec02f2d457c.mp3?hdnea=exp=1763730160~acl=/api/1/1/1/7/4/0/174e82d80a4145d7641c0ec02f2d457c.mp3*~data=user_id=0,application_id=42~hmac=5b2e269ff6b73662fda9f89e447b1b9c51aa266588a649c849a3ddd21984ec67",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/b00b9ee9d0543257b70abf6b28aee606/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "Suddenly I See",
    artist: "KT Tunstall",
    id: 3120617,
    release_date: "2006-02-07",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/d/8/0/0/d80f3db2915d786e8ea6fa4046125c44.mp3?hdnea=exp=1763730160~acl=/api/1/1/d/8/0/0/d80f3db2915d786e8ea6fa4046125c44.mp3*~data=user_id=0,application_id=42~hmac=ffc7980c611969c1cf672a3e86a9a9ae3d702653eee351806c5554613ea768da",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/b00b9ee9d0543257b70abf6b28aee606/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "Fall At Your Feet",
    artist: "Crowded House",
    id: 3123900,
    release_date: "1991-06-24",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/0/9/d/0/09d58e4ff92fd0585bdbf76e0c59bfeb.mp3?hdnea=exp=1763729085~acl=/api/1/1/0/9/d/0/09d58e4ff92fd0585bdbf76e0c59bfeb.mp3*~data=user_id=0,application_id=42~hmac=436284ceaff60628863e42cf0e4b6833a5872ee53b6f1f375aee964ec52e91b4",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/02ff8eb7243d0f51dc087135012bdb02/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "Close To You",
    artist: "Maxi Priest",
    id: 3125893,
    release_date: "1992-07-11",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/1/d/2/0/1d20862024cfa0064c0a022360ee9fd6.mp3?hdnea=exp=1763729085~acl=/api/1/1/1/d/2/0/1d20862024cfa0064c0a022360ee9fd6.mp3*~data=user_id=0,application_id=42~hmac=6553d25fa92347fbd214a3984bc0b644ed2b9bf949c2322523bea530976bf6cb",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/7416486e591fa1c95a7f70780b8abbc5/250x250-000000-80-0-0.jpg",
    genre: "Reggae",
  },
  {
    title: "Candy",
    artist: "Iggy Pop",
    id: 3125907,
    release_date: "1992-06-29",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/a/1/1/0/a11623402bb2dc80de564bb005596dfd.mp3?hdnea=exp=1763729085~acl=/api/1/1/a/1/1/0/a11623402bb2dc80de564bb005596dfd.mp3*~data=user_id=0,application_id=42~hmac=ef3847281a5054b950f528c64b6b233f69ca2743e138b91df206ba8baa59437b",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/4c6466020ab675f2a36586a20b500f0b/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "Still Got The Blues",
    artist: "Gary Moore",
    id: 3125932,
    release_date: "1992-07-11",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/3/e/4/0/3e46e306a9c84d7b7f2389394ecbe63e.mp3?hdnea=exp=1763729085~acl=/api/1/1/3/e/4/0/3e46e306a9c84d7b7f2389394ecbe63e.mp3*~data=user_id=0,application_id=42~hmac=edb47144f0687286d1c7487e4e6accbb07f69e4d1456c7f4777d8d91ced69949",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/e5ca9ba4e56c7e8a69791f6b194399d3/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "Galvanize",
    artist: "The Chemical Brothers",
    id: 3130293,
    release_date: "2005-01-24",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/4/f/9/0/4f92de31480e970dc5f3b17513635cc3.mp3?hdnea=exp=1763729085~acl=/api/1/1/4/f/9/0/4f92de31480e970dc5f3b17513635cc3.mp3*~data=user_id=0,application_id=42~hmac=17d68aec89ee02e56003329e5b68e490ceff7ac32f217d220d11e3841d546dd1",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/51d7e6bb289a89b531aaa7d047baa6ea/250x250-000000-80-0-0.jpg",
    genre: "Electro",
  },
  {
    title: "Santa Monica",
    artist: "Everclear",
    id: 3131304,
    release_date: "1995-05-11",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/7/5/d/0/75d74b77e610aff4185be1b48bcd0cb7.mp3?hdnea=exp=1763729085~acl=/api/1/1/7/5/d/0/75d74b77e610aff4185be1b48bcd0cb7.mp3*~data=user_id=0,application_id=42~hmac=2ec97c043e8961975e4297df888b5e39acf3d1de50f571b2e9187852fffe4564",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/527fbe3057927e6ce78e288b6f593124/250x250-000000-80-0-0.jpg",
    genre: "Alternative",
  },
  {
    title: "Naked and Sacred",
    artist: "Chynna Phillips",
    id: 3132131,
    release_date: "1995-10-26",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/3/e/0/0/3e0a836eda8ef8b5ee0e837c381e03c9.mp3?hdnea=exp=1763726044~acl=/api/1/1/3/e/0/0/3e0a836eda8ef8b5ee0e837c381e03c9.mp3*~data=user_id=0,application_id=42~hmac=84d9e489e88f2512b10834ccbe2ddc7d94e135be74294c9330e9cb7497189024",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/589402eca75e424501f9c5b0e54fc0b8/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "I Live For You",
    artist: "Chynna Phillips",
    id: 3132134,
    release_date: "1995-10-26",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/f/8/c/0/f8c88a464fe613a99e6af45aa0e7dd84.mp3?hdnea=exp=1763729085~acl=/api/1/1/f/8/c/0/f8c88a464fe613a99e6af45aa0e7dd84.mp3*~data=user_id=0,application_id=42~hmac=bc2ae2c99e2422cc7cfaebbb7a4a1d2b1be6256a1cf8ad0c5767a1ca90dcafd0",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/589402eca75e424501f9c5b0e54fc0b8/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Hey Boy Hey Girl",
    artist: "The Chemical Brothers",
    id: 3135034,
    release_date: "1999-06-22",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/2/d/b/0/2db6ff657ff4770e022909cdff656fd7.mp3?hdnea=exp=1763726044~acl=/api/1/1/2/d/b/0/2db6ff657ff4770e022909cdff656fd7.mp3*~data=user_id=0,application_id=42~hmac=3819813f0a19f0fdf657bf9f9074be23ff44e75e1148b8c65944c144b7f9cd4b",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/269d141e05d38d3bad414f16b8f047fe/250x250-000000-80-0-0.jpg",
    genre: "Dance",
  },
  {
    title: "Goodbye",
    artist: "Spice Girls",
    id: 3135706,
    release_date: "2000-11-06",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/f/9/a/0/f9a9dc22c9d8dbec46626d7e3f84c7c2.mp3?hdnea=exp=1763726044~acl=/api/1/1/f/9/a/0/f9a9dc22c9d8dbec46626d7e3f84c7c2.mp3*~data=user_id=0,application_id=42~hmac=3c4110001d9aa3660c9c9ed1aecf480b33e8678f7e8a726df31035fb5a3dcef5",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/b0cbf02d23485527c29fc1039e4da138/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "In Too Deep",
    artist: "Belinda Carlisle",
    id: 3136272,
    release_date: "1996-08-09",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/3/f/e/0/3fec619462b5ab8b58c738d6d9984a9d.mp3?hdnea=exp=1763726044~acl=/api/1/1/3/f/e/0/3fec619462b5ab8b58c738d6d9984a9d.mp3*~data=user_id=0,application_id=42~hmac=15ac0a28410ccec9306e46c802ffe2d038537ffb2dcf4985e2dba09cf312e09a",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/4ff616135daf7d10cfc4a587b99eff83/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "Lola's Theme",
    artist: "The Shapeshifters",
    id: 3137332,
    release_date: "2004-07-12",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/1ac68184e5cbae22810453b615232867/250x250-000000-80-0-0.jpg",
    genre: "Dance",
  },
  {
    title: "Let There Be Love",
    artist: "Simple Minds",
    id: 3139497,
    release_date: "1991-03-03",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/4/4/1/0/441f785045b72adc450b312f3bec1231.mp3?hdnea=exp=1763726044~acl=/api/1/1/4/4/1/0/441f785045b72adc450b312f3bec1231.mp3*~data=user_id=0,application_id=42~hmac=2401379aa12cc72f4dbc2b5907f4442b185588fa18677d8f373bd1bdcebb5927",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/30093e3d2496f605a0dca32e80070f81/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "Bed",
    artist: "J Holiday",
    id: 3146991,
    release_date: "2008-02-05",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/7/8/1/0/781d38af7f91d29465ed913808c20480.mp3?hdnea=exp=1763726044~acl=/api/1/1/7/8/1/0/781d38af7f91d29465ed913808c20480.mp3*~data=user_id=0,application_id=42~hmac=0df6e5993c7e8f40e58af6df7146bfab3a9b3be5e0206250e54deaf3f50d62c3",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/d3d13ff20642f1a7ea592beab94e546e/250x250-000000-80-0-0.jpg",
    genre: "R&B",
  },
  {
    title: "Always On The Run",
    artist: "Lenny Kravitz",
    id: 3151230,
    release_date: "1992-07-11",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/b/1/9/0/b195646ea1365aca8189832e3d6d4fd4.mp3?hdnea=exp=1763726044~acl=/api/1/1/b/1/9/0/b195646ea1365aca8189832e3d6d4fd4.mp3*~data=user_id=0,application_id=42~hmac=24d8b2072c1bafb47862738778fb1826fcfe459a08f804ceba6aafd0421adbf6",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/6a40fdebd05516980c02b6980ef12c2c/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "Stand By My Woman",
    artist: "Lenny Kravitz",
    id: 3151231,
    release_date: "1992-07-11",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/1/4/7/0/1477a0338e626a0f7f8ae27a6c24fc86.mp3?hdnea=exp=1763726044~acl=/api/1/1/1/4/7/0/1477a0338e626a0f7f8ae27a6c24fc86.mp3*~data=user_id=0,application_id=42~hmac=b7fbfc43eca433f4a22d7d458d0e937abce42b3640994773fa70c4d278cb621a",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/6a40fdebd05516980c02b6980ef12c2c/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "It Ain't Over 'Til It's Over",
    artist: "Lenny Kravitz",
    id: 3151232,
    release_date: "1992-07-11",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/2/7/e/0/27e61e13e5b22b109cda87d91b92ddd7.mp3?hdnea=exp=1763726044~acl=/api/1/1/2/7/e/0/27e61e13e5b22b109cda87d91b92ddd7.mp3*~data=user_id=0,application_id=42~hmac=09871d3eec31063d40dd60da36538bd5834c1587c748a9cc48e583fd83b13e52",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/6a40fdebd05516980c02b6980ef12c2c/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "Spinning Around",
    artist: "Kylie Minogue",
    id: 3151534,
    release_date: "2000-07-10",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/a/8/1/0/a810627fb694817f9f1bfaa9a3d16832.mp3?hdnea=exp=1763726044~acl=/api/1/1/a/8/1/0/a810627fb694817f9f1bfaa9a3d16832.mp3*~data=user_id=0,application_id=42~hmac=b8c9cb2fc53080fdc0ef429d0368834b9c385977e65ce39a3f80440723964d92",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/9739769057203c37f03d6fc5a92a9909/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "Power of a Woman",
    artist: "Eternal",
    id: 3151572,
    release_date: "2002-12-23",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/a/6/a/0/a6a0838235724a177d2aa671dfdb4da4.mp3?hdnea=exp=1763726044~acl=/api/1/1/a/6/a/0/a6a0838235724a177d2aa671dfdb4da4.mp3*~data=user_id=0,application_id=42~hmac=591ecb32573e443d4c40e8044be1363d698ad7ab471d2be9fabda0e5dca63a3c",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/4705992d9f297417ee6ce7ae156b9769/250x250-000000-80-0-0.jpg",
    genre: "Rap/Hip Hop",
  },
  {
    title: "All Rise",
    artist: "Blue",
    id: 3152219,
    release_date: "2004-11-15",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/0/7/6/0/076d5b53fb791c324d3fe25404a26326.mp3?hdnea=exp=1763726044~acl=/api/1/1/0/7/6/0/076d5b53fb791c324d3fe25404a26326.mp3*~data=user_id=0,application_id=42~hmac=017f9a15b0adc72f26dfdbdd8f44243a02b2cca9329e548baa2c24c0e3001fc2",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/2763fc2300ebde89852a09b880a4d61b/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "I Touch Myself",
    artist: "Divinyls",
    id: 3152715,
    release_date: "1992-06-29",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/d/a/7/0/da78e8233904cb6bb100ddc9bb0f33e0.mp3?hdnea=exp=1763726044~acl=/api/1/1/d/a/7/0/da78e8233904cb6bb100ddc9bb0f33e0.mp3*~data=user_id=0,application_id=42~hmac=762f37a73d9200f35618e95c0ea7c4f16cd004e70e820d61ec38fda6563c6761",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/87b4cb604b0ce721b6633e5bac4d0ed2/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "Here I Am / Small Axe (Come And Take Me)",
    artist: "UB40",
    id: 3152725,
    release_date: "2003-03-01",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/6/0/9/0/609f8d38e2cbb219856484e38edbb1c2.mp3?hdnea=exp=1763726044~acl=/api/1/1/6/0/9/0/609f8d38e2cbb219856484e38edbb1c2.mp3*~data=user_id=0,application_id=42~hmac=17904202a78121234eab44b615fe47d1ab08ef2fe6e2bfbeb0e17652d1462df5",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/899f9753e753e81a1feac26909080e8f/250x250-000000-80-0-0.jpg",
    genre: "Reggae",
  },
  {
    title: "Higher Ground",
    artist: "UB40",
    id: 3152880,
    release_date: "1993-07-16",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/0/1/1/0/01110de9696a8227fb17247cff79f8db.mp3?hdnea=exp=1763726044~acl=/api/1/1/0/1/1/0/01110de9696a8227fb17247cff79f8db.mp3*~data=user_id=0,application_id=42~hmac=c2bc5a318dab95b27a9e07aac4fa7b523c4bd089c848a194ec72bf5d394e2667",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/4174ce37d7906bb85bdcc71bcc675ff7/250x250-000000-80-0-0.jpg",
    genre: "Reggae",
  },
  {
    title: "(I Can't Help) Falling In Love With You",
    artist: "UB40",
    id: 3152882,
    release_date: "1993-05-10",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/f/6/1/0/f618f47e75f2dd6f916db9ee05462a5b.mp3?hdnea=exp=1763726044~acl=/api/1/1/f/6/1/0/f618f47e75f2dd6f916db9ee05462a5b.mp3*~data=user_id=0,application_id=42~hmac=452fe3d4181bf5728d31858b48eec3678dd4d6029fa84ec1725960b5f9bc7ef0",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/4174ce37d7906bb85bdcc71bcc675ff7/250x250-000000-80-0-0.jpg",
    genre: "Reggae",
  },
  {
    title: "This Is Why I'm Hot",
    artist: "Mims",
    id: 3154364,
    release_date: "2007-03-27",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/1/c/8/0/1c83b7d414d40d3ba878b49df535ea6b.mp3?hdnea=exp=1763726044~acl=/api/1/1/1/c/8/0/1c83b7d414d40d3ba878b49df535ea6b.mp3*~data=user_id=0,application_id=42~hmac=e806626c8ed3ec3cfbc88eda0e504a1ecfd5fb0db8f8df356baf397070c23340",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/e85648856217de74b25119b08c028f6d/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Trick Me",
    artist: "Kelis",
    id: 3155815,
    release_date: "2004-05-24",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/140a7ec5e359c594e9d1205eead306b6/250x250-000000-80-0-0.jpg",
    genre: "Rap/Hip Hop",
  },
  {
    title: "Milkshake",
    artist: "Kelis",
    id: 3156448,
    release_date: "2003-12-08",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/4bc1ea4ab4967fc2a5facaf9a986c545/250x250-000000-80-0-0.jpg",
    genre: "R&B",
  },
  {
    title: "Millionaire",
    artist: "Kelis",
    id: 3156453,
    release_date: "2003-12-08",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/4bc1ea4ab4967fc2a5facaf9a986c545/250x250-000000-80-0-0.jpg",
    genre: "R&B",
  },
  {
    title: "Fly Away",
    artist: "Lenny Kravitz",
    id: 3156968,
    release_date: "1998-12-05",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/fed66f13aac9058bffaf25e677eb858d/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "Naive",
    artist: "The Kooks",
    id: 3158004,
    release_date: "2008-03-31",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/cc60dc84f76f498600c0c871eb9a0abf/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "Don't Worry",
    artist: "Kim Appleby",
    id: 3163934,
    release_date: "1986-09-23",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/8faa7517aabe346b7a749772c6918834/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Come Undone",
    artist: "Duran Duran",
    id: 3166606,
    release_date: "1993-02-15",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/26e42a1a8eee2426482b026471cbc317/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "I Don't Wanna Fight",
    artist: "Tina Turner",
    id: 3167895,
    release_date: "1993-06-15",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/9ae768c59326588a4f336646a734e0b1/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "All For You",
    artist: "Janet Jackson",
    id: 3168996,
    release_date: "2001-11-08",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/ff125d71cdbd7314f68e44d331356e09/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Doesn't Really Matter",
    artist: "Janet Jackson",
    id: 3169010,
    release_date: "2001-06-19",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/ff125d71cdbd7314f68e44d331356e09/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "I Kissed A Girl",
    artist: "Katy Perry",
    id: 3169161,
    release_date: "2008-09-15",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/ef17ef6218f9a5d42b2cbd5d4eeed25f/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Waking Up In Vegas",
    artist: "Katy Perry",
    id: 3169162,
    release_date: "2008-09-15",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/ef17ef6218f9a5d42b2cbd5d4eeed25f/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Thinking Of You",
    artist: "Katy Perry",
    id: 3169163,
    release_date: "2008-09-15",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/ef17ef6218f9a5d42b2cbd5d4eeed25f/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Hot N Cold",
    artist: "Katy Perry",
    id: 3169166,
    release_date: "2008-09-15",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/ef17ef6218f9a5d42b2cbd5d4eeed25f/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "This House",
    artist: "Tracie Spencer",
    id: 3184294,
    release_date: "1999-01-12",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/1de254c52d1aaf0f6247e411c4b29ab6/250x250-000000-80-0-0.jpg",
    genre: "R&B",
  },
  {
    title: "Whole Again",
    artist: "Atomic Kitten",
    id: 3233916,
    release_date: "2003-03-01",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/7e8ffee7b0c04f9d02d7cf6223dff7b7/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Unskinny Bop",
    artist: "Poison",
    id: 3235346,
    release_date: "2006-03-07",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/48ebebdfce609b5330d2d046afe1b319/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "Something To Believe In",
    artist: "Poison",
    id: 3235352,
    release_date: "1990-03-07",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/48ebebdfce609b5330d2d046afe1b319/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "Wonderful",
    artist: "Everclear",
    id: 3242060,
    release_date: "2000-06-29",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/3c0e3934f386d8a07cdff7d022d7f516/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "I'll Be Your Baby Tonight (feat. UB40)",
    artist: "Robert Palmer",
    id: 3242351,
    release_date: "1990-11-05",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/900069fd8ffdfdb17c0574ff9e6d1b1f/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Get A Life",
    artist: "Soul II Soul",
    id: 3265072,
    release_date: "1992-07-11",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/65e9013d6164f4b0dede4da41e7cb1ce/250x250-000000-80-0-0.jpg",
    genre: "Rap/Hip Hop",
  },
  {
    title: "Oh Carolina",
    artist: "Shaggy",
    id: 3278462,
    release_date: "1993-07-30",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/45ac8ab25c4b0d1c677c30077db65c80/250x250-000000-80-0-0.jpg",
    genre: "Reggae",
  },
  {
    title: "I Like It",
    artist: "Sammie",
    id: 3283305,
    release_date: "2000-04-06",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/3d83e315dbdd7ae71b63bec9c245dbb8/250x250-000000-80-0-0.jpg",
    genre: "R&B",
  },
  {
    title: "Opposites Attract",
    artist: "Paula Abdul",
    id: 3311524,
    release_date: "1988-06-29",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/6b4d71e1c818c86bda5edf4b820e9496/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Rush Rush",
    artist: "Paula Abdul",
    id: 3311534,
    release_date: "1992-06-29",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/d662dd4877f19f64c8b1fb5ff9bbd6da/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Sailing On The Seven Seas",
    artist: "Orchestral Manoeuvres In The Dark",
    id: 3319276,
    release_date: "1989-02-13",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/6ddb1589cf546195f1d5b72c685d782d/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "Pandora's Box",
    artist: "Orchestral Manoeuvres In The Dark",
    id: 3319277,
    release_date: "2007-01-08",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/6ddb1589cf546195f1d5b72c685d782d/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "That's Why You Go Away",
    artist: "Michael Learns To Rock",
    id: 3337829,
    release_date: "1999-08-30",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/0b58e4ac2fc60e588d7a6be9cbf1d7ac/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "Fade Into You",
    artist: "Mazzy Star",
    id: 3360821,
    release_date: "1993-09-27",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/5d3703e81301662626cc06a8b2843c78/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "That Girl",
    artist: "Maxi Priest",
    id: 3362643,
    release_date: "2008-07-22",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/ea51e7f043e12d31468872cb01a3fb5c/250x250-000000-80-0-0.jpg",
    genre: "Reggae",
  },
  {
    title: "Fascinating Rhythm",
    artist: "Bass-O-Matic",
    id: 3363711,
    release_date: "2003-03-01",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/9934f68f983c77cdc5211b5061f9bd10/250x250-000000-80-0-0.jpg",
    genre: "Electro",
  },
  {
    title: "I Turn To You",
    artist: "Melanie C",
    id: 3363796,
    release_date: "2000-09-05",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/f20a0a19158fea0ac436d9ac240c97fb/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "Never Be The Same Again",
    artist: "Melanie C",
    id: 3363798,
    release_date: "2000-09-05",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/f20a0a19158fea0ac436d9ac240c97fb/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "Play That Funky Music",
    artist: "Vanilla Ice",
    id: 3366338,
    release_date: "2009-04-21",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/55522600c5cc17b1c56df91ddee0630d/250x250-000000-80-0-0.jpg",
    genre: "Rap/Hip Hop",
  },
  {
    title: "Baby, Baby",
    artist: "Amy Grant",
    id: 3377259,
    release_date: "1991-06-18",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/34d721988bc16085f6a76844b893ba91/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Every Heartbeat",
    artist: "Amy Grant",
    id: 3377260,
    release_date: "1989-02-01",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/34d721988bc16085f6a76844b893ba91/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "That's What Love Is For",
    artist: "Amy Grant",
    id: 3377261,
    release_date: "2007-08-14",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/6/9/8/0/698920d25ce509b4b0709dfc6e7a9f6e.mp3?hdnea=exp=1763731235~acl=/api/1/1/6/9/8/0/698920d25ce509b4b0709dfc6e7a9f6e.mp3*~data=user_id=0,application_id=42~hmac=98b7d8dd10394bb6d555ab76b6b0c78df0eb348babdd2ca55ee38d046f9d3121",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/34d721988bc16085f6a76844b893ba91/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Spaceman",
    artist: "Babylon Zoo",
    id: 3389663,
    release_date: "1996-02-29",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/1/e/a/0/1ea376dc8d584e668790a72e8ec76c98.mp3?hdnea=exp=1763731235~acl=/api/1/1/1/e/a/0/1ea376dc8d584e668790a72e8ec76c98.mp3*~data=user_id=0,application_id=42~hmac=52c938c4cf9a18e2fd3f5c217e0e7ab869ed3f73da39c47b3a0edd996f26d8bc",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/a9c077fe8f6342724a5aa61deae88d51/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Something To Talk About",
    artist: "Bonnie Raitt",
    id: 3402676,
    release_date: "1991-07-29",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/6/e/5/0/6e535cf2283b4350c0485e0cc479778e.mp3?hdnea=exp=1763731235~acl=/api/1/1/6/e/5/0/6e535cf2283b4350c0485e0cc479778e.mp3*~data=user_id=0,application_id=42~hmac=cc3b6ac696eb042838d600e729b3b1f6e0882a4822e1a0f086d16e3d900553bc",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/a3a4a48d754748571273a43c71583bf9/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "I Can't Make You Love Me",
    artist: "Bonnie Raitt",
    id: 3402678,
    release_date: "1991-02-20",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/a/6/1/0/a610427eb746c0333d1d02b68c39b60b.mp3?hdnea=exp=1763731235~acl=/api/1/1/a/6/1/0/a610427eb746c0333d1d02b68c39b60b.mp3*~data=user_id=0,application_id=42~hmac=1caa42494d28d671fce2fa258e55e58be42429d8881a2e965f25576d939673fa",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/a3a4a48d754748571273a43c71583bf9/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Ms. New Booty",
    artist: "Bubba Sparxxx",
    id: 3405985,
    release_date: "2005-11-29",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/8/2/a/0/82ab72d2160ec20ae8b7ee73ab478d5c.mp3?hdnea=exp=1763731235~acl=/api/1/1/8/2/a/0/82ab72d2160ec20ae8b7ee73ab478d5c.mp3*~data=user_id=0,application_id=42~hmac=be4c93a27f7b8234c9fa162b0bde2665034902f675d474979ffde723d7dad904",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/19a37a491b24a0ba5d06183f01f26c1a/250x250-000000-80-0-0.jpg",
    genre: "Rap/Hip Hop",
  },
  {
    title: "Do It To It",
    artist: "Cherish",
    id: 3414898,
    release_date: "2006-08-15",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/7/1/b/0/71bd26772f3929c43f8388f779a0623a.mp3?hdnea=exp=1763731235~acl=/api/1/1/7/1/b/0/71bd26772f3929c43f8388f779a0623a.mp3*~data=user_id=0,application_id=42~hmac=ba48464589e7f6ca89a0278923cb77a62e6a2d1a1d5f3f807716edfe966c8c0c",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/7b95adc61ae5d092fda8fcc1a522df47/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "When Love Takes Over (feat. Kelly Rowland)",
    artist: "David Guetta",
    id: 3445820,
    release_date: "2009-04-17",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/0/6/1/0/061de66a4031b34cf4ab44f7ab2f4b71.mp3?hdnea=exp=1763731235~acl=/api/1/1/0/6/1/0/061de66a4031b34cf4ab44f7ab2f4b71.mp3*~data=user_id=0,application_id=42~hmac=23a26e5af1590daaeaacf8c141349a3dd60045c0290ac3eda4ebeb451f8722d9",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/ee1ea209237b95cf27a1427ac5ecdec0/250x250-000000-80-0-0.jpg",
    genre: "Dance",
  },
  {
    title: "Again",
    artist: "Janet Jackson",
    id: 3501662,
    release_date: "2000-07-06",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/d/2/b/0/d2bc735963e24936f23f2cd998617c3c.mp3?hdnea=exp=1763731235~acl=/api/1/1/d/2/b/0/d2bc735963e24936f23f2cd998617c3c.mp3*~data=user_id=0,application_id=42~hmac=b5278f5e64d3c59368a5bd28f7c63c485cfac80b9be22afa0ebf074bd03a8be8",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/4104f417dff07ee2b6c49b798f8b23ad/250x250-000000-80-0-0.jpg",
    genre: "R&B",
  },
  {
    title: "Happening All Over Again",
    artist: "Lonnie Gordon",
    id: 3535615,
    release_date: "1993-08-10",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/c/c/a/0/cca5e56a362a684968826ae2072d32e1.mp3?hdnea=exp=1763731235~acl=/api/1/1/c/c/a/0/cca5e56a362a684968826ae2072d32e1.mp3*~data=user_id=0,application_id=42~hmac=5c3e54cf22b9d413cb7580cec389d157ce6bd7bbcbf2f32b02f919c329c93da5",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/59ac02b382c6dc4bfe673e8552cb11d8/250x250-000000-80-0-0.jpg",
    genre: "Dance",
  },
  {
    title: "Epic",
    artist: "Faith No More",
    id: 3590156,
    release_date: "1989-01-29",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/f/0/c/0/f0c43f29f9347719d23a001e627a452e.mp3?hdnea=exp=1763731235~acl=/api/1/1/f/0/c/0/f0c43f29f9347719d23a001e627a452e.mp3*~data=user_id=0,application_id=42~hmac=2065a114294b90910bd0bbac4699573bdfd89d41b19e130c9990e01ae03a8261",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/88fcaad892e7686ec8b9a901e5a29c41/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Supermassive Black Hole",
    artist: "Muse",
    id: 3590186,
    release_date: "2006-06-19",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/4/5/8/0/4589367276d77cfeb3e1257e7006dd37.mp3?hdnea=exp=1763731235~acl=/api/1/1/4/5/8/0/4589367276d77cfeb3e1257e7006dd37.mp3*~data=user_id=0,application_id=42~hmac=48547e5a5e08d04b35eaf50cab6ee3c7e12e56d7c529404070538ff3ed2b7924",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/fc457d27a8c0b7fc6f9b56fb94e22a0d/250x250-000000-80-0-0.jpg",
    genre: "Alternative",
  },
  {
    title: "There You'll Be",
    artist: "Faith Hill",
    id: 3598718,
    release_date: "2001-05-21",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/d/9/8/0/d98727183c7e5b8141d6a45b895c4570.mp3?hdnea=exp=1763731235~acl=/api/1/1/d/9/8/0/d98727183c7e5b8141d6a45b895c4570.mp3*~data=user_id=0,application_id=42~hmac=4854165f445eb07f3745aa00de7885ac8ef7b9efaa787b064b592c8d62f938e9",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/fe9f2f1290275e57df54a32e18d31471/250x250-000000-80-0-0.jpg",
    genre: "Films/Games",
  },
  {
    title: "Closer to Free",
    artist: "BoDeans",
    id: 3599660,
    release_date: "1996-11-12",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/d/2/2/0/d22d6c6c3e984a83841059974f437e90.mp3?hdnea=exp=1763731235~acl=/api/1/1/d/2/2/0/d22d6c6c3e984a83841059974f437e90.mp3*~data=user_id=0,application_id=42~hmac=d59c06edae259cc5c4816e6f32ffe47efa68aa6f158dca3affffc073eca7c348",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/c0752505252130719511a891214b6f79/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "It's Been Awhile",
    artist: "Staind",
    id: 3611374,
    release_date: "2001-05-22",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/8/1/f/0/81fe4fd528f054ac6d11b17ced480ed9.mp3?hdnea=exp=1763731235~acl=/api/1/1/8/1/f/0/81fe4fd528f054ac6d11b17ced480ed9.mp3*~data=user_id=0,application_id=42~hmac=330f29f5556b439732aa6fc7e92c887083fe31c8332229231112c81f9ba8d847",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/3bc28968fcb37db269ea1a90fc7bfc5c/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Twisted",
    artist: "Keith Sweat",
    id: 3616531,
    release_date: "2004-10-26",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/c/0/c/0/c0ce8acdec068fb69446f8b2caaf82da.mp3?hdnea=exp=1763731235~acl=/api/1/1/c/0/c/0/c0ce8acdec068fb69446f8b2caaf82da.mp3*~data=user_id=0,application_id=42~hmac=eaa383613e3433a8652f9ba141d17ab39b1c2f78665e92940097b039614d0878",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/2a33be0dde86b9bc7579703c246f9c33/250x250-000000-80-0-0.jpg",
    genre: "Dance",
  },
  {
    title: "Nobody (feat. Athena Cage)",
    artist: "Keith Sweat",
    id: 3616541,
    release_date: "2004-10-26",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/c/6/c/0/c6cef2b8bc14f4bdad3ca62e74b25802.mp3?hdnea=exp=1763731235~acl=/api/1/1/c/6/c/0/c6cef2b8bc14f4bdad3ca62e74b25802.mp3*~data=user_id=0,application_id=42~hmac=665494d1364ca44a09ef0da08b86f4b52a205c41784d713a9fdafed87e3035c8",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/2a33be0dde86b9bc7579703c246f9c33/250x250-000000-80-0-0.jpg",
    genre: "Dance",
  },
  {
    title: "New Shoes",
    artist: "Paolo Nutini",
    id: 3657964,
    release_date: "2007-01-30",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/1/b/3/0/1b3fd906c3def65789e1194581f541a8.mp3?hdnea=exp=1763731235~acl=/api/1/1/1/b/3/0/1b3fd906c3def65789e1194581f541a8.mp3*~data=user_id=0,application_id=42~hmac=36a564e688ed5da496029268c3a4a652ef1b8f5e4e648d944ad34b071ff0369d",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/f43d26dc4fa2d28279dd3665af1dad83/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Shawty (feat. T Pain)",
    artist: "Plies",
    id: 3661514,
    release_date: "2007-08-07",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/3/4/e/0/34e86c6ced69ad7fa498bd0421bb7910.mp3?hdnea=exp=1763731235~acl=/api/1/1/3/4/e/0/34e86c6ced69ad7fa498bd0421bb7910.mp3*~data=user_id=0,application_id=42~hmac=a87ab8b88fc7e8eacefc328801a8249bd9cd8e6c47d8843d45da4048bca3b022",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/6c764e7491bdf0810ef9a1e7dd98743f/250x250-000000-80-0-0.jpg",
    genre: "Rap/Hip Hop",
  },
  {
    title: "Hotel Room Service",
    artist: "Pitbull",
    id: 3731410,
    release_date: "2009-06-11",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/2/6/8/0/268581a9f77c74d44cd29929c06d059a.mp3?hdnea=exp=1763731235~acl=/api/1/1/2/6/8/0/268581a9f77c74d44cd29929c06d059a.mp3*~data=user_id=0,application_id=42~hmac=f82f4c2971fcc1b7eb656ffef1973bfc1172d721d6e42c82ab55b316e794c191",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/2b0fe2aab6f61ba46edd70b74867c2fa/250x250-000000-80-0-0.jpg",
    genre: "Dance",
  },
  {
    title: "She Talks To Angels",
    artist: "The Black Crowes",
    id: 3731807,
    release_date: "2017-11-28",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/d/a/4/0/da42606e45ed385f18f0963c8578f883.mp3?hdnea=exp=1763731235~acl=/api/1/1/d/a/4/0/da42606e45ed385f18f0963c8578f883.mp3*~data=user_id=0,application_id=42~hmac=4867797dc882da7ac3dbcc86863665d9cf4f849223aa074b6c980b28882dab86",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/3a693d580357750108ad14ccde560aa3/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Flat Beat",
    artist: "Mr. Oizo",
    id: 3748159,
    release_date: "1999-03-15",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/0/6/3/0/063bf8c5ea58a31f1d1bd3e92a6ae49e.mp3?hdnea=exp=1763731235~acl=/api/1/1/0/6/3/0/063bf8c5ea58a31f1d1bd3e92a6ae49e.mp3*~data=user_id=0,application_id=42~hmac=f2fb69ad196ad917e06b5996ce7a99ec7578dfcdcaf6ffc93474203b69693f14",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/331d18ce92c355bc0dd5b699e063249c/250x250-000000-80-0-0.jpg",
    genre: "Electro",
  },
  {
    title: "Follow Me",
    artist: "Uncle Kracker",
    id: 3819653,
    release_date: "2000-06-13",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/3/3/2/0/3321454cfde990457df2a64dd54a4794.mp3?hdnea=exp=1763731235~acl=/api/1/1/3/3/2/0/3321454cfde990457df2a64dd54a4794.mp3*~data=user_id=0,application_id=42~hmac=0b143570133a93b82d229d7ef5352605ccf3e3c74b13f51e9bba6962f1db4f35",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/4c5cae288ea63e37ea904ac492dea926/250x250-000000-80-0-0.jpg",
    genre: "Country",
  },
  {
    title: "What's It Gonna Be?! (feat. Janet Jackson)",
    artist: "Busta Rhymes",
    id: 3822107,
    release_date: "2009-07-14",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/2/1/6/0/2164bdd39da6aba732a05a4af9d5f0e6.mp3?hdnea=exp=1763731235~acl=/api/1/1/2/1/6/0/2164bdd39da6aba732a05a4af9d5f0e6.mp3*~data=user_id=0,application_id=42~hmac=f84e690c6d49f3d84cfbae0d942d2e9305d3ead8f69e375ab09aa3191a754da8",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/a9663fa127e4dae473e1754ad921b671/250x250-000000-80-0-0.jpg",
    genre: "Rap/Hip Hop",
  },
  {
    title: "Misery Business",
    artist: "Paramore",
    id: 3829140,
    release_date: "2007-06-11",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/3/0/2/0/3025b7b2163764b922e8e0e1c950f1c5.mp3?hdnea=exp=1763731235~acl=/api/1/1/3/0/2/0/3025b7b2163764b922e8e0e1c950f1c5.mp3*~data=user_id=0,application_id=42~hmac=3b556dc5c8ca53f63bf03a754fbf7a50e43bb299d394a04813d35c0d0c91fa0f",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/1a48b36fe9dd29b2bef2f5058cbe0c25/250x250-000000-80-0-0.jpg",
    genre: "Alternative",
  },
  {
    title: "From a Distance",
    artist: "Bette Midler",
    id: 3860243,
    release_date: "2005-07-26",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/e/e/1/0/ee124d99cf285382737b7fbc9926155a.mp3?hdnea=exp=1763731235~acl=/api/1/1/e/e/1/0/ee124d99cf285382737b7fbc9926155a.mp3*~data=user_id=0,application_id=42~hmac=69b47caa0e5b785f52c66ebe8a5272310446689043b700dbbf97f7326bb95dae",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/fe274e0131fc9daf8b31cf41a097e3ba/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Dance with Me",
    artist: "Debelah Morgan",
    id: 3875181,
    release_date: "2007-11-27",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/4/5/4/0/454a576d30e48606b3a85466c9f2a937.mp3?hdnea=exp=1763731235~acl=/api/1/1/4/5/4/0/454a576d30e48606b3a85466c9f2a937.mp3*~data=user_id=0,application_id=42~hmac=7e25d1884129f18e763e29d714f029c82f8d50dfbf5104ec0cd36bb5198a9d30",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/3be47a01e4301644217cfdca10c89228/250x250-000000-80-0-0.jpg",
    genre: "R&B",
  },
  {
    title: "Just the Girl",
    artist: "The Click Five",
    id: 3877492,
    release_date: "2005-08-16",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/d/3/c/0/d3c9e56755add08b61c9b53ec244fc50.mp3?hdnea=exp=1763731235~acl=/api/1/1/d/3/c/0/d3c9e56755add08b61c9b53ec244fc50.mp3*~data=user_id=0,application_id=42~hmac=0806494b606fd8a7b599d43cd677958e067a67f677571bd0d6fdc4b48d478dd1",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/ec927c501a57078ce66aa1137c360534/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Informer",
    artist: "Snow",
    id: 3884974,
    release_date: "1992-12-29",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/f/1/0/0/f10b6ef0efc562d2f855a370d58895d6.mp3?hdnea=exp=1763731235~acl=/api/1/1/f/1/0/0/f10b6ef0efc562d2f855a370d58895d6.mp3*~data=user_id=0,application_id=42~hmac=dffbc3b7c89d89133e654195c91f6b18bcac7f8f6d91ee18df9f1eb1370544aa",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/899fb38ed8057501e6275319f9c78599/250x250-000000-80-0-0.jpg",
    genre: "Rap/Hip Hop",
  },
  {
    title: "All I Want (Sunship Radio Edit)",
    artist: "Mis-Teeq",
    id: 3892663,
    release_date: "2004-07-13",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/b/7/f/0/b7ffa1a424a8ca57efce929ec9e1dc8b.mp3?hdnea=exp=1763731235~acl=/api/1/1/b/7/f/0/b7ffa1a424a8ca57efce929ec9e1dc8b.mp3*~data=user_id=0,application_id=42~hmac=5d6dbba05259709a996bab9408654ba87d45a382a00217b62773992bdfdc4cdb",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/a93cad437b3825fa5b6d558178bd795f/250x250-000000-80-0-0.jpg",
    genre: "Rap/Hip Hop",
  },
  {
    title: "Laffy Taffy",
    artist: "D4L",
    id: 3896443,
    release_date: "2005-11-08",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/1/0/8/0/10890990f63137c2a9c7d94bcee1278c.mp3?hdnea=exp=1763731235~acl=/api/1/1/1/0/8/0/10890990f63137c2a9c7d94bcee1278c.mp3*~data=user_id=0,application_id=42~hmac=0f995bc0fc2aa2fb07dd856a04b8c4656d0827ae036fcf1a9cdccaf95f45450a",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/13ea59bc8163ced278f9f7b8e019a750/250x250-000000-80-0-0.jpg",
    genre: "Rap/Hip Hop",
  },
  {
    title: "Sunshine (feat. Anthony Hamilton)",
    artist: "Twista",
    id: 3899461,
    release_date: "2004-01-27",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/9/9/a/0/99a5338e7c52ac131498c1ff6999d921.mp3?hdnea=exp=1763731235~acl=/api/1/1/9/9/a/0/99a5338e7c52ac131498c1ff6999d921.mp3*~data=user_id=0,application_id=42~hmac=4819643b0db6660539908e8582327b6db35bfc4ffa9508a9196512fae8554de5",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/9e43cce86c61e9da6e767a9553681a19/250x250-000000-80-0-0.jpg",
    genre: "Rap/Hip Hop",
  },
  {
    title: "I'm a Thug",
    artist: "Trick Daddy",
    id: 3907007,
    release_date: "2001-03-20",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/4/5/4/0/454ddb87c89482142d9eb91d182442fe.mp3?hdnea=exp=1763731235~acl=/api/1/1/4/5/4/0/454ddb87c89482142d9eb91d182442fe.mp3*~data=user_id=0,application_id=42~hmac=e88acfd8db61088beba05f17dd5ddbfcc3ba3fe0f3923a221e734dfff0f6087c",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/bbc6487b67e43c628d3406e71009bb55/250x250-000000-80-0-0.jpg",
    genre: "Rap/Hip Hop",
  },
  {
    title: "Desperately Wanting",
    artist: "Better Than Ezra",
    id: 3928390,
    release_date: "2005-03-15",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/b/4/d/0/b4dba7f62545abd1e1bfc7a050299b9f.mp3?hdnea=exp=1763731235~acl=/api/1/1/b/4/d/0/b4dba7f62545abd1e1bfc7a050299b9f.mp3*~data=user_id=0,application_id=42~hmac=ee5b2a591c68472b62d4b84380c3960f26dc746e136a6eb25fa167e68afc4596",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/46e6ffccac3acea3ac17c3c9c736a12a/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "(When You Gonna) Give It Up to Me (feat. Keyshia Cole)",
    artist: "Sean Paul",
    id: 3957322,
    release_date: "2006-09-11",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/c/a/b/0/caba00a8b3fdfe486f5af3c4cfbca02d.mp3?hdnea=exp=1763731235~acl=/api/1/1/c/a/b/0/caba00a8b3fdfe486f5af3c4cfbca02d.mp3*~data=user_id=0,application_id=42~hmac=83754c2db2ab540129dbc115b06ca1bb64feccf402cb8a702e58a531e8a986d0",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/1dd7650a5eae9cdde6aa8b4f977fb3a6/250x250-000000-80-0-0.jpg",
    genre: "R&B",
  },
  {
    title: "Pony (Single Version)",
    artist: "Ginuwine",
    id: 3958370,
    release_date: "2008-05-26",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/3/7/4/0/374e4517b45b6a3025a7e37f6e49a9b2.mp3?hdnea=exp=1763731235~acl=/api/1/1/3/7/4/0/374e4517b45b6a3025a7e37f6e49a9b2.mp3*~data=user_id=0,application_id=42~hmac=3de29ce23646cfe20e23752970a90baec3f40dbba9852411e1548b9911dd9ca9",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/cae317b2c560c0b95a9c106d3ceb108e/250x250-000000-80-0-0.jpg",
    genre: "R&B",
  },
  {
    title: "Maria Maria (feat. The Product G&B)",
    artist: "Santana",
    id: 3958522,
    release_date: "2009-07-06",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/e/4/9/0/e49385ce31d15db40261d34502e1d7cf.mp3?hdnea=exp=1763731235~acl=/api/1/1/e/4/9/0/e49385ce31d15db40261d34502e1d7cf.mp3*~data=user_id=0,application_id=42~hmac=edf224b478919291a5e47e9ec52047140d908889e0046d82a293b066cad69554",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/e3efd1474f3c04b4cd6d5e35f48a0c92/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Battlefield",
    artist: "Jordin Sparks",
    id: 3959408,
    release_date: "2009-07-20",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/8/c/0/0/8c083e7d0aedee444c7aa3d28a5e8e16.mp3?hdnea=exp=1763731235~acl=/api/1/1/8/c/0/0/8c083e7d0aedee444c7aa3d28a5e8e16.mp3*~data=user_id=0,application_id=42~hmac=ee3843016d2e84bb6bdeca6d407d60cd21470c83474e5486c9271785cac35337",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/b177fda7c042ec001b8a107bec060688/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "No Air (feat. Chris Brown)",
    artist: "Jordin Sparks",
    id: 3960474,
    release_date: "2008-04-11",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/8/0/f/0/80f47e1c5e4272e85f7565120c8c3faa.mp3?hdnea=exp=1763731235~acl=/api/1/1/8/0/f/0/80f47e1c5e4272e85f7565120c8c3faa.mp3*~data=user_id=0,application_id=42~hmac=0fcb3aa1ada0cce2812e496e7912140d5604593de0982590081cf75363cc2c6a",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/c43d5f019822b288e1c31fbb4243eadc/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Bulletproof",
    artist: "La Roux",
    id: 3976602,
    release_date: "2009-06-29",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/2/b/4/0/2b472990b2411fecf16bae53ddf3424b.mp3?hdnea=exp=1763731235~acl=/api/1/1/2/b/4/0/2b472990b2411fecf16bae53ddf3424b.mp3*~data=user_id=0,application_id=42~hmac=2817af61e5347996633af37e9d8a17c8ce849915da4dda0af6c25e2658bbe236",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/91f8ab3d5dace0f93a4de460a9c5c10b/250x250-000000-80-0-0.jpg",
    genre: "Dance",
  },
  {
    title: "Take Me To The Clouds Above (LMC Vs. U2 / Radio Edit)",
    artist: "LMC",
    id: 3979726,
    release_date: "2006-11-27",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/7291ddcdfb47e42e6f63cd5d2352d998/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Any Dream Will Do",
    artist: "Andrew Lloyd Webber",
    id: 3981462,
    release_date: "2005-11-07",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/8fff4bb0a157b2f5b6cbed404fd6015b/250x250-000000-80-0-0.jpg",
    genre: "Films/Games",
  },
  {
    title: "Bootylicious",
    artist: "Destiny's Child",
    id: 4006939,
    release_date: "2001-01-01",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/c/a/0/0/ca088efd573fc05a2325ef3326ed846f.mp3?hdnea=exp=1763731235~acl=/api/1/1/c/a/0/0/ca088efd573fc05a2325ef3326ed846f.mp3*~data=user_id=0,application_id=42~hmac=e5c1a519a985021cba07a82dea0d0ba7795e13afa1bcd249ca49f4cc4c4e8915",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/6569bbc2ccd786c051555084ebc9b355/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Like a Boy",
    artist: "Ciara",
    id: 4007318,
    release_date: "2009-07-24",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/8/3/d/0/83d058f78ed26b35fe8fbbc8ecaa1c0c.mp3?hdnea=exp=1763731235~acl=/api/1/1/8/3/d/0/83d058f78ed26b35fe8fbbc8ecaa1c0c.mp3*~data=user_id=0,application_id=42~hmac=329a71030cdb08dd5dceba9068fda1613d5926c6ff7053d07b6858a8e6737518",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/9b24f9dddee58fd516f48f593d38b82d/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Heaven Is a Halfpipe (If I Die)",
    artist: "OPM",
    id: 4086982,
    release_date: "2000-01-01",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/7/c/e/0/7cea6319fa28b7d110137bc623efa712.mp3?hdnea=exp=1763731235~acl=/api/1/1/7/c/e/0/7cea6319fa28b7d110137bc623efa712.mp3*~data=user_id=0,application_id=42~hmac=1d55078a3f9f0023efd38592947e3e750c8d62293c311c016cffcec16c31b20a",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/8600ad1ca9a86b139519354d2d061ab7/250x250-000000-80-0-0.jpg",
    genre: "Rap/Hip Hop",
  },
  {
    title: "Youth of the Nation",
    artist: "P.O.D",
    id: 4087048,
    release_date: "2001-09-11",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/3/b/3/0/3b3b23cc79d03ce287952a1ecffd2fdd.mp3?hdnea=exp=1763731235~acl=/api/1/1/3/b/3/0/3b3b23cc79d03ce287952a1ecffd2fdd.mp3*~data=user_id=0,application_id=42~hmac=08885ac01f9ab7d2756898b75f2b8ce2b604373ace01ebd86162dd653a8ca2ca",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/655f3e742d4b5ef53d0b95554d34616e/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "All Summer Long",
    artist: "Kid Rock",
    id: 4087608,
    release_date: "2007-10-09",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/0/b/d/0/0bd2303952d321fb693e3a1dd49c9f35.mp3?hdnea=exp=1763731235~acl=/api/1/1/0/b/d/0/0bd2303952d321fb693e3a1dd49c9f35.mp3*~data=user_id=0,application_id=42~hmac=6ee5ebabaea51160c141973948ddea107e0c68e66597142cce8a18ecadc7832b",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/b0ce5aa10cc52b8dc6661c7ce9b6c876/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "I Wanna Sex You Up (Single Mix)",
    artist: "Color Me Badd",
    id: 4089646,
    release_date: "1991-01-01",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/5/4/d/0/54d202edf56e524128f98935ba62dbe6.mp3?hdnea=exp=1763731235~acl=/api/1/1/5/4/d/0/54d202edf56e524128f98935ba62dbe6.mp3*~data=user_id=0,application_id=42~hmac=d658f3769e26deee6399e6a87723b1a0972a891b2f71aff1ca180fcae0f374eb",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/c6a712e65a0ad34577553759dd7b4141/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "All 4 Love",
    artist: "Color Me Badd",
    id: 4089647,
    release_date: "1991-01-01",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/d/5/8/0/d58927e7547ba48b288a7b1f118129aa.mp3?hdnea=exp=1763731235~acl=/api/1/1/d/5/8/0/d58927e7547ba48b288a7b1f118129aa.mp3*~data=user_id=0,application_id=42~hmac=0a105fefcb52cd769c85bb8347ddf40aa43a2b7da7017c8cc7a11f04b7ecf323",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/c6a712e65a0ad34577553759dd7b4141/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Take a Picture",
    artist: "Filter",
    id: 4094391,
    release_date: "1999-08-23",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/b8936f824746325c3ef81edb1816e847/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "So Fine",
    artist: "Sean Paul",
    id: 4096449,
    release_date: "2009-08-14",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/9/f/6/0/9f6dc0da7defbf5fb909026893aa465d.mp3?hdnea=exp=1763731235~acl=/api/1/1/9/f/6/0/9f6dc0da7defbf5fb909026893aa465d.mp3*~data=user_id=0,application_id=42~hmac=01c7ea54fd0a974f430c673947a3b21449a6a79361026660858466087d017e80",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/27b211e7caf59b0e434a836dfc078165/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Knock You Down",
    artist: "Keri Hilson",
    id: 4123045,
    release_date: "2009-05-04",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/1dba35079692ff47f7bce2a00d3bc514/250x250-000000-80-0-0.jpg",
    genre: "R&B",
  },
  {
    title: "Down",
    artist: "Jay Sean",
    id: 4160021,
    release_date: "2009-07-10",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/9a7f4fbf785e1745c8f628fe85b3d594/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Right Round",
    artist: "Flo Rida",
    id: 4162078,
    release_date: "2009-03-30",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/7/d/6/0/7d6fe29bfa82439035a4a9f18f744397.mp3?hdnea=exp=1763730761~acl=/api/1/1/7/d/6/0/7d6fe29bfa82439035a4a9f18f744397.mp3*~data=user_id=0,application_id=42~hmac=7943b26067d891113dd4b66fa83825c61d983b9d7c5e38225947743e96208b56",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/53654f189e39eb74aea041f8140649f5/250x250-000000-80-0-0.jpg",
    genre: "Rap/Hip Hop",
  },
  {
    title: "We Be Burnin'",
    artist: "Sean Paul",
    id: 4162685,
    release_date: "2005-09-26",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/c/7/5/0/c75675ab8b7ecf2f3e961c4e893b58ad.mp3?hdnea=exp=1763730761~acl=/api/1/1/c/7/5/0/c75675ab8b7ecf2f3e961c4e893b58ad.mp3*~data=user_id=0,application_id=42~hmac=9b73c5e52be1706ae3bc3b5e980d4b7b7d3973947f256a04f9e7045267528a4b",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/acea01270d22ab9c87661dff9d98bfec/250x250-000000-80-0-0.jpg",
    genre: "R&B",
  },
  {
    title: "Temperature",
    artist: "Sean Paul",
    id: 4162693,
    release_date: "2005-09-26",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/acea01270d22ab9c87661dff9d98bfec/250x250-000000-80-0-0.jpg",
    genre: "R&B",
  },
  {
    title: "One Time",
    artist: "Justin Bieber",
    id: 4187426,
    release_date: "2009-06-26",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/43a761bf503ec58425f97e2371e4a6ea/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Happily Ever After",
    artist: "Case",
    id: 4190566,
    release_date: "2009-06-16",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/6a8b49bc036a6f40865c8efcf007e4d6/250x250-000000-80-0-0.jpg",
    genre: "Rap/Hip Hop",
  },
  {
    title: "Beautiful Stranger",
    artist: "Madonna",
    id: 4209674,
    release_date: "1999-05-29",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/3/9/4/0/3946f17134082afd6cade13736136f22.mp3?hdnea=exp=1763730761~acl=/api/1/1/3/9/4/0/3946f17134082afd6cade13736136f22.mp3*~data=user_id=0,application_id=42~hmac=6a682da44f43335072bd7dfb4d702a71ccbc2357b2f0e030bab957c1f31e0d64",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/195d3d2c1196b20711cfb6ad76e1c2ba/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "I Know You Want Me (Calle Ocho)",
    artist: "Pitbull",
    id: 4216277,
    release_date: "2009-08-31",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/e/7/f/0/e7fbf56f9a6ce62c79e8a32d6aedacf6.mp3?hdnea=exp=1763730761~acl=/api/1/1/e/7/f/0/e7fbf56f9a6ce62c79e8a32d6aedacf6.mp3*~data=user_id=0,application_id=42~hmac=e7724904109eaaa9f0128687f0655848fe1c37bdcaf900e3ba927ddd515a308a",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/dafa15ce0606a487a15f00dea03654e8/250x250-000000-80-0-0.jpg",
    genre: "Rap/Hip Hop",
  },
  {
    title: "Day 'N' Nite (Crookers Remix)",
    artist: "Kid Cudi",
    id: 4232307,
    release_date: "2009-09-14",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/1/1/0/0/110c2964384d4756550cadd50369ca61.mp3?hdnea=exp=1763730761~acl=/api/1/1/1/1/0/0/110c2964384d4756550cadd50369ca61.mp3*~data=user_id=0,application_id=42~hmac=52bdceb98ccd71d09193c6df2441267f3df60d8db2e0fec403f23bc99194b0d2",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/852d93133d8a0b298b87f4fd69b3f1fb/250x250-000000-80-0-0.jpg",
    genre: "Rap/Hip Hop",
  },
  {
    title: "Party In The U.S.A.",
    artist: "Miley Cyrus",
    id: 4233792,
    release_date: "2009-08-11",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/4/2/9/0/42924e08b4f6076c082fc97fd31f30de.mp3?hdnea=exp=1763730761~acl=/api/1/1/4/2/9/0/42924e08b4f6076c082fc97fd31f30de.mp3*~data=user_id=0,application_id=42~hmac=31a1526e6df25b137c0bddb7ece4e0bf0a7aa6147a9f213701f56decbb7d7c27",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/5eb7bf3d5a9e623f2f74536dbb197dfa/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Obsessed",
    artist: "Mariah Carey",
    id: 4247257,
    release_date: "2009-10-13",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/6/6/4/0/664d963d5f769e9bc1a06b13fa3d169b.mp3?hdnea=exp=1763730761~acl=/api/1/1/6/6/4/0/664d963d5f769e9bc1a06b13fa3d169b.mp3*~data=user_id=0,application_id=42~hmac=18158c7aafb722e234eb4e672c0fe3dbe69c605e6897dd56c1654303a2d72fe5",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/67e6af08b67272ec67eacccbb44a1368/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Every Morning",
    artist: "Sugar Ray",
    id: 4288270,
    release_date: "1998-12-23",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/b/5/c/0/b5cb9c5fa8cbc7088c22af8d36a8badb.mp3?hdnea=exp=1763730761~acl=/api/1/1/b/5/c/0/b5cb9c5fa8cbc7088c22af8d36a8badb.mp3*~data=user_id=0,application_id=42~hmac=347ce23c3c7b14a81a1971072d3967af0fd75273af6440a479c5cfed38ea486c",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/b31183d3344b839c9dc801fd804899b1/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "I'll Be There for You (Theme from 'Friends')",
    artist: "The Rembrandts",
    id: 4289170,
    release_date: "1995-08-15",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/7/c/2/0/7c2bc66d987e6df36292f32509e1c609.mp3?hdnea=exp=1763730761~acl=/api/1/1/7/c/2/0/7c2bc66d987e6df36292f32509e1c609.mp3*~data=user_id=0,application_id=42~hmac=0adb2ee942e7df138e1119a876bd11bb1ff9fec27f421a94adbdde63440b1be6",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/ac4bfa0c432871ba5e843c1ca3058825/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Forever",
    artist: "Drake",
    id: 4302261,
    release_date: "2009-09-28",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/a/d/0/0/ad08962f276c77c0615e2cd9966097f4.mp3?hdnea=exp=1763730761~acl=/api/1/1/a/d/0/0/ad08962f276c77c0615e2cd9966097f4.mp3*~data=user_id=0,application_id=42~hmac=e5dc487335b7e89359c321e1de609652fbd7833f55b4add8c5fad8c904603212",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/785f058792860715d97984a969a8407f/250x250-000000-80-0-0.jpg",
    genre: "Rap/Hip Hop",
  },
  {
    title: "The Climb",
    artist: "Miley Cyrus",
    id: 4307896,
    release_date: "2009-10-26",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/f/f/8/0/ff8d8a21791c825ca48e4779036bcc0a.mp3?hdnea=exp=1763730761~acl=/api/1/1/f/f/8/0/ff8d8a21791c825ca48e4779036bcc0a.mp3*~data=user_id=0,application_id=42~hmac=d05653c0f5166586cea67b4e86ef3684a0ba2d1cea23cf89f268a8c39ad902b3",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/515658453fdf5d6b55550edec648487c/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Ego",
    artist: "Beyoncé",
    id: 4311359,
    release_date: "2009-09-04",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/f/3/a/0/f3a001eaa91afec2016dd3a1910bdd17.mp3?hdnea=exp=1763730761~acl=/api/1/1/f/3/a/0/f3a001eaa91afec2016dd3a1910bdd17.mp3*~data=user_id=0,application_id=42~hmac=62723f4b4e939e752bda0d33b58e653daa565860b9fda872df7bf33c0fb4dbd1",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/9e6686fb79ab27afcc7ceeaf98689277/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "The Pretender",
    artist: "Foo Fighters",
    id: 4311597,
    release_date: "2007-09-17",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/0/5/6/0/0563ec4e57aeb9c730d2fa983d76c6b2.mp3?hdnea=exp=1763730761~acl=/api/1/1/0/5/6/0/0563ec4e57aeb9c730d2fa983d76c6b2.mp3*~data=user_id=0,application_id=42~hmac=3bf386c60de57c2aac788420dc8bfa775641eb869f62618bc6e66a649f1024a8",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/266f01f1c7a04843d11cd08f9c07d11f/250x250-000000-80-0-0.jpg",
    genre: "Alternative",
  },
  {
    title: "Learn to Fly",
    artist: "Foo Fighters",
    id: 4311599,
    release_date: "1999-10-18",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/7/e/8/0/7e8382266519e65aec826ade2107849e.mp3?hdnea=exp=1763730761~acl=/api/1/1/7/e/8/0/7e8382266519e65aec826ade2107849e.mp3*~data=user_id=0,application_id=42~hmac=dbdb5fe4183ef99ceb8300e9f818b407999540664b88c14ef73950b2e42af091",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/266f01f1c7a04843d11cd08f9c07d11f/250x250-000000-80-0-0.jpg",
    genre: "Alternative",
  },
  {
    title: "Do You Want To",
    artist: "Franz Ferdinand",
    id: 4315297,
    release_date: "2005-10-03",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/9/1/1/0/911cfa30045a34e182bf6707a07a024e.mp3?hdnea=exp=1763730761~acl=/api/1/1/9/1/1/0/911cfa30045a34e182bf6707a07a024e.mp3*~data=user_id=0,application_id=42~hmac=0b1351f4b3427a0a040d943a3185dedd1bcb28fe8c81498a0fde1b612e9e182e",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/bdc6f51d05880072275b2e1eefc907ba/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "I Bet You Look Good On The Dancefloor",
    artist: "Arctic Monkeys",
    id: 4315310,
    release_date: "2006-01-29",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/6/6/7/0/667973ef99272d4622145ddddd4f1201.mp3?hdnea=exp=1763730761~acl=/api/1/1/6/6/7/0/667973ef99272d4622145ddddd4f1201.mp3*~data=user_id=0,application_id=42~hmac=ab9ad966baae52f353a8f04fafe9d82aef50a9b326a3213d78982464f6fb48ff",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/f7a0a1ca91431861989efe5a22aad557/250x250-000000-80-0-0.jpg",
    genre: "Alternative",
  },
  {
    title: "When The Sun Goes Down",
    artist: "Arctic Monkeys",
    id: 4315319,
    release_date: "2006-01-29",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/f/f/6/0/ff639e85a24b793f1fc05d6a037809b1.mp3?hdnea=exp=1763730761~acl=/api/1/1/f/f/6/0/ff639e85a24b793f1fc05d6a037809b1.mp3*~data=user_id=0,application_id=42~hmac=e4cdc989b7c2dd48d6939a384bcb7a2e8f510802de95399c17ab3f91c5e275b0",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/f7a0a1ca91431861989efe5a22aad557/250x250-000000-80-0-0.jpg",
    genre: "Alternative",
  },
  {
    title: "Brianstorm",
    artist: "Arctic Monkeys",
    id: 4315378,
    release_date: "2007-04-22",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/e/2/5/0/e25582132cf097d9dc673e7b014404f6.mp3?hdnea=exp=1763730761~acl=/api/1/1/e/2/5/0/e25582132cf097d9dc673e7b014404f6.mp3*~data=user_id=0,application_id=42~hmac=939e5cc5fa6b6b1926c2f45dc7227f4cbda7b31029784c3a80b5deed4881cebd",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/d7a4f9f1af8736457de34f28d50ef496/250x250-000000-80-0-0.jpg",
    genre: "Alternative",
  },
  {
    title: "Fluorescent Adolescent",
    artist: "Arctic Monkeys",
    id: 4315382,
    release_date: "2007-04-22",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/e/f/7/0/ef7220044ffe85c636aa2abbe0fafec3.mp3?hdnea=exp=1763730761~acl=/api/1/1/e/f/7/0/ef7220044ffe85c636aa2abbe0fafec3.mp3*~data=user_id=0,application_id=42~hmac=43ec329e4d939469b94c708c28cf1c08fb3b323601133df384b6fdafe7a407f0",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/d7a4f9f1af8736457de34f28d50ef496/250x250-000000-80-0-0.jpg",
    genre: "Alternative",
  },
  {
    title: "Crying Lightning",
    artist: "Arctic Monkeys",
    id: 4315578,
    release_date: "2009-08-20",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/3/6/a/0/36a7cc7ad3bd6a5c0b2956fe5b97b161.mp3?hdnea=exp=1763730761~acl=/api/1/1/3/6/a/0/36a7cc7ad3bd6a5c0b2956fe5b97b161.mp3*~data=user_id=0,application_id=42~hmac=34bbf9c572422e24c6a5b970ad3a0d23ef7b9fb08bb1fc53bdcc9de0eb6e68c3",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/13cdeb23547351f3ea543a2f5b4b9a4b/250x250-000000-80-0-0.jpg",
    genre: "Alternative",
  },
  {
    title: "Take Me Out",
    artist: "Franz Ferdinand",
    id: 4315684,
    release_date: "2004-02-16",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/a/8/3/0/a83b89c2a51d71e1ba168c4bd74d3c1e.mp3?hdnea=exp=1763730761~acl=/api/1/1/a/8/3/0/a83b89c2a51d71e1ba168c4bd74d3c1e.mp3*~data=user_id=0,application_id=42~hmac=4b65b962a610a6f36ed53e839e0c809a028975220313002c28c8fec67fa5906f",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/a45459c60f8e8b809c701a22b445b6c3/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Home",
    artist: "Michael Bublé",
    id: 4368120,
    release_date: "2005-02-08",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/3/d/1/0/3d1321b02b93777660320cb571d45d87.mp3?hdnea=exp=1763730761~acl=/api/1/1/3/d/1/0/3d1321b02b93777660320cb571d45d87.mp3*~data=user_id=0,application_id=42~hmac=8774afd3e71c1aecfea79b81b4530427b2ed84bcd6d11a3fe503fa800b8390a5",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/82adbd44bbe338520d8dfd815524dfaa/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "22",
    artist: "Lily Allen",
    id: 4530801,
    release_date: "2008-12-02",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/1/b/7/0/1b71514164860ba071854929f8bf1806.mp3?hdnea=exp=1763730761~acl=/api/1/1/1/b/7/0/1b71514164860ba071854929f8bf1806.mp3*~data=user_id=0,application_id=42~hmac=04ec87cc8715a617cf7394b0a6f57cd0c0b16f59751f54ee8f74bbf1a516a9ca",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/6d9b52cac00fd43603bec19b40a0ffc3/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Hate It Or Love It",
    artist: "The Game",
    id: 4586924,
    release_date: "2005-01-13",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/1/5/1/0/151590e64be3cde7abe60dcd3024b5df.mp3?hdnea=exp=1763730761~acl=/api/1/1/1/5/1/0/151590e64be3cde7abe60dcd3024b5df.mp3*~data=user_id=0,application_id=42~hmac=984da47f763c66da113393b9fc2f396b5703483a23be755e9dd7859cb2c62563",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/77812f497bc35690f4dab2269cd76424/250x250-000000-80-0-0.jpg",
    genre: "Rap/Hip Hop",
  },
  {
    title: "How We Do",
    artist: "The Game",
    id: 4586926,
    release_date: "2005-01-13",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/b/1/c/0/b1c599589ff1215a6390ad88b1a85614.mp3?hdnea=exp=1763730761~acl=/api/1/1/b/1/c/0/b1c599589ff1215a6390ad88b1a85614.mp3*~data=user_id=0,application_id=42~hmac=f8f2b945ac608483f3d0c5a7014cd43ff9b93e08a01a185a272c3c7b51a8eec4",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/77812f497bc35690f4dab2269cd76424/250x250-000000-80-0-0.jpg",
    genre: "Rap/Hip Hop",
  },
  {
    title: "Boom Boom Pow",
    artist: "The Black Eyed Peas",
    id: 4619462,
    release_date: "2009-10-26",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/4/8/8/0/488632bf53faf8960cfeb3a23ea7ed96.mp3?hdnea=exp=1763730761~acl=/api/1/1/4/8/8/0/488632bf53faf8960cfeb3a23ea7ed96.mp3*~data=user_id=0,application_id=42~hmac=0518f271920d7c0d80b86f35ceabab9f0fba9495dafe258092bd37e2b5a38111",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/ea30377840f4ef9ac62406c5e16e9c4b/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Meet Me Halfway",
    artist: "The Black Eyed Peas",
    id: 4619464,
    release_date: "2009-06-08",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/9/9/0/0/990f36445579c48c123d941d9a021494.mp3?hdnea=exp=1763730761~acl=/api/1/1/9/9/0/0/990f36445579c48c123d941d9a021494.mp3*~data=user_id=0,application_id=42~hmac=c2588893200e642aaa4894c952c2f10038a7908013261cfa9278a206b3d9d734",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/ea30377840f4ef9ac62406c5e16e9c4b/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Somewhere Only We Know",
    artist: "Keane",
    id: 2317363,
    release_date: "2009-11-09",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/7/c/3/0/7c3c1d285fd85240236a55685de81228.mp3?hdnea=exp=1763731676~acl=/api/1/1/7/c/3/0/7c3c1d285fd85240236a55685de81228.mp3*~data=user_id=0,application_id=42~hmac=f6966c84781e86fd99f9fe5eddd55292ae06f56c7d8790ef2ad470f138688aa7",
    cover: "https://api.deezer.com/album/230778/image",
    genre: "Pop",
  },
  {
    title: "Love Story",
    artist: "Taylor Swift",
    id: 4634579,
    release_date: "2009-11-16",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/a/f/3/0/af326f77729a2acb34330b5e7d7c76c9.mp3?hdnea=exp=1763730761~acl=/api/1/1/a/f/3/0/af326f77729a2acb34330b5e7d7c76c9.mp3*~data=user_id=0,application_id=42~hmac=0b781933817c1140f8272f412a39e3044dae093952d0b02254b1f325bdf0c22e",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/58d23fd7cd3456d59e946f3e8bacb1bd/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "You Belong With Me",
    artist: "Taylor Swift",
    id: 4634582,
    release_date: "2009-11-16",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/2/3/6/0/2361881f93ec08afc1637455aca36dd0.mp3?hdnea=exp=1763730761~acl=/api/1/1/2/3/6/0/2361881f93ec08afc1637455aca36dd0.mp3*~data=user_id=0,application_id=42~hmac=da2f3314aa28d4ae44197e493424ed2194638a1fa308dcff7805e1eadd98d58b",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/58d23fd7cd3456d59e946f3e8bacb1bd/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Dip It Low",
    artist: "Christina Milian",
    id: 4639613,
    release_date: "2004-02-02",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/e/7/6/0/e7658628a6e2bed6c83e93e659135a3e.mp3?hdnea=exp=1763730761~acl=/api/1/1/e/7/6/0/e7658628a6e2bed6c83e93e659135a3e.mp3*~data=user_id=0,application_id=42~hmac=330250d5bd20de34d75591d7d9162b1986c1530621e75904c5d921fafe297168",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/67013a63761b59dbc7dd7d08577f022c/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Te Amo (Album Version)",
    artist: "Rihanna",
    id: 4670276,
    release_date: "2009-11-23",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/2/0/7/0/207f0e239edc585b1a5c69fd4fb0f7a6.mp3?hdnea=exp=1763730761~acl=/api/1/1/2/0/7/0/207f0e239edc585b1a5c69fd4fb0f7a6.mp3*~data=user_id=0,application_id=42~hmac=ca47607b14cc5afcee81c6685f6b7bbcf0cc2b0aa5d4deb717b5bc9cfcd35d2e",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/af82bfab0277506de1d91c3f9d2e28c3/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Bad Romance",
    artist: "Lady Gaga",
    id: 4709937,
    release_date: "2009-11-23",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/0/3/b/0/03b88d2b81b503db09c4590d80aa3be8.mp3?hdnea=exp=1763730761~acl=/api/1/1/0/3/b/0/03b88d2b81b503db09c4590d80aa3be8.mp3*~data=user_id=0,application_id=42~hmac=dd2334a19b1545f688edae46f2c0f9e436169929efc590e4e0273781d8658cc3",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/62f368993ddb68c5364cd03221d07ac6/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Paparazzi",
    artist: "Lady Gaga",
    id: 4709950,
    release_date: "2009-11-23",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/7/2/1/0/72124291383192f420c1a46c0fa014df.mp3?hdnea=exp=1763730761~acl=/api/1/1/7/2/1/0/72124291383192f420c1a46c0fa014df.mp3*~data=user_id=0,application_id=42~hmac=ea3e80b2ed4227892aa778dd8d74cc56a4110b4a20aae4ad24a60bcd6aa5258a",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/62f368993ddb68c5364cd03221d07ac6/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Wrap Me Up (Original Mix)",
    artist: "Alex Party",
    id: 4955228,
    release_date: "2009-12-16",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/e/9/4/0/e9402976e793cf3f46621ee039c721a1.mp3?hdnea=exp=1763730761~acl=/api/1/1/e/9/4/0/e9402976e793cf3f46621ee039c721a1.mp3*~data=user_id=0,application_id=42~hmac=0482e9ca3fd5994746b194794a54242c131a2081a0fcf966dec5e6d17065b84b",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/19d56728f53c6791c62d09f44a87029d/250x250-000000-80-0-0.jpg",
    genre: "Dance",
  },
  {
    title: "All The Small Things",
    artist: "blink-182",
    id: 5059907,
    release_date: "1996-06-24",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/e/5/5/0/e55e8a7d6c519ebed116ab380abe4292.mp3?hdnea=exp=1763730761~acl=/api/1/1/e/5/5/0/e55e8a7d6c519ebed116ab380abe4292.mp3*~data=user_id=0,application_id=42~hmac=0080d0b73cbc9bb4507b9e84118eb5e21f89b7c3f8fb44355c86656986c4d13f",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/c3df0e187221bbb3717fde50164d3a58/250x250-000000-80-0-0.jpg",
    genre: "Kids",
  },
  {
    title: "BedRock",
    artist: "Young Money",
    id: 5060034,
    release_date: "2009-12-21",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/5/9/f/0/59fff5ab37011243cf43158c2484e617.mp3?hdnea=exp=1763730761~acl=/api/1/1/5/9/f/0/59fff5ab37011243cf43158c2484e617.mp3*~data=user_id=0,application_id=42~hmac=c2a351168708a62298a3aa60c681219890c8bfbb834536ad962f909e05ad5f23",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/20ba560a4e6fd95147a782984320894f/250x250-000000-80-0-0.jpg",
    genre: "Rap/Hip Hop",
  },
  {
    title: "I Write Sins Not Tragedies",
    artist: "Panic! At The Disco",
    id: 5094040,
    release_date: "2005-09-27",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/4/1/6/0/4161d7491bd211c082d572e24b943b6b.mp3?hdnea=exp=1763730761~acl=/api/1/1/4/1/6/0/4161d7491bd211c082d572e24b943b6b.mp3*~data=user_id=0,application_id=42~hmac=fe21c508e21b112958a643ff629585176a6610bfb5482209170b719ef1f2fe33",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/12f418509c1f4fecca36b80c1432019a/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "Whatcha Say",
    artist: "Jason Derulo",
    id: 5420471,
    release_date: "2010-02-26",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/4/f/0/0/4f06439e37340676ee928aa6c852adfc.mp3?hdnea=exp=1763730761~acl=/api/1/1/4/f/0/0/4f06439e37340676ee928aa6c852adfc.mp3*~data=user_id=0,application_id=42~hmac=f82e1897c6d9111cfb3ad259a7c754f349a667313876302af757c38b71150218",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/27386b7a34a432c964078d3cff59cf6f/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Don't Walk Away",
    artist: "Jade",
    id: 5617992,
    release_date: "1992-11-13",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/d/d/a/0/dda2fdc93ac2bb3849d5f9ffd6599d08.mp3?hdnea=exp=1763730761~acl=/api/1/1/d/d/a/0/dda2fdc93ac2bb3849d5f9ffd6599d08.mp3*~data=user_id=0,application_id=42~hmac=d11874a93dbbef5cfc87b0a76ed02e8741a1ea817d52b4488265e1ff33c03015",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/059707c9b249ce3e89b99c2fde9c6878/250x250-000000-80-0-0.jpg",
    genre: "Dance",
  },
  {
    title: "Round and Round (Soul Mix Edit)",
    artist: "Tevin Campbell",
    id: 5619144,
    release_date: "1991-11-15",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/0/6/b/0/06b0ca15d9fd21e1b23360d6e7f507db.mp3?hdnea=exp=1763730761~acl=/api/1/1/0/6/b/0/06b0ca15d9fd21e1b23360d6e7f507db.mp3*~data=user_id=0,application_id=42~hmac=9cd10808751ae160f5bb2f3f394f5d2ec51faec89da5b1021860505ccacd18e8",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/764a227f147a9e2078de69992fa445e5/250x250-000000-80-0-0.jpg",
    genre: "R&B",
  },
  {
    title: "I'm Too Sexy",
    artist: "Right Said Fred",
    id: 2625962812,
    release_date: "1992-01-07",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/5/c/0/0/5c09da5f2e5df00ed802daf4d6334ec2.mp3?hdnea=exp=1763731676~acl=/api/1/1/5/c/0/0/5c09da5f2e5df00ed802daf4d6334ec2.mp3*~data=user_id=0,application_id=42~hmac=8e0aff345d217102e9ac6fdd2609baf52a719225ecd4f690ddad57904e5e7f45",
    cover: "https://api.deezer.com/album/536650072/image",
    genre: "Electro",
  },
  {
    title: "Independent Women, Pt. 1",
    artist: "Destiny's Child",
    id: 5817088,
    release_date: "2001-01-01",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/0/9/0/0/0904380099778d8f542fad0b15dd493e.mp3?hdnea=exp=1763730762~acl=/api/1/1/0/9/0/0/0904380099778d8f542fad0b15dd493e.mp3*~data=user_id=0,application_id=42~hmac=74d7223bbcf93c89bc18fe99cfb21516f3835665f03ede86c22c09d97a45ea0b",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/6569bbc2ccd786c051555084ebc9b355/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Pictures Of You",
    artist: "The Cure",
    id: 6215171,
    release_date: "1989-05-24",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/a/8/4/0/a8481118ab1050572cff39671318d755.mp3?hdnea=exp=1763730762~acl=/api/1/1/a/8/4/0/a8481118ab1050572cff39671318d755.mp3*~data=user_id=0,application_id=42~hmac=cfd5f5e41dae2edf5313a46668fd5e9a52d0d6fca8f6d6e2eda3f03b61ae093c",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/413833519b93fda0a2e4b148d2f04efa/250x250-000000-80-0-0.jpg",
    genre: "Alternative",
  },
  {
    title: "Sometimes When We Touch",
    artist: "Newton",
    id: 6247405,
    release_date: "2009-10-05",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/d/d/4/0/dd41a8de5961014bf5754ebe7cb0eb66.mp3?hdnea=exp=1763730762~acl=/api/1/1/d/d/4/0/dd41a8de5961014bf5754ebe7cb0eb66.mp3*~data=user_id=0,application_id=42~hmac=5218efe9916ee91b058563f7947aa5c942b5e55d9cc122743e7b0fbb35bc1b4f",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/c4fe0e7a9c4c84e10310a4a5d30edfef/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Dear Maria, Count Me In",
    artist: "All Time Low",
    id: 6249577,
    release_date: "2007-09-25",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/f/7/6/0/f761524a925388fffc58005e86f8de29.mp3?hdnea=exp=1763730762~acl=/api/1/1/f/7/6/0/f761524a925388fffc58005e86f8de29.mp3*~data=user_id=0,application_id=42~hmac=5bda656eee024dc5f2e3dd98bcf0b710c9642ba3278d1cef9383c03b8b6461f8",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/acab0eec4dca657129907a8cac083645/250x250-000000-80-0-0.jpg",
    genre: "Alternative",
  },
  {
    title: "Replay",
    artist: "Iyaz",
    id: 6276158,
    release_date: "2009-08-18",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/9/d/4/0/9d4195f7b83bdae5bd9d695d3335fb09.mp3?hdnea=exp=1763730762~acl=/api/1/1/9/d/4/0/9d4195f7b83bdae5bd9d695d3335fb09.mp3*~data=user_id=0,application_id=42~hmac=c675045cf23fd1aef87e802481adb04901c3e4e2068af1c77b1205204835f461",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/e10ea1c02a800e48c6bb3572bd661102/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Got To Have Your Love",
    artist: "Mantronix",
    id: 6283556,
    release_date: "1989-06-19",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/9/a/5/0/9a5eb5dc6bde516f5cd197d3accdfe33.mp3?hdnea=exp=1763730762~acl=/api/1/1/9/a/5/0/9a5eb5dc6bde516f5cd197d3accdfe33.mp3*~data=user_id=0,application_id=42~hmac=08a3e0ab67001c42b9fc13b55fc0f34c1ec6fd7dd9d0a15331a3afad7e185d85",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/9a137ade09e14a5bccf032627b616e0f/250x250-000000-80-0-0.jpg",
    genre: "Rap/Hip Hop",
  },
  {
    title: "Crying in the Rain",
    artist: "a-ha",
    id: 6463613,
    release_date: "1986-03-13",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/0/a/c/0/0acd145a3737485a77deb593a5f65355.mp3?hdnea=exp=1763731676~acl=/api/1/1/0/a/c/0/0acd145a3737485a77deb593a5f65355.mp3*~data=user_id=0,application_id=42~hmac=47f624fd5e75d999b1cd7de73e2156fa0b843b2b11541db5775fd0792225b99a",
    cover: "https://api.deezer.com/album/595462/image",
    genre: "Pop",
  },
  {
    title: "Don't Give Up",
    artist: "Chicane",
    id: 6467783,
    release_date: "2008-10-06",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/9/b/6/0/9b62c9cfd341995b9b9e90cbc16c136c.mp3?hdnea=exp=1763731676~acl=/api/1/1/9/b/6/0/9b62c9cfd341995b9b9e90cbc16c136c.mp3*~data=user_id=0,application_id=42~hmac=bf2eb1787c7c2893e7bcdd44da8799a07a6855dc545e1578ac491ffbf6e64808",
    cover: "https://api.deezer.com/album/595997/image",
    genre: "Electro",
  },
  {
    title: "Escapade",
    artist: "Janet Jackson",
    id: 6575395,
    release_date: "1989-01-17",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/b/d/8/0/bd8a35e556e5b81dcb83269784c97e6d.mp3?hdnea=exp=1763731676~acl=/api/1/1/b/d/8/0/bd8a35e556e5b81dcb83269784c97e6d.mp3*~data=user_id=0,application_id=42~hmac=081549f27dff923f87b78ef6f8431cb630f3b1671621f8d80efee47c869f9eb1",
    cover: "https://api.deezer.com/album/607854/image",
    genre: "Pop",
  },
  {
    title: "Black Cat",
    artist: "Janet Jackson",
    id: 6575397,
    release_date: "1989-08-20",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/7/0/d/0/70dc9e578d91644f8a64367710cc004b.mp3?hdnea=exp=1763731676~acl=/api/1/1/7/0/d/0/70dc9e578d91644f8a64367710cc004b.mp3*~data=user_id=0,application_id=42~hmac=d5bb854e4b74e2541cb8694a027692ec39db4650489e43c0015664b2f1839dad",
    cover: "https://api.deezer.com/album/607854/image",
    genre: "Pop",
  },
  {
    title: "Come Back To Me",
    artist: "Janet Jackson",
    id: 6575399,
    release_date: "1989-01-23",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/9/9/9/0/9994aa2bcdfdca990060d9da3ae2f794.mp3?hdnea=exp=1763731676~acl=/api/1/1/9/9/9/0/9994aa2bcdfdca990060d9da3ae2f794.mp3*~data=user_id=0,application_id=42~hmac=e211fe89c16411f49d47b483bbf269d63bedfd8292b0614daca23d6d41895305",
    cover: "https://api.deezer.com/album/607854/image",
    genre: "Pop",
  },
  {
    title: "Never Let You Go",
    artist: "Third Eye Blind",
    id: 6586756,
    release_date: "1999-11-23",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/8/1/e/0/81e0f522525f4629dab00b7beb044254.mp3?hdnea=exp=1763731676~acl=/api/1/1/8/1/e/0/81e0f522525f4629dab00b7beb044254.mp3*~data=user_id=0,application_id=42~hmac=55e2ef2d2284d1285cee70802f24a110593acca25560794706f86fa4bf09c801",
    cover: "https://api.deezer.com/album/608919/image",
    genre: "Pop",
  },
  {
    title: "Bleed It Out",
    artist: "Linkin Park",
    id: 6611048,
    release_date: "2007-05-14",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/0/f/7/0/0f7d0eaa4440eaea386c7ed66d5c9a86.mp3?hdnea=exp=1763731676~acl=/api/1/1/0/f/7/0/0f7d0eaa4440eaea386c7ed66d5c9a86.mp3*~data=user_id=0,application_id=42~hmac=1d3f498b9f1e798110db651a756cd3028b4ac9c76bd1995ad187505c3e6c4cc4",
    cover: "https://api.deezer.com/album/611222/image",
    genre: "Alternative",
  },
  {
    title: "Boulevard of Broken Dreams",
    artist: "Green Day",
    id: 6611231,
    release_date: "2009-06-16",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/4/9/c/0/49c71c37f91c8280512ba6c5cef9d328.mp3?hdnea=exp=1763731676~acl=/api/1/1/4/9/c/0/49c71c37f91c8280512ba6c5cef9d328.mp3*~data=user_id=0,application_id=42~hmac=c9d64f755a220a3659859556aff48247478a8ae78676605cfc7c0e25e5b627dd",
    cover: "https://api.deezer.com/album/611243/image",
    genre: "Alternative",
  },
  {
    title: "Show Me Love",
    artist: "Robin S",
    id: 6628158,
    release_date: "1993-06-15",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/e/6/6/0/e66a3f6c1588d9bc3571bc47a69f4fc9.mp3?hdnea=exp=1763731676~acl=/api/1/1/e/6/6/0/e66a3f6c1588d9bc3571bc47a69f4fc9.mp3*~data=user_id=0,application_id=42~hmac=5d2d0180a74e2a0d737de89fcff495d33646a0e3e4dc57afc06439ba040a9d41",
    cover: "https://api.deezer.com/album/612921/image",
    genre: "Pop",
  },
  {
    title: "Bust It Baby, Pt. 2 (feat. Ne-Yo)",
    artist: "Plies",
    id: 6639947,
    release_date: "2008-06-10",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/d/7/7/0/d77c4f2c16baf4d2eecd50a39b4c43cf.mp3?hdnea=exp=1763731676~acl=/api/1/1/d/7/7/0/d77c4f2c16baf4d2eecd50a39b4c43cf.mp3*~data=user_id=0,application_id=42~hmac=d45ce16a3d337f2e0431630db7163f2f36217804828df3a1cd7ba21c4ca52fd6",
    cover: "https://api.deezer.com/album/614022/image",
    genre: "Rap/Hip Hop",
  },
  {
    title: "Better Days (And the Bottom Drops Out)",
    artist: "Citizen King",
    id: 6640921,
    release_date: "1999-02-26",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/1/9/d/0/19d92635dd257777568e4223035b4f20.mp3?hdnea=exp=1763731676~acl=/api/1/1/1/9/d/0/19d92635dd257777568e4223035b4f20.mp3*~data=user_id=0,application_id=42~hmac=3491d6719c3fa3a63719855862bea0ce2c6e655e38e5a867ec9db46a0473d768",
    cover: "https://api.deezer.com/album/614144/image",
    genre: "Rap/Hip Hop",
  },
  {
    title: "Breathe",
    artist: "Faith Hill",
    id: 6641040,
    release_date: "1999-11-09",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/4/a/d/0/4ad197b9369e1b711c3679baf4e277bc.mp3?hdnea=exp=1763731676~acl=/api/1/1/4/a/d/0/4ad197b9369e1b711c3679baf4e277bc.mp3*~data=user_id=0,application_id=42~hmac=29eb9c30541a767f262a59262129e9983d5fca32a07f9489e140ef7d9023c88a",
    cover: "https://api.deezer.com/album/614154/image",
    genre: "Country",
  },
  {
    title: "Don't Stop Movin'",
    artist: "S Club 7",
    id: 6789702,
    release_date: "2010-07-12",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/e/f/f/0/effd0d0af86a7be00fbefee6088ab555.mp3?hdnea=exp=1763731676~acl=/api/1/1/e/f/f/0/effd0d0af86a7be00fbefee6088ab555.mp3*~data=user_id=0,application_id=42~hmac=9b98e139fb5f7b4844cc0be33d264c83325883fddd63f86fa5cf0a1dac1b0e8b",
    cover: "https://api.deezer.com/album/627268/image",
    genre: "Pop",
  },
  {
    title: "Pure & Simple",
    artist: "Hear'Say",
    id: 6789707,
    release_date: "2001-03-12",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/a/b/b/0/abb1b2a48915d81308bb15017664806f.mp3?hdnea=exp=1763731676~acl=/api/1/1/a/b/b/0/abb1b2a48915d81308bb15017664806f.mp3*~data=user_id=0,application_id=42~hmac=08819f84682bd43841afe2779d09de097f06a1781c75b8c8fd88a07c8c31ccf3",
    cover: "https://api.deezer.com/album/627268/image",
    genre: "Pop",
  },
  {
    title: "E.T.",
    artist: "Katy Perry",
    id: 6812365,
    release_date: "2010-08-27",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/9/e/1/0/9e12c257b887368423ec2b08f4a8c00f.mp3?hdnea=exp=1763731676~acl=/api/1/1/9/e/1/0/9e12c257b887368423ec2b08f4a8c00f.mp3*~data=user_id=0,application_id=42~hmac=4997f9c0a9cfad9d20f029a9d6fe5c8fa1cc5bfa28b308c8fad39d7ece394efb",
    cover: "https://api.deezer.com/album/629078/image",
    genre: "Rock",
  },
  {
    title: "Rise",
    artist: "Gabrielle",
    id: 6824033,
    release_date: "1999-05-25",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/d/c/d/0/dcdd9d300c1913645d9dc8e3f0c874d5.mp3?hdnea=exp=1763731676~acl=/api/1/1/d/c/d/0/dcdd9d300c1913645d9dc8e3f0c874d5.mp3*~data=user_id=0,application_id=42~hmac=83c03b79c23ecf5127a9f88e04f18b5ba822a8ad6dff84b4c2f85416d05c3308",
    cover: "https://api.deezer.com/album/241947/image",
    genre: "Pop",
  },
  {
    title: "Flowers (Sunship Edit)",
    artist: "Sweet Female Attitude",
    id: 7238967,
    release_date: "2000-03-13",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/3/f/e/0/3fe662c089829fa47c97ae2a16afaaf9.mp3?hdnea=exp=1763731676~acl=/api/1/1/3/f/e/0/3fe662c089829fa47c97ae2a16afaaf9.mp3*~data=user_id=0,application_id=42~hmac=1c57ccf5494be8fdf7d5ba5091cd4b22e0cf8e5e5ce75f31d61e24d876a87bb9",
    cover: "https://api.deezer.com/album/667925/image",
    genre: "Pop",
  },
  {
    title: "Right Now (Na Na Na)",
    artist: "Akon",
    id: 2675166,
    release_date: "2008-12-01",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/2/3/2/0/232dda9f84df5e34b6ee2183ff6c9ec3.mp3?hdnea=exp=1763731676~acl=/api/1/1/2/3/2/0/232dda9f84df5e34b6ee2183ff6c9ec3.mp3*~data=user_id=0,application_id=42~hmac=5ceafa8ee26546413beb997a2fc408f8e1484272582bed6d6b6f0f1e36e5126b",
    cover: "https://api.deezer.com/album/259312/image",
    genre: "R&B",
  },
  {
    title: "My Place",
    artist: "Nelly",
    id: 7278730,
    release_date: "2005-11-22",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/f/4/1/0/f41f27427451f92899b6e7a800e7b3f9.mp3?hdnea=exp=1763731676~acl=/api/1/1/f/4/1/0/f41f27427451f92899b6e7a800e7b3f9.mp3*~data=user_id=0,application_id=42~hmac=995c5ba5958953af2fd8bd1f5b41ad3b050aeface1802c31b733f3bc6420a96f",
    cover: "https://api.deezer.com/album/671768/image",
    genre: "Rap/Hip Hop",
  },
  {
    title: "Ride Wit Me",
    artist: "Nelly",
    id: 7292333,
    release_date: "2000-03-10",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/1/7/9/0/179fddc0b5aecf9ebb8f8cef3345925a.mp3?hdnea=exp=1763731676~acl=/api/1/1/1/7/9/0/179fddc0b5aecf9ebb8f8cef3345925a.mp3*~data=user_id=0,application_id=42~hmac=4b2cddde88c24065b275cded333301591e73f95a01eced7b9e247584083ba50c",
    cover: "https://api.deezer.com/album/673093/image",
    genre: "Pop",
  },
  {
    title: "I Hate This Part",
    artist: "The Pussycat Dolls",
    id: 619976932,
    release_date: "2009-04-13",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/9/7/6/0/9768f240f73ae722c0ad9e7603c5c5d9.mp3?hdnea=exp=1763731676~acl=/api/1/1/9/7/6/0/9768f240f73ae722c0ad9e7603c5c5d9.mp3*~data=user_id=0,application_id=42~hmac=a7643de1d64d9a421f6e660deaf513a444a6a0ac969bc1c0fedbcfb6675a1458",
    cover: "https://api.deezer.com/album/84882522/image",
    genre: "Pop",
  },
  {
    title: "Loca",
    artist: "Shakira",
    id: 7365619,
    release_date: "2010-10-18",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/9b7ae6b468322bb9a1acc6a02eedadd8/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Show Me The Way",
    artist: "Styx",
    id: 7374163,
    release_date: "1975-01-01",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/4/7/a/0/47a4f7981a9ccb4a063871f6221e725d.mp3?hdnea=exp=1763731676~acl=/api/1/1/4/7/a/0/47a4f7981a9ccb4a063871f6221e725d.mp3*~data=user_id=0,application_id=42~hmac=eac818fb3dbd912d7732e9e4fbdabb007a5d9fd866d088572f6e732aa959d8db",
    cover: "https://api.deezer.com/album/680291/image",
    genre: "Rock",
  },
  {
    title: "Pump It",
    artist: "The Black Eyed Peas",
    id: 7375556,
    release_date: "2005-02-14",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/e/c/1/0/ec1ae3b55ed18838b0aaf7ad6bc45df8.mp3?hdnea=exp=1763731676~acl=/api/1/1/e/c/1/0/ec1ae3b55ed18838b0aaf7ad6bc45df8.mp3*~data=user_id=0,application_id=42~hmac=a6e2dcee249db8aacd543d67941661ba05044677caecb35b65c173e1b0503ba6",
    cover: "https://api.deezer.com/album/680407/image",
    genre: "Rap/Hip Hop",
  },
  {
    title: "Is It Any Wonder?",
    artist: "Keane",
    id: 71967082,
    release_date: "2006-09-07",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/7/a/c/0/7ac686413d94c91e6ac247fb82e40a1d.mp3?hdnea=exp=1763731677~acl=/api/1/1/7/a/c/0/7ac686413d94c91e6ac247fb82e40a1d.mp3*~data=user_id=0,application_id=42~hmac=2ea33bec155dbb17f0769b7588e5320ff89375852b2e291025262e044149e4da",
    cover: "https://api.deezer.com/album/7069140/image",
    genre: "Pop",
  },
  {
    title: "Everything You Want",
    artist: "Vertical Horizon",
    id: 7410392,
    release_date: "1999-06-14",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/d/6/a/0/d6a7aae48b986f6a5ab3954dfc163dbd.mp3?hdnea=exp=1763731676~acl=/api/1/1/d/6/a/0/d6a7aae48b986f6a5ab3954dfc163dbd.mp3*~data=user_id=0,application_id=42~hmac=546409299f14e6dcbb5b3dad721177a823c33809fc4447a5381f48076cdf4f3e",
    cover: "https://api.deezer.com/album/683835/image",
    genre: "Pop",
  },
  {
    title: "That Don't Impress Me Much (Album Version)",
    artist: "Shania Twain",
    id: 7442366,
    release_date: "2009-09-22",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/5943f0ad9dabe26cb3ff9f0ca45c611a/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Silent Lucidity",
    artist: "Queensrÿche",
    id: 7459741,
    release_date: "1990-11-05",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/3/f/9/0/3f9055e83588263c10d6d45bb7fdc1b0.mp3?hdnea=exp=1763731676~acl=/api/1/1/3/f/9/0/3f9055e83588263c10d6d45bb7fdc1b0.mp3*~data=user_id=0,application_id=42~hmac=74bed99bab14f4fdd06a768b56ceb3936ba351bd51b427d4c5609fb7ab6edcaf",
    cover: "https://api.deezer.com/album/687998/image",
    genre: "Rock",
  },
  {
    title: "There You Go",
    artist: "P!nk",
    id: 7512050,
    release_date: "2000-02-08",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/6/d/2/0/6d2ddff0010f734bb430b1a07679c10c.mp3?hdnea=exp=1763731677~acl=/api/1/1/6/d/2/0/6d2ddff0010f734bb430b1a07679c10c.mp3*~data=user_id=0,application_id=42~hmac=1b0d0ffe21ee2c5436e9c8850c2a63a489e06d35db87ba75b0fef1cf36a876ec",
    cover: "https://api.deezer.com/album/692684/image",
    genre: "Pop",
  },
  {
    title: "Who Knew",
    artist: "P!nk",
    id: 7512057,
    release_date: "2006-05-18",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/5/1/7/0/5179c104cc8e8d6a18fc57b1b713a9c1.mp3?hdnea=exp=1763731677~acl=/api/1/1/5/1/7/0/5179c104cc8e8d6a18fc57b1b713a9c1.mp3*~data=user_id=0,application_id=42~hmac=2879a9c000a79e66b58b5be21255be415bf4f400774ca2f88a81fa73ad2c6b99",
    cover: "https://api.deezer.com/album/692684/image",
    genre: "Pop",
  },
  {
    title: "Raise Your Glass",
    artist: "P!nk",
    id: 7512065,
    release_date: "2010-11-12",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/1/e/b/0/1eb3e13e7e11e41bbb39a39088ab538e.mp3?hdnea=exp=1763731677~acl=/api/1/1/1/e/b/0/1eb3e13e7e11e41bbb39a39088ab538e.mp3*~data=user_id=0,application_id=42~hmac=4adb842f6a0a424495b8e423c50b82cb88742bab2a638f1faee3ce71829f3500",
    cover: "https://api.deezer.com/album/692684/image",
    genre: "Pop",
  },
  {
    title: "Move Any Mountian",
    artist: "Shamen",
    id: 7517553,
    release_date: "1990-03-01",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/4/e/4/0/4e4603bd47c38188fa9ce6a50ac49eaf.mp3?hdnea=exp=1763731677~acl=/api/1/1/4/e/4/0/4e4603bd47c38188fa9ce6a50ac49eaf.mp3*~data=user_id=0,application_id=42~hmac=32d27ec7154889270791f252f345b63b24fb3c778f026eadb6b4ae03160150ea",
    cover: "https://api.deezer.com/album/693296/image",
    genre: "Alternative",
  },
  {
    title: "Izzo (H.O.V.A.)",
    artist: "JAY-Z",
    id: 7532692,
    release_date: "2001-09-11",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/e/2/f/0/e2fad2e0f3f1dcdfe22bc0cacf9c6dff.mp3?hdnea=exp=1763731677~acl=/api/1/1/e/2/f/0/e2fad2e0f3f1dcdfe22bc0cacf9c6dff.mp3*~data=user_id=0,application_id=42~hmac=2729da26643a720725d20fe81bdd4240adf0238ec701fbb872e824fe14173b1e",
    cover: "https://api.deezer.com/album/694909/image",
    genre: "Rap/Hip Hop",
  },
  {
    title: "I'm Like A Bird",
    artist: "Nelly Furtado",
    id: 7562977,
    release_date: "2000-11-16",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/8/b/b/0/8bb28c0d0387607e4aadca79066a3e1a.mp3?hdnea=exp=1763731677~acl=/api/1/1/8/b/b/0/8bb28c0d0387607e4aadca79066a3e1a.mp3*~data=user_id=0,application_id=42~hmac=f756a725560d093bc8438b86d3c5cf7626192f3dc4eb2abfa6122803e7822b96",
    cover: "https://api.deezer.com/album/697807/image",
    genre: "Pop",
  },
  {
    title: "Over My Head (Cable Car)",
    artist: "The Fray",
    id: 7674864,
    release_date: "2005-10-22",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/3/0/d/0/30d9289a75ee6569b740ed89b11b8330.mp3?hdnea=exp=1763731677~acl=/api/1/1/3/0/d/0/30d9289a75ee6569b740ed89b11b8330.mp3*~data=user_id=0,application_id=42~hmac=5cd1a1e949ed9f3a94fb8e9790415bcefabee638be5e07d586dcc7ce65df14cd",
    cover: "https://api.deezer.com/album/708661/image",
    genre: "Rock",
  },
  {
    title: "How to Save a Life",
    artist: "The Fray",
    id: 7674865,
    release_date: "2005-09-13",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/8/4/2/0/84269d40c23d64a448138d4c772dd936.mp3?hdnea=exp=1763731677~acl=/api/1/1/8/4/2/0/84269d40c23d64a448138d4c772dd936.mp3*~data=user_id=0,application_id=42~hmac=4b374cc450da6e0f54ad185c175fba889802023e6e2610a330ab3ed9fd0c9a23",
    cover: "https://api.deezer.com/album/708661/image",
    genre: "Rock",
  },
  {
    title: "Last Kiss",
    artist: "Pearl Jam",
    id: 7675332,
    release_date: "2003-11-11",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/7/b/b/0/7bb34066c8809d567d519697f69536f0.mp3?hdnea=exp=1763731677~acl=/api/1/1/7/b/b/0/7bb34066c8809d567d519697f69536f0.mp3*~data=user_id=0,application_id=42~hmac=582423c5baf8c05acf6b2a2243ed5a3c6a5d359f63d99c620421dfc3b878fc56",
    cover: "https://api.deezer.com/album/708687/image",
    genre: "Rock",
  },
  {
    title: "I'm Every Woman",
    artist: "Whitney Houston",
    id: 7675405,
    release_date: "1992-11-17",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/0/3/9/0/039bab3b4cfdf897a5f1151376426acc.mp3?hdnea=exp=1763731677~acl=/api/1/1/0/3/9/0/039bab3b4cfdf897a5f1151376426acc.mp3*~data=user_id=0,application_id=42~hmac=d3eaea12851f895e42a3c1a97aa3629bb3ae6fdfb98f157b33a7a85bf2947011",
    cover: "https://api.deezer.com/album/708692/image",
    genre: "Films/Games",
  },
  {
    title: "The Time (Dirty Bit)",
    artist: "The Black Eyed Peas",
    id: 7705885,
    release_date: "2010-11-30",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/4/b/4/0/4b486b680bd6351011600f95ccfff95a.mp3?hdnea=exp=1763731677~acl=/api/1/1/4/b/4/0/4b486b680bd6351011600f95ccfff95a.mp3*~data=user_id=0,application_id=42~hmac=397b3b3eb58c9372531e32311bc9aceec1b8c1cf3cf8f645ff4f58d52e56be86",
    cover: "https://api.deezer.com/album/711456/image",
    genre: "Pop",
  },
  {
    title: "Who's That Chick? (feat. Rihanna)",
    artist: "David Guetta",
    id: 7754536,
    release_date: "2010-12-06",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/7/0/9/0/70974e90cd0e7c05b2606d48de21373c.mp3?hdnea=exp=1763731677~acl=/api/1/1/7/0/9/0/70974e90cd0e7c05b2606d48de21373c.mp3*~data=user_id=0,application_id=42~hmac=0744bef0634ce65c493ee2b47607a71e134d17a8c6f17ddc0656ccaec4b1ebec",
    cover: "https://api.deezer.com/album/715839/image",
    genre: "Dance",
  },
  {
    title: "Steal My Sunshine",
    artist: "LEN",
    id: 7779493,
    release_date: "1999-05-31",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/3/1/0/0/31075bb6b763a8a2a1b1751a0373cbc5.mp3?hdnea=exp=1763731677~acl=/api/1/1/3/1/0/0/31075bb6b763a8a2a1b1751a0373cbc5.mp3*~data=user_id=0,application_id=42~hmac=477ed7483967744d82a9a39954029005914e8e96a5a14fb17f9acc205625ef1c",
    cover: "https://api.deezer.com/album/718235/image",
    genre: "Pop",
  },
  {
    title: "Coming Home",
    artist: "Diddy - Dirty Money",
    id: 7857290,
    release_date: "2010-12-10",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/4a194b74602666dfe41269619ea6713e/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Stop Me (feat. Daniel Merriweather)",
    artist: "Mark Ronson",
    id: 7923754,
    release_date: "2007-04-16",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/6/e/1/0/6e159fbb446d78c1d8fb8b10021f0b11.mp3?hdnea=exp=1763731677~acl=/api/1/1/6/e/1/0/6e159fbb446d78c1d8fb8b10021f0b11.mp3*~data=user_id=0,application_id=42~hmac=54d30e455c40d673fc2e7d4679e9bbce2d80344721fa45c096d940dd483fa76a",
    cover: "https://api.deezer.com/album/731280/image",
    genre: "Pop",
  },
  {
    title: "Valerie (feat. Amy Winehouse) (Version Revisited)",
    artist: "Mark Ronson",
    id: 7923756,
    release_date: "2007-04-16",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/1/d/2/0/1d2abe863e60afb472b52986795bd3f8.mp3?hdnea=exp=1763731677~acl=/api/1/1/1/d/2/0/1d2abe863e60afb472b52986795bd3f8.mp3*~data=user_id=0,application_id=42~hmac=73022a2c6affd186ac14a76618de5d9ef06a24a7c1c64454fe397fc9d36ea7a5",
    cover: "https://api.deezer.com/album/731280/image",
    genre: "Pop",
  },
  {
    title: "The Lazy Song",
    artist: "Bruno Mars",
    id: 8011853,
    release_date: "2010-10-05",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/5b59dc18e109515420f8237719bd2186/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "(Mucho Mambo) Sway",
    artist: "Shaft",
    id: 8083107,
    release_date: "2011-01-21",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/f192a3b6d39d198cc660d17407d24e81/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Rolling in the Deep",
    artist: "Adele",
    id: 8086126,
    release_date: "2011-01-24",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/8bdaf37e2e7f883e84bbc3462c938293/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Rumour Has It",
    artist: "Adele",
    id: 8086127,
    release_date: "2011-01-24",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/8bdaf37e2e7f883e84bbc3462c938293/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Set Fire to the Rain",
    artist: "Adele",
    id: 8086130,
    release_date: "2011-01-24",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/8bdaf37e2e7f883e84bbc3462c938293/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Someone Like You",
    artist: "Adele",
    id: 8086136,
    release_date: "2011-01-24",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/8bdaf37e2e7f883e84bbc3462c938293/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "With Every Heartbeat (Album Version)",
    artist: "Robyn",
    id: 8104352,
    release_date: "2007-09-17",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/a3e008fd70c27ad84c004d687f36a5ac/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Fastlove, Pt. 1",
    artist: "George Michael",
    id: 8112357,
    release_date: "1996-01-05",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/4/e/9/0/4e9f080eb71b7b267ea9d6ccb6f17caa.mp3?hdnea=exp=1763730482~acl=/api/1/1/4/e/9/0/4e9f080eb71b7b267ea9d6ccb6f17caa.mp3*~data=user_id=0,application_id=42~hmac=a03269453998c841064bffd2e4b29f68d7f0daf6df43c746d0fe3c5acf2d729f",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/eed917419ae0b958730b075c165dd607/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "I'm Your Baby Tonight",
    artist: "Whitney Houston",
    id: 8164769,
    release_date: "1990-11-06",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/6/1/4/0/61428c2caa00b2e9b88517d797c4d579.mp3?hdnea=exp=1763730482~acl=/api/1/1/6/1/4/0/61428c2caa00b2e9b88517d797c4d579.mp3*~data=user_id=0,application_id=42~hmac=bc3bd6de514518e1d2672256b8cf2f94e295a4071ad176c5882cc7440dfdf277",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/ae3c96eda6ff123bf537b78387d4a11d/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Higher (feat. Kylie Minogue)",
    artist: "Taio Cruz",
    id: 8167112,
    release_date: "2011-02-14",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/1/8/c/0/18c974c128f9f95ea59291b3b755aed5.mp3?hdnea=exp=1763730482~acl=/api/1/1/1/8/c/0/18c974c128f9f95ea59291b3b755aed5.mp3*~data=user_id=0,application_id=42~hmac=c4a468e43414ac01362bdbf240b7eacc979004a2b71ba64ae3573f0b2787452f",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/2f7fa7c56ff43a5aa7704b4e38312e26/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "On The Floor",
    artist: "Jennifer Lopez",
    id: 8930372,
    release_date: "2011-02-22",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/6/4/0/0/6408ca8d561953e3920dc30be03822e2.mp3?hdnea=exp=1763730482~acl=/api/1/1/6/4/0/0/6408ca8d561953e3920dc30be03822e2.mp3*~data=user_id=0,application_id=42~hmac=f6d70bf2e556d14c02393030be82a5099d758414fab344764b9509cdca8e315e",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/d3df69d1356e25bf018df6cb66f8376b/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "I Need A Doctor",
    artist: "Dr. Dre",
    id: 9806802,
    release_date: "2011-02-01",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/3/c/f/0/3cf6c74847f37fe81ba13ce8a32d2646.mp3?hdnea=exp=1763730482~acl=/api/1/1/3/c/f/0/3cf6c74847f37fe81ba13ce8a32d2646.mp3*~data=user_id=0,application_id=42~hmac=354efe908d577c293b425be5ee0c55f251eca2b5b36576b743f1508bdcb842ec",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/a71f29ab2cfa97c88f69afa9041e5f35/250x250-000000-80-0-0.jpg",
    genre: "Rap/Hip Hop",
  },
  {
    title: "Look At Me Now",
    artist: "Chris Brown",
    id: 9815458,
    release_date: "2011-02-01",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/a335c1df1805ac07bf5a96cd578954fc/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Sweat (Remix)",
    artist: "Snoop Dogg",
    id: 10162588,
    release_date: "2011-03-04",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/b/b/8/0/bb86b02e5795f6e875b22d49cb1a30c3.mp3?hdnea=exp=1763730482~acl=/api/1/1/b/b/8/0/bb86b02e5795f6e875b22d49cb1a30c3.mp3*~data=user_id=0,application_id=42~hmac=ccd80a00caa6dd85ec7ddd5683d944d32d7685c23e7f5573160e78aa207536a3",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/f81151ad27acdf3d3139e9c3dbf875ff/250x250-000000-80-0-0.jpg",
    genre: "Rap/Hip Hop",
  },
  {
    title: "Just Can’t Get Enough",
    artist: "The Black Eyed Peas",
    id: 10214182,
    release_date: "2011-04-11",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/2/8/d/0/28d48a46fcfb6778d280e84ef030d717.mp3?hdnea=exp=1763730482~acl=/api/1/1/2/8/d/0/28d48a46fcfb6778d280e84ef030d717.mp3*~data=user_id=0,application_id=42~hmac=a7abb486d36abe228932375a8266e5db4e9340ecda9016c1890d507d6c470465",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/9b1143cf8255a6ac45c81ff1cf32529d/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Can't Stop",
    artist: "After 7",
    id: 10245255,
    release_date: "1989-08-22",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/e/7/5/0/e75643e259c78ed36e0ab925abc57824.mp3?hdnea=exp=1763730482~acl=/api/1/1/e/7/5/0/e75643e259c78ed36e0ab925abc57824.mp3*~data=user_id=0,application_id=42~hmac=f80dab90f2f3b30e58feb00e71e5a0087e563d20d91ac6dd044c4bddee4a49e6",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/35934a99503482f2206937bb56b4dcc8/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Golden Skans",
    artist: "Klaxons",
    id: 10284894,
    release_date: "2007-04-09",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/d2b333806e9d743e029c165e7e5697be/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "These Words",
    artist: "Natasha Bedingfield",
    id: 10307864,
    release_date: "2010-01-20",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/037175c9788fc00c4fc5125e75c043e8/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Give Me Everything (feat. Ne-Yo, Afrojack & Nayer)",
    artist: "Pitbull",
    id: 10308117,
    release_date: "2011-03-21",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/5/d/c/0/5dcb1d36168c2d36031b0708e49e3a46.mp3?hdnea=exp=1763730482~acl=/api/1/1/5/d/c/0/5dcb1d36168c2d36031b0708e49e3a46.mp3*~data=user_id=0,application_id=42~hmac=1b1a967ac1b6ec0032801f6f81cf6be0583414540a60d7f49378ce442cb8b5c5",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/93806e3105596219e5c241af4b7e1955/250x250-000000-80-0-0.jpg",
    genre: "Dance",
  },
  {
    title: "Don't Let the Sun Go Down on Me",
    artist: "George Michael",
    id: 10392073,
    release_date: "2011-04-01",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/7/3/3/0/7339a5776a12498a55a376b97bb5c9e2.mp3?hdnea=exp=1763730482~acl=/api/1/1/7/3/3/0/7339a5776a12498a55a376b97bb5c9e2.mp3*~data=user_id=0,application_id=42~hmac=726b0ed18ce600523c055a473f988c1791c5c799c3c61988f7b5f3905932a087",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/4c9fd7e1257024bff5be2a795fc7e5ca/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Judas",
    artist: "Lady Gaga",
    id: 10496009,
    release_date: "2011-04-15",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/91c4f68c2e8d805ce1e1d53d2f73bb44/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Run the World (Girls)",
    artist: "Beyoncé",
    id: 10686934,
    release_date: "2011-04-21",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/9/9/5/0/9958c7a250b18c3a950dbab276fe6b47.mp3?hdnea=exp=1763730482~acl=/api/1/1/9/9/5/0/9958c7a250b18c3a950dbab276fe6b47.mp3*~data=user_id=0,application_id=42~hmac=f0649504d70e8ec4b4895a489c321bb2e9bef69d8e14ef5fcf39ca8be07067f8",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/b9ffe6c9d8a81bfa273378f45b06deee/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Black and Yellow",
    artist: "Wiz Khalifa",
    id: 11272651,
    release_date: "2011-03-28",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/7/d/5/0/7d53c673c1040b94c45d68a4f4def008.mp3?hdnea=exp=1763730482~acl=/api/1/1/7/d/5/0/7d53c673c1040b94c45d68a4f4def008.mp3*~data=user_id=0,application_id=42~hmac=3c5ee9406ef1f572c642c39884a177ca81f73d542b778d96c696cd1a07a247f3",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/9cdc2fb0118ecd5b02e8cef180ad2c50/250x250-000000-80-0-0.jpg",
    genre: "Rap/Hip Hop",
  },
  {
    title: "The Edge Of Glory",
    artist: "Lady Gaga",
    id: 11282846,
    release_date: "2011-05-09",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/6c7650967fb544f7edae9b8b1c214a0d/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Rapture (feat.Nadia Ali)",
    artist: "iiO",
    id: 11495726,
    release_date: "2006-06-27",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/4/8/d/0/48d98a354dd517dcc23828542e04cf98.mp3?hdnea=exp=1763730482~acl=/api/1/1/4/8/d/0/48d98a354dd517dcc23828542e04cf98.mp3*~data=user_id=0,application_id=42~hmac=8528c96793efc4b8d89140e8429cf917f1de2e24067397abae9fadf1e2eb700c",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/e5dbef12cc8e979e99f0970ede1947da/250x250-000000-80-0-0.jpg",
    genre: "Electro",
  },
  {
    title: "Touch Me [feat. Cassandra]",
    artist: "Rui Da Silva",
    id: 11663132,
    release_date: "2006-06-17",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/5/2/3/0/523362a46ed7a4f687d8d7db47af42a4.mp3?hdnea=exp=1763730482~acl=/api/1/1/5/2/3/0/523362a46ed7a4f687d8d7db47af42a4.mp3*~data=user_id=0,application_id=42~hmac=870b74cdfe4b9f2005cf4ce88e2387ce9442c0cd2fed1e5499d814c38c841ff5",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/1fcf07163732e1a64a61be0acd2dd865/250x250-000000-80-0-0.jpg",
    genre: "Electro",
  },
  {
    title: "Feels Like Heaven",
    artist: "Urban Cookie Collective",
    id: 12159135,
    release_date: "1984-02-26",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/7/1/7/0/7171cfbda26304fd890c4010d532da1c.mp3?hdnea=exp=1763730482~acl=/api/1/1/7/1/7/0/7171cfbda26304fd890c4010d532da1c.mp3*~data=user_id=0,application_id=42~hmac=c91d7c725acde66e7373af0774752b3e8ea8fb10899c53cf88440fdabece6794",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/57ffff16dc7fff50b677277367f3fb6f/250x250-000000-80-0-0.jpg",
    genre: "Electro",
  },
  {
    title: "Pocketful of Sunshine",
    artist: "Natasha Bedingfield",
    id: 12270014,
    release_date: "2011-05-16",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/d/2/4/0/d248d2a164654d17d2282ab1221274c7.mp3?hdnea=exp=1763730482~acl=/api/1/1/d/2/4/0/d248d2a164654d17d2282ab1221274c7.mp3*~data=user_id=0,application_id=42~hmac=a4cb8417ff8a301094bc1a891fd5ce590102e139e81be0cf30692bfefe9fe805",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/94457d1b153666f38985fe6837ac61db/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "International Love (feat. Chris Brown)",
    artist: "Pitbull",
    id: 12270398,
    release_date: "2011-06-17",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/1/0/e/0/10ec8629dff52cb9a055c6c0d4d46c5d.mp3?hdnea=exp=1763730482~acl=/api/1/1/1/0/e/0/10ec8629dff52cb9a055c6c0d4d46c5d.mp3*~data=user_id=0,application_id=42~hmac=6a3ebfa9cb6bd887cd50c0fb38e682af2cf26fba295b97ef3c64c954219de500",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/4863897b132d5c656b9190fc87e9c5bb/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Too Close",
    artist: "Alex Clare",
    id: 12324769,
    release_date: "2011-07-11",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/8/a/8/0/8a895824d6b24abfa717f255f79f9804.mp3?hdnea=exp=1763730482~acl=/api/1/1/8/a/8/0/8a895824d6b24abfa717f255f79f9804.mp3*~data=user_id=0,application_id=42~hmac=b11c2cae61fe9705c50e96f93c7129500d0824a71f6c7fe79f7470afb27dc27c",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/b0359aae28bdd739f51623284c858f6f/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: 'Moves Like Jagger (Studio Recording From "The Voice" Performance)',
    artist: "Maroon 5",
    id: 12724819,
    release_date: "2011-07-11",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/a/7/e/0/a7e50624b3070ba5f6b6bdc963849590.mp3?hdnea=exp=1763730482~acl=/api/1/1/a/7/e/0/a7e50624b3070ba5f6b6bdc963849590.mp3*~data=user_id=0,application_id=42~hmac=47ae7db78f0b39410fb34770c94707f624b506561d82ee9dfc0317376961487e",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/86fb42ca017f0266d0885c1bede988bf/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "The Horses",
    artist: "Daryl Braithwaite",
    id: 12791711,
    release_date: "1991-07-29",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/a/2/8/0/a2802cbc90dc07452efc31d91621cd3e.mp3?hdnea=exp=1763730482~acl=/api/1/1/a/2/8/0/a2802cbc90dc07452efc31d91621cd3e.mp3*~data=user_id=0,application_id=42~hmac=00fda3910022a5abedc149860740b60e1d18678a3ffdf4e0519b418400f213c6",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/7fc5f98e7f888e01ee2a401ae8136815/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Man Down",
    artist: "Rihanna",
    id: 12817764,
    release_date: "2011-07-11",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/1dcd6f6b3cdc437db8bd8cce66ace72a/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Skyscraper",
    artist: "Demi Lovato",
    id: 12976495,
    release_date: "2011-07-19",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/5078f55143908d8790edf84e482b1c7c/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Candyman",
    artist: "Christina Aguilera",
    id: 13129923,
    release_date: "2008-11-07",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/c5e073307f63ce67bc134d1f993fbcd0/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Irreplaceable",
    artist: "Beyoncé",
    id: 13131048,
    release_date: "2007-05-29",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/6/a/9/0/6a982096b71303a1dca91dc221ce1907.mp3?hdnea=exp=1763730482~acl=/api/1/1/6/a/9/0/6a982096b71303a1dca91dc221ce1907.mp3*~data=user_id=0,application_id=42~hmac=8761a40128e388a4bba66532336865332e3edaf7feeaa972198f62937d36f80e",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/a3afedf4800754b8c87eda2bf5cbd06b/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Goodbye Mr A",
    artist: "The Hoosiers",
    id: 13131186,
    release_date: "2007-10-22",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/e/f/d/0/efde631fe98248a1a9f67d1d3cfa5d8f.mp3?hdnea=exp=1763730482~acl=/api/1/1/e/f/d/0/efde631fe98248a1a9f67d1d3cfa5d8f.mp3*~data=user_id=0,application_id=42~hmac=bf37fb267264e73d97d8a0bc670aca76243882d8d2428a525f07c158968bc3fc",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/217d7fd25d5521edceb63ae1bbc38cd0/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "What a Girl Wants",
    artist: "Christina Aguilera",
    id: 13131682,
    release_date: "1999-11-16",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/1/9/d/0/19dd385ff8269ae6152e00e0a3de9ffa.mp3?hdnea=exp=1763730482~acl=/api/1/1/1/9/d/0/19dd385ff8269ae6152e00e0a3de9ffa.mp3*~data=user_id=0,application_id=42~hmac=cb9f47cf200edb1229a95efffcd8bd844983aef4cd73210a8caad8c6c6263aa1",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/92905e4be8c6f1c49a4796c96f3b1c26/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Come on over Baby (All I Want Is You) (Radio Version)",
    artist: "Christina Aguilera",
    id: 13131684,
    release_date: "2008-11-12",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/d/d/2/0/dd25916dc6f75a231fc0e67e95d4e5b8.mp3?hdnea=exp=1763730482~acl=/api/1/1/d/d/2/0/dd25916dc6f75a231fc0e67e95d4e5b8.mp3*~data=user_id=0,application_id=42~hmac=1b1f261b17892fc90ca200802e737fbd9e6cc2a1b1ef54f22fa2b165f6180507",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/92905e4be8c6f1c49a4796c96f3b1c26/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "I'm Not Alone",
    artist: "Calvin Harris",
    id: 13131862,
    release_date: "2009-08-17",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/c/4/f/0/c4fd4fee71004b74fdd12b0ff54393cd.mp3?hdnea=exp=1763730482~acl=/api/1/1/c/4/f/0/c4fd4fee71004b74fdd12b0ff54393cd.mp3*~data=user_id=0,application_id=42~hmac=f429d2266d00f5eb2dbacfc16646a528a2d7a7c72d5fd58975cc62b383f99e27",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/fe730c8560784944b7d349b1605a0427/250x250-000000-80-0-0.jpg",
    genre: "Electro",
  },
  {
    title: "Children",
    artist: "Robert Miles",
    id: 13131916,
    release_date: "1995-12-18",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/e/6/7/0/e67317d3f714be84069651d46c25a924.mp3?hdnea=exp=1763730482~acl=/api/1/1/e/6/7/0/e67317d3f714be84069651d46c25a924.mp3*~data=user_id=0,application_id=42~hmac=104f171369da48fef1218e1d470a4129a5feb4b556e03936dc19b7f303120a41",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/0dcb6d056d2e619cc479be7c24bd8e39/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Check On It (feat. Slim Thug)",
    artist: "Beyoncé",
    id: 13132317,
    release_date: "2003-05-19",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/b/6/1/0/b617bc149fa0c6c17e20333a2898bad4.mp3?hdnea=exp=1763730482~acl=/api/1/1/b/6/1/0/b617bc149fa0c6c17e20333a2898bad4.mp3*~data=user_id=0,application_id=42~hmac=7f60d1ad8e0aa240788f2cce239782febe306014f63f3a7a41594e2aad37d3f6",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/47a1d2dec4ca5c7e734a19dd8bba8b97/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Summer Love",
    artist: "Justin Timberlake",
    id: 13132402,
    release_date: "2006-09-12",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/3b707034b3a1cd1bb8323d051b2afe86/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Acceptable in the 80's",
    artist: "Calvin Harris",
    id: 13132580,
    release_date: "2007-06-18",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/8/2/7/0/8272f8d1e13b24f3f0ac07fc3dc1cc02.mp3?hdnea=exp=1763730482~acl=/api/1/1/8/2/7/0/8272f8d1e13b24f3f0ac07fc3dc1cc02.mp3*~data=user_id=0,application_id=42~hmac=24503707672d3a724ee9561f3fb41ef29c9ba8a87e384399c74775477984cd49",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/45444d3745d99607af530ef1c008f573/250x250-000000-80-0-0.jpg",
    genre: "Electro",
  },
  {
    title: "Me, Myself and I",
    artist: "Beyoncé",
    id: 13138703,
    release_date: "2003-03-10",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/3/a/9/0/3a9ce021944e074039e99812a2f996ae.mp3?hdnea=exp=1763730482~acl=/api/1/1/3/a/9/0/3a9ce021944e074039e99812a2f996ae.mp3*~data=user_id=0,application_id=42~hmac=d8edbdd5e201c2dccbfc77cf9ead67bdcd9a675d013b05cac4df796603ca91a0",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/b3415e1ea8c2e98a8bff153c6cfb4f7b/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Say",
    artist: "John Mayer",
    id: 13139469,
    release_date: "2008-07-07",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/939d0cda3950cfa85554937b4da75188/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Gimme That",
    artist: "Chris Brown",
    id: 13140206,
    release_date: "2006-02-04",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/b/e/3/0/be388e89fd3a6218783b501621decb05.mp3?hdnea=exp=1763730482~acl=/api/1/1/b/e/3/0/be388e89fd3a6218783b501621decb05.mp3*~data=user_id=0,application_id=42~hmac=1d4bb6c733864d789971c14261246ca03ab2d29910acadca0d488cecaf62766e",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/2ab54c7e1839b47f3d2361776a20b2f0/250x250-000000-80-0-0.jpg",
    genre: "Rap/Hip Hop",
  },
  {
    title: "(God Must Have Spent) A Little More Time On You (Remix)",
    artist: "*NSYNC",
    id: 13140661,
    release_date: "1998-09-08",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/a/d/8/0/ad80b1e33631226133f8b364a70ac4c3.mp3?hdnea=exp=1763730482~acl=/api/1/1/a/d/8/0/ad80b1e33631226133f8b364a70ac4c3.mp3*~data=user_id=0,application_id=42~hmac=b1068359206bd60029ea7a96619b90e1754741b3913f86f5aa721775c2f25b2a",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/fbdb20df66f20256eac80af608980c1c/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "I Want It That Way",
    artist: "Backstreet Boys",
    id: 13141170,
    release_date: "1999-05-18",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/7/1/9/0/71997935a6df8ac013ac4f76fbe7d72e.mp3?hdnea=exp=1763730482~acl=/api/1/1/7/1/9/0/71997935a6df8ac013ac4f76fbe7d72e.mp3*~data=user_id=0,application_id=42~hmac=47d860da64a3adc04d0e336431bc143b90fccc2c19bb8ecbd63e364a175e0e24",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/d61eaad8f321ea876a5f5c7219aae892/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Hey Ya! (Radio Mix / Club Mix)",
    artist: "OutKast",
    id: 13141229,
    release_date: "2003-09-09",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/b3e4aada3a8c394dcce645b9024c378c/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Summertime",
    artist: "DJ Jazzy Jeff & The Fresh Prince",
    id: 13142599,
    release_date: "1991-07-09",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/7/4/e/0/74e754b89dec548c01954c661f2fb26f.mp3?hdnea=exp=1763730482~acl=/api/1/1/7/4/e/0/74e754b89dec548c01954c661f2fb26f.mp3*~data=user_id=0,application_id=42~hmac=0468a0f7e8726fa3d1d79c2cae7bdd00e9b5c97037a704b6461189ec5c3d8b05",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/11c9ba03d98347205620fdc31449749d/250x250-000000-80-0-0.jpg",
    genre: "Rap/Hip Hop",
  },
  {
    title: "Before He Cheats",
    artist: "Carrie Underwood",
    id: 13144323,
    release_date: "2005-11-14",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/7/b/8/0/7b88c3e59d1556f50c8bc3446121cfd5.mp3?hdnea=exp=1763730482~acl=/api/1/1/7/b/8/0/7b88c3e59d1556f50c8bc3446121cfd5.mp3*~data=user_id=0,application_id=42~hmac=399448ba1e4c38eebeecd3959d37e541d3becbb27f229d297c2fa3cee2d97bad",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/1e6671d78586231350f8eda9097d0036/250x250-000000-80-0-0.jpg",
    genre: "Country",
  },
  {
    title: "Ice Box",
    artist: "Omarion",
    id: 13144433,
    release_date: "2010-02-10",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/7/e/8/0/7e876e5e4b8453744110e42603ee91c3.mp3?hdnea=exp=1763730482~acl=/api/1/1/7/e/8/0/7e876e5e4b8453744110e42603ee91c3.mp3*~data=user_id=0,application_id=42~hmac=35024e6588a75f73a74c60f67461a65aac5b5f5254cc5d91bed54b74f5c148b4",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/d3d7bcbd88d9242021361165ea5be959/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Butterfly",
    artist: "Crazy Town",
    id: 13144759,
    release_date: "1999-10-22",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/5/4/b/0/54bb26b7f926039a78ec30dbbab2a44d.mp3?hdnea=exp=1763730482~acl=/api/1/1/5/4/b/0/54bb26b7f926039a78ec30dbbab2a44d.mp3*~data=user_id=0,application_id=42~hmac=109c9e081e04f432ae958f9830ad4f546868f4fd6785e464b1cab13fc920f0c3",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/4360765d7a2aceae49aaaa8cfcff6ddf/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "Goodies (feat. Petey Pablo)",
    artist: "Ciara",
    id: 13145340,
    release_date: "2004-09-27",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/7/3/a/0/73a1d4308af730f18facf2b7872361d3.mp3?hdnea=exp=1763730482~acl=/api/1/1/7/3/a/0/73a1d4308af730f18facf2b7872361d3.mp3*~data=user_id=0,application_id=42~hmac=316b853784593b865011518e035a02eb57059ddf229df0baa69f1f702f68f8f1",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/d38ab86f75dd3d1d87581face5ec3116/250x250-000000-80-0-0.jpg",
    genre: "R&B",
  },
  {
    title: "Your Body Is a Wonderland",
    artist: "John Mayer",
    id: 13146259,
    release_date: "2001-08-16",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/e/8/a/0/e8a4c05c957682ca58515022b7e53902.mp3?hdnea=exp=1763730482~acl=/api/1/1/e/8/a/0/e8a4c05c957682ca58515022b7e53902.mp3*~data=user_id=0,application_id=42~hmac=d044d3ce838fce945e1063b345609c51cc33c5052333c954a36d47ff4bd0afe4",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/70933e9355b563d73f3eb7272f1f8960/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "All or Nothing",
    artist: "O-Town",
    id: 13149243,
    release_date: "2003-02-03",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/c/d/2/0/cd2135e86a8eca891f5ba3fea74403cb.mp3?hdnea=exp=1763730482~acl=/api/1/1/c/d/2/0/cd2135e86a8eca891f5ba3fea74403cb.mp3*~data=user_id=0,application_id=42~hmac=f176bfef2cd8b1bce51e42cbde98ff215da7cdc4b8667fed70076e4471240da3",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/649bc2446c8ebfc64c1d49102e47215c/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Cold as Ice",
    artist: "M.O.P.",
    id: 13162037,
    release_date: "2000-10-09",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/b6cf6cd00671f0df1b2c750aca2d88fd/250x250-000000-80-0-0.jpg",
    genre: "Rap/Hip Hop",
  },
  {
    title: "Wifey",
    artist: "Next",
    id: 13165897,
    release_date: "2004-04-30",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/fea2bf81593b4fef77fe519250b0741b/250x250-000000-80-0-0.jpg",
    genre: "R&B",
  },
  {
    title: "Sweet Lady",
    artist: "Tyrese",
    id: 13181571,
    release_date: "1998-08-31",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/dd1b551e7d99dee0521c9d431fcaa09f/250x250-000000-80-0-0.jpg",
    genre: "R&B",
  },
  {
    title: "Pop, Lock & Drop It (Video Edit)",
    artist: "Huey",
    id: 13181757,
    release_date: "2010-02-10",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/1fc1e57226d985b09461e03858e893ab/250x250-000000-80-0-0.jpg",
    genre: "Rap/Hip Hop",
  },
  {
    title: "Headlines",
    artist: "Drake",
    id: 13191028,
    release_date: "2011-08-09",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/9e9c05f4b95a31af4dd284f763ea2e27/250x250-000000-80-0-0.jpg",
    genre: "Rap/Hip Hop",
  },
  {
    title: "Two Princes",
    artist: "Spin Doctors",
    id: 13438339,
    release_date: "1991-08-26",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/46abfe87f61beb365349cd25ce46f087/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Last Friday Night (T.G.I.F.)",
    artist: "Katy Perry",
    id: 13460184,
    release_date: "2010-03-23",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/c7283218e496f35f1d804d3617eecb73/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "S&M",
    artist: "Rihanna",
    id: 13529559,
    release_date: "2011-08-18",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/3a12c64bb52a167944783878ffe41f02/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Don't Wanna Go Home",
    artist: "Jason Derulo",
    id: 13548266,
    release_date: "2011-06-17",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/0f8c5376d6ad5edd6334f4146cf373a2/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "The A Team",
    artist: "Ed Sheeran",
    id: 13651702,
    release_date: "2011-09-09",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/b9dc81301e73f9fe31362858febcef03/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Drunk",
    artist: "Ed Sheeran",
    id: 13651703,
    release_date: "2011-09-09",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/b9dc81301e73f9fe31362858febcef03/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Lego House",
    artist: "Ed Sheeran",
    id: 13651710,
    release_date: "2011-09-09",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/b9dc81301e73f9fe31362858febcef03/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Keep Holding On",
    artist: "Avril Lavigne",
    id: 13705107,
    release_date: "2007-04-17",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/3e150c4bd64c9a0f2e2ccfa97dbe0936/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Yo (Excuse Me Miss)",
    artist: "Chris Brown",
    id: 13783330,
    release_date: "2005-11-14",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/2f45b6c32e1cc1e63ae3454b9af9566e/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Confessions Part II",
    artist: "Usher",
    id: 13783452,
    release_date: "2004-03-23",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/b89c20012cccb051c8a4e04d98386f95/250x250-000000-80-0-0.jpg",
    genre: "R&B",
  },
  {
    title: "Come As You Are",
    artist: "Nirvana",
    id: 13791932,
    release_date: "1996-03-25",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/f0282817b697279e56df13909962a54a/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "She's So Lovely",
    artist: "Scouting For Girls",
    id: 13816166,
    release_date: "2011-10-07",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/0740f28f1be5b17922bb47c0cd792ca5/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "We Found Love",
    artist: "Rihanna",
    id: 13839981,
    release_date: "2011-09-22",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/618976e0787bafb970ce45f2e78fd4d5/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Night People",
    artist: "Professional Losers",
    id: 14144466,
    release_date: "2006-07-02",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/99117b19d198d2a99b1b81a31c9fba08/250x250-000000-80-0-0.jpg",
    genre: "Dance",
  },
  {
    title: "Stronger (What Doesn't Kill You)",
    artist: "Kelly Clarkson",
    id: 14241633,
    release_date: "2011-10-24",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/790f5653c73d01fe3bd55d2990ee3db6/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Paradise",
    artist: "Coldplay",
    id: 14299589,
    release_date: "2011-10-19",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/e0dd8263dfed37c50a868abbf65fd7da/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "Every Teardrop Is a Waterfall",
    artist: "Coldplay",
    id: 14299593,
    release_date: "2011-10-19",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/e0dd8263dfed37c50a868abbf65fd7da/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "Princess of China",
    artist: "Coldplay",
    id: 14299596,
    release_date: "2011-10-19",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/e0dd8263dfed37c50a868abbf65fd7da/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "The Fly",
    artist: "U2",
    id: 14343286,
    release_date: "1991-10-21",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/64b797ea83d52f3869593a448c790a4d/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "Mysterious Ways",
    artist: "U2",
    id: 14343287,
    release_date: "1991-11-25",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/64b797ea83d52f3869593a448c790a4d/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "Mr. Saxobeat (Extended Version)",
    artist: "Alexandra Stan",
    id: 14393619,
    release_date: "2011-10-26",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/fd3b4665e9398285bcc5ab330ac73612/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Got 2 Luv U (feat. Alexis Jordan)",
    artist: "Sean Paul",
    id: 14500223,
    release_date: "2011-11-21",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/9d61e3d80e4dd3fb986cb442023d530b/250x250-000000-80-0-0.jpg",
    genre: "Reggae",
  },
  {
    title: "Where Have You Been (Album Version)",
    artist: "Rihanna",
    id: 14525573,
    release_date: "2011-11-21",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/5199f89d5113a83b5086463d5d0c9415/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Grenade",
    artist: "Bruno Mars",
    id: 14616013,
    release_date: "2011-02-08",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/12ac2e58b173d8704718b48a0e91b349/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Love Is",
    artist: "Vanessa Williams And Brian McKnight",
    id: 14630802,
    release_date: "1992-03-31",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/3999ed89f8f52144208e91c83a4ffc93/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Until It Sleeps (LP Version)",
    artist: "Metallica",
    id: 14632295,
    release_date: "1996-04-30",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/aed353510c02609d2d8ca20d4887aed5/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Home",
    artist: "Westlife",
    id: 14834540,
    release_date: "2005-02-08",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/ebbdea4a120e2b6d2e7b3538f113279a/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Now That We Found Love",
    artist: "Heavy D & The Boyz",
    id: 14935057,
    release_date: "1989-07-11",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/77481e7bbcd9e4f7631696fa825a3d15/250x250-000000-80-0-0.jpg",
    genre: "Rap/Hip Hop",
  },
  {
    title: "Danza Kuduro",
    artist: "Don Omar",
    id: 14948701,
    release_date: "2010-11-16",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/c22882ab30334c535a3e638f9cbf24d6/250x250-000000-80-0-0.jpg",
    genre: "Rap/Hip Hop",
  },
  {
    title: "The Creeps",
    artist: "Camille Jones",
    id: 15002075,
    release_date: "2015-02-10",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/1abb8469423bdf2a29364747756b60eb/250x250-000000-80-0-0.jpg",
    genre: "Electro",
  },
  {
    title: "What's Left Of Me (Main Version)",
    artist: "Nick Lachey",
    id: 15050556,
    release_date: "2006-06-08",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/edb123e396df7dfe68f31ee534041e87/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "The Animal Song",
    artist: "Savage Garden",
    id: 15175374,
    release_date: "2007-02-02",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/d14d6858c6692515091a67db20b63d44/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Dreamlover",
    artist: "Mariah Carey",
    id: 15176152,
    release_date: "1993-08-31",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/074f9fdaefead72442368c647b46f500/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Guerrilla Radio",
    artist: "Rage Against the Machine",
    id: 15178643,
    release_date: "1999-11-02",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/2cec0fa04bf4fe49a6ad539ddfbae77d/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "Little L",
    artist: "Jamiroquai",
    id: 15215897,
    release_date: "2001-08-29",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/5fc6c36d3b78be9862f91112afe6ad91/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Wild Ones (feat. Sia)",
    artist: "Flo Rida",
    id: 15269141,
    release_date: "2011-12-19",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/1d2540f454fad844251105b78ec4ea7b/250x250-000000-80-0-0.jpg",
    genre: "Rap/Hip Hop",
  },
  {
    title: "Hey Baby",
    artist: "DJ Ötzi",
    id: 15319250,
    release_date: "2010-04-25",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/3ca3d33867c9eb2529fc8e01fd68da9c/250x250-000000-80-0-0.jpg",
    genre: "Electro",
  },
  {
    title: "Sunshine (feat. Lea)",
    artist: "Lil' Flip",
    id: 15346718,
    release_date: "2004-03-30",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/07e303524a9cdf9c81b11942f4ee08bf/250x250-000000-80-0-0.jpg",
    genre: "Rap/Hip Hop",
  },
  {
    title: "Lose My Breath",
    artist: "Destiny's Child",
    id: 15376488,
    release_date: "2004-11-16",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/a834c91eee2bb719f89287aa6d93ff51/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Freek-A-Leek",
    artist: "Petey Pablo",
    id: 15379253,
    release_date: "2002-11-26",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/cf2c878507b89b1e691636d7b7a4a2fc/250x250-000000-80-0-0.jpg",
    genre: "Rap/Hip Hop",
  },
  {
    title: "Toxic",
    artist: "Britney Spears",
    id: 15391618,
    release_date: "2003-11-13",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/8a2b95cda407d004d829831d20e2e20b/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Shape of My Heart",
    artist: "Backstreet Boys",
    id: 15396992,
    release_date: "2001-10-23",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/52f58f75fc623f6202d1825cc0081dcd/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "La Tortura (feat. Alejandro Sanz) (Album)",
    artist: "Shakira",
    id: 15404852,
    release_date: "2005-06-03",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/f2065ca5ce5f5ddefbd8b89e13386c17/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Video Games",
    artist: "Lana Del Rey",
    id: 15425694,
    release_date: "2012-01-06",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/d/c/1/0/dc19f76be2eb7417deda5dfc0f89e688.mp3?hdnea=exp=1763729090~acl=/api/1/1/d/c/1/0/dc19f76be2eb7417deda5dfc0f89e688.mp3*~data=user_id=0,application_id=42~hmac=a11d19aeaa3bc24599d3e60d345540e5894c46e3aa3842123e1ee4626f36c703",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/5b00b6bf2a353dc0bfd6ff6846708d0e/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "What is Love",
    artist: "Haddaway",
    id: 15457312,
    release_date: "1993-11-29",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/2c6db52efd00bd77cb57de0cbcd0ef85/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Life",
    artist: "Haddaway",
    id: 15457313,
    release_date: "1993-11-29",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/2c6db52efd00bd77cb57de0cbcd0ef85/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "My Love (feat. T.I.)",
    artist: "Justin Timberlake",
    id: 15489385,
    release_date: "2006-09-08",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/d/0/7/0/d07c8f3e3de67216a6ddd905cccddf55.mp3?hdnea=exp=1763729090~acl=/api/1/1/d/0/7/0/d07c8f3e3de67216a6ddd905cccddf55.mp3*~data=user_id=0,application_id=42~hmac=4d9369cb0d0515c28532408910ebde796d0481f503e1d2adc3bbd02e9970a729",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/615bb58abf2e5fd86741ed5311d364b1/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "What Goes Around.../...Comes Around (Interlude)",
    artist: "Justin Timberlake",
    id: 15489392,
    release_date: "2006-09-08",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/f/a/2/0/fa21044e35e5a8257fb2a1090b2f86a0.mp3?hdnea=exp=1763729090~acl=/api/1/1/f/a/2/0/fa21044e35e5a8257fb2a1090b2f86a0.mp3*~data=user_id=0,application_id=42~hmac=c4eb78cb791fd8430a1d62d40dcf240e84490368d9459e1a898376fc75229440",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/615bb58abf2e5fd86741ed5311d364b1/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Love in This Club (feat. Young Jeezy)",
    artist: "Usher",
    id: 15527509,
    release_date: "2008-05-27",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/4/5/6/0/456089c444bf61b7dbb5c6c7bddb420e.mp3?hdnea=exp=1763729090~acl=/api/1/1/4/5/6/0/456089c444bf61b7dbb5c6c7bddb420e.mp3*~data=user_id=0,application_id=42~hmac=3d2a94a52fce0f692d6192ee4a657020f1a86b3507b724fa880ab4130e67539f",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/4e12ebffaef7555770c0fc35f92be3b4/250x250-000000-80-0-0.jpg",
    genre: "R&B",
  },
  {
    title: "Use Somebody",
    artist: "Kings Of Leon",
    id: 15531171,
    release_date: "2008-09-19",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/8/e/3/0/8e362dc51853bee4970425c8fc1518ed.mp3?hdnea=exp=1763729090~acl=/api/1/1/8/e/3/0/8e362dc51853bee4970425c8fc1518ed.mp3*~data=user_id=0,application_id=42~hmac=4d7751db9a99a1ddaa54a3a27e35fdb599efe0ef1cedfecf3ccbc4ff5e642013",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/a4d41f829fac22196b44e97824ee9180/250x250-000000-80-0-0.jpg",
    genre: "Alternative",
  },
  {
    title: "Ex-Factor",
    artist: "Lauryn Hill",
    id: 15586234,
    release_date: "1998-02-25",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/4/0/1/0/401e00b1a249906bb28be5958d0a3e4b.mp3?hdnea=exp=1763729090~acl=/api/1/1/4/0/1/0/401e00b1a249906bb28be5958d0a3e4b.mp3*~data=user_id=0,application_id=42~hmac=74482c54cf4e9219bb7bbdba14675a9833f5ceed50fe4bef9c63899439529a04",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/1322b9d5248a55034f098802072cfac4/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Gimme More",
    artist: "Britney Spears",
    id: 15589893,
    release_date: "2007-10-25",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/0/f/d/0/0fdc5f2b47b7650d5e2f3f862c13a936.mp3?hdnea=exp=1763729090~acl=/api/1/1/0/f/d/0/0fdc5f2b47b7650d5e2f3f862c13a936.mp3*~data=user_id=0,application_id=42~hmac=013f6c649c00fa6d39b8d92d68301ea1fb40d0df331265295d4469f1a3674bb5",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/76763b33422eb22b46ffa7c1d8bfe910/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Piece of Me",
    artist: "Britney Spears",
    id: 15589894,
    release_date: "2007-10-25",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/1/f/9/0/1f92ee461c05cfbe7afefc6530c67cd5.mp3?hdnea=exp=1763729090~acl=/api/1/1/1/f/9/0/1f92ee461c05cfbe7afefc6530c67cd5.mp3*~data=user_id=0,application_id=42~hmac=975a049e04c3aa35becf8edad06a9ef7b19cab25ecae5e6c7904ac0ed91fd131",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/76763b33422eb22b46ffa7c1d8bfe910/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Give In to Me",
    artist: "Michael Jackson",
    id: 15593568,
    release_date: "1991-10-16",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/6/d/b/0/6db2cac551f48f001c6c15b4da5c7a91.mp3?hdnea=exp=1763729090~acl=/api/1/1/6/d/b/0/6db2cac551f48f001c6c15b4da5c7a91.mp3*~data=user_id=0,application_id=42~hmac=9e7d6fde9674bfcfa0a53e920fd196a1a54b4cd6c9f08b904bceb02c16a67041",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/93a5354699d552666448e1c87c976605/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Will You Be There",
    artist: "Michael Jackson",
    id: 15593569,
    release_date: "1993-06-28",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/d/c/0/0/dc04050bea0490b7018c7ec01239d187.mp3?hdnea=exp=1763730766~acl=/api/1/1/d/c/0/0/dc04050bea0490b7018c7ec01239d187.mp3*~data=user_id=0,application_id=42~hmac=2419cd05ce9664ca99f7f2d836b17396f505dbbf76d4a3fdbd6d8912d056d898",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/93a5354699d552666448e1c87c976605/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Heartbreaker",
    artist: "Mariah Carey",
    id: 15599093,
    release_date: "1999-08-27",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/784da1add09faff9726abdbf500cbf35/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "She's All I Ever Had",
    artist: "Ricky Martin",
    id: 15613949,
    release_date: "1999-10-12",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/f/8/8/0/f88a539da9ff80e2549320f7ade044c0.mp3?hdnea=exp=1763730766~acl=/api/1/1/f/8/8/0/f88a539da9ff80e2549320f7ade044c0.mp3*~data=user_id=0,application_id=42~hmac=b266d4a1a3036696fac8104c6234c0630cdb019e4727bbfeaee831976e647791",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/e8f7d172b047120fccdaaa86a71e8d47/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Don't Tell Me",
    artist: "Avril Lavigne",
    id: 15626757,
    release_date: "2004-05-25",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/7/e/8/0/7e86c1afed2b48082abbcc1f082dde10.mp3?hdnea=exp=1763730766~acl=/api/1/1/7/e/8/0/7e86c1afed2b48082abbcc1f082dde10.mp3*~data=user_id=0,application_id=42~hmac=75f1eb729e6d725a88a4cb65db3a8a56d13b7c23f24094a3a275faf33d337bb5",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/438e2e737a239379ee4a52e4fb0cf675/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "One Night in Heaven",
    artist: "M People",
    id: 15642705,
    release_date: "1998-10-29",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/6/5/c/0/65caeebf8f1dab8088a8df7a450aa1ef.mp3?hdnea=exp=1763730766~acl=/api/1/1/6/5/c/0/65caeebf8f1dab8088a8df7a450aa1ef.mp3*~data=user_id=0,application_id=42~hmac=8e51895856d4a8c500d19ef97ea8c3e784702d3e264c6e795c0620f669dffc55",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/0f8c459f449832bc6005f26e340df3c6/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Boom! Shake the Room",
    artist: "DJ Jazzy Jeff & The Fresh Prince",
    id: 15698925,
    release_date: "1993-10-12",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/1/b/4/0/1b4c2800fdb09a777cfcd80fe2287ebb.mp3?hdnea=exp=1763730766~acl=/api/1/1/1/b/4/0/1b4c2800fdb09a777cfcd80fe2287ebb.mp3*~data=user_id=0,application_id=42~hmac=2171d2f339901c9dd7f56019021479d3795b33bdc6656cb34af4b2aa8ba4cf4f",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/beffbbf0ca43d886bc2f7686f17dbe75/250x250-000000-80-0-0.jpg",
    genre: "Rap/Hip Hop",
  },
  {
    title: "Where the Streets Have No Name (I Can't Take My Eyes off You)",
    artist: "Pet Shop Boys",
    id: 15707229,
    release_date: "1990-01-01",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/5/3/5/0/53581ebe552a17b8971c8e2a725d481b.mp3?hdnea=exp=1763730766~acl=/api/1/1/5/3/5/0/53581ebe552a17b8971c8e2a725d481b.mp3*~data=user_id=0,application_id=42~hmac=21bf1013b29b67b62d7a79190594f3296db4330c6e7d4e1081e677684749947a",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/b032e0e6281ee7535e0756a213aede73/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Disarm",
    artist: "The Smashing Pumpkins",
    id: 15715637,
    release_date: "1993-11-29",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/2/f/1/0/2f11c422cc2bedc3f1f8ec0d42433a53.mp3?hdnea=exp=1763730766~acl=/api/1/1/2/f/1/0/2f11c422cc2bedc3f1f8ec0d42433a53.mp3*~data=user_id=0,application_id=42~hmac=300f9bc1e0985b0de6cbaf510849724a5df075408c614c1ba140953f31f9113f",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/9821c23566db6e54775087a85d57efce/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "What Makes You Beautiful",
    artist: "One Direction",
    id: 16014608,
    release_date: "2012-02-06",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/8e5e0d51244ccd4d3452136c10043b14/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Summertime Sadness",
    artist: "Lana Del Rey",
    id: 16149860,
    release_date: "2012-01-30",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/7/4/1/0/7415ee6d2566908ce97889ab9184a2bd.mp3?hdnea=exp=1763730766~acl=/api/1/1/7/4/1/0/7415ee6d2566908ce97889ab9184a2bd.mp3*~data=user_id=0,application_id=42~hmac=22a08d6aa7b6fdf447a2c2e383a63f9a41f20ec5852ae3f9207a5cdcc3b014df",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/4c2c6143c3e83a01ea73517c57d1d138/250x250-000000-80-0-0.jpg",
    genre: "Alternative",
  },
  {
    title: "Want U Back",
    artist: "Cher Lloyd",
    id: 16197305,
    release_date: "2012-02-17",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/e/1/f/0/e1f8cb1d7dd21f901f1042ed852d585f.mp3?hdnea=exp=1763730766~acl=/api/1/1/e/1/f/0/e1f8cb1d7dd21f901f1042ed852d585f.mp3*~data=user_id=0,application_id=42~hmac=869ab3ef844d388e88a485ca90fb55e4fbe76219c834583019638210dba079aa",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/e2d26b3822c3016b3ad5c4900053eff0/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Praying for Time",
    artist: "George Michael",
    id: 16433494,
    release_date: "1998-01-30",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/549a1f50cd5903e2f42e3253814f8b33/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "As",
    artist: "George Michael",
    id: 16433498,
    release_date: "1998-01-30",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/549a1f50cd5903e2f42e3253814f8b33/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Freedom! '90",
    artist: "George Michael",
    id: 16433501,
    release_date: "1990-10-20",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/549a1f50cd5903e2f42e3253814f8b33/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Some Nights",
    artist: "fun.",
    id: 16501727,
    release_date: "2012-02-14",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/8/2/e/0/82e60f2a537430569bdfcc6f590cafac.mp3?hdnea=exp=1763730766~acl=/api/1/1/8/2/e/0/82e60f2a537430569bdfcc6f590cafac.mp3*~data=user_id=0,application_id=42~hmac=f690c09958cc61eb7bec751c625e07d4e4b74eb587f8e6f8262e41212c90e322",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/5f7bd91e2d91ce2d308ee754d6821ff7/250x250-000000-80-0-0.jpg",
    genre: "Alternative",
  },
  {
    title: "We Are Young (feat. Janelle Monáe)",
    artist: "fun.",
    id: 16501728,
    release_date: "2012-02-14",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/8/2/c/0/82c08ccf615f63cca82adfe5d7110dd4.mp3?hdnea=exp=1763730766~acl=/api/1/1/8/2/c/0/82c08ccf615f63cca82adfe5d7110dd4.mp3*~data=user_id=0,application_id=42~hmac=34aa98dbd816d693a93af9e3654d2160be76507483d85df378edb8755afa4f4d",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/5f7bd91e2d91ce2d308ee754d6821ff7/250x250-000000-80-0-0.jpg",
    genre: "Alternative",
  },
  {
    title: "Starships",
    artist: "Nicki Minaj",
    id: 16607977,
    release_date: "2012-02-14",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/491d15440764a745c62e6d36f12a554f/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "She Doesn't Mind",
    artist: "Sean Paul",
    id: 16944546,
    release_date: "2012-03-16",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/d/7/5/0/d75adf578cdb7d427f264dd8eb16485d.mp3?hdnea=exp=1763730766~acl=/api/1/1/d/7/5/0/d75adf578cdb7d427f264dd8eb16485d.mp3*~data=user_id=0,application_id=42~hmac=ae336b2ba6c5a2c1e696c3e6f253a2424d52c9f33541f45e53c2e9c85df49dfe",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/526d42d913cd89140759c39a642e9bbd/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Wide Awake",
    artist: "Katy Perry",
    id: 17135122,
    release_date: "2012-03-23",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/d/3/a/0/d3aa90fc94b36144542841a8e67c7884.mp3?hdnea=exp=1763730766~acl=/api/1/1/d/3/a/0/d3aa90fc94b36144542841a8e67c7884.mp3*~data=user_id=0,application_id=42~hmac=bca2e58c7c2ffa15388c1ba562680a4f0eb87cd2b82c579dfa42488e5734b791",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/99578b0bb8c838383c414a5b62b5e15d/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Take Care",
    artist: "Drake",
    id: 17347967,
    release_date: "2012-03-20",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/2/c/8/0/2c8e63eefa13bd0e30a0ee3edf194425.mp3?hdnea=exp=1763730766~acl=/api/1/1/2/c/8/0/2c8e63eefa13bd0e30a0ee3edf194425.mp3*~data=user_id=0,application_id=42~hmac=b2e8ad266777162611b7021c282d504837fe098c57d54657eebe8193c4388bc0",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/6e7a6c8f36669dcd11abe7e7c3222e91/250x250-000000-80-0-0.jpg",
    genre: "Rap/Hip Hop",
  },
  {
    title: "The Motto",
    artist: "Drake",
    id: 17347988,
    release_date: "2012-03-20",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/6/5/e/0/65e7f2405f539294489aedb09191985e.mp3?hdnea=exp=1763730766~acl=/api/1/1/6/5/e/0/65e7f2405f539294489aedb09191985e.mp3*~data=user_id=0,application_id=42~hmac=216a2694c357ef999a1bdfc0bd821bdc786ac586f5356ffda709c9fd2400992d",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/6e7a6c8f36669dcd11abe7e7c3222e91/250x250-000000-80-0-0.jpg",
    genre: "Rap/Hip Hop",
  },
  {
    title: "Beneath Your Beautiful (feat. Emeli Sandé)",
    artist: "Labrinth",
    id: 16753987,
    release_date: "2012-03-30",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/e/a/5/0/ea5149844ed2bfc56f9d1ea6bad914fe.mp3?hdnea=exp=1763731681~acl=/api/1/1/e/a/5/0/ea5149844ed2bfc56f9d1ea6bad914fe.mp3*~data=user_id=0,application_id=42~hmac=975504f83eb7de742dbeabb2cfa6204ab57bb48fa8075622be9e4ea50a7f3128",
    cover: "https://api.deezer.com/album/1569082/image",
    genre: "Pop",
  },
  {
    title: "Little Talks",
    artist: "Of Monsters and Men",
    id: 17615568,
    release_date: "2012-04-03",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/b/f/6/0/bf6c6c9357af965de4ef5669feb31fbf.mp3?hdnea=exp=1763730766~acl=/api/1/1/b/f/6/0/bf6c6c9357af965de4ef5669feb31fbf.mp3*~data=user_id=0,application_id=42~hmac=3fb64f703bacf3916d782073b994281abf6542f05b38e7d7f546f8d5d3935c51",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/fd269461cb1125e4d74abfc21ba39e6e/250x250-000000-80-0-0.jpg",
    genre: "Alternative",
  },
  {
    title: "Everybody Talks",
    artist: "Neon Trees",
    id: 17806810,
    release_date: "2012-04-17",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/d/4/7/0/d4715c243a3d84edcd4a59fa139266e2.mp3?hdnea=exp=1763730766~acl=/api/1/1/d/4/7/0/d4715c243a3d84edcd4a59fa139266e2.mp3*~data=user_id=0,application_id=42~hmac=27646baae9d29842f5b123b9fa4fe2f98288a75e7f2607fe34c3dc96a7c9d6a0",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/aa71c0d064e5698ac486c5bb8005318a/250x250-000000-80-0-0.jpg",
    genre: "Alternative",
  },
  {
    title: "I Won't Give Up",
    artist: "Jason Mraz",
    id: 17827563,
    release_date: "2012-04-13",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/e/a/c/0/eacaaa65ff55bc5ab69d3915bbd0c4c0.mp3?hdnea=exp=1763730766~acl=/api/1/1/e/a/c/0/eacaaa65ff55bc5ab69d3915bbd0c4c0.mp3*~data=user_id=0,application_id=42~hmac=4ad31dafa9d5c4ed1f4a24bab6ac63615ac9480b4bc7d4408ef535a0993b0abd",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/8bfa86b30b8d0278a6253c9631b3202d/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Drive By",
    artist: "Train",
    id: 17880924,
    release_date: "2012-04-13",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/1/f/2/0/1f2c80b3cbbf8ad052a3fa42cd981588.mp3?hdnea=exp=1763730766~acl=/api/1/1/1/f/2/0/1f2c80b3cbbf8ad052a3fa42cd981588.mp3*~data=user_id=0,application_id=42~hmac=b2e6f3ca3181b989cb5e44b270aa7f71727b0a1e5b640841276b3e643f4a847a",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/cbfad98434163acc07e30fb557404b18/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "I Do (Cherish You)",
    artist: "98º",
    id: 18059138,
    release_date: "1998-07-11",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/f030ef60160074e69f2451a4b4ac2aad/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Move Your Body (D.J.Gabry Ponte Original Radio Edit)",
    artist: "Eiffel 65",
    id: 18061916,
    release_date: "1999-01-18",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/3/1/e/0/31eb8f988ee9a2ca899c113d4e26f002.mp3?hdnea=exp=1763730766~acl=/api/1/1/3/1/e/0/31eb8f988ee9a2ca899c113d4e26f002.mp3*~data=user_id=0,application_id=42~hmac=daeb467920850e86e1126b22f79a97fa1d1208b69b29b5018dd26845a87d9bd6",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/ed32356ccdb1a74ad08c01a0f588c37f/250x250-000000-80-0-0.jpg",
    genre: "Dance",
  },
  {
    title: "All This Time",
    artist: "Sting",
    id: 18221389,
    release_date: "2011-11-01",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/0/c/d/0/0cd6de9f892b0251c8706eb373b8948b.mp3?hdnea=exp=1763730766~acl=/api/1/1/0/c/d/0/0cd6de9f892b0251c8706eb373b8948b.mp3*~data=user_id=0,application_id=42~hmac=87aba9abe440c0febbc5d93ce825d9a516f919cde995bb67bfbf7d15888b681f",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/373b3c7bed40c3e7637432bb3e76d1b8/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "So Good",
    artist: "B.o.B",
    id: 18227779,
    release_date: "2012-04-27",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/5/0/b/0/50b8dce4877e3a84154cd5bb9c2bee3e.mp3?hdnea=exp=1763730766~acl=/api/1/1/5/0/b/0/50b8dce4877e3a84154cd5bb9c2bee3e.mp3*~data=user_id=0,application_id=42~hmac=372fd07fb840ca95af63f7b0dd8f7f720cbb91b8a1b8cc61ddf264ab3768c1a9",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/32e50032afeddaedb645363434f238bc/250x250-000000-80-0-0.jpg",
    genre: "Rap/Hip Hop",
  },
  {
    title: "Whistle",
    artist: "Flo Rida",
    id: 18232117,
    release_date: "2012-04-24",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/b/f/f/0/bffc653084e7457cc0e2e4d90c721d7e.mp3?hdnea=exp=1763730766~acl=/api/1/1/b/f/f/0/bffc653084e7457cc0e2e4d90c721d7e.mp3*~data=user_id=0,application_id=42~hmac=7908029027e295ea372ba226163272edeeeb75409ea838e78c2245301c706eb6",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/e92a46b7e2132f83a0416b0e4606c131/250x250-000000-80-0-0.jpg",
    genre: "Rap/Hip Hop",
  },
  {
    title: "Put Your Hands Up for Detroit",
    artist: "Fedde Le Grand",
    id: 18639001,
    release_date: "2011-05-20",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/e82d1c5e060cd1da1a287c7b634c3377/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Beautiful Life",
    artist: "Ace of Base",
    id: 92382204,
    release_date: "2008-11-14",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/d/6/5/0/d65c02a59ace13cef93a430e5a98ee4e.mp3?hdnea=exp=1763731681~acl=/api/1/1/d/6/5/0/d65c02a59ace13cef93a430e5a98ee4e.mp3*~data=user_id=0,application_id=42~hmac=138764f2c6edcc343680fec306a1bd281a828295c28586e188c01b05619319db",
    cover: "https://api.deezer.com/album/9373934/image",
    genre: "Pop",
  },
  {
    title: "You",
    artist: "Ten Sharp",
    id: 22961611,
    release_date: "2015-03-01",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/b/2/1/0/b21eec215da2b3ab2913bfa574f5ef6b.mp3?hdnea=exp=1763730766~acl=/api/1/1/b/2/1/0/b21eec215da2b3ab2913bfa574f5ef6b.mp3*~data=user_id=0,application_id=42~hmac=a4121138ee6f1e69189bf9084ba915457b3815f63dbb636c1f77f51a5cd305f5",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/51a063a30141836e34e32b32c8aa9b94/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Silhouettes",
    artist: "Avicii",
    id: 24276241,
    release_date: "2012-04-27",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/9/0/0/0/9004ac6d42a8fe982df56c4c0ee21feb.mp3?hdnea=exp=1763730766~acl=/api/1/1/9/0/0/0/9004ac6d42a8fe982df56c4c0ee21feb.mp3*~data=user_id=0,application_id=42~hmac=b0ce259c2d71a32b02ad8a244808c68651ea4bf050bb75e091ac55ed1d00ec50",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/7cc97f6748a49d0950c388a5ae695fe1/250x250-000000-80-0-0.jpg",
    genre: "Dance",
  },
  {
    title: "Ruby",
    artist: "Kaiser Chiefs",
    id: 26608051,
    release_date: "2007-02-05",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/e/d/8/0/ed8910873cdf507873924886e91af794.mp3?hdnea=exp=1763730766~acl=/api/1/1/e/d/8/0/ed8910873cdf507873924886e91af794.mp3*~data=user_id=0,application_id=42~hmac=22e26ac9a73ceef8250107b645560f594a86cfc3b87658bc78971510930058ea",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/20d08d2d341364bebb9296f5d12a6004/250x250-000000-80-0-0.jpg",
    genre: "Alternative",
  },
  {
    title: "Pound The Alarm",
    artist: "Nicki Minaj",
    id: 28852761,
    release_date: "2012-05-15",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/1/f/9/0/1f93ff825e51a53f6b1fea6d9312aa8b.mp3?hdnea=exp=1763730766~acl=/api/1/1/1/f/9/0/1f93ff825e51a53f6b1fea6d9312aa8b.mp3*~data=user_id=0,application_id=42~hmac=c69ce4cf30328941f21c4f59d6b429fe3949ce3b851b12b39901f0ad8aa370aa",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/3de7484240aaf23e129662c5914707df/250x250-000000-80-0-0.jpg",
    genre: "Rap/Hip Hop",
  },
  {
    title: "Got to Get It",
    artist: "Culture Beat",
    id: 29794791,
    release_date: "1993-05-11",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/5/a/2/0/5a2da38ebe57ef6e3d1b61af186c9486.mp3?hdnea=exp=1763730766~acl=/api/1/1/5/a/2/0/5a2da38ebe57ef6e3d1b61af186c9486.mp3*~data=user_id=0,application_id=42~hmac=45fb7a81a32c53aaee81613a71b1d7b62b082d5d95e4aa4056e527a52672be23",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/a652433c79217dc6e885cfa28428f174/250x250-000000-80-0-0.jpg",
    genre: "Dance",
  },
  {
    title: "I Believe In You",
    artist: "Kylie Minogue",
    id: 3164047,
    release_date: "2004-11-29",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/b/a/3/0/ba3ff6a82c24f68d806afc3b1bb652a6.mp3?hdnea=exp=1763731681~acl=/api/1/1/b/a/3/0/ba3ff6a82c24f68d806afc3b1bb652a6.mp3*~data=user_id=0,application_id=42~hmac=48745cf7be7be7e5a17483185aedcfc43a98dce6e282ccc627da4aa32d6d3bab",
    cover: "https://api.deezer.com/album/303924/image",
    genre: "Pop",
  },
  {
    title: "Levels",
    artist: "Avicii",
    id: 32109141,
    release_date: "2012-06-04",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/8683a6d123ea9e86c3640c88b9abaf82/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "This Love",
    artist: "Maroon 5",
    id: 33382301,
    release_date: "2004-01-27",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/e/a/9/0/ea9275e9e444b5b77003498f0c37c270.mp3?hdnea=exp=1763730766~acl=/api/1/1/e/a/9/0/ea9275e9e444b5b77003498f0c37c270.mp3*~data=user_id=0,application_id=42~hmac=dd05b4503d7f27d58bf2d37489463da3b1b96b184a26d42dad0904f8eae0e702",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/a93caa280e6dd750508aa54c932b6bbe/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Oh Girl",
    artist: "Paul Young",
    id: 33542981,
    release_date: "2012-06-11",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/d/b/b/0/dbb79a9447d6361c33ebe2b933067b40.mp3?hdnea=exp=1763730766~acl=/api/1/1/d/b/b/0/dbb79a9447d6361c33ebe2b933067b40.mp3*~data=user_id=0,application_id=42~hmac=fe27180728490cc1b50902b7ad86b2debf0a6b15edfb441cbd2a50039c9e448f",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/4cbb211fb5094813bb24349ef206ee75/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Boyfriend",
    artist: "Justin Bieber",
    id: 37027901,
    release_date: "2012-06-19",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/6/5/0/0/650db3085582715b3fb6bf8f27e84b33.mp3?hdnea=exp=1763730766~acl=/api/1/1/6/5/0/0/650db3085582715b3fb6bf8f27e84b33.mp3*~data=user_id=0,application_id=42~hmac=2191164279ca137e9115c1b2c7d97dd0a120c98ed5ee745dfbfd01e13e5361d7",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/312ece7b31fb86c7a13afd757e99437c/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Beauty And A Beat",
    artist: "Justin Bieber",
    id: 37027991,
    release_date: "2012-06-19",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/a/1/c/0/a1c35032aab8a465a73991e05ac30db6.mp3?hdnea=exp=1763730767~acl=/api/1/1/a/1/c/0/a1c35032aab8a465a73991e05ac30db6.mp3*~data=user_id=0,application_id=42~hmac=39bed3022711904d3ef414bdf50f7600c981b21626dec22a478e4c7196675ad3",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/312ece7b31fb86c7a13afd757e99437c/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Tender",
    artist: "Blur",
    id: 38442111,
    release_date: "1998-03-15",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/3/0/c/0/30c0d64507bb23e63a76471753453afb.mp3?hdnea=exp=1763730767~acl=/api/1/1/3/0/c/0/30c0d64507bb23e63a76471753453afb.mp3*~data=user_id=0,application_id=42~hmac=d1cbf398f425271a35553e1f1a30a898234e8ef9e1903dc4d90d0c92924f1fdf",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/d8ca3605465df71d54cd5204b7d2a38f/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "Coffee & TV",
    artist: "Blur",
    id: 38442131,
    release_date: "1998-03-15",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/f/f/e/0/ffeb35f14c92787e4f1fb7360c171eb2.mp3?hdnea=exp=1763730767~acl=/api/1/1/f/f/e/0/ffeb35f14c92787e4f1fb7360c171eb2.mp3*~data=user_id=0,application_id=42~hmac=b312461219a55844fb39384fc4daebcc92a2e255e44ef0ef9445391d381693ed",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/d8ca3605465df71d54cd5204b7d2a38f/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "Payphone",
    artist: "Maroon 5",
    id: 38934641,
    release_date: "2012-06-25",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/d/e/1/0/de10d6ccef12d0c1cecf774a858fe28b.mp3?hdnea=exp=1763730767~acl=/api/1/1/d/e/1/0/de10d6ccef12d0c1cecf774a858fe28b.mp3*~data=user_id=0,application_id=42~hmac=75d06676099812fd87b665c030e28671549522c80f7ff5c7c4017294514cfac7",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/81d7aae96ab55297abdfd5370f6b38a0/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Turn Up the Music",
    artist: "Chris Brown",
    id: 648151672,
    release_date: "2014-12-18",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/1/f/2/0/1f2912434e5f4bbb8e0110293dff6ac4.mp3?hdnea=exp=1763731681~acl=/api/1/1/1/f/2/0/1f2912434e5f4bbb8e0110293dff6ac4.mp3*~data=user_id=0,application_id=42~hmac=c6e4f0890684228aa94d784dcc5c3c17c4be3724c2bf328049fe4cdcd3d011f0",
    cover: "https://api.deezer.com/album/90252342/image",
    genre: "Pop",
  },
  {
    title: "Don't Wake Me Up",
    artist: "Chris Brown",
    id: 46711461,
    release_date: "2012-06-29",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/d/6/f/0/d6f5faf0b1624ac72ddc8765180f0423.mp3?hdnea=exp=1763731681~acl=/api/1/1/d/6/f/0/d6f5faf0b1624ac72ddc8765180f0423.mp3*~data=user_id=0,application_id=42~hmac=8605920c429d5255baa4504b26503cdf5b848155d240a74a4ec86bc1a8ba3c59",
    cover: "https://api.deezer.com/album/4622281/image",
    genre: "Pop",
  },
  {
    title: "True Love",
    artist: "Elton John",
    id: 40987781,
    release_date: "1993-11-22",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/f/e/a/0/feac0a1ba6fbfccae7d11349014c0389.mp3?hdnea=exp=1763730767~acl=/api/1/1/f/e/a/0/feac0a1ba6fbfccae7d11349014c0389.mp3*~data=user_id=0,application_id=42~hmac=69181245897cb96fb5883f0f83c15a672fb0f239830d4c7833036f3d15711a01",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/bd76e50c54c1298735a0ebe320aafd94/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Kingston Town",
    artist: "UB40",
    id: 41299901,
    release_date: "1989-09-27",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/0/1/0/0/0109b3ed870115ed2bcf12c5ccf9d60f.mp3?hdnea=exp=1763730767~acl=/api/1/1/0/1/0/0/0109b3ed870115ed2bcf12c5ccf9d60f.mp3*~data=user_id=0,application_id=42~hmac=70e1710a76ca1f200367b17e60fcf25773b5ddfb137cc97ed2e7146c8525f40f",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/22dd28eab628af31319dbcc1873e8085/250x250-000000-80-0-0.jpg",
    genre: "Reggae",
  },
  {
    title: "One More Night",
    artist: "Maroon 5",
    id: 44230981,
    release_date: "2012-07-17",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/8/6/8/0/8681a5aa3360951b22e4a305028c7f4a.mp3?hdnea=exp=1763730165~acl=/api/1/1/8/6/8/0/8681a5aa3360951b22e4a305028c7f4a.mp3*~data=user_id=0,application_id=42~hmac=91b3eb6d0ecd0552fe237fb45481a4a09b4575c3e64192f12f035cefbfb55c9b",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/81d7aae96ab55297abdfd5370f6b38a0/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Try Again",
    artist: "Aaliyah",
    id: 3380593991,
    release_date: "2008-10-18",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/c/2/b/0/c2bbd17cff3376ce27407e6286860431.mp3?hdnea=exp=1763731681~acl=/api/1/1/c/2/b/0/c2bbd17cff3376ce27407e6286860431.mp3*~data=user_id=0,application_id=42~hmac=0a16b627b5cf3f6fbf4afab55c6d5caa3de9fd5c4c289189958c4ed7c4eafd77",
    cover: "https://api.deezer.com/album/761244101/image",
    genre: "Pop",
  },
  {
    title: "Spectrum",
    artist: "Florence + The Machine",
    id: 45594311,
    release_date: "2012-07-30",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/1/5/0/0/150ed47971402d921932b0ea8ec86e69.mp3?hdnea=exp=1763730165~acl=/api/1/1/1/5/0/0/150ed47971402d921932b0ea8ec86e69.mp3*~data=user_id=0,application_id=42~hmac=f1e9031ebaf098c1ab7d346f0dcb813bc2d34a19c15c856d5dde2e0935c8f305",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/62d6168fd810482d09252025d9f69b0a/250x250-000000-80-0-0.jpg",
    genre: "Alternative",
  },
  {
    title: "Good Time",
    artist: "Owl City",
    id: 53825251,
    release_date: "2012-08-21",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/e/6/0/0/e6058714e4015c2e5d20452bc73a5eb0.mp3?hdnea=exp=1763730165~acl=/api/1/1/e/6/0/0/e6058714e4015c2e5d20452bc73a5eb0.mp3*~data=user_id=0,application_id=42~hmac=42525476df760518ed22edf61426f76705fdfe8af9aa85cb4253b2d09c0ef4cf",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/7e6ddcd830f7a041f606d7b29864be2e/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "I Love It (feat. Charli XCX)",
    artist: "Icona Pop",
    id: 54420921,
    release_date: "2012-06-19",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/4/5/8/0/458d1533b9d9aca38352307e6f690c86.mp3?hdnea=exp=1763730165~acl=/api/1/1/4/5/8/0/458d1533b9d9aca38352307e6f690c86.mp3*~data=user_id=0,application_id=42~hmac=26e222d12c9b99c0a680bd637aacb7dee7f6f7fe6020645e9daa0cd92fdbd853",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/2ce4269eefe4ffc9aee9c2f47c2be3eb/250x250-000000-80-0-0.jpg",
    genre: "Dance",
  },
  {
    title: "How We Do (Party)",
    artist: "Rita Ora",
    id: 2466003705,
    release_date: "2012-08-27",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/f/c/5/0/fc55b393f6389c36ef2cfb6c127333e8.mp3?hdnea=exp=1763731681~acl=/api/1/1/f/c/5/0/fc55b393f6389c36ef2cfb6c127333e8.mp3*~data=user_id=0,application_id=42~hmac=5e83634246f0a6ee7a3413244fb14b01938c4d1f1e5434be16a988c437cee5ef",
    cover: "https://api.deezer.com/album/491145435/image",
    genre: "Pop",
  },
  {
    title: "Hall of Fame (feat. will.i.am)",
    artist: "The Script",
    id: 55848051,
    release_date: "2012-08-31",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/2/5/a/0/25ac28a34347f227645db2390836ee41.mp3?hdnea=exp=1763726049~acl=/api/1/1/2/5/a/0/25ac28a34347f227645db2390836ee41.mp3*~data=user_id=0,application_id=42~hmac=130608b8f39eb650367c660211a379024c8a105d72c26e77a509e0c9feb1730a",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/049dca48d45587b1bc5d2c47d7b875e8/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Blow Me (One Last Kiss)",
    artist: "P!nk",
    id: 60200371,
    release_date: "2012-09-18",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/8/1/3/0/813f66b8fb41d98591e89b9c24cd73ae.mp3?hdnea=exp=1763726049~acl=/api/1/1/8/1/3/0/813f66b8fb41d98591e89b9c24cd73ae.mp3*~data=user_id=0,application_id=42~hmac=87638d8d520bbdb3aeac0032280e49a9884dfd8ae6f54567fc5b86d1d0f78114",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/a43e104f2ff2872df2e1bf4207b6b5e6/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Candy Shop",
    artist: "50 Cent",
    id: 60722933,
    release_date: "2005-03-03",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/6/b/7/0/6b75f1ca24e351627fa804474d3d0b5f.mp3?hdnea=exp=1763726049~acl=/api/1/1/6/b/7/0/6b75f1ca24e351627fa804474d3d0b5f.mp3*~data=user_id=0,application_id=42~hmac=ca6f774e3aeccedd55ad8487a5f5c3cfc207ac61d2644d584e42624b772a0c57",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/8550ab66b25e9ccfbe3cad3cdb7d8284/250x250-000000-80-0-0.jpg",
    genre: "Rap/Hip Hop",
  },
  {
    title: "Just A Lil Bit",
    artist: "50 Cent",
    id: 60722940,
    release_date: "2005-03-03",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/c/5/8/0/c58894093a7a34c8ec39095dc54c2099.mp3?hdnea=exp=1763726049~acl=/api/1/1/c/5/8/0/c58894093a7a34c8ec39095dc54c2099.mp3*~data=user_id=0,application_id=42~hmac=77577b54494c7444591813d6b38686f2c193f2f8a86c8eed4d8582dfa5988111",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/8550ab66b25e9ccfbe3cad3cdb7d8284/250x250-000000-80-0-0.jpg",
    genre: "Rap/Hip Hop",
  },
  {
    title: "Gangnam Style (강남스타일)",
    artist: "Psy",
    id: 60726278,
    release_date: "2012-09-06",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/3/a/0/0/3a0567e318e4ca3102cc6ab1579ec61b.mp3?hdnea=exp=1763726049~acl=/api/1/1/3/a/0/0/3a0567e318e4ca3102cc6ab1579ec61b.mp3*~data=user_id=0,application_id=42~hmac=141d99c86cf7654b9dfa8c921c94862184b39900c993542d1503ff8b4aba33cf",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/45e4493fcc15997085491debddcf049e/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "I Will Wait",
    artist: "Mumford & Sons",
    id: 60742288,
    release_date: "2012-09-24",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/c/4/1/0/c41c64f39b55e6b501b902b215abebfd.mp3?hdnea=exp=1763726049~acl=/api/1/1/c/4/1/0/c41c64f39b55e6b501b902b215abebfd.mp3*~data=user_id=0,application_id=42~hmac=2a08aab2e012934926a7ab496be48acd6b8f2e3a787d3a6815c244f3b7c5cc95",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/e41dc3e801f3972cc417ed83654a1b11/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "Something",
    artist: "Lasgo",
    id: 60831419,
    release_date: "2011-09-22",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/5/3/2/0/53240fa388efbf084ac5fb32b851a719.mp3?hdnea=exp=1763726049~acl=/api/1/1/5/3/2/0/53240fa388efbf084ac5fb32b851a719.mp3*~data=user_id=0,application_id=42~hmac=6b20067d92eeea3f9fd83032dda8bc3a133796cd7ebdc2516e84cf3b59a66b92",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/39a9a6a52c3bce30aa4f3a76a35ef53e/250x250-000000-80-0-0.jpg",
    genre: "Dance",
  },
  {
    title: "Don't You Worry Child",
    artist: "Swedish House Mafia",
    id: 60842359,
    release_date: "2015-06-07",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/2/1/8/0/2184ae5bfff6b4af12135560d359abe9.mp3?hdnea=exp=1763726049~acl=/api/1/1/2/1/8/0/2184ae5bfff6b4af12135560d359abe9.mp3*~data=user_id=0,application_id=42~hmac=0ecdaf86c164a00736cb747b9685ffaa3a952e906c25addee41160da4ec93bae",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/a6e59fada64940a751de6eaa01229e8b/250x250-000000-80-0-0.jpg",
    genre: "Dance",
  },
  {
    title: "Die Young",
    artist: "Ke$ha",
    id: 60847163,
    release_date: "2014-12-18",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/d/9/6/0/d96b59ae5c90ff9bde68f741f420ca55.mp3?hdnea=exp=1763726049~acl=/api/1/1/d/9/6/0/d96b59ae5c90ff9bde68f741f420ca55.mp3*~data=user_id=0,application_id=42~hmac=24200d9f32ed4bbb427dc7b944fb5efc061e935fe01ea90d05fcee5db95e66d5",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/3ca332797349e6a5921abbc7f48152a2/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Clarity",
    artist: "Zedd",
    id: 60904700,
    release_date: "2013-09-10",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/e/9/3/0/e9361dad0bf958c5bccb53ed096be917.mp3?hdnea=exp=1763726049~acl=/api/1/1/e/9/3/0/e9361dad0bf958c5bccb53ed096be917.mp3*~data=user_id=0,application_id=42~hmac=ceedcede78816210a98e6071017fe671db5583bbf8ed33dc2751cef174c7c7d3",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/6b8a51cd4d5e2a277c8a1c4f88d59489/250x250-000000-80-0-0.jpg",
    genre: "Dance",
  },
  {
    title: "Diamonds",
    artist: "Rihanna",
    id: 60978718,
    release_date: "2012-09-27",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/d/9/a/0/d9a6e59bc4f67c830ab1df243e976e55.mp3?hdnea=exp=1763726049~acl=/api/1/1/d/9/a/0/d9a6e59bc4f67c830ab1df243e976e55.mp3*~data=user_id=0,application_id=42~hmac=acf38437a22b20023aeac324efca446e913e98e2a0cdf156ade667d5441c50bb",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/a1b2457fcd12bb9ed5488e4bbd01ec25/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Feel So Close",
    artist: "Calvin Harris",
    id: 61142285,
    release_date: "2012-10-26",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/e/3/2/0/e32ccdaea23d6c132f169d9828b8cf39.mp3?hdnea=exp=1763726049~acl=/api/1/1/e/3/2/0/e32ccdaea23d6c132f169d9828b8cf39.mp3*~data=user_id=0,application_id=42~hmac=acad04f4497c6dcfab56e26c391896616c08cb76a067a94e7be6aaa1d2c966b9",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/3cd154b7ee332e7fb0dc3e8bd4085f6b/250x250-000000-80-0-0.jpg",
    genre: "Dance",
  },
  {
    title: "I Need Your Love",
    artist: "Calvin Harris",
    id: 61142290,
    release_date: "2013-08-12",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/4/6/d/0/46de48e9209011ad736fbd69feb3c878.mp3?hdnea=exp=1763726049~acl=/api/1/1/4/6/d/0/46de48e9209011ad736fbd69feb3c878.mp3*~data=user_id=0,application_id=42~hmac=d0621bb986e3243f840a638db0cf5df2fc9ddb21f3a1d8dc17d38866a06a1aea",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/3cd154b7ee332e7fb0dc3e8bd4085f6b/250x250-000000-80-0-0.jpg",
    genre: "Dance",
  },
  {
    title: "Sweet Nothing",
    artist: "Calvin Harris",
    id: 61142292,
    release_date: "2012-10-26",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/4/6/c/0/46cb8f19ad68002be74eb1aa3dbd38e1.mp3?hdnea=exp=1763726049~acl=/api/1/1/4/6/c/0/46cb8f19ad68002be74eb1aa3dbd38e1.mp3*~data=user_id=0,application_id=42~hmac=510f7182efc6dd932f712a022b585a760b5f9aa8cf49b41955b18304a71f9940",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/3cd154b7ee332e7fb0dc3e8bd4085f6b/250x250-000000-80-0-0.jpg",
    genre: "Dance",
  },
  {
    title: "Thinking About You",
    artist: "Calvin Harris",
    id: 61142297,
    release_date: "2012-10-26",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/5/d/3/0/5d3131b58e76d44cc83c952dc20c1330.mp3?hdnea=exp=1763726049~acl=/api/1/1/5/d/3/0/5d3131b58e76d44cc83c952dc20c1330.mp3*~data=user_id=0,application_id=42~hmac=193912daf8339d85bd3cede1dce0d7adceec7736b0d493f8df4739785cc7ac14",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/3cd154b7ee332e7fb0dc3e8bd4085f6b/250x250-000000-80-0-0.jpg",
    genre: "Dance",
  },
  {
    title: "Unfinished Sympathy",
    artist: "Massive Attack",
    id: 61381707,
    release_date: "1991-02-11",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/6/4/3/0/643c0983f745f7b3b1bd56aef2069a1d.mp3?hdnea=exp=1763726049~acl=/api/1/1/6/4/3/0/643c0983f745f7b3b1bd56aef2069a1d.mp3*~data=user_id=0,application_id=42~hmac=b9786191a5090e45a2858e0f933a83d2008411628a79bca7f008e1c11e73ad67",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/81ba5b6bf32dcbf2e2dae244a7cfab51/250x250-000000-80-0-0.jpg",
    genre: "Electro",
  },
  {
    title: "U Got 2 Let The Music",
    artist: "Cappella",
    id: 61405980,
    release_date: "1993-11-20",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/7/5/0/0/750ed79b3c75f221d887b6426647a8f0.mp3?hdnea=exp=1763726049~acl=/api/1/1/7/5/0/0/750ed79b3c75f221d887b6426647a8f0.mp3*~data=user_id=0,application_id=42~hmac=2eb782542ea65030d099d78e025a0c9300bdd172ee618739a747f97d0ef1d1dc",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/1dca0975da499b5d0a201bbadc034bd2/250x250-000000-80-0-0.jpg",
    genre: "Dance",
  },
  {
    title: "Can't Hold Us (feat. Ray Dalton)",
    artist: "Macklemore & Ryan Lewis",
    id: 61424044,
    release_date: "2012-10-09",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/b/c/6/0/bc66a201d24622fb130e7a624b1679fd.mp3?hdnea=exp=1763726049~acl=/api/1/1/b/c/6/0/bc66a201d24622fb130e7a624b1679fd.mp3*~data=user_id=0,application_id=42~hmac=32147b0efa2b0148b313c922adc84902bf9a010a2a3da1a8d99782d5686a1096",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/238f1c36e8445fd162d1d53b8181ecb5/250x250-000000-80-0-0.jpg",
    genre: "Rap/Hip Hop",
  },
  {
    title: "Thrift Shop (feat. Wanz)",
    artist: "Macklemore & Ryan Lewis",
    id: 61424045,
    release_date: "2012-10-09",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/5/9/9/0/5995c9379a056ada2feb902bc04f10ae.mp3?hdnea=exp=1763726049~acl=/api/1/1/5/9/9/0/5995c9379a056ada2feb902bc04f10ae.mp3*~data=user_id=0,application_id=42~hmac=aecfd3296c34d5fb8edc4d4ea57b5e860f6a764d31af56dfa19faad2947509c3",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/238f1c36e8445fd162d1d53b8181ecb5/250x250-000000-80-0-0.jpg",
    genre: "Rap/Hip Hop",
  },
  {
    title: "Same Love (feat. Mary Lambert)",
    artist: "Macklemore & Ryan Lewis",
    id: 61424047,
    release_date: "2012-10-09",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/3/b/3/0/3b3c48d359ef09f96e3c221fa86255b9.mp3?hdnea=exp=1763726049~acl=/api/1/1/3/b/3/0/3b3c48d359ef09f96e3c221fa86255b9.mp3*~data=user_id=0,application_id=42~hmac=696a7293a7f91e435c1a4d6ee4aac19f8e750da78aaa8b1e840b8b69fd616584",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/238f1c36e8445fd162d1d53b8181ecb5/250x250-000000-80-0-0.jpg",
    genre: "Rap/Hip Hop",
  },
  {
    title: "Girl on Fire",
    artist: "Alicia Keys",
    id: 61542462,
    release_date: "2012-11-18",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/c/d/0/0/cd0e2fd4e4795705f2469d8d32242f06.mp3?hdnea=exp=1763726049~acl=/api/1/1/c/d/0/0/cd0e2fd4e4795705f2469d8d32242f06.mp3*~data=user_id=0,application_id=42~hmac=2ccb20d98b301cbea69a161ad1a285ac676c7d6567069215c7b16c1ff0c2cfeb",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/36c185941d3fd043ff9861d89040ba46/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Live While We're Young",
    artist: "One Direction",
    id: 61644195,
    release_date: "2012-11-09",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/b/a/2/0/ba2762da1f8ab5f38bf8df6b7c38220d.mp3?hdnea=exp=1763731681~acl=/api/1/1/b/a/2/0/ba2762da1f8ab5f38bf8df6b7c38220d.mp3*~data=user_id=0,application_id=42~hmac=10fc89dae77a51b7c67d8d56cc3fd3400d41f1e2763f1e77f5e50ed4bd69595c",
    cover: "https://api.deezer.com/album/6041110/image",
    genre: "Pop",
  },
  {
    title: "Come With Me : Come With Me",
    artist: "Special D.",
    id: 61675981,
    release_date: "2004-08-02",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/e/9/f/0/e9fee18b7f669e819803a894264ceccf.mp3?hdnea=exp=1763726049~acl=/api/1/1/e/9/f/0/e9fee18b7f669e819803a894264ceccf.mp3*~data=user_id=0,application_id=42~hmac=a5f870d0d69fbef41a6655f737c25abf4ace12f9f00c56cd80b657b49a242764",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/42b418c533629608f88853d1105164cf/250x250-000000-80-0-0.jpg",
    genre: "Electro",
  },
  {
    title: "Let Me Love You (Until You Learn To Love Yourself)",
    artist: "Ne-Yo",
    id: 61793545,
    release_date: "2012-11-06",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/e/6/a/0/e6ae2c638a0ed498d87203d96b15b2bb.mp3?hdnea=exp=1763726049~acl=/api/1/1/e/6/a/0/e6ae2c638a0ed498d87203d96b15b2bb.mp3*~data=user_id=0,application_id=42~hmac=47bbf0e05ba01ae65f41c93775e3b8398ece19044d7b5acd7a5790722bc7cf5c",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/13a5fae9ef2b362718fd963d02af49d5/250x250-000000-80-0-0.jpg",
    genre: "R&B",
  },
  {
    title: "Let Her Go",
    artist: "Passenger",
    id: 604074552,
    release_date: "2012-11-05",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/d/d/8/0/dd8f319d5229834f112e95fcaf08696c.mp3?hdnea=exp=1763731681~acl=/api/1/1/d/d/8/0/dd8f319d5229834f112e95fcaf08696c.mp3*~data=user_id=0,application_id=42~hmac=f46a8c79d151f373dc9b9ca20a04f8c4a7649b6638e020408ed664d305548a64",
    cover: "https://api.deezer.com/album/81710372/image",
    genre: "Pop",
  },
  {
    title: "Leave (Get Out)",
    artist: "JoJo",
    id: 89867937,
    release_date: "2005-09-30",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/9/b/4/0/9b43a8628d6060ce5e81e6423db933bc.mp3?hdnea=exp=1763731681~acl=/api/1/1/9/b/4/0/9b43a8628d6060ce5e81e6423db933bc.mp3*~data=user_id=0,application_id=42~hmac=a10afec53f31c01e371954b89674d8e01cf6545b5977659c397924b7ca63d18b",
    cover: "https://api.deezer.com/album/9101331/image",
    genre: "Pop",
  },
  {
    title: "Ooh Aah (Just a Little Bit)",
    artist: "Gina G",
    id: 62166934,
    release_date: "1997-11-16",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/3f376afe41ca5983862adfb1042bd2e7/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Everytime You Need Me (Radio Version)",
    artist: "Fragma",
    id: 62172333,
    release_date: "2001-01-08",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/a/7/b/0/a7ba8e541702d55da58865fbbf6b8e04.mp3?hdnea=exp=1763726049~acl=/api/1/1/a/7/b/0/a7ba8e541702d55da58865fbbf6b8e04.mp3*~data=user_id=0,application_id=42~hmac=aea73131d89219dc62603ef3a6f6389465ca15694b39d5cef20ad2087a85dd92",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/f7ce9233e857aa2dca89b169b79c5eda/250x250-000000-80-0-0.jpg",
    genre: "Electro",
  },
  {
    title: "Stay (Album Version)",
    artist: "Rihanna",
    id: 62376291,
    release_date: "2012-11-19",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/0/2/4/0/024fa2b07b9cf44a902aa11ad7494cde.mp3?hdnea=exp=1763726049~acl=/api/1/1/0/2/4/0/024fa2b07b9cf44a902aa11ad7494cde.mp3*~data=user_id=0,application_id=42~hmac=7299deea000bc4abbc827496a4594ab72176c1291883b0ab802d472b60152bbd",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/246fb21e05da3d1460eb147123bb906b/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Ain't No Other Man",
    artist: "Christina Aguilera",
    id: 62417658,
    release_date: "2006-08-14",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/d/a/9/0/da9f9098cf13ded444d345ad4c31b3b8.mp3?hdnea=exp=1763726049~acl=/api/1/1/d/a/9/0/da9f9098cf13ded444d345ad4c31b3b8.mp3*~data=user_id=0,application_id=42~hmac=3e476172faead0b3f7bccfa447e725b117e735cb7d6df93b61233c9f27bca800",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/3aa572afd198583c88297022bf2d9ddb/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Something Kinda Ooooh",
    artist: "Girls Aloud",
    id: 62418649,
    release_date: "2012-11-26",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/b/9/5/0/b95f3f8a3609e773e4df8c0c3fc34eb8.mp3?hdnea=exp=1763726049~acl=/api/1/1/b/9/5/0/b95f3f8a3609e773e4df8c0c3fc34eb8.mp3*~data=user_id=0,application_id=42~hmac=4171181720569c92006f389cdd3b40723fb8f125a8d128fa7dcbb55a68518d8d",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/ccac386ee2a76f429fab05ba71acd99f/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Scream & Shout",
    artist: "will.i.am",
    id: 62439051,
    release_date: "2012-11-20",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/0/e/2/0/0e2b31a4075e57790335569f13f32051.mp3?hdnea=exp=1763726049~acl=/api/1/1/0/e/2/0/0e2b31a4075e57790335569f13f32051.mp3*~data=user_id=0,application_id=42~hmac=5b25ad5c0de23105ab3b64259f6bbdf78ef462eff65dbe6588d27b77387c15f8",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/6da4573b0e3ef016f7618214a466eed2/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Star Girl",
    artist: "McFly",
    id: 62471655,
    release_date: "2012-11-26",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/1/0/a/0/10a3038d63c250e1a7a820e428d3615d.mp3?hdnea=exp=1763726049~acl=/api/1/1/1/0/a/0/10a3038d63c250e1a7a820e428d3615d.mp3*~data=user_id=0,application_id=42~hmac=053ccadce0f3df8e77e87095de9a1d0f83702c816ba522e6f3ef1ff6b48a4de8",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/4762dda7d47537a9759fa0b680a0c9a0/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Five Colours In Her Hair (U.S Version)",
    artist: "McFly",
    id: 62471686,
    release_date: "2012-11-26",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/d/d/6/0/dd6ff42fbcd583f48fc5712147020699.mp3?hdnea=exp=1763726049~acl=/api/1/1/d/d/6/0/dd6ff42fbcd583f48fc5712147020699.mp3*~data=user_id=0,application_id=42~hmac=ed05dc5f5dfb7628aaca51421549ab95cf6880f97d3cc3e220c0936ddfa41b02",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/4762dda7d47537a9759fa0b680a0c9a0/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Work Hard, Play Hard",
    artist: "Wiz Khalifa",
    id: 62557258,
    release_date: "2012-12-04",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/b/a/4/0/ba446c8cae70447115c5ea24ca8f98fd.mp3?hdnea=exp=1763726049~acl=/api/1/1/b/a/4/0/ba446c8cae70447115c5ea24ca8f98fd.mp3*~data=user_id=0,application_id=42~hmac=fce8522c81b448b87946cfc328025a1f084baebd4d1b6edd6034cb3f89419f29",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/2d6583447f0da9284bec73517752253d/250x250-000000-80-0-0.jpg",
    genre: "Rap/Hip Hop",
  },
  {
    title: "I'm Free",
    artist: "The Soup Dragons",
    id: 62637202,
    release_date: "2012-12-10",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/c/4/d/0/c4de62e096d89f2bd14702ae40f2c965.mp3?hdnea=exp=1763726049~acl=/api/1/1/c/4/d/0/c4de62e096d89f2bd14702ae40f2c965.mp3*~data=user_id=0,application_id=42~hmac=93d2804910833fe8be4b9a11aac3d64cb1ab914a94e6a24bc2e14a0167d16229",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/ef0b7e6071137d72900f460670b88c42/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "Locked out of Heaven",
    artist: "Bruno Mars",
    id: 62723995,
    release_date: "2012-12-01",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/9/3/f/0/93f14ffaa5cabb2d870c8b5efafcd4b1.mp3?hdnea=exp=1763726049~acl=/api/1/1/9/3/f/0/93f14ffaa5cabb2d870c8b5efafcd4b1.mp3*~data=user_id=0,application_id=42~hmac=ec854292d6c1445fa0e96f94d4758a72db10a27a2c94c6a9cce92224b221a07b",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/2ae8e9f1714cc6cc9393f7873008f45c/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Treasure",
    artist: "Bruno Mars",
    id: 62724017,
    release_date: "2012-12-07",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/a/a/2/0/aa2c2c603565ecfbe6dc4a965c58b185.mp3?hdnea=exp=1763726049~acl=/api/1/1/a/a/2/0/aa2c2c603565ecfbe6dc4a965c58b185.mp3*~data=user_id=0,application_id=42~hmac=31772d029d4e340d196a39d224ecf132f47455621ce34c9dccd3215ade9c60a7",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/2ae8e9f1714cc6cc9393f7873008f45c/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "When I Was Your Man",
    artist: "Bruno Mars",
    id: 62724019,
    release_date: "2012-12-07",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/3/d/9/0/3d95c3e6438380b922ae8877ebada436.mp3?hdnea=exp=1763726049~acl=/api/1/1/3/d/9/0/3d95c3e6438380b922ae8877ebada436.mp3*~data=user_id=0,application_id=42~hmac=ee07761cd63e0a134251f79bc49ca87f50d5f0a12e6af3b7879a47be05a508d9",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/2ae8e9f1714cc6cc9393f7873008f45c/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Titanium (feat. Sia)",
    artist: "David Guetta",
    id: 62847142,
    release_date: "2012-12-07",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/6/7/0/0/6704168518eedd6eff222b5fb55f86c0.mp3?hdnea=exp=1763726049~acl=/api/1/1/6/7/0/0/6704168518eedd6eff222b5fb55f86c0.mp3*~data=user_id=0,application_id=42~hmac=498e93632b9a89499cb0843ff8fd3cb1b670a9f88e12575586d06e6f05b3f0aa",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/7d4a24e294bb3c228ad96dd75512e2f0/250x250-000000-80-0-0.jpg",
    genre: "Dance",
  },
  {
    title: "She Wolf (Falling to Pieces) [feat. Sia]",
    artist: "David Guetta",
    id: 62847144,
    release_date: "2012-12-07",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/d/3/8/0/d386a76a92be9d322adcb29a1d68d9ff.mp3?hdnea=exp=1763726049~acl=/api/1/1/d/3/8/0/d386a76a92be9d322adcb29a1d68d9ff.mp3*~data=user_id=0,application_id=42~hmac=295fb42c6e4073cbfa342e785e3378d3ad64f7def4324734b399ac00002a5c61",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/7d4a24e294bb3c228ad96dd75512e2f0/250x250-000000-80-0-0.jpg",
    genre: "Dance",
  },
  {
    title: "Without You (feat. Usher)",
    artist: "David Guetta",
    id: 62847145,
    release_date: "2012-12-07",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/b/2/a/0/b2a1058f9cd4bcaff6fd6689c0db72c5.mp3?hdnea=exp=1763726049~acl=/api/1/1/b/2/a/0/b2a1058f9cd4bcaff6fd6689c0db72c5.mp3*~data=user_id=0,application_id=42~hmac=ac987d90bee2571b0c16c9626b043418b3242743374df9db1547fed38d7207e9",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/7d4a24e294bb3c228ad96dd75512e2f0/250x250-000000-80-0-0.jpg",
    genre: "Dance",
  },
  {
    title: "Where Them Girls At (feat. Nicki Minaj & Flo Rida)",
    artist: "David Guetta",
    id: 62847150,
    release_date: "2012-12-07",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/c/5/1/0/c51082f95148f0fbfe29856440ab4b99.mp3?hdnea=exp=1763726049~acl=/api/1/1/c/5/1/0/c51082f95148f0fbfe29856440ab4b99.mp3*~data=user_id=0,application_id=42~hmac=08a2f4d5130bd5877002721af4de41a830f6bddc1430229db78cd62fed418ee3",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/7d4a24e294bb3c228ad96dd75512e2f0/250x250-000000-80-0-0.jpg",
    genre: "Dance",
  },
  {
    title: "Pompeii",
    artist: "Bastille",
    id: 63034985,
    release_date: "2013-02-22",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/a/a/d/0/aadea7d50a71fb8f75cd5b49bf3b0fa1.mp3?hdnea=exp=1763726049~acl=/api/1/1/a/a/d/0/aadea7d50a71fb8f75cd5b49bf3b0fa1.mp3*~data=user_id=0,application_id=42~hmac=642f932c505987aecc0970bccc4510bdb35386347812a5fcbbe20b54394024d7",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/2d5984bac3f7865ea5a92a30221d5386/250x250-000000-80-0-0.jpg",
    genre: "Alternative",
  },
  {
    title: "Radioactive",
    artist: "Imagine Dragons",
    id: 63510358,
    release_date: "2013-02-05",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/4/3/2/0/43253a7dedefdd14b613839ab6b6e976.mp3?hdnea=exp=1763726049~acl=/api/1/1/4/3/2/0/43253a7dedefdd14b613839ab6b6e976.mp3*~data=user_id=0,application_id=42~hmac=4c9e10f1c976c90a4381b96624a605910224773cb1d48a3b76ad57b90ed5bb22",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/7e8314f4280cffde363547a495a260bc/250x250-000000-80-0-0.jpg",
    genre: "Alternative",
  },
  {
    title: "It's Over Now",
    artist: "112",
    id: 64471365,
    release_date: "2013-02-12",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/f/4/d/0/f4d2ba6d2b7fdf1fa45c3db6a5a5ff99.mp3?hdnea=exp=1763726049~acl=/api/1/1/f/4/d/0/f4d2ba6d2b7fdf1fa45c3db6a5a5ff99.mp3*~data=user_id=0,application_id=42~hmac=ce515f97077db0bc38c922b9955cd3e127a53c9c7f9205146c8a1eb27139cbc5",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/4fab66532af65edbee7b56c6547ff315/250x250-000000-80-0-0.jpg",
    genre: "R&B",
  },
  {
    title: "Peaches & Cream",
    artist: "112",
    id: 64471366,
    release_date: "2013-02-12",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/4/2/e/0/42ee6e1a63b9aa7436f6bb608b6f28e8.mp3?hdnea=exp=1763731681~acl=/api/1/1/4/2/e/0/42ee6e1a63b9aa7436f6bb608b6f28e8.mp3*~data=user_id=0,application_id=42~hmac=2da2560608251afbbd1efd56a9cdc4538eb6c013cee20018cee6b790fbf6c816",
    cover: "https://api.deezer.com/album/6315524/image",
    genre: "R&B",
  },
  {
    title: "Harlem Shake",
    artist: "Baauer",
    id: 64734097,
    release_date: "2013-05-22",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/4/a/2/0/4a2d0347b5ba2a50071ab9f0d535df5a.mp3?hdnea=exp=1763726049~acl=/api/1/1/4/a/2/0/4a2d0347b5ba2a50071ab9f0d535df5a.mp3*~data=user_id=0,application_id=42~hmac=7cf9043c43ac2942fdf05146544b4b6f14b2f52014631a1e5f74c6c05c39524a",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/bd39494987420479d7952267463aec97/250x250-000000-80-0-0.jpg",
    genre: "Electro",
  },
  {
    title: "Heart Attack",
    artist: "Demi Lovato",
    id: 64971011,
    release_date: "2013-02-26",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/5/e/5/0/5e571f5eba684d7840c92f4f54fc59f7.mp3?hdnea=exp=1763731681~acl=/api/1/1/5/e/5/0/5e571f5eba684d7840c92f4f54fc59f7.mp3*~data=user_id=0,application_id=42~hmac=28316efb681b52f577b5afdb6ed50c5652488b3c4c9b994e567bfbc98df79640",
    cover: "https://api.deezer.com/album/6364026/image",
    genre: "Pop",
  },
  {
    title: "Most Girls",
    artist: "P!nk",
    id: 65186996,
    release_date: "2013-03-15",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/5/2/c/0/52c08effd79dd9161443c981378417da.mp3?hdnea=exp=1763731681~acl=/api/1/1/5/2/c/0/52c08effd79dd9161443c981378417da.mp3*~data=user_id=0,application_id=42~hmac=88e43d76d90cdff35fd05c1a3b0d4aab0868168fd8a8d954ff0dbcffe2584f80",
    cover: "https://api.deezer.com/album/6387979/image",
    genre: "Pop",
  },
  {
    title: "My Happy Ending",
    artist: "Avril Lavigne",
    id: 606018,
    release_date: "2004-02-09",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/6/b/6/0/6b6f027aad8e521a35330c8f244c7f5a.mp3?hdnea=exp=1763731681~acl=/api/1/1/6/b/6/0/6b6f027aad8e521a35330c8f244c7f5a.mp3*~data=user_id=0,application_id=42~hmac=a245b77b2a18bf2eb0bb085e93056179d9066c5ef18c0a460c356264785f8cca",
    cover: "https://api.deezer.com/album/76960/image",
    genre: "Pop",
  },
  {
    title: "Good Feeling",
    artist: "Flo Rida",
    id: 65232772,
    release_date: "2011-08-29",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/0/1/1/0/0114b57480f97f4cbd6efe23e870f944.mp3?hdnea=exp=1763731681~acl=/api/1/1/0/1/1/0/0114b57480f97f4cbd6efe23e870f944.mp3*~data=user_id=0,application_id=42~hmac=398962fd5bbf7f1f6df886b75c9b5abf66386180617dfcd10e7ed06920654222",
    cover: "https://api.deezer.com/album/6393486/image",
    genre: "Rap/Hip Hop",
  },
  {
    title: "Suit & Tie (feat. Jay-Z)",
    artist: "Justin Timberlake",
    id: 65356217,
    release_date: "2013-03-15",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/7/1/6/0/7168a3312fb30f9d6a355d7543d12d42.mp3?hdnea=exp=1763731681~acl=/api/1/1/7/1/6/0/7168a3312fb30f9d6a355d7543d12d42.mp3*~data=user_id=0,application_id=42~hmac=f5f81f594774aaffc1ba1972a8c33fbffef95fac822bc591eedc4883089d8e9a",
    cover: "https://api.deezer.com/album/6406302/image",
    genre: "Pop",
  },
  {
    title: "Mirrors",
    artist: "Justin Timberlake",
    id: 65372358,
    release_date: "2013-03-13",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/7/a/7/0/7a7514dad784c6e6868728cc77e691b6.mp3?hdnea=exp=1763731681~acl=/api/1/1/7/a/7/0/7a7514dad784c6e6868728cc77e691b6.mp3*~data=user_id=0,application_id=42~hmac=429150445c49a26f70c3878cf14190eaa7735019719657d46b2e75b4ce771603",
    cover: "https://api.deezer.com/album/6407801/image",
    genre: "Pop",
  },
  {
    title: "Hard To Handle",
    artist: "The Black Crowes",
    id: 65707258,
    release_date: "2013-04-16",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/1/6/7/0/16733912cb6bd9662acd3b79c0ace944.mp3?hdnea=exp=1763731681~acl=/api/1/1/1/6/7/0/16733912cb6bd9662acd3b79c0ace944.mp3*~data=user_id=0,application_id=42~hmac=daf7bb7acfe8a10007d88eb08a5d6a4b7e7b9c963c9b3052237a7a98847dacd4",
    cover: "https://api.deezer.com/album/6441469/image",
    genre: "Rock",
  },
  {
    title: "Another Love",
    artist: "Tom Odell",
    id: 65723649,
    release_date: "2013-06-24",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/4/b/3/0/4b393b254e857c451c8eda85832d1fa9.mp3?hdnea=exp=1763731682~acl=/api/1/1/4/b/3/0/4b393b254e857c451c8eda85832d1fa9.mp3*~data=user_id=0,application_id=42~hmac=a2b9783653ad52a38c88f5ca76605cd233eb3cc273b48b27f6e2656d40f765fb",
    cover: "https://api.deezer.com/album/6443018/image",
    genre: "Pop",
  },
  {
    title: "Counting Stars",
    artist: "OneRepublic",
    id: 65759979,
    release_date: "2013-09-03",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/f/a/8/0/fa8a782eabf6ba2dafa67246782600f9.mp3?hdnea=exp=1763731681~acl=/api/1/1/f/a/8/0/fa8a782eabf6ba2dafa67246782600f9.mp3*~data=user_id=0,application_id=42~hmac=5b31bfc9738b4489924d35e74a88eebbb959d74dac37c4bbe9a3e7438b1e6352",
    cover: "https://api.deezer.com/album/6446668/image",
    genre: "Pop",
  },
  {
    title: "Who Am I (What's My Name)?",
    artist: "Snoop Dogg",
    id: 1556832932,
    release_date: "1993-10-30",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/b/c/c/0/bcc5172c99847853f3230ff7b8c899a1.mp3?hdnea=exp=1763731682~acl=/api/1/1/b/c/c/0/bcc5172c99847853f3230ff7b8c899a1.mp3*~data=user_id=0,application_id=42~hmac=9f62cc7875e894b893dc07a4cada737634597ab1ca81e03b772f8ed8ceeeb0f7",
    cover: "https://api.deezer.com/album/273367132/image",
    genre: "Pop",
  },
  {
    title: "We Fly High",
    artist: "Jim Jones",
    id: 66023308,
    release_date: "2015-02-04",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/a/0/6/0/a066d16effcb2d30f922722a3e26c7d3.mp3?hdnea=exp=1763731682~acl=/api/1/1/a/0/6/0/a066d16effcb2d30f922722a3e26c7d3.mp3*~data=user_id=0,application_id=42~hmac=b29b56793608e34b961d8bb9dc813935a301bb41156cc04ad0d0b2a1621995cf",
    cover: "https://api.deezer.com/album/6462896/image",
    genre: "Rap/Hip Hop",
  },
  {
    title: "Cha Cha Slide",
    artist: "Mr. C",
    id: 66028747,
    release_date: "2014-12-19",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/9/1/5/0/915f13fa1bd5679718642e0426d1bac5.mp3?hdnea=exp=1763731682~acl=/api/1/1/9/1/5/0/915f13fa1bd5679718642e0426d1bac5.mp3*~data=user_id=0,application_id=42~hmac=bbcdb899dd122515bc63c7312188c1dabffc6cb9bee7ace1d0c5e0be3f861170",
    cover: "https://api.deezer.com/album/6463294/image",
    genre: "Pop",
  },
  {
    title: "Love On Top",
    artist: "Beyoncé",
    id: 66190255,
    release_date: "2013-03-29",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/7/2/1/0/721867fbb6f6c0abf9911d924c36fa3f.mp3?hdnea=exp=1763731682~acl=/api/1/1/7/2/1/0/721867fbb6f6c0abf9911d924c36fa3f.mp3*~data=user_id=0,application_id=42~hmac=3ca2b88587ab1bbc7d60e9fd1bbbfca7048a3af3f220bef10cc45135f00b1c91",
    cover: "https://api.deezer.com/album/6475501/image",
    genre: "Pop",
  },
  {
    title: "Best Thing I Never Had",
    artist: "Beyoncé",
    id: 66190266,
    release_date: "2013-03-29",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/1/6/0/0/160f7f5ee11a1cf565e20e33508bdaec.mp3?hdnea=exp=1763731682~acl=/api/1/1/1/6/0/0/160f7f5ee11a1cf565e20e33508bdaec.mp3*~data=user_id=0,application_id=42~hmac=90c058b768119ca9ea726e034b259eca03ab0fa1d237bf213dbde4dbba2a1344",
    cover: "https://api.deezer.com/album/6475501/image",
    genre: "Pop",
  },
  {
    title: "Porcelain",
    artist: "Moby",
    id: 143035440,
    release_date: "2008-06-02",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/3/3/8/0/3389dd48eb0f419dc9a9c12a9177b2d3.mp3?hdnea=exp=1763731682~acl=/api/1/1/3/3/8/0/3389dd48eb0f419dc9a9c12a9177b2d3.mp3*~data=user_id=0,application_id=42~hmac=b71d0f75ea84b3fa1377b905b1dd0723195d610f099c6b021a7575781a1d568a",
    cover: "https://api.deezer.com/album/15483710/image",
    genre: "Electro",
  },
  {
    title: "Natural Blues",
    artist: "Moby",
    id: 66266874,
    release_date: "2008-06-02",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/77154158a26e46531b1998ed2c3ea140/250x250-000000-80-0-0.jpg",
    genre: "Electro",
  },
  {
    title: "Safe And Sound",
    artist: "Capital Cities",
    id: 602515742,
    release_date: "2013-04-05",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/d/d/c/0/ddcca18132459946fb0a14877e7efdef.mp3?hdnea=exp=1763731682~acl=/api/1/1/d/d/c/0/ddcca18132459946fb0a14877e7efdef.mp3*~data=user_id=0,application_id=42~hmac=692cb7513d7118cbb8b9087fb7ddb2d6131c87fd36771a239df4dab4941ccf04",
    cover: "https://api.deezer.com/album/81467732/image",
    genre: "Pop",
  },
  {
    title: "Come & Get It",
    artist: "Selena Gomez",
    id: 66404487,
    release_date: "2013-04-09",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/9/c/b/0/9cbbff6fa17947952f8093f43f07d3c8.mp3?hdnea=exp=1763731682~acl=/api/1/1/9/c/b/0/9cbbff6fa17947952f8093f43f07d3c8.mp3*~data=user_id=0,application_id=42~hmac=0f9335fcebe3ea6cf105f8bc783a1ede9c7cd736031fd5bf2d94bfa87f7d290c",
    cover: "https://api.deezer.com/album/6495493/image",
    genre: "Pop",
  },
  {
    title: "My Songs Know What You Did In The Dark (Light Em Up)",
    artist: "Fall Out Boy",
    id: 66404564,
    release_date: "2013-04-16",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/8/2/3/0/8238aa8f7e6fa1139b34f7c6bf7cb950.mp3?hdnea=exp=1763731682~acl=/api/1/1/8/2/3/0/8238aa8f7e6fa1139b34f7c6bf7cb950.mp3*~data=user_id=0,application_id=42~hmac=2bcd4b3fbd54ce4ddb37c3936468d81ae6e9747919aff4fe4b20e3f67b9ebc67",
    cover: "https://api.deezer.com/album/6495498/image",
    genre: "Alternative",
  },
  {
    title: "Waiting All Night (feat. Ella Eyre)",
    artist: "Rudimental",
    id: 66554899,
    release_date: "2013-04-26",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/f/4/3/0/f43927e56c25904e1bdd28828f281dae.mp3?hdnea=exp=1763731682~acl=/api/1/1/f/4/3/0/f43927e56c25904e1bdd28828f281dae.mp3*~data=user_id=0,application_id=42~hmac=815fc458ccd90a87c761b35762b7156fd40e0eb59023295ae14b176fd0a20033",
    cover: "https://api.deezer.com/album/6510922/image",
    genre: "Dance",
  },
  {
    title: "Don't Stop Movin' (Radio Edit)",
    artist: "Livin' Joy",
    id: 66601211,
    release_date: "1996-07-12",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/8b9216114e6fe18cdf04375c041bdc3c/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Get Lucky (feat. Pharrell Williams & Nile Rodgers)",
    artist: "Daft Punk",
    id: 66609426,
    release_date: "2013-04-19",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/bc49adb87758e0c8c4e508a9c5cce85d/250x250-000000-80-0-0.jpg",
    genre: "Electro",
  },
  {
    title: "Young And Beautiful",
    artist: "Lana Del Rey",
    id: 66660698,
    release_date: "2013-04-22",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/e45246b90badf4bd3a9a994729433bf8/250x250-000000-80-0-0.jpg",
    genre: "Alternative",
  },
  {
    title: "Don't Call Me Baby",
    artist: "Madison Avenue",
    id: 66881687,
    release_date: "2011-12-16",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/f0e3ee8873febbd48c52e0629705523e/250x250-000000-80-0-0.jpg",
    genre: "Electro",
  },
  {
    title: "Sexual Healing",
    artist: "Max-A-Million",
    id: 66975897,
    release_date: "1997-06-11",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/3f4d64858d558bef6d93c898d814dba0/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "La La La",
    artist: "Naughty Boy",
    id: 67041323,
    release_date: "2013-05-20",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/e0059a4597222a502c8c298819f2d3f8/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Lisztomania",
    artist: "Phoenix",
    id: 67239341,
    release_date: "2013-05-13",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/5bfd635c3bf252c6c0d3e3e4b8f53794/250x250-000000-80-0-0.jpg",
    genre: "Alternative",
  },
  {
    title: "Really Don't Care",
    artist: "Demi Lovato",
    id: 67320697,
    release_date: "2013-05-20",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/e6e49efbd01fe2cd9cfc481a5edd4da7/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Riptide",
    artist: "Vance Joy",
    id: 67354825,
    release_date: "2013-09-03",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/93b43ae51ab68cbe154220f1d3b8a942/250x250-000000-80-0-0.jpg",
    genre: "Alternative",
  },
  {
    title: "Love Me Again",
    artist: "John Newman",
    id: 67446406,
    release_date: "2013-07-01",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/9cfd261e3d2aac39bffdf87d0eb61400/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Home",
    artist: "Phillip Phillips",
    id: 67446814,
    release_date: "2005-02-08",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/909347a5bd004b27e669069589ed5e13/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "White Noise",
    artist: "Disclosure",
    id: 67563938,
    release_date: "2013-01-01",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/852c5b27f0d710e29c7be01a33608747/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "You & Me",
    artist: "Disclosure",
    id: 67563944,
    release_date: "2013-06-03",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/852c5b27f0d710e29c7be01a33608747/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Counting Blue Cars (Studio Version)",
    artist: "J.R. Richards",
    id: 67794719,
    release_date: "2014-02-12",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/5fed4bda69aaaf9ac5c0427e267d6c0a/250x250-000000-80-0-0.jpg",
    genre: "Alternative",
  },
  {
    title: "We Can't Stop",
    artist: "Miley Cyrus",
    id: 67928750,
    release_date: "2013-06-03",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/927419c821ded69c31c945446714ace0/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Backseat Freestyle",
    artist: "Kendrick Lamar",
    id: 67929155,
    release_date: "2013-06-17",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/b5be27644d505bad7bdb516fe4165475/250x250-000000-80-0-0.jpg",
    genre: "Rap/Hip Hop",
  },
  {
    title: "808",
    artist: "Blaque",
    id: 67943130,
    release_date: "2007-05-21",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/31341ee01666b9d7240ee3ca6ce5600b/250x250-000000-80-0-0.jpg",
    genre: "R&B",
  },
  {
    title: "Mouth",
    artist: "Merril Bainbridge",
    id: 68024830,
    release_date: "1994-09-06",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/313111071a77a9aaea3c406066021d11/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Gonna Make You Sweat (Everybody Dance Now)",
    artist: "C+C Music Factory",
    id: 68075245,
    release_date: "1990-12-13",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/480c4177106ac283accd9cb35198b43d/250x250-000000-80-0-0.jpg",
    genre: "Dance",
  },
  {
    title: "Black Skinhead",
    artist: "Kanye West",
    id: 68350105,
    release_date: "2013-06-18",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/5a56530f7906bd9786fa47bd0be421b3/250x250-000000-80-0-0.jpg",
    genre: "Rap/Hip Hop",
  },
  {
    title: "Burnin' Up (Album Version)",
    artist: "Jonas Brothers",
    id: 68414905,
    release_date: "2013-07-01",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/95c392f46192413ca204f232b16f7779/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "1979",
    artist: "The Smashing Pumpkins",
    id: 68976286,
    release_date: "1995-10-23",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/c64acd4abaf6e8f2d7c895b4b73f3764/250x250-000000-80-0-0.jpg",
    genre: "Alternative",
  },
  {
    title: "Beautiful People (feat. Benny Benassi)",
    artist: "Chris Brown",
    id: 69295402,
    release_date: "2013-07-23",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/041de2e983e6fd6539f042a66e2962e8/250x250-000000-80-0-0.jpg",
    genre: "Dance",
  },
  {
    title: "Summertime Sadness (Lana Del Rey Vs. Cedric Gervais)",
    artist: "Lana Del Rey",
    id: 69419038,
    release_date: "2013-07-31",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/2d0643dae51cf195717246ad9341c5b7/250x250-000000-80-0-0.jpg",
    genre: "Dance",
  },
  {
    title: "Not an Addict",
    artist: "K's Choice",
    id: 69830287,
    release_date: "1995-02-20",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/96766dc00360ac19e4150a842ebd65be/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "Everybody Everybody",
    artist: "Black Box",
    id: 70051866,
    release_date: "1990-04-09",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/ad31d939346f5770e86af0622c595d32/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "All of Me",
    artist: "John Legend",
    id: 70079770,
    release_date: "2013-08-30",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/e9a170ca0ae06918f9baa6cb109fb321/250x250-000000-80-0-0.jpg",
    genre: "R&B",
  },
  {
    title: "Wrecking Ball",
    artist: "Miley Cyrus",
    id: 70100098,
    release_date: "2013-08-25",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/811459eab745b63e17252a5dd41baa06/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Lady (Hear Me Tonight)",
    artist: "Modjo",
    id: 70179720,
    release_date: "2013-08-19",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/0cc5f4e1e3aee3eb30546097bbfadb60/250x250-000000-80-0-0.jpg",
    genre: "Dance",
  },
  {
    title: "Things That Make You Go Hmmmm.... (feat. Freedom Williams)",
    artist: "C+C Music Factory",
    id: 70196653,
    release_date: "2000-02-28",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/480c4177106ac283accd9cb35198b43d/250x250-000000-80-0-0.jpg",
    genre: "Dance",
  },
  {
    title: "Wasting My Young Years",
    artist: "London Grammar",
    id: 70206826,
    release_date: "2013-09-06",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/615db2012ca3877aee3da15e5e7f7017/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Wake Me Up",
    artist: "Avicii",
    id: 70266756,
    release_date: "2013-09-16",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/ec97306735b46ec334e0ce562290775b/250x250-000000-80-0-0.jpg",
    genre: "Dance",
  },
  {
    title: "Do I Wanna Know?",
    artist: "Arctic Monkeys",
    id: 70322130,
    release_date: "2013-09-09",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/64e54e307bd5e2bdb27ffeb662fd910d/250x250-000000-80-0-0.jpg",
    genre: "Alternative",
  },
  {
    title: "Why'd You Only Call Me When You're High?",
    artist: "Arctic Monkeys",
    id: 70322139,
    release_date: "2013-09-09",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/64e54e307bd5e2bdb27ffeb662fd910d/250x250-000000-80-0-0.jpg",
    genre: "Alternative",
  },
  {
    title: "Blurred Lines",
    artist: "Robin Thicke",
    id: 70335406,
    release_date: "2013-07-30",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/3479d5d0a070eae22f7b67ddb715f49e/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Royals",
    artist: "Lorde",
    id: 70403437,
    release_date: "2013-03-08",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/7bb0b356418fbb275c0c3db7259128d7/250x250-000000-80-0-0.jpg",
    genre: "Alternative",
  },
  {
    title: "Team",
    artist: "Lorde",
    id: 70403440,
    release_date: "2013-09-30",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/7bb0b356418fbb275c0c3db7259128d7/250x250-000000-80-0-0.jpg",
    genre: "Alternative",
  },
  {
    title: "Hey Porsche",
    artist: "Nelly",
    id: 70625532,
    release_date: "2013-09-30",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/2edfed19af239636bd719b8fc2202fa8/250x250-000000-80-0-0.jpg",
    genre: "Rap/Hip Hop",
  },
  {
    title: "The Power of Love",
    artist: "Céline Dion",
    id: 70627953,
    release_date: "1993-11-09",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/a4e0abf3f7a4f4ce8cba4af2cbd6416d/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Ho Hey",
    artist: "The Lumineers",
    id: 70834770,
    release_date: "2013-10-21",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/e1b328ab275f0ff34e0d478c739a89aa/250x250-000000-80-0-0.jpg",
    genre: "Alternative",
  },
  {
    title: "Automatic Lover (Call For Love)",
    artist: "Real McCoy",
    id: 71180726,
    release_date: "2003-06-17",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/55765184bd90adab249b765dd91cd77a/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "It's the Way You Make Me Feel",
    artist: "Steps",
    id: 71400923,
    release_date: "2000-10-30",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/a148dfe850b0dbb574b10629fee98a38/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "I Wish (LP Version)",
    artist: "R. Kelly",
    id: 71481397,
    release_date: "2000-11-07",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/953d0d09a35af90735caab67b83c9a6d/250x250-000000-80-0-0.jpg",
    genre: "R&B",
  },
  {
    title: "Dark Horse",
    artist: "Katy Perry",
    id: 71645436,
    release_date: "2013-10-22",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/fe781ecd9879a82beed80f6d3e80745b/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Take You There",
    artist: "Sean Kingston",
    id: 71751482,
    release_date: "2008-08-14",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/8c4637431d399e0546767cae6d8d7a85/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Sober",
    artist: "P!nk",
    id: 71849861,
    release_date: "2008-10-22",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/57010d59449040db067e5e62e49b7d42/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "My Life Would Suck Without You",
    artist: "Kelly Clarkson",
    id: 71901172,
    release_date: "2009-03-09",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/6b53f0f2d5a73769e29c6b01629edf58/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "The Monster",
    artist: "Eminem",
    id: 72059773,
    release_date: "2013-10-29",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/57ba8f36a09d07be40cf778dfa923e49/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Next To Me",
    artist: "Emeli Sandé",
    id: 72283603,
    release_date: "2013-11-18",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/b52901777db8faba9536ae0795088f20/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Say Something",
    artist: "A Great Big World",
    id: 72299954,
    release_date: "2013-11-04",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/eb5b766197ec98b8df0fafec11b50266/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Lily Was Here (feat. Candy Dulfer)",
    artist: "David A. Stewart",
    id: 72308297,
    release_date: "1990-06-08",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/20b07f7266dd4fb1bcfbe6424c70ff51/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Timber (feat. Ke$ha)",
    artist: "Pitbull",
    id: 72314234,
    release_date: "2013-11-25",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/b304ae156680756fa7290aeef0f32704/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "This Is What It Feels Like",
    artist: "Armin van Buuren",
    id: 72327967,
    release_date: "2013-05-03",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/8c11a0aa8f4bf63c10a86ff32942e9e2/250x250-000000-80-0-0.jpg",
    genre: "Dance",
  },
  {
    title: "Best Song Ever",
    artist: "One Direction",
    id: 72544948,
    release_date: "2013-11-25",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/620bcd9a3310b1bfaba639b060b54abf/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Story of My Life",
    artist: "One Direction",
    id: 72544949,
    release_date: "2013-11-25",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/620bcd9a3310b1bfaba639b060b54abf/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Right in the Night (feat. Plavka) (Fall in Love with Music)",
    artist: "Jam & Spoon",
    id: 73133012,
    release_date: "1993-12-13",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/74e4aa76edd35a7725e324b34132aa41/250x250-000000-80-0-0.jpg",
    genre: "Dance",
  },
  {
    title: "Can We Dance",
    artist: "The Vamps",
    id: 73145938,
    release_date: "2013-09-29",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/9a0d024d64270e2a0fd94d3abb926f5b/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: 'Happy (From "Despicable Me 2")',
    artist: "Pharrell Williams",
    id: 73616508,
    release_date: "2014-06-23",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/b4ff500ac3523e2ce881818f9ffb1879/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Turn Down for What",
    artist: "DJ Snake",
    id: 73707710,
    release_date: "2013-12-18",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/82c139e154a40073542914dfed468474/250x250-000000-80-0-0.jpg",
    genre: "Rap/Hip Hop",
  },
  {
    title: "Drunk in Love (feat. Jay-Z)",
    artist: "Beyoncé",
    id: 73724283,
    release_date: "2013-12-20",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/fd920280eb3de243b3d0d7b313428c13/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Rather Be (feat. Jess Glynne)",
    artist: "Clean Bandit",
    id: 73982869,
    release_date: "2014-06-23",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/3193132d50c74a62d1cd419fa170139a/250x250-000000-80-0-0.jpg",
    genre: "Dance",
  },
  {
    title: "In These Arms",
    artist: "Bon Jovi",
    id: 74628109,
    release_date: "2007-04-05",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/4a2821c5cfa61955ddd982c15cc21882/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "Stay High (Habits Remix)",
    artist: "Tove Lo",
    id: 75072795,
    release_date: "2014-03-10",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/234f7e4100c8764ac365f61715882b0b/250x250-000000-80-0-0.jpg",
    genre: "Alternative",
  },
  {
    title: "Latch",
    artist: "Disclosure",
    id: 75526535,
    release_date: "2015-05-04",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/e44468007c45f2523d056a0b19eed80a/250x250-000000-80-0-0.jpg",
    genre: "Electro",
  },
  {
    title: "Best Day Of My Life",
    artist: "American Authors",
    id: 75711295,
    release_date: "2014-03-03",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/b965a1aa1b44e52fa89ab7b393a80eeb/250x250-000000-80-0-0.jpg",
    genre: "Alternative",
  },
  {
    title: "Magic",
    artist: "Coldplay",
    id: 75716617,
    release_date: "2014-03-03",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/3539e28c608c6376d63511a4426e4e54/250x250-000000-80-0-0.jpg",
    genre: "Alternative",
  },
  {
    title: "Live Like You Were Dying",
    artist: "Tim McGraw",
    id: 75766544,
    release_date: "2010-11-30",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/be12b009324217afcd78a385c071c61e/250x250-000000-80-0-0.jpg",
    genre: "Country",
  },
  {
    title: "Who Do U Love",
    artist: "Deborah Cox",
    id: 75817990,
    release_date: "2014-03-24",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/963c4ea359622492ebaf01a83da663fe/250x250-000000-80-0-0.jpg",
    genre: "R&B",
  },
  {
    title: "She Wolf (Album)",
    artist: "Shakira",
    id: 75834066,
    release_date: "2014-03-07",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/3686fe46b249a6c0f51809cd5685a024/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Dare (La La La)",
    artist: "Shakira",
    id: 76066730,
    release_date: "2014-03-21",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/ad17bc162663a06dd9316c9ee6bdc4e5/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Sweet Dreams",
    artist: "La Bouche",
    id: 13166572,
    release_date: "1994-11-27",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/5/4/0/0/540cd0a8b4ffb0c87c4b372ed4d744cb.mp3?hdnea=exp=1763731686~acl=/api/1/1/5/4/0/0/540cd0a8b4ffb0c87c4b372ed4d744cb.mp3*~data=user_id=0,application_id=42~hmac=7f66827c428cacbd8fb8a3fe78f3ebe58e5c8d62b445a046169dcfec8a280a3f",
    cover: "https://api.deezer.com/album/1207738/image",
    genre: "Pop",
  },
  {
    title: "I Will Never Let You Down",
    artist: "Rita Ora",
    id: 2659860542,
    release_date: "2014-03-31",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/e/6/f/0/e6fbdcd49c98363ab58d3f75be1a5038.mp3?hdnea=exp=1763731686~acl=/api/1/1/e/6/f/0/e6fbdcd49c98363ab58d3f75be1a5038.mp3*~data=user_id=0,application_id=42~hmac=e397eb050fbb21bfea6fa910fee67dd55687066f8196761ad30f90b088d8d0d1",
    cover: "https://api.deezer.com/album/547066582/image",
    genre: "Pop",
  },
  {
    title: "The Other Side",
    artist: "Jason Derulo",
    id: 76734208,
    release_date: "2013-09-10",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/3/b/1/0/3b11beca3bad8ba3b351cb317b647ae6.mp3?hdnea=exp=1763731686~acl=/api/1/1/3/b/1/0/3b11beca3bad8ba3b351cb317b647ae6.mp3*~data=user_id=0,application_id=42~hmac=db3d38a3f4e01ad89016a4b5a9dc440c4c0abafd7d1a4d0e87fc0e971b0b35b8",
    cover: "https://api.deezer.com/album/7613363/image",
    genre: "Pop",
  },
  {
    title: "Crazy for You",
    artist: "Let Loose",
    id: 77325534,
    release_date: "2014-08-26",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/1/7/8/0/1786449358cb122e536054b7d352a3eb.mp3?hdnea=exp=1763731686~acl=/api/1/1/1/7/8/0/1786449358cb122e536054b7d352a3eb.mp3*~data=user_id=0,application_id=42~hmac=20bb62ac05cfe0302d87e65111c0667d0c184c47164cdaeb018b77feaf8dc2cb",
    cover: "https://api.deezer.com/album/7682628/image",
    genre: "Pop",
  },
  {
    title: "Fancy",
    artist: "Iggy Azalea",
    id: 77349246,
    release_date: "2014-04-21",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/c/e/c/0/cec38fc004bfd544b72cc957d588b420.mp3?hdnea=exp=1763731686~acl=/api/1/1/c/e/c/0/cec38fc004bfd544b72cc957d588b420.mp3*~data=user_id=0,application_id=42~hmac=7f16c1b45fc0aa428c2e48781b9831945c36a5c054df395423ec022c3a62dd2d",
    cover: "https://api.deezer.com/album/7685764/image",
    genre: "Rap/Hip Hop",
  },
  {
    title: "Black Widow",
    artist: "Iggy Azalea",
    id: 77349251,
    release_date: "2014-04-21",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/9/8/6/0/986bb1d68c41b52185c03ede31130cf4.mp3?hdnea=exp=1763731686~acl=/api/1/1/9/8/6/0/986bb1d68c41b52185c03ede31130cf4.mp3*~data=user_id=0,application_id=42~hmac=f9025d2af09ded6a75f263a7a06af997428b166fb8599c5a1917a844dbd88648",
    cover: "https://api.deezer.com/album/7685764/image",
    genre: "Rap/Hip Hop",
  },
  {
    title: "Problem",
    artist: "Ariana Grande",
    id: 83844534,
    release_date: "2014-12-19",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/3/5/8/0/35858e8a5c26a6cea0ff584c83801da2.mp3?hdnea=exp=1763731686~acl=/api/1/1/3/5/8/0/35858e8a5c26a6cea0ff584c83801da2.mp3*~data=user_id=0,application_id=42~hmac=25e5150fba183062bfe4a81299dc5b7a70a4c73767085d6c27a0eb337f8f2976",
    cover: "https://api.deezer.com/album/8436154/image",
    genre: "Pop",
  },
  {
    title: "Shower",
    artist: "Becky G",
    id: 77861338,
    release_date: "2014-04-23",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/3/e/3/0/3e3f12c594327e1ea048f1380af0a9a3.mp3?hdnea=exp=1763731686~acl=/api/1/1/3/e/3/0/3e3f12c594327e1ea048f1380af0a9a3.mp3*~data=user_id=0,application_id=42~hmac=030e1172e5ea5d9c2ca26dad4c3098967fae2ab9d35048e6952b953bea1e3d0a",
    cover: "https://api.deezer.com/album/7738427/image",
    genre: "Pop",
  },
  {
    title: "Cheerleader (Felix Jaehn Remix)",
    artist: "OMI",
    id: 78098991,
    release_date: "2014-05-20",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/3/8/8/0/3887647b2c919af64005625835ba854b.mp3?hdnea=exp=1763730771~acl=/api/1/1/3/8/8/0/3887647b2c919af64005625835ba854b.mp3*~data=user_id=0,application_id=42~hmac=bb19ffc827a551bcd7c5fd9078c57f66f0c652501c0a5b7c502225660c9c9a86",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/7f8e1e80d7b9d66ffddf7f457375ccf7/250x250-000000-80-0-0.jpg",
    genre: "Electro",
  },
  {
    title: "Love Never Felt So Good",
    artist: "Michael Jackson",
    id: 78213551,
    release_date: "2014-05-09",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/7/c/1/0/7c10ef0ea63b4fa0337ec54ec864180e.mp3?hdnea=exp=1763730771~acl=/api/1/1/7/c/1/0/7c10ef0ea63b4fa0337ec54ec864180e.mp3*~data=user_id=0,application_id=42~hmac=03ccd08b0fbcc326d04665950430ddda0022345161c55ed92377464f5963e37e",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/fad0dd777fb660bb1c3388334afd8419/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Stay With Me",
    artist: "Sam Smith",
    id: 78282330,
    release_date: "2015-02-18",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/d/9/3/0/d933e05c370881a7962c1984feefe6d8.mp3?hdnea=exp=1763730771~acl=/api/1/1/d/9/3/0/d933e05c370881a7962c1984feefe6d8.mp3*~data=user_id=0,application_id=42~hmac=7d98e90ff00273f4e381fc2f3954d57d98cae3b2995779f6f06bef5e549a1305",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/44e0fbe81ca549290348d3544375e29a/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "I'm Not The Only One",
    artist: "Sam Smith",
    id: 78282333,
    release_date: "2014-05-26",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/3/4/1/0/34157a75b508b109e31f570b20b4d862.mp3?hdnea=exp=1763730771~acl=/api/1/1/3/4/1/0/34157a75b508b109e31f570b20b4d862.mp3*~data=user_id=0,application_id=42~hmac=0002c532460fccaa48023fbc20496525308903e7a8bc6cc88f6cdc2a8fc9fcc9",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/44e0fbe81ca549290348d3544375e29a/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Colorblind",
    artist: "Counting Crows",
    id: 78934726,
    release_date: "2008-03-18",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/c/e/e/0/cee81946c8399855ebd8c5a1f13dabe8.mp3?hdnea=exp=1763730771~acl=/api/1/1/c/e/e/0/cee81946c8399855ebd8c5a1f13dabe8.mp3*~data=user_id=0,application_id=42~hmac=174895a516fb8932140fdab85e2d4881ec7d54cb05e23f050f82a085d19a6f2d",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/d856fe41f25e299f2caddc777bbfef4c/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Ugly Heart",
    artist: "G.R.L.",
    id: 79036884,
    release_date: "2014-06-03",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/8/f/a/0/8faf54d348106017188b28476890d661.mp3?hdnea=exp=1763730771~acl=/api/1/1/8/f/a/0/8faf54d348106017188b28476890d661.mp3*~data=user_id=0,application_id=42~hmac=2e1d54380a49eeda5d12d39a39e98bd905ebf65faacf01380f8a07ce3ba5dc99",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/9f1f6b9faa56c06617523afbcac4c3a6/250x250-000000-80-0-0.jpg",
    genre: "Dance",
  },
  {
    title: "Maps",
    artist: "Maroon 5",
    id: 100004582,
    release_date: "2014-06-16",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/2/3/3/0/233b3636bb73c8f2c33c69975cd54690.mp3?hdnea=exp=1763731686~acl=/api/1/1/2/3/3/0/233b3636bb73c8f2c33c69975cd54690.mp3*~data=user_id=0,application_id=42~hmac=6280506658e000f4a6a7ac9c1238dc539dfd98fba25c3ecda77ecb4642616e15",
    cover: "https://api.deezer.com/album/10239058/image",
    genre: "Pop",
  },
  {
    title: "Chandelier",
    artist: "Sia",
    id: 79587580,
    release_date: "2014-07-04",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/8/7/3/0/8732a4eb0fbbcfaf4f163b79cfff29ea.mp3?hdnea=exp=1763730771~acl=/api/1/1/8/7/3/0/8732a4eb0fbbcfaf4f163b79cfff29ea.mp3*~data=user_id=0,application_id=42~hmac=95e4c5cca68ae17a7fe66c6bf7996e525a2dea85e4289b83810513f34bcd807e",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/4275db12f5e284b3c2f3e20726187b64/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Runaway (Radio Edit)",
    artist: "Janet Jackson",
    id: 79588928,
    release_date: "2001-01-01",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/ecc4dd3edd69606fde71fc67132ae014/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Boom Clap",
    artist: "Charli XCX",
    id: 79590714,
    release_date: "2014-06-16",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/9/f/a/0/9fa25c406bdb8033532520552263430f.mp3?hdnea=exp=1763730771~acl=/api/1/1/9/f/a/0/9fa25c406bdb8033532520552263430f.mp3*~data=user_id=0,application_id=42~hmac=8995bbffbb8161fbbaf08ab8e0a6eb9a598b95d544ab0fd52ed45a388a6df000",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/e87d1f644da8067dda2284e582602900/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Rude",
    artist: "MAGIC!",
    id: 79845486,
    release_date: "2014-07-08",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/9/4/a/0/94ad7aa3890dfef93c9314a4762eaa45.mp3?hdnea=exp=1763730771~acl=/api/1/1/9/4/a/0/94ad7aa3890dfef93c9314a4762eaa45.mp3*~data=user_id=0,application_id=42~hmac=3296d8aacfb9df3bd8ea504b6c677b12bf8d1e0f23bde9e0ca7081aa50352522",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/a393ea2d5dafca17cb80c3258a47a9ee/250x250-000000-80-0-0.jpg",
    genre: "Alternative",
  },
  {
    title: "Don't",
    artist: "Ed Sheeran",
    id: 79875050,
    release_date: "2014-06-20",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/5/3/f/0/53f6ffbf96d861b06ecf7b2f740dfb42.mp3?hdnea=exp=1763730771~acl=/api/1/1/5/3/f/0/53f6ffbf96d861b06ecf7b2f740dfb42.mp3*~data=user_id=0,application_id=42~hmac=f2f731dff8d64ffd65d86f1da76c6a2eb999a265b9c302eb8166c8ee36810da2",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/b1d763da698c38bde6a526c8220ca0ea/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Photograph",
    artist: "Ed Sheeran",
    id: 79875054,
    release_date: "2008-06-14",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/5/f/e/0/5fe724b9c9f40a3e8d21319a882b034b.mp3?hdnea=exp=1763730771~acl=/api/1/1/5/f/e/0/5fe724b9c9f40a3e8d21319a882b034b.mp3*~data=user_id=0,application_id=42~hmac=9da698ab4e13cbb2bebcba1dc0887249d82685f8801e0d8104c33a6e79425bc2",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/b1d763da698c38bde6a526c8220ca0ea/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Bloodstream",
    artist: "Ed Sheeran",
    id: 79875056,
    release_date: "2014-06-20",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/6/0/5/0/6059962fafc7b35ea53c017c3c56b954.mp3?hdnea=exp=1763730771~acl=/api/1/1/6/0/5/0/6059962fafc7b35ea53c017c3c56b954.mp3*~data=user_id=0,application_id=42~hmac=e75606eb52a5ac462fa3688e044e07a87c03bfe3a2728b46542734268c1582b5",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/b1d763da698c38bde6a526c8220ca0ea/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Stay The Night (Featuring Hayley Williams Of Paramore)",
    artist: "Zedd",
    id: 79942796,
    release_date: "2014-07-04",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/3/a/f/0/3aff23f4e9894a6228821581726b73a1.mp3?hdnea=exp=1763730771~acl=/api/1/1/3/a/f/0/3aff23f4e9894a6228821581726b73a1.mp3*~data=user_id=0,application_id=42~hmac=9dba077f449b891b45bf6e0b50d1f82e006ad8e95026e3fdbb2df06da16fc633",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/d1941bbbb615993e9ca18d7710dca024/250x250-000000-80-0-0.jpg",
    genre: "Dance",
  },
  {
    title: "She Looks So Perfect",
    artist: "5 Seconds of Summer",
    id: 80077244,
    release_date: "2014-06-30",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/4/7/5/0/475a12f23fd8b4e51e095672b72d1fa2.mp3?hdnea=exp=1763730771~acl=/api/1/1/4/7/5/0/475a12f23fd8b4e51e095672b72d1fa2.mp3*~data=user_id=0,application_id=42~hmac=233f1913f57fc12f78e0b7328b2dffa6df9f64f00f7178592d16a179ab1a9d69",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/607edd6e04268585206f8f42ca760de0/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Hideaway",
    artist: "Kiesza",
    id: 80194320,
    release_date: "2014-07-07",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/3/d/1/0/3d100780bd84304a088a6188a000a3a2.mp3?hdnea=exp=1763730771~acl=/api/1/1/3/d/1/0/3d100780bd84304a088a6188a000a3a2.mp3*~data=user_id=0,application_id=42~hmac=abae9bba0522a4bfbb2e60b1264ecb1cbadb9a50ab3bb089000aa4ee81af5a8b",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/e82b7ee9a70e690a0d927a6df8411176/250x250-000000-80-0-0.jpg",
    genre: "Electro",
  },
  {
    title: "Call Me When You're Sober",
    artist: "Evanescence",
    id: 80273734,
    release_date: "2006-09-04",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/0/4/d/0/04d83e0858d07308a05787168a5c5575.mp3?hdnea=exp=1763730771~acl=/api/1/1/0/4/d/0/04d83e0858d07308a05787168a5c5575.mp3*~data=user_id=0,application_id=42~hmac=e6545c053b8e7a834578d2f3d0e6186283f865a756b340b7b9ae2f2a03cdede9",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/1ff74ac5b35955c8d4fe115ac1d1f41f/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "Higher",
    artist: "Creed",
    id: 80274464,
    release_date: "1999-02-14",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/8/6/d/0/86d828718b7ce7054b5471fdd75bd7bf.mp3?hdnea=exp=1763730771~acl=/api/1/1/8/6/d/0/86d828718b7ce7054b5471fdd75bd7bf.mp3*~data=user_id=0,application_id=42~hmac=3533ee2595f0181be1a3e2656c39440ff3ed438a722149003961897082b4e051",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/7c5e2402a3bcb04b871d503087ef56da/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "Paralyzer",
    artist: "Finger Eleven",
    id: 80275000,
    release_date: "2007-03-06",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/7/4/6/0/746494269b27e66ba0f8d6fb7adfdae6.mp3?hdnea=exp=1763730771~acl=/api/1/1/7/4/6/0/746494269b27e66ba0f8d6fb7adfdae6.mp3*~data=user_id=0,application_id=42~hmac=baa6a6ffa5595261823aa8016c04d2c074e16ac7ae083f0e00b46a14a58e5ce5",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/302f0325f79a75a76f778ee0a80dee48/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "Fake It",
    artist: "Seether",
    id: 80276490,
    release_date: "2007-08-28",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/c/7/9/0/c79290d8990e6fea09a3c7798409a557.mp3?hdnea=exp=1763730771~acl=/api/1/1/c/7/9/0/c79290d8990e6fea09a3c7798409a557.mp3*~data=user_id=0,application_id=42~hmac=f1ed49334bcfbc5eb7104794fd7ebb42b7f41e18a303974bfe89ca40a2db67c7",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/7b828bdaa512c9061bb6df1a9255142b/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "Break Free",
    artist: "Ariana Grande",
    id: 83844544,
    release_date: "2015-06-07",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/b/8/c/0/b8c03021b05ef13e479c6f33e7c1230a.mp3?hdnea=exp=1763731686~acl=/api/1/1/b/8/c/0/b8c03021b05ef13e479c6f33e7c1230a.mp3*~data=user_id=0,application_id=42~hmac=2a90262844cf25257e46d9084212694a32b61c943e4eedf7b2c10eb1e03c88b9",
    cover: "https://api.deezer.com/album/8436154/image",
    genre: "Pop",
  },
  {
    title: "Bang Bang",
    artist: "Jessie J",
    id: 81609384,
    release_date: "2014-07-29",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/a/3/4/0/a34517ab6008375a2a8010d9da1018dc.mp3?hdnea=exp=1763730771~acl=/api/1/1/a/3/4/0/a34517ab6008375a2a8010d9da1018dc.mp3*~data=user_id=0,application_id=42~hmac=1c1c559d17427437e285c0c5d1d25ef528808e58ff326c012eb5815b3d2f3bd5",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/e436fcd3350dc5fe2adbf59516f6cbe7/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Womanizer",
    artist: "Britney Spears",
    id: 82199332,
    release_date: "2008-12-02",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/b/1/a/0/b1a2051c3a95d347b62f801cb46d8077.mp3?hdnea=exp=1763730771~acl=/api/1/1/b/1/a/0/b1a2051c3a95d347b62f801cb46d8077.mp3*~data=user_id=0,application_id=42~hmac=c8e15d07b3a5689a04e3b969523e968a30c1cda08a7960a588b50a9ab9e13aa7",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/16d60157d51a9e21ffac61b50a7d02d0/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Circus",
    artist: "Britney Spears",
    id: 82199334,
    release_date: "2008-12-02",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/a/a/4/0/aa41a4cb3a80cc03d9545fba55f69af9.mp3?hdnea=exp=1763730771~acl=/api/1/1/a/a/4/0/aa41a4cb3a80cc03d9545fba55f69af9.mp3*~data=user_id=0,application_id=42~hmac=0890c8f40555cd41dcc3f8700c0ed904a787355ae5c1725563e9922f424730cf",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/16d60157d51a9e21ffac61b50a7d02d0/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Smooth (feat. Rob Thomas)",
    artist: "Santana",
    id: 82241402,
    release_date: "2011-02-18",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/0/6/6/0/066818622bab6266aa80190fa52124cc.mp3?hdnea=exp=1763730771~acl=/api/1/1/0/6/6/0/066818622bab6266aa80190fa52124cc.mp3*~data=user_id=0,application_id=42~hmac=fbbd40b3d351a99ba7932ae244b7e5e15c2968099c98cdc4259c806ffaede250",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/929132f50492c7acfab23b32722f4537/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Cool Kids",
    artist: "Echosmith",
    id: 83756190,
    release_date: "2014-08-15",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/e/8/a/0/e8aedb7b93a9558ad1aeaafcd8ac6a7b.mp3?hdnea=exp=1763730771~acl=/api/1/1/e/8/a/0/e8aedb7b93a9558ad1aeaafcd8ac6a7b.mp3*~data=user_id=0,application_id=42~hmac=b99d6fedef805d65ff3c01858fc19cb25b918079d9847e4fe3751624c10aaab5",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/7f50aafeda73533575225e471bd295ca/250x250-000000-80-0-0.jpg",
    genre: "Alternative",
  },
  {
    title: "Amnesia",
    artist: "5 Seconds of Summer",
    id: 83939103,
    release_date: "2014-09-08",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/2/e/a/0/2ea9dc5619e36f961a6559722cf419fa.mp3?hdnea=exp=1763730771~acl=/api/1/1/2/e/a/0/2ea9dc5619e36f961a6559722cf419fa.mp3*~data=user_id=0,application_id=42~hmac=c92d10575c7a57cea0c3aea6e5659e1a08f17297d16fa051a054b53464fbb946",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/02de0988cdbc1d4a221a8b5011a03a93/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Talking Body",
    artist: "Tove Lo",
    id: 84669123,
    release_date: "2014-09-29",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/e/4/2/0/e4275b997966a9a05e339831573133c7.mp3?hdnea=exp=1763730771~acl=/api/1/1/e/4/2/0/e4275b997966a9a05e339831573133c7.mp3*~data=user_id=0,application_id=42~hmac=54b24b3564b359396e6fb9cd92674eba46f8c6cb0ff0f9b18b43467e1285fbdf",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/bca07a0bfaaf112657e078b3cbc48d82/250x250-000000-80-0-0.jpg",
    genre: "Alternative",
  },
  {
    title: "Take Me To Church",
    artist: "Hozier",
    id: 84791735,
    release_date: "2014-10-06",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/5/2/f/0/52faa238ac6801a1eb418bb9e7c7a3e7.mp3?hdnea=exp=1763730771~acl=/api/1/1/5/2/f/0/52faa238ac6801a1eb418bb9e7c7a3e7.mp3*~data=user_id=0,application_id=42~hmac=b4671695f87b730b9b3394590c81cfa91817d37bade42ab94363a17dd2d25c90",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/8442e9ac0227a07b00c9dfd0ec00032d/250x250-000000-80-0-0.jpg",
    genre: "Alternative",
  },
  {
    title: "Calling Elvis",
    artist: "Dire Straits",
    id: 84843605,
    release_date: "1990-01-01",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/8/4/b/0/84b07904d304d73862595ba3f1c5cb3f.mp3?hdnea=exp=1763730771~acl=/api/1/1/8/4/b/0/84b07904d304d73862595ba3f1c5cb3f.mp3*~data=user_id=0,application_id=42~hmac=04c5d7ae80738e09c48b7cd00dcac84f8a4b3cd53153395f633c488f1fc7ff5e",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/6c99199e34fd23973d9e023820e2a1b7/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Heavy Fuel",
    artist: "Dire Straits",
    id: 84843617,
    release_date: "1990-01-01",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/2/c/4/0/2c433bb143302e91c516f0cccecd85f1.mp3?hdnea=exp=1763730771~acl=/api/1/1/2/c/4/0/2c433bb143302e91c516f0cccecd85f1.mp3*~data=user_id=0,application_id=42~hmac=01800533535627afc1dc70fa8771668af4d3ff26f74bfd0bdf46175c77d33b0c",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/6c99199e34fd23973d9e023820e2a1b7/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Budapest",
    artist: "George Ezra",
    id: 71220746,
    release_date: "2015-05-04",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/0/7/a/0/07abeb1936eaac500b89acf179f7dd9b.mp3?hdnea=exp=1763731686~acl=/api/1/1/0/7/a/0/07abeb1936eaac500b89acf179f7dd9b.mp3*~data=user_id=0,application_id=42~hmac=2847d8e9acbe6b8e346862f5b2f5b17275ea1be6071e0e721d169fb45ee38249",
    cover: "https://api.deezer.com/album/6991678/image",
    genre: "Pop",
  },
  {
    title: "A Sky Full of Stars",
    artist: "Coldplay",
    id: 86044539,
    release_date: "2014-05-19",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/8/e/d/0/8ed66859ab91f709c58d302768747fd7.mp3?hdnea=exp=1763730771~acl=/api/1/1/8/e/d/0/8ed66859ab91f709c58d302768747fd7.mp3*~data=user_id=0,application_id=42~hmac=7a81ab40bcffd98589caa4182552a4289079843f7eedd80b3799a6cccc3f8420",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/58669ace38d333770941332f8d860dc1/250x250-000000-80-0-0.jpg",
    genre: "Alternative",
  },
  {
    title: "Am I Wrong",
    artist: "Nico & Vinz",
    id: 86646433,
    release_date: "2014-10-03",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/4/c/2/0/4c236560b6461c8bdd3c831ce72fe01a.mp3?hdnea=exp=1763730771~acl=/api/1/1/4/c/2/0/4c236560b6461c8bdd3c831ce72fe01a.mp3*~data=user_id=0,application_id=42~hmac=43b103416d2da35dd2e39e8c0560ded5439062180ef7188a493a88f0b0209b13",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/e351fc0509a96a598ae8c89fb0d0d530/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Dangerous (feat. Sam Martin)",
    artist: "David Guetta",
    id: 87371673,
    release_date: "2014-10-06",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/b/b/a/0/bba461e51f865eca0d8e8eadd307b392.mp3?hdnea=exp=1763730771~acl=/api/1/1/b/b/a/0/bba461e51f865eca0d8e8eadd307b392.mp3*~data=user_id=0,application_id=42~hmac=c4e76c6c688e40159d04af9117a5b2617c190ea43b3bb1777279103ffb426592",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/1be5c19b38770609a0884b988d7094c4/250x250-000000-80-0-0.jpg",
    genre: "Dance",
  },
  {
    title: "I Promised Myself",
    artist: "Nick Kamen",
    id: 88310763,
    release_date: "1992-05-25",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/6/8/b/0/68b11d43b5dfe86a9a1fc2fdd3916926.mp3?hdnea=exp=1763730771~acl=/api/1/1/6/8/b/0/68b11d43b5dfe86a9a1fc2fdd3916926.mp3*~data=user_id=0,application_id=42~hmac=631a43908aaa108e518fe1df7c9d4c9adab384b3d28b72bead9f482c3c102360",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/e82b704a2551a383ae70736b151a8da6/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Sweet Like Chocolate",
    artist: "Shanks & Bigfoot",
    id: 88806539,
    release_date: "1999-08-02",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/4fe1a66f0c14d7b8e979d1e97aa785de/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Tipsy (Club Mix)",
    artist: "J-Kwon",
    id: 88897871,
    release_date: "2004-01-01",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/1/e/9/0/1e9e1a95d506763bd73fdc00964f3b66.mp3?hdnea=exp=1763730771~acl=/api/1/1/1/e/9/0/1e9e1a95d506763bd73fdc00964f3b66.mp3*~data=user_id=0,application_id=42~hmac=5430f281a9c32d22711e70dbb1dc067ce07dc89b57f51a18b7365e83ede124e0",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/0e4b8c4332328521ec4ed16b4b9e26b1/250x250-000000-80-0-0.jpg",
    genre: "R&B",
  },
  {
    title: "Summer",
    artist: "Calvin Harris",
    id: 88936747,
    release_date: "2014-03-14",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/7/e/3/0/7e3fa54179108b453a9b360bf1976177.mp3?hdnea=exp=1763730772~acl=/api/1/1/7/e/3/0/7e3fa54179108b453a9b360bf1976177.mp3*~data=user_id=0,application_id=42~hmac=dd734e89f8a2c54641ba1e8c19ce20db76597ea64c8a94bdea788d595d49a049",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/42e13c6a1f25fd821407b4d4762eb3ce/250x250-000000-80-0-0.jpg",
    genre: "Dance",
  },
  {
    title: "Sandstorm",
    artist: "Darude",
    id: 11390027,
    release_date: "2007-04-18",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/0/3/5/0/0350d31fdd1b8c626c82f5250ab1afd4.mp3?hdnea=exp=1763731686~acl=/api/1/1/0/3/5/0/0350d31fdd1b8c626c82f5250ab1afd4.mp3*~data=user_id=0,application_id=42~hmac=7b2a495a338dc5aa3113b65fcbca930c69c39b3877f1a3c6c4c57c44d0dd7013",
    cover: "https://api.deezer.com/album/1043963/image",
    genre: "Pop",
  },
  {
    title: "Cry For You",
    artist: "September",
    id: 15543742,
    release_date: "2008-02-26",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/d/4/4/0/d44e19fcdfe0c7a4a99bfc55fac76951.mp3?hdnea=exp=1763731686~acl=/api/1/1/d/4/4/0/d44e19fcdfe0c7a4a99bfc55fac76951.mp3*~data=user_id=0,application_id=42~hmac=409eac9f7c7a5df99d810d0db5597ff4a458a62e37dd9851221c667c7361a5e5",
    cover: "https://api.deezer.com/album/1436576/image",
    genre: "Electro",
  },
  {
    title: "Blank Space",
    artist: "Taylor Swift",
    id: 89077547,
    release_date: "2014-10-27",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/b/b/7/0/bb7f65683e286ea3014c0fbd26bfaa5b.mp3?hdnea=exp=1763730772~acl=/api/1/1/b/b/7/0/bb7f65683e286ea3014c0fbd26bfaa5b.mp3*~data=user_id=0,application_id=42~hmac=6ca81f6db915a8f0e6eb32a409af3a19351586cf9e64e5b3a34c35705556d689",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/68b4e986958b17f05b062ffa8d7ae114/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Style",
    artist: "Taylor Swift",
    id: 89077549,
    release_date: "2014-10-27",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/4/8/9/0/48987dd8172da882b49d040dd158e2ae.mp3?hdnea=exp=1763730772~acl=/api/1/1/4/8/9/0/48987dd8172da882b49d040dd158e2ae.mp3*~data=user_id=0,application_id=42~hmac=46fdcb90326f975ba6ce6924a2faa2bab5bac67b8a11f3011c1acbf8322a2aba",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/68b4e986958b17f05b062ffa8d7ae114/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Jealous",
    artist: "Nick Jonas",
    id: 89128471,
    release_date: "2014-11-10",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/7/c/9/0/7c9e893c5fe72425dfd5b75b0e3f5f74.mp3?hdnea=exp=1763730772~acl=/api/1/1/7/c/9/0/7c9e893c5fe72425dfd5b75b0e3f5f74.mp3*~data=user_id=0,application_id=42~hmac=61470022cd51684d425d8e7ab7de32a0d391b769b1dd8bb70e3f2d6920f67ea5",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/375942fe5d0cf64de22ef7e8f9924978/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Are You With Me",
    artist: "Lost Frequencies",
    id: 81300218,
    release_date: "2014-11-17",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/2/1/8/0/2187d055b080dbd13614fc459d58dc65.mp3?hdnea=exp=1763731686~acl=/api/1/1/2/1/8/0/2187d055b080dbd13614fc459d58dc65.mp3*~data=user_id=0,application_id=42~hmac=15952f0e9448bc01fd768f4219b4ebafd287acce27d7a6e04f7658e241ea22c0",
    cover: "https://api.deezer.com/album/8142034/image",
    genre: "Pop",
  },
  {
    title: "Let It Go (From 'Frozen' / Single Version)",
    artist: "Demi Lovato",
    id: 89824505,
    release_date: "2013-11-25",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/e/d/b/0/edb3ddd15f5c19177641c3624fdce58c.mp3?hdnea=exp=1763730772~acl=/api/1/1/e/d/b/0/edb3ddd15f5c19177641c3624fdce58c.mp3*~data=user_id=0,application_id=42~hmac=5882beff3a82be9b6361d5a07ff7382858f47b54e86bfafa58eb47172c10a6ed",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/e4264ac960d380a45992d93d9ee9930f/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Mama Do (Uh Oh, Uh Oh)",
    artist: "Pixie Lott",
    id: 89825089,
    release_date: "2014-11-24",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/7/a/8/0/7a855a5cc2e7e0e25f170d44f6f22a9c.mp3?hdnea=exp=1763730772~acl=/api/1/1/7/a/8/0/7a855a5cc2e7e0e25f170d44f6f22a9c.mp3*~data=user_id=0,application_id=42~hmac=145ae5415e895e2ac2e6486e709b722c2209beba2108738edf63a30ef9298299",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/f3e878d31dc253cc380e7cc1344c5275/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Steal My Girl",
    artist: "One Direction",
    id: 90248129,
    release_date: "2014-11-17",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/4/a/6/0/4a6b4e0311b19af6776aae5a46eb995c.mp3?hdnea=exp=1763730772~acl=/api/1/1/4/a/6/0/4a6b4e0311b19af6776aae5a46eb995c.mp3*~data=user_id=0,application_id=42~hmac=72eaa113061de405cbf6c74fee05eb06def053e38770d7849fa229ed91147812",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/44d6c40a5d127528c991b1923948d4bd/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Shut Up and Dance",
    artist: "WALK THE MOON",
    id: 90326361,
    release_date: "2014-11-28",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/a/9/b/0/a9bb99c03f2ecfde508ccc9ffa60421f.mp3?hdnea=exp=1763730772~acl=/api/1/1/a/9/b/0/a9bb99c03f2ecfde508ccc9ffa60421f.mp3*~data=user_id=0,application_id=42~hmac=919c128906921ad9a0b9cee37986b86d0036f92f6ee2ae1e78f33c878493a3de",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/4fd07406ef0cfa6dab31fd68d71eb2b7/250x250-000000-80-0-0.jpg",
    genre: "Alternative",
  },
  {
    title: "Tragedy (Radio Edit)",
    artist: "Steps",
    id: 90630567,
    release_date: "1976-05-16",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/8/5/6/0/8564c1b18d1400a49443417fbb2277a0.mp3?hdnea=exp=1763731686~acl=/api/1/1/8/5/6/0/8564c1b18d1400a49443417fbb2277a0.mp3*~data=user_id=0,application_id=42~hmac=d881b53d44692d6f3e5dcb0c5248cae3ebdc2224217052fca69c644a401c23ed",
    cover: "https://api.deezer.com/album/9188115/image",
    genre: "Pop",
  },
  {
    title: "Infinity",
    artist: "Guru Josh",
    id: 90630583,
    release_date: "2014-11-28",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/d/f/b/0/dfbc22af348f3651340f81c87502fa8e.mp3?hdnea=exp=1763730487~acl=/api/1/1/d/f/b/0/dfbc22af348f3651340f81c87502fa8e.mp3*~data=user_id=0,application_id=42~hmac=1999d6495521b1c4a392db52650befa111627a4038bf4b01bd5e8f07eea8ff48",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/23200f2a6cecb3df661cd187a6889dba/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "I Still Haven't Found What I'm Looking For",
    artist: "The Chimes",
    id: 90630633,
    release_date: "1987-05-25",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/9/2/3/0/923e6eb6c72ef767fa1416fc8c20a77a.mp3?hdnea=exp=1763730487~acl=/api/1/1/9/2/3/0/923e6eb6c72ef767fa1416fc8c20a77a.mp3*~data=user_id=0,application_id=42~hmac=a46c420a1826b172a1cd5950dea0a1f55d06af930b300d03391292cf07065495",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/23200f2a6cecb3df661cd187a6889dba/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Nobody Knows",
    artist: "The Tony Rich Project",
    id: 90630707,
    release_date: "2014-11-28",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/6/e/4/0/6e43c6859288ff3dfcd1aa97e6e4ee90.mp3?hdnea=exp=1763730487~acl=/api/1/1/6/e/4/0/6e43c6859288ff3dfcd1aa97e6e4ee90.mp3*~data=user_id=0,application_id=42~hmac=d99c0df11bedf7b09a6c07a71783ecdc9dc95e63af94f7aa1c58510e8dcc3fce",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/23200f2a6cecb3df661cd187a6889dba/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Firestone",
    artist: "Kygo",
    id: 90726629,
    release_date: "2015-08-07",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/1/3/5/0/135503829a79bb3d2870c940ba13c9b0.mp3?hdnea=exp=1763730487~acl=/api/1/1/1/3/5/0/135503829a79bb3d2870c940ba13c9b0.mp3*~data=user_id=0,application_id=42~hmac=24b0ca43367762a2eb62a867c9bb1f90741895edeb701a9ab4e8428202ac591e",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/28a8beab24b92bcbbd1e80df83c4bd24/250x250-000000-80-0-0.jpg",
    genre: "Electro",
  },
  {
    title: "Around The Way Girl",
    artist: "LL COOL J",
    id: 90806063,
    release_date: "1990-05-29",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/7/f/6/0/7f6161dcaaf4808c76493d1c127a949f.mp3?hdnea=exp=1763730487~acl=/api/1/1/7/f/6/0/7f6161dcaaf4808c76493d1c127a949f.mp3*~data=user_id=0,application_id=42~hmac=5e20b1e5139b5998f8aafa2ac2959071307a885810895bba893d74dc6f40ca6e",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/2a50b1e25b7d176948fb3be9274c95dc/250x250-000000-80-0-0.jpg",
    genre: "Rap/Hip Hop",
  },
  {
    title: "Dani California",
    artist: "Red Hot Chili Peppers",
    id: 91442720,
    release_date: "2006-04-03",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/3/5/1/0/3511630544ca5c9e6c91829062e87f50.mp3?hdnea=exp=1763730487~acl=/api/1/1/3/5/1/0/3511630544ca5c9e6c91829062e87f50.mp3*~data=user_id=0,application_id=42~hmac=f805d99c9eabba4d1a899e51695ff7f0fc799e8addac8c6ea94f554f3922e9d5",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/ca9441e904f0f09044fb514bbfc49089/250x250-000000-80-0-0.jpg",
    genre: "Alternative",
  },
  {
    title: "Anaconda",
    artist: "Nicki Minaj",
    id: 91543346,
    release_date: "2014-12-15",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/8/9/4/0/89430508b13a61e0e4b25ddfc73c5403.mp3?hdnea=exp=1763730487~acl=/api/1/1/8/9/4/0/89430508b13a61e0e4b25ddfc73c5403.mp3*~data=user_id=0,application_id=42~hmac=6ea884e8758ab5997b59d96de3c369745d2f80c694a810716cc07a53a907a5e2",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/ebbcc26be4391b139475aed5ce6a6c3e/250x250-000000-80-0-0.jpg",
    genre: "Rap/Hip Hop",
  },
  {
    title: "Trap Queen",
    artist: "Fetty Wap",
    id: 91934728,
    release_date: "2014-12-15",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/d/2/3/0/d236757c1e73afbdf29640ff7195e862.mp3?hdnea=exp=1763730487~acl=/api/1/1/d/2/3/0/d236757c1e73afbdf29640ff7195e862.mp3*~data=user_id=0,application_id=42~hmac=5853fca84a4db0badedf5474a9dd75e7b72a3239bb4cc6735cc3a2b4596481d0",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/57e2e32eb38000eb7454fff32fc56f02/250x250-000000-80-0-0.jpg",
    genre: "Rap/Hip Hop",
  },
  {
    title: "There's Nothing I Won't Do",
    artist: "JX",
    id: 535026292,
    release_date: "2014-12-14",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/1/6/8/0/168277720eb6f786f3a9473d03e4c0ee.mp3?hdnea=exp=1763731686~acl=/api/1/1/1/6/8/0/168277720eb6f786f3a9473d03e4c0ee.mp3*~data=user_id=0,application_id=42~hmac=e79cd3b51e776573c595c33d7701db2faaf32d231e9e477ad56e810482588daa",
    cover: "https://api.deezer.com/album/69584112/image",
    genre: "Pop",
  },
  {
    title: "Wait for You",
    artist: "Mikkel S. Eriksen",
    id: 92154620,
    release_date: "2007-03-20",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/4/4/8/0/44800dd28b712cac35e023a011cbb976.mp3?hdnea=exp=1763730487~acl=/api/1/1/4/4/8/0/44800dd28b712cac35e023a011cbb976.mp3*~data=user_id=0,application_id=42~hmac=591ef4b0a3178c91c9f83fa46862ddaad28b3b111cd55b7bcddd550058944acb",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/5ffa1c57b16d0abd4f7baaeb424c48bb/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Thunderstruck",
    artist: "AC/DC",
    id: 92720102,
    release_date: "1990-09-21",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/1/1/1/0/1117489d36f3a1a80c8815c1137747a9.mp3?hdnea=exp=1763730487~acl=/api/1/1/1/1/1/0/1117489d36f3a1a80c8815c1137747a9.mp3*~data=user_id=0,application_id=42~hmac=200175dce32eb1b61274e18fa556f594826b84abf44fc04faafda561bee8f496",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/e715766b21a8db6076f6a9a89e25cf82/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "Moneytalks",
    artist: "AC/DC",
    id: 92720106,
    release_date: "1990-09-21",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/a/5/4/0/a547b7039cd70bc6c583d38f99c4e748.mp3?hdnea=exp=1763730487~acl=/api/1/1/a/5/4/0/a547b7039cd70bc6c583d38f99c4e748.mp3*~data=user_id=0,application_id=42~hmac=f4b452a2bb6d954076422e6c3f49a288508a1992f907492efd8993929ea63bb8",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/e715766b21a8db6076f6a9a89e25cf82/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "Uma Thurman",
    artist: "Fall Out Boy",
    id: 92872160,
    release_date: "2015-01-20",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/1/d/9/0/1d9955b9c7bfb03929bb91a92f88cdd5.mp3?hdnea=exp=1763730487~acl=/api/1/1/1/d/9/0/1d9955b9c7bfb03929bb91a92f88cdd5.mp3*~data=user_id=0,application_id=42~hmac=9c3b34dbdc1dd082463481f2dea28825b9e6e20b8593e506c09d1d9bd4ef738e",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/c0a1d1281570ad3becbb6146c6d54c0c/250x250-000000-80-0-0.jpg",
    genre: "Alternative",
  },
  {
    title: "Heartbeat Song",
    artist: "Kelly Clarkson",
    id: 93029240,
    release_date: "2015-01-12",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/3/4/c/0/34cce7bc8877ab1b3104b973ef13fb5d.mp3?hdnea=exp=1763730487~acl=/api/1/1/3/4/c/0/34cce7bc8877ab1b3104b973ef13fb5d.mp3*~data=user_id=0,application_id=42~hmac=90182e7bdc253c2dad9667e03ca790650e0a27cf2d97926299d3739d730cd1ee",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/518d7d043e005c17c96db2afb94f790f/250x250-000000-80-0-0.jpg",
    genre: "Alternative",
  },
  {
    title: "Uncover",
    artist: "Zara Larsson",
    id: 93194632,
    release_date: "2015-01-19",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/1/4/7/0/147a5e85bd5b0819be74f57a97a61e71.mp3?hdnea=exp=1763730487~acl=/api/1/1/1/4/7/0/147a5e85bd5b0819be74f57a97a61e71.mp3*~data=user_id=0,application_id=42~hmac=39da19439cf6618b9dcd959a37ab579276bf86be39af57f1d40497aafe28c3e0",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/19c9a6e7fc71b50afe379d22ff564d9c/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Headsprung",
    artist: "LL COOL J",
    id: 93195088,
    release_date: "2004-03-09",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/c/c/8/0/cc887f0b5a83ff5e29c86b851e775fce.mp3?hdnea=exp=1763730487~acl=/api/1/1/c/c/8/0/cc887f0b5a83ff5e29c86b851e775fce.mp3*~data=user_id=0,application_id=42~hmac=bd865b300a0d90177e585eb4319ab848ebefb80fd669a06b3263dce75589afc4",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/f906fa962984644b266f6da8c657c048/250x250-000000-80-0-0.jpg",
    genre: "Rap/Hip Hop",
  },
  {
    title: "All That She Wants",
    artist: "Ace of Base",
    id: 93851020,
    release_date: "1992-11-10",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/9/b/0/0/9b0f3a66a9c89f7274ee31eb47be2b1c.mp3?hdnea=exp=1763730487~acl=/api/1/1/9/b/0/0/9b0f3a66a9c89f7274ee31eb47be2b1c.mp3*~data=user_id=0,application_id=42~hmac=62dd2f31440157e9610cd3a11c20c019981e342b85905f40b0181ee99dc23aaa",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/cbd01c1f0b97725e2e069f579a0020f8/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Worth It (feat. Kid Ink)",
    artist: "Fifth Harmony",
    id: 94195484,
    release_date: "2015-06-21",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/b/e/2/0/be2c7a8ebffcd6fe29d8522fd31b8542.mp3?hdnea=exp=1763730487~acl=/api/1/1/b/e/2/0/be2c7a8ebffcd6fe29d8522fd31b8542.mp3*~data=user_id=0,application_id=42~hmac=9bec64f7ebbc62a5e093f0c4ff5c52ba0f8a1de2e1efbae98f6489801b66ac16",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/f7f85b17171a8b1d062dca5484c022de/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Truffle Butter",
    artist: "Nicki Minaj",
    id: 94195822,
    release_date: "2015-02-03",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/b/a/e/0/bae444fcc6664d9371491ea7f3966ea7.mp3?hdnea=exp=1763730487~acl=/api/1/1/b/a/e/0/bae444fcc6664d9371491ea7f3966ea7.mp3*~data=user_id=0,application_id=42~hmac=dfd7a1218157230e79473cdfc70e2903170820161100211ba940bb1126a8c70b",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/9c7a83a79ec78cfa0e4d93839d065557/250x250-000000-80-0-0.jpg",
    genre: "Rap/Hip Hop",
  },
  {
    title: "Marvin Gaye (feat. Meghan Trainor)",
    artist: "Charlie Puth",
    id: 94424876,
    release_date: "2015-02-10",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/1/4/a/0/14ac4fcc4165c8ed447fc1716b318e46.mp3?hdnea=exp=1763730487~acl=/api/1/1/1/4/a/0/14ac4fcc4165c8ed447fc1716b318e46.mp3*~data=user_id=0,application_id=42~hmac=548e01abf80dc736a6fbdcc6010ac1ea7c74edfe4b560343cf4d963dd0880843",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/64807472696691250b2d9842de935fd9/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Break Stuff",
    artist: "Limp Bizkit",
    id: 94613616,
    release_date: "1999-02-17",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/c/4/f/0/c4f2e311d3f1c6be5c4c73f4687a4c04.mp3?hdnea=exp=1763730487~acl=/api/1/1/c/4/f/0/c4f2e311d3f1c6be5c4c73f4687a4c04.mp3*~data=user_id=0,application_id=42~hmac=9b734081ca5db27e57d9c732edae83030d90b5b38256a34fc0b45253a5fd581c",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/997093089e97966606459e719848329f/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "Love Me Like You Do",
    artist: "Ellie Goulding",
    id: 94664184,
    release_date: "2015-02-15",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/b/8/c/0/b8ca9d3f1be186d32e32b0e93f5185cd.mp3?hdnea=exp=1763730487~acl=/api/1/1/b/8/c/0/b8ca9d3f1be186d32e32b0e93f5185cd.mp3*~data=user_id=0,application_id=42~hmac=037924c5ea5589022ce27a666494bcbd950f5a5e499011f429f2a87f16cfcc08",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/68753cbcc25b895096edf665bab00f65/250x250-000000-80-0-0.jpg",
    genre: "Films/Games",
  },
  {
    title: "Ex's & Oh's",
    artist: "Elle King",
    id: 94753848,
    release_date: "2015-05-26",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/7/e/6/0/7e6ac8bf74f8b2322e65a4223625f731.mp3?hdnea=exp=1763730487~acl=/api/1/1/7/e/6/0/7e6ac8bf74f8b2322e65a4223625f731.mp3*~data=user_id=0,application_id=42~hmac=53d3ad1b2ceaae8ee327cf16755f313f89fe562c301a520adb2ebeea2f02f84d",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/7663599d3a24513178261fcbe91f94c0/250x250-000000-80-0-0.jpg",
    genre: "Alternative",
  },
  {
    title: "See You Again (feat. Charlie Puth)",
    artist: "Wiz Khalifa",
    id: 95813354,
    release_date: "2015-03-10",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/7/8/5/0/785e73b6069d7600a02ef6178dc8020b.mp3?hdnea=exp=1763730487~acl=/api/1/1/7/8/5/0/785e73b6069d7600a02ef6178dc8020b.mp3*~data=user_id=0,application_id=42~hmac=c9c8a776274bbfac6cd9e27d9bbaeafce3487eab5bc4b17f6e9600ad3905dc73",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/9411ab46dfc749311f7bbfd7398b7251/250x250-000000-80-0-0.jpg",
    genre: "Rap/Hip Hop",
  },
  {
    title: "Where Are Ü Now (with Justin Bieber)",
    artist: "Jack Ü",
    id: 95963378,
    release_date: "2015-02-24",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/d/5/c/0/d5ce6934ce4f71ca1a43ac55ca1e8692.mp3?hdnea=exp=1763730487~acl=/api/1/1/d/5/c/0/d5ce6934ce4f71ca1a43ac55ca1e8692.mp3*~data=user_id=0,application_id=42~hmac=f55f1eaaeefab3fd97790e90923881021d9e435b73de80966979621f5c635f95",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/f26a87471422a3800e576cf18bde4184/250x250-000000-80-0-0.jpg",
    genre: "Electro",
  },
  {
    title: "FourFiveSeconds",
    artist: "Rihanna",
    id: 95965912,
    release_date: "2015-01-24",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/4/c/7/0/4c77f893ebc00b70d9431039f33e1f4e.mp3?hdnea=exp=1763730487~acl=/api/1/1/4/c/7/0/4c77f893ebc00b70d9431039f33e1f4e.mp3*~data=user_id=0,application_id=42~hmac=34324a12fbb8d56cbf72b2bc66b64868accd69f860d6695946f6059b60a17000",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/ebe39c7db49fedcc2c0e8b28daf6bf31/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Ain't Nobody (Loves Me Better)",
    artist: "Felix Jaehn",
    id: 95978792,
    release_date: "2015-04-03",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/1/e/c/0/1ecbc1e8eac7ab78343e95ae163339bb.mp3?hdnea=exp=1763730487~acl=/api/1/1/1/e/c/0/1ecbc1e8eac7ab78343e95ae163339bb.mp3*~data=user_id=0,application_id=42~hmac=7f3f60c45f391c2f56702f4b376c6702dc93524bf7d46a00727bf9584fa2a81b",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/fd5af0c9128cada6270eed382f2adc87/250x250-000000-80-0-0.jpg",
    genre: "Dance",
  },
  {
    title: 'It Must Have Been Love (From the Film "Pretty Woman")',
    artist: "Roxette",
    id: 97085034,
    release_date: "2011-07-26",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/0/6/6/0/066aae449406b6ea3addfb6ad51a6ded.mp3?hdnea=exp=1763730487~acl=/api/1/1/0/6/6/0/066aae449406b6ea3addfb6ad51a6ded.mp3*~data=user_id=0,application_id=42~hmac=28a3ddb0f1320bf245c4b71391daa38649cd726ac6fa8ec50f1addf676eca3c9",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/ea2967f883f39855e430d24feddf4a19/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Don't Worry (with Ray Dalton)",
    artist: "Madcon",
    id: 97094250,
    release_date: "2015-04-10",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/0/c/8/0/0c88933400a7622c191fbea8ffa85253.mp3?hdnea=exp=1763730487~acl=/api/1/1/0/c/8/0/0c88933400a7622c191fbea8ffa85253.mp3*~data=user_id=0,application_id=42~hmac=fcdfbc19e91ee15892365f35090f7a6e3d1c8f2f3736207364c24441d36066b8",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/d778373518b1c54b3182041a0dfe4b07/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Stitches",
    artist: "Shawn Mendes",
    id: 113418500,
    release_date: "2015-04-14",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/9/0/d/0/90d519b85ffa95029493e12946963257.mp3?hdnea=exp=1763731686~acl=/api/1/1/9/0/d/0/90d519b85ffa95029493e12946963257.mp3*~data=user_id=0,application_id=42~hmac=4157d44ce1467b71f9627c1dbe81915f70c31552b948ae1862803eb6ce0c5034",
    cover: "https://api.deezer.com/album/11748100/image",
    genre: "Pop",
  },
  {
    title: "Reach",
    artist: "S Club 7",
    id: 98981556,
    release_date: "2015-05-04",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/b/6/1/0/b6109d50a76621e6be34999da44c708f.mp3?hdnea=exp=1763730487~acl=/api/1/1/b/6/1/0/b6109d50a76621e6be34999da44c708f.mp3*~data=user_id=0,application_id=42~hmac=6371a73442f30cc38cbb228daced0144877b41331e76928ec99386846e2ed342",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/5bea3cbaea9de3fdc785c64412b157ad/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Have You Ever",
    artist: "S Club 7",
    id: 98981564,
    release_date: "2015-05-04",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/c/6/9/0/c6906abee0260766987f3915ec67b4f4.mp3?hdnea=exp=1763730487~acl=/api/1/1/c/6/9/0/c6906abee0260766987f3915ec67b4f4.mp3*~data=user_id=0,application_id=42~hmac=adcfff13c2f936c45995799ca170a53bb06aaffa60260659f9c046f515f75cc0",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/5bea3cbaea9de3fdc785c64412b157ad/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "One Sweet Day",
    artist: "Mariah Carey",
    id: 99408480,
    release_date: "1995-11-14",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/5/7/8/0/5789309cb4ad3fddb953e949daa15e36.mp3?hdnea=exp=1763730487~acl=/api/1/1/5/7/8/0/5789309cb4ad3fddb953e949daa15e36.mp3*~data=user_id=0,application_id=42~hmac=d7aac0acf8bf6b7e55cb3132d20beb11136c3cdf87e2f69912ee11659e0e98d2",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/608dcac5f547cd39e1caa441e64f33e8/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Thinking About Your Love",
    artist: "Kenny Thomas",
    id: 99558148,
    release_date: "2015-06-02",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/7/4/7/0/747627497ac0bfdc20b902e8b7d14b43.mp3?hdnea=exp=1763730487~acl=/api/1/1/7/4/7/0/747627497ac0bfdc20b902e8b7d14b43.mp3*~data=user_id=0,application_id=42~hmac=b7935595e2b1588ed188ce2b8a448c2359322cec81afd6a127bd4cb20f09a415",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/7cd455219b3b685a3dd93176f96be680/250x250-000000-80-0-0.jpg",
    genre: "Soul & Funk",
  },
  {
    title: "I Still Believe",
    artist: "Mariah Carey",
    id: 596063,
    release_date: "2015-05-05",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/9/4/9/0/949f0a497092cbcf8323f381b387ee6a.mp3?hdnea=exp=1763731687~acl=/api/1/1/9/4/9/0/949f0a497092cbcf8323f381b387ee6a.mp3*~data=user_id=0,application_id=42~hmac=2ada19ea8198361f8d84317aa6bb2a917b0e0a5dd083a21598aa6167154a6710",
    cover: "https://api.deezer.com/album/76133/image",
    genre: "Pop",
  },
  {
    title: "Roses (feat. ROZES)",
    artist: "The Chainsmokers",
    id: 99756342,
    release_date: "2015-06-15",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/d/9/1/0/d91d869efac393df27aaf51a7cae81d0.mp3?hdnea=exp=1763730487~acl=/api/1/1/d/9/1/0/d91d869efac393df27aaf51a7cae81d0.mp3*~data=user_id=0,application_id=42~hmac=b15a4fa79613da672f1e404ccbcbdc1b20138f7f3f6eacc4eadea577b862b533",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/dca2f32070d5bebf548ce450f969bcc8/250x250-000000-80-0-0.jpg",
    genre: "Electro",
  },
  {
    title: "Stressed Out",
    artist: "Twenty One Pilots",
    id: 99976952,
    release_date: "2015-05-15",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/0/3/9/0/039205494378011a773a49f8929ff032.mp3?hdnea=exp=1763730487~acl=/api/1/1/0/3/9/0/039205494378011a773a49f8929ff032.mp3*~data=user_id=0,application_id=42~hmac=519152418761ae149e636190cdedf942ccd9e7f135e9bbc3802881901249c418",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/48e4d114036a2b4ac24f7fadb44a3c4d/250x250-000000-80-0-0.jpg",
    genre: "Alternative",
  },
  {
    title: "Sugar",
    artist: "Maroon 5",
    id: 100004590,
    release_date: "2015-05-15",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/1/2/3/0/123f63052868a933dde356de070d7855.mp3?hdnea=exp=1763730487~acl=/api/1/1/1/2/3/0/123f63052868a933dde356de070d7855.mp3*~data=user_id=0,application_id=42~hmac=efdb06ae255b319c41248f00d8b1f6575e726cb6684196a19672317308330ca3",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/f0a1d4442389bcd7919a7054f8c0b785/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Want to Want Me",
    artist: "Jason Derülo",
    id: 100598482,
    release_date: "2015-06-19",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/b/d/b/0/bdb295c63fea74e8c5b8d0154ab0a143.mp3?hdnea=exp=1763730487~acl=/api/1/1/b/d/b/0/bdb295c63fea74e8c5b8d0154ab0a143.mp3*~data=user_id=0,application_id=42~hmac=f4c39cb135287aa461239787216fbfef691daacce4d7056b1db6769f7b72eeed",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/4e438c2f2ad8cde2ff67009ce311df06/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Watch Me (Whip / Nae Nae)",
    artist: "Silentó",
    id: 100614636,
    release_date: "2015-05-06",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/a/2/0/0/a204688c7e74520e3342609aefafb17b.mp3?hdnea=exp=1763730487~acl=/api/1/1/a/2/0/0/a204688c7e74520e3342609aefafb17b.mp3*~data=user_id=0,application_id=42~hmac=85a73c9ab3f3e803e44bf43c26824dcec1d248f9ed9de34d1aa150781276ebd3",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/294810837e79077c74039a2bde044dfe/250x250-000000-80-0-0.jpg",
    genre: "Rap/Hip Hop",
  },
  {
    title: "Jubel",
    artist: "Klingande",
    id: 102875744,
    release_date: "2015-06-30",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/8/a/5/0/8a5e96327ffdc5b5bc7711eb952d2e6f.mp3?hdnea=exp=1763730487~acl=/api/1/1/8/a/5/0/8a5e96327ffdc5b5bc7711eb952d2e6f.mp3*~data=user_id=0,application_id=42~hmac=e92299f58ef5ffdc85490eb070c9a5a7aa03349b579f5d3736166c691db9646e",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/0a1b6fef621f8eb2081e6cb4850ac27b/250x250-000000-80-0-0.jpg",
    genre: "Electro",
  },
  {
    title: "I Took A Pill In Ibiza",
    artist: "Mike Posner",
    id: 124550818,
    release_date: "2015-07-24",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/b/c/1/0/bc15c8b13c2af1ead2e1f3a059fd45da.mp3?hdnea=exp=1763731687~acl=/api/1/1/b/c/1/0/bc15c8b13c2af1ead2e1f3a059fd45da.mp3*~data=user_id=0,application_id=42~hmac=b816ae33518637a7db414c94ab6efa3e8d4dfbb552b1cf0c3725488c41ffc9f3",
    cover: "https://api.deezer.com/album/13076610/image",
    genre: "Pop",
  },
  {
    title: "How Deep is Your Love (feat. Disciples)",
    artist: "Calvin Harris",
    id: 103996098,
    release_date: "2015-07-17",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/d/9/f/0/d9f98813bdad5d7556be280bbc3e7514.mp3?hdnea=exp=1763730487~acl=/api/1/1/d/9/f/0/d9f98813bdad5d7556be280bbc3e7514.mp3*~data=user_id=0,application_id=42~hmac=a739c21634d8e98f09fd758eadf029eb58518e2e71aaf95370c42f2caea22008",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/5f79dbfc625337959420585635b03e91/250x250-000000-80-0-0.jpg",
    genre: "Dance",
  },
  {
    title: "Hold My Hand",
    artist: "Jess Glynne",
    id: 105498804,
    release_date: "2015-03-27",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/4/9/6/0/49601e8d76ce4a73bebd27084c9335b7.mp3?hdnea=exp=1763730487~acl=/api/1/1/4/9/6/0/49601e8d76ce4a73bebd27084c9335b7.mp3*~data=user_id=0,application_id=42~hmac=7acfc5204b1f8b327996a6c2182704f8230429ea5eb1f77cdd0c753dcd650d20",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/fab6839029d8fd4736549144f350070c/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Back Here",
    artist: "Bb Mak",
    id: 106397338,
    release_date: "2000-04-11",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/1/8/4/0/18476ef886473157ef8399ceab1761d8.mp3?hdnea=exp=1763730487~acl=/api/1/1/1/8/4/0/18476ef886473157ef8399ceab1761d8.mp3*~data=user_id=0,application_id=42~hmac=74bb43c87aa15bca04e8a41af298e3ffacd1222319ca9f25e87aef54ae7ee232",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/4549cf4c92daf334a4ba5ff1ed40f289/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "The Hills",
    artist: "The Weeknd",
    id: 106506512,
    release_date: "2015-08-28",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/7/c/5/0/7c561179e6eb8c33aaac84ae86c4f79e.mp3?hdnea=exp=1763730487~acl=/api/1/1/7/c/5/0/7c561179e6eb8c33aaac84ae86c4f79e.mp3*~data=user_id=0,application_id=42~hmac=e38fc4fddb511e49cd9325cb9e69670170130e3c99f5d74f69b17029a0c555f0",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/eea9f7fc913300e40307a0ff70dc73cf/250x250-000000-80-0-0.jpg",
    genre: "R&B",
  },
  {
    title: "Can't Feel My Face",
    artist: "The Weeknd",
    id: 106506516,
    release_date: "2015-06-09",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/6/f/9/0/6f9235bd9737db1a62149c9f5f474f43.mp3?hdnea=exp=1763730487~acl=/api/1/1/6/f/9/0/6f9235bd9737db1a62149c9f5f474f43.mp3*~data=user_id=0,application_id=42~hmac=067ba76beaaf9dec0a9ad37c7d9241d323be93cb1b54c79a3e38e9ee54b56bd6",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/eea9f7fc913300e40307a0ff70dc73cf/250x250-000000-80-0-0.jpg",
    genre: "R&B",
  },
  {
    title: "Waiting For Love",
    artist: "Avicii",
    id: 107346368,
    release_date: "2015-08-07",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/8/8/1/0/8817d20f31a1d4ba508bd74739af6318.mp3?hdnea=exp=1763730487~acl=/api/1/1/8/8/1/0/8817d20f31a1d4ba508bd74739af6318.mp3*~data=user_id=0,application_id=42~hmac=72eb5efd5b72f0d88012a2eb5e4a5c85504fd1a0ec0fa8a9f2178b92d0408e67",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/6fe420c62b5696019b9359b689785086/250x250-000000-80-0-0.jpg",
    genre: "Dance",
  },
  {
    title: "Runnin' (Lose It All)",
    artist: "Naughty Boy",
    id: 107406104,
    release_date: "2015-09-18",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/5/a/6/0/5a6aee285c93337c60624b8f0612af53.mp3?hdnea=exp=1763730487~acl=/api/1/1/5/a/6/0/5a6aee285c93337c60624b8f0612af53.mp3*~data=user_id=0,application_id=42~hmac=7cc717444b944352b746a072fd2c9069f80bc5111048f2b1da9af9a92216f96b",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/a826f8f8efb62f35b3f78f83b18a233b/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Sugar (feat. Francesco Yates)",
    artist: "Robin Schulz",
    id: 107471416,
    release_date: "2015-07-17",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/3/6/4/0/36418a9c145c529d44c10e727c7a231c.mp3?hdnea=exp=1763730487~acl=/api/1/1/3/6/4/0/36418a9c145c529d44c10e727c7a231c.mp3*~data=user_id=0,application_id=42~hmac=9cf86ac0fc5557b5e9b9720aa97dbb2b4c60099c8c936e7bd934dde453deea8a",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/43815c2b219ed818623d61c6ab71a3b5/250x250-000000-80-0-0.jpg",
    genre: "Dance",
  },
  {
    title: "Regret",
    artist: "New Order",
    id: 107749890,
    release_date: "1993-09-25",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/1/2/d/0/12df090fbffc464ef836658fcf0bd4f8.mp3?hdnea=exp=1763730487~acl=/api/1/1/1/2/d/0/12df090fbffc464ef836658fcf0bd4f8.mp3*~data=user_id=0,application_id=42~hmac=217fa9f4bfc454d8b3e489934dc48f30f3c0a042294dc5c092d2a7d756354c34",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/a0172cf1cd85983f65ea24df3b831524/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: 'Writing\'s On The Wall (From "Spectre" Soundtrack)',
    artist: "Sam Smith",
    id: 107900036,
    release_date: "2015-09-25",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/3/1/5/0/3153ca71b74366b43e30d4f99827fc8e.mp3?hdnea=exp=1763731686~acl=/api/1/1/3/1/5/0/3153ca71b74366b43e30d4f99827fc8e.mp3*~data=user_id=0,application_id=42~hmac=171f8cb5b980f360a7d7bf643d150069d1782cd0394ca7c39e543d3845b1d66a",
    cover: "https://api.deezer.com/album/11253166/image",
    genre: "Pop",
  },
  {
    title: "Skyfall",
    artist: "Adele",
    id: 82715364,
    release_date: "2012-10-05",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/e/2/6/0/e26bc2264f5f33f2587b0f5cc0b3b54e.mp3?hdnea=exp=1763731687~acl=/api/1/1/e/2/6/0/e26bc2264f5f33f2587b0f5cc0b3b54e.mp3*~data=user_id=0,application_id=42~hmac=aff96039efc2b7120ebd503a4e7ca7db4b8006eee69e9f232076443f181bde4e",
    cover: "https://api.deezer.com/album/8307448/image",
    genre: "Pop",
  },
  {
    title: "Hands To Myself",
    artist: "Selena Gomez",
    id: 109169056,
    release_date: "2015-10-09",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/6/e/5/0/6e555aa7174aaa4c09f6e7afd51a8cb1.mp3?hdnea=exp=1763731686~acl=/api/1/1/6/e/5/0/6e555aa7174aaa4c09f6e7afd51a8cb1.mp3*~data=user_id=0,application_id=42~hmac=26d4b4ce4f5b41556ed6666e1de91041a36c2fd57ddd6bd6b83a03a5ad66a350",
    cover: "https://api.deezer.com/album/11375172/image",
    genre: "Pop",
  },
  {
    title: "Good For You",
    artist: "Selena Gomez",
    id: 109169062,
    release_date: "2015-10-09",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/f/c/6/0/fc63dcb81f2fb03778cba32c8a54ef21.mp3?hdnea=exp=1763731686~acl=/api/1/1/f/c/6/0/fc63dcb81f2fb03778cba32c8a54ef21.mp3*~data=user_id=0,application_id=42~hmac=759802ab643789a2fb97df141ff084c59d0c359a089125f869da9fc9f8fca097",
    cover: "https://api.deezer.com/album/11375172/image",
    genre: "Pop",
  },
  {
    title: "Cool for the Summer",
    artist: "Demi Lovato",
    id: 109703218,
    release_date: "2015-07-01",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/f/b/9/0/fb9d0e692e44ce6575ff9073f66a18db.mp3?hdnea=exp=1763731687~acl=/api/1/1/f/b/9/0/fb9d0e692e44ce6575ff9073f66a18db.mp3*~data=user_id=0,application_id=42~hmac=210f65a13d9364122d5ba71b860c6b21696a36426c68b476a3eb852a514b3817",
    cover: "https://api.deezer.com/album/11428814/image",
    genre: "Pop",
  },
  {
    title: "Bang My Head (feat. Sia & Fetty Wap)",
    artist: "David Guetta",
    id: 110663020,
    release_date: "2015-11-28",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/e/2/1/0/e2199586208bccaa3f3a34701eaa13a8.mp3?hdnea=exp=1763731687~acl=/api/1/1/e/2/1/0/e2199586208bccaa3f3a34701eaa13a8.mp3*~data=user_id=0,application_id=42~hmac=511f5c36617def118d357f05e18b7858ca9ec3617406ad2682f770b79994f4d4",
    cover: "https://api.deezer.com/album/11514762/image",
    genre: "Dance",
  },
  {
    title: "Black Magic",
    artist: "Little Mix",
    id: 1540130952,
    release_date: "2015-05-21",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/d/e/9/0/de998a80c9adf4e05844067819e9bb36.mp3?hdnea=exp=1763731687~acl=/api/1/1/d/e/9/0/de998a80c9adf4e05844067819e9bb36.mp3*~data=user_id=0,application_id=42~hmac=c23f14111e91d7f58cb6388c744c87e06e9a35c5b492360120b468683a3d9cd6",
    cover: "https://api.deezer.com/album/269913152/image",
    genre: "Pop",
  },
  {
    title: "What Do You Mean?",
    artist: "Justin Bieber",
    id: 112662364,
    release_date: "2015-11-13",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/b/0/3/0/b0363bc18e45090d1699fcf51c65e2d6.mp3?hdnea=exp=1763731687~acl=/api/1/1/b/0/3/0/b0363bc18e45090d1699fcf51c65e2d6.mp3*~data=user_id=0,application_id=42~hmac=1733158ec8e71b7f2d185316de32380a7cca772c0159a72669b8ce1c7a21a7db",
    cover: "https://api.deezer.com/album/11674708/image",
    genre: "Pop",
  },
  {
    title: "Sorry",
    artist: "Justin Bieber",
    id: 112662366,
    release_date: "2015-11-13",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/7/8/e/0/78e56ce103487a2c3395c0e6dff48a2f.mp3?hdnea=exp=1763731687~acl=/api/1/1/7/8/e/0/78e56ce103487a2c3395c0e6dff48a2f.mp3*~data=user_id=0,application_id=42~hmac=d0157d2b498c964fce78172ca9b334d45b41d75f97c025f225374b15b02ec80f",
    cover: "https://api.deezer.com/album/11674708/image",
    genre: "Pop",
  },
  {
    title: "Love Yourself",
    artist: "Justin Bieber",
    id: 112662368,
    release_date: "2015-11-09",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/c/d/d/0/cddd7c0890d483abfd383c41c14a7e43.mp3?hdnea=exp=1763731687~acl=/api/1/1/c/d/d/0/cddd7c0890d483abfd383c41c14a7e43.mp3*~data=user_id=0,application_id=42~hmac=6db1a7d61b05a015d6156bc5b251aea46e12b09c31a7fbc1209124d82a7a9091",
    cover: "https://api.deezer.com/album/11674708/image",
    genre: "Pop",
  },
  {
    title: "Drag Me Down",
    artist: "One Direction",
    id: 112667890,
    release_date: "2015-11-13",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/7/a/7/0/7a7bd26a8ce73500eaa67aad98a4b0fb.mp3?hdnea=exp=1763731687~acl=/api/1/1/7/a/7/0/7a7bd26a8ce73500eaa67aad98a4b0fb.mp3*~data=user_id=0,application_id=42~hmac=e0429cccaefa0872e43eb8e53c4216b6188bf46975967554e25ae59f140f04af",
    cover: "https://api.deezer.com/album/11675254/image",
    genre: "Pop",
  },
  {
    title: "Lean On (feat. MØ & DJ Snake)",
    artist: "Major Lazer",
    id: 113366532,
    release_date: "2015-11-27",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/3014373057a1486c786709b8dd888368/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Lips Are Movin",
    artist: "Meghan Trainor",
    id: 113420742,
    release_date: "2014-10-21",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/e/9/e/0/e9e2d6b03b3df5230072ca1857d48fb4.mp3?hdnea=exp=1763731687~acl=/api/1/1/e/9/e/0/e9e2d6b03b3df5230072ca1857d48fb4.mp3*~data=user_id=0,application_id=42~hmac=276e601473b26636ffab8a6afb801ad50fda1f3eb65704edb1ae86e193365b83",
    cover: "https://api.deezer.com/album/11748268/image",
    genre: "Pop",
  },
  {
    title: "Hymn for the Weekend",
    artist: "Coldplay",
    id: 114811546,
    release_date: "2015-12-04",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/9/1/c/0/91c17f88f9d882d7b015595af8fce617.mp3?hdnea=exp=1763731687~acl=/api/1/1/9/1/c/0/91c17f88f9d882d7b015595af8fce617.mp3*~data=user_id=0,application_id=42~hmac=a0ff2d1ee3813d11a038eb0133fce64ab4ef6b3432b9d55191674fcb915d9b0e",
    cover: "https://api.deezer.com/album/11898198/image",
    genre: "Alternative",
  },
  {
    title: "Adventure of a Lifetime",
    artist: "Coldplay",
    id: 114811560,
    release_date: "2015-12-04",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/5df065fdcbaffd0f83d09789bad9d2db/250x250-000000-80-0-0.jpg",
    genre: "Alternative",
  },
  {
    title: "I can't stand it",
    artist: "Twenty 4 Seven Ft. Capt. Hollywood",
    id: 116924416,
    release_date: "2016-01-06",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/d6287f851eca2e533b0cb3f201623048/250x250-000000-80-0-0.jpg",
    genre: "Dance",
  },
  {
    title: "Never Be Like You",
    artist: "Flume",
    id: 117176358,
    release_date: "2016-01-16",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/3b2956ccdac8af8f657e909188aa0231/250x250-000000-80-0-0.jpg",
    genre: "Electro",
  },
  {
    title: "We Don't Talk Anymore (feat. Selena Gomez)",
    artist: "Charlie Puth",
    id: 117797212,
    release_date: "2016-01-29",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/948200588c813c1afd10f29b56e0ce50/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Work",
    artist: "Rihanna",
    id: 118190298,
    release_date: "2016-01-29",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/4fc5f387624c25de0ec96b4719e3a36d/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Needed Me",
    artist: "Rihanna",
    id: 118190304,
    release_date: "2016-01-29",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/4fc5f387624c25de0ec96b4719e3a36d/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Love On The Brain",
    artist: "Rihanna",
    id: 118190312,
    release_date: "2016-01-29",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/4fc5f387624c25de0ec96b4719e3a36d/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Chocolate",
    artist: "The 1975",
    id: 118760310,
    release_date: "2013-03-04",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/8f71d66a99bcb46e0768bced1769d0f9/250x250-000000-80-0-0.jpg",
    genre: "Alternative",
  },
  {
    title: "It's Not Over",
    artist: "Daughtry",
    id: 118996424,
    release_date: "2006-11-21",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/81916bcc55a66a059964ebea556d794d/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Home",
    artist: "Daughtry",
    id: 118996426,
    release_date: "2005-02-08",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/81916bcc55a66a059964ebea556d794d/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Feels Like Tonight",
    artist: "Daughtry",
    id: 118996432,
    release_date: "2006-02-07",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/81916bcc55a66a059964ebea556d794d/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Since I Don't Have You",
    artist: "Guns N' Roses",
    id: 119519234,
    release_date: "1958-06-01",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/7d2814d6c110b68afb3efd5573624666/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "Panda",
    artist: "Desiigner",
    id: 120026876,
    release_date: "2016-02-26",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/c8de97b0f63c2fc67106ca69198aee18/250x250-000000-80-0-0.jpg",
    genre: "Rap/Hip Hop",
  },
  {
    title: "King",
    artist: "Years & Years",
    id: 120307594,
    release_date: "2015-02-28",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/c40aaac2fb76f4b95a8623aa460f59c5/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Here",
    artist: "Alessia Cara",
    id: 120739000,
    release_date: "2015-05-01",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/c2c09bb30073e88323ddcdb6e3311e49/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Scars To Your Beautiful",
    artist: "Alessia Cara",
    id: 120739016,
    release_date: "2015-11-13",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/c2c09bb30073e88323ddcdb6e3311e49/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Pop Ya Collar",
    artist: "Usher",
    id: 120742236,
    release_date: "2000-10-23",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/2c30c54358b56d1c0556a5aab00f48bd/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "This Girl (Kungs Vs Cookin' On 3 Burners)",
    artist: "Kungs",
    id: 121593956,
    release_date: "2016-03-25",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/6945e1d1812cfd26b0ff668886ebfe46/250x250-000000-80-0-0.jpg",
    genre: "Dance",
  },
  {
    title: "PILLOWTALK",
    artist: "ZAYN",
    id: 121595532,
    release_date: "2016-01-29",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/1224e92320d2d00568fb0327b248acf4/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "7 Years",
    artist: "Lukas Graham",
    id: 122016704,
    release_date: "2015-06-26",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/30db449ef0f3214b2eb5b95104d03de7/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Aloha",
    artist: "Møme",
    id: 122440564,
    release_date: "2015-10-30",
    preview:
      "https://cdn`s-preview-5.dzcdn.net/stream/c-582b578866983d6bbea1b13691e41100-7.mp3",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/27202f0b3fb35fbda502d9c873a0bf2f/250x250-000000-80-0-0.jpg",
    genre: "Electro",
  },
  {
    title: "Ain't Your Mama",
    artist: "Jennifer Lopez",
    id: 122450802,
    release_date: "2016-04-08",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/ad148abf988309facb40399ba4a54cec/250x250-000000-80-0-0.jpg",
    genre: "Electro",
  },
  {
    title: "I Wish I Was a Punk Rocker (with Flowers in My Hair)",
    artist: "Sandi Thom",
    id: 122539400,
    release_date: "2006-05-22",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/ddc4060f2db51579a6f807bbf954640d/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Low Life (feat. The Weeknd)",
    artist: "Future",
    id: 122703266,
    release_date: "2016-04-13",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/d67a9d21359a1704127c45dde2c8c57c/250x250-000000-80-0-0.jpg",
    genre: "Rap/Hip Hop",
  },
  {
    title: "All My Friends (feat. Tinashe & Chance the Rapper)",
    artist: "Snakehips",
    id: 122886910,
    release_date: "2016-04-15",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/9dee7bff71e7663fc2c94e8918266ada/250x250-000000-80-0-0.jpg",
    genre: "Electro",
  },
  {
    title: 'Just Like Fire (From "Alice Through The Looking Glass")',
    artist: "P!nk",
    id: 122946174,
    release_date: "2016-04-15",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/4/8/4/0/484c59e674950c29a7e48e03b3eace4f.mp3?hdnea=exp=1763729095~acl=/api/1/1/4/8/4/0/484c59e674950c29a7e48e03b3eace4f.mp3*~data=user_id=0,application_id=42~hmac=397993ddfbe5df6b3b5043909d5796f915f41382b0e23570cbc438f728422519",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/03afe5c85becc933ff77998808d08872/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Hotter Than Hell",
    artist: "Dua Lipa",
    id: 123357486,
    release_date: "2016-04-29",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/7/e/8/0/7e8a3e0e09cdcb31ac2157aac19a5bf1.mp3?hdnea=exp=1763729095~acl=/api/1/1/7/e/8/0/7e8a3e0e09cdcb31ac2157aac19a5bf1.mp3*~data=user_id=0,application_id=42~hmac=62247a3bc7bf92d63ba3d8d28fd0c4858b23154480b10285f7a91e7e87b5b450",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/6e92b4f69e3db10f830c66f089950dd1/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "This Is What You Came For",
    artist: "Calvin Harris",
    id: 123883254,
    release_date: "2016-04-29",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/e/e/9/0/ee9343b8c6302f49270fd6e96321276c.mp3?hdnea=exp=1763729095~acl=/api/1/1/e/e/9/0/ee9343b8c6302f49270fd6e96321276c.mp3*~data=user_id=0,application_id=42~hmac=3712069f6dec60a27966e50a3d6283de97f2e498dca60abd8766491cac64c9b1",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/b8af7ff13a47e2775307299843da9b36/250x250-000000-80-0-0.jpg",
    genre: "Electro",
  },
  {
    title: "Alarm",
    artist: "Anne-Marie",
    id: 123903244,
    release_date: "2016-05-20",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/7/c/2/0/7c23f9ea877b8cb0ac6c879a16e68de2.mp3?hdnea=exp=1763729095~acl=/api/1/1/7/c/2/0/7c23f9ea877b8cb0ac6c879a16e68de2.mp3*~data=user_id=0,application_id=42~hmac=ef4e66148b5111b4e3cccccfe6a9b416100f97b6ee1d3475bd3513a90842771d",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/8f152e1da4b3bb1ebbf33381b2a88f75/250x250-000000-80-0-0.jpg",
    genre: "Electro",
  },
  {
    title: "Dreams",
    artist: "Gabrielle",
    id: 124220438,
    release_date: "1977-02-04",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/e/5/0/0/e507ee7ef98568251cae7c3b13c1b43c.mp3?hdnea=exp=1763729095~acl=/api/1/1/e/5/0/0/e507ee7ef98568251cae7c3b13c1b43c.mp3*~data=user_id=0,application_id=42~hmac=5872ec7c7c32ed48e636d3bc4aa3fa8f21c36ee2544bc4d492b48a86b35c6083",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/e2cc14e736859706babb2246aee61e5e/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "CAN'T STOP THE FEELING! (from DreamWorks Animation's \"TROLLS\")",
    artist: "Justin Timberlake",
    id: 124237488,
    release_date: "2016-05-06",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/9/4/b/0/94b08535e1d86650c891c720af3aa77a.mp3?hdnea=exp=1763729095~acl=/api/1/1/9/4/b/0/94b08535e1d86650c891c720af3aa77a.mp3*~data=user_id=0,application_id=42~hmac=4ab3ee116d415fc966152aba081031af6210a184929cd3168e54d8f575f13589",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/209aa560e3b5fbe679e91887fc0c7332/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "This One's for You (feat. Zara Larsson)",
    artist: "David Guetta",
    id: 124433692,
    release_date: "2016-07-09",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/e/3/f/0/e3fdf45cc818ffeca9b5429581f0c46b.mp3?hdnea=exp=1763729095~acl=/api/1/1/e/3/f/0/e3fdf45cc818ffeca9b5429581f0c46b.mp3*~data=user_id=0,application_id=42~hmac=ada5a4b64abfa3e0b76dc9ed003d4956736867eb6540fdd9a49f9374f0de0f36",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/6e72ba6dace3fa59dab4bb403fc9ba4f/250x250-000000-80-0-0.jpg",
    genre: "Dance",
  },
  {
    title: "One Dance",
    artist: "Drake",
    id: 124603270,
    release_date: "2016-05-06",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/7/a/b/0/7ab0602a95834e7862f7ef2ee5389d88.mp3?hdnea=exp=1763729095~acl=/api/1/1/7/a/b/0/7ab0602a95834e7862f7ef2ee5389d88.mp3*~data=user_id=0,application_id=42~hmac=be1323716fdb084aa346349e0fdf297a50f5a0f566dd35118c0fa11084742c14",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/56bdb7a86a27fadb96332c0c8f1b8e81/250x250-000000-80-0-0.jpg",
    genre: "Rap/Hip Hop",
  },
  {
    title: "Too Good",
    artist: "Drake",
    id: 124603278,
    release_date: "2016-05-06",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/f/1/5/0/f152d4afb75fae93e1f8702f2e6be4b3.mp3?hdnea=exp=1763729095~acl=/api/1/1/f/1/5/0/f152d4afb75fae93e1f8702f2e6be4b3.mp3*~data=user_id=0,application_id=42~hmac=959485a33b0f77d2c1993a5b2300a3254dfc25b36210b055f4b143f03e30afd2",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/56bdb7a86a27fadb96332c0c8f1b8e81/250x250-000000-80-0-0.jpg",
    genre: "Rap/Hip Hop",
  },
  {
    title: "Hotline Bling",
    artist: "Drake",
    id: 124603286,
    release_date: "2016-05-06",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/a/c/1/0/ac1d5a7a9a829c0332a6de32a0f8a90b.mp3?hdnea=exp=1763729095~acl=/api/1/1/a/c/1/0/ac1d5a7a9a829c0332a6de32a0f8a90b.mp3*~data=user_id=0,application_id=42~hmac=0b35fac746320c602423203b07c5c36f42cc83700e64b0e9adfd65360a637132",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/56bdb7a86a27fadb96332c0c8f1b8e81/250x250-000000-80-0-0.jpg",
    genre: "Rap/Hip Hop",
  },
  {
    title: "Final Song",
    artist: "MØ",
    id: 124604316,
    release_date: "2016-05-13",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/6/a/6/0/6a6d9c8d17b80d11ac7c8ed70613564e.mp3?hdnea=exp=1763729095~acl=/api/1/1/6/a/6/0/6a6d9c8d17b80d11ac7c8ed70613564e.mp3*~data=user_id=0,application_id=42~hmac=d29c4e908e969d19cde4bd110125d77f5aec9eddfe37badd781e2e66acc8e191",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/fd198aa0a511e33d42c787a364434962/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Side To Side",
    artist: "Ariana Grande",
    id: 124995668,
    release_date: "2016-05-20",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/7/e/8/0/7e8c23116649d041bac2f15f39bd7424.mp3?hdnea=exp=1763729095~acl=/api/1/1/7/e/8/0/7e8c23116649d041bac2f15f39bd7424.mp3*~data=user_id=0,application_id=42~hmac=4b9b8fea836dbe1baaa0aa60abb1976eb49583489a19817fdeb688a834b3faa1",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/e5bf0368c12f211bdafe91deba06cdda/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Dangerous Woman",
    artist: "Ariana Grande",
    id: 124996686,
    release_date: "2016-03-11",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/1a8f399e9ddbb8ec2530232c0dfd953f/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Do You Remember?",
    artist: "Phil Collins",
    id: 125493146,
    release_date: "1989-11-20",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/7/2/d/0/72d68bc0e7c14fe405e6e90d344499d8.mp3?hdnea=exp=1763729095~acl=/api/1/1/7/2/d/0/72d68bc0e7c14fe405e6e90d344499d8.mp3*~data=user_id=0,application_id=42~hmac=bd0930a5bde611c91f0c6025964b2250d1de81e868f6563104dc7f371be3eca4",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/00e0c82ab19515ecb615775c4db797c7/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Something Happened on the Way to Heaven",
    artist: "Phil Collins",
    id: 125493148,
    release_date: "1989-11-20",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/4/a/4/0/4a4e1bd4f4a829fd85d983d26a9b6fa3.mp3?hdnea=exp=1763729095~acl=/api/1/1/4/a/4/0/4a4e1bd4f4a829fd85d983d26a9b6fa3.mp3*~data=user_id=0,application_id=42~hmac=f221d57531dca2a7b1ec01aa90233c5c919b7e0d66f9398730eac54f884aa700",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/00e0c82ab19515ecb615775c4db797c7/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "I Wish It Would Rain Down",
    artist: "Phil Collins",
    id: 125493152,
    release_date: "1989-11-20",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/e/e/f/0/eefc64253bbb503e79516cb0eeb7bf82.mp3?hdnea=exp=1763729095~acl=/api/1/1/e/e/f/0/eefc64253bbb503e79516cb0eeb7bf82.mp3*~data=user_id=0,application_id=42~hmac=8ba3aabb9ccf56ffb089b886aadb5200881df7dfdfe0cd90162357990c6a1c84",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/00e0c82ab19515ecb615775c4db797c7/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Work from Home (feat. Ty Dolla $ign)",
    artist: "Fifth Harmony",
    id: 125513414,
    release_date: "2016-02-26",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/9/a/2/0/9a2d83de7b1bf8d47f7cb90b66dc3f97.mp3?hdnea=exp=1763729095~acl=/api/1/1/9/a/2/0/9a2d83de7b1bf8d47f7cb90b66dc3f97.mp3*~data=user_id=0,application_id=42~hmac=ec3b52938f1790795e5a9104283eb56e5075917fe620577c5353fef58f037a55",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/4529a3c8ec16c3e21de17a6294a6b3e1/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Heathens",
    artist: "Twenty One Pilots",
    id: 126884459,
    release_date: "2016-06-16",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/8/6/8/0/8684b6d370f8e19eed27de357c3c4e89.mp3?hdnea=exp=1763729095~acl=/api/1/1/8/6/8/0/8684b6d370f8e19eed27de357c3c4e89.mp3*~data=user_id=0,application_id=42~hmac=fb5c041158d329f8dac2319f788727e5debd8d067053d8d8bbeabf1922a794d4",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/3dfc8c9e406cf1bba8ce0695a44a9b7e/250x250-000000-80-0-0.jpg",
    genre: "Alternative",
  },
  {
    title: "What's My Age Again?",
    artist: "blink-182",
    id: 127354205,
    release_date: "1999-09-13",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/5/7/4/0/574a967034713764316b48e4b8b68b52.mp3?hdnea=exp=1763729095~acl=/api/1/1/5/7/4/0/574a967034713764316b48e4b8b68b52.mp3*~data=user_id=0,application_id=42~hmac=c4156d1b54e82a6de1a2aaf2e473dba7264579f1f289a498648ad0fa0fb9e06e",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/50627ad1a5ce0215359f0e8b2e37a01f/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "Adam's Song",
    artist: "blink-182",
    id: 127354209,
    release_date: "1999-06-01",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/c/0/f/0/c0f564e18f68a4952f3ba58f980f1d94.mp3?hdnea=exp=1763729095~acl=/api/1/1/c/0/f/0/c0f564e18f68a4952f3ba58f980f1d94.mp3*~data=user_id=0,application_id=42~hmac=cbe1c504fa66b3d3f9031470fd9743c3648d864795cc537fb43c3bd6467366f1",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/50627ad1a5ce0215359f0e8b2e37a01f/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "Drinking in L.A.",
    artist: "Bran Van 3000",
    id: 128237751,
    release_date: "1997-03-31",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/5/c/9/0/5c97d1f1c16a11b6b6105749e90a83d2.mp3?hdnea=exp=1763729095~acl=/api/1/1/5/c/9/0/5c97d1f1c16a11b6b6105749e90a83d2.mp3*~data=user_id=0,application_id=42~hmac=5e125811d724cf5338c90f65eb59cf4e4b2c63c91f5caa92df33b1e9a3bf101b",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/f8cbd0fa24ca51b23b89fea5e3f51ff6/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Starving",
    artist: "Hailee Steinfeld",
    id: 128948012,
    release_date: "2016-07-22",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/a/7/8/0/a78bc8bb08ed7364f7fa7d725516062d.mp3?hdnea=exp=1763729095~acl=/api/1/1/a/7/8/0/a78bc8bb08ed7364f7fa7d725516062d.mp3*~data=user_id=0,application_id=42~hmac=54273bc1fedc2b8c8e487deeee383f032f88af191ae008036a57f00c77c23689",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/46b47680d6c0f754365a9744737ef426/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Life is a Highway",
    artist: "Rascal Flatts",
    id: 128948754,
    release_date: "2016-07-22",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/6/a/b/0/6abe190bd28cc35ffa750266c48df47d.mp3?hdnea=exp=1763729095~acl=/api/1/1/6/a/b/0/6abe190bd28cc35ffa750266c48df47d.mp3*~data=user_id=0,application_id=42~hmac=470628d815dce84bcbac4c5ff668e8311a02dfefa70220295ce3835a235a7e19",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/619de6393fcae78ae199d38324ed611c/250x250-000000-80-0-0.jpg",
    genre: "Films/Games",
  },
  {
    title: "Cold Water (feat. Justin Bieber & MØ)",
    artist: "Major Lazer",
    id: 129011934,
    release_date: "2016-07-23",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/a90fa0db4b7142b0fcd65f9c3c9a3a82/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "In the Name of Love",
    artist: "Martin Garrix",
    id: 129313094,
    release_date: "2016-07-29",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/e/9/f/0/e9f810d14e97f241541cc7fc40cb695f.mp3?hdnea=exp=1763729095~acl=/api/1/1/e/9/f/0/e9f810d14e97f241541cc7fc40cb695f.mp3*~data=user_id=0,application_id=42~hmac=4d03ec012d677309c23ea0c64863053aa902ab45cea0cb9a8dcf206161b5e183",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/eed47f7aa8765df6c4e8891a4a70d298/250x250-000000-80-0-0.jpg",
    genre: "Electro",
  },
  {
    title: "Middle",
    artist: "DJ Snake",
    id: 129632290,
    release_date: "2015-10-16",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/b/c/0/0/bc0cc895b99463798269b64103ae4ef0.mp3?hdnea=exp=1763729095~acl=/api/1/1/b/c/0/0/bc0cc895b99463798269b64103ae4ef0.mp3*~data=user_id=0,application_id=42~hmac=6fa7ffb33d2d2b90b91e8004b9315c702f4e87ed36d425e548d32d3e5194e853",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/6a52e1bbddc750c996a66b0ccfa4370c/250x250-000000-80-0-0.jpg",
    genre: "Dance",
  },
  {
    title: "I Don't Wanna Know (feat. Enya & P. Diddy)",
    artist: "Mario Winans",
    id: 130012244,
    release_date: "2004-08-12",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/4/6/f/0/46fa4e8cad2a0bb6f50f6fa31d3ebefa.mp3?hdnea=exp=1763729095~acl=/api/1/1/4/6/f/0/46fa4e8cad2a0bb6f50f6fa31d3ebefa.mp3*~data=user_id=0,application_id=42~hmac=1e56c70e1b3a5391530f91e63ef65d5b4f59e4c4753e515d4a3d98d45841bf4a",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/0c57677dbbbf536f80109d11664f00ad/250x250-000000-80-0-0.jpg",
    genre: "Rap/Hip Hop",
  },
  {
    title: "Black Beatles",
    artist: "Rae Sremmurd",
    id: 130105294,
    release_date: "2016-08-12",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/2/d/2/0/2d21de95abc3e94cc0379a488a039f12.mp3?hdnea=exp=1763729095~acl=/api/1/1/2/d/2/0/2d21de95abc3e94cc0379a488a039f12.mp3*~data=user_id=0,application_id=42~hmac=62e07d3af58732121e52c255997747db3405e51a4df1aaa371f4778cc4a24683",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/d9c957b88855e088940f96e955cf26be/250x250-000000-80-0-0.jpg",
    genre: "Rap/Hip Hop",
  },
  {
    title: "Love Lockdown (Album Version)",
    artist: "Kanye West",
    id: 130412304,
    release_date: "2008-09-18",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/e/1/1/0/e11bfa8b83b3a37636353621803687cd.mp3?hdnea=exp=1763729095~acl=/api/1/1/e/1/1/0/e11bfa8b83b3a37636353621803687cd.mp3*~data=user_id=0,application_id=42~hmac=7dce7ac363a36a121ca03b4f626e912d65ca054e7e86202f127e4d0d6049a01b",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/2877c6bf4fad750c54dd212fb50a366b/250x250-000000-80-0-0.jpg",
    genre: "Rap/Hip Hop",
  },
  {
    title: "LUV",
    artist: "Tory Lanez",
    id: 130414944,
    release_date: "2016-08-19",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/0/3/2/0/032098020ac7523c93acb1dd0fcc2344.mp3?hdnea=exp=1763729095~acl=/api/1/1/0/3/2/0/032098020ac7523c93acb1dd0fcc2344.mp3*~data=user_id=0,application_id=42~hmac=0f9a39fa9286693d69a65cb561cfbe45878679a12e07b6cfbce97a125292cb0f",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/87fc9529b168e4085459c5ccc0eb5ade/250x250-000000-80-0-0.jpg",
    genre: "Rap/Hip Hop",
  },
  {
    title: 'Still Falling For You (From "Bridget Jones\'s Baby")',
    artist: "Ellie Goulding",
    id: 130495956,
    release_date: "2016-08-21",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/c/d/6/0/cd6ea7461d5e410aa289af69f7223061.mp3?hdnea=exp=1763729095~acl=/api/1/1/c/d/6/0/cd6ea7461d5e410aa289af69f7223061.mp3*~data=user_id=0,application_id=42~hmac=d445c9057ff0e60cc21e9829679b4023a744dbba2d5838222cc2ed7c066b2f7e",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/6ddf28511ba3c8c1a8ad81ee43d60495/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Nine Million Bicycles",
    artist: "Katie Melua",
    id: 131200662,
    release_date: "2005-07-18",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/b/6/8/0/b68420dfdd0a5d7fa05916bb87551fd5.mp3?hdnea=exp=1763729095~acl=/api/1/1/b/6/8/0/b68420dfdd0a5d7fa05916bb87551fd5.mp3*~data=user_id=0,application_id=42~hmac=fcd4be64c0d13d906e0523c67adbd11e71793a766dfdae9b4622155615596cb3",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/a6abeb6b8111a3b9a2e878b27d896dfb/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "The Closest Thing to Crazy",
    artist: "Katie Melua",
    id: 131207980,
    release_date: "2008-10-27",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/458f370e11945b9b4c5b806747679977/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "The Time Is Now",
    artist: "Moloko",
    id: 131225962,
    release_date: "2000-10-31",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/3/3/0/0/330aaacb874d903d45160dc1f91bb72f.mp3?hdnea=exp=1763729095~acl=/api/1/1/3/3/0/0/330aaacb874d903d45160dc1f91bb72f.mp3*~data=user_id=0,application_id=42~hmac=629b5533719b5e4ce9b8e314b4c46e50b2a7a0ebc62f5a4894bcb0f50009faf5",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/ac44604eb968f8a05b5be5d01227cde5/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Broccoli (feat. Lil Yachty)",
    artist: "Shelley FKA DRAM",
    id: 131611536,
    release_date: "2016-09-05",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/e/a/f/0/eaf865041da0c5e10ead04f7509cb7d7.mp3?hdnea=exp=1763729095~acl=/api/1/1/e/a/f/0/eaf865041da0c5e10ead04f7509cb7d7.mp3*~data=user_id=0,application_id=42~hmac=e45488d287dc343e26c1d3cda4d4db64ffb59ea97fc2bb12e5b8c66923ac0f7f",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/3725bffa56ab8ce31e5194ef65259707/250x250-000000-80-0-0.jpg",
    genre: "Rap/Hip Hop",
  },
  {
    title: "Get Ready",
    artist: "2 Unlimited",
    id: 131708868,
    release_date: "1992-02-24",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/c/d/2/0/cd2c3c83f62641cf86725223bc78c8bb.mp3?hdnea=exp=1763729095~acl=/api/1/1/c/d/2/0/cd2c3c83f62641cf86725223bc78c8bb.mp3*~data=user_id=0,application_id=42~hmac=b04d003eeed674f0befe3f212a861acd967c49a57280ec4a9751ee89c55ca1e2",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/fcf639eb7914835c67586b0b3da55fd3/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "My Way",
    artist: "Calvin Harris",
    id: 132265704,
    release_date: "2016-12-23",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/b/9/c/0/b9c1416096c52f650f791c4ad44c27d2.mp3?hdnea=exp=1763729095~acl=/api/1/1/b/9/c/0/b9c1416096c52f650f791c4ad44c27d2.mp3*~data=user_id=0,application_id=42~hmac=3f5e9196536ad8affde215e4e5e76315c716d385248553a2fbf6c3f365b129dc",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/cd6eb258ea0449cc0137e6afd35eee34/250x250-000000-80-0-0.jpg",
    genre: "Dance",
  },
  {
    title: "Hey There Delilah",
    artist: "Plain White T's",
    id: 133105770,
    release_date: "2006-05-09",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/8/d/1/0/8d1bffc7b1abde49048bccd5a5a3557d.mp3?hdnea=exp=1763729095~acl=/api/1/1/8/d/1/0/8d1bffc7b1abde49048bccd5a5a3557d.mp3*~data=user_id=0,application_id=42~hmac=b138959020fa23b06a781a4c0e622259aa53e7c99a29b846a0398352d460693b",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/1bce8d12398935d6e559ee007500da88/250x250-000000-80-0-0.jpg",
    genre: "Alternative",
  },
  {
    title: "Good as Hell",
    artist: "Lizzo",
    id: 133167964,
    release_date: "2016-10-07",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/1/3/2/0/132863f2f0cd808e1f5b6ce9c27dc911.mp3?hdnea=exp=1763730170~acl=/api/1/1/1/3/2/0/132863f2f0cd808e1f5b6ce9c27dc911.mp3*~data=user_id=0,application_id=42~hmac=a808ee978d5dd12506cb460cbd9f99644584008ba6c4d9dd4fcb12409d22ffc3",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/71693ef84b80cb7c6b479c59186200b2/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Perfect Illusion",
    artist: "Lady Gaga",
    id: 134525902,
    release_date: "2016-09-09",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/6/2/a/0/62a97d5e5ce9b38eaa77ee152007c795.mp3?hdnea=exp=1763730170~acl=/api/1/1/6/2/a/0/62a97d5e5ce9b38eaa77ee152007c795.mp3*~data=user_id=0,application_id=42~hmac=4d43ea3af653711e5cfabd0945ef1006e95ecd621b7240f3b643ca812a5e4e42",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/614af5cb69dd52e4de82dd2cd9e217c9/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Rockabye (feat. Sean Paul & Anne-Marie)",
    artist: "Clean Bandit",
    id: 134527024,
    release_date: "2016-10-21",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/0/9/c/0/09ce8958e060d54acaf77a64245fb707.mp3?hdnea=exp=1763730170~acl=/api/1/1/0/9/c/0/09ce8958e060d54acaf77a64245fb707.mp3*~data=user_id=0,application_id=42~hmac=e4daa1afe92418af48f0874ac3ca3746ce5eec6536507f573295924f041c5fcc",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/58b6ae3ff5e9dfc6f9e4d59862094528/250x250-000000-80-0-0.jpg",
    genre: "Electro",
  },
  {
    title: "Cheap Thrills (feat. Sean Paul)",
    artist: "Sia",
    id: 134533238,
    release_date: "2016-02-11",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/d/0/f/0/d0f5b77f97f66d0cf5a5cbd8469badb2.mp3?hdnea=exp=1763730170~acl=/api/1/1/d/0/f/0/d0f5b77f97f66d0cf5a5cbd8469badb2.mp3*~data=user_id=0,application_id=42~hmac=be91a0f1d125f6cae233796e97bdae9b6e433c0235de1cbb351b69a781d9e910",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/305b06b02f21849dd2bf45614e0fafef/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "The Greatest (feat. Kendrick Lamar)",
    artist: "Sia",
    id: 134533240,
    release_date: "2016-09-06",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/d/1/b/0/d1b3c54643f36c29f38f88d462522fad.mp3?hdnea=exp=1763730170~acl=/api/1/1/d/1/b/0/d1b3c54643f36c29f38f88d462522fad.mp3*~data=user_id=0,application_id=42~hmac=110974e9d87be790ca5601cdc783bd5b00ba4a0a0337ebfac5aa5134b4f08bab",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/305b06b02f21849dd2bf45614e0fafef/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "No Limit",
    artist: "2 Unlimited",
    id: 134706074,
    release_date: "1993-05-10",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/0/e/0/0/0e069806f3fd4760310f801cc96028d8.mp3?hdnea=exp=1763730170~acl=/api/1/1/0/e/0/0/0e069806f3fd4760310f801cc96028d8.mp3*~data=user_id=0,application_id=42~hmac=960f1b056be7c1cda4493f818360e956751df40dc542977dd322e050875652ce",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/37e6834a65f160a58c3b58dc8a76d240/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Say You Won't Let Go",
    artist: "James Arthur",
    id: 134945400,
    release_date: "2016-11-04",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/3/b/2/0/3b266b256412f0652bcf73218d97b863.mp3?hdnea=exp=1763730170~acl=/api/1/1/3/b/2/0/3b266b256412f0652bcf73218d97b863.mp3*~data=user_id=0,application_id=42~hmac=3685c11e01a91bf7e9ac5436e8b285764fa26ffc17a90b608e54c55bf77a3e50",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/6ea183258031dd17afb3706a903d5900/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Cool Girl",
    artist: "Tove Lo",
    id: 134948420,
    release_date: "2016-10-28",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/6/2/f/0/62f457ea83548bad1ea61d0f3084f830.mp3?hdnea=exp=1763730170~acl=/api/1/1/6/2/f/0/62f457ea83548bad1ea61d0f3084f830.mp3*~data=user_id=0,application_id=42~hmac=138c38d8a47a1d645a91d9660aff5e3db78a8f4c94b044286a344006b58c0c2a",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/6b74f13b67c28682ebaea1c2dd35820a/250x250-000000-80-0-0.jpg",
    genre: "Alternative",
  },
  {
    title: "Shout Out to My Ex",
    artist: "Little Mix",
    id: 136135070,
    release_date: "2016-11-18",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/61df554793c5d1b0d31d4987c03ffe44/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Policy of Truth",
    artist: "Depeche Mode",
    id: 136331384,
    release_date: "1990-03-19",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/4/d/4/0/4d4f5961db8f69fda3b6e8685a970f9f.mp3?hdnea=exp=1763730170~acl=/api/1/1/4/d/4/0/4d4f5961db8f69fda3b6e8685a970f9f.mp3*~data=user_id=0,application_id=42~hmac=b9c1dbafb762ff09aa8637a7c7eb09979995e4fb71afad00d1932a3263a62fad",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/2632e326fac7c48c2fbef198f295995a/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "24K Magic",
    artist: "Bruno Mars",
    id: 136336110,
    release_date: "2016-11-18",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/f/6/d/0/f6d7752ec2f4897dcbb120ea220f07ea.mp3?hdnea=exp=1763730170~acl=/api/1/1/f/6/d/0/f6d7752ec2f4897dcbb120ea220f07ea.mp3*~data=user_id=0,application_id=42~hmac=3fe7acdcb1d939d4bfa01d126ef89dc48a915b858976ce464e43ca09254cc49e",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/012b27906b430a37ec1d8f793d5c4fa6/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Cake By The Ocean",
    artist: "DNCE",
    id: 136341758,
    release_date: "2016-11-18",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/8/9/4/0/894bb0470dd38238cb9f1f86d1320f94.mp3?hdnea=exp=1763730170~acl=/api/1/1/8/9/4/0/894bb0470dd38238cb9f1f86d1320f94.mp3*~data=user_id=0,application_id=42~hmac=e713ff8882c1d226085d301d16e1c25143912f1600a10c212202b16ef9f926c1",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/d3380b311743baf8435f616371b95194/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Starboy",
    artist: "The Weeknd",
    id: 136889400,
    release_date: "2016-09-22",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/3/c/1/0/3c19a82aeffd2f6f6adb63c4d8548e06.mp3?hdnea=exp=1763730170~acl=/api/1/1/3/c/1/0/3c19a82aeffd2f6f6adb63c4d8548e06.mp3*~data=user_id=0,application_id=42~hmac=571abcaee8b51b0535e711835b9f50862596242b60c1942ff0e8b4a4c3fe66fd",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/134778e4c4f19ea71c82408300925a9a/250x250-000000-80-0-0.jpg",
    genre: "R&B",
  },
  {
    title: "I Feel It Coming",
    artist: "The Weeknd",
    id: 136889434,
    release_date: "2016-11-18",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/6/4/9/0/64964cf78e664f63594a3190e1e834eb.mp3?hdnea=exp=1763730170~acl=/api/1/1/6/4/9/0/64964cf78e664f63594a3190e1e834eb.mp3*~data=user_id=0,application_id=42~hmac=2a4004f947aa25183d8b5da09644a5ded900ee6f5c9b6ac569565d4655ab87b2",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/134778e4c4f19ea71c82408300925a9a/250x250-000000-80-0-0.jpg",
    genre: "R&B",
  },
  {
    title: "Ready 2 Go",
    artist: "Martin Solveig",
    id: 137336032,
    release_date: "2015-02-18",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/9c416e36c700eabc739ca3402df11d11/250x250-000000-80-0-0.jpg",
    genre: "Dance",
  },
  {
    title: "I Don’t Wanna Live Forever (Fifty Shades Darker)",
    artist: "ZAYN",
    id: 137828447,
    release_date: "2016-12-09",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/fbbc4eaec3e7a083940c84769ea2b96c/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Just Hold On",
    artist: "Steve Aoki",
    id: 137911999,
    release_date: "2016-12-12",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/a/5/a/0/a5aa83dce33909cd8477162e8bc48325.mp3?hdnea=exp=1763730170~acl=/api/1/1/a/5/a/0/a5aa83dce33909cd8477162e8bc48325.mp3*~data=user_id=0,application_id=42~hmac=2da088a21b11f3a99a3a2eb2d25a047570324f20a7b932de82bfbd7b4fe64bc3",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/6a539d60efd4b12f346ce71272dbb893/250x250-000000-80-0-0.jpg",
    genre: "Electro",
  },
  {
    title: "Hello",
    artist: "Adele",
    id: 138545995,
    release_date: "2015-10-23",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/f/0/a/0/f0a110b02db34fd1968d862e2aec800d.mp3?hdnea=exp=1763730170~acl=/api/1/1/f/0/a/0/f0a110b02db34fd1968d862e2aec800d.mp3*~data=user_id=0,application_id=42~hmac=4753030b6cb8e61842b0a65953b572e41bb47daffc7042a95e51be68b1975066",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/eaeadce7932a97533fe495881d2fcd7a/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Send My Love (To Your New Lover)",
    artist: "Adele",
    id: 138545997,
    release_date: "2015-11-20",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/6/f/d/0/6fde73b43e47761d51ecfde89d5b43bc.mp3?hdnea=exp=1763730170~acl=/api/1/1/6/f/d/0/6fde73b43e47761d51ecfde89d5b43bc.mp3*~data=user_id=0,application_id=42~hmac=e8125852bc4543c75d51a5b99f607a4422bbd2f8be13bd285f48db94d81e8ee7",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/eaeadce7932a97533fe495881d2fcd7a/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "From Paris To Berlin",
    artist: "Infernal",
    id: 138728387,
    release_date: "0000-00-00",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/4e72c06619ab08fd04e4e36cecd5baf2/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Because I Got High",
    artist: "Afroman",
    id: 139102115,
    release_date: "2001-08-06",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/5/d/e/0/5de86c94aa533e0a191fa354ce6ed301.mp3?hdnea=exp=1763730170~acl=/api/1/1/5/d/e/0/5de86c94aa533e0a191fa354ce6ed301.mp3*~data=user_id=0,application_id=42~hmac=16c1330576b6e9d8b941d9921113a585543d39044efdb00cd91e50df70bd74a2",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/2dff8a4efefaea6e300a4732ffffa3bf/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "For Whom The Bell Tolls",
    artist: "Bee Gees",
    id: 139138469,
    release_date: "1993-09-13",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/5/9/f/0/59f378654ae0c692d93a5bf10ce06ca2.mp3?hdnea=exp=1763730170~acl=/api/1/1/5/9/f/0/59f378654ae0c692d93a5bf10ce06ca2.mp3*~data=user_id=0,application_id=42~hmac=1bf4c2ec80837c2ea9f162320fbadab024b9a3d9f6ffa4fc7610b2a8174417c5",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/cbf620ce76f4d23c12043f19b32de852/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Issues",
    artist: "Julia Michaels",
    id: 139874527,
    release_date: "2017-01-13",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/3/2/8/0/32825813561b488373c5cb5d649c348a.mp3?hdnea=exp=1763730170~acl=/api/1/1/3/2/8/0/32825813561b488373c5cb5d649c348a.mp3*~data=user_id=0,application_id=42~hmac=1c2d9272bb64c7049a94fbbad2f58cafefecdfd7f190930b4f21375fe2543890",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/8f5109f8902b35c2d88a1ac6c14b3fe1/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Faded",
    artist: "Alan Walker",
    id: 140295501,
    release_date: "2016-06-03",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/3/5/2/0/35298490e5d17d74eefdb1b285f94dfd.mp3?hdnea=exp=1763730776~acl=/api/1/1/3/5/2/0/35298490e5d17d74eefdb1b285f94dfd.mp3*~data=user_id=0,application_id=42~hmac=2447194db11f0cea41f7f97c802279fe327d86c33aeafcbdea18ccc3646d4cba",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/e50540d7f752c93e0695ebae272be0c3/250x250-000000-80-0-0.jpg",
    genre: "Electro",
  },
  {
    title: "Scared to Be Lonely",
    artist: "Martin Garrix",
    id: 140856305,
    release_date: "2017-01-27",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/a/3/f/0/a3ff12704287b970d52f5b19ab308a31.mp3?hdnea=exp=1763730776~acl=/api/1/1/a/3/f/0/a3ff12704287b970d52f5b19ab308a31.mp3*~data=user_id=0,application_id=42~hmac=218ef21f85d82d4add2ca5fff5c9d63dcb5e9f2c943ad8812817434a557bec39",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/8e6e0c8973442986572a2e8a5492fdd9/250x250-000000-80-0-0.jpg",
    genre: "Electro",
  },
  {
    title: "Human",
    artist: "Rag'n'Bone Man",
    id: 140869461,
    release_date: "2016-10-07",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/7/b/b/0/7bb304e65e1dfa8540d8037cf0a962c8.mp3?hdnea=exp=1763730776~acl=/api/1/1/7/b/b/0/7bb304e65e1dfa8540d8037cf0a962c8.mp3*~data=user_id=0,application_id=42~hmac=da96653b128abb44b93d75ad75abf4b3e66a83b5589533e617c18c8f0c00e794",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/fb1e80abccac5db8d2a0265f990dd5af/250x250-000000-80-0-0.jpg",
    genre: "Alternative",
  },
  {
    title: "Skin",
    artist: "Rag'n'Bone Man",
    id: 140889759,
    release_date: "2017-01-26",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/a/f/8/0/af80ba7223fba27ae195ba4322b15bc4.mp3?hdnea=exp=1763730776~acl=/api/1/1/a/f/8/0/af80ba7223fba27ae195ba4322b15bc4.mp3*~data=user_id=0,application_id=42~hmac=fc4a4ff74c6b549e9d0fb0b578d37c12012c4be3275faf8b7b6ba8fbb2706604",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/75141a524cc39b49a969211c132df2ef/250x250-000000-80-0-0.jpg",
    genre: "Alternative",
  },
  {
    title: "Groovy Train",
    artist: "The Farm",
    id: 141567165,
    release_date: "1991-03-04",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/3/3/f/0/33f03f955c992ebbd342dceba118554e.mp3?hdnea=exp=1763730776~acl=/api/1/1/3/3/f/0/33f03f955c992ebbd342dceba118554e.mp3*~data=user_id=0,application_id=42~hmac=d3fc4c563ce15b919b57915f12b5b54bf343e903c748fc50e93c4341935f2375",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/40097e1c15ac78eec2720d635edbb9e6/250x250-000000-80-0-0.jpg",
    genre: "Alternative",
  },
  {
    title: "Ciao Adios",
    artist: "Anne-Marie",
    id: 141826655,
    release_date: "2017-02-10",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/a/8/d/0/a8ded42b51253b0a067146c22db99609.mp3?hdnea=exp=1763730776~acl=/api/1/1/a/8/d/0/a8ded42b51253b0a067146c22db99609.mp3*~data=user_id=0,application_id=42~hmac=5c7497569ba10a6a2f9e8dba722d68f3bce980a3e5b928f077c95fc24e496ffc",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/2afe820c32c6be78f12f49252fcf7bb5/250x250-000000-80-0-0.jpg",
    genre: "Electro",
  },
  {
    title: "Life Is A Highway",
    artist: "Tom Cochrane",
    id: 141826703,
    release_date: "1991-02-01",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/1/5/e/0/15e2c6f6bacbd6ed86c282c2affb82e7.mp3?hdnea=exp=1763730776~acl=/api/1/1/1/5/e/0/15e2c6f6bacbd6ed86c282c2affb82e7.mp3*~data=user_id=0,application_id=42~hmac=f7cdd4870aa40664db6582135a0965da2fab53487dfa3b16993a87b77fd9353b",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/923563603da263fb7879aae3b9935690/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "It Ain't Me",
    artist: "Kygo",
    id: 142328215,
    release_date: "2017-02-16",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/9/f/7/0/9f7eecc392449e7509ddd2e8a76cff63.mp3?hdnea=exp=1763730776~acl=/api/1/1/9/f/7/0/9f7eecc392449e7509ddd2e8a76cff63.mp3*~data=user_id=0,application_id=42~hmac=387c585be72c960a530ef0c1c1865bd72d4436486a1c136683d51ebfc88458d7",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/e9ec7d8f75708f9a9de5de403cf205c0/250x250-000000-80-0-0.jpg",
    genre: "Electro",
  },
  {
    title: "Mask Off",
    artist: "Future",
    id: 142337683,
    release_date: "2017-02-17",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/f/2/4/0/f24eb3845ff02fae3022d102a7d27e6a.mp3?hdnea=exp=1763730776~acl=/api/1/1/f/2/4/0/f24eb3845ff02fae3022d102a7d27e6a.mp3*~data=user_id=0,application_id=42~hmac=158d0e9e85ca0fb31fd212a0fe338d505726fd1dd6ef52056596c2b6c60153c9",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/5186078c5bd5623ebec9b2753d8aaebe/250x250-000000-80-0-0.jpg",
    genre: "Rap/Hip Hop",
  },
  {
    title: "Something Just Like This",
    artist: "Coldplay",
    id: 142706538,
    release_date: "2017-02-22",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/2/3/b/0/23be037b51d21629c5c224bdec0b30c7.mp3?hdnea=exp=1763730776~acl=/api/1/1/2/3/b/0/23be037b51d21629c5c224bdec0b30c7.mp3*~data=user_id=0,application_id=42~hmac=3c7398449cf72e1c277090c893f36f2a8a9c90d1f3398c9c201165db2891e222",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/2ae6c01a51296a7ec6d89c96a4fac32c/250x250-000000-80-0-0.jpg",
    genre: "Alternative",
  },
  {
    title: "Swalla (feat. Nicki Minaj & Ty Dolla $ign)",
    artist: "Jason Derulo",
    id: 142750222,
    release_date: "2017-02-24",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/6/f/f/0/6ff99a79d70da00d07d9d9db6a0b5ff8.mp3?hdnea=exp=1763730776~acl=/api/1/1/6/f/f/0/6ff99a79d70da00d07d9d9db6a0b5ff8.mp3*~data=user_id=0,application_id=42~hmac=414aa3607c64e750cd3e2f59370137a61b4cc20174f0eeeccf26b1b51db47034",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/3eaa869a2b298f79a739abc44eb19e04/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Stay",
    artist: "Zedd",
    id: 142808100,
    release_date: "2017-02-23",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/c/7/8/0/c7880f07b75768ec51f3e8fc2868531d.mp3?hdnea=exp=1763730776~acl=/api/1/1/c/7/8/0/c7880f07b75768ec51f3e8fc2868531d.mp3*~data=user_id=0,application_id=42~hmac=a0c0e691b041646f74b4e7be65920f5976c8bc65f660a8d13731095d347f9a3f",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/16e8d7fc0a40f75bffac15d7e9e2a9c5/250x250-000000-80-0-0.jpg",
    genre: "Dance",
  },
  {
    title: "Fill Me In",
    artist: "Craig David",
    id: 143169092,
    release_date: "2000-08-21",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/b/2/0/0/b20e7333241c5947e9948ab9bc81314d.mp3?hdnea=exp=1763730776~acl=/api/1/1/b/2/0/0/b20e7333241c5947e9948ab9bc81314d.mp3*~data=user_id=0,application_id=42~hmac=51a4328a4d00e40eed2456a5b134c05c8992bf235f2d5c6dae57ff2d8e98052b",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/2ea24270d49242d3a3f7edaf30d9989e/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "7 Days",
    artist: "Craig David",
    id: 143169102,
    release_date: "2000-08-21",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/7/5/d/0/75de856e3d2fe957f5fe2ede477e1536.mp3?hdnea=exp=1763730776~acl=/api/1/1/7/5/d/0/75de856e3d2fe957f5fe2ede477e1536.mp3*~data=user_id=0,application_id=42~hmac=6bd07a8057807531cca17ef9e03e961e0dd6b8949277ceb62f837cb0d22a4c1d",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/2ea24270d49242d3a3f7edaf30d9989e/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Don't Love You No More (I'm Sorry)",
    artist: "Craig David",
    id: 143170362,
    release_date: "2017-03-03",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/5/d/1/0/5d148811a5959a7f1b58a6df604de314.mp3?hdnea=exp=1763730776~acl=/api/1/1/5/d/1/0/5d148811a5959a7f1b58a6df604de314.mp3*~data=user_id=0,application_id=42~hmac=776cb34d4abce122cc34916b7af51e606e2cf20c74744421e3cab0faef7761ac",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/3ccc40587d0c9bc4ef4cab1a82adc558/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Young Dumb & Broke",
    artist: "Khalid",
    id: 143172406,
    release_date: "2017-03-03",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/5/7/f/0/57faa820a58d242df3961c10b7502177.mp3?hdnea=exp=1763730776~acl=/api/1/1/5/7/f/0/57faa820a58d242df3961c10b7502177.mp3*~data=user_id=0,application_id=42~hmac=c85b3fd77c652f8d0e4c1401061dbdee08f3850c9b6a5d047af7375b220cc911",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/7fa1597e86f5b4283ea316f2ddb54008/250x250-000000-80-0-0.jpg",
    genre: "R&B",
  },
  {
    title: "Pretty Girl (Cheat Codes X CADE Remix)",
    artist: "Maggie Lindemann",
    id: 143172578,
    release_date: "2017-03-03",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/b/5/4/0/b54adbadbd8df6f58f1e24e2f59542a1.mp3?hdnea=exp=1763730776~acl=/api/1/1/b/5/4/0/b54adbadbd8df6f58f1e24e2f59542a1.mp3*~data=user_id=0,application_id=42~hmac=427a9a0469ebc7d36892c433b3600d727f130c6b346b865ec695ebe124826892",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/bca69583b74747f5bad7c0d16b16b915/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Never Forget You",
    artist: "Zara Larsson",
    id: 144389058,
    release_date: "2015-07-22",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/2/e/e/0/2ee699a19309e035909a5ab0321cdc76.mp3?hdnea=exp=1763730776~acl=/api/1/1/2/e/e/0/2ee699a19309e035909a5ab0321cdc76.mp3*~data=user_id=0,application_id=42~hmac=d0ebc98c714b6aa6c7c88433343faed3c1684c5770932f569501273be7074fd2",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/32181f6a74b8ae31013f6a1aa00ca680/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Symphony (feat. Zara Larsson)",
    artist: "Clean Bandit",
    id: 144393668,
    release_date: "2017-03-17",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/6/6/6/0/6661ab10a2757feb0481adfd8091d091.mp3?hdnea=exp=1763730776~acl=/api/1/1/6/6/6/0/6661ab10a2757feb0481adfd8091d091.mp3*~data=user_id=0,application_id=42~hmac=8523611027523fbe8d3fe544bf25f5fc8dfcd57572d903ea42dda0fb94b404ee",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/86c4dc247f751008f2bbd726fdd04465/250x250-000000-80-0-0.jpg",
    genre: "Electro",
  },
  {
    title: "Do You Really Like It?",
    artist: "DJ Pied Piper & The Masters Of Ceremonies",
    id: 144535600,
    release_date: "2001-05-21",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/8/d/c/0/8dcde98023400060ad8a696cc5e4dfd0.mp3?hdnea=exp=1763730776~acl=/api/1/1/8/d/c/0/8dcde98023400060ad8a696cc5e4dfd0.mp3*~data=user_id=0,application_id=42~hmac=9bd8d482bed7c31ebb9df0d0802b1c43f00b18bbe6f4ffda68ae3a4c2e107704",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/7417fcba18dbac94a142d04d07968218/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Passionfruit",
    artist: "Drake",
    id: 144572210,
    release_date: "2017-03-18",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/e/b/d/0/ebd770a4b7ecbfbc98bc19a96e39f048.mp3?hdnea=exp=1763730776~acl=/api/1/1/e/b/d/0/ebd770a4b7ecbfbc98bc19a96e39f048.mp3*~data=user_id=0,application_id=42~hmac=b87d776aab6737573c78af2ffdd51e08b645aed8fb01e0d74f6184267673fd7e",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/8f0187ad83cdd1f47f1c55420f9df227/250x250-000000-80-0-0.jpg",
    genre: "Rap/Hip Hop",
  },
  {
    title: "Ayo Technology",
    artist: "50 Cent",
    id: 145429556,
    release_date: "2008-10-05",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/e/6/a/0/e6a01c8226801a4c5b55f5e0252acbd4.mp3?hdnea=exp=1763730776~acl=/api/1/1/e/6/a/0/e6a01c8226801a4c5b55f5e0252acbd4.mp3*~data=user_id=0,application_id=42~hmac=d1a87516d38a515b04150702b09fa737f09c573619485a4574cc812c2980a85e",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/58ec83e8f74b55096f2115523eb9e7df/250x250-000000-80-0-0.jpg",
    genre: "Rap/Hip Hop",
  },
  {
    title: "No Promises (feat. Demi Lovato)",
    artist: "Cheat Codes",
    id: 145432614,
    release_date: "2017-03-31",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/6/9/d/0/69d92bb16ab994d00878969a06e79a63.mp3?hdnea=exp=1763730776~acl=/api/1/1/6/9/d/0/69d92bb16ab994d00878969a06e79a63.mp3*~data=user_id=0,application_id=42~hmac=4d10f9bef0d6e2d2194a0a3e92491b398969115ed13cf6deb9b3276daadbf47e",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/c542b7050bd4435bcc60c4bda1efee3b/250x250-000000-80-0-0.jpg",
    genre: "Dance",
  },
  {
    title: "Paris",
    artist: "The Chainsmokers",
    id: 346434701,
    release_date: "2017-01-13",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/2/5/d/0/25d81ff43c8f3317ecf2e07995d8b274.mp3?hdnea=exp=1763730776~acl=/api/1/1/2/5/d/0/25d81ff43c8f3317ecf2e07995d8b274.mp3*~data=user_id=0,application_id=42~hmac=60486d34c6473194096e65e07c11d7a1c0563c1453593bd36a25d8cbc283dda2",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/d4451405fea03536f6788fa806045141/250x250-000000-80-0-0.jpg",
    genre: "Dance",
  },
  {
    title: "Secret Love",
    artist: "Bee Gees",
    id: 348129131,
    release_date: "2008-03-03",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/1/8/9/0/189165a6b0679634c400749a648ac7a8.mp3?hdnea=exp=1763730776~acl=/api/1/1/1/8/9/0/189165a6b0679634c400749a648ac7a8.mp3*~data=user_id=0,application_id=42~hmac=7efac8d9828a55c06b17d940857c1e9b87508e904cecb4fae5163fbcb1e4f9f3",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/6f865f8e722986099cd3ac954ddd5e6f/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "(Can't Live Without Your) Love And Affection",
    artist: "Nelson",
    id: 350059451,
    release_date: "1990-08-07",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/7/2/b/0/72b4896cda7e107c65a24ddcc0bd2328.mp3?hdnea=exp=1763730776~acl=/api/1/1/7/2/b/0/72b4896cda7e107c65a24ddcc0bd2328.mp3*~data=user_id=0,application_id=42~hmac=592ec4568be862b875f267d92130b825a8f3441b549001bead052b9f02ff75fd",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/007cf45d319186497b198fcbb187c01e/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "HUMBLE.",
    artist: "Kendrick Lamar",
    id: 350171311,
    release_date: "2017-04-14",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/5/9/c/0/59c7208affd26e5d728f03dd312dc4cd.mp3?hdnea=exp=1763730776~acl=/api/1/1/5/9/c/0/59c7208affd26e5d728f03dd312dc4cd.mp3*~data=user_id=0,application_id=42~hmac=fe522d9c0eea2d64adafc96a476a78baf972ee300fa83b1ee140828b7b19f68a",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/7ce6b8452fae425557067db6e6a1cad5/250x250-000000-80-0-0.jpg",
    genre: "Rap/Hip Hop",
  },
  {
    title: "Despacito (Remix)",
    artist: "Luis Fonsi",
    id: 350428781,
    release_date: "2017-04-17",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/ab51cbf8ebae60634ba587782f5acda2/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "The Cure",
    artist: "Lady Gaga",
    id: 350720621,
    release_date: "2017-04-16",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/f/f/c/0/ffcd76ae3a26bd5555358d38c1b5bfb8.mp3?hdnea=exp=1763730776~acl=/api/1/1/f/f/c/0/ffcd76ae3a26bd5555358d38c1b5bfb8.mp3*~data=user_id=0,application_id=42~hmac=3b861d5a2935e08ac51506a36cf0d6a60027d4bb46e192c10f6a6db8ef9118af",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/f1000f6aab94a6a9991af2c3bbfb1685/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "There's Nothing Holdin' Me Back",
    artist: "Shawn Mendes",
    id: 351595631,
    release_date: "2017-04-20",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/b/e/8/0/be88643e41855aaba89ad69fba9df9e0.mp3?hdnea=exp=1763730776~acl=/api/1/1/b/e/8/0/be88643e41855aaba89ad69fba9df9e0.mp3*~data=user_id=0,application_id=42~hmac=c5fa5be9c79a6d69298deaa49fef1ccd08ffb90d061b7f01a974ce0806e13f3a",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/35d5f7dd0b398bb37287b3454f0b05b9/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Cradle Of Love",
    artist: "Billy Idol",
    id: 354284151,
    release_date: "1990-05-15",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/e/a/a/0/eaae4e840e3aca3cfe280a0728a84754.mp3?hdnea=exp=1763730776~acl=/api/1/1/e/a/a/0/eaae4e840e3aca3cfe280a0728a84754.mp3*~data=user_id=0,application_id=42~hmac=4c9e07e39459db05e9811049e4424e8fd56e7c0af0a9638cda6dd24cd70a4f42",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/38a065da1b4efcb6e9ef41794ee220c2/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "Mama",
    artist: "Jonas Blue",
    id: 355724441,
    release_date: "2017-05-05",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/e/2/8/0/e280875b3f66aa69da4342f9247cc437.mp3?hdnea=exp=1763730776~acl=/api/1/1/e/2/8/0/e280875b3f66aa69da4342f9247cc437.mp3*~data=user_id=0,application_id=42~hmac=c85e00231bfa0430b115ae40b5752886f07a98f057dd76abc933661628a5f014",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/b7e72d659e204adc7a84f1a5ab8af51d/250x250-000000-80-0-0.jpg",
    genre: "Dance",
  },
  {
    title: "1-800-273-8255",
    artist: "Logic",
    id: 357859971,
    release_date: "2017-05-05",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/3/e/9/0/3e9c50ead4f9aa81d1492cc844f89b30.mp3?hdnea=exp=1763730776~acl=/api/1/1/3/e/9/0/3e9c50ead4f9aa81d1492cc844f89b30.mp3*~data=user_id=0,application_id=42~hmac=60af771417b149a8079b085907889427a6cb613423f58aee8c1f318ae6086f31",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/ae3a9ec5d5f2b7885753b1835852ae1c/250x250-000000-80-0-0.jpg",
    genre: "Rap/Hip Hop",
  },
  {
    title: "NO",
    artist: "Meghan Trainor",
    id: 358920101,
    release_date: "2016-03-05",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/e/d/c/0/edc328d551a362d44696bbaeeac68339.mp3?hdnea=exp=1763730776~acl=/api/1/1/e/d/c/0/edc328d551a362d44696bbaeeac68339.mp3*~data=user_id=0,application_id=42~hmac=dc5753115eb02d3c23480454d792e074388a2a01956dc0ebac98590662bbed8e",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/5b6f3f7b4a3d8d765498f7939c7458cb/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "I Like Me Better",
    artist: "Lauv",
    id: 358972401,
    release_date: "2017-05-19",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/3905f16f540254e3c9841cc781c91271/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Sign of the Times",
    artist: "Harry Styles",
    id: 360301951,
    release_date: "2017-05-12",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/5/5/1/0/551d8084025fa8648c30aed373171301.mp3?hdnea=exp=1763730776~acl=/api/1/1/5/5/1/0/551d8084025fa8648c30aed373171301.mp3*~data=user_id=0,application_id=42~hmac=0344e7e1faad73323cf1620ce62f3a1ed32ded0fa4078020686644c5dc89331f",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/a41167cfcc7e840821fad5f5f5f91da2/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Glycerine",
    artist: "Bush",
    id: 361116571,
    release_date: "1994-12-18",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/b/d/7/0/bd7a5fb9621da2b125b27add547a55cb.mp3?hdnea=exp=1763730776~acl=/api/1/1/b/d/7/0/bd7a5fb9621da2b125b27add547a55cb.mp3*~data=user_id=0,application_id=42~hmac=af09f7e68fcb64ee1981c3b7a414e4e6cb89e146403c0cc704bcb79a1254b0c8",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/01bb7dd3e6fa3f6e47f554f518954d58/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "Bad Liar",
    artist: "Selena Gomez",
    id: 363418191,
    release_date: "2017-05-18",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/8/8/a/0/88a8a736fd3c68721158ba8bcc7d13c0.mp3?hdnea=exp=1763730777~acl=/api/1/1/8/8/a/0/88a8a736fd3c68721158ba8bcc7d13c0.mp3*~data=user_id=0,application_id=42~hmac=1939ca599783b1fc76e07588b4c2c0fce67928d0625c224f9708e25b9a34763c",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/a2ecffe63ad4434d6158ab1cee72ccf3/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Strip That Down",
    artist: "Liam Payne",
    id: 363834871,
    release_date: "2017-05-18",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/4/f/d/0/4fd49a16a73ebe99d8d0168722b16d71.mp3?hdnea=exp=1763730777~acl=/api/1/1/4/f/d/0/4fd49a16a73ebe99d8d0168722b16d71.mp3*~data=user_id=0,application_id=42~hmac=560fde02e2b4ac5bfdee81b4202e33adf9c99bad8ada91788a3b47abf386db84",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/b6a75ea44e69d582722e9dd0505228b6/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Chantaje (feat. Maluma)",
    artist: "Shakira",
    id: 364957401,
    release_date: "2016-10-28",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/5/1/2/0/512b41d3e0539a12aaf8c8d60ad806f9.mp3?hdnea=exp=1763730777~acl=/api/1/1/5/1/2/0/512b41d3e0539a12aaf8c8d60ad806f9.mp3*~data=user_id=0,application_id=42~hmac=508c8fae67bc4dc36b4568f3d8ac28979b8b3b76ae4cbab7c174de1310b57b73",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/975abab73605c4526d1a050940ecf7cf/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "IDGAF",
    artist: "Dua Lipa",
    id: 366297871,
    release_date: "2017-06-02",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/6/f/1/0/6f1f6cae1c08262ede6ce8e60f9a4622.mp3?hdnea=exp=1763730777~acl=/api/1/1/6/f/1/0/6f1f6cae1c08262ede6ce8e60f9a4622.mp3*~data=user_id=0,application_id=42~hmac=99e519904f17499f93d5efbf5507bd05330d5b3d87ce77fea3dbc6c7e5d1af63",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/75476548cb1a37e557b38bd8e8f8823f/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "New Rules",
    artist: "Dua Lipa",
    id: 366297921,
    release_date: "2017-06-02",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/8/8/8/0/888034b031289572c81b681502bdf399.mp3?hdnea=exp=1763730777~acl=/api/1/1/8/8/8/0/888034b031289572c81b681502bdf399.mp3*~data=user_id=0,application_id=42~hmac=9b9c87fadb3bda00f14db371d2bf10d322a88ccd918125ac4bc482d35f53ff2d",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/75476548cb1a37e557b38bd8e8f8823f/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Unbelievable",
    artist: "EMF",
    id: 367782641,
    release_date: "1991-05-07",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/1/a/a/0/1aa98a4c38c6b6a29ec0a11b7ef19d70.mp3?hdnea=exp=1763730777~acl=/api/1/1/1/a/a/0/1aa98a4c38c6b6a29ec0a11b7ef19d70.mp3*~data=user_id=0,application_id=42~hmac=f436e8e1b40a1f9c552fe3b3436a4c4c1798381dceb2f65583fb8d5177e417b9",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/2f666a086f47062b759f20913a6d3d37/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "2U (feat. Justin Bieber)",
    artist: "David Guetta",
    id: 369397961,
    release_date: "2017-06-09",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/c/d/0/0/cd0d4eadb9dacbb57fb8b28676668e21.mp3?hdnea=exp=1763730777~acl=/api/1/1/c/d/0/0/cd0d4eadb9dacbb57fb8b28676668e21.mp3*~data=user_id=0,application_id=42~hmac=e872308e582d3f14404ec9dfce0e19b702a7bf2c2890f7e2ba8447e19bfcb679",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/a392a6c833438989f1c2803da7f50f1b/250x250-000000-80-0-0.jpg",
    genre: "Dance",
  },
  {
    title: "Bon appétit",
    artist: "Katy Perry",
    id: 371182241,
    release_date: "2017-06-09",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/7974148c2797fef5b7634b1338ec31f5/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Green Light",
    artist: "Lorde",
    id: 371625771,
    release_date: "2017-03-02",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/f/3/7/0/f37d1ab90e5551aed1d8d432d40542e4.mp3?hdnea=exp=1763730777~acl=/api/1/1/f/3/7/0/f37d1ab90e5551aed1d8d432d40542e4.mp3*~data=user_id=0,application_id=42~hmac=d19be072f0fca2e3d146438e83e6c013fcfb07eaed3cafda1bb34976a68cc4bb",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/0c424dbe627530cd06a6fd408baba3f3/250x250-000000-80-0-0.jpg",
    genre: "Alternative",
  },
  {
    title: "Bad Blood",
    artist: "Taylor Swift",
    id: 372049961,
    release_date: "2015-05-17",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/7/2/6/0/7265f6261d516b1c14bece8398bd2ffb.mp3?hdnea=exp=1763730777~acl=/api/1/1/7/2/6/0/7265f6261d516b1c14bece8398bd2ffb.mp3*~data=user_id=0,application_id=42~hmac=bdf36b7ca59b268b4c364221ec18e6e297f3043f5a9f88d7b171b6cbb480a447",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/de7addba2b3b6effb8ea517fe5edff02/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Wild Thoughts (feat. Rihanna & Bryson Tiller)",
    artist: "DJ Khaled",
    id: 375689861,
    release_date: "2017-06-23",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/a/5/f/0/a5f3bc9b9957b70ff3eeb21b30badd40.mp3?hdnea=exp=1763730777~acl=/api/1/1/a/5/f/0/a5f3bc9b9957b70ff3eeb21b30badd40.mp3*~data=user_id=0,application_id=42~hmac=3acc2f1b6eb7de6d42291442775d728c35747fd246cf290b4c232a2aeb60bc48",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/31c5c7f955540f34d0f109be6e86bc19/250x250-000000-80-0-0.jpg",
    genre: "Rap/Hip Hop",
  },
  {
    title: "I'm the One",
    artist: "DJ Khaled",
    id: 375689871,
    release_date: "2017-06-23",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/3/4/1/0/34103bbc20bfaaf936f2707de6e382cd.mp3?hdnea=exp=1763730777~acl=/api/1/1/3/4/1/0/34103bbc20bfaaf936f2707de6e382cd.mp3*~data=user_id=0,application_id=42~hmac=e4fc0c5b3490ad7897f1b606a67b5614bbee8c7ce10c5e302d315b834b6919de",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/31c5c7f955540f34d0f109be6e86bc19/250x250-000000-80-0-0.jpg",
    genre: "Rap/Hip Hop",
  },
  {
    title: "Slide (feat. Frank Ocean & Migos)",
    artist: "Calvin Harris",
    id: 376480891,
    release_date: "2017-06-30",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/9/a/0/0/9a0f6d1e3f4423a5a57053a26439ca84.mp3?hdnea=exp=1763730777~acl=/api/1/1/9/a/0/0/9a0f6d1e3f4423a5a57053a26439ca84.mp3*~data=user_id=0,application_id=42~hmac=542549b3a10780b46c536488d6c9a3baf2412b925e97b30b7cb7d50560d8b0e4",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/953237229a2d2a8d36c99faf24c337d7/250x250-000000-80-0-0.jpg",
    genre: "Dance",
  },
  {
    title: "Feels (feat. Pharrell Williams, Katy Perry & Big Sean)",
    artist: "Calvin Harris",
    id: 376480961,
    release_date: "2017-06-30",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/9/a/e/0/9ae28d3a010d95112358f9542f121685.mp3?hdnea=exp=1763726054~acl=/api/1/1/9/a/e/0/9ae28d3a010d95112358f9542f121685.mp3*~data=user_id=0,application_id=42~hmac=f5a5cc536f158dd23bdc9aa459d73f1c2775c9c698ee0cdea5070c6d09a12400",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/953237229a2d2a8d36c99faf24c337d7/250x250-000000-80-0-0.jpg",
    genre: "Dance",
  },
  {
    title: "Mi Gente",
    artist: "J Balvin",
    id: 376989861,
    release_date: "2017-06-30",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/1/0/2/0/102e796478cc967233c52a60ffa75823.mp3?hdnea=exp=1763730777~acl=/api/1/1/1/0/2/0/102e796478cc967233c52a60ffa75823.mp3*~data=user_id=0,application_id=42~hmac=51c8055a4cc3d56c72e7622d3e953cb2b831916cb1501d10e33e0836d3ff8764",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/aad5dfbfd03587d830cb7dec810d92e0/250x250-000000-80-0-0.jpg",
    genre: "Rap/Hip Hop",
  },
  {
    title: "Unforgettable (feat. Swae Lee)",
    artist: "French Montana",
    id: 382428781,
    release_date: "2017-07-14",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/9/9/b/0/99b838ee825b764637e4cc1563ee3a36.mp3?hdnea=exp=1763730777~acl=/api/1/1/9/9/b/0/99b838ee825b764637e4cc1563ee3a36.mp3*~data=user_id=0,application_id=42~hmac=ff83c886c29f0f5501ab9c0d3df7bf01780915585104d5df5bba9e093dbe5dca",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/b9b0f5d741397596eefe0c1db4c5aea1/250x250-000000-80-0-0.jpg",
    genre: "Rap/Hip Hop",
  },
  {
    title: "Dragostea Din Tei",
    artist: "O-Zone",
    id: 383495601,
    release_date: "2004-06-06",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/bdabeb6095ca91be01ae377c91da6458/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Bring Em Out",
    artist: "T.I.",
    id: 383740881,
    release_date: "2004-11-28",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/e/7/4/0/e747cbe66d173942ae2fb2a12559f500.mp3?hdnea=exp=1763726054~acl=/api/1/1/e/7/4/0/e747cbe66d173942ae2fb2a12559f500.mp3*~data=user_id=0,application_id=42~hmac=c5fb8e85311d2ebee24d18c0a420c9b26c2c8c8fd5e0360401f562e614245de0",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/0658619a6f777f7311feb4972698c184/250x250-000000-80-0-0.jpg",
    genre: "Rap/Hip Hop",
  },
  {
    title: "Live Your Life",
    artist: "T.I.",
    id: 383741911,
    release_date: "2008-09-08",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/b/c/a/0/bcac4c096018fc1e9510713d1f5d6ed0.mp3?hdnea=exp=1763726054~acl=/api/1/1/b/c/a/0/bcac4c096018fc1e9510713d1f5d6ed0.mp3*~data=user_id=0,application_id=42~hmac=7dbda1b2185f70aed1f8183f6e3d31b8d997abfc746ca7fde75c59a458e4eff7",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/797f88ddbe4364d743ea4b6e7598bb97/250x250-000000-80-0-0.jpg",
    genre: "Rap/Hip Hop",
  },
  {
    title: "Whatever You Like",
    artist: "T.I.",
    id: 383742081,
    release_date: "2008-09-07",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/a/2/3/0/a23105becb3290b0a1993f9d2eb8c165.mp3?hdnea=exp=1763726054~acl=/api/1/1/a/2/3/0/a23105becb3290b0a1993f9d2eb8c165.mp3*~data=user_id=0,application_id=42~hmac=d9919ac7ccfc150ad91db2f72b7c972901b5e2bfae61f4658732a05b02acaf55",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/f4c83cd8eebca6f61ee616f78160c99d/250x250-000000-80-0-0.jpg",
    genre: "Rap/Hip Hop",
  },
  {
    title: "Dead And Gone",
    artist: "T.I.",
    id: 383742181,
    release_date: "2008-09-07",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/1/3/6/0/136efa9059757df8afc8ff590c83eb97.mp3?hdnea=exp=1763726054~acl=/api/1/1/1/3/6/0/136efa9059757df8afc8ff590c83eb97.mp3*~data=user_id=0,application_id=42~hmac=149643b906f2e4d5bc200e0dd8fbbe62375fd555fbdfde59998c338e610eaede",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/f4c83cd8eebca6f61ee616f78160c99d/250x250-000000-80-0-0.jpg",
    genre: "Rap/Hip Hop",
  },
  {
    title: "Gasolina",
    artist: "Daddy Yankee",
    id: 385097421,
    release_date: "2004-07-13",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/77f9bfa97ef4ee089f7596759c5adf87/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Proper Education",
    artist: "Eric Prydz",
    id: 388965251,
    release_date: "2006-12-29",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/8559217f18e6c194ff0ec86e871f8d0c/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "The Middle",
    artist: "Jimmy Eat World",
    id: 389059151,
    release_date: "2001-11-05",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/d/0/0/0/d00808d4599144d1ce8b166660019ed0.mp3?hdnea=exp=1763726054~acl=/api/1/1/d/0/0/0/d00808d4599144d1ce8b166660019ed0.mp3*~data=user_id=0,application_id=42~hmac=6aff3bbad83ea37ef51248ebffbccf9ec5b74f352e9e62c6b16f5ad3e12d930c",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/7494f2967fd2426dad3caab076e66bd5/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Praying",
    artist: "Ke$ha",
    id: 391689572,
    release_date: "2017-07-06",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/e/4/5/0/e4572b30f2707b0c8435ac9fa52619fd.mp3?hdnea=exp=1763726054~acl=/api/1/1/e/4/5/0/e4572b30f2707b0c8435ac9fa52619fd.mp3*~data=user_id=0,application_id=42~hmac=f721cbdbbd91319581c94cfb36fc4882bc80e2e2500b2b54cbcd31d446d1a336",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/92db233804151e1bef19e26a3d5e78f0/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Silence (feat. Khalid)",
    artist: "Marshmello",
    id: 391727202,
    release_date: "2017-08-11",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/c/b/c/0/cbcc5100777061b21af4aac5377ead9f.mp3?hdnea=exp=1763726054~acl=/api/1/1/c/b/c/0/cbcc5100777061b21af4aac5377ead9f.mp3*~data=user_id=0,application_id=42~hmac=7817777ab962cc167c7f7d97045b19206f44013eeb5bc5d6053f3481abc82275",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/eda5721c07c0c9d6ff937132f33d808a/250x250-000000-80-0-0.jpg",
    genre: "Dance",
  },
  {
    title: "Glorious (feat. Skylar Grey)",
    artist: "Macklemore",
    id: 397729422,
    release_date: "2017-09-22",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/c/7/0/0/c704254fd50475d5c9ea3f19ff41e1dc.mp3?hdnea=exp=1763726054~acl=/api/1/1/c/7/0/0/c704254fd50475d5c9ea3f19ff41e1dc.mp3*~data=user_id=0,application_id=42~hmac=3a87238926bd5c9276e42d900b3cef6adec901b4f6b8848cfdd7a3b0644b8e30",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/01cd93c5a9e67df6f5156b01267c29eb/250x250-000000-80-0-0.jpg",
    genre: "Rap/Hip Hop",
  },
  {
    title: "Dusk Till Dawn (feat. Sia)",
    artist: "ZAYN",
    id: 403074632,
    release_date: "2017-09-07",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/c/a/2/0/ca2dbf2404ac73ae6d42ec9a2cb3a622.mp3?hdnea=exp=1763726054~acl=/api/1/1/c/a/2/0/ca2dbf2404ac73ae6d42ec9a2cb3a622.mp3*~data=user_id=0,application_id=42~hmac=4fa6adcdc620488ac766d7f9a975522b10728383fb4aabf13aa24751251546c6",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/a16b3974bb938cf6fdd290ea8c60baf0/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "rockstar",
    artist: "Post Malone",
    id: 404667822,
    release_date: "2017-09-15",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/2bf933d5cee270018a277b99c6798b7f/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "One Wish",
    artist: "Ray J",
    id: 409607052,
    release_date: "2005-09-05",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/ef81adac7e58c61b83cbabd7e7ff4a88/250x250-000000-80-0-0.jpg",
    genre: "R&B",
  },
  {
    title: "1, 2, 3, 4 (Sumpin' New)",
    artist: "Coolio",
    id: 409963662,
    release_date: "1995-10-02",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/f3ad5b7eafec51e9f67638b7084d2a19/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "This Is Your Night",
    artist: "Amber",
    id: 409976592,
    release_date: "1996-11-26",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/4c8fd1b8319a46814e7b0ac9fcb39b69/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "What About Us",
    artist: "P!nk",
    id: 415238442,
    release_date: "2017-10-13",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/b/2/6/0/b26acff1f405cbfff4f719b0542f4d04.mp3?hdnea=exp=1763726054~acl=/api/1/1/b/2/6/0/b26acff1f405cbfff4f719b0542f4d04.mp3*~data=user_id=0,application_id=42~hmac=46917dac24ef73867afdb7de5fc621df732b3f4acfb2e731eda27b57870ad149",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/a0ca592cf963bdab9f8da72ff7bbec38/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Mine",
    artist: "Bazzi",
    id: 415370102,
    release_date: "2017-10-12",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/4/7/4/0/47404eb5a1d8c2cb68282d874a8521fb.mp3?hdnea=exp=1763726054~acl=/api/1/1/4/7/4/0/47404eb5a1d8c2cb68282d874a8521fb.mp3*~data=user_id=0,application_id=42~hmac=9ba430d17828d1e1c5b51f3ca7e1f878b0a7cfe005d689ec2df5c622b34b0046",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/ae5084aaf778ffcd83df999c84f8bd16/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Slow Hands",
    artist: "Niall Horan",
    id: 417673222,
    release_date: "2017-10-20",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/6/d/e/0/6de2b2ac0ecaaacc509e9e66915b8ca1.mp3?hdnea=exp=1763726054~acl=/api/1/1/6/d/e/0/6de2b2ac0ecaaacc509e9e66915b8ca1.mp3*~data=user_id=0,application_id=42~hmac=aee4638f60d4f2e49396932720e010e9e255230aa39b95ecff8898784890f265",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/280f054262ce5c2b534150d79f694350/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Wolves",
    artist: "Selena Gomez",
    id: 420355352,
    release_date: "2017-10-25",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/6/e/a/0/6eadd6af4e505a155656610b8cc88281.mp3?hdnea=exp=1763726054~acl=/api/1/1/6/e/a/0/6eadd6af4e505a155656610b8cc88281.mp3*~data=user_id=0,application_id=42~hmac=11895d0249159202556829f91c388273463178c9ade03a37b0a022e85d694299",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/018f19bb66c83e0c843dddaa6d97e544/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Too Good At Goodbyes",
    artist: "Sam Smith",
    id: 422201642,
    release_date: "2017-11-03",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/e/0/8/0/e08666915438f18d9e61440a4f6d624e.mp3?hdnea=exp=1763731240~acl=/api/1/1/e/0/8/0/e08666915438f18d9e61440a4f6d624e.mp3*~data=user_id=0,application_id=42~hmac=115a501a3601480087d0d97692a0461dfc8d2cc9fd34483f59208e0bdfee3d6b",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/c05a89574878fc88a9254c3e7f6b4b26/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "What Lovers Do",
    artist: "Maroon 5",
    id: 422214512,
    release_date: "2017-09-01",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/891a16bc70a0927c3a01a96b26eb4a4f/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "No More Sad Songs",
    artist: "Little Mix",
    id: 425662542,
    release_date: "2017-11-24",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/52eff0349665a3d20553a6642e10c60c/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Deep",
    artist: "East 17",
    id: 428735302,
    release_date: "1992-01-01",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/9/5/3/0/953a3e0d98c0c469fb7be25289ae34c0.mp3?hdnea=exp=1763731240~acl=/api/1/1/9/5/3/0/953a3e0d98c0c469fb7be25289ae34c0.mp3*~data=user_id=0,application_id=42~hmac=e1e907f8a3ccc8e165f9075a2fdd42ac22ec090a4ce4cee317c4e3c41f0ffe20",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/16ec934f7df7de09a7f96433606543ba/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Step On",
    artist: "Happy Mondays",
    id: 428806912,
    release_date: "1990-01-01",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/e/9/1/0/e91dbd716d53e5cbc3fab1d954dadd23.mp3?hdnea=exp=1763731240~acl=/api/1/1/e/9/1/0/e91dbd716d53e5cbc3fab1d954dadd23.mp3*~data=user_id=0,application_id=42~hmac=fa5a0080aafea2f543ecea2e42f60ebc7db646552057e8a15b40f9e184469726",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/6cb24a32422ad9e9c52db98475eb800b/250x250-000000-80-0-0.jpg",
    genre: "Alternative",
  },
  {
    title: "Exterminate (Endzeit 7) [feat. Niki Haris]",
    artist: "Snap!",
    id: 434215212,
    release_date: "1992-01-01",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/f/5/9/0/f59cb2474daee79e024c66da7879e3d0.mp3?hdnea=exp=1763731240~acl=/api/1/1/f/5/9/0/f59cb2474daee79e024c66da7879e3d0.mp3*~data=user_id=0,application_id=42~hmac=83966927c97d20862ea1d885c1b16451f8d3d3c509002a1386b639e103ed7d91",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/e9836fcf60102662b686f93d01bcda69/250x250-000000-80-0-0.jpg",
    genre: "Dance",
  },
  {
    title: "The Power",
    artist: "Snap!",
    id: 434218692,
    release_date: "1990-01-01",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/f/f/0/0/ff0f5064ad1b4ed35c09c345d4c1a8b9.mp3?hdnea=exp=1763731240~acl=/api/1/1/f/f/0/0/ff0f5064ad1b4ed35c09c345d4c1a8b9.mp3*~data=user_id=0,application_id=42~hmac=18841741e1a5bb32855870833e01df70fefd25e6d2969bfddd23d21210417c62",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/22b5838370473301c18c6454a4dd9a6e/250x250-000000-80-0-0.jpg",
    genre: "Dance",
  },
  {
    title: "Ooops Up",
    artist: "Snap!",
    id: 434218702,
    release_date: "1990-01-01",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/5/6/d/0/56d1f191f2ca90377e9ad89de19023b5.mp3?hdnea=exp=1763731240~acl=/api/1/1/5/6/d/0/56d1f191f2ca90377e9ad89de19023b5.mp3*~data=user_id=0,application_id=42~hmac=4b2883cfcedd4970553033c26e2e424d91007558217f593806fd1ee06db53629",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/22b5838370473301c18c6454a4dd9a6e/250x250-000000-80-0-0.jpg",
    genre: "Dance",
  },
  {
    title: "Delicate",
    artist: "Taylor Swift",
    id: 435491482,
    release_date: "2017-11-17",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/f/5/4/0/f543b5683a47050143fdd44dc1a06243.mp3?hdnea=exp=1763731240~acl=/api/1/1/f/5/4/0/f543b5683a47050143fdd44dc1a06243.mp3*~data=user_id=0,application_id=42~hmac=52e385dd9152af18f7c93c9f7679adab075532921cfa1f3cf1a4df321affdbff",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/e6f3afd8a5c3d8ea797f458694166e47/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Look What You Made Me Do",
    artist: "Taylor Swift",
    id: 435491492,
    release_date: "2017-11-17",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/2/f/4/0/2f41fd09761078ab764569668c66fbf5.mp3?hdnea=exp=1763731240~acl=/api/1/1/2/f/4/0/2f41fd09761078ab764569668c66fbf5.mp3*~data=user_id=0,application_id=42~hmac=c43e039da436fbb8e0160032dc2fffd063e8f56ff034510e9226bee8e83c860b",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/e6f3afd8a5c3d8ea797f458694166e47/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Sweet Harmony",
    artist: "The Beloved",
    id: 442403542,
    release_date: "1993-04-05",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/754bf822e1097b41c167292a1eb86e50/250x250-000000-80-0-0.jpg",
    genre: "Electro",
  },
  {
    title: "Love Will Lead You Back",
    artist: "Taylor Dayne",
    id: 444737912,
    release_date: "1989-10-07",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/f/0/9/0/f096723b4c7e1ae4eb06dce744fc8910.mp3?hdnea=exp=1763731240~acl=/api/1/1/f/0/9/0/f096723b4c7e1ae4eb06dce744fc8910.mp3*~data=user_id=0,application_id=42~hmac=2f6a4759fb63985be482533cd782a4e01ede519c92245251aa0b94e41c91c8ab",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/0ac25e8eff2e693ab9d94211e0ffad56/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Never Be the Same",
    artist: "Camila Cabello",
    id: 447098062,
    release_date: "2018-01-12",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/f/f/e/0/ffed8df7e9197f02facc234beced00bc.mp3?hdnea=exp=1763731240~acl=/api/1/1/f/f/e/0/ffed8df7e9197f02facc234beced00bc.mp3*~data=user_id=0,application_id=42~hmac=3da2e472893a4e0030b63315f018fcc6e8b62c83751cafb0934a6571f8e731dc",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/824145a71e397185d8a1abe57842430c/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Havana (feat. Young Thug)",
    artist: "Camila Cabello",
    id: 447098092,
    release_date: "2018-01-12",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/b/1/9/0/b19a0e36acb2526676f68f031023d66f.mp3?hdnea=exp=1763731240~acl=/api/1/1/b/1/9/0/b19a0e36acb2526676f68f031023d66f.mp3*~data=user_id=0,application_id=42~hmac=d1edd09d5afeebf1b584f9d0a8987bb49fbd6dd78577602d8c7b42f56efc858c",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/824145a71e397185d8a1abe57842430c/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Two Steps Behind (String / Acoustic Version)",
    artist: "Def Leppard",
    id: 447556912,
    release_date: "1992-01-19",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/e/d/4/0/ed403a1c49320db284a188ddcf2ee90e.mp3?hdnea=exp=1763731240~acl=/api/1/1/e/d/4/0/ed403a1c49320db284a188ddcf2ee90e.mp3*~data=user_id=0,application_id=42~hmac=f55a58643da82ba145e34a240d5477c2ba4737bf3904acc2f81f515b6b377368",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/6351d7a113318ff475712e8a539f9a75/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "Say Something (feat. Chris Stapleton)",
    artist: "Justin Timberlake",
    id: 455564382,
    release_date: "2018-02-02",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/d/3/2/0/d3212ebc35ca89749debed4c287baaeb.mp3?hdnea=exp=1763731240~acl=/api/1/1/d/3/2/0/d3212ebc35ca89749debed4c287baaeb.mp3*~data=user_id=0,application_id=42~hmac=17c519bd871766892061a6ebac8d43529fd32921adc10f97f72d2013a1d228cd",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/de01a2810fe1e119b502b380c8ce00eb/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "FRIENDS",
    artist: "Marshmello",
    id: 456379902,
    release_date: "2018-02-09",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/b57e2db906a8af3c54b4485313bf18c2/250x250-000000-80-0-0.jpg",
    genre: "Electro",
  },
  {
    title: "1, 2, 3 (feat. Jason Derulo & De La Ghetto)",
    artist: "Sofia Reyes",
    id: 457086912,
    release_date: "2018-02-16",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/7/1/1/0/711d151175a21ab20d334dc3a7af57bf.mp3?hdnea=exp=1763731240~acl=/api/1/1/7/1/1/0/711d151175a21ab20d334dc3a7af57bf.mp3*~data=user_id=0,application_id=42~hmac=8a809e0b83a6da81f97c1253df2f59f91da927473253ed0c7fc251e26c28186b",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/a39202efe2d8d686e7cf7b36afc240a3/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Love Lies",
    artist: "Khalid",
    id: 460570702,
    release_date: "2018-02-14",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/3/9/8/0/398e7171e057ef4f43c875590ecc4f13.mp3?hdnea=exp=1763731240~acl=/api/1/1/3/9/8/0/398e7171e057ef4f43c875590ecc4f13.mp3*~data=user_id=0,application_id=42~hmac=100ee3d70e93a322a7a5ccbbd0f819d755c824b025e5db85b4a40f573487566c",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/5fa933d7f3523f7249129d0675dd8893/250x250-000000-80-0-0.jpg",
    genre: "Rap/Hip Hop",
  },
  {
    title: "American Boy",
    artist: "Estelle",
    id: 462849482,
    release_date: "2008-03-31",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/2f15abe0f32a2d4b61e53e5b8126daae/250x250-000000-80-0-0.jpg",
    genre: "R&B",
  },
  {
    title: "X",
    artist: "Nicky Jam",
    id: 466856262,
    release_date: "2018-03-02",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/7846659119db2e8323b9678d51c8b79d/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Dancing On My Own",
    artist: "Calum Scott",
    id: 468232772,
    release_date: "2016-03-11",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/9/b/0/0/9b085e250d7bc0636bb85a6a91dabfe1.mp3?hdnea=exp=1763731240~acl=/api/1/1/9/b/0/0/9b085e250d7bc0636bb85a6a91dabfe1.mp3*~data=user_id=0,application_id=42~hmac=12c2c2c1ae06fc1fa743840b205df85d20f3decffdd1dbeb50ac18fc12525e54",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/afba3ab4a93cfdcd4357a51868904da3/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Remind Me to Forget",
    artist: "Kygo",
    id: 470287772,
    release_date: "2018-03-16",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/6/2/a/0/62a950a89bbd955b9754adf1628d9bc6.mp3?hdnea=exp=1763731240~acl=/api/1/1/6/2/a/0/62a950a89bbd955b9754adf1628d9bc6.mp3*~data=user_id=0,application_id=42~hmac=6f6efb2e6f90b932a08495e7447ab34c98db5f2b3938004272aca6a94e6d86cb",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/7805200f0899af981550e427105a0890/250x250-000000-80-0-0.jpg",
    genre: "Electro",
  },
  {
    title: "Alien",
    artist: "Sabrina Carpenter",
    id: 471581512,
    release_date: "2018-03-16",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/8/3/7/0/83704ebef34786bf69802771f86c700f.mp3?hdnea=exp=1763731240~acl=/api/1/1/8/3/7/0/83704ebef34786bf69802771f86c700f.mp3*~data=user_id=0,application_id=42~hmac=7ee6a499367fc7c9b512a09e3f984dff35e1049205667e3ffb20a279675fd60b",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/4c73b93fd964b0b5674260ec27020fda/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Disappear",
    artist: "INXS",
    id: 480061582,
    release_date: "1989-09-11",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/5/9/e/0/59e4866ea20957dc5fcd00ea42cefe69.mp3?hdnea=exp=1763731240~acl=/api/1/1/5/9/e/0/59e4866ea20957dc5fcd00ea42cefe69.mp3*~data=user_id=0,application_id=42~hmac=fda47bfa25430d87630c3833c3efd56d9e03933e8a2bf3bd37c78695b9081087",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/4da6268e94854a45b401201a68b5d31e/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Bodak Yellow",
    artist: "Cardi B",
    id: 482986812,
    release_date: "2018-04-06",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/8/7/b/0/87b0d5683f0349028924b99a5c13210b.mp3?hdnea=exp=1763731240~acl=/api/1/1/8/7/b/0/87b0d5683f0349028924b99a5c13210b.mp3*~data=user_id=0,application_id=42~hmac=92d5acab94e81ea8d2649d37e387e980c41b7bf5854c0d5aac92223d979b942e",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/9617334140532d2a13584042f38e67fa/250x250-000000-80-0-0.jpg",
    genre: "Rap/Hip Hop",
  },
  {
    title: "One Kiss",
    artist: "Calvin Harris",
    id: 482990352,
    release_date: "2018-04-06",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/7/b/8/0/7b84ba7a054ea9a49a23f0b3f49744e1.mp3?hdnea=exp=1763731240~acl=/api/1/1/7/b/8/0/7b84ba7a054ea9a49a23f0b3f49744e1.mp3*~data=user_id=0,application_id=42~hmac=57a6214367e23f3b5d09161dcb6034741a9df4b63aa1ae9316e23d30e1042363",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/0397baea24f861db7ee63fb1c70391f9/250x250-000000-80-0-0.jpg",
    genre: "Dance",
  },
  {
    title: "Youngblood",
    artist: "5 Seconds of Summer",
    id: 483399272,
    release_date: "2018-04-12",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/f/2/4/0/f24a0ad647ee2b25874ba89b8a6fd9b3.mp3?hdnea=exp=1763731240~acl=/api/1/1/f/2/4/0/f24a0ad647ee2b25874ba89b8a6fd9b3.mp3*~data=user_id=0,application_id=42~hmac=be213eaf0dab5898152f42f6558298a59588e6e44fe3c7ec083b7c3923691c81",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/3bbfddbac4bcfc7e2b19fb86619d7ee5/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Axel F (Radio Mix)",
    artist: "Crazy Frog",
    id: 484231112,
    release_date: "2005-06-01",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/0/f/b/0/0fb6510132c560338bd44c91d208fbfb.mp3?hdnea=exp=1763731240~acl=/api/1/1/0/f/b/0/0fb6510132c560338bd44c91d208fbfb.mp3*~data=user_id=0,application_id=42~hmac=ff8df555e49faaa36c247465eeff9dd00f9f4b82ea96123cab72b209910a5905",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/2e24d2924e6475cd59ad987fd0a34bd3/250x250-000000-80-0-0.jpg",
    genre: "Dance",
  },
  {
    title: "lovely",
    artist: "Billie Eilish",
    id: 486928932,
    release_date: "2018-04-19",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/1/f/d/0/1fda9705f0b0c9f5f6246257423c4f03.mp3?hdnea=exp=1763731240~acl=/api/1/1/1/f/d/0/1fda9705f0b0c9f5f6246257423c4f03.mp3*~data=user_id=0,application_id=42~hmac=c71648ebffb5f0d610d0c83bb56638f228362cc8838d7db8218c22d04771cb0a",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/910033ba5cd64291a921061c8e8ba85a/250x250-000000-80-0-0.jpg",
    genre: "Alternative",
  },
  {
    title: "Psycho",
    artist: "Post Malone",
    id: 491446962,
    release_date: "2018-02-23",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/b/1/5/0/b156f009eceb31d14bf2a9fe64e4fac4.mp3?hdnea=exp=1763731240~acl=/api/1/1/b/1/5/0/b156f009eceb31d14bf2a9fe64e4fac4.mp3*~data=user_id=0,application_id=42~hmac=a59631bbc4b097d714f43196d831dbeec3c870422a36ec7ec0fbc508a93f8e92",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/c000a4d39f31f3716bf3f11aa5fab080/250x250-000000-80-0-0.jpg",
    genre: "Rap/Hip Hop",
  },
  {
    title: "Better Now",
    artist: "Post Malone",
    id: 491446972,
    release_date: "2018-04-27",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/9/1/f/0/91f12dc732a82a0bc914d5810cf2cd9e.mp3?hdnea=exp=1763731240~acl=/api/1/1/9/1/f/0/91f12dc732a82a0bc914d5810cf2cd9e.mp3*~data=user_id=0,application_id=42~hmac=93b159384fe5f442704d4cbbdb4467a4097f68d0a6a3b065efe97658874b9710",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/c000a4d39f31f3716bf3f11aa5fab080/250x250-000000-80-0-0.jpg",
    genre: "Rap/Hip Hop",
  },
  {
    title: "Make Me Feel",
    artist: "Janelle Monáe",
    id: 492390782,
    release_date: "2018-04-27",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/c/3/1/0/c314187647f7d1620e71a5c50f09399e.mp3?hdnea=exp=1763731240~acl=/api/1/1/c/3/1/0/c314187647f7d1620e71a5c50f09399e.mp3*~data=user_id=0,application_id=42~hmac=79bf52e83474093526c79089f4751ed7ef12ba39949e4ec4da6793c22f2349b9",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/cc49bde7963ee33be2d027466700eb2e/250x250-000000-80-0-0.jpg",
    genre: "R&B",
  },
  {
    title: "Girls Like You (Cardi B Version)",
    artist: "Maroon 5",
    id: 498130042,
    release_date: "2018-05-31",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/6/5/b/0/65bbdc467425f985d49b411c935da731.mp3?hdnea=exp=1763731240~acl=/api/1/1/6/5/b/0/65bbdc467425f985d49b411c935da731.mp3*~data=user_id=0,application_id=42~hmac=d7c8e936bf579c599bf7936ba0ff1bfcd589dbf637dc23822cbf4f458a0f4935",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/6b4d59645e2d1cf7a692782983cee963/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Attention",
    artist: "Charlie Puth",
    id: 498386892,
    release_date: "2018-05-11",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/a/e/5/0/ae5ef079b6184f5a7de4fc9ce68d04eb.mp3?hdnea=exp=1763731240~acl=/api/1/1/a/e/5/0/ae5ef079b6184f5a7de4fc9ce68d04eb.mp3*~data=user_id=0,application_id=42~hmac=95341898e0b1aae96c3d454fb61dab68a4b2afc9fe55e36d3d3d8cd035d48db3",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/e8a3333f8b5382b07190a415e16248b4/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Audio (feat. Sia, Diplo & Labrinth)",
    artist: "LSD",
    id: 498525792,
    release_date: "2018-05-10",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/e/d/f/0/edf0de70b7ed963ca94306f3e1886f42.mp3?hdnea=exp=1763731240~acl=/api/1/1/e/d/f/0/edf0de70b7ed963ca94306f3e1886f42.mp3*~data=user_id=0,application_id=42~hmac=606284f7febe3442f535fd5cacb0f893038578fabc4c5af04f092f063da6ada1",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/cee9902d75371aeb14e32621bc47a2df/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Back To You",
    artist: "Selena Gomez",
    id: 499988792,
    release_date: "2018-05-18",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/f/8/0/0/f802d79ac80ae7f26f99ba0b7240c4b3.mp3?hdnea=exp=1763731240~acl=/api/1/1/f/8/0/0/f802d79ac80ae7f26f99ba0b7240c4b3.mp3*~data=user_id=0,application_id=42~hmac=055f9a19c49c969955394a57ee80b7df609eeb134ffd361a2d2f18b017b8ac18",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/19b14fa5b494e0e74332f7dbf8dab87d/250x250-000000-80-0-0.jpg",
    genre: "Films/Games",
  },
  {
    title: "Start Again",
    artist: "OneRepublic",
    id: 499988812,
    release_date: "2018-05-18",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/8/8/3/0/8833024783d2fa72906497d1282cef43.mp3?hdnea=exp=1763731240~acl=/api/1/1/8/8/3/0/8833024783d2fa72906497d1282cef43.mp3*~data=user_id=0,application_id=42~hmac=b693b117711c5421e6cb7745dbc6c362a165048aad64806a4d2dc1a549f6f0ad",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/19b14fa5b494e0e74332f7dbf8dab87d/250x250-000000-80-0-0.jpg",
    genre: "Films/Games",
  },
  {
    title: "Jackie Chan",
    artist: "Tiësto",
    id: 499994962,
    release_date: "2018-05-18",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/0/4/d/0/04dd26582ea186ae52ef87912d1ed566.mp3?hdnea=exp=1763731240~acl=/api/1/1/0/4/d/0/04dd26582ea186ae52ef87912d1ed566.mp3*~data=user_id=0,application_id=42~hmac=e3dbd7f38822433008e487ae465bb95fd87b46299e6363b92fa981359efcbad5",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/bab7fb0d0bfd1e98756aa70f8efe9128/250x250-000000-80-0-0.jpg",
    genre: "Dance",
  },
  {
    title: "Forget to Forget",
    artist: "Shy Martin",
    id: 502559712,
    release_date: "2018-05-25",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/8dc4926be0cb07226279884273dc4d42/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "In My Blood",
    artist: "Shawn Mendes",
    id: 504135662,
    release_date: "2018-05-25",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/d/a/4/0/da49bb6398f594228bd6d87c399719c7.mp3?hdnea=exp=1763731240~acl=/api/1/1/d/a/4/0/da49bb6398f594228bd6d87c399719c7.mp3*~data=user_id=0,application_id=42~hmac=d9e277cb570fcae34dd224fd9743242895951c679a693b1b3ff55c21c2090612",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/1a7bbe4434bb38821b20c96cfa1c35d7/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Let Me Down Slowly",
    artist: "Alec Benjamin",
    id: 504313072,
    release_date: "2018-05-25",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/1a2ff1ad7241739d524583d6f775c379/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "In My Mind",
    artist: "Dynoro",
    id: 505204262,
    release_date: "2018-06-08",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/27170198c97ac7e37f8a62cf5cae4299/250x250-000000-80-0-0.jpg",
    genre: "Dance",
  },
  {
    title: "Knockin' On Heaven's Door",
    artist: "Guns N' Roses",
    id: 505510232,
    release_date: "1973-05-23",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/e/d/f/0/edfb2b7cf4665adcf6e57c038d4cee44.mp3?hdnea=exp=1763731240~acl=/api/1/1/e/d/f/0/edfb2b7cf4665adcf6e57c038d4cee44.mp3*~data=user_id=0,application_id=42~hmac=fc03c57e210e03b040154470ebb7e138bdad6a27632111eed6db1291be6d0d75",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/c32f893b8670d5a3d9b1e70078bbc8fa/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "Girls Like You",
    artist: "Maroon 5",
    id: 511053902,
    release_date: "2018-05-30",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/768d869cc8b4ca2990c76e742f6d4f8e/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Don't Wanna Know",
    artist: "Maroon 5",
    id: 511053952,
    release_date: "2016-10-12",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/768d869cc8b4ca2990c76e742f6d4f8e/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Ocean (feat. Khalid)",
    artist: "Martin Garrix",
    id: 511515822,
    release_date: "2018-06-15",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/f28287a0225e1105cfae80bea658ab1f/250x250-000000-80-0-0.jpg",
    genre: "Electro",
  },
  {
    title: "Turn Around",
    artist: "Phats & Small",
    id: 511594332,
    release_date: "2014-03-14",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/f8a3141c23104125afa20e1b67a07c60/250x250-000000-80-0-0.jpg",
    genre: "Dance",
  },
  {
    title: "I'm a Mess",
    artist: "Bebe Rexha",
    id: 511875602,
    release_date: "2018-06-22",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/93df12633104eb53d68c82981d150270/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "High Hopes",
    artist: "Panic! At The Disco",
    id: 516351532,
    release_date: "2018-06-22",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/61a2e3b5a084305f503ea641e2841ecb/250x250-000000-80-0-0.jpg",
    genre: "Alternative",
  },
  {
    title: "Mad Love",
    artist: "Sean Paul",
    id: 518466662,
    release_date: "2018-06-29",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/1fdd524dacaaa389d6d416570882fdd7/250x250-000000-80-0-0.jpg",
    genre: "Reggae",
  },
  {
    title: "Happy Now",
    artist: "Zedd",
    id: 527894901,
    release_date: "2018-07-18",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/6e0f9fade33fb548b959fa5f5516084a/250x250-000000-80-0-0.jpg",
    genre: "Dance",
  },
  {
    title: "Believer",
    artist: "Imagine Dragons",
    id: 528330441,
    release_date: "2018-07-18",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/247b228179aea3b083eef43522b78b45/250x250-000000-80-0-0.jpg",
    genre: "Alternative",
  },
  {
    title: "Thunder",
    artist: "Imagine Dragons",
    id: 528330501,
    release_date: "2018-07-18",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/247b228179aea3b083eef43522b78b45/250x250-000000-80-0-0.jpg",
    genre: "Alternative",
  },
  {
    title: "All Falls Down",
    artist: "Kanye West",
    id: 528869461,
    release_date: "2004-02-24",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/069a5dba671436da9301aad36fc9a983/250x250-000000-80-0-0.jpg",
    genre: "Rap/Hip Hop",
  },
  {
    title: "Jesus Walks",
    artist: "Kanye West",
    id: 528869491,
    release_date: "2004-05-03",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/069a5dba671436da9301aad36fc9a983/250x250-000000-80-0-0.jpg",
    genre: "Rap/Hip Hop",
  },
  {
    title: "I Knew You Were Trouble.",
    artist: "Taylor Swift",
    id: 529117801,
    release_date: "2012-10-09",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/56a83d3002710bf2044b86c01db665aa/250x250-000000-80-0-0.jpg",
    genre: "Country",
  },
  {
    title: "We Are Never Ever Getting Back Together",
    artist: "Taylor Swift",
    id: 529117841,
    release_date: "2018-07-17",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/56a83d3002710bf2044b86c01db665aa/250x250-000000-80-0-0.jpg",
    genre: "Country",
  },
  {
    title: "Body",
    artist: "Loud Luxury",
    id: 529677191,
    release_date: "2018-07-20",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/10c2f51050aaa840b36aa75fcd46a8d5/250x250-000000-80-0-0.jpg",
    genre: "Dance",
  },
  {
    title: "If I Ever Lose My Faith In You",
    artist: "Sting",
    id: 530979431,
    release_date: "1993-08-02",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/e2491c22fb19c154e46b449ff7aa7a62/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "No Brainer (feat. Justin Bieber, Chance the Rapper & Quavo)",
    artist: "DJ Khaled",
    id: 533193682,
    release_date: "2018-07-27",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/cb3c040271bf9e6eb9fa81f74038e937/250x250-000000-80-0-0.jpg",
    genre: "Rap/Hip Hop",
  },
  {
    title: "God's Plan",
    artist: "Drake",
    id: 533609232,
    release_date: "2018-01-19",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/b69d3bcbd130ad4cc9259de543889e30/250x250-000000-80-0-0.jpg",
    genre: "Rap/Hip Hop",
  },
  {
    title: "In My Feelings",
    artist: "Drake",
    id: 533609392,
    release_date: "2018-06-29",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/b69d3bcbd130ad4cc9259de543889e30/250x250-000000-80-0-0.jpg",
    genre: "Rap/Hip Hop",
  },
  {
    title: "Whatta Man",
    artist: "Salt-N-Pepa",
    id: 537989532,
    release_date: "1993-07-20",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/e5e0b9c239ffe88c9e5230589ecf4dcc/250x250-000000-80-0-0.jpg",
    genre: "R&B",
  },
  {
    title: "Shoop",
    artist: "Salt-N-Pepa",
    id: 537989562,
    release_date: "1993-06-15",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/e5e0b9c239ffe88c9e5230589ecf4dcc/250x250-000000-80-0-0.jpg",
    genre: "R&B",
  },
  {
    title: "Sweet but Psycho",
    artist: "Ava Max",
    id: 539562302,
    release_date: "2018-08-17",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/b/e/9/0/be9199583424d6b2bcd324cfd8e61cb4.mp3?hdnea=exp=1763731691~acl=/api/1/1/b/e/9/0/be9199583424d6b2bcd324cfd8e61cb4.mp3*~data=user_id=0,application_id=42~hmac=0dd81ff673c4ad5ffc6bc543b07347e90cf0b350e1c65d8b6ba981cff44af9bb",
    cover: "https://api.deezer.com/album/70366152/image",
    genre: "Pop",
  },
  {
    title: "Do Me Right",
    artist: "Guy",
    id: 548865182,
    release_date: "2010-01-01",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/c/5/b/0/c5b79c1c79e9460dc50e0bfc22fac123.mp3?hdnea=exp=1763731691~acl=/api/1/1/c/5/b/0/c5b79c1c79e9460dc50e0bfc22fac123.mp3*~data=user_id=0,application_id=42~hmac=589a448f9a08e4984b4d065b492d49482b04437fe03f870eb0f89635552a5e52",
    cover: "https://api.deezer.com/album/72090822/image",
    genre: "Rap/Hip Hop",
  },
  {
    title: "Save Up All Your Tears",
    artist: "Cher",
    id: 1126794,
    release_date: "2018-08-10",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/5/9/2/0/5922acc533d8aa29e77c7c7d92c5f050.mp3?hdnea=exp=1763731691~acl=/api/1/1/5/9/2/0/5922acc533d8aa29e77c7c7d92c5f050.mp3*~data=user_id=0,application_id=42~hmac=c1ab42fb258f205bc607f64476e13f08d850e60875e1238f30487b37ac2c196e",
    cover: "https://api.deezer.com/album/121095/image",
    genre: "Pop",
  },
  {
    title: "Love And Understanding",
    artist: "Cher",
    id: 1126793,
    release_date: "1989-06-13",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/6/b/e/0/6be34d6675608f6b1f1ab0c6d905d70b.mp3?hdnea=exp=1763731691~acl=/api/1/1/6/b/e/0/6be34d6675608f6b1f1ab0c6d905d70b.mp3*~data=user_id=0,application_id=42~hmac=59f328f7fd06bf992c9ca6c3056d8ef66918c4def2fe951064d44fa1fe46e83b",
    cover: "https://api.deezer.com/album/121095/image",
    genre: "Pop",
  },
  {
    title: "Give It To You",
    artist: "Jordan Knight",
    id: 540495122,
    release_date: "2018-08-17",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/5/7/8/0/578ff298af680e4c245e7b97f25f616c.mp3?hdnea=exp=1763731691~acl=/api/1/1/5/7/8/0/578ff298af680e4c245e7b97f25f616c.mp3*~data=user_id=0,application_id=42~hmac=7eb59b1562e534061ab9f940fa60e4aaecb82c25013efa9960579e8ee7f89e62",
    cover: "https://api.deezer.com/album/70549922/image",
    genre: "Pop",
  },
  {
    title: "Happier",
    artist: "Marshmello",
    id: 2441318935,
    release_date: "2018-08-17",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/c/3/9/0/c3987d791da5efff1bd4fcf8a3a0b5da.mp3?hdnea=exp=1763731691~acl=/api/1/1/c/3/9/0/c3987d791da5efff1bd4fcf8a3a0b5da.mp3*~data=user_id=0,application_id=42~hmac=c185be308c8ea9d1a6a1de909dc838c1c41970f82dfe191d84163dfe99d4fe5a",
    cover: "https://api.deezer.com/album/484483015/image",
    genre: "Dance",
  },
  {
    title: "Promises",
    artist: "Calvin Harris",
    id: 542335432,
    release_date: "2018-08-17",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/5/4/7/0/5470ab1da420554999cb77b5bd33348b.mp3?hdnea=exp=1763731691~acl=/api/1/1/5/4/7/0/5470ab1da420554999cb77b5bd33348b.mp3*~data=user_id=0,application_id=42~hmac=5d77207e51b9b26b9e5209768c8e338ea103812dd4e312e88a32c1319473a14e",
    cover: "https://api.deezer.com/album/70900922/image",
    genre: "Dance",
  },
  {
    title: "God is a woman",
    artist: "Ariana Grande",
    id: 542389502,
    release_date: "2018-08-17",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/f/3/0/0/f305a4bf959e3d9a61337a3e71162dd5.mp3?hdnea=exp=1763731691~acl=/api/1/1/f/3/0/0/f305a4bf959e3d9a61337a3e71162dd5.mp3*~data=user_id=0,application_id=42~hmac=c8dea69f5718905cf1cbb451ac18b37c773cea45f2eb504432e7f2984d6509c9",
    cover: "https://api.deezer.com/album/70912182/image",
    genre: "Pop",
  },
  {
    title: "no tears left to cry",
    artist: "Ariana Grande",
    id: 542389552,
    release_date: "2018-04-20",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/0/7/1/0/07194b97de48a5d786141c69541a5184.mp3?hdnea=exp=1763731691~acl=/api/1/1/0/7/1/0/07194b97de48a5d786141c69541a5184.mp3*~data=user_id=0,application_id=42~hmac=1be38b66a41a732dbaa1420feda0fc48d3207ba8283aaf24e53bc74ced662f36",
    cover: "https://api.deezer.com/album/70912182/image",
    genre: "Pop",
  },
  {
    title: "My My My!",
    artist: "Troye Sivan",
    id: 546233492,
    release_date: "2018-08-31",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/b/0/d/0/b0d79f31bb6f40c80f4d196de2e60a14.mp3?hdnea=exp=1763731691~acl=/api/1/1/b/0/d/0/b0d79f31bb6f40c80f4d196de2e60a14.mp3*~data=user_id=0,application_id=42~hmac=11ced4a81241e5118641237aa0c3233e07960f952e101e59d57a096f749f18d5",
    cover: "https://api.deezer.com/album/71592302/image",
    genre: "Pop",
  },
  {
    title: "My Blood",
    artist: "Twenty One Pilots",
    id: 546720982,
    release_date: "2018-08-27",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/e/f/7/0/ef7882ca58fee92955cb61498ea2bb2d.mp3?hdnea=exp=1763731691~acl=/api/1/1/e/f/7/0/ef7882ca58fee92955cb61498ea2bb2d.mp3*~data=user_id=0,application_id=42~hmac=0645c9628dee360762de3554a0cbcd4cb4c6cd32f4fae597ba3aed8fb9fb518d",
    cover: "https://api.deezer.com/album/71699692/image",
    genre: "Alternative",
  },
  {
    title: "Electricity (feat. Diplo & Mark Ronson)",
    artist: "Silk City",
    id: 550232732,
    release_date: "2018-09-06",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/a/5/0/0/a500c065d671f024fdb0602412e447b5.mp3?hdnea=exp=1763731691~acl=/api/1/1/a/5/0/0/a500c065d671f024fdb0602412e447b5.mp3*~data=user_id=0,application_id=42~hmac=154fab8df83cca1e66f87170643339185185540bfd4432f43587ef187637f339",
    cover: "https://api.deezer.com/album/72333032/image",
    genre: "Dance",
  },
  {
    title: "Don't Leave Me Alone (feat. Anne-Marie)",
    artist: "David Guetta",
    id: 553056552,
    release_date: "2018-09-14",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/f/3/f/0/f3f66e3f56a8010e43cbda90058059e4.mp3?hdnea=exp=1763731691~acl=/api/1/1/f/3/f/0/f3f66e3f56a8010e43cbda90058059e4.mp3*~data=user_id=0,application_id=42~hmac=f92f32e579502b7576f1f0448a8d1aedc5a4d4240e807ac3f3a2ec487278164e",
    cover: "https://api.deezer.com/album/72839592/image",
    genre: "Dance",
  },
  {
    title: "Let You Love Me",
    artist: "Rita Ora",
    id: 556352852,
    release_date: "2018-09-21",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/7/6/6/0/766f3c49595d11fc123a800305bfc5c9.mp3?hdnea=exp=1763731691~acl=/api/1/1/7/6/6/0/766f3c49595d11fc123a800305bfc5c9.mp3*~data=user_id=0,application_id=42~hmac=3aeca99f5d111c0d449697c795782fbe8cc7039e717ebd1a1662339c87c9dda0",
    cover: "https://api.deezer.com/album/73444962/image",
    genre: "Pop",
  },
  {
    title: "Taki Taki",
    artist: "DJ Snake",
    id: 716383912,
    release_date: "2018-09-28",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/f/a/f/0/faf0d340bde5e5a10f3c810bafa8c5a9.mp3?hdnea=exp=1763731691~acl=/api/1/1/f/a/f/0/faf0d340bde5e5a10f3c810bafa8c5a9.mp3*~data=user_id=0,application_id=42~hmac=a58159f70572bb1943d6d7b5d0d8b5c062cd7378960a4d4455694be231514023",
    cover: "https://api.deezer.com/album/104455482/image",
    genre: "Pop",
  },
  {
    title: "Without Me",
    artist: "Halsey",
    id: 1088873812,
    release_date: "2018-10-04",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/f/5/d/0/f5d750dc0c106e10bf594ce7e4bb7851.mp3?hdnea=exp=1763731691~acl=/api/1/1/f/5/d/0/f5d750dc0c106e10bf594ce7e4bb7851.mp3*~data=user_id=0,application_id=42~hmac=eba0507a8e8ce8639688e56e63b156549bafdec04a3e7c1fadf4aa521b84a44e",
    cover: "https://api.deezer.com/album/175153222/image",
    genre: "Alternative",
  },
  {
    title: "Shallow",
    artist: "Lady Gaga",
    id: 561855992,
    release_date: "2018-10-05",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/5/c/8/0/5c893bebee36adefcc193a36c6d6783f.mp3?hdnea=exp=1763731691~acl=/api/1/1/5/c/8/0/5c893bebee36adefcc193a36c6d6783f.mp3*~data=user_id=0,application_id=42~hmac=36c890a05799f825855330d177df0c96f059361a069948015f10a863adcaada2",
    cover: "https://api.deezer.com/album/74434902/image",
    genre: "Films/Games",
  },
  {
    title: "Son of Man",
    artist: "Phil Collins",
    id: 561875042,
    release_date: "2018-10-05",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/1/0/c/0/10c1bd5dfce498626ddd02178e0df4ad.mp3?hdnea=exp=1763731691~acl=/api/1/1/1/0/c/0/10c1bd5dfce498626ddd02178e0df4ad.mp3*~data=user_id=0,application_id=42~hmac=996afe575ea0a2ea0d443f34124e27292118617ab3aee42f060d793ae594221d",
    cover: "https://api.deezer.com/album/74437962/image",
    genre: "Films/Games",
  },
  {
    title: "Strangers Like Me",
    artist: "Phil Collins",
    id: 561875072,
    release_date: "2018-10-05",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/6/5/3/0/65363ca58f21bfc2b20c8744d1b09710.mp3?hdnea=exp=1763731691~acl=/api/1/1/6/5/3/0/65363ca58f21bfc2b20c8744d1b09710.mp3*~data=user_id=0,application_id=42~hmac=e1678b8ad4607f1bf0c4954a3b714f6be87907d485fb53327df8ffccf467fabb",
    cover: "https://api.deezer.com/album/74437962/image",
    genre: "Films/Games",
  },
  {
    title: "Falling",
    artist: "Trevor Daniel",
    id: 1421190662,
    release_date: "2018-10-05",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/9/5/5/0/9555b705b38f511c53a2c99c811a9a7c.mp3?hdnea=exp=1763731691~acl=/api/1/1/9/5/5/0/9555b705b38f511c53a2c99c811a9a7c.mp3*~data=user_id=0,application_id=42~hmac=11c7770f089556c2d6cc38285a2aa62a52e68fa6e05ce665fd13c996e79a73cd",
    cover: "https://api.deezer.com/album/241350872/image",
    genre: "Pop",
  },
  {
    title: "3 Nights",
    artist: "Dominic Fike",
    id: 564326642,
    release_date: "2018-10-16",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/2/a/9/0/2a9f884bbccc2a4ef8169d2447d35106.mp3?hdnea=exp=1763731691~acl=/api/1/1/2/a/9/0/2a9f884bbccc2a4ef8169d2447d35106.mp3*~data=user_id=0,application_id=42~hmac=fe21b65e9e17c68d19c0c8caa38855a9ef37cdd954ef289327a7add1f1635475",
    cover: "https://api.deezer.com/album/74919842/image",
    genre: "Alternative",
  },
  {
    title: "MIA (feat. Drake)",
    artist: "Bad Bunny",
    id: 2349151045,
    release_date: "2018-10-11",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/5/b/1/0/5b1f33e04a410ebbaeb5ea7c0c87028c.mp3?hdnea=exp=1763731691~acl=/api/1/1/5/b/1/0/5b1f33e04a410ebbaeb5ea7c0c87028c.mp3*~data=user_id=0,application_id=42~hmac=1100de137be2fea9b198521bd66457ef01d95c642e0182eea0bf4065352fc105",
    cover: "https://api.deezer.com/album/459361075/image",
    genre: "Rap/Hip Hop",
  },
  {
    title: "Missing U",
    artist: "Robyn",
    id: 571860802,
    release_date: "2018-10-26",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/4/4/d/0/44da7d302a012be06519d6cb98986597.mp3?hdnea=exp=1763731691~acl=/api/1/1/4/4/d/0/44da7d302a012be06519d6cb98986597.mp3*~data=user_id=0,application_id=42~hmac=e96f8ee07424f484c61f25aadcbb0863e1ae28ff961acc82b974a172acce060d",
    cover: "https://api.deezer.com/album/76256212/image",
    genre: "Pop",
  },
  {
    title: "thank u, next",
    artist: "Ariana Grande",
    id: 579496662,
    release_date: "2018-11-04",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/f/8/7/0/f87f4d9b48df89c8d1ded1e58254da98.mp3?hdnea=exp=1763731691~acl=/api/1/1/f/8/7/0/f87f4d9b48df89c8d1ded1e58254da98.mp3*~data=user_id=0,application_id=42~hmac=e1db8041691aeb7f5f934b58019190b66e0912e9972a80a055e27a5cd50441f6",
    cover: "https://api.deezer.com/album/77578472/image",
    genre: "Pop",
  },
  {
    title: "Woman Like Me (feat. Nicki Minaj)",
    artist: "Little Mix",
    id: 580705262,
    release_date: "2018-11-16",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/a/8/4/0/a845d630350a376411ee497ebb736775.mp3?hdnea=exp=1763731691~acl=/api/1/1/a/8/4/0/a845d630350a376411ee497ebb736775.mp3*~data=user_id=0,application_id=42~hmac=850adaefbd25b3143a60ef384d06ed37a57603fb2f9e2cee7f3877a357ba00a2",
    cover: "https://api.deezer.com/album/77777842/image",
    genre: "Pop",
  },
  {
    title: "Someone You Loved",
    artist: "Lewis Capaldi",
    id: 582143242,
    release_date: "2018-11-08",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/5/e/9/0/5e9d413644939d60388868b3befb242d.mp3?hdnea=exp=1763731691~acl=/api/1/1/5/e/9/0/5e9d413644939d60388868b3befb242d.mp3*~data=user_id=0,application_id=42~hmac=43885cff3d97941cc1dc350239c82bc8335fe7b528eae2af9673c526c82a0cc9",
    cover: "https://api.deezer.com/album/78031872/image",
    genre: "Alternative",
  },
  {
    title: "It Feels So Good",
    artist: "Sonique",
    id: 3439503611,
    release_date: "2000-08-24",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/b/f/2/0/bf2611924c76df7d9b112201f72797e1.mp3?hdnea=exp=1763731692~acl=/api/1/1/b/f/2/0/bf2611924c76df7d9b112201f72797e1.mp3*~data=user_id=0,application_id=42~hmac=d20b03336c081b3283e24a48171c12101f2f90229c37b0ec0e4f084f266b1b95",
    cover: "https://api.deezer.com/album/781118871/image",
    genre: "Dance",
  },
  {
    title: "Solo (feat. Demi Lovato)",
    artist: "Clean Bandit",
    id: 595082272,
    release_date: "2018-11-30",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/0/0/c/0/00ca8f5f7067ab69b6f5a8d36be206cc.mp3?hdnea=exp=1763731691~acl=/api/1/1/0/0/c/0/00ca8f5f7067ab69b6f5a8d36be206cc.mp3*~data=user_id=0,application_id=42~hmac=953cf2d2d01bf95341a627479a33b0f31b1e265acbc96ee75b33a6f83e5a9a39",
    cover: "https://api.deezer.com/album/80120742/image",
    genre: "Electro",
  },
  {
    title: "Eastside",
    artist: "benny blanco",
    id: 598081672,
    release_date: "2018-07-13",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/8/0/3/0/803a887c43747303b9b5b14f76dbbb84.mp3?hdnea=exp=1763731691~acl=/api/1/1/8/0/3/0/803a887c43747303b9b5b14f76dbbb84.mp3*~data=user_id=0,application_id=42~hmac=1cc8fd7f7c5b8d8bd79a3d415ea7fcfb585a4a283d92364f6b4b9e0efbeae0a4",
    cover: "https://api.deezer.com/album/80676652/image",
    genre: "Pop",
  },
  {
    title: "New Soul",
    artist: "Yael Naim",
    id: 605635722,
    release_date: "2007-01-01",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/b/2/3/0/b23d5469126012b32360a2aa4ba9cd88.mp3?hdnea=exp=1763731691~acl=/api/1/1/b/2/3/0/b23d5469126012b32360a2aa4ba9cd88.mp3*~data=user_id=0,application_id=42~hmac=17111f45bbaee196957659c8a15fdf0c7133336ef0056f05cfb9ab8d03dac065",
    cover: "https://api.deezer.com/album/81993632/image",
    genre: "Pop",
  },
  {
    title: "Boom Boom Boom",
    artist: "The Outhere Brothers",
    id: 606658802,
    release_date: "1994-01-01",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/d/7/a/0/d7acc5ddce916da322b4341163bb68a3.mp3?hdnea=exp=1763731691~acl=/api/1/1/d/7/a/0/d7acc5ddce916da322b4341163bb68a3.mp3*~data=user_id=0,application_id=42~hmac=ce7edf243daf1d9d15edce8cb0ea0cdcfb21508edb558dd0a05b53da3603beb5",
    cover: "https://api.deezer.com/album/82192282/image",
    genre: "Dance",
  },
  {
    title: "It's Alright (The Guvnor Mix)",
    artist: "East 17",
    id: 608745242,
    release_date: "2017-12-15",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/2/1/e/0/21e6a04db38e09bd71e349599075a62b.mp3?hdnea=exp=1763731692~acl=/api/1/1/2/1/e/0/21e6a04db38e09bd71e349599075a62b.mp3*~data=user_id=0,application_id=42~hmac=6f7538e880cb7fee008e1e4b36d695c02ee404f04219d3f3ec844e142435fc3d",
    cover: "https://api.deezer.com/album/82633072/image",
    genre: "Pop",
  },
  {
    title: "Grillz",
    artist: "Nelly",
    id: 610858502,
    release_date: "2005-11-29",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/7/f/a/0/7fa13b6c7fcf151f82d1672bda78bbe2.mp3?hdnea=exp=1763731692~acl=/api/1/1/7/f/a/0/7fa13b6c7fcf151f82d1672bda78bbe2.mp3*~data=user_id=0,application_id=42~hmac=dab1455a8fe6744ef163debaf1c3dcaa2511e459201f3be7a8f4712377ac8ec5",
    cover: "https://api.deezer.com/album/83065202/image",
    genre: "Rap/Hip Hop",
  },
  {
    title: "Get Right",
    artist: "Jennifer Lopez",
    id: 611716572,
    release_date: "2005-03-01",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/0/a/3/0/0a3c1da6bb811da2c5999d1d461b3e87.mp3?hdnea=exp=1763731692~acl=/api/1/1/0/a/3/0/0a3c1da6bb811da2c5999d1d461b3e87.mp3*~data=user_id=0,application_id=42~hmac=f37ca42ba4f73ba74beec5f49618158a493bff05853ea74625415973e95520d8",
    cover: "https://api.deezer.com/album/83268202/image",
    genre: "Pop",
  },
  {
    title: "Dancing With A Stranger",
    artist: "Sam Smith",
    id: 613138092,
    release_date: "2019-01-11",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/e/d/9/0/ed9124ff741b721affcd6d9c4a832a57.mp3?hdnea=exp=1763731692~acl=/api/1/1/e/d/9/0/ed9124ff741b721affcd6d9c4a832a57.mp3*~data=user_id=0,application_id=42~hmac=323d8098fbdab2cb79d2264cc7811ac56fef63ae20e48ce6dc8c0f874b3c5b68",
    cover: "https://api.deezer.com/album/83522392/image",
    genre: "Pop",
  },
  {
    title: "i'm so tired...",
    artist: "Lauv",
    id: 1951168607,
    release_date: "2019-01-24",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/6/1/b/0/61b1d7f78437a17a8372abd8b714c0c6.mp3?hdnea=exp=1763731692~acl=/api/1/1/6/1/b/0/61b1d7f78437a17a8372abd8b714c0c6.mp3*~data=user_id=0,application_id=42~hmac=e0b3032b0a6daad5d178c9d8874414356ca81ad6fc4c121f241efae64f38250c",
    cover: "https://api.deezer.com/album/363772797/image",
    genre: "Pop",
  },
  {
    title: "Giant",
    artist: "Calvin Harris",
    id: 614756502,
    release_date: "2019-01-11",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/d/b/f/0/dbfbde29b0b6fcad262558410fcd2985.mp3?hdnea=exp=1763731692~acl=/api/1/1/d/b/f/0/dbfbde29b0b6fcad262558410fcd2985.mp3*~data=user_id=0,application_id=42~hmac=cae245ef0abcbeed1fb31bd9b4f72f21cdd5d334671b79b1504fa2b0050f5ba1",
    cover: "https://api.deezer.com/album/83805552/image",
    genre: "Electro",
  },
  {
    title: "The World I Know",
    artist: "Collective Soul",
    id: 2542612881,
    release_date: "1995-06-13",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/3/0/c/0/30c3fedb7a28f3b4d57a93d87f502dcf.mp3?hdnea=exp=1763731692~acl=/api/1/1/3/0/c/0/30c3fedb7a28f3b4d57a93d87f502dcf.mp3*~data=user_id=0,application_id=42~hmac=d42bdd1e700d761f502864b7c928288c6513c3cd34442062b17ec0893127f061",
    cover: "https://api.deezer.com/album/512664881/image",
    genre: "Pop",
  },
  {
    title: "Don't Call Me Up",
    artist: "Mabel",
    id: 616963582,
    release_date: "2019-01-18",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/6/c/6/0/6c632a2c29c4701994198accbb2434b1.mp3?hdnea=exp=1763731692~acl=/api/1/1/6/c/6/0/6c632a2c29c4701994198accbb2434b1.mp3*~data=user_id=0,application_id=42~hmac=bbff924515224047d2edc412538f101c5aa06b53a13545001d5c4fb40728d86a",
    cover: "https://api.deezer.com/album/84226812/image",
    genre: "Pop",
  },
  {
    title: "Con Calma",
    artist: "Daddy Yankee",
    id: 619949882,
    release_date: "2019-01-24",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/a/a/2/0/aa2358dfb2fa623b5dfbdc1b04e42158.mp3?hdnea=exp=1763731692~acl=/api/1/1/a/a/2/0/aa2358dfb2fa623b5dfbdc1b04e42158.mp3*~data=user_id=0,application_id=42~hmac=3abdbc66cc79bde1680d4d2921cac2b902ebda63c292d157e7ff1c5f81205e0e",
    cover: "https://api.deezer.com/album/84880812/image",
    genre: "Rap/Hip Hop",
  },
  {
    title: "Separated",
    artist: "Avant",
    id: 620269712,
    release_date: "2019-01-25",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/c/a/9/0/ca9ea5852c1f209ef9ca5474dc172b36.mp3?hdnea=exp=1763731692~acl=/api/1/1/c/a/9/0/ca9ea5852c1f209ef9ca5474dc172b36.mp3*~data=user_id=0,application_id=42~hmac=6d5c85bfbae18722b71a55fc8f54f9bbaf834efc2b1a9e9be2b9cc93575860ed",
    cover: "https://api.deezer.com/album/84921032/image",
    genre: "R&B",
  },
  {
    title: "The Hardest Thing",
    artist: "98º",
    id: 620285952,
    release_date: "2019-01-25",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/5/3/2/0/53240a4d237a1a4ad770fd46d4c34898.mp3?hdnea=exp=1763731692~acl=/api/1/1/5/3/2/0/53240a4d237a1a4ad770fd46d4c34898.mp3*~data=user_id=0,application_id=42~hmac=a071a6b70df22add58eda86a7074618b562632e094bf671ce6cc60bfedc03e69",
    cover: "https://api.deezer.com/album/84923282/image",
    genre: "Pop",
  },
  {
    title: "Piece Of Your Heart",
    artist: "MEDUZA",
    id: 623723282,
    release_date: "2019-02-01",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/2aa3a5de3aef945681ee002d3dbde756/250x250-000000-80-0-0.jpg",
    genre: "Dance",
  },
  {
    title: "Applause",
    artist: "Lady Gaga",
    id: 629561092,
    release_date: "2019-02-08",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/2355b9a023e34665e347afa8b53fd9e1/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "7 rings",
    artist: "Ariana Grande",
    id: 629899842,
    release_date: "2019-01-18",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/49e86e935da829b44cb5ffae16826e55/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "break up with your girlfriend, i'm bored",
    artist: "Ariana Grande",
    id: 629899862,
    release_date: "2019-02-08",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/49e86e935da829b44cb5ffae16826e55/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "We R Who We R",
    artist: "Ke$ha",
    id: 630085482,
    release_date: "2010-10-22",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/9bfec16708a9c22fea00707580070014/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Flashing Lights",
    artist: "Kanye West",
    id: 630827302,
    release_date: "2007-10-01",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/8c6578a2099561992fb7544e6826f767/250x250-000000-80-0-0.jpg",
    genre: "Rap/Hip Hop",
  },
  {
    title: "Best I Ever Had",
    artist: "Drake",
    id: 633377802,
    release_date: "2009-02-13",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/55fb57cfe1b96220bc9688a1ede36bd4/250x250-000000-80-0-0.jpg",
    genre: "Rap/Hip Hop",
  },
  {
    title: "Can't Stop This Thing We Started",
    artist: "Bryan Adams",
    id: 638497402,
    release_date: "1991-09-17",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/b7ac3a89574d965e2ea7e735340724e4/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "Please Forgive Me",
    artist: "Bryan Adams",
    id: 638497442,
    release_date: "1993-10-26",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/b7ac3a89574d965e2ea7e735340724e4/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "All Day And Night",
    artist: "Jax Jones",
    id: 653689002,
    release_date: "2019-03-28",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/bb6b4dec86fe2f6af318d69bafa1e54d/250x250-000000-80-0-0.jpg",
    genre: "Dance",
  },
  {
    title: "bad guy",
    artist: "Billie Eilish",
    id: 655095912,
    release_date: "2019-03-29",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/6630083f454d48eadb6a9b53f035d734/250x250-000000-80-0-0.jpg",
    genre: "Alternative",
  },
  {
    title: "when the party's over",
    artist: "Billie Eilish",
    id: 655095962,
    release_date: "2018-10-17",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/6630083f454d48eadb6a9b53f035d734/250x250-000000-80-0-0.jpg",
    genre: "Alternative",
  },
  {
    title: "21 Seconds",
    artist: "So Solid Crew",
    id: 657204592,
    release_date: "2001-08-06",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/c/4/f/0/c4fec1f479942136e48be1728c54aca7.mp3?hdnea=exp=1763730781~acl=/api/1/1/c/4/f/0/c4fec1f479942136e48be1728c54aca7.mp3*~data=user_id=0,application_id=42~hmac=697ddbcf4aa9a03abdf31a0dd04f02ee6c6ba2aa84955b941fbc08c87e0b9477",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/37ec77714bd672c9c41251b810453fcf/250x250-000000-80-0-0.jpg",
    genre: "Rap/Hip Hop",
  },
  {
    title: "Old Town Road (feat. Billy Ray Cyrus) (Remix)",
    artist: "Lil Nas X",
    id: 660051472,
    release_date: "2019-04-05",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/d/7/9/0/d79ca0ab57b16730433f9b53ce6bf599.mp3?hdnea=exp=1763730781~acl=/api/1/1/d/7/9/0/d79ca0ab57b16730433f9b53ce6bf599.mp3*~data=user_id=0,application_id=42~hmac=8ff66a575ae5d99155c5c04bd74328d15e69031cde065a58a4914247aaf15b1e",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/e20107f84c7830f1edfedbbb0dd95201/250x250-000000-80-0-0.jpg",
    genre: "Country",
  },
  {
    title: "Let Me Think About It",
    artist: "Fedde Le Grand",
    id: 661837522,
    release_date: "2007-07-20",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/b/5/d/0/b5d5d2b753f3c979849a03afb671c600.mp3?hdnea=exp=1763730781~acl=/api/1/1/b/5/d/0/b5d5d2b753f3c979849a03afb671c600.mp3*~data=user_id=0,application_id=42~hmac=bf7b809eeda0b63977b9e7c662bde4aa380b9341a8d01e86b64e068b069730c9",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/0657020873c9e293845dad0767777dbc/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Truth Hurts",
    artist: "Lizzo",
    id: 674416352,
    release_date: "2019-04-19",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/3/d/1/0/3d1ef62384b03dbca441b342f33f8e82.mp3?hdnea=exp=1763730781~acl=/api/1/1/3/d/1/0/3d1ef62384b03dbca441b342f33f8e82.mp3*~data=user_id=0,application_id=42~hmac=181a9b68940342e4381de185fa132ab557b89cb499c9c707d5d408201ff30647",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/6ca3ef91da07e9b9a2e9671a6583a01f/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "SOS",
    artist: "Avicii",
    id: 675656892,
    release_date: "2019-06-06",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/5/3/5/0/535c7ed963fe556b7719cea757909ad4.mp3?hdnea=exp=1763730781~acl=/api/1/1/5/3/5/0/535c7ed963fe556b7719cea757909ad4.mp3*~data=user_id=0,application_id=42~hmac=1e49d4f8096ecb4fdbcbb5edda9122655a6e9b65ac552a4da2b9f16d20b05f8f",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/4587f72f5f04f20b033140d578f3758f/250x250-000000-80-0-0.jpg",
    genre: "Dance",
  },
  {
    title: "Party For One",
    artist: "Carly Rae Jepsen",
    id: 678689072,
    release_date: "2019-05-17",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/4/b/b/0/4bb4790815b3aae4b4318f5cd08a1ced.mp3?hdnea=exp=1763730781~acl=/api/1/1/4/b/b/0/4bb4790815b3aae4b4318f5cd08a1ced.mp3*~data=user_id=0,application_id=42~hmac=86e14830015b5609416e45055f64de91e1422b703dda7c8bea0c68ecbd94297e",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/af2306b975e7a762f36dbb37d9e8bc05/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Wish You Well",
    artist: "Sigala",
    id: 680950222,
    release_date: "2019-05-24",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/7/f/0/0/7f00ffa3cc409c3ea27affc66be94977.mp3?hdnea=exp=1763730781~acl=/api/1/1/7/f/0/0/7f00ffa3cc409c3ea27affc66be94977.mp3*~data=user_id=0,application_id=42~hmac=d410ad917140286778374f5dae259331211d74173f2c2e4b4e6957646b9a18b5",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/ea114f4d82187b7aefd0371525bd6b65/250x250-000000-80-0-0.jpg",
    genre: "Dance",
  },
  {
    title: "Post Malone (feat. RANI)",
    artist: "Sam Feldt",
    id: 682799032,
    release_date: "2019-05-24",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/e/9/4/0/e94bae7ee80e8b401b3037bb6c4cb0e4.mp3?hdnea=exp=1763730781~acl=/api/1/1/e/9/4/0/e94bae7ee80e8b401b3037bb6c4cb0e4.mp3*~data=user_id=0,application_id=42~hmac=022fa3a89a3eedf9930c36d2083e2fd44ad69c28d5986861d7686addc185cf0a",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/655b1a09abafa3cf0ed7e5e0593677bb/250x250-000000-80-0-0.jpg",
    genre: "Dance",
  },
  {
    title: "The London (feat. J. Cole & Travis Scott)",
    artist: "Young Thug",
    id: 684538942,
    release_date: "2019-05-23",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/d/5/b/0/d5b8d3e7df0275e5a62f940879005089.mp3?hdnea=exp=1763730781~acl=/api/1/1/d/5/b/0/d5b8d3e7df0275e5a62f940879005089.mp3*~data=user_id=0,application_id=42~hmac=7fe35e7bf8be223ef71ef6a1a90dad8203ccf5ef801d247e824997562ad6aef9",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/35c08dcc0ec7871b020b0591291eb9ef/250x250-000000-80-0-0.jpg",
    genre: "Rap/Hip Hop",
  },
  {
    title: "Ritual",
    artist: "Tiësto",
    id: 685843722,
    release_date: "2019-06-07",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/4/f/7/0/4f7a201c8756efe79018b9b9571031c5.mp3?hdnea=exp=1763730781~acl=/api/1/1/4/f/7/0/4f7a201c8756efe79018b9b9571031c5.mp3*~data=user_id=0,application_id=42~hmac=009ccbc6f8a1b335e26436ab03ada2f5e5c8131f3da5b6467c1e6db8fb11baec",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/5e0101413ddcf2c692b8c81647ff3c9e/250x250-000000-80-0-0.jpg",
    genre: "Dance",
  },
  {
    title: "Never Really Over",
    artist: "Katy Perry",
    id: 687131312,
    release_date: "2019-05-31",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/8/b/9/0/8b933fc96d4a57706ee645b18d1c0ca5.mp3?hdnea=exp=1763730781~acl=/api/1/1/8/b/9/0/8b933fc96d4a57706ee645b18d1c0ca5.mp3*~data=user_id=0,application_id=42~hmac=54de2f2f8c5b435c3a77397935f11317f28ae9e8cc07f939bfd72db9168106d2",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/c1a86211260449a1e893890768735506/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Ransom",
    artist: "Lil Tecca",
    id: 690610892,
    release_date: "2019-06-04",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/3/e/7/0/3e77408aefa012280544dda89bf1e022.mp3?hdnea=exp=1763730781~acl=/api/1/1/3/e/7/0/3e77408aefa012280544dda89bf1e022.mp3*~data=user_id=0,application_id=42~hmac=2a484300ca63b883cc75c7cba0a3d56bd277a4adc759eb6bb8258c85dcea29bc",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/e921ba46a5327b8c165ec407c82740ee/250x250-000000-80-0-0.jpg",
    genre: "Rap/Hip Hop",
  },
  {
    title: "Sucker",
    artist: "Jonas Brothers",
    id: 692002952,
    release_date: "2019-06-07",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/b/f/2/0/bf2472186fb5483b93461e808e345c94.mp3?hdnea=exp=1763730781~acl=/api/1/1/b/f/2/0/bf2472186fb5483b93461e808e345c94.mp3*~data=user_id=0,application_id=42~hmac=ef7fc1aa1705403067d83580d402837ff2c3acdc7625edfe06bd1f4f9cf40cd8",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/89834d35dd6320600b90f044e9bbf467/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "On A Roll",
    artist: "Ashley O",
    id: 696053222,
    release_date: "2019-06-14",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/e/c/4/0/ec4b7de46f2e35255a8409959ec170f1.mp3?hdnea=exp=1763730781~acl=/api/1/1/e/c/4/0/ec4b7de46f2e35255a8409959ec170f1.mp3*~data=user_id=0,application_id=42~hmac=dba3ee37f873bb38a2c9ea5339d38af0c0f39baa69faa757ba28972fbf558acd",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/a488df725503905cba5dd0d239533676/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Nothing Breaks Like a Heart (feat. Miley Cyrus)",
    artist: "Mark Ronson",
    id: 696580272,
    release_date: "2019-06-21",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/2/0/0/0/20001debb581a27fa57bb559a9b98322.mp3?hdnea=exp=1763730781~acl=/api/1/1/2/0/0/0/20001debb581a27fa57bb559a9b98322.mp3*~data=user_id=0,application_id=42~hmac=fd6de935f25e2f504ea537a8965388524ef6e5d035a70addd0ed2f5cd54531d0",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/20c1edddaf2d221052f0989623663a38/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Señorita",
    artist: "Shawn Mendes",
    id: 698905582,
    release_date: "2019-06-21",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/5/9/3/0/5930dfc69d00f718d90a65d56b9ddd0a.mp3?hdnea=exp=1763730781~acl=/api/1/1/5/9/3/0/5930dfc69d00f718d90a65d56b9ddd0a.mp3*~data=user_id=0,application_id=42~hmac=1b8a4617e68b7041f612c91aaac4fc624fa647ca37c73a3a9c1bf85891bab3db",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/4426e8a06d8d0cd96263094c6178bbf9/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Old Town Road",
    artist: "Lil Nas X",
    id: 699056262,
    release_date: "2019-06-21",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/d/e/2/0/de20d4587b2a569f18ce012e38bc776e.mp3?hdnea=exp=1763730781~acl=/api/1/1/d/e/2/0/de20d4587b2a569f18ce012e38bc776e.mp3*~data=user_id=0,application_id=42~hmac=4c56b42bf52ba7416804ac09349468ca1da0d513e7a5cf556045660be6c399eb",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/3cfd6900fd2b342ec0e478faf300f6a2/250x250-000000-80-0-0.jpg",
    genre: "Alternative",
  },
  {
    title: "Instagram",
    artist: "David Guetta",
    id: 699922432,
    release_date: "2019-07-05",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/7/1/5/0/715fb9d042dee1be007a272df6fa5913.mp3?hdnea=exp=1763730781~acl=/api/1/1/7/1/5/0/715fb9d042dee1be007a272df6fa5913.mp3*~data=user_id=0,application_id=42~hmac=efde9159182750483b600d240ed70061f87ade68ff88dba3cfa9b91105f86c94",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/f693c75e8953597f8b667d3bc4889560/250x250-000000-80-0-0.jpg",
    genre: "Electro",
  },
  {
    title: "Higher Love",
    artist: "Kygo",
    id: 701281342,
    release_date: "2019-06-28",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/f/9/6/0/f964ee57f9795ea09789426ef738a8dc.mp3?hdnea=exp=1763730781~acl=/api/1/1/f/9/6/0/f964ee57f9795ea09789426ef738a8dc.mp3*~data=user_id=0,application_id=42~hmac=182fe73703f61f3a16a62033006181b6c7077f84bcda823e8a1563ff894cab12",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/5f45ec14c6cc67e1428a60e3548be46c/250x250-000000-80-0-0.jpg",
    genre: "Dance",
  },
  {
    title: "Lalala",
    artist: "Y2K",
    id: 703842302,
    release_date: "2019-06-27",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/3/a/e/0/3ae584fbfa7e6a4d7272e945882b53ac.mp3?hdnea=exp=1763730781~acl=/api/1/1/3/a/e/0/3ae584fbfa7e6a4d7272e945882b53ac.mp3*~data=user_id=0,application_id=42~hmac=cb55591b21922f4ed72dd671c998b9bd8baaa63db5e51fd73941e44601696cd0",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/57f9e0aa71f8831dc2150fa8e281496f/250x250-000000-80-0-0.jpg",
    genre: "Rap/Hip Hop",
  },
  {
    title: "One Day / Reckoning Song (Wankelmut Remix)",
    artist: "Asaf Avidan",
    id: 705022722,
    release_date: "2012-08-03",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/3/f/6/0/3f62634a63ae67f9c6fc745042ee3192.mp3?hdnea=exp=1763730781~acl=/api/1/1/3/f/6/0/3f62634a63ae67f9c6fc745042ee3192.mp3*~data=user_id=0,application_id=42~hmac=09fcf5dc5aedaf0e06633254c8576db26210cbdfd092cc5d18f07ba30e99cc3a",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/758c53b7f72dbfbed8c5ffc882bf6a7c/250x250-000000-80-0-0.jpg",
    genre: "Electro",
  },
  {
    title: "Ride It",
    artist: "Regard",
    id: 708907602,
    release_date: "2019-07-26",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/e/9/b/0/e9b52ce769c059d3c9527ddc9b128990.mp3?hdnea=exp=1763730781~acl=/api/1/1/e/9/b/0/e9b52ce769c059d3c9527ddc9b128990.mp3*~data=user_id=0,application_id=42~hmac=80e6c79886cb600ea5b5e662d275ade5b05dc1acae017fc9f910957a9b4b257d",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/c7abf65b190c825054f29b55372619b3/250x250-000000-80-0-0.jpg",
    genre: "Dance",
  },
  {
    title: "Beautiful People (feat. Khalid)",
    artist: "Ed Sheeran",
    id: 710164302,
    release_date: "2019-07-12",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/0/c/b/0/0cbb768840bb5712958367339f5eec8a.mp3?hdnea=exp=1763730781~acl=/api/1/1/0/c/b/0/0cbb768840bb5712958367339f5eec8a.mp3*~data=user_id=0,application_id=42~hmac=fa7ffce65f40b5b2df18422ddc15dfb48394a4ea3d03141808c943fdf37e396d",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/1d809f545fb9ecea849cf45fc8bcc681/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "I Don't Care",
    artist: "Ed Sheeran",
    id: 710164352,
    release_date: "2019-05-10",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/2/9/4/0/2947ed413d210287df1e53c14e5a9250.mp3?hdnea=exp=1763730781~acl=/api/1/1/2/9/4/0/2947ed413d210287df1e53c14e5a9250.mp3*~data=user_id=0,application_id=42~hmac=62d0dfc2581c99fb2093c717c8c309867fa09ff49dc8069e467320fd667a1b42",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/1d809f545fb9ecea849cf45fc8bcc681/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Killer",
    artist: "Adamski",
    id: 712072122,
    release_date: "1989-07-29",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/6/d/4/0/6d4eee1ffb6f51e7c450265038464db4.mp3?hdnea=exp=1763730781~acl=/api/1/1/6/d/4/0/6d4eee1ffb6f51e7c450265038464db4.mp3*~data=user_id=0,application_id=42~hmac=e0e828ff204c2c074647eb8bae555951c605f231f540e50ba1fe6ffb5717d455",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/9dc3e8c756bd3e9c6aad4a85cae47f07/250x250-000000-80-0-0.jpg",
    genre: "Dance",
  },
  {
    title: "How Do You Sleep?",
    artist: "Sam Smith",
    id: 712113642,
    release_date: "2019-07-19",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/d/f/c/0/dfcc69946589929cc7c7becc98808872.mp3?hdnea=exp=1763730781~acl=/api/1/1/d/f/c/0/dfcc69946589929cc7c7becc98808872.mp3*~data=user_id=0,application_id=42~hmac=f04635081d75e01d8e85fff70b8698f874dfe913d006ff1f66e24c4e4c14ab43",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/8e20716603c6d72c5d15cb3f9f013108/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Like You",
    artist: "Ghita",
    id: 713044362,
    release_date: "2019-07-19",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/8751a1ab31ff71aa283bc1127d1f6001/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "China",
    artist: "Anuel AA",
    id: 714210042,
    release_date: "2019-07-19",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/c/0/4/0/c042c8d32a0252bb683d8964bd5a19fc.mp3?hdnea=exp=1763730781~acl=/api/1/1/c/0/4/0/c042c8d32a0252bb683d8964bd5a19fc.mp3*~data=user_id=0,application_id=42~hmac=710353a49b8f37f440dd5fe3895dd6cdfb0b88c30992ff67b81d6963631ce046",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/9792592cb08a52adafe49e0d93c5c177/250x250-000000-80-0-0.jpg",
    genre: "Latin Music",
  },
  {
    title: "Where Does My Heart Beat Now",
    artist: "Céline Dion",
    id: 714264732,
    release_date: "1990-04-02",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/8/c/e/0/8cec9f22a6acd3ac9f52d0debd36a3b2.mp3?hdnea=exp=1763730781~acl=/api/1/1/8/c/e/0/8cec9f22a6acd3ac9f52d0debd36a3b2.mp3*~data=user_id=0,application_id=42~hmac=78d33cfe9aec1e1e9254e0bd6f251f659cb39e2860b4a4d6d4baaff1bcc97631",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/ddd1746ade549a4a86cc4d4cf12cba52/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Loco Contigo",
    artist: "DJ Snake",
    id: 716383902,
    release_date: "2019-07-25",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/5/5/e/0/55e3a25c84f109d6ee75fe904abdc8b7.mp3?hdnea=exp=1763730781~acl=/api/1/1/5/5/e/0/55e3a25c84f109d6ee75fe904abdc8b7.mp3*~data=user_id=0,application_id=42~hmac=d81ee37ea397e41e711299d3c1ac8cdb151d165279d68c811758b1c5302d5c95",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/8d55951e5b20dbb211998d29be970be2/250x250-000000-80-0-0.jpg",
    genre: "Dance",
  },
  {
    title: "Innuendo",
    artist: "Queen",
    id: 716513502,
    release_date: "1991-07-26",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/4/5/2/0/452e95c505c673ab61c8e501b434e239.mp3?hdnea=exp=1763730781~acl=/api/1/1/4/5/2/0/452e95c505c673ab61c8e501b434e239.mp3*~data=user_id=0,application_id=42~hmac=d090b6f08d7e2dfe42dee0b4fa9e4af7232a70694bd7a3ba8d234c33f57d8f52",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/780b4f2e2ed49cafc20e88c029062c2c/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "The Show Must Go On",
    artist: "Queen",
    id: 716513602,
    release_date: "2019-07-26",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/e/8/6/0/e86ba3c4f30a9a369dd5870260e9ee64.mp3?hdnea=exp=1763730781~acl=/api/1/1/e/8/6/0/e86ba3c4f30a9a369dd5870260e9ee64.mp3*~data=user_id=0,application_id=42~hmac=6dcf2fb2cd36b542fe0c77dd058abaa3d726377f0e711ad6eba2e3be469df87f",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/780b4f2e2ed49cafc20e88c029062c2c/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "Hot Girl Summer (feat. Nicki Minaj & Ty Dolla $ign)",
    artist: "Megan Thee Stallion",
    id: 726785832,
    release_date: "2019-08-09",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/4/9/1/0/491a642198d3bc3fb36fe861e67c7234.mp3?hdnea=exp=1763730781~acl=/api/1/1/4/9/1/0/491a642198d3bc3fb36fe861e67c7234.mp3*~data=user_id=0,application_id=42~hmac=122cdb54c1d71dca07c9c40373840bca4c43260eb855017916b88f636ffbda86",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/fc456b76e9ce22a1ec5ec1cdb3f25721/250x250-000000-80-0-0.jpg",
    genre: "Rap/Hip Hop",
  },
  {
    title: "Dance Monkey",
    artist: "Tones And I",
    id: 727924692,
    release_date: "2019-08-08",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/b/5/9/0/b59d3c5a5127030c2d7255c557405f69.mp3?hdnea=exp=1763730781~acl=/api/1/1/b/5/9/0/b59d3c5a5127030c2d7255c557405f69.mp3*~data=user_id=0,application_id=42~hmac=e23f212c213339dd59e36cad9acead1e6384bbe211dd0f0d7dc75adc781ff835",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/3d7b540eb85c84a37cd5bf53740991cb/250x250-000000-80-0-0.jpg",
    genre: "Alternative",
  },
  {
    title: "Yo x Ti, Tu x Mi",
    artist: "ROSALÍA",
    id: 731498882,
    release_date: "2019-08-15",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/a/b/3/0/ab3c26c46ff680e8f020c60703210c35.mp3?hdnea=exp=1763730781~acl=/api/1/1/a/b/3/0/ab3c26c46ff680e8f020c60703210c35.mp3*~data=user_id=0,application_id=42~hmac=893b082477ff1a074bac23e4f052a2efaecaa39294f8ca16c324cc304d730eb8",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/536c7d0c86cc2a779c0f63b12c616ee7/250x250-000000-80-0-0.jpg",
    genre: "Latin Music",
  },
  {
    title: "hot girl bummer",
    artist: "blackbear",
    id: 734497752,
    release_date: "2019-08-23",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/45027772023daecc4ad704e7eb6be50b/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Poker Face",
    artist: "Lady Gaga",
    id: 734508762,
    release_date: "2008-09-23",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/2/3/3/0/233fe3a96cf1654b2cf30be68cb94624.mp3?hdnea=exp=1763730782~acl=/api/1/1/2/3/3/0/233fe3a96cf1654b2cf30be68cb94624.mp3*~data=user_id=0,application_id=42~hmac=9af1310fed074589806f1934dbca60c61036ebb9b83699cf7b6817fc247b2454",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/fad7de079aa103d60ec1e2d1582c2281/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Teeth",
    artist: "5 Seconds of Summer",
    id: 737208652,
    release_date: "2019-08-23",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/6/7/9/0/6793c9670fb51e0d1c93d5c684e0098d.mp3?hdnea=exp=1763730782~acl=/api/1/1/6/7/9/0/6793c9670fb51e0d1c93d5c684e0098d.mp3*~data=user_id=0,application_id=42~hmac=37ff6d4da54d397f2355183ab1744e9455c20ac47e28a23ceea612d575432e55",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/5fc9e57d4d48014e1cc68e574d532299/250x250-000000-80-0-0.jpg",
    genre: "Films/Games",
  },
  {
    title: "Lover",
    artist: "Taylor Swift",
    id: 737967302,
    release_date: "2019-08-23",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/6/8/6/0/686483dedc83fe46be5c1f4d02739e03.mp3?hdnea=exp=1763730782~acl=/api/1/1/6/8/6/0/686483dedc83fe46be5c1f4d02739e03.mp3*~data=user_id=0,application_id=42~hmac=a216bf87d4a56b97d171c62385331ca3be6df42984fb8ddb72383014af9944ff",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/6111c5ab9729c8eac47883e4e50e9cf8/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "You Need To Calm Down",
    artist: "Taylor Swift",
    id: 737967412,
    release_date: "2019-08-23",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/2/c/b/0/2cb4062c72c6b741dffb32995f1f8ba5.mp3?hdnea=exp=1763730782~acl=/api/1/1/2/c/b/0/2cb4062c72c6b741dffb32995f1f8ba5.mp3*~data=user_id=0,application_id=42~hmac=f4ea397b41b61da938053092677f3f8e6c693d6cc4c8231b56b61a4f5c8ac36c",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/6111c5ab9729c8eac47883e4e50e9cf8/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Never Seen The Rain",
    artist: "Tones And I",
    id: 739870832,
    release_date: "2019-08-29",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/e/8/7/0/e87f2a93817ab2924047ec4c7fc8a32f.mp3?hdnea=exp=1763730782~acl=/api/1/1/e/8/7/0/e87f2a93817ab2924047ec4c7fc8a32f.mp3*~data=user_id=0,application_id=42~hmac=be9762309f0b70dbf6df56d19b9493a0c601dc50e9cea5f6856d3bdf229b9867",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/5636a569737f8dad9a928f3d907c493a/250x250-000000-80-0-0.jpg",
    genre: "Alternative",
  },
  {
    title: "Circles",
    artist: "Post Malone",
    id: 742744952,
    release_date: "2019-08-30",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/9/8/4/0/9849c9775670a9f7058f799a0d704df9.mp3?hdnea=exp=1763730782~acl=/api/1/1/9/8/4/0/9849c9775670a9f7058f799a0d704df9.mp3*~data=user_id=0,application_id=42~hmac=6996877c47c307dbb5d67512b70468716cf9c043d5da250d8071c5f301e1c913",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/6fb46005a49df7aeba49f1ca117f3710/250x250-000000-80-0-0.jpg",
    genre: "Rap/Hip Hop",
  },
  {
    title: "Wanted",
    artist: "OneRepublic",
    id: 743847102,
    release_date: "2019-09-06",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/b/4/4/0/b440e2396e63432f0538b02b8ac316db.mp3?hdnea=exp=1763730782~acl=/api/1/1/b/4/4/0/b440e2396e63432f0538b02b8ac316db.mp3*~data=user_id=0,application_id=42~hmac=579c21008bb102b279d94925630663dce394dd5ab4e9e9fcd44b38287aafce9e",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/68d9911b5aacde47ea07ab9bdef72f6b/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Liar",
    artist: "Camila Cabello",
    id: 744266592,
    release_date: "2019-09-04",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/1/2/c/0/12c86fcfac20ab646ead67d2d7973430.mp3?hdnea=exp=1763730782~acl=/api/1/1/1/2/c/0/12c86fcfac20ab646ead67d2d7973430.mp3*~data=user_id=0,application_id=42~hmac=ea196d32206864c98afb8dbed0801fc9b11caf43e2e111938527e6358a74acba",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/25cd3ea786c37a421a3950d8ba3f35cf/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Goodbyes",
    artist: "Post Malone",
    id: 747399432,
    release_date: "2019-09-06",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/c/3/3/0/c334f5e70fc12a61401f0560853a81d4.mp3?hdnea=exp=1763730782~acl=/api/1/1/c/3/3/0/c334f5e70fc12a61401f0560853a81d4.mp3*~data=user_id=0,application_id=42~hmac=a56324d3775ccc4a509186d15ed34b1c29d4f34ed18fc43a5152774016de312b",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/4642b8e3e0a89f92a6e2bfed13d8f31c/250x250-000000-80-0-0.jpg",
    genre: "Rap/Hip Hop",
  },
  {
    title: "Heartbreak Hotel (feat. Faith Evans & Kelly Price)",
    artist: "Whitney Houston",
    id: 747726862,
    release_date: "2000-05-16",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/68e683629703c4602fa5c0dde472a843/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Graveyard",
    artist: "Halsey",
    id: 750145322,
    release_date: "2019-09-13",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/97df2575e251a12aaa4aca7f632411b5/250x250-000000-80-0-0.jpg",
    genre: "Alternative",
  },
  {
    title: "Stack It Up",
    artist: "Liam Payne",
    id: 754038312,
    release_date: "2019-09-18",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/2/e/6/0/2e62264470b131363f7d3565bc709cf1.mp3?hdnea=exp=1763730782~acl=/api/1/1/2/e/6/0/2e62264470b131363f7d3565bc709cf1.mp3*~data=user_id=0,application_id=42~hmac=28db817202d16c888702c5cfe9dda2035b5f02ad213a7bfae6e11e3b2ef33079",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/bf48daea99c1d5c92512a10189af5509/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Memories",
    artist: "Maroon 5",
    id: 755405702,
    release_date: "2019-09-20",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/8/d/e/0/8dee94e67b8d404df8b7ab8afce5f795.mp3?hdnea=exp=1763730782~acl=/api/1/1/8/d/e/0/8dee94e67b8d404df8b7ab8afce5f795.mp3*~data=user_id=0,application_id=42~hmac=2281a4be49bc6758c623cade966cd112566f133d7f3a207db0db96a403ba9d21",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/535b9b868b048d4c9ee460f1c0120365/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Trampoline",
    artist: "SHAED",
    id: 759831102,
    release_date: "2019-09-26",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/55fbdbd22ff0bfdacbc354b727564961/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Playing Games",
    artist: "Summer Walker",
    id: 765794412,
    release_date: "2019-10-04",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/1/5/f/0/15fedec3970d50e2e2936feeac5a1fa9.mp3?hdnea=exp=1763730782~acl=/api/1/1/1/5/f/0/15fedec3970d50e2e2936feeac5a1fa9.mp3*~data=user_id=0,application_id=42~hmac=cbe325006aaa858fc584ddf492ee7f4d6a65112961ac9dc62a48248cf7f1e457",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/b63fec3a3108a1a346cc27a51af6c840/250x250-000000-80-0-0.jpg",
    genre: "R&B",
  },
  {
    title: "Outnumbered",
    artist: "Dermot Kennedy",
    id: 765796912,
    release_date: "2019-10-04",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/7/b/0/0/7b026c6143e54b3747450c704fa2fbfd.mp3?hdnea=exp=1763730492~acl=/api/1/1/7/b/0/0/7b026c6143e54b3747450c704fa2fbfd.mp3*~data=user_id=0,application_id=42~hmac=b36716c84987968ed8503908187b8fbb6ec26becd37a031514a39003f14859c7",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/fc120d55b9340ff8057028d19859fe0c/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Do Me!",
    artist: "Bell Biv DeVoe",
    id: 765887532,
    release_date: "1990-02-20",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/8/b/5/0/8b5b05dad0a67d0217f1347212df7d98.mp3?hdnea=exp=1763730492~acl=/api/1/1/8/b/5/0/8b5b05dad0a67d0217f1347212df7d98.mp3*~data=user_id=0,application_id=42~hmac=74635f76bfac3e65c8f8e04b0bad78fd4a5710c2b8b9674a9777cdbc66f520a2",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/9b13732b4372ea0d63801c910d993992/250x250-000000-80-0-0.jpg",
    genre: "R&B",
  },
  {
    title: "HIGHEST IN THE ROOM",
    artist: "Travis Scott",
    id: 767583072,
    release_date: "2019-10-04",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/2/7/1/0/2719bbd3dad355b7c5e7f32be24a5cfe.mp3?hdnea=exp=1763730492~acl=/api/1/1/2/7/1/0/2719bbd3dad355b7c5e7f32be24a5cfe.mp3*~data=user_id=0,application_id=42~hmac=c0a91faff6f159b2956f0673e106c329e93676b091965e622a33d824cfecf602",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/5fa05e7d74819963577a92a8c6ad4979/250x250-000000-80-0-0.jpg",
    genre: "Rap/Hip Hop",
  },
  {
    title: "Lose Control",
    artist: "MEDUZA",
    id: 769757652,
    release_date: "2019-10-11",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/9/c/5/0/9c543729d3c5937beed10f14a00a7f6b.mp3?hdnea=exp=1763730492~acl=/api/1/1/9/c/5/0/9c543729d3c5937beed10f14a00a7f6b.mp3*~data=user_id=0,application_id=42~hmac=2b9857074d5a0ab56b2108d5d4364aa439e8b01bd36ef67a5611004cef8a1d12",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/453595cce92efa85b6cade031f59cad6/250x250-000000-80-0-0.jpg",
    genre: "Dance",
  },
  {
    title: "The Git Up",
    artist: "Blanco Brown",
    id: 770754302,
    release_date: "2019-10-11",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/e/8/c/0/e8c408463623c7650458bda4e7a10658.mp3?hdnea=exp=1763730492~acl=/api/1/1/e/8/c/0/e8c408463623c7650458bda4e7a10658.mp3*~data=user_id=0,application_id=42~hmac=4f968ab26fb586a7cddeef447aa08e5b0dbc52f908d35712ccd9331ef35f436e",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/a578fd926bb27ae3a35b8d8bbd5ec7d9/250x250-000000-80-0-0.jpg",
    genre: "Country",
  },
  {
    title: "RITMO (Bad Boys For Life)",
    artist: "The Black Eyed Peas",
    id: 772603752,
    release_date: "2019-10-12",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/b/7/2/0/b72a1f6e5111cf6f079e2d170f4b8d65.mp3?hdnea=exp=1763730492~acl=/api/1/1/b/7/2/0/b72a1f6e5111cf6f079e2d170f4b8d65.mp3*~data=user_id=0,application_id=42~hmac=d27ae5237a4c7716fef650bb5d7764984eae2b1eb699189779981786be354055",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/39e98d2bd759fe5bf9dc95d0e8553424/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Make It Right (feat. Lauv)",
    artist: "BTS",
    id: 776433672,
    release_date: "2019-10-18",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/e5740689303d6abea5bd387387566bce/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Lose You To Love Me",
    artist: "Selena Gomez",
    id: 782281832,
    release_date: "2019-10-23",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/c/e/c/0/cec0aad4420cea10503e3fd11aac77e3.mp3?hdnea=exp=1763730492~acl=/api/1/1/c/e/c/0/cec0aad4420cea10503e3fd11aac77e3.mp3*~data=user_id=0,application_id=42~hmac=aa138dc546de885378882ef0fa6a7dd2f3430ba77991eee8e537f17754c4dcda",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/86193ca4aafbb86708b8040a25c22d51/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "What Hurts The Most",
    artist: "Rascal Flatts",
    id: 783033602,
    release_date: "2006-07-22",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/3a33e99fdcbbf7db5a0361afd6ce4250/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Takeaway (feat. Lennon Stella)",
    artist: "The Chainsmokers",
    id: 794938292,
    release_date: "2019-11-08",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/7/f/0/0/7f0d20dbf707af7062d6db218ffdeb24.mp3?hdnea=exp=1763730492~acl=/api/1/1/7/f/0/0/7f0d20dbf707af7062d6db218ffdeb24.mp3*~data=user_id=0,application_id=42~hmac=0534d99d1118c9ac98dfd7f91272979ce77c4f3de44c4f305012dc04711d0ecb",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/32d3144799e5f4790c59161e7750e111/250x250-000000-80-0-0.jpg",
    genre: "Dance",
  },
  {
    title: "Tusa",
    artist: "KAROL G",
    id: 796342592,
    release_date: "2019-11-08",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/2/9/5/0/295fb558a4b893d959b8a985d12a38b7.mp3?hdnea=exp=1763730492~acl=/api/1/1/2/9/5/0/295fb558a4b893d959b8a985d12a38b7.mp3*~data=user_id=0,application_id=42~hmac=7aa432f735aacb085de5b10af30699bdc78e711044974d49094b8af58e30028c",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/7f4412829dda081518fcad597601c778/250x250-000000-80-0-0.jpg",
    genre: "Rap/Hip Hop",
  },
  {
    title: "Say So",
    artist: "Doja Cat",
    id: 797228462,
    release_date: "2019-11-07",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/6/d/a/0/6da69886017c24595749d63483910d85.mp3?hdnea=exp=1763730492~acl=/api/1/1/6/d/a/0/6da69886017c24595749d63483910d85.mp3*~data=user_id=0,application_id=42~hmac=c33f0442ef9ce5f3ec1a5acf66211ec264cf0bbb6da927fb7dcce1b30196f0eb",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/1e0d4359a328f8b0ea3563e8623a09aa/250x250-000000-80-0-0.jpg",
    genre: "R&B",
  },
  {
    title: "It's You",
    artist: "Ali Gatie",
    id: 797479512,
    release_date: "2019-11-08",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/1/f/1/0/1f199c7f7cfe3af694b45c5a65f03521.mp3?hdnea=exp=1763730492~acl=/api/1/1/1/f/1/0/1f199c7f7cfe3af694b45c5a65f03521.mp3*~data=user_id=0,application_id=42~hmac=7fb6ed5da13819b306c96b6e1fe59587ae3df88074a3d3d0b12e8f6424ed2570",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/9bd3c2d43ebdb7676b705e96df91ed82/250x250-000000-80-0-0.jpg",
    genre: "R&B",
  },
  {
    title: "everything i wanted",
    artist: "Billie Eilish",
    id: 803010392,
    release_date: "2019-11-13",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/4/2/1/0/42180bc4b6e5347d1c6abb557501a110.mp3?hdnea=exp=1763730492~acl=/api/1/1/4/2/1/0/42180bc4b6e5347d1c6abb557501a110.mp3*~data=user_id=0,application_id=42~hmac=e9dd46a018f65f381f1d6a171ccd601ba97af5aa2b40c9be7ab6c6b9e8468bda",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/0da7f3792b522921eb9aa5a44f0a4ce7/250x250-000000-80-0-0.jpg",
    genre: "Alternative",
  },
  {
    title: "ROXANNE",
    artist: "Arizona Zervas",
    id: 806698322,
    release_date: "2019-10-10",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/7/b/1/0/7b117cdc7b7316066a9d1391e72684ce.mp3?hdnea=exp=1763730492~acl=/api/1/1/7/b/1/0/7b117cdc7b7316066a9d1391e72684ce.mp3*~data=user_id=0,application_id=42~hmac=e1a44e6784395a17920fa352d6f993b71979a41e6863e32588fa8b361fd61e6d",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/1306297f553065dfd70701837045b41f/250x250-000000-80-0-0.jpg",
    genre: "Rap/Hip Hop",
  },
  {
    title: "Before You Go",
    artist: "Lewis Capaldi",
    id: 807205422,
    release_date: "2019-11-19",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/d/a/4/0/da4564a79ddd1d91a002fec8f7be6263.mp3?hdnea=exp=1763730492~acl=/api/1/1/d/a/4/0/da4564a79ddd1d91a002fec8f7be6263.mp3*~data=user_id=0,application_id=42~hmac=6984a41068dbc093c082f321ea72b386d014fd770ed26b14bd1623e9feff3fce",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/327a13284c291832cf01622a414847c9/250x250-000000-80-0-0.jpg",
    genre: "Alternative",
  },
  {
    title: "Better Off Alone",
    artist: "Alice Deejay",
    id: 810585662,
    release_date: "2019-11-22",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/ec8f13cfcd69cf0c98c2830b7c4308f4/250x250-000000-80-0-0.jpg",
    genre: "Dance",
  },
  {
    title: "Baila Baila Baila",
    artist: "Ozuna",
    id: 820200292,
    release_date: "2019-11-29",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/a/e/5/0/ae5a76e49c5911c6b4e92d74d3f9c6e1.mp3?hdnea=exp=1763730492~acl=/api/1/1/a/e/5/0/ae5a76e49c5911c6b4e92d74d3f9c6e1.mp3*~data=user_id=0,application_id=42~hmac=071320295aa8cd118250fc67bb27fb1ccbb33137f443c6e7d3a29878765134d5",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/53a787af01844391a3f59f2dc1b59e9a/250x250-000000-80-0-0.jpg",
    genre: "Latin Music",
  },
  {
    title: "Nothin' My Love Can't Fix",
    artist: "Joey Lawrence",
    id: 822662142,
    release_date: "2019-12-06",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/a/c/7/0/ac7c91e0822ccf1d3f27b643ae7d2740.mp3?hdnea=exp=1763730492~acl=/api/1/1/a/c/7/0/ac7c91e0822ccf1d3f27b643ae7d2740.mp3*~data=user_id=0,application_id=42~hmac=7b7779fe1f3ac155a7585e4f01f6ff06b8e0b84acc2e2fe75639d640c8010bda",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/ec0c708c0fc944a27eb7778a6b82c9bd/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "The Box",
    artist: "Roddy Ricch",
    id: 825986992,
    release_date: "2019-12-06",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/a/6/9/0/a69a4cc3f399e48765dfea7eca17af9e.mp3?hdnea=exp=1763730492~acl=/api/1/1/a/6/9/0/a69a4cc3f399e48765dfea7eca17af9e.mp3*~data=user_id=0,application_id=42~hmac=c3d70d399c97a50992f42b50255ece2973e08a88589ff5d43c18600258c402df",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/4cecb47ae25837b9dd022004b5cacbdc/250x250-000000-80-0-0.jpg",
    genre: "Rap/Hip Hop",
  },
  {
    title: "Alone, Pt. II",
    artist: "Alan Walker",
    id: 829185532,
    release_date: "2019-12-27",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/5950c85f789a083d4be4dfaba9054483/250x250-000000-80-0-0.jpg",
    genre: "Electro",
  },
  {
    title: "Watermelon Sugar",
    artist: "Harry Styles",
    id: 830336922,
    release_date: "2019-12-13",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/346c524c15ecccbc4a8a78e8972a352c/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Adore You",
    artist: "Harry Styles",
    id: 830336932,
    release_date: "2019-12-13",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/346c524c15ecccbc4a8a78e8972a352c/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Breaking Me",
    artist: "Topic",
    id: 831917182,
    release_date: "2019-12-19",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/bb227e15bc9947de08a5ae26e62bb3b7/250x250-000000-80-0-0.jpg",
    genre: "Dance",
  },
  {
    title: "Another Chance",
    artist: "Roger Sanchez",
    id: 839264762,
    release_date: "2001-07-30",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/2cd34219232eb3122b5c8a700e65284f/250x250-000000-80-0-0.jpg",
    genre: "Electro",
  },
  {
    title: "Life Is Good (feat. Drake)",
    artist: "Future",
    id: 847699482,
    release_date: "2020-01-09",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/b37cb4509f1e4bb8a4a4dfa5e55c4a8c/250x250-000000-80-0-0.jpg",
    genre: "Rap/Hip Hop",
  },
  {
    title: "Pray",
    artist: "Take That",
    id: 848872242,
    release_date: "1993-10-25",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/0068fc2123277ef700493d6fa6c0fc34/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Relight My Fire (feat. Lulu)",
    artist: "Take That",
    id: 848872262,
    release_date: "1993-10-25",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/0068fc2123277ef700493d6fa6c0fc34/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Babe",
    artist: "Take That",
    id: 848872352,
    release_date: "1993-10-25",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/0068fc2123277ef700493d6fa6c0fc34/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Heartless",
    artist: "Diplo",
    id: 862201652,
    release_date: "2020-01-31",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/25c25645b8bb7772d47219498f5792ac/250x250-000000-80-0-0.jpg",
    genre: "Country",
  },
  {
    title: "Know Your Worth",
    artist: "Khalid",
    id: 862847042,
    release_date: "2020-02-04",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/34cb1dcadca75c2d57a4a2bcb2d9f0fd/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "death bed (coffee for your head)",
    artist: "Powfu",
    id: 871124582,
    release_date: "2020-02-08",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/85380bbb010f1b675c29ac06c6e343ea/250x250-000000-80-0-0.jpg",
    genre: "Rap/Hip Hop",
  },
  {
    title: "Love to Hate You",
    artist: "Erasure",
    id: 874017852,
    release_date: "1991-10-14",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/c22d746953becdab3e08d57b51b45d1d/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Intentions",
    artist: "Justin Bieber",
    id: 876196932,
    release_date: "2020-02-14",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/8d54ffac647e9e40cd91686c8a906de6/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Yummy",
    artist: "Justin Bieber",
    id: 876196942,
    release_date: "2020-01-03",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/8d54ffac647e9e40cd91686c8a906de6/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "ily (i love you baby)",
    artist: "Surf Mesa",
    id: 886766742,
    release_date: "2020-02-25",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/81533216382c3957b8a3fda95105c7b9/250x250-000000-80-0-0.jpg",
    genre: "Dance",
  },
  {
    title: "Make It Rain",
    artist: "Fat Joe",
    id: 890568262,
    release_date: "2006-11-14",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/a1d933af006a1bb717061ae8f12269bd/250x250-000000-80-0-0.jpg",
    genre: "Rap/Hip Hop",
  },
  {
    title: "Kings & Queens",
    artist: "Ava Max",
    id: 899198132,
    release_date: "2020-03-12",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/996c48926ead8a54c1d90db4e9b109fe/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Blinding Lights",
    artist: "The Weeknd",
    id: 908604612,
    release_date: "2020-03-20",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/fd00ebd6d30d7253f813dba3bb1c66a9/250x250-000000-80-0-0.jpg",
    genre: "R&B",
  },
  {
    title: "How Do You Do!",
    artist: "Roxette",
    id: 912373352,
    release_date: "1992-08-31",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/8c70da2cd385c01c7c90bf185ae350a1/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Almost Unreal",
    artist: "Roxette",
    id: 912428852,
    release_date: "1994-04-11",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/971b587c788d73cdcb99eecb1ea9a846/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Fading Like A Flower (Every Time You Leave)",
    artist: "Roxette",
    id: 913092212,
    release_date: "1991-04-02",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/2e9452ee63b87b6affd59d24ffbf5c31/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Spending My Time",
    artist: "Roxette",
    id: 913092232,
    release_date: "1991-04-02",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/2e9452ee63b87b6affd59d24ffbf5c31/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Toosie Slide",
    artist: "Drake",
    id: 919708552,
    release_date: "2020-04-03",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/d2216c368d2223ebf839fa09cd90c150/250x250-000000-80-0-0.jpg",
    genre: "Rap/Hip Hop",
  },
  {
    title: "Sensitivity",
    artist: "Ralph Tresvant",
    id: 921943172,
    release_date: "1990-12-10",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/5f86d1fcf9056bae9ed99deab09fa7be/250x250-000000-80-0-0.jpg",
    genre: "R&B",
  },
  {
    title: "My, My, My",
    artist: "Johnny Gill",
    id: 921971922,
    release_date: "1990-04-10",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/4b99eac10ba88cb1de078f001accf9b9/250x250-000000-80-0-0.jpg",
    genre: "R&B",
  },
  {
    title: "you broke me first",
    artist: "Tate McRae",
    id: 929158322,
    release_date: "2020-04-17",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/e98a0f036dce1ff55a2b1bcb9bff3dc3/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "ROCKSTAR",
    artist: "DaBaby",
    id: 932661672,
    release_date: "2020-04-17",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/945d96da8abf5a9457974d83298ee384/250x250-000000-80-0-0.jpg",
    genre: "Rap/Hip Hop",
  },
  {
    title: "Somebody Dance with Me",
    artist: "DJ Bobo",
    id: 946033732,
    release_date: "1993-03-25",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/29ec2ed9adcd00fdb9d2af71662f67d1/250x250-000000-80-0-0.jpg",
    genre: "Dance",
  },
  {
    title: "Loverboy",
    artist: "Mariah Carey",
    id: 961309092,
    release_date: "2003-03-25",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/d/3/6/0/d36702f31fa7f7c121b437ec19647031.mp3?hdnea=exp=1763729100~acl=/api/1/1/d/3/6/0/d36702f31fa7f7c121b437ec19647031.mp3*~data=user_id=0,application_id=42~hmac=f86a31ecbd5298f13499f8d8f87d2f2968c405d7bc8e910751ab5b03bfa40772",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/2eb17513f571c8447732b3bb5d927ce5/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Some Say",
    artist: "Nea",
    id: 971925602,
    release_date: "2020-06-12",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/d/4/7/0/d47fd15eff4c9d34c25f209413e627fc.mp3?hdnea=exp=1763729100~acl=/api/1/1/d/4/7/0/d47fd15eff4c9d34c25f209413e627fc.mp3*~data=user_id=0,application_id=42~hmac=1feffb02f0025b368582f21e602e6a9957f413ee7337ef350f13d149bd2e5a6b",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/f817d873795e5bc0cb6e6d2e1f39ae07/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Stupid Love",
    artist: "Lady Gaga",
    id: 973317052,
    release_date: "2020-02-28",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/e/a/2/0/ea21b334767de665bc6b5adb790484ef.mp3?hdnea=exp=1763729100~acl=/api/1/1/e/a/2/0/ea21b334767de665bc6b5adb790484ef.mp3*~data=user_id=0,application_id=42~hmac=f13b208bd4c18dca92883d2251b1b3a470ff538ac3c6a0e732187296b51bcee7",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/81572deeede9e5f691e4b1889b828197/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Rain On Me",
    artist: "Lady Gaga",
    id: 973317062,
    release_date: "2020-05-22",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/b/e/4/0/be4ba29835365775b759ae7d37e486a8.mp3?hdnea=exp=1763729100~acl=/api/1/1/b/e/4/0/be4ba29835365775b759ae7d37e486a8.mp3*~data=user_id=0,application_id=42~hmac=4a72198b6e0893853b55b14a1390cbf682c89f9162ef8d8cba7a8dcef7b8bfae",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/81572deeede9e5f691e4b1889b828197/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Go Let It Out",
    artist: "Oasis",
    id: 985703762,
    release_date: "2000-02-07",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/e/7/0/0/e70460dd48fba930d27b17f09eb91fc6.mp3?hdnea=exp=1763729100~acl=/api/1/1/e/7/0/0/e70460dd48fba930d27b17f09eb91fc6.mp3*~data=user_id=0,application_id=42~hmac=58c5bfaad4811a7e51eb9b10e8b4be5e4e12b92611f448e3b90db95aad49fe64",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/c81b4b047a1a12743df8487357a2e7ce/250x250-000000-80-0-0.jpg",
    genre: "Alternative",
  },
  {
    title: "Lyla",
    artist: "Oasis",
    id: 985938012,
    release_date: "2005-05-16",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/f/7/b/0/f7b06f6a48950188f643ed0c8fa2fb89.mp3?hdnea=exp=1763729100~acl=/api/1/1/f/7/b/0/f7b06f6a48950188f643ed0c8fa2fb89.mp3*~data=user_id=0,application_id=42~hmac=2f3d17fbb1712a742e809026bbacd938375e54113c290cd7cacea0eee4433741",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/7e85af53344bb44a32a45d0d455c92ae/250x250-000000-80-0-0.jpg",
    genre: "Alternative",
  },
  {
    title: "Savage Love (Laxed - Siren Beat)",
    artist: "Jawsh 685",
    id: 986939372,
    release_date: "2020-06-11",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/d/f/2/0/df2cfe64119e4aacabd95d5e60e4c1e5.mp3?hdnea=exp=1763729100~acl=/api/1/1/d/f/2/0/df2cfe64119e4aacabd95d5e60e4c1e5.mp3*~data=user_id=0,application_id=42~hmac=cc1a09ee85a81cda76a280b316a56f38e3e191ea7fadcf8ce617dc52201aa8d7",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/ae220905519d1bb84cddd953abbc08da/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "MAMACITA",
    artist: "The Black Eyed Peas",
    id: 990604222,
    release_date: "2020-11-02",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/d/c/7/0/dc78eee41b52f6ac5787db346cdd434d.mp3?hdnea=exp=1763729100~acl=/api/1/1/d/c/7/0/dc78eee41b52f6ac5787db346cdd434d.mp3*~data=user_id=0,application_id=42~hmac=7c057b7321fce116143e056cdb22d898ac116f2109c769626a720c00462a1fc6",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/5f69e64c44314ff6b1422829afe08503/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Everybody's Free",
    artist: "Rozalla",
    id: 1024779992,
    release_date: "1991-04-12",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/ea3a56163959ac0beed6f6b65b6a07a4/250x250-000000-80-0-0.jpg",
    genre: "Electro",
  },
  {
    title: "Salt",
    artist: "Ava Max",
    id: 1077837252,
    release_date: "2020-09-18",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/b/f/8/0/bf8b86891fc749c10429fb57bdfee1d0.mp3?hdnea=exp=1763729100~acl=/api/1/1/b/f/8/0/bf8b86891fc749c10429fb57bdfee1d0.mp3*~data=user_id=0,application_id=42~hmac=6eeb84909a8141bab1884ecc8e099321504ae3249d94a110783749cd71174a9d",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/0eca025ac1206d710f91c32e49d6e8a8/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Calma",
    artist: "Pedro Capó",
    id: 1081480062,
    release_date: "2020-09-18",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/3/c/6/0/3c65a5a6c9bdfa90fa2bd725d10b890d.mp3?hdnea=exp=1763729100~acl=/api/1/1/3/c/6/0/3c65a5a6c9bdfa90fa2bd725d10b890d.mp3*~data=user_id=0,application_id=42~hmac=ee78869d35696df474d82b97fface7a7fb5a66afc3b01e1cd35f6dd3570f27d8",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/41534e6a39dbaa8032e9f40beafd6198/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Holy",
    artist: "Justin Bieber",
    id: 1084400712,
    release_date: "2020-09-18",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/e/1/9/0/e19395eec0aa5f6111c196e29bfa7ad0.mp3?hdnea=exp=1763729100~acl=/api/1/1/e/1/9/0/e19395eec0aa5f6111c196e29bfa7ad0.mp3*~data=user_id=0,application_id=42~hmac=b1c70dce31dc59e3de08100cbdcebe822cce6a008f1cb4f68d6ef16c2939b4a1",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/8dc2f1bf748626716e84ed32a500d4f3/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Waves (Robin Schulz Radio Edit)",
    artist: "Mr. Probz",
    id: 1084861832,
    release_date: "2014-02-07",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/e/3/1/0/e317e159b7ba11b2eeb0ad3a0866a7a7.mp3?hdnea=exp=1763729100~acl=/api/1/1/e/3/1/0/e317e159b7ba11b2eeb0ad3a0866a7a7.mp3*~data=user_id=0,application_id=42~hmac=8f50f99fcfa2d3c913de9452c0a3baaf0e02a9f50fece2e78d5c8ecf80405590",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/81ae52925eae1b3b0e73dee1f2854877/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Que Calor",
    artist: "Major Lazer",
    id: 1115454692,
    release_date: "2019-07-17",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/4/2/d/0/42d99e310e07cb6978b68d65fa8c68de.mp3?hdnea=exp=1763729100~acl=/api/1/1/4/2/d/0/42d99e310e07cb6978b68d65fa8c68de.mp3*~data=user_id=0,application_id=42~hmac=f048f85a52e1c3e242b46228955d8ada8e46f50c075b6e75192c52d615ef836c",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/1abb736dab8c1499e32f6078c0b58aa3/250x250-000000-80-0-0.jpg",
    genre: "Electro",
  },
  {
    title: 'Show Me Heaven (From "Days Of Thunder")',
    artist: "Maria McKee",
    id: 1121914752,
    release_date: "2022-08-31",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/c97d56f244c9a5b69715f1c59fe79515/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Physical",
    artist: "Dua Lipa",
    id: 1124841672,
    release_date: "2020-03-27",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/a/f/d/0/afda0b7f71d588ec744418bf3775181d.mp3?hdnea=exp=1763729100~acl=/api/1/1/a/f/d/0/afda0b7f71d588ec744418bf3775181d.mp3*~data=user_id=0,application_id=42~hmac=c0d51c13303e7ba442fc3481454190d6628eeeb3c90c4cb0218cc9775285cb7a",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/d0f8d853e871838a4a6d8e5b7cdd1432/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Break My Heart",
    artist: "Dua Lipa",
    id: 1124841722,
    release_date: "2020-03-27",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/0/7/2/0/072b80ef4d6eee68295ac8db579baa41.mp3?hdnea=exp=1763729100~acl=/api/1/1/0/7/2/0/072b80ef4d6eee68295ac8db579baa41.mp3*~data=user_id=0,application_id=42~hmac=753b4c1a6990b29076c63c583aa0a4b1bb47affe9f20acf6fc3ad6e3e216993b",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/d0f8d853e871838a4a6d8e5b7cdd1432/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Supalonely",
    artist: "BENEE",
    id: 1133433862,
    release_date: "2020-11-13",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/f/6/c/0/f6cd67fc82dbb40edd24f6549df8f747.mp3?hdnea=exp=1763729100~acl=/api/1/1/f/6/c/0/f6cd67fc82dbb40edd24f6549df8f747.mp3*~data=user_id=0,application_id=42~hmac=adc1f6904ff5460d5e95150288eeb380c04e1c947eaccb5183cabe4f8136fc11",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/8a81cb7d7c54db700ee6aec6c6941b16/250x250-000000-80-0-0.jpg",
    genre: "Alternative",
  },
  {
    title: "Super Bass",
    artist: "Nicki Minaj",
    id: 1140884892,
    release_date: "2011-04-05",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/0/3/d/0/03dd15bc4597d25c284f73e7033e7f82.mp3?hdnea=exp=1763729100~acl=/api/1/1/0/3/d/0/03dd15bc4597d25c284f73e7033e7f82.mp3*~data=user_id=0,application_id=42~hmac=ae8538c078c4d2dc54bf70f8174a7207e14f7d81aeba66e8b6e110c5fcaf55fe",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/93c7ca2b54d614843dfe7658106eed69/250x250-000000-80-0-0.jpg",
    genre: "Rap/Hip Hop",
  },
  {
    title: "What Time Is Love? (Live at Trancentral)",
    artist: "The KLF",
    id: 1181472092,
    release_date: "2021-01-01",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/b/f/b/0/bfbe6864336187c3df47fbf7c1c5abb9.mp3?hdnea=exp=1763729100~acl=/api/1/1/b/f/b/0/bfbe6864336187c3df47fbf7c1c5abb9.mp3*~data=user_id=0,application_id=42~hmac=a2988f60384ea5115b3c812b71245131c590383de30da54f85a15b9791f585dd",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/2f906742179b93091b5f089fd95cd90f/250x250-000000-80-0-0.jpg",
    genre: "Electro",
  },
  {
    title: "3AM Eternal (Live at the S.S.L.)",
    artist: "The KLF",
    id: 1181472102,
    release_date: "2021-01-01",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/c/9/9/0/c99c9cdca66220bfe035a730b35ead4d.mp3?hdnea=exp=1763729100~acl=/api/1/1/c/9/9/0/c99c9cdca66220bfe035a730b35ead4d.mp3*~data=user_id=0,application_id=42~hmac=3bfbabd9321e74a3bcad40a79cbb48db7fba827ad0be665e7ed2c2c3c36c8f6c",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/2f906742179b93091b5f089fd95cd90f/250x250-000000-80-0-0.jpg",
    genre: "Electro",
  },
  {
    title: "Last Train To Trancentral (Live From The Lost Continent)",
    artist: "The KLF",
    id: 1181472112,
    release_date: "1991-07-08",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/d/0/3/0/d03d2c5ece6801581ab26b5457022bb7.mp3?hdnea=exp=1763729100~acl=/api/1/1/d/0/3/0/d03d2c5ece6801581ab26b5457022bb7.mp3*~data=user_id=0,application_id=42~hmac=99a8b767604ff06fca46fc93818f36202469d04a34460ccbc2ddb80cbd4cafe7",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/2f906742179b93091b5f089fd95cd90f/250x250-000000-80-0-0.jpg",
    genre: "Electro",
  },
  {
    title: "Justified & Ancient",
    artist: "The KLF",
    id: 1181472142,
    release_date: "2021-01-01",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/2/7/8/0/278c803b7c5f4bded8c33b98aed8f521.mp3?hdnea=exp=1763729100~acl=/api/1/1/2/7/8/0/278c803b7c5f4bded8c33b98aed8f521.mp3*~data=user_id=0,application_id=42~hmac=5128fa2ad98e400ae45b20dfe5d6255db43f05ff198f31af80a276aa78ed00ab",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/2f906742179b93091b5f089fd95cd90f/250x250-000000-80-0-0.jpg",
    genre: "Electro",
  },
  {
    title: "Gett Off",
    artist: "Prince",
    id: 1183597212,
    release_date: "1991-06-07",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/b/4/d/0/b4dbe43d30f60f42da8800a2634412a6.mp3?hdnea=exp=1763729100~acl=/api/1/1/b/4/d/0/b4dbe43d30f60f42da8800a2634412a6.mp3*~data=user_id=0,application_id=42~hmac=26ee598ef46b6562c259dc61b6a383efce6f023e9166eca4b158b7879f668d3b",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/d413d3635279526b67d43cbf735af6e6/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "See You Again",
    artist: "Miley Cyrus",
    id: 1215683092,
    release_date: "2007-05-15",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/4/d/3/0/4d3c20c4b5aa1bab82c54403a5f8568e.mp3?hdnea=exp=1763729100~acl=/api/1/1/4/d/3/0/4d3c20c4b5aa1bab82c54403a5f8568e.mp3*~data=user_id=0,application_id=42~hmac=b0d5cecf54a398b66740a29a3a344754000207ee556e3a8e9a70c5ab4e83f488",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/aac443912f3199e6582457c714a0edfd/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Dub Be Good To Me",
    artist: "Beats International",
    id: 1240062942,
    release_date: "2022-08-27",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/e/5/a/0/e5abf045c82772b8726d0b61101ac418.mp3?hdnea=exp=1763729100~acl=/api/1/1/e/5/a/0/e5abf045c82772b8726d0b61101ac418.mp3*~data=user_id=0,application_id=42~hmac=538fd617813e7498eb6eadbbd9d5b9ec1dd01bf26b73cd74c98b484e5a0c7643",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/879525cf913b35a1060088b5a8e2b68c/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Love Story (Taylor's Version)",
    artist: "Taylor Swift",
    id: 1241796632,
    release_date: "2021-02-12",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/6/4/e/0/64ee8188d680d591b1482976ddc81619.mp3?hdnea=exp=1763729100~acl=/api/1/1/6/4/e/0/64ee8188d680d591b1482976ddc81619.mp3*~data=user_id=0,application_id=42~hmac=e16e8bb6cda0b4c58aec9bda4483d3aa9bc6b2969e9cfa23df56236d83595255",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/cce4e99be496acc9dc2e4365c5b288fc/250x250-000000-80-0-0.jpg",
    genre: "Country",
  },
  {
    title: "Cry for Help",
    artist: "Rick Astley",
    id: 1280843412,
    release_date: "1991-02-25",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/f/9/e/0/f9e8a139a989465a9d923f669a6ae611.mp3?hdnea=exp=1763729100~acl=/api/1/1/f/9/e/0/f9e8a139a989465a9d923f669a6ae611.mp3*~data=user_id=0,application_id=42~hmac=96823540ebd823d4c6a7836eb5182285750a46c523c859bf488b6ed23ca9544a",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/2085ecffa5c7bd36f9953f81f45c2974/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Mood (feat. iann dior)",
    artist: "24kGoldn",
    id: 1283264632,
    release_date: "2021-03-26",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/4/b/d/0/4bd053749607fd7064616ba0e2a09ec0.mp3?hdnea=exp=1763729100~acl=/api/1/1/4/b/d/0/4bd053749607fd7064616ba0e2a09ec0.mp3*~data=user_id=0,application_id=42~hmac=d24d12fa859c25b9e45fa84c1509bfd1dfb6a1147b3fc02d10b5196fc155c663",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/2bc3ee63eaf3e5515a100a4a13a64d1d/250x250-000000-80-0-0.jpg",
    genre: "Alternative",
  },
  {
    title: "Sorry Not Sorry",
    artist: "Demi Lovato",
    id: 1352270152,
    release_date: "2017-07-11",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/3/8/2/0/3826950f5415a038d513d2adab1839fd.mp3?hdnea=exp=1763729100~acl=/api/1/1/3/8/2/0/3826950f5415a038d513d2adab1839fd.mp3*~data=user_id=0,application_id=42~hmac=1955d41cefd46f3b3c66b0fcd7099accebb54f3a6a136e1bb59526b020b701da",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/6d11e6d61282fe095f730160099fffbe/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Nobody's Love",
    artist: "Maroon 5",
    id: 1400843182,
    release_date: "2021-06-11",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/9/8/7/0/987588d10037fe61c445d1d4e2eb017c.mp3?hdnea=exp=1763729100~acl=/api/1/1/9/8/7/0/987588d10037fe61c445d1d4e2eb017c.mp3*~data=user_id=0,application_id=42~hmac=4a5e27a7ccd675658108d5f2cbc1c2b8d8ad9d8f0c3846ec2551712c6446fec7",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/62d6f17a706ac04fdd3dccddfdb65653/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Glad You Came",
    artist: "The Wanted",
    id: 1543600932,
    release_date: "2011-07-10",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/0/7/9/0/0798d1885049867fe21b46044d1891bf.mp3?hdnea=exp=1763729100~acl=/api/1/1/0/7/9/0/0798d1885049867fe21b46044d1891bf.mp3*~data=user_id=0,application_id=42~hmac=fa94fa8d57c32b8f9984d755744b3883fc612d0e315e084cc575728b1f72ab98",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/b1919bfb068b62200eb2157a8afa4c32/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Whoomp! There It Is",
    artist: "Tag Team",
    id: 1558003142,
    release_date: "1993-05-07",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/6/9/3/0/6937da32a33c5de16df6ea16cbe78660.mp3?hdnea=exp=1763729100~acl=/api/1/1/6/9/3/0/6937da32a33c5de16df6ea16cbe78660.mp3*~data=user_id=0,application_id=42~hmac=f68dd93b2389d5befae58b541d408e27d3ffb23d52f1b46ffc034ac2354f15cb",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/8b2f8361c6207045ef6a36457a7eaf3d/250x250-000000-80-0-0.jpg",
    genre: "Rap/Hip Hop",
  },
  {
    title: "Dynamite",
    artist: "BTS",
    id: 1560787612,
    release_date: "2020-08-21",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/a/a/5/0/aa54c72b731e33f1bce82fb15a286ec9.mp3?hdnea=exp=1763729100~acl=/api/1/1/a/a/5/0/aa54c72b731e33f1bce82fb15a286ec9.mp3*~data=user_id=0,application_id=42~hmac=c267b2f521b1c24007c9cbb52cf60594c5473f8ce11f313572563dc02455e3b0",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/7218df00a126bf159d852516400a1127/250x250-000000-80-0-0.jpg",
    genre: "Asian Music",
  },
  {
    title: "FAKE LOVE",
    artist: "BTS",
    id: 1576170872,
    release_date: "2018-05-18",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/8/f/5/0/8f597b8d2c2b82380f25eeef2570d93e.mp3?hdnea=exp=1763729100~acl=/api/1/1/8/f/5/0/8f597b8d2c2b82380f25eeef2570d93e.mp3*~data=user_id=0,application_id=42~hmac=f48a5a0d70928c4b887de1562f654460d19eea3745f7e25f2ce0f29c92ce084c",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/318cd3fbb62cab2bc6155848f28f34b5/250x250-000000-80-0-0.jpg",
    genre: "Asian Music",
  },
  {
    title: "Hip Hop Hooray",
    artist: "Naughty By Nature",
    id: 1584431742,
    release_date: "1993-02-23",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/9/a/3/0/9a3598f88366a179bb1d425857a4105e.mp3?hdnea=exp=1763729100~acl=/api/1/1/9/a/3/0/9a3598f88366a179bb1d425857a4105e.mp3*~data=user_id=0,application_id=42~hmac=2be1dc67f538d422e75e37e03cc1b43aa34a7478d02e626e810e240416a40d08",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/738565cc6aa4f480f122d944cb2aabdb/250x250-000000-80-0-0.jpg",
    genre: "Rap/Hip Hop",
  },
  {
    title: "Come Baby Come",
    artist: "K7",
    id: 1584432112,
    release_date: "1993-11-09",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/4/4/4/0/444f07852dbf01797d9e242a613c5560.mp3?hdnea=exp=1763729100~acl=/api/1/1/4/4/4/0/444f07852dbf01797d9e242a613c5560.mp3*~data=user_id=0,application_id=42~hmac=184200372c760f86053352a322511fdb6af8abd38abe3ce4a9aad1a3869e3d49",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/cf3c8539ecf11cf1dc40b91d3733107a/250x250-000000-80-0-0.jpg",
    genre: "Dance",
  },
  {
    title: "(We Want) The Same Thing",
    artist: "Belinda Carlisle",
    id: 1653264392,
    release_date: "1989-04-22",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/49f3421234c10a42e8f28ccf6267b069/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Mercy",
    artist: "Kanye West",
    id: 1705211167,
    release_date: "2012-04-03",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/d/7/0/0/d70552a8bf50900e2752cfe792ea239d.mp3?hdnea=exp=1763729100~acl=/api/1/1/d/7/0/0/d70552a8bf50900e2752cfe792ea239d.mp3*~data=user_id=0,application_id=42~hmac=076414a1b3093dc733e8f2c4cd29bff8654f9ec38a57230153d5f588a445402d",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/eceb48aaaf32bb2afb27451d1fc71d88/250x250-000000-80-0-0.jpg",
    genre: "Rap/Hip Hop",
  },
  {
    title: "Hole Hearted",
    artist: "Extreme",
    id: 1758927657,
    release_date: "2007-09-13",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/2/a/9/0/2a9f2ca4c5d8105d7ee6e03d574c0bd6.mp3?hdnea=exp=1763729100~acl=/api/1/1/2/a/9/0/2a9f2ca4c5d8105d7ee6e03d574c0bd6.mp3*~data=user_id=0,application_id=42~hmac=7f4bec8e83834a1d03dbb967f12b55394bf611f138d977830f3235b9399d1694",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/cf195bfad5df119bd47bfcd2a764573b/250x250-000000-80-0-0.jpg",
    genre: "Rock",
  },
  {
    title: "Everybody Plays The Fool",
    artist: "Aaron Neville",
    id: 1762472057,
    release_date: "2008-05-08",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/8/7/1/0/871eae8b0614f5b35a6f0a320c00ca13.mp3?hdnea=exp=1763729100~acl=/api/1/1/8/7/1/0/871eae8b0614f5b35a6f0a320c00ca13.mp3*~data=user_id=0,application_id=42~hmac=11873d1f3188a5077ca083a24e85cf2b10933785069878a74a1707d74372a50d",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/e77dd93163d03044afa757b8acb186ba/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Nothing Compares 2 U",
    artist: "Sinéad O'Connor",
    id: 1787569267,
    release_date: "1990-01-08",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/c/b/a/0/cba38c67b7aa5bb88d87df8d28af07d0.mp3?hdnea=exp=1763729100~acl=/api/1/1/c/b/a/0/cba38c67b7aa5bb88d87df8d28af07d0.mp3*~data=user_id=0,application_id=42~hmac=731c515542a378ca973e10360fcc40ac7047a6f2a71bc8ddddd90b6662655adf",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/393b4ac52c6d958363edefbb4c009af7/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "The King of Wishful Thinking",
    artist: "Go West",
    id: 1787666357,
    release_date: "1992-11-14",
    preview:
      "https://cdnt-preview.dzcdn.net/api/1/1/c/0/8/0/c088a304a579dde17da3c8c7fd685792.mp3?hdnea=exp=1763729100~acl=/api/1/1/c/0/8/0/c088a304a579dde17da3c8c7fd685792.mp3*~data=user_id=0,application_id=42~hmac=54c00cd7873c9454cac6d59ef2a0c04ff2b5a970112075830b745935a3ba9118",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/0a64ceebaae7dddbbba477567e9cbe5b/250x250-000000-80-0-0.jpg",
    genre: "Pop",
  },
  {
    title: "Hero Of The Day (LP Version)",
    artist: "Metallica",
    id: -685289221,
    release_date: "2013-04-30",
    preview: "",
    cover: "undefined",
    genre: "Pop",
  },
  {
    title: "Eyes On You",
    artist: "Jay Sean",
    id: -594119471,
    release_date: "2007-01-30",
    preview: "",
    cover:
      "https://e-cdns-images.dzcdn.net/images/cover/7019e3a669461cdb26585668c120be02/250x250-000000-80-0-0.jpg",
    genre: "Rap/Hip Hop",
  },
];

export const tracksWithPreview = tracks.filter((t) =>
  trackTitlesWithPreview.includes(t.title)
);

export function getTrackTitle(track: Track): string {
  return track.title + " - " + track.artist;
}

export function sanitizeTrackTitle(trackTitle: string): string {
  return trackTitle
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[- '()]/g, "")
    .toLowerCase();
}
